webpackJsonp([28],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataServiceModule = void 0;

/**
 * URLs can be found in settings.provider.js
 * default headers are set in api.interceptor.js
 */
var DataServiceModule = angular.module('app.services.data.dataService', []).service('dataService', ["$http", function ($http) {
  return {
    get: get,
    getAll: getAll,
    save: save,
    saveAll: saveAll,
    create: create,
    copy: copy,
    patch: patch,
    remove: remove,
    newOrders: 0,
    inProgress: 0
  };

  function get(endpoint, id, options) {
    var responseType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    return $http.get(getUrl(endpoint, id), {
      params: options,
      responseType: responseType
    }).then(function (response) {
      return response.data;
    });
  }

  function getAll(endpoint, options, headers) {
    var returnHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var config = Object.assign({}, {
      params: options
    }, {
      headers: headers
    });
    return $http.get(getUrl(endpoint), config).then(function (response) {
      if (returnHeaders) {
        return {
          data: response.data,
          headers: response.headers()
        };
      }

      return response.data;
    });
  }

  function saveAll(endpoint, obj, headers) {
    return $http.put(getUrl(endpoint), obj, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  }

  function save(endpoint, id, obj, headers) {
    return $http.put(getUrl(endpoint, id), obj, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  }

  function create(endpoint, obj, headers, params) {
    return $http.post(getUrl(endpoint), obj, {
      headers: headers,
      params: params
    }).then(function (response) {
      return response.data;
    });
  }

  function copy(endpoint, obj, nameLength, headers) {
    nameLength = nameLength || 35;
    var strLength = nameLength - 7;
    obj.name = "".concat(obj.name.substring(0, strLength), " - COPY");
    return create(endpoint, obj, headers);
  }

  function remove(endpoint, id, headers) {
    return $http.delete(getUrl(endpoint, id), {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  }

  function patch(endpoint, id) {
    var patches = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var headers = arguments.length > 3 ? arguments[3] : undefined;
    return $http.patch(getUrl(endpoint, id), patches, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  }

  function getUrl(endpoint, id) {
    var url = "".concat("https://sandbox.api-v2.volusion.com", "/").concat(endpoint);

    if (id !== undefined && id !== null) {
      url += "/".concat(id);
    }

    return url;
  }
}]).name;
exports.DataServiceModule = DataServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppSettingsModule = void 0;
var AppSettingsModule = angular.module('app.settings', []).constant('settings', {
  api: {
    cartsREST: 'admin/rest/carts',
    publicCartsREST: 'public/rest/carts',
    abandonedCartsLegacy: 'admin/carts/abandoned',
    abandonedCartsExport: 'admin/carts/abandoned/export',
    adminCategories: 'store/admin/categories',
    analytics: 'admin/analytics',
    apiKeys: 'admin/keys',
    auditlogs: 'store/admin/auditlogs',
    cart: 'admin/carts',
    categories: 'store/admin/categorytree',
    configuration: 'store/admin/configuration',
    coupons: 'store/admin/discounts',
    currencies: 'store/admin/currencies',
    customerBulkUpload: 'admin/data-importer/customers',
    customerBulkUploadStatus: 'admin/data-importer/status/customers',
    customCss: 'store/admin/customcss',
    customDomainStatus: 'admin/customdomains/status',
    customers: 'admin/shoppers',
    customersCount: 'admin/shoppers/count',
    defaultStyleEditorSettings: 'store/admin/defaultstyleeditorsettings',
    discounts: 'admin/discounts',
    discountsREST: 'admin/rest/discounts',
    discountMetrics: 'admin/orders/discountMetrics',
    avalaraCredential: 'taxes/avalaracredential',
    avalaraEntityUseCodes: 'taxes/avatax/entityusecodes',
    avalaraStatus: 'taxes/avatax/status',
    features: 'admin/features',
    fulfillers: 'admin/fulfillers',
    greetingsurvey: 'greetingsurvey',
    hubspotToken: 'store/admin/hubspot/token',
    imageAnalytics: 'admin/image-analysis',
    imageLinks: 'images',
    images: 'admin/images',
    importJob: 'admin/importjob',
    lessSettings: 'store/admin/lesssettingsfile',
    menus: 'store/admin/menus',
    options: 'store/admin/options',
    orderBulkUpdate: 'admin/orderBulkUpdate',
    orderBulkUpdateStatus: 'admin/orderBulkUpdateStatus',
    orderBulkUpload: 'admin/data-importer/orders',
    orders: 'store/admin/orders',
    ordersMetrics: 'admin/orders/metrics',
    pages: 'admin/contentpages',
    pagesMetrics: 'admin/contentpagemetrics',
    paymentMethod: 'admin/paymentmethod',
    paypalConnect: 'admin/paypal/connect',
    paypalDisconnect: 'admin/paypal/disconnect',
    paypalPrefill: 'admin/paypal/prefill',
    paypalUpsert: 'admin/paypal',
    populateLibrary: 'admin/images/populate',
    postage: 'admin/shipping',
    productBulkUpload: 'admin/importer/csv',
    productBulkUploadStatus: 'admin/importer/status',
    products: 'store/admin/products',
    productExport: 'store/admin/product-export',
    productsMinimal: 'store/admin/products-minimal',
    productsMetrics: 'admin/products/metrics',
    productTaxCodes: 'taxes/avatax/taxcode',
    purchasedextensions: 'store/admin/purchasedextensions',
    purchasedplugins: 'store/admin/purchasedplugins',
    purchasedthemes: 'store/admin/purchasedthemes',
    refreshStorefrontCache: 'admin/storefrontcache/invalidate',
    registerCustomDomain: 'admin/customdomains/register',
    reviews: 'store/admin/reviews',
    searchKey: 'store/admin/searchkeys',
    shippingMethods: 'admin/shippingmethods',
    sitemap: 'admin/sitemap',
    storeAdmin: 'admin/administrators',
    storeAddresses: 'admin/storeaddresses',
    storeAddressesPrimary: 'admin/storeaddresses/primary',
    storeAddress: 'admin/storeaddresses/address',
    storeInformation: 'admin/storeinformation',
    tenantInformation: 'tenantinformation',
    storeInformationCustomDomain: 'admin/storeinformation/customdomain',
    storeSettings: 'store/admin/storesettings',
    stripe: 'admin/storeinformation/stripe',
    stripeCustomerDetails: 'admin/stripecustomerdetails',
    stripeInvoicePayments: 'admin/stripeinvoicepayments',
    stripeInvoicePdf: 'admin/stripeinvoicepdf',
    stripeInvoices: 'admin/stripeinvoices',
    stripeUpcomingInvoice: 'admin/stripeupcominginvoice',
    styleEditorSettings: 'store/admin/styleeditorsettings',
    taxProvider: 'taxes/taxprovider',
    timeout: 4000,
    users: 'store/admin/users',
    validateStripeCoupon: 'stripecoupons',
    verification: 'admin/emails/verification',
    version: 'store/admin/version',
    volusionPaymentsComplete: 'store/admin/paymentkeys/authorizenet',
    volusionPaymentsKYC: 'admin/paymentsmerchantinfo',
    volusionPaymentsTestMode: 'store/admin/authorizenet/settings',
    customFields: 'store/admin/customfields',
    customFieldLinks: 'store/admin/customfieldlinks',
    terms: 'terms',
    acceptedTerms: 'store/admin/acceptedterms',
    storeCredits: 'store/admin/storeCredit'
  },
  language: 'en'
}).name;
exports.AppSettingsModule = AppSettingsModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALLOWED_TAGS = exports.ADMINISTRATIVE_AREA_LEVEL_1_LABELS = exports.COUNTRIES = exports.STATES_US = exports.CATEGORY_SELECTION_ACTIONS = exports.RESTRICTED_PLANS = exports.PHONE_NUM_MAX = exports.PHONE_NUM_MIN = exports.ADDRESS_REGION_PLURAL = exports.ADDRESS_REGION = exports.ADDRESS_COUNTRY = exports.DEFAULT_COUNTRY_CODE = exports.LOGIN_PASSWORD_EXPIRED_COOKIE = exports.LOGIN_REDIRECT_COOKIE = exports.YOTPO_APP_KEY = exports.IMPORTER_TYPES = exports.AUTH0_PASSWORD_EXPIRED_CLAIM = exports.AUTH0_METADATA_CLAIM = exports.AUTH0_TENANT_CLAIM = exports.LIVE_CHAT_CLIENT = exports.STRIPE_ELEMENTS_GOOGLE_PAY = exports.STRIPE_ELEMENTS_APPLE_PAY = exports.LITE_PRODUCT_LIMIT = exports.ROOT_DOMAIN = exports.LOGO_DHL = exports.LOGO_FEDEX = exports.LOGO_UPS = exports.LOGO_USPS = exports.LOGO_SYMBOL_LIGHT_URL = exports.LOGO_SYMBOL_URL = exports.LOGO_URL = exports.STATUS_PAGE_URL = exports.RELEASE_NOTES_URL = exports.HELP_PURCHASING_CUSTOM_DOMAIN_URL = exports.VOLUSION_CONTACT_URL = exports.HELP_CENTER_URL = exports.GOOGLE_STATIC_MAPS_KEY = void 0;
var GOOGLE_STATIC_MAPS_KEY = 'AIzaSyBVvRYGnSTIFppjaVB_qmdi8Enl5suNW4s';
exports.GOOGLE_STATIC_MAPS_KEY = GOOGLE_STATIC_MAPS_KEY;
var HELP_CENTER_URL = 'https://help.volusion.com';
exports.HELP_CENTER_URL = HELP_CENTER_URL;
var VOLUSION_CONTACT_URL = 'https://www.volusion.com/contact/'; // eslint-disable-next-line max-len

exports.VOLUSION_CONTACT_URL = VOLUSION_CONTACT_URL;
var HELP_PURCHASING_CUSTOM_DOMAIN_URL = 'https://www.godaddy.com/help/dive-in-browse-essential-articles-list-26986?isc=gofd2001aj&gclid=EAIaIQobChMIh6OJtYL_6AIVU5JbCh36HwKWEAAYASAAEgIwyfD_BwE&gclsrc=aw.ds';
exports.HELP_PURCHASING_CUSTOM_DOMAIN_URL = HELP_PURCHASING_CUSTOM_DOMAIN_URL;
var RELEASE_NOTES_URL = 'https://help.volusion.com/release-notes';
exports.RELEASE_NOTES_URL = RELEASE_NOTES_URL;
var STATUS_PAGE_URL = 'https://volusion2.statuspage.io';
exports.STATUS_PAGE_URL = STATUS_PAGE_URL;
var LOGO_URL = '//d3ggqrmoaaez04.cloudfront.net/images/logos/logo.svg';
exports.LOGO_URL = LOGO_URL;
var LOGO_SYMBOL_URL = '//d3ggqrmoaaez04.cloudfront.net/images/logos/logo_symbol.svg';
exports.LOGO_SYMBOL_URL = LOGO_SYMBOL_URL;
var LOGO_SYMBOL_LIGHT_URL = '//d3ggqrmoaaez04.cloudfront.net/images/logos/logo_symbol_light.svg';
exports.LOGO_SYMBOL_LIGHT_URL = LOGO_SYMBOL_LIGHT_URL;
var LOGO_USPS = '/assets/usps-icon.svg';
exports.LOGO_USPS = LOGO_USPS;
var LOGO_UPS = '/assets/ups-icon.svg';
exports.LOGO_UPS = LOGO_UPS;
var LOGO_FEDEX = '/assets/fedex-icon.svg';
exports.LOGO_FEDEX = LOGO_FEDEX;
var LOGO_DHL = '/assets/dhl-icon.svg';
exports.LOGO_DHL = LOGO_DHL;
var ROOT_DOMAIN = 'volusion.com';
exports.ROOT_DOMAIN = ROOT_DOMAIN;
var LITE_PRODUCT_LIMIT = 5;
exports.LITE_PRODUCT_LIMIT = LITE_PRODUCT_LIMIT;
var STRIPE_ELEMENTS_APPLE_PAY = 'Apple Pay';
exports.STRIPE_ELEMENTS_APPLE_PAY = STRIPE_ELEMENTS_APPLE_PAY;
var STRIPE_ELEMENTS_GOOGLE_PAY = 'Google Pay';
exports.STRIPE_ELEMENTS_GOOGLE_PAY = STRIPE_ELEMENTS_GOOGLE_PAY;
var LIVE_CHAT_CLIENT = '141adc3fc6de37100f4b26f351b5f8a2';
exports.LIVE_CHAT_CLIENT = LIVE_CHAT_CLIENT;
var AUTH0_TENANT_CLAIM = 'https://api.material.com/tenant';
exports.AUTH0_TENANT_CLAIM = AUTH0_TENANT_CLAIM;
var AUTH0_METADATA_CLAIM = 'https://api.material.com/user_metadata';
exports.AUTH0_METADATA_CLAIM = AUTH0_METADATA_CLAIM;
var AUTH0_PASSWORD_EXPIRED_CLAIM = 'https://api.material.com/password_expired';
exports.AUTH0_PASSWORD_EXPIRED_CLAIM = AUTH0_PASSWORD_EXPIRED_CLAIM;
var IMPORTER_TYPES = {
  ORDER: 'order',
  PRODUCT: 'product',
  CUSTOMER: 'customer'
};
exports.IMPORTER_TYPES = IMPORTER_TYPES;
var YOTPO_APP_KEY = 'ZHjSUsdLwpPReKPO41FDgnQd5Tk0hcphahtH9cdlwYn1W2mWBvQ6WmyJS617uIXpsPHq0YQUFKSVTBVAAUGsWA';
exports.YOTPO_APP_KEY = YOTPO_APP_KEY;
var LOGIN_REDIRECT_COOKIE = 'loginredirect';
exports.LOGIN_REDIRECT_COOKIE = LOGIN_REDIRECT_COOKIE;
var LOGIN_PASSWORD_EXPIRED_COOKIE = 'loginpasswordexpired';
exports.LOGIN_PASSWORD_EXPIRED_COOKIE = LOGIN_PASSWORD_EXPIRED_COOKIE;
var DEFAULT_COUNTRY_CODE = 'US';
exports.DEFAULT_COUNTRY_CODE = DEFAULT_COUNTRY_CODE;
var ADDRESS_COUNTRY = 'Country';
exports.ADDRESS_COUNTRY = ADDRESS_COUNTRY;
var ADDRESS_REGION = 'Region';
exports.ADDRESS_REGION = ADDRESS_REGION;
var ADDRESS_REGION_PLURAL = 'Regions';
exports.ADDRESS_REGION_PLURAL = ADDRESS_REGION_PLURAL;
var PHONE_NUM_MIN = 9;
exports.PHONE_NUM_MIN = PHONE_NUM_MIN;
var PHONE_NUM_MAX = 17;
exports.PHONE_NUM_MAX = PHONE_NUM_MAX;
var RESTRICTED_PLANS = ["plan_DqbHJDWOd1MceZ", "plan_DqbK5XSmbjT1wn", "plan_DqbMwslOtfhUhD"];
exports.RESTRICTED_PLANS = RESTRICTED_PLANS;
var CATEGORY_SELECTION_ACTIONS = {
  ADD: 'add',
  REMOVE: 'remove'
};
exports.CATEGORY_SELECTION_ACTIONS = CATEGORY_SELECTION_ACTIONS;
var STATES_US = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FM: 'Federated States Of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};
exports.STATES_US = STATES_US;
var COUNTRIES = [{
  id: 234,
  name: 'United States',
  stateLabel: 'State',
  states: [{
    id: 1,
    name: 'Alabama',
    code: 'AL'
  }, {
    id: 2,
    name: 'Alaska',
    code: 'AK'
  }, {
    id: 3,
    name: 'Arizona',
    code: 'AZ'
  }, {
    id: 4,
    name: 'Arkansas',
    code: 'AR'
  }, {
    id: 5,
    name: 'California',
    code: 'CA'
  }, {
    id: 6,
    name: 'Colorado',
    code: 'CO'
  }, {
    id: 7,
    name: 'Connecticut',
    code: 'CT'
  }, {
    id: 8,
    name: 'Delaware',
    code: 'DE'
  }, {
    id: 52,
    name: 'District of Columbia',
    code: 'DC'
  }, {
    id: 9,
    name: 'Florida',
    code: 'FL'
  }, {
    id: 10,
    name: 'Georgia',
    code: 'GA'
  }, {
    id: 11,
    name: 'Hawaii',
    code: 'HI'
  }, {
    id: 12,
    name: 'Idaho',
    code: 'ID'
  }, {
    id: 13,
    name: 'Illinois',
    code: 'IL'
  }, {
    id: 14,
    name: 'Indiana',
    code: 'IN'
  }, {
    id: 15,
    name: 'Iowa',
    code: 'IA'
  }, {
    id: 16,
    name: 'Kansas',
    code: 'KS'
  }, {
    id: 17,
    name: 'Kentucky',
    code: 'KY'
  }, {
    id: 18,
    name: 'Louisiana',
    code: 'LA'
  }, {
    id: 19,
    name: 'Maine',
    code: 'ME'
  }, {
    id: 20,
    name: 'Maryland',
    code: 'MD'
  }, {
    id: 21,
    name: 'Massachusetts',
    code: 'MA'
  }, {
    id: 22,
    name: 'Michigan',
    code: 'MI'
  }, {
    id: 23,
    name: 'Minnesota',
    code: 'MN'
  }, {
    id: 24,
    name: 'Mississippi',
    code: 'MS'
  }, {
    id: 25,
    name: 'Missouri',
    code: 'MO'
  }, {
    id: 26,
    name: 'Montana',
    code: 'MT'
  }, {
    id: 27,
    name: 'Nebraska',
    code: 'NE'
  }, {
    id: 28,
    name: 'Nevada',
    code: 'NV'
  }, {
    id: 29,
    name: 'New Hampshire',
    code: 'NH'
  }, {
    id: 30,
    name: 'New Jersey',
    code: 'NJ'
  }, {
    id: 31,
    name: 'New Mexico',
    code: 'NM'
  }, {
    id: 32,
    name: 'New York',
    code: 'NY'
  }, {
    id: 33,
    name: 'North Carolina',
    code: 'NC'
  }, {
    id: 34,
    name: 'North Dakota',
    code: 'ND'
  }, {
    id: 35,
    name: 'Ohio',
    code: 'OH'
  }, {
    id: 36,
    name: 'Oklahoma',
    code: 'OK'
  }, {
    id: 37,
    name: 'Oregon',
    code: 'OR'
  }, {
    id: 38,
    name: 'Pennsylvania',
    code: 'PA'
  }, {
    id: 39,
    name: 'Rhode Island',
    code: 'RI'
  }, {
    id: 40,
    name: 'South Carolina',
    code: 'SC'
  }, {
    id: 41,
    name: 'South Dakota',
    code: 'SD'
  }, {
    id: 42,
    name: 'Tennessee',
    code: 'TN'
  }, {
    id: 43,
    name: 'Texas',
    code: 'TX'
  }, {
    id: 44,
    name: 'Utah',
    code: 'UT'
  }, {
    id: 45,
    name: 'Vermont',
    code: 'VT'
  }, {
    id: 46,
    name: 'Virginia',
    code: 'VA'
  }, {
    id: 47,
    name: 'Washington',
    code: 'WA'
  }, {
    id: 48,
    name: 'West Virginia',
    code: 'WV'
  }, {
    id: 49,
    name: 'Wisconsin',
    code: 'WI'
  }, {
    id: 50,
    name: 'Wyoming',
    code: 'WY'
  }]
}];
exports.COUNTRIES = COUNTRIES;
var ADMINISTRATIVE_AREA_LEVEL_1_LABELS = {
  US: 'State',
  MX: 'State',
  AU: {
    singular: 'State/Territory',
    plural: 'States/Territories'
  },
  MY: {
    singular: 'State/Territory',
    plural: 'States/Territories'
  },
  CN: 'Province',
  CA: 'Province',
  IT: 'Province',
  ID: 'Province',
  DZ: 'Province',
  TH: 'Province',
  UZ: 'Province',
  EG: 'Governorate',
  AE: 'Emirate',
  BR: 'State'
};
exports.ADMINISTRATIVE_AREA_LEVEL_1_LABELS = ADMINISTRATIVE_AREA_LEVEL_1_LABELS;
var ALLOWED_TAGS = ['<a>', '<audio>', '<b>', '<big>', '<blockquote>', '<br>', '<cite>', '<code>', '<dd>', '<del>', '<div>', '<dl>', '<dt>', '<em>', '<embed>', '<figcaption>', '<figure>', '<h1>', '<h2>', '<h3>', '<h4>', '<h5>', '<h6>', '<hr>', '<i>', '<iframe>', '<img>', '<label>', '<li>', '<mark>', '<object>', '<ol>', '<p>', '<param>', '<pre>', '<small>', '<span>', '<strike>', '<strong>', '<sub>', '<sup>', '<table>', '<tbody>', '<td>', '<tfoot>', '<th>', '<thead>', '<tr>', '<u>', '<ul>', '<video>'];
exports.ALLOWED_TAGS = ALLOWED_TAGS;

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LaunchDarklyServiceModule = void 0;

var _moment = _interopRequireDefault(__webpack_require__(74));

var _ldclientJs = __webpack_require__(488);

var _authToken = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LaunchDarklyServiceModule = angular.module('app.services.access.launchDarkly', [_authToken.AuthTokenServiceModule]).service('launchDarklyService', ["$q", "$rootScope", "authTokenService", function ($q, $rootScope, authTokenService) {
  var client;
  var initialized = false;
  var initDeferred = $q.defer();
  var service = {
    allFlags: allFlags,
    getClient: getClient,
    getFeature: getFeature,
    getLaunchDate: getLaunchDate,
    init: init,
    initialized: initialized,
    isNewAccount: isNewAccount,
    isElementStore: isElementStore,
    unInit: unInit,
    updateUser: updateUser,
    waitForInit: waitForInit,
    initFromToken: initFromToken
  };

  function updateUser(newUser) {
    return service.waitForInit().then(function () {
      var deferred = $q.defer();
      client.identify(newUser, null, function () {
        deferred.resolve();
      });
      return deferred.promise;
    });
  }

  function init(user, initLD) {
    if (initialized) return $q.resolve();
    if (!initLD) return $q.reject();
    client = initLD("580e6a00af75f20830919f1f", user);
    client.on('ready', function () {
      initialized = true;
      initDeferred.resolve();
      $rootScope.$apply();
    });
    return initDeferred.promise;
  }

  function unInit() {
    initialized = false;
    initDeferred = $q.defer();
  }

  function getFeature(featureKey) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return service.waitForInit().then(function () {
      return client.variation(featureKey, defaultValue);
    }).catch(function () {
      return defaultValue;
    });
  }

  function getLaunchDate(featureKey) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return service.getFeature(featureKey, defaultValue).then(function (feature) {
      var result = {
        hasFeature: false,
        hasMessaging: false
      };
      if (typeof feature === 'boolean') return feature;
      if (feature === 'off') return result;
      result.hasFeature = true;
      if (feature === 'cutover') return result;

      var _feature$split$map = feature.split(',').map(function (p) {
        return Number(p);
      }),
          _feature$split$map2 = _slicedToArray(_feature$split$map, 3),
          year = _feature$split$map2[0],
          month = _feature$split$map2[1],
          day = _feature$split$map2[2];

      var date = new Date(year, month - 1, day);
      var now = new Date();

      if (date.getTime() > now.getTime()) {
        // launch date not yet passed
        result.hasMessaging = true;
        result.launchDate = (0, _moment.default)(date).format('MMMM D, YYYY');
      }

      return result;
    }).catch(function () {
      return defaultValue;
    });
  }

  function isNewAccount(storeInformation) {
    return service.getFeature('element-myvolusion-launch-date').then(function (elementLaunchDateFlag) {
      if (!elementLaunchDateFlag) return false;

      var _elementLaunchDateFla = elementLaunchDateFlag.split(',').map(function (el) {
        return el.trim();
      }),
          _elementLaunchDateFla2 = _slicedToArray(_elementLaunchDateFla, 3),
          year = _elementLaunchDateFla2[0],
          month = _elementLaunchDateFla2[1],
          day = _elementLaunchDateFla2[2];

      var elementLaunchDate = new Date(year, month - 1, day);
      var storeCreatedOn = new Date(storeInformation.createdOn);
      return storeCreatedOn.getTime() >= elementLaunchDate.getTime();
    });
  }

  function isElementStore(storeInformationService) {
    return storeInformationService.getStore().then(function (storeInformation) {
      return Promise.all([service.getLaunchDate('element-launch'), service.isNewAccount(storeInformation)]);
    }).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          feature = _ref2[0],
          newAccount = _ref2[1];

      return feature.hasFeature && !feature.hasMessaging || newAccount;
    });
  }

  function allFlags() {
    return service.waitForInit().then(function () {
      return client.allFlags();
    });
  }

  function getClient() {
    return service.waitForInit().then(function () {
      return client;
    });
  }

  function waitForInit() {
    if (initialized) return $q.resolve();
    return initDeferred.promise;
  }

  function initFromToken(custom) {
    return authTokenService.getAccessToken().then(function () {
      var tenantPromise = authTokenService.getTenantId();
      var emailPromise = authTokenService.getEmail();
      return $q.all([tenantPromise, emailPromise]).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            tenant = _ref4[0],
            email = _ref4[1];

        return service.init({
          key: tenant,
          email: email,
          custom: custom
        }, _ldclientJs.initialize);
      });
    });
  }

  return service;
}]).name;
exports.LaunchDarklyServiceModule = LaunchDarklyServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoreInformationServiceModule = void 0;

var _settings = __webpack_require__(15);

var _onboarding = __webpack_require__(59);

var _founderGuide = __webpack_require__(155);

var _data = __webpack_require__(11);

var StoreInformationServiceModule = angular.module('app.services.data.storeInformation', [_data.DataServiceModule, _settings.AppSettingsModule, _onboarding.OnboardingServiceModule, _founderGuide.FounderGuideServiceModule]).service('storeInformationService', ["$q", "$http", "onboardingService", "founderGuideService", "dataService", "settings", function ($q, $http, onboardingService, founderGuideService, dataService, settings) {
  var store = null;
  var storeCall = null;
  return {
    checkEmail: checkEmail,
    getCustomDomainStatus: getCustomDomainStatus,
    getLaunchStatus: getLaunchStatus,
    getStore: getStore,
    hasStoreAddress: hasStoreAddress,
    registerCustomDomain: registerCustomDomain,
    removeCustomDomain: removeCustomDomain,
    removeImage: removeImage,
    save: save
  };

  function getStore(force) {
    if (store && !force) {
      return $q.resolve(store);
    } else if (storeCall) {
      return storeCall;
    }

    storeCall = dataService.get(settings.api.storeInformation).then(function (response) {
      store = response;
      storeCall = null;
      return response;
    });
    return storeCall;
  }

  function getCustomDomainStatus() {
    return dataService.get(settings.api.customDomainStatus);
  }

  function registerCustomDomain(domain) {
    return dataService.create(settings.api.registerCustomDomain, {
      domain: domain
    });
  }

  function hasStoreAddress() {
    return getStore().then(function (response) {
      return angular.isDefined(response.mailingAddress) && isValidAddressString(response.mailingAddress.address1) && isValidAddressString(response.mailingAddress.city) && isValidAddressString(response.mailingAddress.state) && isValidAddressString(response.mailingAddress.postalCode);
    });
  }

  function isValidAddressString(s) {
    return angular.isDefined(s) && s !== '';
  }

  function checkEmail(email) {
    return $http.get("".concat("https://sandbox.api-v2.volusion.com", "/users"), {
      params: {
        email: email
      }
    }).then(function (res) {
      return res.data;
    });
  }

  function removeCustomDomain(customDomain) {
    var apiUrl = "".concat("https://sandbox.api-v2.volusion.com", "/").concat(settings.api.storeInformationCustomDomain);
    return $http.delete(apiUrl, {
      data: customDomain,
      headers: {
        'Content-Type': 'application/json'
      },
      // since the API is not returning a JSON string,
      // override the default transformation (JSON.parse)
      transformResponse: function transformResponse(data) {
        if (data === 'success') {
          return {
            success: true
          };
        }

        return {
          success: false
        };
      }
    });
  }

  function save(storeInformation, markTaskComplete) {
    return dataService.saveAll(settings.api.storeInformation, storeInformation).then(function (response) {
      store = response;

      if (store.completedLaunchRequirements) {
        onboardingService.unlockTask('launch.launchStore');
      }

      if (store.launched) {
        onboardingService.completeTask('launch.launchStore');
        onboardingService.unlockTask('run.processOrder');
      }

      if (store.stripeAccountId) {
        onboardingService.completeTask('launch.configureStore');
      }

      if (store.logo && store.logo.imageLink || markTaskComplete) {
        var MILESTONE = 2;
        return founderGuideService.completeFounderGuideTask('design.addLogo', null, MILESTONE).then(function () {
          return store;
        });
      }

      return store;
    });
  }

  function removeImage(imageId) {
    var imageUrl = "".concat(settings.api.images, "/").concat(imageId);
    return dataService.remove(imageUrl);
  }

  function getLaunchStatus() {
    return getStore(true).then(function (storeInfo) {
      return storeInfo.launched;
    });
  }
}]).name;
exports.StoreInformationServiceModule = StoreInformationServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionServiceModule = exports.isDowngrade = void 0;

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _get = _interopRequireDefault(__webpack_require__(34));

var _creditCard = __webpack_require__(164);

var _paymentMethod = __webpack_require__(269);

var _expireCache = __webpack_require__(255);

var _data = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDowngrade = function isDowngrade(currentPlan, newPlan) {
  return getDailyPriceOfPlan(currentPlan) > getDailyPriceOfPlan(newPlan);
};

exports.isDowngrade = isDowngrade;

var getDailyPriceOfPlan = function getDailyPriceOfPlan(plan) {
  return plan.amount / getNumberOfDaysInPlanCycle(plan);
};

var getNumberOfDaysInPlanCycle = function getNumberOfDaysInPlanCycle(plan) {
  var daysInIntervals = {
    day: 1,
    week: 7,
    month: 30,
    year: 365
  };
  return daysInIntervals[plan.interval] * plan.interval_count;
};

var SubscriptionServiceModule = angular.module('app.services.access.subscription', [_angularTranslate.default, _creditCard.CreditCardServiceModule, _paymentMethod.PaymentMethodServiceModule, _expireCache.ExpireCacheServiceModule, _data.DataServiceModule]).service('subscriptionsService', ["$http", "$q", "$cacheFactory", "creditCardService", "$translate", "$rootScope", "paymentMethodService", "dataService", "$window", "expireCache", function ($http, $q, $cacheFactory, creditCardService, $translate, $rootScope, paymentMethodService, dataService, $window, expireCache) {
  var cache = $cacheFactory('subscriptionCache');
  var subscriptionsUrl = "".concat("https://sandbox.api-v2.volusion.com", "/admin/subscriptions");
  var service = {
    cache: cache,
    changePlan: changePlan,
    getPlan: getPlan,
    getPlanFeatures: getPlanFeatures,
    getPlanName: getPlanName,
    getSubscription: getSubscription,
    getTaxPercent: getTaxPercent,
    getGrandTotal: getGrandTotal,
    subscribeToPlusPlan: subscribeToPlusPlan,
    unsubscribeFromPlusPlan: unsubscribeFromPlusPlan,
    updateSubscription: updateSubscription,
    appPlans: {
      'Personal-1App': {
        maxInstalledApps: 1
      },
      'Professional-3Apps': {
        maxInstalledApps: 3
      },
      'Business-5Apps': {
        maxInstalledApps: 5
      },
      '3M-Personal-1App': {
        maxInstalledApps: 1
      },
      '3M-Professional-3Apps': {
        maxInstalledApps: 3
      },
      '3M-Business-5Apps': {
        maxInstalledApps: 5
      }
    }
  };

  function unsubscribeFromPlusPlan() {
    return service.changePlan("57e139f2f6c4e20011a67722");
  }

  function subscribeToPlusPlan(user, card, billingAddress) {
    return creditCardService.createStripeCcToken(card, user, billingAddress).then(function (cardResponse) {
      var stripeCcToken = (0, _get.default)(cardResponse, 'id', null);
      return service.changePlan("57e139f2f6c4e20011a67723", stripeCcToken);
    }, function (error) {
      return $q.reject({
        description: 'Stripe Token Error',
        data: error
      });
    });
  }

  function changePlan(_ref) {
    var stripeToken = _ref.stripeToken,
        planId = _ref.planId,
        couponCode = _ref.couponCode,
        trialDaysRemaining = _ref.trialDaysRemaining,
        address = _ref.address;
    return updatePaymentMethod(stripeToken).catch(function (error) {
      return $q.reject({
        message: 'There was a problem with your payment card. Please check your payment details and try again.',
        // eslint-disable-line max-len
        data: error
      });
    }).then(service.getSubscription).then(function (subscription) {
      var failureMessage = 'Failed to change plan';

      if (subscription.plan) {
        subscription.plan.id = planId;
      } else {
        return $q.reject({
          description: failureMessage
        });
      }

      if (couponCode) {
        subscription.couponCode = couponCode;
      }

      if (trialDaysRemaining) {
        subscription.trialLengthInDays = trialDaysRemaining;
      }

      if (address) {
        subscription.address = address;
      }

      return service.updateSubscription(subscription).then(function (response) {
        $rootScope.$emit('SubscriptionService:PlanChanged', response);
        return response;
      }).catch(function (error) {
        return $q.reject({
          description: failureMessage,
          data: error
        });
      }).then(function (subscriptionResponse) {
        expireCache();
        return subscriptionResponse;
      });
    });
  }

  function updatePaymentMethod(stripeToken) {
    if (!stripeToken) return $q.resolve();
    return paymentMethodService.updatePaymentMethod(stripeToken).catch(function (error) {
      return $q.reject({
        description: 'Failed to update payment information',
        data: error
      });
    });
  }

  function getPlanName() {
    return service.getSubscription().then(function (response) {
      return response.plan.name;
    });
  }

  function getPlan() {
    return service.getSubscription().then(function (response) {
      return response.plan;
    });
  }

  function getTaxPercent(state, zipcode) {
    return $http.get("".concat("https://sandbox.api-v2.volusion.com", "/admin/taxrate"), {
      params: {
        state: state,
        zipcode: zipcode
      }
    }).then(function (response) {
      return response.data.taxPercent;
    });
  }

  function getGrandTotal(plan, state, zip) {
    return $http.post("".concat("https://sandbox.api-v2.volusion.com", "/admin/subscriptions/grandtotal"), {
      plan: plan,
      address: {
        state: state,
        zip: zip
      }
    }).then(function (grandTotalResponse) {
      return grandTotalResponse.data;
    });
  }

  function getSubscription() {
    return $http.get(subscriptionsUrl, {
      cache: service.cache
    }).then(function (response) {
      return response.data;
    });
  }

  function updateSubscription(subscription) {
    return $http.put(subscriptionsUrl, subscription).then(function (response) {
      service.cache.removeAll();
      service.cache.put('subscriptionCache', response.data);
      return response.data;
    });
  }

  function getPlanFeatures(planName) {
    var translationKey = planName === 'plus' ? 'MYACCOUNT.PLUSFEATURES' : '';
    return $translate([translationKey]).then(function (response) {
      var features = response[translationKey];
      return features ? features.split('_') : [];
    });
  }

  return service;
}]).name;
exports.SubscriptionServiceModule = SubscriptionServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthTokenServiceModule = void 0;

var _auth0sdk = __webpack_require__(328);

var _angularJwt = _interopRequireDefault(__webpack_require__(167));

var _constants = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AuthTokenServiceModule = angular.module('app.services.auth.authTokenService', [_auth0sdk.Auth0SdkServiceModule, _angularJwt.default]).factory('authTokenService', ["auth0SdkService", "$q", function (auth0SdkService, $q) {
  var cachedToken;
  var cachedTenant;
  return {
    getTenantId: getTenantId,
    getBearer: getBearer,
    getDecodedIdToken: getDecodedIdToken,
    getAccessToken: getAccessToken,
    getEmail: getEmail,
    getHeaders: getHeaders,
    getUser: getUser,
    getCachedTenantId: getCachedTenantId,
    getCachedToken: getCachedToken
  };

  function getCachedTenantId() {
    return cachedTenant;
  }

  function getCachedToken() {
    return cachedToken;
  }

  function getTenantId() {
    return auth0SdkService.getUser().then(function (user) {
      return user && (user[_constants.AUTH0_TENANT_CLAIM] || user.tenant);
    });
  }

  function getUser() {
    return auth0SdkService.getUser().then(function (user) {
      if (user) {
        cachedTenant = user[_constants.AUTH0_TENANT_CLAIM] || user.tenant;
      }

      return user;
    });
  }

  function getEmail() {
    return auth0SdkService.getUser().then(function (user) {
      return user && user.email;
    });
  }

  function getAccessToken() {
    return auth0SdkService.getTokenSilently().then(function (token) {
      cachedToken = token;

      if (!cachedTenant) {
        auth0SdkService.getUser().then(function (user) {
          if (user) {
            cachedTenant = user[_constants.AUTH0_TENANT_CLAIM] || user.tenant;
          }
        });
      }

      return token;
    });
  }

  function getDecodedIdToken() {
    return auth0SdkService.getUser();
  }

  function getBearer() {
    return getAccessToken();
  }

  function getHeaders() {
    var tokenPromise = getBearer();
    var tenantIdPromise = getTenantId();
    return $q.all([tokenPromise, tenantIdPromise]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          token = _ref2[0],
          tenantId = _ref2[1];

      return {
        token: token,
        tenantId: tenantId
      };
    });
  }
}]).name;
exports.AuthTokenServiceModule = AuthTokenServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SegmentServiceModule = void 0;
var SegmentServiceModule = angular.module('app.services.tracking.segment.segment', []).service('segmentService', ["$window", function ($window) {
  var service = {
    trackGtmEvent: trackGtmEvent,
    trackPage: trackPage,
    trackIdentity: trackIdentity
  };

  function trackPage(pageName, data) {
    return $window.analytics.page(pageName, data);
  }

  function trackIdentity(userId, data) {
    return $window.analytics.identify(userId, data);
  }

  function trackGtmEvent(attrs, options) {
    logGtmEvent(attrs, options);
  }

  function logGtmEvent(attrs, options) {
    if (typeof $window.dataLayer !== 'undefined') {
      var eventData = {
        event: attrs.analyticsClickEvent
      };

      if (Object.keys(options).length) {
        eventData = Object.assign(eventData, options);
      }

      $window.dataLayer.push(eventData);
    }
  }

  return service;
}]).name;
exports.SegmentServiceModule = SegmentServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnboardingServiceModule = void 0;

var _OnboardingStore = _interopRequireDefault(__webpack_require__(414));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OnboardingServiceModule = angular.module('app.components.onboarding.onboardingService', []).factory('onboardingService', ["$rootScope", function ($rootScope) {
  function handleAsyncResponse(response) {
    $rootScope.$digest();
    return response;
  }

  return {
    getState: function getState(force) {
      return _OnboardingStore.default.getState(force).then(handleAsyncResponse);
    },
    completeTask: function completeTask(taskId) {
      return _OnboardingStore.default.completeTask(taskId).then(handleAsyncResponse);
    },
    dismissHotspot: function dismissHotspot(hotspotId) {
      return _OnboardingStore.default.dismissHotspot(hotspotId).then(handleAsyncResponse);
    },
    unlockTask: function unlockTask(taskId) {
      return _OnboardingStore.default.unlockTask(taskId).then(handleAsyncResponse);
    },
    setShowNextStepNotice: function setShowNextStepNotice(sessionKey) {
      return _OnboardingStore.default.setShowNextStepNotice(sessionKey);
    },
    completeInitialTask: function completeInitialTask(taskId, taskKey) {
      return _OnboardingStore.default.completeInitialTask(taskId, taskKey).then(handleAsyncResponse);
    }
  };
}]).name;
exports.OnboardingServiceModule = OnboardingServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrialServiceModule = exports.EXPIRED = exports.NOT_TRIAL = exports.PARKED = void 0;

var _moment = _interopRequireDefault(__webpack_require__(74));

var _isUndefined = _interopRequireDefault(__webpack_require__(270));

var _isNull = _interopRequireDefault(__webpack_require__(1244));

var _subscription = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var PARKED = 'PARKED';
exports.PARKED = PARKED;
var NOT_TRIAL = 'NOT_TRIAL';
exports.NOT_TRIAL = NOT_TRIAL;
var EXPIRED = 'EXPIRED';
exports.EXPIRED = EXPIRED;
var TrialServiceModule = angular.module('app.components.trial.trialService', [_subscription.SubscriptionServiceModule]).service('trialService', ["subscriptionsService", "$q", function (subscriptionsService, $q) {
  function getTrialStatus() {
    return getSubscription().then(function (subscription) {
      return getTrialStatusFromSubscription(subscription);
    });
  }

  function getTrialStatusFromSubscription(subscription) {
    return isTrialPlan(subscription).then(function (isTrial) {
      if (isTrial) {
        var currentUnixTimestamp = (0, _moment.default)().unix();
        if ((0, _moment.default)(currentUnixTimestamp).isAfter(subscription.trial_end)) return EXPIRED;

        var timeRemainingInTrial = _moment.default.unix(subscription.trial_end).fromNow(true);

        return timeRemainingInTrial;
      }

      return isParkedPlan(subscription).then(function (isParked) {
        return isParked ? PARKED : NOT_TRIAL;
      });
    });
  }

  function isValidTrialPlanStatus(trialStatus) {
    if ((0, _isUndefined.default)(trialStatus) || (0, _isNull.default)(trialStatus) || trialStatus === '') {
      return false;
    }

    switch (trialStatus) {
      case NOT_TRIAL:
      case PARKED:
      case EXPIRED:
        return false;

      default:
        return true;
    }
  }

  function isTrialPlan(preFetchedSubscription) {
    return getSubscription(preFetchedSubscription).then(function (subscription) {
      return !!(subscription.plan && subscription.plan.name === 'Trial Plan' && isTrialTimestampValid(subscription.trial_start) && isTrialTimestampValid(subscription.trial_end));
    });
  }

  function isTrialTimestampValid(trialTimestamp) {
    return angular.isDefined(trialTimestamp) && trialTimestamp !== null && _typeof(trialTimestamp) !== 'object' && (0, _moment.default)(trialTimestamp).isValid();
  }

  function isParkedPlan(preFetchedSubscription) {
    return getSubscription(preFetchedSubscription).then(function (subscription) {
      return subscription.plan.id === "156b51e031a347f38d2b66e9d71bf380";
    });
  }

  function getSubscription(preFetchedSubscription) {
    if (preFetchedSubscription) return $q.resolve(preFetchedSubscription);
    return subscriptionsService.getSubscription().then(function (subscription) {
      return subscription;
    });
  }

  return {
    getTrialStatus: getTrialStatus,
    isTrialPlan: isTrialPlan,
    isValidTrialPlanStatus: isValidTrialPlanStatus,
    isTrialTimestampValid: isTrialTimestampValid,
    isParkedPlan: isParkedPlan,
    getSubscription: getSubscription,
    getTrialStatusFromSubscription: getTrialStatusFromSubscription
  };
}]).name;
exports.TrialServiceModule = TrialServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppsServiceModule = void 0;

var _map = _interopRequireDefault(__webpack_require__(75));

var _isUndefined = _interopRequireDefault(__webpack_require__(270));

var _isBoolean = _interopRequireDefault(__webpack_require__(1044));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _isPlainObject = _interopRequireDefault(__webpack_require__(236));

var _filter = _interopRequireDefault(__webpack_require__(157));

var _features = __webpack_require__(258);

var _onboarding = __webpack_require__(59);

var _launchDarkly = __webpack_require__(30);

var _optimizely = __webpack_require__(264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AppsServiceModule = angular.module('app.services.data.appsService', [_features.FeaturesServiceModule, _onboarding.OnboardingServiceModule, _optimizely.OptimizelyServiceModule, _launchDarkly.LaunchDarklyServiceModule]).service('appsService', ["$http", "$window", "$q", "featureService", "onboardingService", "optimizelyService", "launchDarklyService", function ($http, $window, $q, featureService, onboardingService, optimizelyService, launchDarklyService) {
  var storeApps;
  return {
    getApps: getApps,
    getSortedApps: getSortedApps,
    getPurchasedApps: getPurchasedApps,
    installApp: installApp,
    uninstallApp: uninstallApp,
    getHmac: getHmac,
    getAppToken: getAppToken,
    getUninstalledFeaturedApps: getUninstalledFeaturedApps
  };

  function getStoreApps() {
    if (!storeApps) {
      return $http.get("".concat("https://sandbox.api-v2.volusion.com", "/marketplace/storeapps")).then(function (res) {
        storeApps = (0, _map.default)(res.data, fixAppImageStructure);
        return storeApps;
      });
    }

    return $q.resolve(storeApps);
  }

  function isFeatureFlagNotSetOrTurnedOn(allFeatureFlags, featureFlag) {
    if ((0, _isUndefined.default)(allFeatureFlags) || (0, _isUndefined.default)(allFeatureFlags[featureFlag])) {
      return true;
    }

    if ((0, _isBoolean.default)(allFeatureFlags[featureFlag])) {
      return allFeatureFlags[featureFlag];
    }

    return !!allFeatureFlags[featureFlag];
  }

  function getApps() {
    return $q.all([getStoreApps(), featureService.getFeatures(), launchDarklyService.allFlags()]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          allApps = _ref2[0],
          features = _ref2[1],
          ldFlags = _ref2[2];

      var filteredApps = (0, _filter.default)(allApps, function (app) {
        return app.isAvailable && (0, _isPlainObject.default)(features[app.sku]) && isFeatureFlagNotSetOrTurnedOn(ldFlags, app.sku);
      });
      return (0, _map.default)(filteredApps, function (app) {
        return (0, _assign.default)(app, features[app.sku]);
      });
    });
  }

  function getSortedApps(sortOrder) {
    return getApps().then(function (apps) {
      return apps.sort(function (a, b) {
        var indexA = sortOrder.indexOf(a.sku);
        var indexB = sortOrder.indexOf(b.sku);
        if (indexA >= 0 && indexB >= 0) return indexA < indexB ? -1 : 1;
        if (indexA >= 0 && indexB < 0) return -1;
        if (indexA < 0 && indexB >= 0) return 1;
        return 0;
      });
    });
  }

  function getHmac() {
    return $http.get("".concat("https://sandbox.api-v2.volusion.com", "/apps/hmac")).then(function (hmac) {
      return hmac.data;
    });
  }

  function getAppToken(appKey) {
    return $http.post("".concat("https://sandbox.api-v2.volusion.com", "/apps/token"), {}, {
      headers: {
        'x-vol-app-key': appKey
      }
    }).then(function (token) {
      return token.data.token;
    });
  }

  function getPurchasedApps() {
    //This will have list of purchased App with app details.
    return getApps().then(function (allApps) {
      return (0, _filter.default)(allApps, {
        enabled: true
      });
    });
  }

  function getUninstalledFeaturedApps(count, sortOrder) {
    var unfilteredApps = sortOrder ? getSortedApps(sortOrder) : getApps();
    return unfilteredApps.then(function (allApps) {
      var apps = (0, _filter.default)(allApps, {
        enabled: false,
        isFeatured: true
      });
      return apps.slice(0, count);
    });
  }

  function installApp(app) {
    return featureService.enableFeature(app.sku).then(function () {
      onboardingService.completeTask('run.installApp');
      onboardingService.completeTask("apps.".concat(app.sku, "_installed"));
      optimizelyService.trackEvent('action_complete');
      return getApps();
    });
  }

  function uninstallApp(app) {
    return featureService.disableFeature(app.sku).then(function () {
      return getApps();
    });
  }

  function fixAppImageStructure(app) {
    if (app.images[0] && app.images[0].logo) {
      app.logo = app.images[0].logo;
    }

    if (app.images[2] && app.images[2].icon) {
      app.icon = app.images[2].icon;
    }

    if (app.images[1] && app.images[1].app) {
      app.images = app.images[1].app;
    }

    return app;
  }
}]).name;
exports.AppsServiceModule = AppsServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthServiceModule = void 0;

var _angularCookies = _interopRequireDefault(__webpack_require__(103));

var _angularJwt = _interopRequireDefault(__webpack_require__(167));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _nativePlatform = __webpack_require__(125);

var _launchDarkly = __webpack_require__(30);

var _sessionTimeoutModal = __webpack_require__(957);

var _conciergeAuth = __webpack_require__(961);

var _constants = __webpack_require__(24);

var _authToken = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthServiceModule = angular.module('app.services.auth.authService', [_angularCookies.default, _angularJwt.default, _angularjs.default, _nativePlatform.NativePlatformServiceModule, _launchDarkly.LaunchDarklyServiceModule, _conciergeAuth.ConciergeAuthServiceModule, _sessionTimeoutModal.SessionTimeoutModalServiceModule, _authToken.AuthTokenServiceModule]).service('authService', ["$cookies", "$location", "$window", "$document", "$q", "$http", "$state", "jwtHelper", "conciergeAuthService", "nativePlatformService", "launchDarklyService", function ($cookies, $location, $window, $document, $q, $http, $state, jwtHelper, conciergeAuthService, nativePlatformService, launchDarklyService) {
  var config = {
    auth0Domain: "login-sandbox.volusion.com",
    auth0ClientId: "rWEyCZ6MhTBUtDs5ztXrceCVEeBX4FZv",
    auth0Audience: "https://sandbox.api.material.com",
    registrationApiUrl: "".concat("https://sandbox.api-v2.volusion.com", "/registration"),
    rootApiUrl: "https://sandbox.api-v2.volusion.com"
  };

  function getRootDomain(hostname) {
    var parts = hostname.split('.');
    var hasSubdomain = parts.length === 3;
    return hasSubdomain ? "".concat(parts[1], ".").concat(parts[2]) : hostname;
  }

  function clearUser() {
    $window.localStorage.removeItem('user');
    $cookies.remove('id_token');
    $cookies.remove('access_token');
  }

  function isGoogleUser(decodedIdToken) {
    if (!decodedIdToken) {
      return false;
    }

    var userId = decodedIdToken.user_id || decodedIdToken.sub;
    if (!userId) return false;
    var userIdProvider = userId.split('|')[0];
    return userIdProvider === 'google-oauth2';
  }

  function getTenant(decodedIdToken) {
    if (!decodedIdToken) return null;
    return decodedIdToken.tenant || decodedIdToken[_constants.AUTH0_TENANT_CLAIM] || null;
  }

  function hasExistingStore(decodedIdToken) {
    if (!decodedIdToken || !decodedIdToken.email) {
      return $q.reject('no token or email');
    }

    return checkEmail(decodedIdToken.email).then(function (response) {
      return response.data;
    });
  }

  function register(user) {
    var _this = this;

    return $http.post("".concat(config.registrationApiUrl, "/stores"), user).then(function (response) {
      if (response.data.tenantId) {
        // fall back to email/password if token was not available
        return _this.login(user.email, user.password).then(function () {
          return {
            tenantId: response.data.tenantId
          };
        });
      }

      return $q.reject({
        data: response.data
      });
    });
  }

  function registerViaGoogle(decodedIdToken) {
    var user = {
      auth0UserId: decodedIdToken.user_id || decodedIdToken.sub,
      username: decodedIdToken.name,
      email: decodedIdToken.email,
      termsAndConditionsAccepted: true,
      firstName: decodedIdToken.given_name,
      lastName: decodedIdToken.family_name,
      planId: "plan_EOIrHAaznhp9Xq"
    };
    return launchDarklyService.getFeature('create-salesforce-lead').then(function (getsSalesforceFeature) {
      if (getsSalesforceFeature) {
        user.createSalesforceLead = true;
        user.salesforce = {
          Email: decodedIdToken.email,
          FirstName: decodedIdToken.given_name,
          LastName: decodedIdToken.family_name,
          Lead_Source_Description__C: 'Google Social Signup',
          Device_Type__c: nativePlatformService.isMobileUserAgent ? 'mobile' : 'desktop',
          SocialSignUp__c: true,
          SocialSignUpNetwork__c: 'google-oauth2',
          productVersion__c: 'v2',
          GA_Source__c: 'Google Social Signup',
          GA_Campaign__c: 'Google Social Signup',
          GA_Medium__c: 'Google Social Signup',
          Marketing_1__c: 'Google Social Signup',
          Marketing_2__c: 'Google Social Signup',
          Marketing_3__c: 'Google Social Signup'
        };
      }

      return $http.post("".concat(config.registrationApiUrl, "/stores"), user);
    }).catch(function () {
      return $http.post("".concat(config.registrationApiUrl, "/stores"), user);
    });
  }

  function linkExistingGoogleUser(decodedIdToken) {
    var auth0UserId = decodedIdToken.user_id || decodedIdToken.sub;
    var email = decodedIdToken.email;
    return $http.put("".concat(config.rootApiUrl, "/admin/users/").concat(auth0UserId, "/").concat(email, "/linkgoogleaccount"));
  }

  function resetPassword(user) {
    return $http.post("".concat(config.rootApiUrl, "/admin/passwords/reset"), user, {
      transformResponse: angular.identity
    });
  }

  function checkEmail(email) {
    return $http.get("".concat(config.rootApiUrl, "/users?email=").concat(email));
  }

  function isImpersonator() {
    return conciergeAuthService.isImpersonator();
  }

  function isCookiesEnabled() {
    var cookieEnabled = $window.navigator.cookieEnabled;

    if (typeof $window.navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
      $document.cookie = 'testcookie';
      cookieEnabled = $document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }

  function getTokensFromUrlHash(hash) {
    if (hash && hash.length > 0) {
      var tokenDataArray = hash.split('&').map(function (i) {
        var parts = i.split('=');
        var partsObj = {};
        partsObj[parts[0]] = parts[1];
        return partsObj;
      });

      if (tokenDataArray && tokenDataArray.length > 0) {
        var accessToken = unwrapArray(tokenDataArray.filter(function (tokenObj) {
          return tokenObj.access_token;
        }));
        var idToken = unwrapArray(tokenDataArray.filter(function (i) {
          return i.id_token;
        }));

        if (accessToken && idToken) {
          var tokens = {};
          tokens.access_token = accessToken.access_token;
          tokens.id_token = idToken.id_token;
          return tokens;
        }
      }
    }

    function unwrapArray(arr) {
      if (arr.length && arr.length === 1) return arr[0];
    }

    return null;
  }

  function hasTokens(tokens) {
    return tokens.id_token && tokens.access_token;
  }

  return {
    checkEmail: checkEmail,
    clearUser: clearUser,
    config: config,
    getRootDomain: getRootDomain,
    getTenant: getTenant,
    getTokensFromUrlHash: getTokensFromUrlHash,
    hasExistingStore: hasExistingStore,
    hasTokens: hasTokens,
    isCookiesEnabled: isCookiesEnabled,
    isGoogleUser: isGoogleUser,
    isImpersonator: isImpersonator,
    linkExistingGoogleUser: linkExistingGoogleUser,
    register: register,
    registerViaGoogle: registerViaGoogle,
    resetPassword: resetPassword
  };
}]).name;
exports.AuthServiceModule = AuthServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyAccountServiceModule = void 0;

var _auth = __webpack_require__(77);

var _settings = __webpack_require__(15);

var _storage = __webpack_require__(130);

var _authToken = __webpack_require__(43);

var _auth0auth = __webpack_require__(166);

var _segment = __webpack_require__(58);

var _data = __webpack_require__(11);

var MyAccountServiceModule = angular.module('app.services.data.myAccount', [_data.DataServiceModule, _settings.AppSettingsModule, _storage.StorageServiceModule, _authToken.AuthTokenServiceModule, _auth0auth.Auth0AuthServiceModule, _auth.AuthServiceModule, _segment.SegmentServiceModule]).service('myAccountService', ["$q", "$window", "$http", "dataService", "settings", "authTokenService", "auth0AuthService", function ($q, $window, $http, dataService, settings, authTokenService, auth0AuthService) {
  var storeAdmin = null;
  return {
    getUser: getUser,
    getUserId: getUserId,
    save: save,
    updatePassword: updatePassword,
    cancelAccount: cancelAccount,
    getEmailVerifiedStatus: getEmailVerifiedStatus,
    resendVerification: resendVerification,
    checkInterval: null
  };

  function getUser(force) {
    if (storeAdmin && !force) {
      $q.resolve(storeAdmin);
    }

    return auth0AuthService.getTokenSilently().then(getUserId).then(function (userId) {
      var storeAdminUrl = "".concat(settings.api.storeAdmin, "/").concat(userId);
      return dataService.get(storeAdminUrl).then(function (response) {
        storeAdmin = response;
        return response;
      });
    });
  }

  function getUserId() {
    return auth0AuthService.getUser().then(function (auth0User) {
      return auth0User ? auth0User.sub : null;
    });
  }

  function save(newUser) {
    return dataService.save(settings.api.storeAdmin, encodeURIComponent(newUser.id), newUser);
  }

  function updatePassword(user, pass) {
    return dataService.save("".concat(settings.api.storeAdmin, "/").concat(encodeURIComponent(user.id), "/password"), null, {
      email: user.email,
      oldPassword: pass.old,
      tenantId: authTokenService.getTenantId(),
      password: pass.new
    });
  }

  function cancelAccount() {
    return $http.delete("".concat("https://sandbox.api-v2.volusion.com", "/registration/stores")).then(function () {
      auth0AuthService.logout();
    });
  }

  function getEmailVerifiedStatus() {
    return getUser(true).then(function (user) {
      return user.emailVerified;
    });
  }

  function resendVerification(user) {
    var payload = {
      email: user.email
    };
    return dataService.create(settings.api.verification, payload);
  }
}]).name;
exports.MyAccountServiceModule = MyAccountServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditCardUtilitiesServiceModule = void 0;
var CreditCardUtilitiesServiceModule = angular.module('app.services.payment.creditCardUtilities', []).service('creditCardUtilities', function () {
  function newCard() {
    return {
      cardNumber: '',
      expMonth: '',
      expYear: ''
    };
  }

  function getCardType(cardNumber) {
    var cardTypeName = '';

    if (/^(34)|^(37)/.test(cardNumber)) {
      cardTypeName = 'American Express';
    } else if (/^4/.test(cardNumber)) {
      cardTypeName = 'Visa';
    } else if (/^5[1-5]/.test(cardNumber)) {
      cardTypeName = 'MasterCard'; // eslint-disable-next-line max-len
    } else if (/^(6011)|^(622(1(2[6-9]|[3-9][0-9])|[2-8][0-9]{2}|9([01][0-9]|2[0-5])))|^(64[4-9])|^65/.test(cardNumber)) {
      cardTypeName = 'Discover';
    } else if (/^(36|38|30[0-5])/.test(cardNumber)) {
      cardTypeName = 'Diners Club';
    } else if (/^35/.test(cardNumber)) {
      cardTypeName = 'JCB';
    }

    return cardTypeName;
  }

  function getLastFour(cardNumber) {
    return cardNumber.slice(-4);
  }

  function getMaskedCardNumber(cardNumber) {
    return "xxxx xxxx xxxx ".concat(cardNumber.length === 4 ? cardNumber : getLastFour(cardNumber));
  }

  function parseExpiration(value) {
    var month;
    var prefix;
    var year;

    var _ref;

    value = value || '';
    value = value.replace(/\s/g, '');
    _ref = value.split('/', 2);
    month = _ref[0];
    year = _ref[1];

    if ((year != null ? year.length : undefined) === 2 && /^\d+$/.test(year)) {
      prefix = new Date().getFullYear();
      prefix = prefix.toString().slice(0, 2);
      year = prefix + year;
    }

    month = parseInt(month);
    year = parseInt(year);
    return {
      month: month,
      year: year
    };
  }

  function getCssClass(cardType) {
    switch (angular.isString(cardType) ? cardType.toUpperCase() : cardType) {
      case 'AMEX':
      case 'AMERICAN EXPRESS':
        return 'credit-card-img--amex';

      case 'VISA':
        return 'credit-card-img--visa';

      case 'MC':
      case 'MASTERCARD':
        return 'credit-card-img--mastercard';

      case 'DISC':
      case 'DISCOVER':
        return 'credit-card-img--discover';

      case 'DINERS CLUB':
        return 'credit-card-img--dinersclub';

      case 'JCB':
        return 'credit-card-img--jcb';

      case 'APPLE_PAY':
        return 'credit-card-img--applepay';

      default:
        return 'credit-card-img--unknown';
    }
  }

  return {
    newCard: newCard,
    getCardType: getCardType,
    getLastFour: getLastFour,
    getMaskedCardNumber: getMaskedCardNumber,
    parseExpiration: parseExpiration,
    getCssClass: getCssClass
  };
}).name;
exports.CreditCardUtilitiesServiceModule = CreditCardUtilitiesServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductServiceModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _cloneDeep = _interopRequireDefault(__webpack_require__(189));

var _find = _interopRequireDefault(__webpack_require__(66));

var _flatten = _interopRequireDefault(__webpack_require__(259));

var _has = _interopRequireDefault(__webpack_require__(425));

var _pick = _interopRequireDefault(__webpack_require__(273));

var _reduce = _interopRequireDefault(__webpack_require__(160));

var _founderGuide = __webpack_require__(155);

var _segment = __webpack_require__(58);

var _data = __webpack_require__(11);

var _search = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductServiceModule = angular.module('app.service.data.productService', [_data.DataServiceModule, _founderGuide.FounderGuideServiceModule, _search.SearchServiceModule, _segment.SegmentServiceModule]).service('productService', ["$q", "$http", "dataService", "settings", "$window", "founderGuideService", function ($q, $http, dataService, settings, $window, founderGuideService) {
  return {
    save: save,
    create: create,
    createImportJob: createImportJob,
    bulkUpload: bulkUpload,
    getBulkUploadStatus: getBulkUploadStatus,
    getProduct: getProduct,
    getProducts: getProducts,
    getMinimalProducts: getMinimalProducts,
    getMinimalProductsWithVariants: getMinimalProductsWithVariants,
    removeProduct: removeProduct,
    copyProduct: copyProduct,
    getProductCount: getProductCount,
    getMetrics: getMetrics,
    getBaseProductSkuItemFromProduct: getBaseProductSkuItemFromProduct,
    doesProductHaveVariants: doesProductHaveVariants,
    showListPrice: showListPrice,
    asVariantsWithMetaData: asVariantsWithMetaData,
    createProductExportJob: createProductExportJob,
    getStatusCodesForFilter: getStatusCodesForFilter
  };

  function save(product) {
    return dataService.save(settings.api.products, product.id, product);
  }

  function create(product) {
    return dataService.create(settings.api.products, product).then(function (data) {
      var taskId = 'organize.addProduct';
      var firstProductCreatedKey = 'productsService:firstProductCreated';
      var productCreatedKey = 'productsService:productCreated';
      var MILESTONE = 1;
      var FOUNDERGUIDE_STEP_KEY = 'productDetails:founderGuideStepComplete';
      $window.sessionStorage.setItem(productCreatedKey, true);
      return founderGuideService.completeFounderGuideTask(taskId, firstProductCreatedKey, MILESTONE).then(function (taskCompleted) {
        if (taskCompleted) $window.sessionStorage.setItem(FOUNDERGUIDE_STEP_KEY, true);
        return data;
      });
    });
  }

  function bulkUpload(url, csv) {
    return $http.put(url, atob(csv), {
      headers: {
        'Content-Type': 'text/csv'
      }
    });
  }

  function createImportJob() {
    return dataService.create(settings.api.importJob);
  }

  function getBulkUploadStatus(importerJobId) {
    return dataService.get(settings.api.productBulkUploadStatus, importerJobId);
  }

  function removeProduct(product) {
    if (Object.prototype.hasOwnProperty.call(product, 'update')) {
      product.update();
    }

    return dataService.remove(settings.api.products, product.id);
  }

  function copyProduct(item, nameLength) {
    var copyItem = angular.copy(item);
    copyItem.sku = null;
    copyItem.seo.friendlyName = null;
    copyItem.createdOn = null;
    copyItem.updatedOn = null;
    return dataService.copy(settings.api.products, copyItem, nameLength);
  }

  function getProduct(id) {
    return dataService.get(settings.api.products, id);
  }

  function getProductsCommon(page, count, sort, options, apiRoute) {
    options = options || {};
    page = page || 1;
    count = count || 25;
    options.pageSize = count;
    options.startIndex = (page - 1) * count;

    if (sort && sort.length) {
      options.sortBy = sort[0].replace(' ', '+');
    }

    return dataService.getAll(apiRoute, options);
  }

  function getProducts(page, count, sort, options) {
    return getProductsCommon(page, count, sort, options, settings.api.products);
  }

  function getMinimalProducts(page, count, sort, options) {
    return getProductsCommon(page, count, sort, options, settings.api.productsMinimal);
  }

  function getMinimalProductsWithVariants(page, count, sort, options) {
    var queryStringOptions = options || {};

    if (!(0, _has.default)(queryStringOptions, 'include')) {
      queryStringOptions.include = 'variants';
    }

    return getProductsCommon(page, count, sort, queryStringOptions, settings.api.productsMinimal);
  }

  function getProductCount(queryFilter, sort) {
    return dataService.getAll(settings.api.productsMinimal, {
      filter: queryFilter,
      sort: sort ? sort.replace(' ', '+') : null,
      pageSize: 1
    }).then(function (response) {
      return response.totalCount;
    });
  }

  function getBaseProductSkuItemFromProduct(product) {
    if (product.productVariants && angular.isArray(product.productVariants) && product.productVariants.length > 0) {
      return (0, _find.default)(product.productVariants, function (productVariant) {
        return !productVariant.variants || productVariant.variants.length === 0;
      });
    }
  }

  function doesProductHaveVariants(product) {
    if (!product.variantOptions || product.variantOptions.length === 0) {
      return false;
    }

    return true;
  }

  function getMetrics() {
    return dataService.getAll(settings.api.productsMetrics).then(function (_ref) {
      var activeCount = _ref.activeCount,
          inactiveCount = _ref.inactiveCount,
          newProductCount = _ref.newProductCount,
          trackedSKUCount = _ref.trackedSKUCount,
          outOfStockSKUCount = _ref.outOfStockSKUCount;
      return {
        activeCount: activeCount,
        inactiveCount: inactiveCount,
        newProductCount: newProductCount,
        totalProductCount: activeCount + inactiveCount,
        trackedSKUCount: trackedSKUCount,
        outOfStockSKUCount: outOfStockSKUCount
      };
    });
  }

  function showListPrice(product) {
    return product.pricing ? product.pricing.listPrice : product.price;
  }

  function asVariantsWithMetaData(products) {
    var wrappedProducts = products.map(function (product) {
      var hasVariants = product.productVariants.length > 1;

      if (!hasVariants) {
        var quantity = (0, _reduce.default)(product.productVariants, function (sum, variant) {
          return sum + variant.quantity;
        }, 0);
        var isInventoryTracked = product.productVariants[0].isInventoryTracked;
        var fulfillmentData = product.productVariants[0].fulfillmentData;
        return {
          selected: false,
          data: product,
          id: product.id,
          hasVariants: hasVariants,
          isInventoryTracked: isInventoryTracked,
          quantity: quantity,
          sourceSku: fulfillmentData.sourceSku || '',
          disabled: isInventoryTracked && quantity === 0
        };
      }

      if (hasVariants) {
        var variants = product.productVariants.map(function (variant) {
          var p = (0, _cloneDeep.default)(product);
          (0, _assign.default)(p, (0, _pick.default)(variant, ['sku', 'price', 'priceOverride', 'isInventoryTracked', 'quantity', 'variants', 'fulfillmentData']));
          p.productVariantId = variant.id;
          return {
            selected: false,
            data: p,
            id: p.id,
            isVariant: true,
            isInventoryTracked: variant.isInventoryTracked,
            quantity: variant.quantity,
            disabled: variant.isInventoryTracked && variant.quantity === 0,
            sourceSku: variant.fulfillmentData.sourceSku || ''
          };
        });
        return variants;
      }

      return [];
    });
    return (0, _flatten.default)(wrappedProducts);
  }

  function createProductExportJob() {
    var selectedProductSkus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return dataService.create(settings.api.productExport, {
      productSkus: selectedProductSkus
    });
  }

  function getStatusCodesForFilter(filter) {
    return dataService.get(settings.api.productTaxCodes, filter);
  }
}]).name;
exports.ProductServiceModule = ProductServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryServiceModule = void 0;

var _filter = _interopRequireDefault(__webpack_require__(157));

var _findIndex = _interopRequireDefault(__webpack_require__(192));

var _extend = _interopRequireDefault(__webpack_require__(415));

var _last = _interopRequireDefault(__webpack_require__(275));

var _omit = _interopRequireDefault(__webpack_require__(197));

var _sortBy = _interopRequireDefault(__webpack_require__(195));

var _reduce = _interopRequireDefault(__webpack_require__(160));

var _find = _interopRequireDefault(__webpack_require__(66));

var _map = _interopRequireDefault(__webpack_require__(75));

var _remove2 = _interopRequireDefault(__webpack_require__(193));

var _onboarding = __webpack_require__(59);

var _menus = __webpack_require__(654);

var _products = __webpack_require__(98);

var _data = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CategoryServiceModule = angular.module('app.services.data.categoryService', [_products.ProductServiceModule, _onboarding.OnboardingServiceModule, _data.DataServiceModule, _menus.MenuServiceModule]).service('categoryService', ["$q", "$window", "productService", "menuService", "dataService", "onboardingService", "settings", function ($q, $window, productService, menuService, dataService, onboardingService, settings) {
  var categoryTree;
  return {
    add: add,
    copy: copy,
    createNewCategory: createNewCategory,
    remove: remove,
    update: update,
    updateAll: updateAll,
    getCategories: getCategories,
    getCategoryById: getCategoryById,
    getCategoryTree: getCategoryTree,
    getFlatCategories: getFlatCategories,
    getCategory: getCategory,
    getCategoryProducts: getCategoryProducts,
    getMenuCount: getMenuCount,
    saveCategoryProducts: saveCategoryProducts,
    flattenCategories: flattenCategories,
    removeById: removeById,
    removeFieldsForCreate: removeFieldsForCreate,
    updateCategory: updateCategory,
    updateCategoryProducts: updateCategoryProducts,
    updateCategoryImages: updateCategoryImages,
    // the following are used for testing
    _setTree: _setTree,
    _getTree: _getTree
  };

  function _setTree(tree) {
    categoryTree = tree;
    return categoryTree;
  }

  function _getTree() {
    return categoryTree;
  }

  function getCategories(forceFetch) {
    // returns an array of categories
    if (categoryTree && !forceFetch) {
      return $q.resolve(angular.copy(categoryTree.categories));
    }

    return dataService.getAll(settings.api.categories, {
      pageSize: 200
    }).then(updateCategoryTree).then(function (tree) {
      return angular.copy(tree.categories);
    });
  }

  function getCategoryTree() {
    return dataService.getAll(settings.api.adminCategories);
  }

  function getCategoryById(categoryId) {
    return dataService.get(settings.api.adminCategories, categoryId);
  }

  function getFlatCategories() {
    // returns a flat array of all categories (including subcategories)
    return getCategories().then(flattenCategories);
  }

  function findById(id) {
    return (0, _find.default)(flattenCategories(categoryTree.categories), ['id', id]);
  }

  function flattenCategories(categories) {
    var shouldAddIndentationIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    return categories.reduce(function (arr, category) {
      return arr.concat([shouldAddIndentationIndex ? _objectSpread({}, category, {
        level: level
      }) : category], flattenCategories(category.subCategories || [], shouldAddIndentationIndex, level + 1));
    }, []);
  }

  function add(_ref) {
    var category = _ref.category,
        parentId = _ref.parentId,
        _ref$showCreatedMessa = _ref.showCreatedMessage,
        showCreatedMessage = _ref$showCreatedMessa === void 0 ? true : _ref$showCreatedMessa,
        _ref$markTaskComplete = _ref.markTaskComplete,
        markTaskComplete = _ref$markTaskComplete === void 0 ? true : _ref$markTaskComplete;

    function addCategory() {
      var parent = findById(parentId || category.parentId);
      var categoryArray = parent ? parent.subCategories : categoryTree.categories;
      categoryArray.push(category);
      return save(categoryTree).then(function (data) {
        var taskId = 'organize.addCategory';
        var firstCategoryCreatedKey = 'categoriesService:firstCategoryCreated';
        if (showCreatedMessage) $window.sessionStorage.setItem('categoriesService:categoryCreated', true);

        if (markTaskComplete) {
          onboardingService.completeInitialTask(taskId, firstCategoryCreatedKey);
        }

        return data;
      }).then(returnLatestCategory);
    }

    return categoryTree ? addCategory() : getCategories().then(addCategory);
  }

  function remove(category) {
    var parent = findById(category.parentId);

    if (parent) {
      parent.subCategories = (0, _filter.default)(parent.subCategories, function (el) {
        return el.id !== category.id;
      });
    } else {
      categoryTree.categories = (0, _filter.default)(categoryTree.categories, function (el) {
        return el.id !== category.id;
      });
    }

    return save(categoryTree);
  }

  function removeById(categoryId) {
    return dataService.remove(settings.api.adminCategories, categoryId);
  }

  function update(category) {
    // returns updated category
    var parent = findById(category.parentId);
    var categoryArray = parent ? parent.subCategories : categoryTree.categories;
    var i = (0, _findIndex.default)(categoryArray, ['id', category.id]);
    categoryArray.splice(i, 1, category);
    return save(categoryTree).then(function () {
      return getCategory(category.id);
    });
  }

  function removeFieldsForCreate(category) {
    return (0, _omit.default)(category, '_id', 'categoryId', 'contentPageId', 'createdOn', 'id', 'images', 'productCount', 'subCategories', 'updatedOn');
  }

  function createNewCategory(category) {
    return dataService.create(settings.api.adminCategories, category);
  }

  function updateCategory(category) {
    return dataService.save(settings.api.adminCategories, category.categoryId, category);
  }

  function copy(category, nameLength) {
    // returns copied category
    nameLength = nameLength || 35;
    var strLength = nameLength - 7;
    var copyItem = (0, _extend.default)({}, category, {
      id: null,
      name: "".concat(category.name.substring(0, strLength), " - COPY"),
      subCategories: []
    });
    var parent = findById(category.parentId);
    var categoryArray = parent ? parent.subCategories : categoryTree.categories;
    categoryArray.push(copyItem);
    return save(categoryTree).then(returnLatestCategory);
  }

  function findMostRecent(categories) {
    var flatCategories = flattenCategories(categories);
    return (0, _last.default)((0, _sortBy.default)(flatCategories, 'createdOn'));
  }

  function getCategory(id) {
    return categoryTree ? $q.resolve(findById(id)) : getCategories().then(function () {
      return findById(id);
    });
  }

  function getCategoryProducts(categoryId, page, count, sort) {
    var options = {
      filter: "categoryId eq ".concat(categoryId)
    };
    return productService.getMinimalProducts(page, count, sort, options);
  }

  function updateAll(categories) {
    categoryTree.categories = categories;
    return save(categoryTree);
  }

  function save(catTree) {
    return dataService.saveAll(settings.api.categories, catTree).then(updateCategoryTree).then(function (cTree) {
      return cTree.categories;
    });
  }

  function updateCategoryTree(response) {
    categoryTree = response;
    return categoryTree;
  }

  function returnLatestCategory() {
    return findMostRecent(categoryTree.categories);
  }

  function getMenuCount(category) {
    return menuService.getMenus().then(function (response) {
      var menus = response.items;
      var menuCount = (0, _reduce.default)(menus, function (count, menu) {
        var menuHasCategory = (0, _find.default)(menu.items, {
          name: category.name
        });
        return menuHasCategory ? count + 1 : count;
      }, 0);
      return menuCount;
    });
  }

  function updateCategoryProducts(category, productChanges) {
    if (productChanges) {
      var updateCategoryProductsUrl = "".concat(settings.api.adminCategories, "/").concat(category.categoryId, "/products");
      return dataService.saveAll(updateCategoryProductsUrl, productChanges);
    }
  }

  function updateCategoryImages(category, imagesChanges) {
    if (imagesChanges) {
      var updateCategoryImagesUrl = "".concat(settings.api.adminCategories, "/").concat(category.categoryId, "/images");
      return dataService.saveAll(updateCategoryImagesUrl, imagesChanges);
    }
  }

  function saveCategoryProducts(category, products) {
    var productPromises = [];

    if (products.length) {
      productPromises = (0, _map.default)(products, function (product) {
        if (product.categoryIds.indexOf(category.id) !== -1) {
          (0, _remove2.default)(product.categoryIds, function (id) {
            return id === category.id;
          });
        } else {
          product.categoryIds.push(category.id);
        }

        return productService.save(product);
      });
      return $q.all(productPromises).then(function () {
        return category;
      });
    }

    return $q.resolve(category);
  }
}]).name;
exports.CategoryServiceModule = CategoryServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LaunchChangePlanServiceModule = void 0;

var _changePlanModule = __webpack_require__(709);

var LaunchChangePlanServiceModule = angular.module('app.components.changePlan.launchChangePlanService', ['ngMaterial', _changePlanModule.ChangePlanModule]).service('launchChangePlanService', ["$mdDialog", function ($mdDialog) {
  function openModal(event) {
    angular.element('body').addClass('md-dialog--container-scroll');
    $mdDialog.show({
      template: "\n                    <md-dialog class=\"change-plan-modal\">\n                        <change-plan></change-plan>\n                    </md-dialog>\n                ",
      event: event
    }).finally(function () {
      angular.element('body').removeClass('md-dialog--container-scroll');
    });
  }

  return {
    openModal: openModal
  };
}]).name;
exports.LaunchChangePlanServiceModule = LaunchChangePlanServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppShellModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _appShell = __webpack_require__(1404);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppShellModule = angular.module('app.pages.appShell', [_angularjs.default, _appShell.AppShellComponent]).config(["$stateProvider", function ($stateProvider) {
  'ngInject';

  $stateProvider.state({
    name: 'apps',
    parent: 'auth',
    url: '/apps',
    data: {
      page: 'apps'
    },
    abstract: true,
    template: '<ui-view />'
  });
}]).name;
exports.AppShellModule = AppShellModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchServiceModule = void 0;

var _curry = _interopRequireDefault(__webpack_require__(423));

var _algoliasearch = _interopRequireDefault(__webpack_require__(581));

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchServiceModule = angular.module('app.services.data.searchService', [_data.DataServiceModule, _settings.AppSettingsModule]).service('searchService', ["dataService", "settings", "$q", function (dataService, settings, $q) {
  var client = null;
  return {
    setApiKey: setApiKey,
    search: search,
    getAll: getAll,
    getManyByIds: getManyByIds
  };

  function setApiKey() {
    return dataService.get(settings.api.searchKey).then(function (response) {
      client = (0, _algoliasearch.default)("A7ZWRYBDDG", response);
    });
  }

  function searchIndex(indexName, query, options) {
    var restrictSearchToName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var index = client.initIndex(indexName); // wrap with $q to fix native promise bug:
    // https://github.com/angular/material/issues/5485
    // was leading to permanent loading state on autocomplete

    var deferred = $q.defer();
    var restrictOptions = restrictSearchToName ? {
      restrictSearchableAttributes: 'name'
    } : {};
    index.search(query, angular.extend({}, restrictOptions, options)).then(function (res) {
      return deferred.resolve(res);
    });
    return deferred.promise;
  }

  function search(indexName, query) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var restrictSearchToName = arguments.length > 3 ? arguments[3] : undefined;
    var performSearch = (0, _curry.default)(searchIndex)(indexName);
    return client ? performSearch(query, options, restrictSearchToName) : setApiKey().then(function () {
      return performSearch(query, options, restrictSearchToName);
    });
  }

  function getAll(indexName, query) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var performSearch = (0, _curry.default)(searchIndex)(indexName);
    return client ? performSearch(query, options, false) : setApiKey().then(function () {
      return performSearch(query, options, false);
    });
  }

  function getObjects(indexName, idList) {
    var index = client.initIndex(indexName);
    return index.getObjects(idList);
  }

  function getManyByIds(indexName, ids) {
    var performGetManyByIds = (0, _curry.default)(getObjects)(indexName);
    return client ? performGetManyByIds(ids) : setApiKey().then(function () {
      return performGetManyByIds(ids);
    });
  }
}]).name;
exports.SearchServiceModule = SearchServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativePlatformServiceModule = void 0;
var NativePlatformServiceModule = angular.module('app.services.access.nativePlatform', []).service('nativePlatformService', ["$window", function ($window) {
  var isIOS = getIsIOS($window);
  var isAndroid = getIsAndroid($window);
  var isMobileUserAgent = getIsMobileUserAgent($window);
  var service = {
    isIOS: isIOS,
    isAndroid: isAndroid,
    isNative: isIOS || isAndroid,
    isMobileUserAgent: isMobileUserAgent,
    getKit: getKit,
    getIsIOS: getIsIOS,
    getIsAndroid: getIsAndroid,
    supports: supports,
    logout: logout
  };

  function getKit(win) {
    if (getIsIOS(win)) return win.webkit;
    if (getIsAndroid(win)) return win.androidkit;
    return undefined;
  }

  function getIsIOS(win) {
    return angular.isDefined(win.webkit) && angular.isDefined(win.webkit.messageHandlers) && (angular.isDefined(win.webkit.messageHandlers.AnalyticsEventHandler) || angular.isDefined(win.webkit.messageHandlers.StatusBarUpdateHandler) || angular.isDefined(win.webkit.messageHandlers.LogoutHandler));
  }

  function getIsAndroid(win) {
    return angular.isDefined(win.androidkit);
  }

  function supports(win, handler) {
    var kit = getKit(win);

    if (getIsIOS(win)) {
      var messageHandler = kit.messageHandlers[handler];
      return angular.isDefined(messageHandler) && angular.isDefined(messageHandler.postMessage);
    }

    if (getIsAndroid(win)) {
      return angular.isDefined(kit[handler]);
    }
  }

  function logout(win) {
    var kit = getKit(win);

    if (getIsIOS(win) && supports(win, 'LogoutHandler')) {
      kit.messageHandlers.LogoutHandler.postMessage({});
    }

    if (getIsAndroid(win) && supports(win, 'handleLogout')) {
      kit.handleLogout();
    }
  }

  function getIsMobileUserAgent(win) {
    if (angular.isDefined(win) && angular.isDefined(win.navigator) && angular.isDefined(win.navigator.userAgent)) {
      var userAgent = win.navigator.userAgent; // eslint-disable-next-line max-len

      return /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(userAgent);
    }

    return false;
  }

  return service;
}]).name;
exports.NativePlatformServiceModule = NativePlatformServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageServiceModule = void 0;

var _angularCookies = _interopRequireDefault(__webpack_require__(103));

var _memoize = _interopRequireDefault(__webpack_require__(504));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StorageServiceModule = angular.module('app.services.storage.storageService', [_angularCookies.default]).factory('storageService', ["$window", "$cookies", function ($window, $cookies) {
  return {
    supported: (0, _memoize.default)(supported),
    updateCookieObject: updateCookieObject,
    getCookieObject: getCookieObject
  };

  function supported() {
    var testKey = 'test';
    var storage = $window.localStorage;

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function updateCookieObject(cookieName, object, options) {
    var existingCookie = $cookies.getObject(cookieName);
    var objectToPut = angular.isDefined(existingCookie) ? existingCookie : {};
    angular.extend(objectToPut, object);
    $cookies.putObject(cookieName, objectToPut, options);
  }

  function getCookieObject(cookieName, keyName) {
    var object = $cookies.getObject(cookieName);
    return object ? object[keyName] : undefined;
  }
}]).name;
exports.StorageServiceModule = StorageServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutServiceModule = void 0;

var _get = _interopRequireDefault(__webpack_require__(34));

var _map = _interopRequireDefault(__webpack_require__(75));

var _constants = __webpack_require__(24);

var _auth = __webpack_require__(77);

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

var _creditCard = __webpack_require__(164);

var _subscription = __webpack_require__(42);

var _creditCardUtilities = __webpack_require__(86);

var _checkoutTracker = __webpack_require__(1277);

var _productsTracker = __webpack_require__(1278);

var _authToken = __webpack_require__(43);

var _storeInformation = __webpack_require__(38);

var _GtmTracking = __webpack_require__(278);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CheckoutServiceModule = angular.module('app.components.checkout.checkoutService', [_auth.AuthServiceModule, _settings.AppSettingsModule, _data.DataServiceModule, _creditCard.CreditCardServiceModule, _subscription.SubscriptionServiceModule, _creditCardUtilities.CreditCardUtilitiesServiceModule, _checkoutTracker.CheckoutTrackerServiceModule, _productsTracker.ProductsTrackerServiceModule, _authToken.AuthTokenServiceModule, _storeInformation.StoreInformationServiceModule]).service('checkoutService',
/*#__PURE__*/
function () {
  CheckoutService.$inject = ["$http", "$q", "$timeout", "$window", "authService", "creditCardService", "subscriptionsService", "settings", "dataService", "authTokenService", "creditCardUtilities", "checkoutTracker", "productsTracker", "storeInformationService"];

  function CheckoutService($http, $q, $timeout, $window, authService, creditCardService, subscriptionsService, settings, dataService, authTokenService, creditCardUtilities, checkoutTracker, productsTracker, storeInformationService) {
    'ngInject';

    _classCallCheck(this, CheckoutService);

    angular.extend(this, {
      $http: $http,
      $q: $q,
      $timeout: $timeout,
      $window: $window,
      authService: authService,
      creditCardService: creditCardService,
      subscriptionsService: subscriptionsService,
      settings: settings,
      dataService: dataService,
      authTokenService: authTokenService,
      creditCardUtilities: creditCardUtilities,
      checkoutTracker: checkoutTracker,
      productsTracker: productsTracker,
      storeInformationService: storeInformationService,
      cachedStoreInfo: null,
      STEP_ENTRANCE: 1,
      STEP_CONTACTINFO: 2,
      STEP_SHIPPINGADDRESS: 3,
      STEP_SHIPPINGMETHOD: 4,
      STEP_PAYMENTMETHOD: 5,
      STEP_BILLINGADDRESS: 6,
      SUBSCRIPTION_RETRY_DELAY: 1000
    });
  }

  _createClass(CheckoutService, [{
    key: "getLoggedInUserDetails",
    value: function getLoggedInUserDetails() {
      return this.$q.all([this.storeInformationService.getStore(), this.getPaymentMethod(), this.createUser()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
            storeInfo = _ref2[0],
            paymentMethod = _ref2[1],
            user = _ref2[2];

        return {
          storeInfo: storeInfo,
          paymentMethod: paymentMethod,
          user: user
        };
      });
    }
  }, {
    key: "getPaymentMethod",
    value: function getPaymentMethod() {
      return this.$http.get("".concat("https://sandbox.api-v2.volusion.com", "/admin/paymentmethod")).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getPlanDetails",
    value: function getPlanDetails(planId) {
      return this.getPlans().then(function (plans) {
        var planDetails;
        angular.forEach(plans, function (plan) {
          if (planId === plan.id) planDetails = plan;
        });
        return planDetails;
      });
    }
  }, {
    key: "getPlans",
    value: function getPlans() {
      return this.$http.get("".concat("https://sandbox.api-v2.volusion.com", "/plans")).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getUser",
    value: function getUser() {
      return this.authTokenService.getUser();
    }
  }, {
    key: "hasPaymentMethod",
    value: function hasPaymentMethod(paymentMethod) {
      return angular.isDefined(paymentMethod) && angular.isDefined(paymentMethod.creditCard) && angular.isDefined(paymentMethod.creditCard.lastFour);
    }
  }, {
    key: "createUser",
    value: function createUser() {
      return this.getUser().then(function (user) {
        if (!user) return {
          isLoggedIn: false
        };

        if (user[_constants.AUTH0_METADATA_CLAIM]) {
          user.user_metadata = user[_constants.AUTH0_METADATA_CLAIM];
        }

        return {
          isLoggedIn: true,
          contact: {
            firstName: user.user_metadata ? user.user_metadata.firstname : user.given_name,
            lastName: user.user_metadata ? user.user_metadata.lastname : user.family_name
          },
          newPayment: {},
          user: user,
          billingAddress: {
            country: 'US'
          },
          couponCode: ''
        };
      }).catch(function () {
        return {
          isLoggedIn: false
        };
      });
    }
  }, {
    key: "setDetailsToUser",
    value: function setDetailsToUser(user, storeInfo, paymentMethod) {
      return angular.merge(user, {
        contact: {
          phoneNumber: storeInfo.phoneNumber
        },
        account: {
          email: storeInfo.email
        },
        forceEdit: !this.hasPaymentMethod(paymentMethod),
        payment: paymentMethod.creditCard,
        storeInfo: storeInfo
      });
    }
  }, {
    key: "mergeNewPaymentToPayment",
    value: function mergeNewPaymentToPayment(user) {
      if (!user.payment) user.payment = {};
      return angular.merge(user.payment, {
        expirationString: user.newPayment.expiration,
        expiration: this.creditCardUtilities.parseExpiration(user.newPayment.expiration),
        lastFour: this.creditCardUtilities.getLastFour(user.newPayment.cardNumber),
        brand: this.creditCardUtilities.getCardType(user.newPayment.cardNumber),
        cardNumber: user.newPayment.cardNumber,
        cvv: user.newPayment.cvv
      });
    }
  }, {
    key: "placeOrder",
    value: function placeOrder(user, cart, expireTrialInFiveMinutes, trialDaysRemaining, recaptchaResponse) {
      var _this = this;

      var couponCode;

      if (user.couponCode && user.couponCode !== '') {
        couponCode = user.couponCode;
        cart.couponCode = couponCode;
      }

      return this.getUser().then(function (serviceUser) {
        if (serviceUser && !user.newPayment.cardNumber) {
          return _this.subscriptionsService.changePlan({
            planId: cart.planId,
            couponCode: couponCode
          });
        }

        _this.mergeNewPaymentToPayment(user);

        var stripeCard = {
          cardNumber: user.payment.cardNumber,
          CVV: user.payment.cvv,
          expiration: user.payment.expirationString
        };
        var stripeUser = {
          firstName: user.contact.firstName,
          lastName: user.contact.lastName
        };
        var stripeBillingAddress = user.billingAddress;
        var userToLog = serviceUser || user.account;
        return _this.creditCardService.createStripeCcToken(stripeCard, stripeUser, stripeBillingAddress).then(function (cardResponse) {
          if (cardResponse.card && cardResponse.card.funding === 'prepaid') {
            _this.authTokenService.getTenantId().then(function (tenantID) {
              (0, _GtmTracking.trackEvent)('prepaidCard', {
                type: 'purchase_attempt',
                tenantID: tenantID
              });
            });

            throw new Error("Prepaid cards are not currently accepted.\n                                Please provide a credit or debit card, or contact us for help.");
          }

          var stripeCcToken = (0, _get.default)(cardResponse, 'id', null);

          if (serviceUser) {
            return _this.changeUserPlan({
              cart: cart,
              stripeCcToken: stripeCcToken,
              couponCode: couponCode,
              trialDaysRemaining: trialDaysRemaining
            });
          }

          return _this.registerNewUser({
            user: user,
            cart: cart,
            stripeCcToken: stripeCcToken,
            expireTrialInFiveMinutes: expireTrialInFiveMinutes,
            trialDaysRemaining: trialDaysRemaining,
            recaptchaResponse: recaptchaResponse
          });
        }).catch(function (error) {
          _this.$window.dataLayer.push({
            event: 'paymentFailed'
          });

          return _this.$q.reject(error);
        }).then(function () {
          _this.logSubscription(cart, userToLog);
        });
      });
    }
  }, {
    key: "changeUserPlan",
    value: function changeUserPlan(_ref3) {
      var cart = _ref3.cart,
          stripeCcToken = _ref3.stripeCcToken,
          couponCode = _ref3.couponCode,
          trialDaysRemaining = _ref3.trialDaysRemaining;
      return this.subscriptionsService.changePlan({
        planId: cart.planId,
        stripeToken: stripeCcToken,
        couponCode: couponCode,
        trialDaysRemaining: trialDaysRemaining
      });
    }
  }, {
    key: "registerNewUser",
    value: function registerNewUser(params) {
      var navigator = this.$window.navigator;
      var registration = {
        firstName: params.user.contact.firstName,
        lastName: params.user.contact.lastName,
        phoneNumber: params.user.contact.phoneNumber,
        email: params.user.account.email,
        password: params.user.account.password,
        termsAndConditionsAccepted: true,
        planId: params.cart.planId,
        creditCardToken: params.stripeCcToken,
        expireTrialInFiveMinutes: params.expireTrialInFiveMinutes || false,
        userAgent: navigator.userAgent || navigator.vendor || navigator.platform || this.$window.opera,
        'g-recaptcha-response': params.recaptchaResponse
      };

      if (params.trialDaysRemaining) {
        registration.trialLengthInDays = params.trialDaysRemaining;
      }

      if (params.user.couponCode && params.user.couponCode !== '') {
        registration.couponCode = params.user.couponCode;
      }

      return this.authService.register(registration);
    }
  }, {
    key: "logSubscription",
    value: function logSubscription(cart, userToLog) {
      var _this2 = this;

      this.subscriptionsService.getSubscription().catch(this.getSubscriptionDelayedRetry.bind(this)).then(function (subscription) {
        var subscriptionInfo = {
          id: subscription.id,
          tenantId: subscription.tenant,
          customerId: subscription.customer
        };

        _this2.logPurchase(cart, subscriptionInfo, userToLog);
      });
    }
  }, {
    key: "getSubscriptionDelayedRetry",
    value: function getSubscriptionDelayedRetry() {
      var _this3 = this;

      var deferred = this.$q.defer();
      this.$timeout(function () {
        _this3.subscriptionsService.getSubscription().then(function (subscription) {
          deferred.resolve(subscription);
        }).catch(function (error) {
          deferred.reject(error);
        });
      }, this.SUBSCRIPTION_RETRY_DELAY);
      return deferred.promise;
    }
  }, {
    key: "generateProductfromPlan",
    value: function generateProductfromPlan(plan) {
      return {
        title: plan.name,
        productCode: plan.id,
        price: plan.amount / 100,
        variant: plan.name.toLowerCase()
      };
    }
  }, {
    key: "logProductImpression",
    value: function logProductImpression(plans) {
      var _this4 = this;

      var products = (0, _map.default)(plans, function (plan) {
        return _this4.generateProductfromPlan(plan);
      });
      this.productsTracker.logProductImpression(products, 'plans', 'v2_inAdmin');
    }
  }, {
    key: "logProductClick",
    value: function logProductClick(plan) {
      this.productsTracker.logProductClick(this.generateProductfromPlan(plan), 'plans', 'v2_inAdmin');
    }
  }, {
    key: "logProductDetails",
    value: function logProductDetails(plan) {
      this.productsTracker.logProductDetails(this.generateProductfromPlan(plan), 'plans', 'v2_inAdmin');
    }
  }, {
    key: "logAddToCart",
    value: function logAddToCart(plan) {
      this.checkoutTracker.logAddToCart('USD', this.generateProductfromPlan(plan), 'plans', 'v2_inAdmin');
    }
  }, {
    key: "logRemoveFromCart",
    value: function logRemoveFromCart(plan) {
      this.checkoutTracker.logRemoveFromCart(this.generateProductfromPlan(plan), 'plans', 'v2_inAdmin');
    }
  }, {
    key: "logCheckoutStep",
    value: function logCheckoutStep(stepNumber, plan, optionalValue) {
      this.checkoutTracker.logCheckoutStep(this.generateProductfromPlan(plan), 'plans', stepNumber, optionalValue, 'v2_inAdmin');
    }
  }, {
    key: "logPurchase",
    value: function logPurchase(cart, subscription, user, paidWith) {
      var plan = cart.planDetails;
      var productData = this.generateProductfromPlan(plan);
      this.checkoutTracker.logPurchase({
        orderNumber: subscription.id,
        affiliation: subscription.tenantId,
        product: productData,
        taxAmount: 0,
        grandTotal: plan.amount / 100,
        category: 'plans',
        paidWith: paidWith,
        couponCode: cart.couponCode
      });
    }
  }]);

  return CheckoutService;
}()).name;
exports.CheckoutServiceModule = CheckoutServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FounderGuideServiceModule = void 0;

var _launchDarkly = __webpack_require__(30);

var _onboarding = __webpack_require__(59);

var _trial = __webpack_require__(60);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FounderGuideServiceModule = angular.module('app.services.founderGuide', [_onboarding.OnboardingServiceModule, _launchDarkly.LaunchDarklyServiceModule, _trial.TrialServiceModule]).factory('founderGuideService', ["onboardingService", "launchDarklyService", "trialService", "$timeout", "$q", "$window", function (onboardingService, launchDarklyService, trialService, $timeout, $q, $window) {
  var EMPTYSTATE = {
    tasks: {
      completed: {}
    }
  };
  var steps = [{
    id: 'landing',
    icon: 'home',
    name: 'Starting Point',
    color: '#261d4c',
    completeTask: 'path.task'
  }, {
    id: 'product',
    icon: 'local_offer',
    name: 'Products',
    color: '#0ebbd2',
    completeTask: 'organize.addProduct'
  }, {
    id: 'personalize',
    icon: 'edit',
    name: 'Personalize',
    color: '#849ca7',
    completeTask: 'design.styleTheme,organize.addMenu,design.addLogo,design.editTheme'
  }, {
    id: 'page',
    icon: 'insert_drive_file',
    name: 'Pages',
    color: '#cb63a2',
    completeTask: 'organize.addPage'
  }, {
    id: 'finalstep',
    icon: 'star',
    name: 'Final Step',
    color: '#808080',
    completeTask: '',
    locked: true
  }];
  var paths = {
    PRODUCT: 'Product',
    IDEA: 'Idea',
    CLUELESS: 'Clueless',
    NOPATH: 'No Path'
  };

  function getNextUnfinishedStep(state) {
    updateStepsComplete(state);
    var nextIncomplete = steps.map(function (step) {
      return step.complete;
    }).indexOf(false);
    if (nextIncomplete === -1) return steps.length;
    return nextIncomplete + 1;
  }

  function updateStepsComplete(state) {
    var FIRST_STEP = 0;
    var FINAL_STEP = 4;
    steps.forEach(function (step) {
      step.complete = step.completeTask.split(',').some(function (task) {
        return state.tasks.completed[task];
      });
    });
    steps[FIRST_STEP].complete = true; // first step is always complete

    steps[FINAL_STEP].locked = !steps.filter(function (step) {
      return step.id !== 'finalstep';
    }).every(function (step) {
      return step.complete;
    });
    steps[FINAL_STEP].complete = false; // final step is never "complete"
  }

  function getCompletedStepCount() {
    return steps.reduce(function (acc, step) {
      return acc + (step.complete ? 1 : 0);
    }, 0);
  }

  function setActiveStep(activeStep) {
    steps.forEach(function (step, index) {
      step.active = activeStep === index + 1;
    });
  }

  function getFounderGuideNextStepNotice(state) {
    var nextUnfinishedStep = getNextUnfinishedStep(state);
    return steps[nextUnfinishedStep - 1].id;
  }

  function getCompleteTasksForStep(stepId) {
    var editStep = steps.filter(function (step) {
      return step.id === stepId;
    });

    if (editStep.length) {
      return editStep[0].completeTask.split(',');
    }

    return [];
  }

  function isTaskComplete(stepId) {
    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTYSTATE;
    var tasks = getCompleteTasksForStep(stepId);
    return tasks.some(function (task) {
      return state.tasks.completed[task];
    });
  }

  function getStateDelayed() {
    // the delay allows other tasks to finish updating the state before we request it
    return $timeout(function () {
      return onboardingService.getState();
    });
  }

  function completeFounderGuideTask(taskId, taskKey, milestone) {
    var milestones = [null, 'Product Added', 'Store Edited', 'Page Generated'];
    return $q.all([onboardingService.getState(), launchDarklyService.getFeature('founder-guide'), trialService.getTrialStatus()]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          state = _ref2[0],
          feature = _ref2[1],
          trialStatus = _ref2[2];

      if (!state.tasks.completed[taskId]) {
        if (taskKey) onboardingService.completeInitialTask(taskId, taskKey);else onboardingService.completeTask(taskId);

        if (feature) {
          ($window.dataLayer || []).push({
            event: 'milestone_complete',
            action: "Milestone ".concat(milestone),
            value: milestones[milestone]
          });
        }

        return trialStatus !== _trial.NOT_TRIAL;
      }

      return false;
    });
  }

  return {
    paths: paths,
    steps: steps,
    completeFounderGuideTask: completeFounderGuideTask,
    getCompletedStepCount: getCompletedStepCount,
    getCompleteTasksForStep: getCompleteTasksForStep,
    getFounderGuideNextStepNotice: getFounderGuideNextStepNotice,
    getStateDelayed: getStateDelayed,
    getNextUnfinishedStep: getNextUnfinishedStep,
    isTaskComplete: isTaskComplete,
    updateStepsComplete: updateStepsComplete,
    setActiveStep: setActiveStep
  };
}]).name;
exports.FounderGuideServiceModule = FounderGuideServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoSliderServiceModule = void 0;

var _onboarding = __webpack_require__(59);

var _optimizely = __webpack_require__(264);

var VideoSliderServiceModule = angular.module('app.components.videoSlider.videoSliderService', [_onboarding.OnboardingServiceModule, _optimizely.OptimizelyServiceModule]).service('videoSliderService', ["$rootScope", "$window", "onboardingService", "optimizelyService", function ($rootScope, $window, onboardingService, optimizelyService) {
  var api = {
    openSlider: openSlider,
    closeSlider: closeSlider
  };
  return api;

  function openSlider(videoName) {
    if (!$window.dataLayer) $window.dataLayer = [];
    onboardingService.completeTask("video.".concat(videoName));
    $window.dataLayer.push({
      event: "admin_onboarding_watchvideo_".concat(videoName)
    });
    optimizelyService.trackEvent('action_complete');
    $rootScope.$emit('videoSliderService:openSlider', videoName);
  }

  function closeSlider() {
    $rootScope.$emit('videoSliderService:closeSlider');
  }
}]).name;
exports.VideoSliderServiceModule = VideoSliderServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditCardServiceModule = void 0;

var _get = _interopRequireDefault(__webpack_require__(34));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreditCardServiceModule = angular.module('app.services.payment.stripe', []).service('creditCardService', ["$q", "$window", function ($q, $window) {
  function createStripeCcToken(card, user, billingAddress) {
    var deferred = $q.defer();
    var payload = {
      number: card.cardNumber,
      cvc: card.CVV,
      exp: card.expiration,
      name: "".concat(user.firstName, " ").concat(user.lastName)
    };

    if (billingAddress) {
      angular.extend(payload, {
        address_line1: billingAddress.address1,
        address_line2: billingAddress.address2,
        address_city: billingAddress.city,
        address_state: billingAddress.state,
        address_zip: billingAddress.postalCode
      });
    }

    $window.Stripe.setPublishableKey("pk_test_YHSazQuhbd9skwbbzWCkCpTl");
    $window.Stripe.card.createToken(payload, function (status, response) {
      if (response.error) {
        deferred.reject(response.error);
      } else {
        deferred.resolve(response);
      }
    });
    return deferred.promise;
  }

  function getStripe() {
    return $window.Stripe("pk_test_YHSazQuhbd9skwbbzWCkCpTl"); //eslint-disable-line
  }

  function createAuthorizeNetCcToken(card, user, billingAddress, authorizeNet) {
    var postalCode = billingAddress.postalCode;
    var expStringParts = card.expiration.split('/');
    var expMonth = expStringParts[0];
    var expYear = expStringParts[1].substring(2, 4) || expStringParts[1];
    var cardPayload = {
      authData: {
        clientKey: authorizeNet.publicClientKey,
        apiLoginID: authorizeNet.apiLoginId
      },
      cardData: {
        cardNumber: card.cardNumber,
        month: expMonth,
        year: expYear,
        cardCode: card.CVV,
        zip: postalCode,
        fullName: "".concat(user.firstName, " ").concat(user.lastName)
      }
    };
    var deferred = $q.defer();

    var authorizeNetCallback = function authorizeNetCallback(data) {
      var error = getAuthorizeNetError(data);

      if (error) {
        deferred.reject(error);
      } else {
        deferred.resolve(data);
      }
    };

    $window.Accept.dispatchData(cardPayload, authorizeNetCallback);
    return deferred.promise;
  }

  function getAuthorizeNetError(data) {
    if (data.error) {
      return data.error;
    }

    if ((0, _get.default)(data, 'messages.resultCode') === 'Error') {
      var message = "".concat((0, _get.default)(data, 'messages.message[0].code'), ": ").concat((0, _get.default)(data, 'messages.message[0].text'));
      return {
        data: {
          message: message
        }
      };
    }

    var opaqueValue = (0, _get.default)(data, 'opaqueData.dataValue');
    var opaqueDescriptor = (0, _get.default)(data, 'opaqueData.dataDescriptor');

    if (!(opaqueValue && opaqueDescriptor)) {
      return {
        data: {
          message: 'Could not get valid credit card token from Authorize.net.'
        }
      };
    }

    return null;
  }

  function canUsePaymentRequestAPI() {
    var paymentRequest = this.getStripe().paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Stub',
        amount: 0
      }
    }); // Check the availability of the Payment Request API.

    return paymentRequest.canMakePayment().then(function (result) {
      return result !== null && result !== undefined;
    });
  }

  function getSupportedPaymentRequestPlatforms() {
    var paymentRequest = this.getStripe().paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Stub',
        amount: 0
      }
    }); // Check the availability of the Payment Request API.

    return paymentRequest.canMakePayment();
  }

  return {
    createAuthorizeNetCcToken: createAuthorizeNetCcToken,
    createStripeCcToken: createStripeCcToken,
    getAuthorizeNetError: getAuthorizeNetError,
    getStripe: getStripe,
    canUsePaymentRequestAPI: canUsePaymentRequestAPI,
    getSupportedPaymentRequestPlatforms: getSupportedPaymentRequestPlatforms
  };
}]).name;
exports.CreditCardServiceModule = CreditCardServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModelServiceModule = void 0;

var _merge = _interopRequireDefault(__webpack_require__(277));

var _modelWatch = __webpack_require__(589);

var _modelParse = __webpack_require__(591);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModelServiceModule = angular.module('app.services.data.modelService.modelService', [_modelWatch.ModelWatchServiceModule, _modelParse.ModelParseServiceModule]).service('modelService', ["$window", "modelParser", "modelWatcher", function ($window, modelParser, modelWatcher) {
  var api = {
    makeModel: makeModel,
    makeEmptyModel: makeEmptyModel
  };

  function makeModel(obj, model) {
    var newObj = {};

    if (model) {
      newObj = modelParser.parse(model);
      obj = (0, _merge.default)(newObj, obj);
    }

    return new Model(obj);
  }

  function makeEmptyModel(model) {
    var keys = {};

    if (model) {
      keys = modelParser.parse(model);
    }

    return new Model(keys);
  }

  function Model(model) {
    Object.defineProperties(this, {
      _base: {
        enumerable: false,
        value: angular.copy(model)
      },
      model: {
        enumerable: false,
        value: model,
        writable: true
      },
      changedValues: {
        enumerable: false,
        value: [],
        writable: true
      },
      _stash: {
        enumerable: false,
        value: {},
        writable: true
      }
    });
    modelWatcher.assignWatchers(this);
  }

  Object.defineProperties(Model.prototype, {
    getChanges: {
      enumerable: false,
      value: modelWatcher.getChanges
    },
    hasChanges: {
      enumerable: false,
      value: modelWatcher.hasChanges
    },
    reset: {
      enumerable: false,
      value: modelWatcher.reset
    },
    update: {
      enumerable: false,
      value: modelWatcher.update
    },
    updateChanges: {
      enumerable: false,
      value: modelWatcher.updateChangedValues
    },
    stash: {
      enumerable: false,
      value: modelWatcher.stash
    },
    unstash: {
      enumerable: false,
      value: modelWatcher.unstash
    },
    makeDirty: {
      enumerable: false,
      value: modelWatcher.makeDirty
    }
  });
  $window.Model = Model;
  return api;
}]).name;
exports.ModelServiceModule = ModelServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Auth0AuthServiceModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _auth0sdk = __webpack_require__(328);

var _nativePlatform = __webpack_require__(125);

var _constants = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Auth0AuthServiceModule = angular.module('app.services.auth.auth0AuthService', [_angularjs.default, _nativePlatform.NativePlatformServiceModule, _auth0sdk.Auth0SdkServiceModule]).service('auth0AuthService', ["$q", "$window", "$location", "$state", "$cookies", "nativePlatformService", "auth0SdkService", function ($q, $window, $location, $state, $cookies, nativePlatformService, auth0SdkService) {
  function redirectToLogin(shouldResetPassword) {
    var redirectPath = $window.location.pathname === '/error' ? '' : $window.location.pathname;
    $cookies.put(_constants.LOGIN_REDIRECT_COOKIE, redirectPath);
    $cookies.put(_constants.LOGIN_PASSWORD_EXPIRED_COOKIE, shouldResetPassword);
    nativePlatformService.logout($window);
    logout();
  }

  function unauthenticatedHandler(query, $match) {
    var errorDescription = $location.search().error_description || '';
    var shouldResetPassword = query && query.includes('state') && query.includes('error') && errorDescription.startsWith('E001 - ');
    var shouldParseResult = query && query.includes('code=') && query.includes('state=');

    if (shouldParseResult) {
      auth0SdkService.handleRedirectCallback().then(function () {
        var redirect = $cookies.get(_constants.LOGIN_REDIRECT_COOKIE);
        $cookies.remove(_constants.LOGIN_REDIRECT_COOKIE);

        if (redirect && redirect.length > 1 && redirect.charAt(0) === '/') {
          var redirectUrl = new URL(redirect, "https://admin-sandbox.volusion.com");
          var params = Object.fromEntries(redirectUrl.searchParams);

          if (redirectUrl.pathname === '/checkout') {
            $state.transitionTo(redirectUrl.pathname.substring(1), params);
          } else {
            $window.location.href = redirect;
          }
        } else {
          $state.transitionTo('dashboard', $match, false);
        }
      });
    } else {
      auth0SdkService.getTokenSilently().then(function (token) {
        if (!token) {
          redirectToLogin(shouldResetPassword);
        }
      }).catch(function () {
        redirectToLogin(shouldResetPassword);
      });
    }
  }

  function auth0login(email) {
    clearLegacyUserCookies();
    auth0SdkService.loginWithRedirect({
      redirect_uri: "".concat($window.location.protocol, "//").concat($window.location.host),
      audience: "https://sandbox.api.material.com",
      login_hint: email
    });
  }

  function googleLogin() {
    clearLegacyUserCookies();
    auth0SdkService.loginWithRedirect({
      redirect_uri: "".concat($window.location.protocol, "//").concat($window.location.host),
      audience: "https://sandbox.api.material.com",
      connection: 'google-oauth2'
    });
  }

  function isAuthenticated() {
    clearLegacyUserCookies();
    return auth0SdkService.isAuthenticated();
  }

  function getTokenSilently() {
    clearLegacyUserCookies();
    return auth0SdkService.getTokenSilently();
  }

  function getUser() {
    clearLegacyUserCookies();
    return auth0SdkService.getUser();
  }

  function getRootDomain(hostname) {
    var parts = hostname.split('.');
    var hasSubdomain = parts.length === 3;
    return hasSubdomain ? "".concat(parts[1], ".").concat(parts[2]) : hostname;
  }

  function clearLegacyUserCookies() {
    $window.localStorage.removeItem('user');

    if (!$cookies.get('id_token')) {
      return;
    }

    var rootDomain = getRootDomain($location.host());
    $cookies.put('id_token', '', {
      secure: true,
      domain: rootDomain
    });
    $cookies.put('access_token', '', {
      secure: true,
      domain: rootDomain
    });
    $cookies.remove('id_token', {
      domain: rootDomain
    });
    $cookies.remove('access_token', {
      domain: rootDomain
    });
  }

  function logout() {
    clearLegacyUserCookies();
    $cookies.remove(_constants.LOGIN_REDIRECT_COOKIE);
    return auth0SdkService.logout({
      client_id: "rWEyCZ6MhTBUtDs5ztXrceCVEeBX4FZv",
      returnTo: "".concat($window.location.protocol, "//").concat($window.location.host, "/login")
    });
  }

  return {
    auth0login: auth0login,
    clearLegacyUserCookies: clearLegacyUserCookies,
    isAuthenticated: isAuthenticated,
    getTokenSilently: getTokenSilently,
    getUser: getUser,
    googleLogin: googleLogin,
    logout: logout,
    unauthenticatedHandler: unauthenticatedHandler
  };
}]).name;
exports.Auth0AuthServiceModule = Auth0AuthServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileAnalyticsServiceModule = void 0;

var _angularJwt = _interopRequireDefault(__webpack_require__(167));

var _angularCookies = _interopRequireDefault(__webpack_require__(103));

var _nativePlatform = __webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileAnalyticsServiceModule = angular.module('app.services.tracking.mobileAnalytics', [_nativePlatform.NativePlatformServiceModule, _angularJwt.default, _angularCookies.default]).service('mobileAnalyticsService', ["$window", "nativePlatformService", "jwtHelper", "$cookies", function ($window, nativePlatformService, jwtHelper, $cookies) {
  var service = {
    trackEvent: trackEvent
  };

  function trackEvent(eventName, data) {
    // Get user info and append it to data
    var userData = {};
    var token = $cookies.get('id_token');

    if (token) {
      var decoded = jwtHelper.decodeToken(token);

      if (decoded) {
        userData.tenant = decoded.tenant;
        userData.user_id = decoded.user_id;
      }
    }

    Object.assign(data, userData);
    var kit = nativePlatformService.getKit($window);

    if (nativePlatformService.isIOS && nativePlatformService.supports($window, 'AnalyticsEventHandler')) {
      kit.messageHandlers.AnalyticsEventHandler.postMessage({
        eventName: eventName,
        data: data
      });
    }

    if (nativePlatformService.isAndroid && nativePlatformService.supports($window, 'handleAnalyticsEvent')) {
      kit.handleAnalyticsEvent(JSON.stringify({
        eventName: eventName,
        data: data
      }));
    }
  }

  return service;
}]).name;
exports.MobileAnalyticsServiceModule = MobileAnalyticsServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorefrontSliderServiceModule = void 0;

var _storeInformation = __webpack_require__(38);

var StorefrontSliderServiceModule = angular.module('app.components.storefrontSlider.storefrontSliderService', [_storeInformation.StoreInformationServiceModule]).service('storefrontSliderService', ["$q", "$rootScope", "$timeout", "storeInformationService", function ($q, $rootScope, $timeout, storeInformationService) {
  var sliderUrl;
  var merchantStoreUrl;
  var frame;
  var VALID_PAGES = {
    home: 'home',
    product: 'product',
    category: 'category',
    page: 'page'
  };
  var currentItem = null;
  var currentPage = 'home';
  var storefrontState;
  var hasSliderBeenOpened;
  var themePreview = false;
  var themeTitle = null;
  var api = {
    //Slider functions
    setSliderUrl: setSliderUrl,
    getSliderUrl: getSliderUrl,
    openSlider: openSlider,
    closeSlider: closeSlider,
    goToPage: goToPage,
    getCurrentPage: getCurrentPage,
    getPageUrl: getPageUrl,
    setIframeReference: setIframeReference,
    enableStateChange: enableStateChange,
    disableStateChange: disableStateChange,
    getMerchantUrl: getMerchantUrl,
    getIframeReference: getIframeReference,
    getSliderHasOpened: getSliderHasOpened,
    setSliderHasOpened: setSliderHasOpened,
    //Detail page functions
    previewProductChanges: previewProductChanges,
    previewCategoryChanges: previewCategoryChanges,
    previewPageChanges: previewPageChanges,
    //Store editor functions
    sendMessage: sendMessage,
    previewStoreInfoChanges: previewStoreInfoChanges,
    previewEditableChanges: previewEditableChanges,
    previewWidgetChanges: previewWidgetChanges,
    previewMenuChanges: previewMenuChanges,
    highlightCategory: highlightCategory,
    highlightEditable: highlightEditable,
    highlightWidget: highlightWidget,
    highlightDirective: highlightDirective,
    unhighlightCategory: unhighlightCategory,
    unhighlightEditable: unhighlightEditable,
    unhighlightWidget: unhighlightWidget,
    unhighlightDirective: unhighlightDirective,
    unhighlightAll: unhighlightAll,
    scrollToTop: scrollToTop,
    changePage: changePage,
    reloadTheme: reloadTheme,
    showLoader: showLoader,
    hideLoader: hideLoader,
    openPushMenu: openPushMenu,
    closePushMenu: closePushMenu,
    getStorefrontState: getStorefrontState,
    setStorefrontState: setStorefrontState,
    //theme preview
    setThemePreview: setThemePreview,
    isThemePreview: isThemePreview,
    setThemeTitle: setThemeTitle,
    getThemeTitle: getThemeTitle
  };
  return api;

  function getIframeReference() {
    return frame;
  }

  function getMerchantUrl(forceRefresh) {
    if (merchantStoreUrl && !forceRefresh) return $q.resolve(merchantStoreUrl);
    return storeInformationService.getStore().then(function (response) {
      merchantStoreUrl = response.canonicalHost;
      return merchantStoreUrl;
    });
  }

  function setSliderUrl(url) {
    if (url === sliderUrl && getIframeReference()) return;
    sliderUrl = url;
    $rootScope.$emit('storefrontSliderService:sliderUrlChanged', sliderUrl);
  }

  function getSliderHasOpened() {
    return hasSliderBeenOpened;
  }

  function setSliderHasOpened() {
    hasSliderBeenOpened = true;
  }

  function getSliderUrl() {
    return sliderUrl;
  }

  function openSlider(width) {
    $rootScope.$emit('storefrontSliderService:openSlider', width || null);
  }

  function closeSlider() {
    $rootScope.$emit('storefrontSliderService:closeSlider');
  }

  function goToPage(page, item) {
    getMerchantUrl().then(function (storeUrl) {
      switch (page) {
        case VALID_PAGES.home:
          setThemePreview(false);
          setSliderUrl(storeUrl);
          $timeout(function () {
            enableStateChange();
          });
          currentItem = null;
          break;

        case VALID_PAGES.product:
          setSliderUrl("".concat(storeUrl, "/preview/product"));
          $timeout(function () {
            disableStateChange();
          });
          currentItem = item;
          getPageUrl().then(function (pageUrl) {
            $rootScope.$emit('storefrontSliderService:setUrlBarAddress', pageUrl);
          });
          break;

        case VALID_PAGES.category:
          setSliderUrl("".concat(storeUrl, "/preview/category"));
          $timeout(function () {
            disableStateChange();
          });
          currentItem = item;
          getPageUrl().then(function (pageUrl) {
            $rootScope.$emit('storefrontSliderService:setUrlBarAddress', pageUrl);
          });
          break;

        case VALID_PAGES.page:
          setSliderUrl("".concat(storeUrl, "/preview/page"));
          $timeout(function () {
            disableStateChange();
          });
          currentItem = item;
          getPageUrl().then(function (pageUrl) {
            $rootScope.$emit('storefrontSliderService:setUrlBarAddress', pageUrl);
          });
          break;

        default:
          throw new Error('Invalid page name');
      }

      currentPage = page;
    });
  }

  function getCurrentPage() {
    return currentPage;
  }

  function getPageUrl() {
    return getMerchantUrl().then(function (storeUrl) {
      if (!currentItem || !currentItem.seo.friendlyName) return storeUrl;

      switch (currentPage) {
        case VALID_PAGES.product:
          return "".concat(storeUrl, "/p/").concat(currentItem.seo.friendlyName);

        case VALID_PAGES.category:
          return "".concat(storeUrl, "/c/").concat(currentItem.seo.friendlyName);

        case VALID_PAGES.page:
          return "".concat(storeUrl, "/page/").concat(currentItem.seo.friendlyName);

        default:
          return storeUrl;
      }
    });
  }

  function setIframeReference(iframeReference) {
    frame = iframeReference;
  }

  function sendMessage(sender, event, data) {
    var message = JSON.stringify({
      sender: sender,
      event: event,
      data: data
    });

    if (angular.isDefined(frame) && frame !== null) {
      frame.postMessage(message, sliderUrl);
    }
  }

  function sendMessageToTheme(event, data) {
    sendMessage('admin', event, data);
  }

  function openPushMenu() {
    sendMessageToTheme('openPushMenu');
  }

  function closePushMenu() {
    sendMessageToTheme('closePushMenu');
  }

  function previewProductChanges(productData) {
    sendMessageToTheme('previewProductChanges', productData);
  }

  function previewPageChanges(pageData) {
    sendMessageToTheme('previewPageChanges', pageData);
  }

  function previewCategoryChanges(categoryData) {
    sendMessageToTheme('previewCategoryChanges', categoryData);
  }

  function enableStateChange() {
    $rootScope.$emit('storefrontSliderService:stateChanged', true);
    sendMessageToTheme('enableStateChange');
  }

  function disableStateChange() {
    $rootScope.$emit('storefrontSliderService:stateChanged', false);
    sendMessageToTheme('disableStateChange');
  }
  /* Store Editor functions */


  function previewStoreInfoChanges(storeInfo) {
    sendMessage('admin-widget-editor', 'previewStoreInfoChanges', storeInfo);
  }

  function previewEditableChanges(editableData) {
    sendMessage('admin-widget-editor', 'previewEditableChanges', editableData);
  }

  function previewWidgetChanges(widget) {
    sendMessage('admin-widget-editor', 'previewWidgetChanges', widget);
  }

  function previewMenuChanges(menu) {
    sendMessage('admin-widget-editor', 'updateMenus', menu);
  } //Highlight section


  function highlightCategory(categoryId) {
    sendMessage('admin-widget-editor', 'highlightCategory', categoryId);
  }

  function highlightEditable(editableId) {
    sendMessage('admin-widget-editor', 'highlightEditable', editableId);
  }

  function highlightWidget(widgetId) {
    sendMessage('admin-widget-editor', 'highlightWidget', widgetId);
  }

  function highlightDirective(directiveName) {
    sendMessage('admin-widget-editor', 'highlightDirective', directiveName);
  } //Unhighlight section


  function unhighlightCategory() {
    sendMessage('admin-widget-editor', 'unhighlightCategory');
  }

  function unhighlightEditable() {
    sendMessage('admin-widget-editor', 'unhighlightEditable');
  }

  function unhighlightWidget() {
    sendMessage('admin-widget-editor', 'unhighlightWidget');
  }

  function unhighlightDirective(directiveName) {
    sendMessage('admin-widget-editor', 'unhighlightDirective', directiveName);
  }

  function unhighlightAll() {
    sendMessage('admin-widget-editor', 'unhighlightAll');
  }

  function scrollToTop() {
    sendMessage('admin-widget-editor', 'scrollToTop');
  }

  function changePage(toPage) {
    sendMessage('admin-widget-editor', 'changePage', toPage);
  }

  function reloadTheme() {
    sendMessage('admin-widget-editor', 'reloadTheme');
  }

  function showLoader() {
    $rootScope.$emit('storefrontSliderService:toggleLoader', true);
    api.isLoading = true;
  }

  function hideLoader() {
    $rootScope.$emit('storefrontSliderService:toggleLoader', false);
    api.isLoading = false;
  }

  function getStorefrontState() {
    return storefrontState;
  }

  function setStorefrontState(state) {
    storefrontState = state;
  }

  function setThemePreview(isPreview) {
    themePreview = isPreview;
  }

  function isThemePreview() {
    return themePreview;
  }

  function setThemeTitle(title) {
    themeTitle = title;
  }

  function getThemeTitle() {
    return themeTitle;
  }
  /* End Store Editor functions */

}]).name;
exports.StorefrontSliderServiceModule = StorefrontSliderServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtensionServiceModule = void 0;

var _filter = _interopRequireDefault(__webpack_require__(157));

var _isUndefined = _interopRequireDefault(__webpack_require__(270));

var _uniqBy = _interopRequireDefault(__webpack_require__(1015));

var _sortBy = _interopRequireDefault(__webpack_require__(195));

var _each = _interopRequireDefault(__webpack_require__(162));

var _find = _interopRequireDefault(__webpack_require__(66));

var _onboarding = __webpack_require__(59);

var _launchDarkly = __webpack_require__(30);

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ExtensionServiceModule = angular.module('vln.appStore.components', [_onboarding.OnboardingServiceModule, _launchDarkly.LaunchDarklyServiceModule, _data.DataServiceModule, _settings.AppSettingsModule]).service('extensionService', ["dataService", "onboardingService", "$http", "settings", "$q", "launchDarklyService", function (dataService, onboardingService, $http, settings, $q, launchDarklyService) {
  return {
    getExtensions: getExtensions,
    getTenantExtensions: getTenantExtensions,
    installExtension: installExtension,
    getPurchasedExtensions: getPurchasedExtensions
  };

  function getExtensions(app) {
    return $q.all([$http.get("".concat("https://sandbox.api-v2.volusion.com", "/marketplace/extensions")), launchDarklyService.allFlags()]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          allExtensions = _ref2[0],
          ldFlags = _ref2[1];

      return (0, _filter.default)(allExtensions.data.items, function (extn) {
        return extn.isAvailable && ((0, _isUndefined.default)(extn.code) || (0, _isUndefined.default)(ldFlags[extn.code]) || ldFlags[extn.code] === true);
      });
    }).then(function (res) {
      return filterExtensions(app, res);
    });
  }

  function getTenantExtensions(app) {
    return dataService.getAll(settings.api.purchasedextensions).then(function (res) {
      return (0, _uniqBy.default)(filterExtensions(app, res.items), 'extensionId');
    }).then(sortExtensions);
  }

  function filterExtensions(app, extensions) {
    // TODO: learn where extensions are stored once installed (hint: not just MARS) then maybe remove this code
    var withoutDescription = (0, _filter.default)(extensions, function (el) {
      return el.directive !== 'description';
    });
    return app ? (0, _filter.default)(withoutDescription, function (item) {
      return angular.isArray(item.extends) && item.extends.indexOf(app) !== -1;
    }) : withoutDescription;
  }

  function sortExtensions(extensions) {
    return (0, _sortBy.default)(extensions, 'title');
  }

  function getPurchasedExtensions() {
    //This will have list of purchased extensions with extension details.
    return $q.all([getExtensions(), getTenantExtensions()]).then(function (res) {
      var allExtensions = res[0];
      var tenantExtensions = res[1];
      var extensions = [];
      (0, _each.default)(tenantExtensions, function (tenantExtension) {
        extensions.push((0, _find.default)(allExtensions, {
          id: tenantExtension.extensionId
        }));
      });
      return extensions;
    });
  }

  function installExtension(app) {
    return $http.post("".concat("https://sandbox.api-v2.volusion.com", "/marketplace/extensions/orders"), app).then(function (data) {
      onboardingService.completeTask('run.installExtension');
      return data;
    });
  }
}]).name;
exports.ExtensionServiceModule = ExtensionServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 233 */,
/* 234 */,
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ApiConfig =
/*#__PURE__*/
function () {
  function ApiConfig() {
    _classCallCheck(this, ApiConfig);
  }

  _createClass(ApiConfig, [{
    key: "setTenantId",
    value: function setTenantId(tenantId) {
      this.tenantId = tenantId;
    }
  }, {
    key: "setAuthToken",
    value: function setAuthToken(token) {
      this.authToken = token;
    }
  }, {
    key: "getHttpConfig",
    value: function getHttpConfig(addAuthToken, useOldTenantHeader, options) {
      var config = {
        headers: {}
      };

      if (this.tenantId) {
        var tenantHeader = useOldTenantHeader ? 'x-mat-tenant' : 'x-vol-tenant';
        config.headers[tenantHeader] = this.tenantId;
      }

      if (addAuthToken && this.authToken) {
        config.headers.Authorization = "Bearer ".concat(this.authToken);
      }

      return options ? _objectSpread({}, config, {
        params: options
      }) : config;
    }
  }]);

  return ApiConfig;
}();

var _default = new ApiConfig();

exports.default = _default;

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModelModule = void 0;

var _models = __webpack_require__(1334);

var _arrayModel = __webpack_require__(590);

var _model = __webpack_require__(165);

var _modelParse = __webpack_require__(591);

var _modelWatch = __webpack_require__(589);

var ModelModule = angular.module('app.services.data.model', [_models.ModelsModule, _arrayModel.ArrayModelServiceModule, _model.ModelServiceModule, _modelParse.ModelParseServiceModule, _modelWatch.ModelWatchServiceModule]).name;
exports.ModelModule = ModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpireCacheServiceModule = void 0;
var ExpireCacheServiceModule = angular.module('app.services.utilities.expireCache', []).service('expireCache', ["$http", function ($http) {
  return function (res) {
    return $http.post("https://t41cezqof9.execute-api.us-east-1.amazonaws.com/development").then(function () {
      return res;
    }).catch(function () {
      return res;
    });
  };
}]).name;
exports.ExpireCacheServiceModule = ExpireCacheServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturesServiceModule = void 0;

var _get = _interopRequireDefault(__webpack_require__(34));

var _data = __webpack_require__(11);

var _subscription = __webpack_require__(42);

var _settings = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeaturesServiceModule = angular.module('app.services.access.featuresService', [_data.DataServiceModule, _subscription.SubscriptionServiceModule, _settings.AppSettingsModule]).service('featureService', ["dataService", "settings", "$q", "subscriptionsService", function (dataService, settings, $q, subscriptionsService) {
  var features;
  return {
    getFeatures: getFeatures,
    enableFeature: enableFeature,
    getInstalledApps: getInstalledApps,
    disableFeature: disableFeature
  };

  function getFeatures(refetch) {
    if (!features || refetch) {
      return dataService.getAll(settings.api.features).then(function (response) {
        features = response;
        return features;
      });
    }

    return $q.resolve(features);
  }

  function canEnableFeature(feature) {
    return subscriptionsService.getSubscription().then(function (subscription) {
      return subscription && subscription.features && (subscription.features[feature] === true || subscription.features[feature] === undefined);
    });
  }

  function enableFeature(featureName) {
    if (features && features[featureName]) {
      var feature = features[featureName];
      return canEnableFeature(featureName).then(function (featureCanBeEnabled) {
        if (featureCanBeEnabled) {
          feature.enabled = true;
          return dataService.saveAll(settings.api.features, features).then(function (response) {
            angular.extend(features, response);
            return features;
          }).catch(function () {
            feature.enabled = false;
            return $q.reject('APPSTORE.APPINSTALLERROR');
          });
        }

        return $q.reject('APPSTORE.APPINSTALLERROR');
      });
    }

    return $q.resolve(features);
  }

  function disableFeature(featureName) {
    if (features && features[featureName]) {
      var feature = features[featureName];
      feature.enabled = false;
      return dataService.saveAll(settings.api.features, features).then(function (response) {
        angular.extend(features, response);
        return features;
      });
    }

    return $q.resolve(features);
  }

  function getInstalledApps() {
    return getFeatures().then(function (merchantFeatures) {
      return {
        discounts: (0, _get.default)(merchantFeatures, 'discount.enabled', false) || (0, _get.default)(merchantFeatures, 'discounts.enabled', false),
        shipping: (0, _get.default)(merchantFeatures, 'shipping.enabled', false),
        pinterest: (0, _get.default)(merchantFeatures, 'pinterest.enabled', false),
        facebookPixel: (0, _get.default)(merchantFeatures, 'facebookPixel.enabled', false),
        fullstory: (0, _get.default)(merchantFeatures, 'fullstory.enabled', false),
        googleAnalytics: (0, _get.default)(merchantFeatures, 'googleAnalytics.enabled', false),
        privy: (0, _get.default)(merchantFeatures, 'privy.enabled', false),
        mailchimp: (0, _get.default)(merchantFeatures, 'mailchimp.enabled', false),
        chat: (0, _get.default)(merchantFeatures, 'chat.enabled', false),
        zapier: (0, _get.default)(merchantFeatures, 'zapier.enabled', false),
        yotpo: (0, _get.default)(merchantFeatures, 'yotpo.enabled', false),
        amazon: (0, _get.default)(merchantFeatures, 'amazon.enabled', false),
        quickbooks: (0, _get.default)(merchantFeatures, 'quickbooks.enabled', false),
        xero: (0, _get.default)(merchantFeatures, 'xero.enabled', false),
        fulfillers: (0, _get.default)(merchantFeatures, 'fulfillers.enabled', false),
        avalara: (0, _get.default)(merchantFeatures, 'avalara.enabled', false)
      };
    });
  }
}]).name;
exports.FeaturesServiceModule = FeaturesServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VlnBackImageModule = void 0;

__webpack_require__(1267);

var VlnBackImageModule = angular.module('app.directives.vlnBackImg', []).directive('vlnBackImg', function () {
  return {
    restrict: 'A',
    link: function link(scope, ele, attrs) {
      attrs.$observe('vlnBackImg', function (val) {
        ele.css({
          'background-image': "url(".concat(val, ")"),
          'background-size': 'cover',
          'background-position': '50% 50%'
        });
      });
    }
  };
}).name;
exports.VlnBackImageModule = VlnBackImageModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptimizelyServiceModule = void 0;

var _OptimizelyStore = _interopRequireDefault(__webpack_require__(525));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OptimizelyServiceModule = angular.module('app.components.optimizely.optimizelyService', []).factory('optimizelyService', ["$rootScope", function ($rootScope) {
  function handleAsync(response) {
    $rootScope.$digest();
    return response;
  }

  return {
    getExperiments: function getExperiments() {
      return _OptimizelyStore.default.getExperiments().then(handleAsync);
    },
    setUpExperiment: function setUpExperiment(experimentId, condition, variations, pageName) {
      return _OptimizelyStore.default.setUpExperiment(experimentId, condition, variations, pageName);
    },
    trackPage: function trackPage(pageName) {
      return _OptimizelyStore.default.trackPage(pageName);
    },
    trackEvent: function trackEvent(eventName) {
      return _OptimizelyStore.default.trackEvent(eventName);
    }
  };
}]).name;
exports.OptimizelyServiceModule = OptimizelyServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 265 */,
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PagesServiceModule = void 0;

var _settings = __webpack_require__(15);

var _founderGuide = __webpack_require__(155);

var _storefrontCache = __webpack_require__(406);

var _data = __webpack_require__(11);

var PagesServiceModule = angular.module('app.services.data.pagesService', [_data.DataServiceModule, _settings.AppSettingsModule, _founderGuide.FounderGuideServiceModule, _storefrontCache.StorefrontCacheServiceModule]).service('pagesService', ["$window", "dataService", "founderGuideService", "storefrontCacheService", "settings", function ($window, dataService, founderGuideService, storefrontCacheService, settings) {
  var PAGE_STATE = {
    active: 'Active',
    inactive: 'Inactive'
  };
  var QUERY = {
    active: 'isActive eq true',
    inactive: 'isActive eq false',
    defaultSort: ['updatedOn+desc']
  };
  return {
    PAGE_SIZE: 25,
    START_PAGE: 1,
    QUERY: QUERY,
    save: save,
    create: create,
    removePage: removePage,
    getMetrics: getMetrics,
    getPage: getPage,
    getPages: getPages,
    getPageCount: getPageCount,
    copyPage: copyPage,
    refreshStorefrontCache: refreshStorefrontCache,
    buildFilter: buildFilter
  };

  function save(page) {
    var _this = this;

    return dataService.save(settings.api.pages, page.id, page).then(function (result) {
      _this.refreshStorefrontCache();

      return result;
    });
  }

  function create(page) {
    var _this2 = this;

    var completeTask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return dataService.create(settings.api.pages, page).then(function (data) {
      var taskId = 'organize.addPage';
      var firstPageCreated = 'pagesService:firstPageCreated';
      var MILESTONE = 3;
      var FOUNDERGUIDE_STEP_KEY = 'pageDetails:founderGuideStepComplete';

      if (completeTask) {
        return founderGuideService.completeFounderGuideTask(taskId, firstPageCreated, MILESTONE).then(function (taskCompleted) {
          if (taskCompleted) $window.sessionStorage.setItem(FOUNDERGUIDE_STEP_KEY, true);
          return data;
        });
      }

      _this2.refreshStorefrontCache();

      return data;
    });
  }

  function removePage(page) {
    var _this3 = this;

    return dataService.remove(settings.api.pages, page.id).then(function (result) {
      _this3.refreshStorefrontCache();

      return result;
    });
  }

  function getPage(id) {
    return dataService.get(settings.api.pages, id);
  }

  function getPages(page, sort, options) {
    options = options || {};

    if (sort && sort.length) {
      options.sortBy = sort[0].replace(' ', '+');
    }

    return dataService.getAll(settings.api.pages, options);
  }

  function getMetrics() {
    return dataService.getAll(settings.api.pagesMetrics, {});
  }

  function getPageCount() {
    return dataService.getAll(settings.api.pages, {
      sortBy: QUERY.defaultSort,
      pageSize: 1
    }).then(function (response) {
      return response.total;
    });
  }

  function copyPage(item, nameLength) {
    var _this4 = this;

    var copyItem = angular.copy(item);
    copyItem.seo.friendlyName = null;
    copyItem.id = '';
    return dataService.copy(settings.api.pages, copyItem, nameLength).then(function (result) {
      _this4.refreshStorefrontCache();

      return result;
    });
  }

  function refreshStorefrontCache() {
    return storefrontCacheService.refresh('content');
  }

  function buildFilter(filterQuery) {
    switch (filterQuery) {
      case PAGE_STATE.active:
        return QUERY.active;

      case PAGE_STATE.inactive:
        return QUERY.inactive;

      default:
        return null;
    }
  }
}]).name;
exports.PagesServiceModule = PagesServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentMethodServiceModule = void 0;

var _data = __webpack_require__(11);

var _settings = __webpack_require__(15);

var PaymentMethodServiceModule = angular.module('app.services.payment.paymentMethod', [_data.DataServiceModule, _settings.AppSettingsModule]).service('paymentMethodService', ["dataService", "settings", function (dataService, settings) {
  function getPaymentMethod() {
    return dataService.getAll(settings.api.paymentMethod);
  }

  function updatePaymentMethod(creditCardToken) {
    return dataService.saveAll(settings.api.paymentMethod, {
      creditCardToken: creditCardToken
    });
  }

  return {
    getPaymentMethod: getPaymentMethod,
    updatePaymentMethod: updatePaymentMethod
  };
}]).name;
exports.PaymentMethodServiceModule = PaymentMethodServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = trackEvent;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function trackEvent(eventId, eventData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(_objectSpread({
    event: eventId
  }, eventData));
}

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Auth0SdkServiceModule = void 0;

var _auth0SpaJs = __webpack_require__(682);

var Auth0SdkServiceModule = angular.module('app.services.auth.auth0SdkService', []).service('auth0SdkService', ["$q", function ($q) {
  var auth0 = window.crypto ? new _auth0SpaJs.Auth0Client({
    domain: "login-sandbox.volusion.com",
    client_id: "rWEyCZ6MhTBUtDs5ztXrceCVEeBX4FZv",
    audience: "https://sandbox.api.material.com"
  }) : null;

  function handleRedirectCallback() {
    var deferred = $q.defer();
    auth0.handleRedirectCallback().then(function () {
      deferred.resolve();
    }).catch(function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  }

  function loginWithRedirect(options) {
    var deferred = $q.defer();
    auth0.loginWithRedirect(options).then(function () {
      deferred.resolve();
    }).catch(function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  }

  function isAuthenticated() {
    var deferred = $q.defer();
    auth0.isAuthenticated().then(function (authenticated) {
      deferred.resolve(authenticated);
    }).catch(function () {
      deferred.resolve(false);
    });
    return deferred.promise;
  }

  function getTokenSilently() {
    var deferred = $q.defer();
    auth0.getTokenSilently().then(function (token) {
      deferred.resolve(token);
    }).catch(function () {
      deferred.resolve(null);
    });
    return deferred.promise;
  }

  function getUser() {
    var deferred = $q.defer();
    auth0.getUser().then(function (user) {
      deferred.resolve(user);
    }).catch(function () {
      deferred.resolve(null);
    });
    return deferred.promise;
  }

  function logout(options) {
    var deferred = $q.defer();
    auth0.logout(options).then(function () {
      deferred.resolve();
    }).catch(function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  }

  return {
    loginWithRedirect: loginWithRedirect,
    isAuthenticated: isAuthenticated,
    getTokenSilently: getTokenSilently,
    getUser: getUser,
    handleRedirectCallback: handleRedirectCallback,
    logout: logout
  };
}]).name;
exports.Auth0SdkServiceModule = Auth0SdkServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageLibraryModule = void 0;

var _imageLibrary = __webpack_require__(592);

var _imageLibraryDropzone = __webpack_require__(1257);

var _launchImageLibrary = __webpack_require__(1259);

var _imageLibraryItem = __webpack_require__(708);

var ImageLibraryModule = angular.module('vln.imageLibrary', ['angular-clipboard', _imageLibrary.ImageLibraryServiceModule, _imageLibraryDropzone.ImageLibraryDropzoneModule, _launchImageLibrary.ImageLibraryLaunchModule, _imageLibraryItem.ImageLibraryItemModule]).name;
exports.ImageLibraryModule = ImageLibraryModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 373 */,
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataLayerServiceModule = void 0;
var DataLayerServiceModule = angular.module('app.services.tracking.enhancedEcommerce.dataLayer', []).service('dataLayer', ["$window", function ($window) {
  function logCheckoutStep(stepNumber, optionValue, products) {
    $window.dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step: stepNumber,
            option: optionValue
          },
          products: products
        }
      }
    });
  }

  function logAddToCart(currencyCode, products) {
    $window.dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        currencyCode: currencyCode,
        add: {
          products: products
        }
      }
    });
  }

  function logRemoveFromCart(products) {
    $window.dataLayer.push({
      event: 'removeFromCart',
      ecommerce: {
        remove: {
          products: products
        }
      }
    });
  }

  function logProductImpression(impressions) {
    $window.dataLayer.push({
      event: 'productImpressions',
      ecommerce: {
        impressions: impressions
      }
    });
  }

  function logProductClick(products, listType) {
    $window.dataLayer.push({
      event: 'productClick',
      ecommerce: {
        click: updateActionFields(products, listType)
      }
    });
  }

  function logProductDetails(products, listType) {
    $window.dataLayer.push({
      event: 'productDetails',
      ecommerce: {
        detail: updateActionFields(products, listType)
      }
    });
  }

  function logCouponError(couponCode) {
    $window.dataLayer.push({
      event: 'couponError',
      couponCode: couponCode
    });
  }

  function updateActionFields(products, listType) {
    var actionFieldObject = {
      products: products
    };

    if (listType) {
      actionFieldObject.actionField = {
        list: listType
      };
    }

    return actionFieldObject;
  }

  function logPurchase(purchaseId, affiliation, revenue, tax, products, paidWith, couponCode) {
    $window.dataLayer.push({
      event: 'productPurchase',
      ecommerce: {
        purchase: {
          actionField: {
            id: purchaseId,
            affiliation: affiliation,
            revenue: revenue,
            tax: tax,
            paidWith: paidWith,
            coupon: couponCode
          },
          products: products
        }
      }
    });
  }

  function create(_ref, category, listType, position) {
    var productCode = _ref.productCode,
        title = _ref.title,
        price = _ref.price,
        variant = _ref.variant;
    var payload = {
      name: title,
      id: productCode,
      price: price,
      category: category,
      variant: variant,
      brand: 'v2'
    };

    if (angular.isDefined(listType)) {
      payload.list = listType;
    }

    if (isFinite(position)) {
      payload.position = position;
    }

    return payload;
  }

  return {
    logCheckoutStep: logCheckoutStep,
    logAddToCart: logAddToCart,
    logCouponError: logCouponError,
    logRemoveFromCart: logRemoveFromCart,
    logProductImpression: logProductImpression,
    logProductClick: logProductClick,
    logProductDetails: logProductDetails,
    logPurchase: logPurchase,
    create: create
  };
}]).name;
exports.DataLayerServiceModule = DataLayerServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppServiceModule = void 0;

var _myAccount = __webpack_require__(84);

var _storeInformation = __webpack_require__(38);

var _authToken = __webpack_require__(43);

var _settings = __webpack_require__(15);

var _greeting = __webpack_require__(597);

var _hubspot = __webpack_require__(1317);

var _subscription = __webpack_require__(42);

var _launchDarkly = __webpack_require__(30);

var _products = __webpack_require__(98);

var _categories = __webpack_require__(100);

var _pages = __webpack_require__(266);

var _postage = __webpack_require__(624);

var _features = __webpack_require__(258);

var _segment = __webpack_require__(58);

var _orders = __webpack_require__(378);

var _trial = __webpack_require__(60);

var _discounts = __webpack_require__(387);

var _phone = __webpack_require__(594);

var _verifyEmailReminder = __webpack_require__(722);

var _BaremetricsRecover = __webpack_require__(1353);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var AppServiceModule = angular.module('app.service', [_myAccount.MyAccountServiceModule, _storeInformation.StoreInformationServiceModule, _authToken.AuthTokenServiceModule, _settings.AppSettingsModule, _greeting.GreetingServiceModule, _subscription.SubscriptionServiceModule, _launchDarkly.LaunchDarklyServiceModule, _products.ProductServiceModule, _categories.CategoryServiceModule, _pages.PagesServiceModule, _postage.PostageServiceModule, _features.FeaturesServiceModule, _orders.OrderServiceModule, _trial.TrialServiceModule, _discounts.DiscountsServiceModule, _phone.PhoneFilterModule, _verifyEmailReminder.VerifyEmailReminderServiceModule, _segment.SegmentServiceModule, _hubspot.HubspotServiceModule]).service('appService', ["$filter", "$window", "$document", "myAccountService", "storeInformationService", "authTokenService", "auth0AuthService", "$q", "greetingService", "subscriptionsService", "launchDarklyService", "discountsService", "productService", "categoryService", "pagesService", "postageService", "featureService", "orderService", "$rootScope", "$timeout", "trialService", "verifyEmailReminderService", "segmentService", "hubspotService", function ($filter, $window, $document, myAccountService, storeInformationService, authTokenService, auth0AuthService, $q, greetingService, subscriptionsService, launchDarklyService, discountsService, productService, categoryService, pagesService, postageService, featureService, orderService, $rootScope, $timeout, trialService, verifyEmailReminderService, segmentService, hubspotService) {
  function init() {
    return _init.apply(this, arguments);
  }

  function _init() {
    _init = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              orderService.initOrderNotify();
              $q.all([myAccountService.getUser(), trialService.getTrialStatus(), hubspotService.loadChatWidget()]).then(function (_ref12) {
                var _ref13 = _slicedToArray(_ref12, 2),
                    user = _ref13[0],
                    trialStatus = _ref13[1];

                if (!user.emailVerified && trialStatus === _trial.NOT_TRIAL) {
                  verifyEmailReminderService.initVerifyEmailReminder();
                }
              });
              getDomainStatusAndRegister();
              initLogging();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    return _init.apply(this, arguments);
  }

  function initLogging() {
    var getGreeting = greetingService.getProfile().then(function (response) {
      return response.data;
    }).catch(function () {
      return {};
    });
    $q.all([getGreeting, getInitData()]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          greetingData = _ref2[0],
          initData = _ref2[1];

      var mergedData = [greetingData].concat(initData);
      initLibraries(mergedData);
    });
  }

  function getDomainStatusAndRegister() {
    storeInformationService.getStore().then(function (store) {
      storeInformationService.getCustomDomainStatus().then(function (res) {
        if (res.status === 'CREATE_COMPLETE' && store.customDomain) {
          storeInformationService.registerCustomDomain(store.customDomain);
        }
      });
    });
  }

  function getInitData() {
    var getUser = myAccountService.getUser().then(function (res) {
      res = res || {};
      return {
        firstName: res.firstName,
        lastName: res.lastName,
        userName: "".concat(res.firstName || '', " ").concat(res.lastName || '').trim(),
        userId: res.id || '',
        userEmail: res.email || ''
      };
    }).catch(function () {
      return {};
    });
    var getStore = storeInformationService.getStore().then(function (res) {
      return {
        userEmail: res.email,
        storeName: res.name,
        taxNexus: res.taxNexus,
        storeUrl: res.storeUrl,
        customDomain: res.customDomain,
        launched: res.launched,
        materialPlan: res.materialPlan,
        phoneNumber: $filter('phone')(res.phoneNumber),
        paypalConnected: res.paypal ? res.paypal.permissionsGranted === 'true' : false,
        paypalEnabled: res.paypal ? res.paypal.isEnabled : false
      };
    }).catch(function () {
      return {};
    });

    var processSubscription = function processSubscription(subscription) {
      if (subscription.status === 'unpaid') {
        (0, _BaremetricsRecover.loadBaremetricsRecoverWidget)(subscription.customer);
      }

      return subscription;
    };

    var getSubscription = subscriptionsService.getSubscription().then(function (res) {
      return processSubscription(res);
    }).catch(function () {
      return {};
    });
    var getDiscounts = Promise.all([discountsService.getDiscounts(1, 1), discountsService.getDiscounts(1, 1, {
      isActive: true
    })]).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          allDiscounts = _ref4[0],
          activeDiscounts = _ref4[1];

      return {
        activeDiscountCodesCount: activeDiscounts.total,
        totalDiscountCodesCount: allDiscounts.total
      };
    }).catch(function () {
      return {};
    });
    var getProductMetrics = productService.getMetrics().then(function (resp) {
      return {
        totalProductCount: resp.totalProductCount,
        trackedSKUCount: resp.trackedSKUCount,
        outOfStockSKUCount: resp.outOfStockSKUCount
      };
    }).catch(function () {
      return {};
    });
    var getCategories = categoryService.getCategories(true).then(function (resp) {
      var totalCategories = categoryService.flattenCategories(resp).length;
      var parentCategories = resp.length;
      return {
        categoryCount: totalCategories,
        parentCount: parentCategories,
        subCount: totalCategories - parentCategories
      };
    }).catch(function () {
      return {};
    });
    var getPagesMetrics = pagesService.getPageCount().then(function (resp) {
      return {
        pagesCount: resp
      };
    }).catch(function () {
      return {};
    });
    var getShippoDefaults = postageService.getDefaults().then(function (resp) {
      return {
        hasConfiguredDefaults: postageService.hasConfiguredDefaults(resp)
      };
    }).catch(function () {
      return {};
    });
    var getFeatures = featureService.getFeatures().then(function (resp) {
      return {
        shippingEnabled: angular.isDefined(resp.shipping) && resp.shipping.enabled,
        discountEnabled: angular.isDefined(resp.discount) && resp.discount.enabled,
        pinterestEnabled: angular.isDefined(resp.pinterest) && resp.pinterest.enabled
      };
    }).catch(function () {
      return {};
    });
    return $q.all([getUser, getStore, getSubscription, getDiscounts, getProductMetrics, getCategories, getPagesMetrics, getShippoDefaults, getFeatures]);
  }

  var initializeSegmentService = function initializeSegmentService(_ref5) {
    var user = _ref5.user,
        storeInfo = _ref5.storeInfo,
        tenantId = _ref5.tenantId;

    if ($window.analytics) {
      segmentService.trackIdentity(tenantId, {
        email: user.userEmail,
        name: user.userName,
        store_name: storeInfo.storeName,
        store_url: storeInfo.storeUrl,
        custom_domain: storeInfo.customDomain,
        tenant_id: tenantId,
        user_id: user.userId
      });
    }
  };

  var updateLaunchDarklyUser = function updateLaunchDarklyUser(_ref6) {
    var user = _ref6.user,
        storeInfo = _ref6.storeInfo,
        subscription = _ref6.subscription,
        tenantId = _ref6.tenantId;
    return launchDarklyService.updateUser({
      key: tenantId,
      firstName: user.userName,
      email: user.userEmail,
      custom: {
        planType: subscription.plan.name,
        storeName: storeInfo.storeName,
        storeUrl: storeInfo.storeUrl
      }
    });
  };

  var initializeLiveAgentChat = function initializeLiveAgentChat(_ref7) {
    var user = _ref7.user,
        subscription = _ref7.subscription;

    if ($window.embedded_svc) {
      $window.embedded_svc.settings.prepopulatedPrechatFields = {
        FirstName: user.firstName,
        LastName: user.lastName,
        Email: user.userEmail,
        Subject: ''
      };
      $window.embedded_svc.settings.extraPrechatFormDetails = [{
        label: 'Email',
        value: user.userEmail,
        displayToAgent: false
      }, {
        label: 'Active Plan',
        value: subscription.plan.name,
        transcriptFields: ['Active_Plan__c'],
        displayToAgent: false
      }, {
        label: 'Customer Platform',
        value: 'V2',
        transcriptFields: ['Customer_Platform__c'],
        displayToAgent: false
      }, {
        label: 'Prime_Account_Checkbox_Test__c',
        value: subscription.plan.name.toLowerCase().indexOf('prime') > -1,
        transcriptFields: ['Prime_Account_Checkbox_Test__c'],
        displayToAgent: false
      }, {
        label: 'OrderDetails Name',
        value: subscription.id,
        displayToAgent: false
      }];
      $window.embedded_svc.settings.extraPrechatInfo = [{
        entityName: 'OrderDetails__c',
        linkToEntityName: 'Case',
        linkToEntityField: 'Order_Detail_ID__c',
        showOnCreate: true,
        saveToTranscript: 'Order_Detail_ID__c',
        entityFieldMaps: [{
          isExactMatch: true,
          fieldName: 'Name',
          doCreate: false,
          doFind: true,
          label: 'OrderDetails Name'
        }]
      }, {
        entityName: 'Contact',
        showOnCreate: true,
        linkToEntityName: 'Case',
        linkToEntityField: 'ContactId',
        saveToTranscript: 'Contact',
        entityFieldMaps: [{
          isExactMatch: false,
          fieldName: 'FirstName',
          doCreate: false,
          doFind: false,
          label: 'First Name'
        }, {
          isExactMatch: false,
          fieldName: 'LastName',
          doCreate: false,
          doFind: false,
          label: 'Last Name'
        }, {
          isExactMatch: true,
          fieldName: 'Email',
          doCreate: true,
          doFind: true,
          label: 'Email'
        }]
      }];
    }
  };

  var trackAppLoadedEvent = function trackAppLoadedEvent(_ref8, isTrial) {
    var user = _ref8.user,
        subscription = _ref8.subscription,
        storeInfo = _ref8.storeInfo,
        tenantId = _ref8.tenantId;

    if (segmentService) {
      segmentService.trackGtmEvent({
        analyticsClickEvent: 'initialAppLoaded'
      }, {
        event: 'initialAppLoaded',
        tenantID: tenantId,
        userId: user.userId,
        planType: subscription.plan.name,
        isLaunched: storeInfo.launched.toString(),
        isTrial: isTrial
      });
    }
  };

  var sendProfileToGoogleAnalytics = function sendProfileToGoogleAnalytics(_ref9) {
    var greeting = _ref9.greeting;
    $window.dataLayer = $window.dataLayer || [];
    $window.dataLayer.push({
      event: 'profile',
      industry: greeting.industry,
      path: greeting.path,
      tenant: greeting.tenant,
      createdOn: greeting.createdOn,
      updatedOn: greeting.updatedOn
    });
  };

  function initLibraries(_ref10) {
    var _ref11 = _slicedToArray(_ref10, 10),
        greetingResponse = _ref11[0],
        userResponse = _ref11[1],
        storeResponse = _ref11[2],
        getSubscriptionResponse = _ref11[3],
        discountsResponse = _ref11[4],
        productsResponse = _ref11[5],
        categoriesResponse = _ref11[6],
        pagesResponse = _ref11[7],
        shippoDefaultsResponse = _ref11[8],
        featuresResponse = _ref11[9];

    return authTokenService.getTenantId().then(function (tenantId) {
      var initializationPayload = {
        user: userResponse,
        storeInfo: storeResponse,
        subscription: getSubscriptionResponse,
        greeting: greetingResponse,
        discounts: discountsResponse,
        products: productsResponse,
        categories: categoriesResponse,
        pages: pagesResponse,
        features: featuresResponse,
        shippoDefaults: shippoDefaultsResponse,
        tenantId: tenantId
      };
      initializeSegmentService(initializationPayload);
      updateLaunchDarklyUser(initializationPayload).then(function () {
        initializeLiveAgentChat(initializationPayload);
        var helpButtons = $document.find('.embeddedServiceHelpButton');

        if (helpButtons && helpButtons.length > 0) {
          helpButtons[0].style.visibility = 'visible';
        }
      });
      trialService.isTrialPlan(getSubscriptionResponse).then(function (isTrial) {
        trackAppLoadedEvent(initializationPayload, isTrial);
      });
      sendProfileToGoogleAnalytics(initializationPayload);
    });
  }

  return {
    init: init,
    initLogging: initLogging
  };
}]).name;
exports.AppServiceModule = AppServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 376 */,
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpPrefixDirective = void 0;

var _httpPrefixer = __webpack_require__(1573);

var HttpPrefixDirective = angular.module('app.components.httpPrefix.vlnHttpPrefix', [_httpPrefixer.HttpPrefixerService]).directive('vlnHttpPrefix', ["httpPrefixer", function (httpPrefixer) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, elem, attrs, ngModelCtrl) {
      var forceHttps = attrs.forceHttps;

      function ensureHttpPrefix(value) {
        if (value) {
          var viewValue = httpPrefixer.prefixUrl(value, forceHttps);
          ngModelCtrl.$setViewValue(viewValue);
          ngModelCtrl.$render();
          return viewValue;
        }

        return value;
      }

      ngModelCtrl.$formatters.push(ensureHttpPrefix);
      ngModelCtrl.$parsers.splice(0, 0, ensureHttpPrefix);
    }
  };
}]).name;
exports.HttpPrefixDirective = HttpPrefixDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderServiceModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _cloneDeep = _interopRequireDefault(__webpack_require__(189));

var _each = _interopRequireDefault(__webpack_require__(162));

var _find = _interopRequireDefault(__webpack_require__(66));

var _flow = _interopRequireDefault(__webpack_require__(716));

var _get = _interopRequireDefault(__webpack_require__(34));

var _isInteger = _interopRequireDefault(__webpack_require__(718));

var _map = _interopRequireDefault(__webpack_require__(75));

var _pick = _interopRequireDefault(__webpack_require__(273));

var _startsWith = _interopRequireDefault(__webpack_require__(599));

var _uuidV = _interopRequireDefault(__webpack_require__(288));

var _moment = _interopRequireDefault(__webpack_require__(74));

var _angularCookies = _interopRequireDefault(__webpack_require__(103));

var _settings = __webpack_require__(15);

var _notification = __webpack_require__(719);

var _storage = __webpack_require__(130);

var _authToken = __webpack_require__(43);

var _discounts = __webpack_require__(387);

var _discountsREST = __webpack_require__(669);

var _launchDarkly = __webpack_require__(30);

var _data = __webpack_require__(11);

var _model = __webpack_require__(165);

var _paypal = __webpack_require__(655);

var _search = __webpack_require__(120);

var _segment = __webpack_require__(58);

var _storeSettings = __webpack_require__(637);

var _orderConstants = _interopRequireDefault(__webpack_require__(631));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var OrderServiceModule = angular.module('app.services.data.orderService', ['ngMaterial', _angularCookies.default, _data.DataServiceModule, _settings.AppSettingsModule, _model.ModelServiceModule, _storage.StorageServiceModule, _search.SearchServiceModule, _segment.SegmentServiceModule, _notification.NotificationServiceModule, _storeSettings.StoreSettingsServiceModule, _paypal.PaypalServiceModule, _authToken.AuthTokenServiceModule, _discounts.DiscountsServiceModule, _discountsREST.DiscountsRESTServiceModule, _launchDarkly.LaunchDarklyServiceModule]).factory('orderService', ["$q", "$interval", "$rootScope", "$window", "$cookies", "$translate", "$mdDialog", "dataService", "settings", "modelService", "notificationService", "paypalService", "searchService", "segmentService", "storageService", "storeSettingsService", "authTokenService", "discountsService", "discountsRESTService", "launchDarklyService", function ($q, $interval, $rootScope, $window, $cookies, $translate, $mdDialog, dataService, settings, modelService, notificationService, paypalService, searchService, segmentService, storageService, storeSettingsService, authTokenService, discountsService, discountsRESTService, launchDarklyService) {
  var ORDER_STATE = {
    all: 'all',
    new: 'New',
    pending: 'Pending',
    inProgress: 'In Progress',
    completed: 'Complete',
    canceled: 'Canceled',
    archived: 'Archived',
    inbox: 'Inbox',
    refunded: 'Refunded',
    flagged: 'Flagged'
  };

  var _archivedFilter = "status eq \"".concat(ORDER_STATE.completed, "\"\n                        or status eq \"").concat(ORDER_STATE.canceled, "\"\n                        or status eq \"").concat(ORDER_STATE.refunded, "\"");

  var _newStatusFilter = "status eq \"".concat(ORDER_STATE.new, "\"");

  var _inProgressFilter = "status eq \"".concat(ORDER_STATE.inProgress, "\" or status eq \"").concat(ORDER_STATE.pending, "\"");

  var _flaggedFilter = "verification.isFlaggedForReview eq \"true\" and ".concat(_newStatusFilter);

  var _inboxFilter = "".concat(_newStatusFilter, "\n                        or status eq \"").concat(ORDER_STATE.inProgress, "\"\n                        or status eq \"").concat(ORDER_STATE.pending, "\"");

  var CUSTOM = _orderConstants.default.DISCOUNT_TYPE.CUSTOM;
  var FIXED = _orderConstants.default.DISCOUNT_TYPE.FIXED;
  var PERCENT = _orderConstants.default.DISCOUNT_TYPE.PERCENT;
  var MONGO_ERROR = 'Document not found for filter: ';
  return {
    basicDialogController: basicDialogController,
    buildFilter: buildFilter,
    bulkAction: bulkAction,
    bulkUpdate: bulkUpdate,
    bulkUpload: bulkUpload,
    create: create,
    createOrUpdateCustomDiscount: createOrUpdateCustomDiscount,
    createPaymentPromises: createPaymentPromises,
    editFulfillmentEvent: editFulfillmentEvent,
    get: get,
    getAdjustedGrandTotal: getAdjustedGrandTotal,
    getAdjustmentAmount: getAdjustmentAmount,
    getBulkUpdateStatus: getBulkUpdateStatus,
    getCartImages: getCartImages,
    getCombinedItemsDiscount: getCombinedItemsDiscount,
    getCustomerByEmail: getCustomerByEmail,
    getCustomerById: getCustomerById,
    getCustomerOrders: getCustomerOrders,
    getDiscountDisplayLines: getDiscountDisplayLines,
    getDiscountedItemTotals: getDiscountedItemTotals,
    getErrItem: getErrItem,
    getErrorMessage: getErrorMessage,
    getHistory: getHistory,
    getItemQuantity: getItemQuantity,
    getItems: getItems,
    getMetrics: getMetrics,
    getNextOrderId: getNextOrderId,
    getOrderCount: getOrderCount,
    getOrderHistory: getOrderHistory,
    getOriginalAmount: getOriginalAmount,
    getPreviousOrderId: getPreviousOrderId,
    getProductInventory: getProductInventory,
    getQuantityMoreAvailable: getQuantityMoreAvailable,
    getRequestId: getRequestId,
    getShippingMethods: getShippingMethods,
    handleTaxProviderMessageEvent: handleTaxProviderMessageEvent,
    hasDiscountedPrices: hasDiscountedPrices,
    initOrderNotify: initOrderNotify,
    isFixedCustomDiscount: isFixedCustomDiscount,
    isFullyRefunded: isFullyRefunded,
    isInvalidQuantity: isInvalidQuantity,
    isInventoryTracked: isInventoryTracked,
    isPercentCustomDiscount: isPercentCustomDiscount,
    isPrematureRefundError: isPrematureRefundError,
    isQuantityExceedingInventory: isQuantityExceedingInventory,
    isRefundWaitingPeriodPassed: isRefundWaitingPeriodPassed,
    isRegularDiscount: isRegularDiscount,
    isTestOrder: isTestOrder,
    isTrackingRequired: isTrackingRequired,
    logFulfillmentEvent: logFulfillmentEvent,
    markShipped: markShipped,
    mergeOrder: mergeOrder,
    parseCartError: parseCartError,
    readyPaymentData: readyPaymentData,
    recalculateTax: recalculateTax,
    refreshOrder: refreshOrder,
    resendOrderConfirmationEmail: resendOrderConfirmationEmail,
    resendShippingConfirmationEmail: resendShippingConfirmationEmail,
    save: save,
    sendPaymentEvent: sendPaymentEvent,
    shouldShowOrderShipping: shouldShowOrderShipping,
    showErrorModal: showErrorModal,
    tabulateAndCreateCustomDiscount: tabulateAndCreateCustomDiscount,
    updateDiscountedPrices: updateDiscountedPrices,
    updateOrderFn: updateOrderFn
  };

  function buildFilter(filterQuery) {
    var filter;

    switch (filterQuery) {
      case ORDER_STATE.archived:
        filter = _archivedFilter;
        break;

      case ORDER_STATE.inbox:
        filter = _inboxFilter;
        break;

      case ORDER_STATE.inProgress:
        filter = _inProgressFilter;
        break;

      case ORDER_STATE.flagged:
        filter = _flaggedFilter;
        break;

      default:
        filter = "status eq \"".concat(filterQuery, "\"");
        break;
    }

    return filter;
  }

  function bulkUpdate(csvObj) {
    return dataService.saveAll(settings.api.orderBulkUpdate, csvObj);
  }

  function getBulkUpdateStatus(importerJobId) {
    return dataService.get(settings.api.orderBulkUpdateStatus, importerJobId);
  }

  function bulkUpload(csvObj) {
    return dataService.saveAll(settings.api.orderBulkUpload, csvObj);
  }

  function bulkAction(type, orders, self) {
    if (type === 'accept') {
      var bulkPaymentPromises = createPaymentPromises(orders, type, self);
      return $q.all(bulkPaymentPromises);
    }
  }

  function createPaymentPromises(orders, type, self) {
    return orders.map(function (order) {
      var data = readyPaymentData(order);
      return sendPaymentEvent(order.id, data).then(function () {
        self.$window.dataLayer.push({
          event: "admin_order.detail_".concat(type, "-acceptPayment")
        });
        return get(order.id);
      }).then(function (response) {
        if (shouldShowOrderShipping(response)) {
          return getOrderHistory(response);
        }

        var carrierInfo = [{
          carrier: _orderConstants.default.NO_SHIPPING,
          number: ''
        }];
        return markShipped(response, carrierInfo, 'action', self);
      }).catch(function (err) {
        return $q.reject(err);
      });
    });
  }

  function readyPaymentData(order) {
    var data = {
      eventType: 'charge'
    };
    var paypalTransaction = order.payPalPaymentTransactionId;

    if (paypalTransaction) {
      return Object.assign({}, data, {
        payPalPaymentTransactionId: paypalTransaction
      });
    }

    return data;
  }

  function shouldShowOrderShipping(order) {
    return order.cart.items.reduce(function (acc, item) {
      return acc || item.product.requiresShipping === undefined || // no prop == default to true
      item.product.requiresShipping === true;
    }, false);
  } // Returns processed order object


  function updateOrderFn() {
    return (0, _flow.default)([addOrderDiffItems, addPaymentLifeCycleEvents, addPaymentMethodEvents, addShippingLabelEvents]);
  }

  function getOrderHistory(order) {
    order.history = order.history || [];
    order.history.push(initOrderHistory(order));
    return getHistory(order.auditLogId).then(function (response) {
      var updateOrder = updateOrderFn();
      var clonedOrder = (0, _cloneDeep.default)(order);
      return updateOrder(response.auditItems, clonedOrder);
    });
  }

  function initOrderHistory(order) {
    return {
      icon: 'shopping_cart',
      text: 'ORDER.PLACED',
      date: order.createdOn
    };
  }

  function addOrderDiffItems(auditItems, order) {
    (0, _each.default)(auditItems, function (item) {
      (0, _each.default)(item.differences, function (diff) {
        if (diff.fieldName.includes('PlacedBy') || diff.fieldName.includes('DeliverTo')) {
          order.history.push({
            icon: 'mode_edit',
            text: 'ORDER.ORDEREDITED',
            date: item.createdOn
          });
        }

        switch (diff.fieldName) {
          case 'Paid':
            if (diff.modifiedValue === 'True') {
              order.history.push({
                icon: 'credit_card',
                text: 'ORDER.PAYMENTACCEPTED',
                date: item.createdOn
              });
              order.paymentDate = (0, _moment.default)(item.createdOn).format('MM/DD/YYYY');
            }

            break;

          case 'Status':
            if (diff.modifiedValue === 'Complete') {
              order.history.push({
                icon: 'check',
                text: 'ORDER.COMPLETED',
                date: item.createdOn
              });

              if (order.shipped) {
                order.history.push({
                  icon: 'mail',
                  text: 'ORDER.SHIPPED',
                  date: item.createdOn
                });
                order.shippedDate = item.createdOn;
              }
            } else if (diff.modifiedValue === 'Canceled') {
              order.history.push({
                icon: 'clear',
                text: 'ORDER.CANCELED',
                date: item.createdOn
              });
              order.cancelDate = (0, _moment.default)(item.createdOn).format('MM/DD/YYYY');
            }

            break;

          case 'MerchantNote':
            if (diff.modifiedValue !== '' && diff.modifiedValue !== '(null)' && (diff.originalValue === '' || diff.originalValue === '(null)')) {
              order.history.push({
                icon: 'speaker_notes',
                text: 'ORDER.NOTEADDED',
                date: item.createdOn
              });
            } else if (diff.modifiedValue !== '' && diff.modifiedValue !== '(null)' && diff.originalValue !== '' && diff.originalValue !== '(null)') {
              order.history.push({
                icon: 'speaker_notes',
                text: 'ORDER.NOTEUPDATED',
                date: item.createdOn
              });
            } else if (diff.originalValue !== '' && diff.originalValue !== '(null)' && (diff.modifiedValue === '' || diff.modifiedValue === '(null)')) {
              order.history.push({
                icon: 'speaker_notes',
                text: 'ORDER.NOTEREMOVED',
                date: item.createdOn
              });
            }

            break;
          // no default
        }
      });
    });
    return order;
  }

  function addPaymentLifeCycleEvents(order) {
    var paymentLifecycle = order.paymentLifecycle;
    (0, _each.default)(paymentLifecycle, function (event) {
      switch (event.eventType.toLowerCase()) {
        case 'refund':
          order.history.push({
            icon: 'refresh',
            text: 'ORDER.REFUNDED',
            date: event.createdOn
          });
          order.refundDate = (0, _moment.default)(event.createdOn).format('MM/DD/YYYY');
          break;
        // no default
      }
    });
    return order;
  }

  function addPaymentMethodEvents(order) {
    // Create one array of payment events
    var paymentEvents = _toConsumableArray(order.payPalEvents ? order.payPalEvents : []).concat(_toConsumableArray(order.stripeEvents ? order.stripeEvents : []));

    (0, _each.default)(paymentEvents, function (event) {
      switch (event.type) {
        case 'CapturedChargeSuccessful':
          order.history.push({
            icon: 'check',
            text: 'ORDER.CHARGESUCCESSFUL',
            date: event.timestamp
          });
          break;

        case 'CapturedChargeError':
          order.history.push({
            icon: 'close',
            text: 'ORDER.CHARGEERROR',
            date: event.timestamp
          });
          order.chargeError = event.description;
          break;

        case 'ChargeRefundSuccessful':
          order.history.push({
            icon: 'refresh',
            text: 'ORDER.REFUNDSUCCESSFUL',
            date: event.timestamp
          });
          break;

        case 'ChargeRefundError':
          order.history.push({
            icon: 'close',
            text: 'ORDER.REFUNDERROR',
            date: event.timestamp
          });
          break;

        case 'CanceledReversalSuccessful':
          order.history.push({
            icon: 'credit_card',
            text: 'ORDER.REVERSECANCELED',
            date: event.timestamp
          });
          break;
        // no default
      }
    });
    return order;
  }

  function addShippingLabelEvents(order) {
    (0, _each.default)(order.fulfillmentLifecycle, function (event) {
      switch (event.eventType) {
        case 'PostagePaid':
          order.history.push({
            svgSrc: '/assets/shippo-icon.svg',
            text: 'POSTAGE.EVENT_LABELPURCHASED',
            date: event.createdOn
          });
          break;

        case 'PostageRefunded':
          order.history.push({
            svgSrc: '/assets/shippo-icon.svg',
            text: 'POSTAGE.EVENT_LABELREFUNDED',
            date: event.createdOn
          });
          break;
        // no default
      }
    });
    return order;
  }

  function markShipped(order, trackingInfo, clickType, self) {
    return logFulfillmentEvent(order.id, {
      eventType: 'shipped',
      trackingInformation: trackingInfo
    }).then(function () {
      self.$window.dataLayer.push({
        event: "admin_order.detail_".concat(clickType, "-markShipped")
      });
      return refreshOrder(order).then(function (refreshedOrder) {
        return refreshedOrder;
      });
    });
  }

  function refreshOrder(order) {
    return get(order.id).then(function (response) {
      return getHistorySetShipping(response);
    });
  }

  function getHistorySetShipping(order) {
    return getOrderHistory(order).then(setTrackingNumbers).then(setShippingMethodAndStoreInfo);
  }

  function setTrackingNumbers(order) {
    var trackingInformation = order.trackingInformation;
    order.trackingElements = (0, _map.default)(trackingInformation, function (trackingElement, index) {
      var linkUrl = trackingElement.carrier === 'USPS' ? "https://tools.usps.com/go/TrackConfirmAction?tLabels=".concat(trackingElement.number) : "//google.com/search?q=".concat(trackingElement.number);
      return "<a href=\"".concat(linkUrl, "\" target=\"_blank\" class=\"text__link\">\n                ").concat(trackingElement.number, "\n                </a>").concat(index === trackingInformation.length - 1 ? '.' : '');
    });
    order.shippingCarrier = trackingInformation && trackingInformation.length ? trackingInformation[0].carrier : null; // Wrap to continue using the promise chain with `getHistorySetShipping`

    return $q.resolve(order);
  }

  function setShippingMethodAndStoreInfo(order) {
    return storeSettingsService.get().then(function (res) {
      if (res.shippingMethods) {
        order.shippingMethod = res.shippingMethods.name;
      }

      if (res.storeInformation) {
        var storeInfo = modelService.makeModel(res.storeInformation, 'storeInformationModel');
        paypalInit(storeInfo);
      } // Wrap to continue using the promise chain within `getHistorySetShipping`


      return $q.resolve(order);
    });
  }

  function paypalInit(storeInfo) {
    var paypalConnected = paypalService.isConnectedComplete(storeInfo);

    if (paypalConnected) {
      rectifyPaypalConnectionData(storeInfo);
    }

    if (!paypalConnected) {
      paypalService.prefill(true).then(function (response) {
        // eslint-disable-next-line no-console
        console.log('response', response);
      });
    }
  }

  function rectifyPaypalConnectionData(storeInfo) {
    if (!storeInfo.paypal.permissionsGranted && paypalService.hasConnectedPaypalPermissions(storeInfo)) {
      paypalService.setPaypalConnected(storeInfo).then(function (response) {
        // This is a holdover from the orderDetails logic port
        storeInfo = modelService.makeModel(response, 'storeInformationModel');
      });
    }
  }

  function getHistory(id) {
    return dataService.get(settings.api.auditlogs, id);
  }

  function get(orderId) {
    return dataService.get(settings.api.orders, orderId);
  }

  function getItems() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return dataService.getAll(settings.api.orders, options);
  }

  function create(order) {
    return dataService.create(settings.api.orders, order);
  }

  function save(order) {
    return dataService.save(settings.api.orders, order.id, order);
  }

  function recalculateTax(order) {
    return dataService.get("".concat(settings.api.orders, "/").concat(order.id, "/taxes"));
  }

  function getOrderCount(filter, sort) {
    var options = {
      filter: filter,
      pageSize: 1,
      sort: sort ? sort.replace(' ', '+') : null
    };
    return dataService.getAll(settings.api.orders, options).then(function (response) {
      return response.totalCount;
    });
  }

  function getMetrics() {
    var getAllMetrics = dataService.getAll(settings.api.ordersMetrics);
    return getAllMetrics.then(function (response) {
      return {
        flaggedCount: response.flaggedNewOrderCount,
        inProgressCount: response.inProgressOrderCount,
        newCount: response.newOrderCount,
        newTotal: response.newOrderGrandTotalSum,
        recentCount: response.recentOrderCount
      };
    });
  }

  function getCustomerOrders(customerId, page, count, sort) {
    var options = {
      filter: "customerId eq ".concat(customerId),
      pageSize: count,
      startIndex: (page - 1) * count,
      sortBy: sort ? sort.replace(' ', '+') : null
    };
    return dataService.getAll(settings.api.orders, options);
  }

  function sendPaymentEvent(id, paymentObj) {
    return dataService.create("".concat(settings.api.orders, "/").concat(id, "/paymentlifecycleevent"), paymentObj);
  }

  function logFulfillmentEvent(orderId, eventObject) {
    return dataService.create("".concat(settings.api.orders, "/").concat(orderId, "/fulfillmentlifecycleevent"), eventObject);
  }

  function editFulfillmentEvent(orderId, fulfillmentId, eventObject) {
    var endpoint = "".concat(settings.api.orders, "/").concat(orderId, "/fulfillmentlifecycleevent");
    return dataService.save(endpoint, fulfillmentId, eventObject);
  }

  function getShippingMethods() {
    // TODO get methods from API
    var SHIP = _orderConstants.default.SHIPPING_METHODS;
    return [SHIP.UPS, SHIP.FEDEX, SHIP.USPS, SHIP.DHL, SHIP.PICKUP];
  }

  function isTrackingRequired(method) {
    return !!(method !== _orderConstants.default.SHIPPING_METHODS.PICKUP);
  }

  function initOrderNotify() {
    authTokenService.getHeaders().then(function (_ref) {
      var token = _ref.token,
          tenantId = _ref.tenantId;

      if (tenantId && token) {
        var notificationWorker = new $window.Worker('webWorkers/orderNotification.worker.js');
        notificationWorker.postMessage({
          tenant: tenantId,
          token: token,
          orderEndpoint: "".concat("https://sandbox.api-v2.volusion.com", "/").concat(settings.api.orders),
          storeEndpoint: "".concat("https://sandbox.api-v2.volusion.com", "/").concat(settings.api.storeInformation)
        });

        notificationWorker.onmessage = function (e) {
          switch (e.data.message) {
            case 'NOTIFY':
              notificationService.createOrderNotification(e.data.order, e.data.storeName);
              break;
            //no default
          }

          $rootScope.$broadcast('orders:updateCount', e.data.totalCount);
        };
      }
    });
  }

  function getCartImages(cartItems) {
    return (0, _map.default)(cartItems, function (item) {
      return {
        image: item.product.imageMetadata ? item.product.imageMetadata.imageLink.fullUri : '',
        badge: item.quantity > 1 ? item.quantity : ''
      };
    });
  }

  function getCustomerByEmail(email) {
    var options = {
      pageSize: 1,
      filter: "emailAddress eq ".concat(email)
    };
    return dataService.getAll(settings.api.customers, options).then(function (response) {
      if (response.items.length) {
        return response.items[0];
      }
    });
  }

  function getCustomerById(id) {
    return dataService.get(settings.api.customers, id).then(function (response) {
      return response;
    });
  }

  function isRegularDiscount(order) {
    var discountName = (0, _get.default)(order, 'cart.discount.name', '');
    return discountName !== '' && discountName.toUpperCase() !== CUSTOM.toUpperCase();
  }

  function isFixedCustomDiscount(order) {
    var discountName = (0, _get.default)(order, 'cart.discount.name', '');
    var discountType = (0, _get.default)(order, 'cart.discount.discountType', '');
    return discountName.toUpperCase() === CUSTOM.toUpperCase() && discountType.toUpperCase() === FIXED.toUpperCase();
  }

  function isPercentCustomDiscount(order) {
    var discountName = (0, _get.default)(order, 'cart.discount.name', '');
    var discountType = (0, _get.default)(order, 'cart.discount.discountType', '');
    return discountName.toUpperCase() === CUSTOM.toUpperCase() && discountType.toUpperCase() === PERCENT.toUpperCase();
  }

  function getDiscountDisplayLines(order) {
    var discounts = (0, _get.default)(order, 'cart.discounts', []);
    return discounts.map(function (_ref2) {
      var discount = _ref2.discount,
          discountAmount = _ref2.discountAmount;
      var isCustom = discount.name.toUpperCase() === CUSTOM.toUpperCase();
      var isFixed = discount.discountType.toUpperCase() === FIXED.toUpperCase();
      var isAutomatic = !discount.code;
      var displayName = isCustom ? CUSTOM.toUpperCase() : discount.code && discount.code.toUpperCase() || 'AUTOMATIC';
      var discountValue = isFixed ? "$".concat(discount.fixedPriceReduction.toFixed(2)) : "".concat(discount.percentagePriceReduction, "%");
      return {
        displayName: "".concat(displayName).concat(isCustom && !isFixed ? " (".concat(discountValue, ")") : ''),
        discountCode: discount.code,
        isAutomatic: isAutomatic,
        discountValue: discountValue,
        discountAmount: discountAmount
      };
    });
  }

  function getCombinedItemsDiscount(cartItems, itemsDiscountedPrices) {
    var cartTotal = cartItems.reduce(function (accumulator, currentValue) {
      return accumulator + currentValue.quantity * currentValue.product.price;
    }, 0);
    var discountedTotal = itemsDiscountedPrices.reduce(function (accumulator, currentValue, index) {
      var price = getDiscountedPrice(currentValue.discountedPrice, cartItems[index].product.price);
      return accumulator + cartItems[index].quantity * price;
    }, 0);
    var decimalPlaces = 2;
    return (cartTotal - discountedTotal).toFixed(decimalPlaces);
  }

  function updateDiscountedPrices(cartItems, currentDiscountedPrices) {
    return cartItems.map(function (item) {
      var quantity = item.quantity;
      var productVariantId = item.product.productVariantId || item.product.productVariants[0].id;
      var existingPriceItem = (0, _find.default)(currentDiscountedPrices, function (discountedPricesItem) {
        return discountedPricesItem.productVariantId === productVariantId;
      });
      var discountedPrice = existingPriceItem ? existingPriceItem.discountedPrice : null;
      var itemTotal = discountedPrice || discountedPrice === 0 ? discountedPrice * quantity : item.product.price * quantity;
      return {
        discountedPrice: discountedPrice,
        itemTotal: itemTotal,
        quantity: quantity,
        productVariantId: productVariantId,
        itemPrice: item.product.price
      };
    });
  }

  function getDiscountedPrice(price, fallback) {
    return price === 0 ? price : price || fallback;
  }

  function hasDiscountedPrices(discountedPrices) {
    var discountedItem = (0, _find.default)(discountedPrices, function (item) {
      return item.discountedPrice !== null;
    });
    return !!discountedItem;
  }

  function getDiscountedItemTotals(cartItems, itemDiscountedPrices) {
    var discountedPrices = (0, _cloneDeep.default)(itemDiscountedPrices);
    return discountedPrices.map(function (item, index) {
      var price = getDiscountedPrice(item.discountedPrice, cartItems[index].product.price);
      item.itemTotal = price * cartItems[index].quantity;
      return item;
    });
  }

  function basicDialogController(scopeVars) {
    return ["$scope", "$mdDialog", function DialogController($scope, $mdDialog) {
      // eslint-disable-line no-shadow
      'ngInject'; // eslint-disable-line lines-around-directive

      (0, _assign.default)($scope, scopeVars);

      $scope.closeDialog = function () {
        $mdDialog.hide();
      };
    }];
  }

  function createOrUpdateCustomDiscount() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$code = _ref3.code,
        code = _ref3$code === void 0 ? (0, _uuidV.default)().toUpperCase() : _ref3$code,
        customDiscountType = _ref3.customDiscountType,
        customDiscountAmount = _ref3.customDiscountAmount,
        currentDiscount = _ref3.currentDiscount;

    return launchDarklyService.getFeature('new-admin-features-enabled').then(function (launchDarklyResponse) {
      var newDiscountsEnabled = launchDarklyResponse.includes('discounts');
      var customDiscountTypes = {
        PERCENT: 'percent',
        FIXED: 'fixed'
      };

      if (newDiscountsEnabled) {
        var discountType = customDiscountType === customDiscountTypes.PERCENT ? customDiscountTypes.PERCENT : customDiscountTypes.FIXED;
        var discountAmount = Math.round(Number.parseFloat(customDiscountAmount) * 100);

        if (currentDiscount) {
          return discountsRESTService.updateDiscount(currentDiscount, discountAmount);
        }

        var discountREST = {
          discountStatus: 'active',
          discountClass: discountType,
          discountCode: code,
          startAt: new Date(Date.now() - 60000),
          name: 'Custom',
          requirements: {
            fakeId: {
              requirementType: 'uses',
              requirementScopes: {
                fakeId: {
                  entityType: 'storewide'
                }
              },
              boundary: {
                boundaryType: 'quantity',
                boundaryOperator: '$lte',
                boundaryValue: 1
              }
            }
          },
          targets: {
            fakeId: {
              targetScopes: {
                fakeId: {
                  entityType: 'subtotal'
                }
              },
              discountAmount: discountAmount,
              discountType: discountType
            }
          }
        };
        return discountsRESTService.create(discountREST);
      }

      var fixedAmount = 0;
      var percentageAmount = 0;

      if (customDiscountType === customDiscountTypes.PERCENT) {
        percentageAmount = Number.parseFloat(customDiscountAmount);
      } else {
        fixedAmount = Number.parseFloat(customDiscountAmount);
      }

      var discount = {
        code: code,
        isActive: true,
        fixedPriceReduction: fixedAmount,
        percentagePriceReduction: percentageAmount,
        discountType: customDiscountType,
        unlimited: true,
        unlimitedDuration: true,
        hasStartDateTime: false,
        hasEndDateTime: false,
        currentUsageCount: 0,
        totalUsageCount: 0,
        isHidden: true,
        scope: {
          entireStore: true
        },
        name: 'Custom'
      };
      return discountsService.create(discount);
    });
  }

  function tabulateAndCreateCustomDiscount(cartItems, discountedPrices, currentDiscount) {
    var totalDiscount = getCombinedItemsDiscount(cartItems, discountedPrices);
    var customDiscountType = 'fixed';
    var discountOptions = {
      customDiscountType: customDiscountType,
      customDiscountAmount: totalDiscount,
      currentDiscount: currentDiscount
    };
    return createOrUpdateCustomDiscount(discountOptions).then(function (discountResponse) {
      return {
        discountCode: discountResponse.code,
        discountType: 'custom',
        discount: discountResponse.discount
      };
    });
  }

  function isInventoryTracked(product) {
    return (0, _get.default)(product, 'productVariants[0].isInventoryTracked', false);
  }

  function isInvalidQuantity(order, index) {
    var qty = getItemQuantity(order, index);
    return !qty || !(0, _isInteger.default)(qty);
  }

  function isQuantityExceedingInventory(params) {
    var order = params.order,
        index = params.index,
        product = params.product,
        initialSkuQuantity = params.initialSkuQuantity;
    var qty = getItemQuantity(order, index);

    if (isInventoryTracked(product)) {
      var numberAvailable = getQuantityMoreAvailable(product, qty, initialSkuQuantity);

      if (numberAvailable < 0) {
        return true;
      }
    }

    return false;
  }

  function getItemQuantity(order, index) {
    return (0, _get.default)(order, "cart.items[".concat(index, "].quantity"));
  }

  function getQuantityMoreAvailable(product, quantity, initialSkuQuantity) {
    var initialQuantity = (0, _get.default)(initialSkuQuantity, product.sku, 0);
    return getProductInventory(product) + initialQuantity - quantity;
  }

  function getProductInventory(product) {
    return (0, _get.default)(product, 'productVariants[0].quantity', 0);
  }

  function parseCartError(errorResponse) {
    var message = {
      title: 'Problem editing order',
      body: '<p>Please try again later</p>'
    };
    var responseMessage = (0, _get.default)(errorResponse, 'data.message');

    if (responseMessage && (0, _startsWith.default)(responseMessage, MONGO_ERROR)) {
      try {
        var messageObj = JSON.parse(responseMessage.replace(MONGO_ERROR, ''));
        var code = messageObj['criteria.couponCode'];
        var formattedError = "<p>The discount ".concat(code, " has been deleted</p>");
        var nextStep = '<p><a href="/discounts/add">Add a new discount</a> with the same code.</p>';
        message.body = "".concat(formattedError).concat(nextStep);
      } catch (err) {
        console.log('parseCartError:', err); // eslint-disable-line no-console
      }

      return message;
    }

    if (responseMessage) {
      message.body = "<p>".concat(responseMessage, "</p>");
    }

    return message;
  }

  function mergeOrder(orderWithChargeChanges, orderWithItems) {
    var order = (0, _cloneDeep.default)(orderWithItems);
    var chargeProps = (0, _pick.default)(orderWithChargeChanges, ['authorizedAmount', 'authorizeNetTransactionId', 'isRefunded', 'paymentLifecycle', 'refundedAmount', 'revision', 'stripeRefunds', 'stripeEvents']);
    (0, _assign.default)(order, chargeProps);
    return order;
  }

  function showErrorModal(error) {
    return $translate(['ERROR.GENERAL_FAILURE_ERROR', 'ERROR.GENERAL_OK_BUTTON', 'ERROR.INVALID_PRODUCT']).then(function (translations) {
      var errorMessage = getErrorMessage(error, translations);
      return $mdDialog.show($mdDialog.alert().title('Error').textContent(errorMessage).ariaLabel(errorMessage).ok(translations['ERROR.GENERAL_OK_BUTTON']).clickOutsideToClose(true));
    });
  }

  function getErrorMessage(error, translations) {
    var errmsg = translations['ERROR.GENERAL_FAILURE_ERROR'];
    var errItem = getErrItem(error);

    if (errItem) {
      errmsg = errItem.message;

      if (isPrematureRefundError(errItem)) {
        errmsg = "Sorry, could not issue refund yet - the original charge is still processing.\n                        This may take up to 24 hours after payment has been accepted.\n                        Please wait 24 hours and edit the order again.";
      }
    } else if (error.data && error.data.message) {
      if (error.data.message.includes('"sku" must be an object')) {
        errmsg = translations['ERROR.INVALID_PRODUCT'];
      } else if (error.data.message.includes('User authentication failed due to invalid authentication')) {
        // general Auth.net CC tokenization failure - likely a problem with Auth.net's constants
        errmsg = "Authorize.net failed to encrypt the credit card. There may be an issue\n                        with Authorize.net's configuration with Volusion Payments. Please contact customer support.";
      } else if (error.data.message.includes('"postalCode" is required, path: postalCode')) {
        errmsg = 'An address with a zipcode is required.';
      } else {
        errmsg = error.data.message;
      }
    }

    return errmsg;
  }

  function getErrItem(error) {
    return (0, _get.default)(error, 'data.items[0]', null);
  }

  function isPrematureRefundError(errItem) {
    return !!(errItem && errItem.message === 'Failed to refund transaction.' && errItem.additionalErrorData && errItem.additionalErrorData.length > 1 && errItem.additionalErrorData[0].name === 'AuthorizeDotNetCode' && errItem.additionalErrorData[0].value === 'E00027' && errItem.additionalErrorData[1].name === 'AuthorizeDotNetMessage' && errItem.additionalErrorData[1].value === 'The transaction was unsuccessful.');
  }

  function getRequestId() {
    var REQUEST_ID_CHAR_LIMIT = 20;
    return (0, _uuidV.default)().replace(/-/g, '').substring(0, REQUEST_ID_CHAR_LIMIT);
  }

  function isFullyRefunded(order) {
    var grandTotal = (0, _get.default)(order, 'grandTotal', 0);
    var authorizedAmount = (0, _get.default)(order, 'authorizedAmount', grandTotal);

    if (!authorizedAmount) {
      return false;
    }

    return authorizedAmount - order.refundedAmount === 0;
  }

  function getAdjustmentAmount(order) {
    if (!(0, _get.default)(order, 'paymentLifecycle')) return 0;

    var toAdjustment = function toAdjustment(event) {
      if (event.eventType === 'AdjustmentCharge') return event.chargeAmount;
      return 0;
    };

    var add = function add(acc, val) {
      return acc + val;
    };

    return order.paymentLifecycle.map(toAdjustment).reduce(add, 0);
  }
  /*
  * We have a property called refundedFromOrder set to true for
  * orders refunded by choosing the Mark Order as Returned. Only those
  * refunds should be substracted from the grandTotal.
  */


  function getRefund(order) {
    var refundedFromOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!(0, _get.default)(order, 'paymentLifecycle')) return 0;

    var toAdjustment = function toAdjustment(event) {
      if (event.eventType === 'refund' && event.refundedFromOrder === refundedFromOrder) return event.refundAmount;
      return 0;
    };

    var add = function add(acc, val) {
      return acc + val;
    };

    return order.paymentLifecycle.map(toAdjustment).reduce(add, 0);
  }

  function getRefundFromOrderCancelled(order) {
    return getRefund(order, true);
  }

  function getRefundFromProductUpdates(order) {
    return getRefund(order);
  }

  function getAdjustedGrandTotal(order) {
    return isFullyRefunded(order) ? 0 : order.cart.grandTotal - getRefundFromOrderCancelled(order);
  }

  function getOriginalAmount(order) {
    var total = order.grandTotal || order.cart.grandTotal;
    return total - getAdjustmentAmount(order) + getRefundFromProductUpdates(order);
  }

  function isTestOrder(order) {
    return order.authorizeNetTransactionId === '0';
  }

  function getNextOrderId(order, filter, sort) {
    var _sort$split = sort.split(' '),
        _sort$split2 = _slicedToArray(_sort$split, 2),
        sortByField = _sort$split2[0],
        sortDirection = _sort$split2[1];

    var filterBy = filter && buildFilter(filter);
    var comparator = sortDirection === 'desc' ? 'lt' : 'gt';
    var value = order[sortByField];
    if (sortByField === 'status') value = "\"".concat(value, "\"");
    if (sortByField === 'grandTotal') value *= 100;
    var nextFilter = "\n                ((".concat(sortByField, " ").concat(comparator, " ").concat(value, ") or\n                (\n                    ").concat(sortByField, " eq ").concat(value, " and\n                    id ").concat(sortDirection === 'asc' ? 'gt' : 'lt', " \"").concat(order.id, "\"\n                ))\n            ");
    if (filterBy) nextFilter = "(".concat(filterBy, ") and ").concat(nextFilter);
    var sortBy = "".concat(sortByField, " ").concat(sortDirection, ", id ").concat(sortDirection);
    return dataService.getAll(settings.api.orders, {
      filter: nextFilter.replace(/\s+/g, ' ').replace(/\n/g, '').trim(),
      sortBy: sortBy,
      pageSize: 1
    }).then(function (o) {
      return (0, _get.default)(o.items, '[0].id', null);
    });
  }

  function getPreviousOrderId(order, filter, sort) {
    var _sort$split3 = sort.split(' '),
        _sort$split4 = _slicedToArray(_sort$split3, 2),
        sortByField = _sort$split4[0],
        sortDirection = _sort$split4[1];

    var reverseSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    var filterBy = filter && buildFilter(filter);
    var comparator = sortDirection === 'desc' ? 'gt' : 'lt';
    var value = order[sortByField];
    if (sortByField === 'status') value = "\"".concat(value, "\"");
    if (sortByField === 'grandTotal') value *= 100;
    var previousFilter = "\n                ((".concat(sortByField, " ").concat(comparator, " ").concat(value, ") or\n                (\n                    ").concat(sortByField, " eq ").concat(value, " and\n                    id ").concat(sortDirection === 'asc' ? 'lt' : 'gt', " \"").concat(order.id, "\"\n                ))\n            ");
    if (filterBy) previousFilter = "(".concat(filterBy, ") and ").concat(previousFilter);
    var sortBy = "".concat(sortByField, " ").concat(reverseSortDirection, ", id ").concat(reverseSortDirection);
    return dataService.getAll(settings.api.orders, {
      filter: previousFilter.replace(/\s+/g, ' ').replace(/\n/g, '').trim(),
      sortBy: sortBy,
      pageSize: 1
    }).then(function (o) {
      return (0, _get.default)(o.items, '[0].id', null);
    });
  }

  function resendOrderConfirmationEmail(id) {
    return dataService.create("".concat(settings.api.orders, "/").concat(id, "/sendEmail"), {
      type: 'orderConfirmation'
    });
  }

  function resendShippingConfirmationEmail(id) {
    return dataService.create("".concat(settings.api.orders, "/").concat(id, "/sendEmail"), {
      type: 'shippingConfirmation'
    });
  }

  function isRefundWaitingPeriodPassed(order) {
    var waitingPeriodInHours = 24;
    return (0, _moment.default)().diff(order.createdOn, 'hours') >= waitingPeriodInHours;
  }

  function handleTaxProviderMessageEvent(event, actionString) {
    if (event.taxProviderMessage) {
      var taxProviderMessage = event.taxProviderMessage.slice(0, 1).toLowerCase() + event.taxProviderMessage.slice(1);
      var modalContent = "\n                    The ".concat(actionString, " was successful. Unfortunately, \n                    ").concat(taxProviderMessage, "\n                    Please contact Avalara for further assistance.\n                    ");
      return $mdDialog.show($mdDialog.alert().title('Avalara Notice').textContent(modalContent).ariaLabel(modalContent).ok('OK').clickOutsideToClose(true));
    }

    return $q.resolve();
  }
}]).name;
exports.OrderServiceModule = OrderServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 379 */,
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerModule = void 0;

var _spinner = _interopRequireDefault(__webpack_require__(1412));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpinnerModule = angular.module('app.components.spinner', []).component('spinner', {
  template: _spinner.default
}).name;
exports.SpinnerModule = SpinnerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.ModalContent = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

var _omit = _interopRequireDefault(__webpack_require__(197));

var _thread = __webpack_require__(64);

var _Modal = _interopRequireDefault(__webpack_require__(276));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: auto;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalContent = (0, _styledComponents.default)(_thread.Card).withConfig({
  displayName: "Modal__ModalContent",
  componentId: "sc-1jhqgzx-0"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);box-shadow:0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12);margin:0;max-width:", ";width:auto;max-height:90%;overflow:auto;width:90%;", ""], function (props) {
  return props.maxWidth || '900px';
}, _thread.media.md(_templateObject()));
exports.ModalContent = ModalContent;

var Modal = function Modal(props) {
  return _react.default.createElement(_Modal.default, (0, _omit.default)(props, 'maxWidth'), _react.default.createElement(ModalContent, {
    maxWidth: props.maxWidth
  }, props.children));
};

exports.Modal = Modal;
Modal.propTypes = {
  children: _propTypes.default.node,
  maxWidth: _propTypes.default.string
};
Modal.defaultProps = {
  maxWidth: '900px'
};

/***/ }),
/* 386 */,
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiscountsServiceModule = void 0;

var _each = _interopRequireDefault(__webpack_require__(162));

var _find = _interopRequireDefault(__webpack_require__(66));

var _get = _interopRequireDefault(__webpack_require__(34));

var _intersectionBy = _interopRequireDefault(__webpack_require__(1323));

var _moment = _interopRequireDefault(__webpack_require__(74));

var _reduce = _interopRequireDefault(__webpack_require__(160));

var _settings = __webpack_require__(15);

var _categories = __webpack_require__(100);

var _data = __webpack_require__(11);

var _search = __webpack_require__(120);

var _segment = __webpack_require__(58);

var _discountsAnalytics = __webpack_require__(1324);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DiscountsServiceModule = angular.module('app.services.data.discountsService', [_data.DataServiceModule, _settings.AppSettingsModule, _search.SearchServiceModule, _categories.CategoryServiceModule, _discountsAnalytics.DiscountsAnalyticsServiceModule, _segment.SegmentServiceModule]).service('discountsService', ["$q", "dataService", "settings", "searchService", "categoryService", "$window", "$filter", "discountsAnalyticsService", function ($q, dataService, settings, searchService, categoryService, $window, $filter, discountsAnalyticsService) {
  return {
    create: create,
    getDiscount: getDiscount,
    getDiscounts: getDiscounts,
    getDiscountDuration: getDiscountDuration,
    getDiscountMetricsFromOrders: getDiscountMetricsFromOrders,
    getDiscountStatus: getDiscountStatus,
    getMetrics: getMetrics,
    getOrderMetricsForDiscount: getOrderMetricsForDiscount,
    getScopeDataForDiscount: getScopeDataForDiscount,
    getUsesLeft: getUsesLeft,
    isCodeTaken: isCodeTaken,
    removeDiscount: removeDiscount,
    save: save,
    search: search,
    trackSegmentEvent: trackSegmentEvent,
    updateDiscountCodeCounts: updateDiscountCodeCounts,
    getOrdersByDiscountCode: getOrdersByDiscountCode,
    getOrdersByDiscountCodes: getOrdersByDiscountCodes,
    transformDiscount: transformDiscount
  };

  function create(discount) {
    return dataService.create(settings.api.discounts, discount).then(function (response) {
      var savedDiscount = transformDiscount(response);
      discountsAnalyticsService.sendDiscountCreateEvent(savedDiscount);
      return savedDiscount;
    });
  }

  function save(discount) {
    return dataService.save(settings.api.discounts, discount.id, discount).then(function (response) {
      var savedDiscount = transformDiscount(response);
      discountsAnalyticsService.sendDiscountUpdateEvent(savedDiscount);
      return savedDiscount;
    });
  }

  function getDiscounts() {
    var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var queryFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var sortBy = arguments.length > 3 ? arguments[3] : undefined;
    var startIndex = 0;

    if (pageSize) {
      startIndex = ((page || 1) - 1) * pageSize;
    }

    return dataService.getAll(settings.api.discounts, {
      startIndex: startIndex,
      pageSize: pageSize,
      filter: queryFilter,
      sortBy: sortBy
    }).then(function (discounts) {
      discounts.items = discounts.items.map(transformDiscount);
      return discounts;
    });
  }

  function search() {
    var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var sortBy = arguments.length > 1 ? arguments[1] : undefined;
    var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
    var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return dataService.getAll(settings.api.discounts, {
      startIndex: page * pageSize,
      pageSize: pageSize,
      search: searchString,
      sortBy: sortBy
    }).then(function (discounts) {
      discounts.items = discounts.items.map(transformDiscount);
      return discounts;
    });
  }

  function getDiscountMetricsFromOrders() {
    return dataService.getAll(settings.api.discountMetrics).then(function (discountMetrics) {
      return discountMetrics;
    });
  }

  function transformDiscount(discount) {
    discount.status = getDiscountStatus(discount);
    discount.duration = getDiscountDuration(discount);
    discount.usesLeft = getUsesLeft(discount);
    discount.discountValue = discount.discountType === 'percent' ? "".concat(discount.percentagePriceReduction, "%") : "".concat($filter('currency')(discount.fixedPriceReduction));
    return discount;
  }

  function getDiscount(id) {
    return dataService.get(settings.api.discounts, id).then(function (response) {
      return transformDiscount(response);
    });
  }

  function getDiscountDuration(discount) {
    var duration;

    if (discount.hasStartDateTime && discount.hasEndDateTime) {
      var diff = (0, _moment.default)(discount.endDateTime).diff(discount.startDateTime, 'days');
      duration = "".concat(diff, " day").concat(diff === 1 ? '' : 's');
    } else {
      duration = 'Unlimited';
    }

    return duration;
  }

  function discountIsReady(discount, today) {
    var hasNotReachedStartDate = discount.hasStartDateTime && discount.hasEndDateTime && today.isBefore(discount.startDateTime);
    return discount.isActive && hasNotReachedStartDate;
  }

  function discountIsLive(discount, today) {
    return discount.isActive && discountUsageIsLive(discount) && discountDurationIsLive(discount, today);
  }

  function discountUsageIsLive(discount) {
    var hasUsesLeft = discount.usageLimit - discount.currentUsageCount > 0;
    return !discount.unlimited && hasUsesLeft || discount.unlimited;
  }

  function discountDurationIsLive(discount, today) {
    var hasUnlimitedDuration = discount.unlimitedDuration || !discount.hasStartDateTime && !discount.hasEndDateTime;
    var todayIsWithinDateRange = discount.hasStartDateTime && discount.hasEndDateTime && today.isBetween(discount.startDateTime, discount.endDateTime) || today.isSame(discount.startDateTime);
    return hasUnlimitedDuration || todayIsWithinDateRange;
  }

  function discountHasEnded(discount, today) {
    var dateExpired = today.isAfter(discount.endDateTime);
    var usageLimitExpired = !discount.unlimited && discount.usageLimit - discount.currentUsageCount <= 0;
    return discount.isActive && (dateExpired || usageLimitExpired);
  }

  function getDiscountStatus(discount) {
    var status = {};
    var statusDesc = 'This discount ';
    var today = (0, _moment.default)();

    if (!discount.isActive) {
      statusDesc += 'is disabled';
      status = {
        code: 'disabled',
        text: 'Disabled'
      };
    } else if (discountIsReady(discount, today)) {
      var daysUntilStart = today.to(discount.startDateTime);
      statusDesc += "will start ".concat(daysUntilStart);

      if (!discount.unlimited) {
        statusDesc += ", and can be used ".concat(discount.usageLimit, " time").concat(discount.usageLimit > 1 ? 's' : '');
      }

      status = {
        code: 'ready',
        text: 'Ready'
      };
    } else if (discountIsLive(discount, today)) {
      var daysUntilEnd = today.to(discount.endDateTime);
      var diff = discount.usageLimit - discount.currentUsageCount;
      var remainingUses = diff < 0 ? 0 : diff;
      statusDesc += 'is live';
      if (!discount.unlimitedDuration && discount.unlimited) statusDesc += ', and';else if (discount.unlimitedDuration && !discount.unlimited) statusDesc += '';else if (!discount.unlimitedDuration && !discount.unlimited) statusDesc += ', ';
      if (!discount.unlimitedDuration) statusDesc += " will end ".concat(daysUntilEnd);

      if (!discount.unlimited) {
        statusDesc += ", and can be used ".concat(remainingUses, " more time").concat(remainingUses > 1 ? 's' : '');
      }

      status = {
        code: 'live',
        text: 'Live'
      };
    } else if (discountHasEnded(discount, today)) {
      var daysFromEnd = today.to(discount.endDateTime);
      statusDesc += discount.unlimitedDuration ? 'reached its usage limit' : "ended ".concat(daysFromEnd);
      status = {
        code: 'ended',
        text: 'Ended'
      };
    }

    status.desc = statusDesc;
    return status;
  }

  function isCodeTaken(code) {
    return getDiscounts().then(function (discounts) {
      return angular.isDefined((0, _find.default)(discounts.items, {
        code: code
      }));
    });
  }

  function removeDiscount(discount) {
    return dataService.remove(settings.api.discounts, discount.id);
  }

  function getUsesLeft(discount) {
    if (discount.unlimited) {
      return 'Unlimited';
    } else if (discount.usageLimit > discount.currentUsageCount) {
      return discount.usageLimit - discount.currentUsageCount;
    }

    return 'None remaining';
  }

  function getMetrics() {
    return Promise.all([getDiscounts(1, 1), getDiscounts(1, 1, {
      isActive: true
    }), getDiscounts(1, 1, {
      isActive: false
    }), getDiscountMetricsFromOrders()]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 4),
          allDiscountsMetrics = _ref2[0],
          activeMetrics = _ref2[1],
          inactiveMetrics = _ref2[2],
          orders = _ref2[3];

      var totalAmountSaved = (0, _get.default)(orders, '[0].totalDiscountAmount', 0) / 100;
      var totalDiscountUses = (0, _get.default)(orders, '[0].noOfDiscounts', 0);
      return {
        totalAmountSaved: totalAmountSaved,
        totalDiscountUses: totalDiscountUses,
        activeCount: activeMetrics.total,
        inactiveCount: inactiveMetrics.total,
        totalCount: allDiscountsMetrics.total
      };
    }).catch(function () {
      return {
        activeCount: 0,
        inactiveCount: 0,
        totalCount: 0,
        totalDiscountUses: 0,
        totalAmountSaved: 0
      };
    });
  }

  function getOrderMetricsForDiscount(discountCode) {
    return getOrdersByDiscountCode(discountCode).then(function (orders) {
      return {
        code: discountCode,
        orderCount: orders.length,
        totalOrderAmount: (0, _reduce.default)(orders, function (total, order) {
          return total + order.grandTotal || 0;
        }, 0),
        totalDiscountAmount: (0, _reduce.default)(orders, function (total, order) {
          return total + order.cart.discountAmount || 0;
        }, 0)
      };
    });
  }
  /* eslint-disable no-useless-escape */


  function getOrdersByDiscountCode(discountCode) {
    var searchOptions = {
      facets: '*',
      filters: "cart.discount.code:\"".concat(discountCode, "\" AND NOT status:\"Canceled\" AND NOT status:\"Refunded\"")
    };
    return searchService.search('orders', '', searchOptions, false).then(function (response) {
      return response.hits;
    });
  }
  /* eslint-enable no-useless-escape */

  /* eslint-disable no-useless-escape */


  function getOrdersByDiscountCodes(discountCodesList) {
    if (!angular.isArray(discountCodesList) || discountCodesList.length === 0) {
      return $q.reject('Pass in an array of discount codes');
    }

    var discountCodeFacetFilter = discountCodesList.map(function (discountCode) {
      return "cart.discount.code:\"".concat(discountCode, "\"");
    }).join(' OR ');
    var searchOptions = {
      facets: '*',
      filters: "(".concat(discountCodeFacetFilter, ") AND NOT status:\"Canceled\" AND NOT status:\"Refunded\"")
    };
    return searchService.search('orders', '', searchOptions, false).then(function (response) {
      return response.hits;
    });
  }
  /* eslint-enable no-useless-escape */


  function updateDiscountCodeCounts() {
    return getMetrics();
  }

  function trackSegmentEvent() {
    return $q.resolve(true);
  }

  function getScopeDataForDiscount(discount) {
    var promises = [];
    var selectedProductsCount = 0;

    if (discount.scope && discount.scope.items && discount.scope.items.length > 0) {
      var selectedProductIds = discount.scope.items.filter(function (item) {
        return item.type === 'product';
      }).map(function (item) {
        return item.id;
      });
      var selectedCategoryIds = discount.scope.items.filter(function (item) {
        return item.type === 'category';
      }).map(function (item) {
        return {
          id: item.id
        };
      });

      if (angular.isArray(selectedProductIds) && selectedProductIds.length > 0) {
        promises.push(searchService.getManyByIds('products', selectedProductIds).then(function (_ref3) {
          var products = _ref3.results;
          selectedProductsCount += products.length;
          (0, _each.default)(discount.scope.items, function (item) {
            if (item.type === 'product') {
              item.data = (0, _find.default)(products, {
                id: item.id
              });
            }
          });
          return products;
        }));
      }

      if (angular.isArray(selectedCategoryIds) && selectedCategoryIds.length > 0) {
        promises.push(categoryService.getCategoryTree().then(categoryService.flattenCategories).then(function (categories) {
          var selectedCategories = (0, _intersectionBy.default)(categories, selectedCategoryIds, 'id');
          var category;
          (0, _each.default)(discount.scope.items, function (item) {
            if (item.type === 'category') {
              category = (0, _find.default)(selectedCategories, {
                id: item.id
              });
              item.data = category;
              selectedProductsCount += category.productCount;
            }
          });
          return selectedCategories;
        }));
      }

      return $q.all(promises).then(function () {
        return {
          discount: discount,
          selectedProductsCount: selectedProductsCount
        };
      });
    }

    return $q.resolve({
      discount: discount,
      selectedProductsCount: 0
    });
  }
}]).name;
exports.DiscountsServiceModule = DiscountsServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 388 */,
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidateEmailDirectiveModule = void 0;
var ValidateEmailDirectiveModule = angular.module('app.directives.validateEmail', []).directive('vlnValidateEmail', function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModelCtrl) {
      ngModelCtrl.$validators.validEmail = function (modelValue, viewValue) {
        var value = modelValue || viewValue;
        if (!value) return true;
        return /.+@.+\.[^\s]+/.test(value);
      };
    }
  };
}).name;
exports.ValidateEmailDirectiveModule = ValidateEmailDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(__webpack_require__(234));

var _ApiConfig = _interopRequireDefault(__webpack_require__(235));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Api =
/*#__PURE__*/
function () {
  function Api() {
    _classCallCheck(this, Api);
  }

  _createClass(Api, [{
    key: "delete",
    value: function _delete(endpoint, body, addAuthToken, useOldTenantHeader) {
      return _axios.default.delete("".concat("https://sandbox.api-v2.volusion.com").concat(endpoint), _objectSpread({}, _ApiConfig.default.getHttpConfig(addAuthToken, useOldTenantHeader), {
        data: body
      })).then(this.handleSuccess);
    }
  }, {
    key: "get",
    value: function get(endpoint, addAuthToken, useOldTenantHeader, options) {
      return _axios.default.get("".concat("https://sandbox.api-v2.volusion.com").concat(endpoint), _ApiConfig.default.getHttpConfig(addAuthToken, useOldTenantHeader, options)).then(this.handleSuccess);
    }
  }, {
    key: "post",
    value: function post(endpoint, body, addAuthToken, useOldTenantHeader) {
      return _axios.default.post("".concat("https://sandbox.api-v2.volusion.com").concat(endpoint), body, _ApiConfig.default.getHttpConfig(addAuthToken, useOldTenantHeader)).then(this.handleSuccess);
    }
  }, {
    key: "put",
    value: function put(endpoint, body, addAuthToken, useOldTenantHeader) {
      return _axios.default.put("".concat("https://sandbox.api-v2.volusion.com").concat(endpoint), body, _ApiConfig.default.getHttpConfig(addAuthToken, useOldTenantHeader)).then(this.handleSuccess);
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(response) {
      return response.data;
    }
  }]);

  return Api;
}();

var _default = new Api();

exports.default = _default;

/***/ }),
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LaunchAppExtensionPreviewServiceModule = void 0;

var _appExtensionPreview = __webpack_require__(963);

var _appExtensionConfirmInstall = __webpack_require__(1273);

var _appExtensionUpgradePlan = __webpack_require__(1365);

var _apps = __webpack_require__(76);

var _subscription = __webpack_require__(42);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LaunchAppExtensionPreviewServiceModule = angular.module('app.components.appExtensionPreview.launchAppExtensionModalService', ['ngMaterial', _appExtensionPreview.AppExtensionPreviewModule, _appExtensionConfirmInstall.AppExtensionConfirmInstallModule, _appExtensionUpgradePlan.AppExtensionUpgradePlanModule, _apps.AppsServiceModule, _subscription.SubscriptionServiceModule]).service('launchAppExtensionModalService', ["$mdDialog", "$q", "appsService", "subscriptionsService", function ($mdDialog, $q, appsService, subscriptionsService) {
  return {
    launchPreview: launchPreview,
    launchConfirmInstall: launchConfirmInstall,
    launchUpgradePlan: launchUpgradePlan
  };

  function launchModal(options) {
    return $mdDialog.show({
      clickOutsideToClose: true,
      template: "\n                    <md-dialog class=\"".concat(options.cssClass, "\">\n                        ").concat(options.template, "\n                    </md-dialog>\n                "),
      locals: {
        app: options.app,
        isInstalled: options.isInstalled
      },
      controller: ["$scope", "app", "isInstalled", function controller($scope, app, isInstalled) {
        'ngInject';

        $scope.app = app;
        $scope.isInstalled = isInstalled || false;
      }]
    });
  }

  function launchPreview(type, app, isInstalled) {
    var modalPromise = launchModal({
      cssClass: 'modal--appExtension-preview',
      template: "\n                    <app-extension-preview\n                        layout=\"column\"\n                        app=\"app\"\n                        app-type=\"".concat(type, "\"\n                        is-installed=\"isInstalled\">\n                    </app-extension-preview>\n                "),
      app: app,
      isInstalled: isInstalled
    });
    return $q.all([subscriptionsService.getSubscription(), appsService.getPurchasedApps(), modalPromise]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          subscription = _ref2[0],
          installedApps = _ref2[1];

      if (!isInstalled && subscriptionsService.appPlans[subscription.plan.name]) {
        var maxAppCount = subscriptionsService.appPlans[subscription.plan.name].maxInstalledApps;
        angular.element('body').addClass('data-plans--alternate');

        if (installedApps.length >= maxAppCount) {
          return launchUpgradePlan(type, app).catch(function () {});
        }
      }

      return launchConfirmInstall(type, app, isInstalled);
    });
  }

  function launchConfirmInstall(type, app, isInstalled) {
    return launchModal({
      cssClass: 'modal--appExtension-confirm-install',
      template: "\n                    <app-extension-confirm-install\n                        layout=\"column\"\n                        app=\"app\"\n                        app-type=\"".concat(type, "\"\n                        is-installed=\"isInstalled\">\n                    </app-extension-confirm-install>\n                "),
      app: app,
      isInstalled: isInstalled
    });
  }

  function launchUpgradePlan(type, app) {
    return launchModal({
      cssClass: 'modal--appExtension-upgrade-plan',
      template: "\n                    <app-extension-upgrade-plan\n                        layout=\"column\"\n                        app=\"app\"\n                        app-type=\"".concat(type, "\"/>\n                "),
      app: app
    });
  }
}]).name;
exports.LaunchAppExtensionPreviewServiceModule = LaunchAppExtensionPreviewServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImagesServiceModule = void 0;

var _map = _interopRequireDefault(__webpack_require__(75));

var _union = _interopRequireDefault(__webpack_require__(422));

var _settings = __webpack_require__(15);

var _subscription = __webpack_require__(42);

var _data = __webpack_require__(11);

var _search = __webpack_require__(120);

var _storeInformation = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagesServiceModule = angular.module('app.services.data.imagesService', [_data.DataServiceModule, _settings.AppSettingsModule, _search.SearchServiceModule, _storeInformation.StoreInformationServiceModule, _subscription.SubscriptionServiceModule]).service('imagesService', ["dataService", "settings", "$q", "searchService", "subscriptionsService", function (dataService, settings, $q, searchService, subscriptionsService) {
  var saveImage = function saveImage(image) {
    return dataService.create(settings.api.images, {
      file: image
    });
  };

  var saveImages = function saveImages(images) {
    var promises = (0, _map.default)(images, function (image) {
      return saveImage(image);
    });
    return $q.all(promises).then(function (data) {
      return data;
    });
  };

  var populateImageLibraryFromIndustry = function populateImageLibraryFromIndustry(industry) {
    return dataService.save(settings.api.populateLibrary, industry);
  };

  var updateImage = function updateImage(image) {
    return dataService.save(settings.api.images, image.id, image);
  };

  var updateTags = function updateTags(images, tagsToAdd) {
    var promises = (0, _map.default)(images, function (image) {
      image.tags = (0, _union.default)(image.tags, tagsToAdd);
      return updateImage(image);
    });
    return $q.all(promises).then(function (data) {
      return data;
    });
  };

  var create = function create(image) {
    return dataService.create(settings.api.images, image);
  };

  var removeImage = function removeImage(image) {
    return dataService.remove(settings.api.images, image.id);
  };

  var removeImages = function removeImages(images) {
    var promises = (0, _map.default)(images, function (image) {
      return removeImage(image);
    });
    return $q.all(promises);
  };

  var getImage = function getImage(id) {
    return dataService.get(settings.api.images, id);
  };

  var getImages = function getImages(page, count, sort, options) {
    options = options || {};
    page = page || 1;
    count = count || 12;
    options.pagesize = count;
    options.startindex = (page - 1) * count;

    if (sort && sort.length) {
      options.sortby = sort[0].replace(' ', '+');
    }

    return dataService.getAll(settings.api.images, options);
  };

  var getImageLinks = function getImageLinks() {
    return dataService.getAll(settings.api.imageLinks);
  };

  var buildAlgoliaTagString = function buildAlgoliaTagString(tags) {
    var tagString = '';

    if (tags.length > 0) {
      tagString += '(';
      angular.forEach(tags, function (tag, key) {
        tagString += tag;

        if (key < tags.length - 1) {
          tagString += ',';
        }
      });
      tagString += ')';
    }

    return tagString;
  };

  var getImagesFromAlgolia = function getImagesFromAlgolia(tags, page, count) {
    return searchService.search('imagelinks', null, {
      tagFilters: buildAlgoliaTagString(tags),
      hitsPerPage: count,
      page: page
    }, false).then(function (data) {
      return data;
    });
  };

  function getImageLimit() {
    return subscriptionsService.getSubscription().then(function (subscription) {
      return subscription.features.imageLimit;
    });
  }

  return {
    saveImage: saveImage,
    saveImages: saveImages,
    create: create,
    getImage: getImage,
    getImages: getImages,
    getImagesFromAlgolia: getImagesFromAlgolia,
    removeImage: removeImage,
    removeImages: removeImages,
    updateImage: updateImage,
    updateTags: updateTags,
    getImageLimit: getImageLimit,
    populateImageLibraryFromIndustry: populateImageLibraryFromIndustry,
    getImageLinks: getImageLinks
  };
}]).name;
exports.ImagesServiceModule = ImagesServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorefrontCacheServiceModule = void 0;

var _data = __webpack_require__(11);

var _settings = __webpack_require__(15);

var _launchDarkly = __webpack_require__(30);

var StorefrontCacheServiceModule = angular.module('app.services.utilities.storefrontCacheService', [_settings.AppSettingsModule, _data.DataServiceModule, _launchDarkly.LaunchDarklyServiceModule]).factory('storefrontCacheService', ["settings", "dataService", "launchDarklyService", function (settings, dataService, launchDarklyService) {
  return {
    refresh: refresh
  };

  function refresh(resource) {
    return launchDarklyService.getFeature('remove-theme-versioning').then(function (getsFeature) {
      if (getsFeature) {
        return dataService.create(settings.api.refreshStorefrontCache, {
          contents: resource
        });
      }
    });
  }
}]).name;
exports.StorefrontCacheServiceModule = StorefrontCacheServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StripHtmlFilterModule = void 0;

var _striptags = _interopRequireDefault(__webpack_require__(1322));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StripHtmlFilterModule = angular.module('app.filters.stripHtmlFilter', []).filter('stripHTML', function () {
  return function (value) {
    var allowedTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    value = value === undefined || value === null ? '' : value;
    return (0, _striptags.default)(value, allowedTags.join(''));
  };
}).name;
exports.StripHtmlFilterModule = StripHtmlFilterModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 408 */,
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSVReaderService = void 0;
var CSVReaderService = angular.module('app.services.utilities.csvReader', []).factory('csvReader', ["$q", "$window", function ($q, $window) {
  var getCsvData = function getCsvData(file) {
    var deferred = $q.defer();

    if (angular.isUndefined(file)) {
      return $q.reject('Please pass a valid file');
    }

    if (angular.isUndefined($window.FileReader)) {
      return $q.reject('Browser does not support FileReader API');
    }

    var fileReader = new $window.FileReader();
    fileReader.addEventListener('progress', function (e) {
      if (e.lengthComputable) {
        var percentage = Math.round(e.loaded * 100 / e.total);
        deferred.notify(percentage);
      }
    });
    fileReader.addEventListener('load', function () {
      var cleanedDataStream = fileReader.result.replace(/.*;base64,/, '');
      deferred.resolve(cleanedDataStream);
    });
    fileReader.readAsDataURL(file);
    return deferred.promise;
  };

  return {
    getCsvData: getCsvData
  };
}]).name;
exports.CSVReaderService = CSVReaderService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _OnboardingService = _interopRequireDefault(__webpack_require__(1023));

var _OptimizelyStore = _interopRequireDefault(__webpack_require__(525));

var _onboardingData = __webpack_require__(1043);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var OnboardingStore =
/*#__PURE__*/
function () {
  function OnboardingStore() {
    _classCallCheck(this, OnboardingStore);

    this.defaultState = {
      tasks: {
        completed: {},
        locked: {}
      },
      hotspots: {
        completed: {}
      }
    };
  }

  _createClass(OnboardingStore, [{
    key: "getState",
    value: function getState(bypassCache) {
      var _this = this;

      return Promise.resolve().then(function () {
        if (_this.state && !bypassCache) {
          return _this.state;
        }

        if (_this.pendingRequest) {
          return _this.pendingRequest;
        }

        _this.pendingRequest = _OnboardingService.default.getOnboardingData().then(function (response) {
          return _this.setState(response.data);
        });
        return _this.pendingRequest;
      });
    }
  }, {
    key: "setState",
    value: function setState(state) {
      var newState = state.tasks ? state : _objectSpread({}, this.defaultState);
      this.state = newState;
      return this.state;
    }
  }, {
    key: "isHotspotAreaCompleted",
    value: function isHotspotAreaCompleted(areaId) {
      if (!this.state.hotspots) {
        return false;
      }

      if (!_onboardingData.hotspotAreas[areaId]) {
        return false;
      }

      for (var i = 0; i < _onboardingData.hotspotAreas[areaId].hotspots.length; i += 1) {
        var id = _onboardingData.hotspotAreas[areaId].hotspots[i];

        if (!this.state.hotspots.completed[id]) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "dismissHotspot",
    value: function dismissHotspot(hotspotId) {
      var _this2 = this;

      return _OnboardingService.default.dismissHotspot(hotspotId).then(function (updatedState) {
        return _this2.setState(updatedState.data);
      }).then(function () {
        var areaId = hotspotId.split('.')[0];

        if (_this2.isHotspotAreaCompleted(areaId)) {
          _this2.completeTask(_onboardingData.hotspotAreas[areaId].taskName);
        }
      });
    }
  }, {
    key: "completeTask",
    value: function completeTask(taskId) {
      var _this3 = this;

      return this.getState().then(function (state) {
        if (!state.tasks.completed[taskId]) {
          return _OnboardingService.default.updateTask({
            taskId: taskId,
            action: 'complete'
          }).then(function (updatedState) {
            return _this3.setState(updatedState.data);
          });
        }
      });
    }
  }, {
    key: "unlockTask",
    value: function unlockTask(taskId) {
      var _this4 = this;

      return this.getState().then(function (state) {
        if (state.tasks.locked[taskId]) {
          return _OnboardingService.default.updateTask({
            taskId: taskId,
            action: 'unlock'
          }).then(function (updatedState) {
            return _this4.setState(updatedState.data);
          });
        }
      });
    }
  }, {
    key: "setShowNextStepNotice",
    value: function setShowNextStepNotice(sessionKey) {
      var showNextStepNotice = window.sessionStorage.getItem(sessionKey);
      window.sessionStorage.removeItem(sessionKey);
      return showNextStepNotice;
    }
  }, {
    key: "completeInitialTask",
    value: function completeInitialTask(taskId, taskKey) {
      var _this5 = this;

      return this.getState().then(function (state) {
        _OptimizelyStore.default.trackEvent(taskId);

        if (!state.tasks.completed[taskId]) {
          _this5.completeTask(taskId);

          window.sessionStorage.setItem(taskKey, true);
        }
      });
    }
  }]);

  return OnboardingStore;
}();

var _default = new OnboardingStore();

exports.default = _default;

/***/ }),
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageReaderServiceModule = void 0;
var ImageReaderServiceModule = angular.module('app.services.utilities.imageReaderService', []).factory('imageReader', ["$q", "$window", function ($q, $window) {
  var getImageData = function getImageData(file) {
    var deferred = $q.defer();

    if (angular.isUndefined(file)) {
      deferred.reject('Please pass a valid file');
    }

    if (angular.isUndefined($window.FileReader)) {
      deferred.reject('Browser does not support FileReader API');
    }

    var fileReader = new $window.FileReader();
    fileReader.addEventListener('progress', function (e) {
      if (e.lengthComputable) {
        var percentage = Math.round(e.loaded * 100 / e.total);
        deferred.notify(percentage);
      }
    });
    fileReader.addEventListener('load', function () {
      deferred.resolve(fileReader.result);
    });
    fileReader.readAsDataURL(file);
    return deferred.promise;
  };

  var getImagesData = function getImagesData(files) {
    var defer = $q.defer();
    var promises = [];
    angular.forEach(files, function (file) {
      promises.push(getImageData(file));
    });
    $q.all(promises).then(function (data) {
      defer.resolve(data);
    });
    return defer.promise;
  };

  return {
    getImageData: getImageData,
    getImagesData: getImagesData
  };
}]).name;
exports.ImageReaderServiceModule = ImageReaderServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 422 */,
/* 423 */,
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditCardEditorModule = void 0;

var _creditCardUtilities = __webpack_require__(86);

var _creditCardEditor = _interopRequireDefault(__webpack_require__(1298));

__webpack_require__(1299);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreditCardEditorModule = angular.module('app.components.creditCards.creditCardEditor', [_creditCardUtilities.CreditCardUtilitiesServiceModule]).directive('creditCardEditor', ["creditCardUtilities", function (creditCardUtilities) {
  return {
    restrict: 'EA',
    scope: {
      card: '=',
      creditCardForm: '=formController',
      onChange: '&'
    },
    template: _creditCardEditor.default,
    controller: ["$scope", function controller($scope) {
      var vm = {
        ccClass: 'credit-card-img--unknown',
        setCardInfo: setCardInfo
      };
      init();

      function init() {
        $scope.vm = vm;
        vm.setCardInfo();
      }

      function setCardInfo(cardType) {
        vm.ccClass = creditCardUtilities.getCssClass(cardType);

        if ($scope.creditCardForm && $scope.creditCardForm.cardNumber && $scope.creditCardForm.cardNumber.$ccEagerType) {
          $scope.card = $scope.card || {};
          $scope.card.cardTypeName = $scope.creditCardForm.cardNumber.$ccEagerType;
          if ($scope.onChange) $scope.onChange({
            card: $scope.card
          });
        }
      }
    }]
  };
}]).name;
exports.CreditCardEditorModule = CreditCardEditorModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get = _interopRequireDefault(__webpack_require__(34));

var _difference = _interopRequireDefault(__webpack_require__(647));

var _OptimizelyService = _interopRequireDefault(__webpack_require__(1042));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var OptimizelyStore =
/*#__PURE__*/
function () {
  function OptimizelyStore() {
    _classCallCheck(this, OptimizelyStore);

    this.defaultState = {};
  }

  _createClass(OptimizelyStore, [{
    key: "getExperiments",
    value: function getExperiments(bypassCache) {
      var _this = this;

      if (!(0, _get.default)(window, 'optimizely.get')) return Promise.resolve([]);
      var optimizelyData = window.optimizely.get('state').getVariationMap();
      var updateDatastore = false;
      this.push('activate');
      return Promise.resolve().then(function () {
        if (_this.state && !bypassCache) {
          updateDatastore = !!(0, _difference.default)(Object.keys(optimizelyData), Object.keys(_this.state)).length;

          _this.setState(Object.assign(optimizelyData, _this.state), updateDatastore);

          return _this.state;
        }

        if (_this.pendingRequest) {
          return _this.pendingRequest;
        }

        _this.pendingRequest = _OptimizelyService.default.getVariationState().then(function (response) {
          return JSON.parse((0, _get.default)(response, 'data.message', '{}'));
        }).then(function (experiments) {
          updateDatastore = !!(0, _difference.default)(Object.keys(optimizelyData), Object.keys(experiments)).length;
          return experiments;
        }).then(function (response) {
          return _this.getCombinedState(optimizelyData, response);
        }).then(function (combinedState) {
          _this.setState(combinedState, updateDatastore);

          return combinedState;
        });

        _this.registerCampaignListener();

        return _this.pendingRequest;
      });
    }
  }, {
    key: "getCombinedState",
    value: function getCombinedState(optimizelyData, experiments) {
      var _this2 = this;

      var state = Object.assign(optimizelyData, experiments); // manual triggering of credits test experiment

      var CREDITS_TEST_EXPERIMENT_ID = '14482550530';

      if (state[CREDITS_TEST_EXPERIMENT_ID]) {
        this.push('user', {
          attributes: {
            noTrialToken: true
          }
        });
      }

      Object.keys(state).forEach(function (experimentId) {
        _this2.activateExperiment(experimentId, state[experimentId].index, state[experimentId].pageName);
      });
      this.push('activate');
      return state;
    }
  }, {
    key: "setState",
    value: function setState(state) {
      var updateDatastore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var newState = state || this.defaultState;
      this.state = newState;
      if (updateDatastore) _OptimizelyService.default.setVariationState(this.state);
      return this.state;
    }
  }, {
    key: "push",
    value: function push(type) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var optimizely = window.optimizely || [];
      window.setTimeout(function () {
        return optimizely.push(_objectSpread({
          type: type
        }, data));
      });
    }
  }, {
    key: "trackPage",
    value: function trackPage(pageName) {
      this.push('page', {
        pageName: pageName
      });
    }
  }, {
    key: "bucketVisitor",
    value: function bucketVisitor(experimentId, variationIndex) {
      this.push('bucketVisitor', {
        experimentId: experimentId,
        variationIndex: variationIndex
      });
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(eventName) {
      this.push('event', {
        eventName: eventName
      });
    }
  }, {
    key: "activateExperiment",
    value: function activateExperiment(experimentId, variationIndex, pageName) {
      this.bucketVisitor(experimentId, variationIndex);
      this.trackPage(pageName);
    }
  }, {
    key: "setUpExperiment",
    value: function setUpExperiment() {
      var _this3 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          experimentId = _ref.experimentId,
          condition = _ref.condition,
          _ref$variations = _ref.variations,
          variations = _ref$variations === void 0 ? {
        true: 1,
        false: 0
      } : _ref$variations,
          pageName = _ref.pageName;

      return this.getExperiments().then(function (experiments) {
        var variationIndex = 0;
        var updateDatastore = true;

        if (experiments[experimentId]) {
          variationIndex = experiments[experimentId].index;
          updateDatastore = false;
        } else {
          variationIndex = condition ? variations.true : variations.false;
          experiments[experimentId] = {
            index: variationIndex
          };
        }

        experiments[experimentId].pageName = pageName;

        _this3.setState(experiments, updateDatastore);

        _this3.activateExperiment(experimentId, variationIndex, pageName);

        _this3.push('activate');

        return experiments;
      });
    }
  }, {
    key: "campaignDecidedHandler",
    value: function campaignDecidedHandler() {
      if (!(0, _get.default)(window, 'optimizely.get')) return;
      var optimizelyData = window.optimizely.get('state').getVariationMap();
      var updateDatastore = !!(0, _difference.default)(Object.keys(optimizelyData), Object.keys(this.state)).length;
      this.setState(Object.assign(optimizelyData, this.state), updateDatastore);
    }
  }, {
    key: "registerCampaignListener",
    value: function registerCampaignListener() {
      this.push('addListener', {
        filter: {
          type: 'lifecycle',
          name: 'campaignDecided'
        },
        handler: this.campaignDecidedHandler.bind(this)
      });
    }
  }]);

  return OptimizelyStore;
}();

var _default = new OptimizelyStore();

exports.default = _default;

/***/ }),
/* 526 */,
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageEditorModule = void 0;

var _react2angular = __webpack_require__(97);

var _index = __webpack_require__(1058);

var ImageEditorModule = angular.module('app.components.ImageEditor', []).component('imageEditor', (0, _react2angular.react2angular)(_index.ImageEditor)).name;
exports.ImageEditorModule = ImageEditorModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VlnDialogControllerModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _angularMessages = _interopRequireDefault(__webpack_require__(481));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VlnDialogControllerModule = angular.module('app.comopnents.modals.vlnDialogController', [_angularjs.default, _angularMessages.default, 'ngMaterial']).controller('vlnDialogController', ["$scope", "$mdDialog", "$state", function ($scope, $mdDialog, $state) {
  $scope.cancelDialog = function (result) {
    return $mdDialog.cancel(result);
  };

  $scope.closeDialog = function (result) {
    return $mdDialog.hide(result);
  };

  $scope.gtmid = "admin_".concat($state.current.name);
}]).name;
exports.VlnDialogControllerModule = VlnDialogControllerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModelWatchServiceModule = void 0;

var _storage = __webpack_require__(130);

var _arrayModel = __webpack_require__(590);

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var ModelWatchServiceModule = angular.module('app.services.data.modelService.modelWatcher', [_storage.StorageServiceModule, _arrayModel.ArrayModelServiceModule]).service('modelWatcher', ["arrayModel", "$window", "storageService", function (arrayModel, $window, storageService) {
  var api = {
    getChanges: getChanges,
    hasChanges: hasChanges,
    reset: reset,
    update: update,
    stash: stash,
    unstash: unstash,
    makeDirty: makeDirty,
    assignWatchers: assignWatchers,
    updateChangedValues: updateChangedValues
  };
  return api;
  /**
   Gets changed fields from model
    @return {Array} fields changed in model
   */

  function getChanges() {
    return this.changedValues;
  }
  /**
   Returns if Model has been changed
    @param {String} field, optional
   @return {Boolean} changes exist for field or entire Model
   */


  function hasChanges(field) {
    if (field && this.changedValues) {
      return this.changedValues.indexOf(field) > -1;
    }

    if (this.changedValues) {
      return this.changedValues.length > 0;
    }

    return false;
  }
  /**
   Resets the model back to either its original value or last updated value
   */


  function reset(field) {
    if (this.changedValues.length === 0) {
      return;
    }

    if (field) {
      if (Array.isArray(field)) {
        for (var i = 0; i < field.length; i += 1) {
          this.changedValues.splice(this.changedValues.indexOf(field[i]), 1);
          resetField.call(this, field[i]);
        }
      } else {
        this.changedValues.splice(this.changedValues.indexOf(field), 1);
        resetField.call(this, field);
      }
    } else {
      var key;

      while ((key = this.changedValues.pop()) != null) {
        resetField.call(this, key);
      }
    }

    function resetField(key) {
      /**
       Move down the tree if a child is a model object
       if array of values, reassign values
       if array of object, copy over object
       - fixes some angular copy issues when trying to override array of values
       */
      if (this.model[key] instanceof Model) {
        this.model[key].reset();
      } else if (_typeof(this._base[key]) == 'object' && this._base[key] !== null) {
        if (Array.isArray(this._base[key]) && _typeof(this._base[key][0]) != 'object') {
          this.model[key] = angular.copy(this._base[key]);
          arrayModel.overrideArrayFunctions(this, key);
        } else if (this.model[key] !== null) {
          angular.copy(this._base[key], this.model[key]);
        } else {
          this.model[key] = this._base[key];
        }
      } else {
        this.model[key] = this._base[key];
      }
    }
  }
  /**
   Updates either the entire model or a given field, after updating,
   resets will use last update as the return point
    @param {String} field
   */


  function update(field) {
    if (field) {
      if (this.changedValues.indexOf(field) > -1) {
        var fieldIndex = this.changedValues.indexOf(field);
        this.changedValues.splice(fieldIndex, 1);

        if (_typeof(this._base[field]) === 'object') {
          angular.copy(this.model[field], this._base[field]);
        } else {
          this._base[field] = this.model[field];
        }

        if (this.changedValues.length === 0 && this.parent != null) {
          if (this.parent[this.parentName].getChanges().length === 0) {
            this.parent.update(this.parentName);
          }
        }
      }
    } else {
      this.changedValues = [];
      angular.copy(this.model, this._base);
    }
  }

  function makeDirty(field) {
    if (!field) return;

    if (Array.isArray(field)) {
      for (var i = 0; i < field.length; i += 1) {
        if (Object.prototype.hasOwnProperty.call(this, field[i]) && this.changedValues.indexOf(field[i]) === -1) {
          this.changedValues.push(field[i]);
        }
      }
    } else {
      if (!Object.prototype.hasOwnProperty.call(this, field)) return;

      if (this.changedValues.indexOf(field) === -1) {
        this.changedValues.push(field);
      }
    }
  }
  /**
   Modifies changed values by comparing to base object in model
    @param {Object} obj - model object
   @param {String} propName - property name
   */


  function updateChangedValues(obj, propName) {
    if (!angular.equals(obj.model[propName], obj._base[propName])) {
      if (obj.changedValues.indexOf(propName) === -1) {
        obj.changedValues.push(propName);
      }
    } else {
      var index = obj.changedValues.indexOf(propName);

      if (index > -1) {
        obj.changedValues.splice(index, 1);
      }
    }

    if (obj.parent) {
      updateChangedValues(obj.parent, obj.parentName);
    }
  }
  /**
   Wrapper to assign watchers to every property in model
    @param {Object} obj - model object to add getters/setters to
   */


  function assignWatchers(obj) {
    Object.keys(obj.model).forEach(function (i) {
      assignWatcher(obj, i);
    });
  }
  /**
   Assigns Getters/setters on object property to watch for changed values
    @param {Object} obj - model object
   @param {String} propName - model property name
   */


  function assignWatcher(obj, propName) {
    Object.defineProperty(obj, propName, {
      enumerable: true,
      get: function get() {
        return obj.model[propName];
      },
      set: function set(newValue) {
        obj.model[propName] = newValue;

        if (obj.model[propName] === '') {
          obj.model[propName] = null;
        }

        updateChangedValues(obj, propName);

        if (Array.isArray(obj.model[propName])) {
          arrayModel.assignArrayProperty(obj, propName);
        }

        if (obj.parent) {
          updateChangedValues(obj.parent, obj.parentName);
        }
      }
    });

    if (Array.isArray(obj.model[propName])) {
      arrayModel.assignArrayProperty(obj, propName);
    } else if (_typeof(obj.model[propName]) == 'object' && obj.model[propName] != null) {
      obj.model[propName] = assignParentModel(obj, propName, obj[propName]);
    }
  }
  /**
   Set parent of object to allow for cascading change tracking
    @param {Object} parent - Parent model object
   @param {String} parentName - Parent property
   @param {Object} child - item to assign parent
    @return {Object} Modified child object
   */


  function assignParentModel(parent, parentName, child) {
    if (!(child instanceof Model)) {
      child = new Model(child);
    }

    Object.defineProperty(child, 'parent', {
      value: parent,
      configurable: true
    });
    Object.defineProperty(child, 'parentName', {
      value: parentName,
      configurable: true
    });
    return child;
  }

  function stash() {
    if (!this._stash) {
      this._stash = {};
    }

    this._stash.model = angular.copy(this.model);
    this._stash.changes = angular.copy(this.changedValues);

    if (storageService.supported() && this.model.id) {
      $window.localStorage.setItem("modelStash_".concat(this.model.id), JSON.stringify(this._stash));
    }

    this.reset();
  }

  function unstash() {
    if ((!this._stash || Object.keys(this._stash).length === 0) && storageService.supported()) {
      this._stash = $window.localStorage.getItem("modelStash_".concat(this.model.id));
      this._stash = JSON.parse(this._stash);
    }

    if (storageService.supported()) {
      $window.localStorage.removeItem("modelStash_".concat(this.model.id));
    }

    if (this._stash && Object.keys(this._stash).length !== 0) {
      this.model = angular.copy(this._stash.model);
      this.changedValues = angular.copy(this._stash.changes);
    }
  }
}]).name;
exports.ModelWatchServiceModule = ModelWatchServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayModelServiceModule = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*eslint prefer-rest-params: 0 */
var ArrayModelServiceModule = angular.module('app.services.data.modelService.arrayModelService', []).service('arrayModel', function () {
  var api = {
    assignArrayProperty: assignArrayProperty,
    overrideArrayFunctions: overrideArrayFunctions
  };
  return api;

  function assignParentModel(obj, propName, item) {
    if (!(item instanceof Model)) {
      item = new Model(item);
    }

    Object.defineProperty(item, 'parent', {
      value: obj,
      configurable: true
    });
    Object.defineProperty(item, 'parentName', {
      value: propName,
      configurable: true
    });
    return item;
  }

  function assignArrayProperty(obj, propName) {
    overrideArrayFunctions(obj, propName);
    assignArrayParent(obj, propName);
  }

  function assignArrayParent(obj, propName) {
    if (Array.isArray(obj[propName])) {
      Object.keys(obj[propName]).forEach(function (el, i) {
        if (_typeof(obj[propName][i]) == 'object' && !Array.isArray(obj[propName][i])) {
          obj[propName][i] = assignParentModel(obj, propName, obj[propName][i]);
        }
      });
    }
  }

  function overrideArrayFunctions(obj, propName) {
    Object.defineProperty(obj.model[propName], 'push', {
      value: function value() {
        var args;
        var newLength;
        args = arguments;

        if (args[0] && _typeof(args[0]) === 'object' && !Array.isArray(args[0])) {
          args[0] = assignParentModel(obj, propName, arguments[0]);
        }

        newLength = Array.prototype.push.apply(this, arguments);
        obj.updateChanges(obj, propName);
        return newLength;
      },
      configurable: true
    });
    Object.defineProperty(obj.model[propName], 'splice', {
      value: function value() {
        var args;
        var newLength;
        args = arguments;

        if (args[2] && _typeof(args[2]) === 'object' && !Array.isArray(args[2])) {
          args[2] = assignParentModel(obj, propName, arguments[2]);
        }

        newLength = Array.prototype.splice.apply(this, args);
        obj.updateChanges(obj, propName);
        return newLength;
      },
      configurable: true
    });
    Object.defineProperty(obj.model[propName], 'pop', {
      value: function value() {
        var poppedValue = Array.prototype.pop.apply(this, arguments);
        obj.updateChanges(obj, propName);
        return poppedValue;
      },
      configurable: true
    });
  }
}).name;
exports.ArrayModelServiceModule = ArrayModelServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModelParseServiceModule = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var ModelParseServiceModule = angular.module('app.services.data.modelService.modelParser', []).service('modelParser', ["$injector", function ($injector) {
  var api = {
    parse: parse
  };
  return api;

  function getKeysFromString(str) {
    var obj = $injector.get(str);
    return getKeysFromObject(obj);
  }

  function getKeysFromArray(arr) {
    var newObj = {};

    for (var i = 0; i < arr.length; i += 1) {
      var name = arr[i];
      newObj[name] = null;
    }

    return newObj;
  }

  function getKeysFromObject(settings) {
    var model = {};
    Object.keys(settings).forEach(function (i) {
      model[i] = getDefault(settings[i]);
    });
    return model;
  }

  function getDefault(item) {
    switch (item) {
      case 'any':
        return null;

      case 'String':
        return '';

      case 'Number':
        return null;

      case 'Boolean':
        return false;

      case 'Array':
        return [];

      default:
        if (Array.isArray(item)) {
          //if item has default, use that, otherwise use type
          return item.length === 2 ? item[1] : getDefault(item[0]);
        } else if (_typeof(item) === 'object') {
          return getKeysFromObject(item);
        }

        throw new Error("Unsupported type ".concat(item, " used"));
    }
  }

  function parse(model) {
    if (typeof model === 'string') {
      return getKeysFromString(model);
    } else if (Array.isArray(model)) {
      return getKeysFromArray(model);
    }

    return getKeysFromObject(model);
  }
}]).name;
exports.ModelParseServiceModule = ModelParseServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageLibraryServiceModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _imageLibrary = __webpack_require__(1248);

var _imageLibrary2 = _interopRequireDefault(__webpack_require__(1255));

__webpack_require__(1256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLibraryServiceModule = angular.module('app.components.imageLibrary.imageLibraryService', [_angularjs.default, _imageLibrary.ImageLibraryControllerModule]).service('imageLibraryService', ["$mdDialog", function ($mdDialog) {
  return {
    open: function open(_ref) {
      var event = _ref.event,
          multiSelect = _ref.multiSelect,
          context = _ref.context,
          associationTags = _ref.associationTags,
          clearImage = _ref.clearImage;
      return $mdDialog.show({
        controller: 'ImageLibraryController',
        template: _imageLibrary2.default,
        parent: angular.element('body'),
        targetEvent: event,
        clickOutsideToClose: true,
        locals: {
          context: context,
          associationTags: associationTags || [],
          multiSelect: multiSelect,
          clearImage: clearImage
        }
      });
    }
  };
}]).name;
exports.ImageLibraryServiceModule = ImageLibraryServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoutDirectiveModule = void 0;

var _auth = __webpack_require__(77);

var LogoutDirectiveModule = angular.module('app.directives.logoutDirective', [_auth.AuthServiceModule]).directive('logout', ["auth0AuthService", function (auth0AuthService) {
  return {
    restrict: 'A',
    link: function link(scope, element) {
      element.on('click', logout);
      scope.$on('$destroy', function () {
        element.off('click', logout);
      });

      function logout() {
        auth0AuthService.logout();
      }
    }
  };
}]).name;
exports.LogoutDirectiveModule = LogoutDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneFilterModule = void 0;
var PhoneFilterModule = angular.module('app.filters.phoneFilter', []).filter('phone', function () {
  return function (input) {
    if (input === undefined || input === '') {
      return input;
    }

    input = input.replace(/[^\d]+/g, '');
    var country;
    var city;
    var number;

    switch (input.length) {
      case 10:
        // +1PPP####### -> C (PPP) ###-####
        country = 1;
        city = input.slice(0, 3);
        number = input.slice(3);
        break;

      case 11:
        // +CPPP####### -> CCC (PP) ###-####
        country = input[0];
        city = input.slice(1, 4);
        number = input.slice(4);
        break;

      case 12:
        // +CCCPP####### -> CCC (PP) ###-####
        country = input.slice(0, 3);
        city = input.slice(3, 5);
        number = input.slice(5);
        break;

      default:
        return input;
    }

    if (country === 1) {
      country = '';
    }

    number = "".concat(number.slice(0, 3), "-").concat(number.slice(3));
    return "".concat(country, " (").concat(city, ") ").concat(number).trim();
  };
}).name;
exports.PhoneFilterModule = PhoneFilterModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardInfoModule = void 0;

var _creditCardUtilities = __webpack_require__(86);

__webpack_require__(596);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CardInfoModule = angular.module('app.components.cardInfo', [_creditCardUtilities.CreditCardUtilitiesServiceModule]).component('cardInfo', {
  bindings: {
    brand: '<',
    lastFour: '<',
    expiration: '<'
  },
  template: "\n            <div class=\"card-info\" layout=\"row\" layout-align=\"start center\">\n                <div class=\"card-info__image\">\n                    <span class=\"credit-card-img\" ng-class=\"$ctrl.ccClass\"></span>\n                </div>\n                <div class=\"card-info__text\" layout=\"column\">\n                    <div layout-xs=\"column\" layout-gt-xs=\"row\">\n                        <span class=\"card-info__title\">\n                            {{$ctrl.brand}} {{'UPDATEPAYMENTCARD.ENDINGIN' | translate}} {{$ctrl.lastFour}}\n                        </span>\n                        <span class=\"card-info__expiration\">\n                            <span>{{'UPDATEPAYMENTCARD.EXP' | translate}} </span>\n                            <span>{{$ctrl.expiration.month}}/{{$ctrl.expiration.year}}</span>\n                        </span>\n                    </div>\n                    <span class=\"card-info__desc\">This is your default payment method for all admin purchases.</span>\n                </div>\n            </div>\n        ",
  controller:
  /*#__PURE__*/
  function () {
    CardInfoCtrl.$inject = ["creditCardUtilities"];

    function CardInfoCtrl(creditCardUtilities) {
      'ngInject';

      _classCallCheck(this, CardInfoCtrl);

      angular.extend(this, {
        creditCardUtilities: creditCardUtilities
      });
    }

    _createClass(CardInfoCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        this.updateCcClass();
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changesObj) {
        if (changesObj.brand && changesObj.brand.currentValue !== changesObj.brand.previousValue) {
          this.updateCcClass();
        }
      }
    }, {
      key: "updateCcClass",
      value: function updateCcClass() {
        this.ccClass = this.creditCardUtilities.getCssClass(this.brand);
      }
    }]);

    return CardInfoCtrl;
  }()
}).name;
exports.CardInfoModule = CardInfoModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GreetingServiceModule = void 0;

var _authToken = __webpack_require__(43);

var _storage = __webpack_require__(130);

var GreetingServiceModule = angular.module('app.services.greetingService', [_authToken.AuthTokenServiceModule, _storage.StorageServiceModule]).service('greetingService', ["$q", "$http", "$location", "storageService", "authTokenService", function ($q, $http, $location, storageService, authTokenService) {
  return {
    isGreetingFinished: isGreetingFinished,
    doesProfileExist: doesProfileExist,
    getProfile: getProfile,
    saveProfile: saveProfile,
    getRootDomain: getRootDomain
  };

  function isGreetingFinished() {
    var rootDomain = getRootDomain($location.host());
    var tenantId = authTokenService.getTenantId();
    var greetingFinished = storageService.getCookieObject(tenantId, 'greetingFinished');

    if (angular.isUndefined(greetingFinished) || greetingFinished === null || greetingFinished === false) {
      return doesProfileExist().then(function (profileExists) {
        storageService.updateCookieObject(tenantId, {
          greetingFinished: profileExists
        }, {
          secure: true,
          domain: rootDomain
        });
        return profileExists;
      });
    }

    return $q.resolve(greetingFinished);
  }

  function doesProfileExist() {
    return $http.get("".concat("https://sandbox.api-v2.volusion.com", "/admin/profile")).then(function (profileResult) {
      return profileResult.data.isComplete;
    });
  }

  function getProfile() {
    return $http.get("".concat("https://sandbox.api-v2.volusion.com", "/admin/profile"));
  }

  function saveProfile(profile) {
    return $http.put("".concat("https://sandbox.api-v2.volusion.com", "/admin/profile"), profile).then(function (response) {
      storageService.updateCookieObject(authTokenService.getTenantId(), {
        greetingFinished: true
      }, {
        secure: true,
        domain: getRootDomain($location.host())
      });
      return response;
    });
  }

  function getRootDomain(hostname) {
    var parts = hostname.split('.');
    var hasSubdomain = parts.length === 3;
    return hasSubdomain ? "".concat(parts[1], ".").concat(parts[2]) : hostname;
  }
}]).name;
exports.GreetingServiceModule = GreetingServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(__webpack_require__(234));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SiteDesignerService =
/*#__PURE__*/
function () {
  function SiteDesignerService() {
    _classCallCheck(this, SiteDesignerService);

    this.baseApiUrl = "https://btr.v2-sandbox.volusion.com";
  }

  _createClass(SiteDesignerService, [{
    key: "getPages",
    value: function getPages(themeId) {
      return this.get("/themes/".concat(themeId, "/pages/list")).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "getPage",
    value: function getPage(themeId, pageId) {
      return this.get("/themes/".concat(themeId, "/pages/").concat(pageId));
    }
  }, {
    key: "createPage",
    value: function createPage(path) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var themeId = arguments.length > 2 ? arguments[2] : undefined;
      var data = {
        path: path,
        themeId: themeId,
        title: title,
        seoData: {
          title: title.replace(' ', '-')
        }
      };
      return this.post("/themes/".concat(themeId, "/pages"), data).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "getThemes",
    value: function getThemes() {
      return this.get('/themes/drafts').then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "getTheme",
    value: function getTheme(themeId) {
      return this.get("/themes/".concat(themeId)).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "getInstalledTheme",
    value: function getInstalledTheme() {
      return this.get('/themes/installed').then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "setAuthToken",
    value: function setAuthToken(token) {
      this.authToken = token;
    }
  }, {
    key: "installTheme",
    value: function installTheme(themeId) {
      return this.post("/themes/".concat(themeId, "/install"));
    }
  }, {
    key: "activateTheme",
    value: function activateTheme(themeId) {
      return this.post("/themes/".concat(themeId, "/install"));
    }
  }, {
    key: "createNewTheme",
    value: function createNewTheme() {
      var themeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.post('/themes', {
        name: themeName,
        metadata: {
          isPublic: false
        }
      });
    }
  }, {
    key: "getHttpConfig",
    value: function getHttpConfig(options) {
      var config = {
        headers: {
          Authorization: "Bearer ".concat(this.authToken)
        }
      };
      return options ? _objectSpread({}, config, {
        options: options
      }) : config;
    }
  }, {
    key: "get",
    value: function get(url) {
      return _axios.default.get("".concat(this.baseApiUrl).concat(url), this.getHttpConfig());
    }
  }, {
    key: "post",
    value: function post(url, data) {
      return _axios.default.post("".concat(this.baseApiUrl).concat(url), data, this.getPostConfig());
    }
  }, {
    key: "getPostConfig",
    value: function getPostConfig() {
      var postConfig = this.getHttpConfig();
      postConfig.headers['Content-Type'] = 'application/json';
      return postConfig;
    }
  }]);

  return SiteDesignerService;
}();

var _default = new SiteDesignerService();

exports.default = _default;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationMenuServiceModule = void 0;

var _findIndex = _interopRequireDefault(__webpack_require__(192));

var _toLower = _interopRequireDefault(__webpack_require__(723));

var _landing = __webpack_require__(670);

var _launchDarkly = __webpack_require__(30);

var _storeInformation = __webpack_require__(38);

var _navigationMenu = __webpack_require__(603);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NavigationMenuServiceModule = angular.module('app.services.utilities.navigationMenuService', [_landing.LandingServiceModule, _launchDarkly.LaunchDarklyServiceModule, _storeInformation.StoreInformationServiceModule]).service('navigationMenuService', ["$mdSidenav", "$window", "launchDarklyService", "storeInformationService", "DEFAULT_APPS", function ($mdSidenav, $window, launchDarklyService, storeInformationService, DEFAULT_APPS) {
  var appOrder = [_navigationMenu.NAV_STATES.ORDERS, _navigationMenu.NAV_STATES.PRODUCTS, _navigationMenu.NAV_STATES.DISCOUNTS, _navigationMenu.NAV_STATES.CATEGORIES, _navigationMenu.NAV_STATES.CUSTOMERS, _navigationMenu.NAV_STATES.APP_STORE, _navigationMenu.NAV_STATES.SETTINGS, _navigationMenu.NAV_STATES.ANALYTICS, _navigationMenu.NAV_STATES.SITE_DESIGNER, _navigationMenu.NAV_STATES.PAGES, _navigationMenu.NAV_STATES.SITE_TAGGING, _navigationMenu.NAV_STATES.EDIT_MENU];
  var defaultIconColor = '#221b43';
  var homeApp = {
    type: _navigationMenu.NAV_STATES.DASHBOARD,
    icon: 'home',
    link: _navigationMenu.NAV_STATES.DASHBOARD,
    label: 'LABEL.HOME',
    color: defaultIconColor
  };
  var siteTaggingApp = {
    type: 'siteTagging',
    icon: 'code',
    link: 'siteTagging',
    label: 'LABEL.SITE_TAGGING',
    color: defaultIconColor,
    linkedApp: true
  };
  var usersAndPermissionsApp = {
    type: 'users',
    icon: 'people_alt',
    link: 'usersAndPermissions',
    label: 'LABEL.USER_PERMISSIONS',
    color: defaultIconColor
  };
  var blockManagementApp = {
    type: 'blocks',
    icon: 'widgets',
    link: 'blockManagement',
    label: 'LABEL.BLOCK_MANAGEMENT',
    color: defaultIconColor
  };
  var menuManagementApp = {
    type: 'menuManagement',
    label: 'LABEL.MENU_MANAGEMENT',
    icon: 'menu',
    link: 'menuManagement',
    color: defaultIconColor,
    linkedAppEnd: true
  };
  var storeCreditApp = {
    type: 'storeCredit',
    icon: 'card_giftcard',
    link: 'storeCredit',
    label: 'LABEL.STORECREDIT',
    color: defaultIconColor
  };
  var discountsApp = {
    type: 'discounts',
    icon: 'event_seat',
    href: "".concat("https://admin-sandbox.volusion.com/admin", "/discounts/all"),
    label: 'LABEL.DISCOUNTS',
    color: defaultIconColor
  };
  return {
    toggle: toggle,
    close: close,
    getSelectedAppType: getSelectedAppType,
    loadApps: loadApps,
    removeNavOpenCssClassFromBody: removeNavOpenCssClassFromBody,
    addNavOpenCssClassFromBody: addNavOpenCssClassFromBody,
    setNavMenuMarginOnElements: setNavMenuMarginOnElements,
    appOrder: appOrder,
    homeApp: homeApp
  };

  function toggle() {
    $mdSidenav('nav-menu').toggle();

    if ($mdSidenav('nav-menu').isOpen()) {
      this.addNavOpenCssClassFromBody();
    } else {
      this.removeNavOpenCssClassFromBody();
    }
  }

  function close() {
    if ($mdSidenav('nav-menu').isOpen()) {
      this.removeNavOpenCssClassFromBody();
      $mdSidenav('nav-menu').toggle();
    }
  }

  function removeNavOpenCssClassFromBody() {
    var elem = angular.element($window.document.body);
    elem.removeClass('nav-menu__app--open');
  }

  function addNavOpenCssClassFromBody() {
    var elem = angular.element($window.document.body);
    elem.addClass('nav-menu__app--open');
  }

  function setNavMenuMarginOnElements(state) {
    var body = angular.element($window.document.body);
    removeNavMenuCssClasses(body);

    if (state === 'edit-store' || state === 'designer' || state === 'blocks') {
      body.addClass('nav-menu__small');
    } else if (state === 'volusion-payments') {
      body.addClass('nav-menu__none');
    } else {
      body.addClass('nav-menu__full');
    }
  }

  function removeNavMenuCssClasses(elem) {
    elem.removeClass('nav-menu__small');
    elem.removeClass('nav-menu__hidden');
    elem.removeClass('nav-menu__full');
    elem.removeClass('nav-menu__none');
  }

  function getSelectedAppType(pageType) {
    pageType = (0, _toLower.default)(pageType);

    if (pageType.includes('order')) {
      return _navigationMenu.NAV_STATES.ORDERS;
    } else if (pageType.includes('product')) {
      return _navigationMenu.NAV_STATES.PRODUCTS;
    } else if (pageType.includes('categor')) {
      return _navigationMenu.NAV_STATES.CATEGORIES;
    } else if (pageType.includes('pages')) {
      return _navigationMenu.NAV_STATES.PAGES;
    } else if (pageType.includes('customer')) {
      return _navigationMenu.NAV_STATES.CUSTOMERS;
    } else if (pageType.includes('appstore')) {
      return _navigationMenu.NAV_STATES.APP_STORE;
    } else if (pageType.includes('settings.authorizenet')) {
      return _navigationMenu.NAV_STATES.VOLUSION_PAYMENTS;
    } else if (pageType.includes('settings')) {
      return _navigationMenu.NAV_STATES.SETTINGS;
    } else if (pageType.includes('editstore.menu')) {
      return _navigationMenu.NAV_STATES.EDIT_MENU;
    } else if (pageType.includes('editstore')) {
      return _navigationMenu.NAV_STATES.EDIT_STORE;
    } else if (pageType.includes('analytics')) {
      return _navigationMenu.NAV_STATES.ANALYTICS;
    } else if (pageType.includes('dashboard')) {
      return _navigationMenu.NAV_STATES.DASHBOARD;
    } else if (pageType.includes('myaccount')) {
      return _navigationMenu.NAV_STATES.MY_ACCOUNT;
    } else if (pageType.includes('users')) {
      return _navigationMenu.NAV_STATES.USER_PERMISSIONS;
    } else if (pageType.includes('blockmanagement')) {
      return _navigationMenu.NAV_STATES.BLOCK_MANAGEMENT;
    } else if (pageType.includes('designer')) {
      return _navigationMenu.NAV_STATES.SITE_DESIGNER;
    } else if (pageType.includes('sitetagging')) {
      return _navigationMenu.NAV_STATES.SITE_TAGGING;
    } else if (pageType.includes('menumanagement')) {
      return _navigationMenu.NAV_STATES.MENU_MANAGEMENT;
    }
  }

  function loadApps() {
    var apps = DEFAULT_APPS.filter(function (app) {
      return !app.hideInQuickMenu;
    }).sort(function (a, b) {
      return appOrder.indexOf(a.type) - appOrder.indexOf(b.type);
    });
    return storeInformationService.getStore().then(function (storeInformation) {
      return Promise.all([launchDarklyService.isNewAccount(storeInformation), launchDarklyService.getFeature('site-tagging-page'), launchDarklyService.getFeature('users-and-permissions'), launchDarklyService.getFeature('block-management'), launchDarklyService.getFeature('element-menus'), launchDarklyService.getFeature('new-admin-features-enabled')]);
    }).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 6),
          newAccount = _ref2[0],
          siteTaggingPage = _ref2[1],
          usersAndPermissions = _ref2[2],
          blockManagement = _ref2[3],
          elementMenus = _ref2[4],
          newAdminFeatures = _ref2[5];

      var categoryApp = apps.find(function (app) {
        return app.type === _navigationMenu.NAV_STATES.CATEGORIES;
      });
      categoryApp.link = 'categories.list';
      var appList = [homeApp].concat(_toConsumableArray(apps));
      if (siteTaggingPage) addNavItemAfterNavItemType(appList, siteTaggingApp, _navigationMenu.NAV_STATES.SITE_DESIGNER);

      if (blockManagement) {
        addNavItemAfterNavItemType(appList, blockManagementApp, _navigationMenu.NAV_STATES.ANALYTICS);
      }

      if (usersAndPermissions) {
        addNavItemAfterNavItemType(appList, usersAndPermissionsApp, _navigationMenu.NAV_STATES.ANALYTICS);
      }

      if (elementMenus) {
        addNavItemAfterNavItemType(appList, menuManagementApp, _navigationMenu.NAV_STATES.PAGES);
        removeNavItemType(appList, _navigationMenu.NAV_STATES.EDIT_MENU);
      }

      if (newAccount) {
        removeNavItemType(appList, _navigationMenu.NAV_STATES.PAGES);
      }

      if (newAdminFeatures.includes('storeCredit')) {
        addNavItemAfterNavItemType(appList, storeCreditApp, _navigationMenu.NAV_STATES.PRODUCTS);
      }

      if (newAdminFeatures.includes('discounts')) {
        addNavItemAfterNavItemType(appList, discountsApp, _navigationMenu.NAV_STATES.PRODUCTS);
      }

      if (newAdminFeatures.includes('orders')) {
        mutateNavItemType(appList, _navigationMenu.NAV_STATES.ORDERS, {
          href: "".concat("https://admin-sandbox.volusion.com/admin", "/orders/all")
        });
      }

      return appList;
    }).catch(function (err) {
      // eslint-disable-next-line no-console
      console.error("Problem getting LaunchDarkly flags: ".concat(err.message));
      return [homeApp].concat(_toConsumableArray(apps));
    });
  }

  function addNavItemAfterNavItemType(appList, navMenuItemToAdd, navMenuTypeToAddAfter) {
    var navItemIndex = (0, _findIndex.default)(appList, {
      type: navMenuTypeToAddAfter
    });
    appList.splice(navItemIndex + 1, 0, navMenuItemToAdd);
  }

  function mutateNavItemType(appList, navMenuTypeToMutate, newMenuItemAttrs) {
    appList.forEach(function (app, i) {
      if (app.type === navMenuTypeToMutate) {
        appList[i] = _objectSpread({}, app, newMenuItemAttrs);
      }
    });
  }

  function removeNavItemType(appList, navMenuTypeToRemove) {
    var navItemIndex = (0, _findIndex.default)(appList, {
      type: navMenuTypeToRemove
    });
    appList.splice(navItemIndex, 1);
  }
}]).name;
exports.NavigationMenuServiceModule = NavigationMenuServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAV_STATES = void 0;
var NAV_STATES = {
  ANALYTICS: 'analytics',
  APP_STORE: 'app-store',
  CATEGORIES: 'categories',
  CUSTOMERS: 'customers',
  DASHBOARD: 'dashboard',
  EDIT_STORE: 'edit-store',
  MY_ACCOUNT: 'my-account',
  ORDERS: 'orders',
  PAGES: 'pages',
  PRODUCTS: 'products',
  SETTINGS: 'settings',
  SITE_DESIGNER: 'designer',
  VOLUSION_PAYMENTS: 'volusion-payments',
  EDIT_MENU: 'edit-menu',
  MENU_MANAGEMENT: 'menuManagement',
  SITE_TAGGING: 'siteTagging',
  USER_PERMISSIONS: 'users',
  BLOCK_MANAGEMENT: 'blocks',
  DISCOUNTS: 'discounts'
};
exports.NAV_STATES = NAV_STATES;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Triangle = _styledComponents.default.div.withConfig({
  displayName: "Triangle",
  componentId: "re4ygg-0"
})(["position:absolute;width:40px;height:40px;overflow:hidden;&:after{content:'';position:absolute;width:30px;height:30px;background:#fff;transform:rotate(45deg);box-shadow:1px 1px 5px rgba(0,0,0,0.3);}"]);

var _default = Triangle;
exports.default = _default;

/***/ }),
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddLink = void 0;

var _httpPrefix = __webpack_require__(377);

var _addLink = _interopRequireDefault(__webpack_require__(1574));

__webpack_require__(1575);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AddLink = angular.module('app.pages.editstore.menuEditor.addLink', [_httpPrefix.HttpPrefixDirective]).component('menuEditorAddLink', {
  template: _addLink.default,
  bindings: {
    prefillLinkData: '<',
    onCancelClick: '&',
    onLinkSaved: '&'
  },
  controller:
  /*#__PURE__*/
  function () {
    function MenuEditorAddLinkCtrl() {
      _classCallCheck(this, MenuEditorAddLinkCtrl);
    }

    _createClass(MenuEditorAddLinkCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        this.linkData = this.prefillLinkData || {};
      }
    }]);

    return MenuEditorAddLinkCtrl;
  }()
}).name;
exports.AddLink = AddLink;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  TYPES: {
    CATEGORY: 'category',
    PRODUCT: 'product',
    PAGE: 'page',
    ELEMENT_PAGE: 'elementPage'
  }
};
exports.default = _default;

/***/ }),
/* 619 */,
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContentModule = void 0;

var _pageContent = _interopRequireDefault(__webpack_require__(1454));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageContentModule = angular.module('app.components.pageContent', []).component('pageContent', {
  template: _pageContent.default,
  bindings: {
    noTouch: '<'
  },
  transclude: true
}).name;
exports.PageContentModule = PageContentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VolusionPaymentsServiceModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _get = _interopRequireDefault(__webpack_require__(34));

var _omit = _interopRequireDefault(__webpack_require__(197));

var _moment = _interopRequireDefault(__webpack_require__(74));

var _startsWith = _interopRequireDefault(__webpack_require__(599));

var _uuidV = _interopRequireDefault(__webpack_require__(288));

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

var _expireCache = __webpack_require__(255);

var _model = __webpack_require__(165);

var _storeInformation = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var VolusionPaymentsServiceModule = angular.module('app.services.data.volusionPayments', [_data.DataServiceModule, _expireCache.ExpireCacheServiceModule, _model.ModelServiceModule, _settings.AppSettingsModule, _storeInformation.StoreInformationServiceModule]).service('volusionPaymentsService', ["dataService", "expireCache", "modelService", "storeInformationService", "settings", "$window", "$q", "$timeout", function (dataService, expireCache, modelService, storeInformationService, settings, $window, $q, $timeout) {
  return {
    ADDRESS_TYPE: {
      RENT: 'rent',
      OWN: 'own'
    },
    BUSINESS_DESCRIPTION_MAX_LEN: 255,
    BUSINESS_TYPE: {
      INDIVIDUAL: 'Individual/Sole Proprietor',
      PARTNERSHIP: 'Partnership',
      CORPORATION: 'Corporation',
      ORGANIZATION: 'Tax Exempt Organization',
      LLC: 'Limited Liability Company (LLC)',
      UNKNOWN: 'Unknown'
    },
    DELIVERY_TIMES: ['Instantly over the internet', '0-2 Days', '3 to 5 Days', '6 to 10 Days', 'Greater than 10'],
    DESCRIPTOR_MAX_LEN: 22,
    SALES_RANGES: ['Under $50K', '$50K - $100K', '$100K - $150K', '$150K - $250K', '$250K - $500K', 'Over $500K'],
    TYPES_OF_GOODS: ['Art', 'Automotive', 'Entertainment', 'Clothing & Accessories', 'Food & Drink', 'Craft & Hobby', 'Electronics', 'Games', 'Health & Beauty', 'Home Decor', 'Jewelry', 'Kids & Baby', 'Kitchen', 'Lifestyle', 'Pet Supplies', 'Services', 'Sports & Outdoors', 'Toys & Collectibles', 'Weddings', 'Other'],
    formFields: {
      BUSINESS_IDENTITY: ['legalName', 'businessType', 'ein', 'website', 'phoneNumber1', 'address11', 'city1', 'zip1', 'state1'],
      ABOUT_BUSINESS: ['description', 'yearsInBusiness', 'averageTime', 'averageOrder', 'annualSales'],
      BUSINESS_OWNER: ['ownerTitle1', 'ownerFirstName1', 'ownerLastName1', 'address12', 'city2', 'zip2', 'state2', 'addressType', 'yearsAtAddress', 'email', 'phoneNumber2', 'year1', 'month1', 'day1', 'socialSecurityNumber1'],
      CARD_STATEMENT: ['statementDescriptor', 'phoneNumber'],
      BANKING: ['routingNumber', 'bankAccount', 'termsAccepted']
    },
    steps: {
      BUSINESS_IDENTITY: 1,
      ABOUT_BUSINESS: 2,
      BUSINESS_OWNER: 3,
      CARD_STATEMENT: 4,
      BANKING: 5
    },
    userStates: {
      SIGN_UP: 0,
      READY_FOR_OAUTH: 1,
      COMPLETE: 2
    },
    errors: {
      ADDITIONAL_OWNERS: 'Invalid parameter business.us_entity_compliance.additional_beneficial_owners',
      BUSINESS: 'Invalid parameter business.account_owner',
      INDIVIDUAL: 'Invalid parameter individual.account_owner',
      SSN_LAST4: 'social_security_number_last_4',
      PHONE: '.phone',
      FULL_SSN: 'A 9-digit social security number is required for this account.',
      ZIP_CODE: 'Malformed address (ZIP Code',
      EIN: 'Invalid parameter business.us_entity_compliance.ein',
      CONTACT_NUMBER: 'Invalid parameter support_contact_number',
      ROUTING_NUMBER: 'Invalid parameter us_institution.routing_number'
    },
    paymentProviders: {
      VOLUSION_PAYMENTS: 'Voluion Payments',
      AUTHORIZE_NET: 'Authorize.Net',
      STRIPE: 'Stripe'
    },
    usTerritories: ['AS', 'FM', 'GU', 'MH', 'MP', 'PR', 'PW', 'VI'],
    defaultDebounce: 750,
    badValueCheck: badValueCheck,
    bankAccountRegex: bankAccountRegex,
    bankRoutingRegex: bankRoutingRegex,
    basicDialogController: basicDialogController,
    completeOauth: completeOauth,
    disconnectAuthorizeNet: disconnectAuthorizeNet,
    formatKycData: formatKycData,
    getActiveProvider: getActiveProvider,
    getBadgeText: getBadgeText,
    getLoginUrl: getLoginUrl,
    getOauthError: getOauthError,
    getOauthUrl: getOauthUrl,
    getPrePopulationData: getPrePopulationData,
    getTestModeUrl: getTestModeUrl,
    getUserState: getUserState,
    goToAuthorizeNetOauth: goToAuthorizeNetOauth,
    hasAccount: hasAccount,
    hasOauthConnection: hasOauthConnection,
    isInTestMode: isInTestMode,
    isKYCComplete: isKYCComplete,
    isPaymentSignupReminderNeeded: isPaymentSignupReminderNeeded,
    shouldShowAuthorizeNet: shouldShowAuthorizeNet,
    isStepValid: isStepValid,
    isValidBankAccount: isValidBankAccount,
    isValidBillingStatementDescriptor: isValidBillingStatementDescriptor,
    isValidBusinessDescription: isValidBusinessDescription,
    isValidDateOfBirth: isValidDateOfBirth,
    isValidEIN: isValidEIN,
    isValidEmail: isValidEmail,
    isValidLegalEntityName: isValidLegalEntityName,
    isValidName: isValidName,
    isValidNumber: isValidNumber,
    isValidPhone: isValidPhone,
    isValidPostalCode: isValidPostalCode,
    isValidRoutingNumber: isValidRoutingNumber,
    isValidSocialSecurity: isValidSocialSecurity,
    isValidStreetAddress: isValidStreetAddress,
    isValidUrl: isValidUrl,
    isWhitelisted: isWhitelisted,
    makeKYCModel: makeKYCModel,
    molestField: molestField,
    molestFields: molestFields,
    prePopulateAddress: prePopulateAddress,
    prePopulateKYCModel: prePopulateKYCModel,
    refreshStoreInfo: refreshStoreInfo,
    removeUnsupportedStates: removeUnsupportedStates,
    saveAccountCreated: saveAccountCreated,
    saveAccountDenied: saveAccountDenied,
    savePaymentsSignupStarted: savePaymentsSignupStarted,
    setActiveProvider: setActiveProvider,
    setIsEnabled: setIsEnabled,
    setShouldShowConnectedMessage: setShouldShowConnectedMessage,
    showFieldErrors: showFieldErrors,
    submitKyc: submitKyc,
    updateAuthorizeNetEnabled: updateAuthorizeNetEnabled,
    updateSignupSubmitted: updateSignupSubmitted,
    updateStripePreferred: updateStripePreferred,
    validateAboutBusiness: validateAboutBusiness,
    validateBanking: validateBanking,
    validateBusinessIdentity: validateBusinessIdentity,
    validateCardStatement: validateCardStatement,
    validateKYC: validateKYC,
    validateOwner: validateOwner
  };

  function submitKyc(kycData) {
    var formattedData = formatKycData(kycData);
    return dataService.create(settings.api.volusionPaymentsKYC, formattedData).then(this.updateSignupSubmitted.bind(this));
  }

  function formatKycData(kycData) {
    var data = JSON.parse(JSON.stringify(kycData));
    return clean(data);
  }

  function clean(obj) {
    var propNames = Object.keys(obj);

    for (var i = 0; i < propNames.length; i++) {
      if (isBadObjValue(obj[propNames[i]]) || propNames[i] === '$$hashKey') {
        delete obj[propNames[i]];
      } else if (_typeof(obj[propNames[i]]) === 'object' && obj[propNames[i]] !== null) {
        obj[propNames[i]] = clean(obj[propNames[i]]);
      }
    }

    return obj;
  }

  function isBadObjValue(val) {
    return val === undefined || val === '';
  }

  function isKYCComplete(storeInfo) {
    return (0, _get.default)(storeInfo, 'authorizeNet.isPaymentsSignupSubmitted');
  } // KYC Validation (entire form)


  function validateKYC(inputModel) {
    var model = inputModel || {};
    var businessIdentityValidation = validateBusinessIdentity(model.business_identity);
    var aboutBusinessValidation = validateAboutBusiness(model.about_business);
    var ownerValidation = validateOwner(model.owner);
    var cardStatementValidation = this.validateCardStatement(model.card_statement);
    var bankingValidation = validateBanking(model.banking);
    var steps = {
      businessIdentityValidation: businessIdentityValidation,
      aboutBusinessValidation: aboutBusinessValidation,
      ownerValidation: ownerValidation,
      cardStatementValidation: cardStatementValidation,
      bankingValidation: bankingValidation
    };
    var isValid = businessIdentityValidation.isValid && aboutBusinessValidation.isValid && ownerValidation.isValid && cardStatementValidation.isValid && bankingValidation.isValid;
    return {
      isValid: isValid,
      steps: steps,
      props: _objectSpread({}, businessIdentityValidation.props, aboutBusinessValidation.props, ownerValidation.props, cardStatementValidation.props, bankingValidation.props)
    };
  } // KYC Step 1: BUSINESS_IDENTITY


  function validateBusinessIdentity(inputIdentity) {
    var identity = inputIdentity || {};
    identity.address = identity.address || {};
    identity.business_phone = identity.business_phone || {};
    var isBusinessNameValid = isNonEmptyString(identity.business_name); // required

    var isEINValid = isValidEIN(identity.employer_id_number);
    var isWebsiteValid = isValidUrl(identity.business_website);
    var isPhoneValid = isValidPhone(identity.business_phone); // required

    var isPostalCodeValid = isValidPostalCode(identity.address.postal_code); // required

    var isCountryValid = isValidCountry(identity.address.country); // required

    var isValid = isBusinessNameValid && isEINValid && isWebsiteValid && isPhoneValid && isPostalCodeValid && isCountryValid;
    return {
      isValid: isValid,
      props: {
        business_name: isBusinessNameValid,
        business_phone: isPhoneValid,
        business_postal_code: isPostalCodeValid,
        business_website: isWebsiteValid,
        country: isCountryValid,
        employer_id_number: isEINValid
      }
    };
  } // KYC Step 2: ABOUT_BUSINESS


  function validateAboutBusiness(inputAbout) {
    var about = inputAbout || {};
    var isValidYearsInBusiness = isValidNumber(about.years_in_business);
    var isValidAverageOrder = isValidNumber(about.average_order);
    var isValid = isValidYearsInBusiness && isValidAverageOrder;
    return {
      isValid: isValid,
      props: {
        average_order: isValidAverageOrder,
        years_in_business: isValidYearsInBusiness
      }
    };
  } // KYC Step 3: BUSINESS_OWNER


  function validateOwner(inputOwner) {
    var owner = inputOwner || {};
    owner.owner_address = owner.owner_address || {};
    owner.owner_phone = owner.owner_phone || {};
    var REQUIRED = true;
    var isNameValid = isValidName(owner.owner_name); // required

    var isPostalCodeValid = isValidPostalCode(owner.owner_address.postal_code); // required

    var isPhoneValid = isValidPhone(owner.owner_phone); // required

    var isOwnershipTypeValid = isValidOwnershipType(owner.ownership_type); // required

    var isSocialSecurityValid = isValidSocialSecurity(owner.social_security_number);
    var isEmailValid = isValidEmail(owner.email, REQUIRED); // required

    var isDateOfBirthValid = isValidDateOfBirth(owner.date_of_birth);
    var isYearsAtAddressValid = isValidNumber(owner.owner_years_at_address, REQUIRED); // required

    var isValid = isPostalCodeValid && isPhoneValid && isOwnershipTypeValid && isNameValid && isSocialSecurityValid && isEmailValid && isDateOfBirthValid && isYearsAtAddressValid;
    return {
      isValid: isValid,
      props: {
        date_of_birth: isDateOfBirthValid,
        email: isEmailValid,
        owner_name: isNameValid,
        owner_phone: isPhoneValid,
        owner_postal_code: isPostalCodeValid,
        owner_years_at_address: isYearsAtAddressValid,
        ownership_type: isOwnershipTypeValid,
        social_security: isSocialSecurityValid
      }
    };
  } // KYC Step 4: CARD_STATEMENT


  function validateCardStatement(inputStatement) {
    var statement = inputStatement || {};
    var isBillingDescriptorValid = this.isValidBillingStatementDescriptor(statement.billing_statement_descriptor);
    var isCustomerServicePhoneValid = isValidPhone(statement.customer_service_phone); // required

    var isValid = isBillingDescriptorValid && isCustomerServicePhoneValid;
    return {
      isValid: isValid,
      props: {
        billing_statement_descriptor: isBillingDescriptorValid,
        customer_service_phone: isCustomerServicePhoneValid
      }
    };
  } // KYC Step 5: BANKING


  function validateBanking(inputBanking) {
    var banking = inputBanking || {};
    var isBankAccountValid = isValidBankAccount(banking.account_number); // required

    var isRoutingNumberValid = isValidRoutingNumber(banking.routing_number); // required

    var isTermsOfServiceValid = !!banking.terms_of_service; // required

    var isValid = isBankAccountValid && isRoutingNumberValid && isTermsOfServiceValid;
    return {
      isValid: isValid,
      props: {
        account_number: isBankAccountValid,
        routing_number: isRoutingNumberValid,
        terms_of_service: isTermsOfServiceValid
      }
    };
  }

  function isNonEmptyString(string) {
    return !!string && typeof string === 'string';
  }

  function isValidName(name) {
    return !!name && isNonEmptyString(name.first) && isNonEmptyString(name.last);
  }

  function isValidLegalEntityName(name) {
    return !!name && isNonEmptyString(name) && name.length < 256;
  }

  function isValidStreetAddress(address) {
    return !!address.address1 && isNonEmptyString(address.address1);
  }

  function isValidCountry(country) {
    return country === 'US';
  }

  function removeUnsupportedStates(usStates) {
    return (0, _omit.default)(usStates, this.usTerritories);
  }

  function isValidPostalCode(code) {
    return isNonEmptyString(code) && /^\d{5}(?:[-\s]\d{4})?$/.test(code);
  }

  function isValidPhone(phone) {
    var defined = !!phone && isNonEmptyString(phone.country_code) && isNonEmptyString(phone.phone_number);
    if (!defined) return false;
    var re = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    return re.test(phone.phone_number);
  }

  function isValidBusinessDescription(description) {
    if (description) return description.length <= this.BUSINESS_DESCRIPTION_MAX_LEN;
    return true;
  }

  function isValidDateOfBirth(date, isRequired) {
    var isEmpty = date && !date.year && !date.month && !date.day;
    if (isEmpty && !isRequired) return true;
    if (!date || !date.year || !date.month || !date.day) return false;
    var newDateFromGivenDate = new Date(date.year, date.month - 1, date.day);
    var validDate = newDateFromGivenDate.getFullYear() === date.year && newDateFromGivenDate.getMonth() + 1 === date.month && newDateFromGivenDate.getDate() === date.day;
    var momentFromGivenDate = (0, _moment.default)({
      year: date.year,
      month: date.month - 1,
      day: date.day
    });
    var oneHundredYearsAgo = (0, _moment.default)().subtract(100, 'years');
    var eighteenYearsAgo = (0, _moment.default)().subtract(18, 'years');
    var tooOld = momentFromGivenDate.isBefore(oneHundredYearsAgo);
    var tooYoung = momentFromGivenDate.isAfter(eighteenYearsAgo);
    return validDate && !tooOld && !tooYoung;
  }

  function isValidOwnershipType(type) {
    return !!type;
  }

  function isValidEmail(email, isRequired) {
    if (!email && !isRequired) return true;
    var re = /.+@.+\.[^\s]+/;
    return isNonEmptyString(email) && re.test(String(email).toLowerCase());
  }

  function isValidSocialSecurity(ssn, isRequired) {
    if (!ssn && !isRequired) return true;
    var testSsn = ssn || '';
    return /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/.test(testSsn); // nnn-nn-nnnn
  }

  function isValidEIN(ein, isRequired) {
    if (!ein && !isRequired) return true;
    var testEin = ein || ''; // nnnnnnnnn, n-nnnnnnnn, or nn-nnnnnnn

    var isEinValid = /^([0-9]{1}-?[0-9]{8}|[0-9]{2}-?[0-9]{7})$/.test(testEin);
    var isValidSsn = isValidSocialSecurity(ein, isRequired);
    return isEinValid || isValidSsn;
  }

  function isValidBillingStatementDescriptor(descriptor, isRequired) {
    if (!descriptor && !isRequired) return true;
    var testDescriptor = descriptor || '';
    return /^[\x20-\x7E]+$/.test(testDescriptor) && // all printable ascii characters
    testDescriptor.length <= this.DESCRIPTOR_MAX_LEN;
  }

  function isValidUrl(url, isRequired) {
    if (!url && !isRequired) return true;
    return isNonEmptyString(url) && (0, _startsWith.default)(url, 'http');
  }

  function isValidNumber(number, isRequired) {
    if (!number && !isRequired) return true;
    var numberRegex = /^[0-9]*$/;
    return numberRegex.test(number);
  }

  function bankRoutingRegex() {
    return /^[0-9]{9}$/;
  }

  function bankAccountRegex() {
    return /^[0-9a-zA-Z]{3,17}$/;
  }

  function isValidBankAccount(accountNumber) {
    if (!accountNumber) return false;
    return bankAccountRegex().test(accountNumber);
  }

  function isValidRoutingNumber(routingNumber) {
    return bankRoutingRegex().test(routingNumber);
  }

  function isStepValid(step, model) {
    switch (step) {
      case this.steps.BUSINESS_IDENTITY:
        return validateBusinessIdentity(model.business_identity).isValid;

      case this.steps.ABOUT_BUSINESS:
        return validateAboutBusiness(model.about_business).isValid;

      case this.steps.BUSINESS_OWNER:
        return validateOwner(model.owner).isValid;

      case this.steps.CARD_STATEMENT:
        return this.validateCardStatement(model.card_statement).isValid;

      case this.steps.BANKING:
        return validateBanking(model.banking).isValid;

      default:
        return false;
    }
  }

  function makeKYCModel(data) {
    // data is optional
    return modelService.makeModel(data, 'volusionPaymentsKYCModel');
  }

  function prePopulateKYCModel(storeInfo, accountInfo, addresses, subscription) {
    var business = this.makeKYCModel();
    business.subscriptionId = subscription.id;
    var address = getPrimaryAddress(addresses, storeInfo); // business identity

    var identity = business.business_identity;
    identity.business_name = storeInfo.name;
    identity.business_website = storeInfo.customDomain ? "https://".concat(storeInfo.customDomain) : null;
    identity.business_phone.phone_number = storeInfo.phoneNumber || accountInfo.phoneNumber;
    identity.address = prePopulateAddress(identity.address, address); // owner

    var owner = business.owner;
    if (accountInfo.firstName) owner.owner_name.first = accountInfo.firstName;
    if (accountInfo.lastName) owner.owner_name.last = accountInfo.lastName;
    if (accountInfo.email) owner.email = accountInfo.email;
    owner.owner_phone.phone_number = accountInfo.phoneNumber || storeInfo.phoneNumber;
    owner.owner_address = prePopulateAddress(owner.owner_address, address); // card statement

    var descriptor = storeInfo.name.length > this.DESCRIPTOR_MAX_LEN ? storeInfo.name.substring(0, this.DESCRIPTOR_MAX_LEN) : storeInfo.name;
    business.card_statement.billing_statement_descriptor = descriptor;
    business.card_statement.customer_service_phone.phone_number = storeInfo.phoneNumber;
    return business;
  }

  function getPrimaryAddress(addresses, storeInfo) {
    if (addresses && addresses.length > 0) {
      return addresses.filter(function (address) {
        return address.isPrimary;
      })[0].mailingAddress;
    }

    return storeInfo.mailingAddress;
  }

  function prePopulateAddress(target, source) {
    var sourceFields = {
      address1: source.address1,
      address2: source.address2,
      city: source.city,
      region: source.state,
      postal_code: source.postalCode
    };
    return (0, _assign.default)(target, sourceFields);
  }

  function getPrePopulationData(model) {
    var identity = model.business_identity || {};
    var identity_address = identity.address || {}; // eslint-disable-line camelcase

    var identity_phone = identity.business_phone || {}; // eslint-disable-line camelcase

    var owner = model.owner || {};
    var owner_name = owner.owner_name || {}; // eslint-disable-line camelcase

    var owner_phone = owner.owner_phone || {}; // eslint-disable-line camelcase

    return {
      address1: !!identity_address.address1,
      address2: !!identity_address.address2,
      city: !!identity_address.city,
      state: !!identity_address.region,
      zip: !!identity_address.postal_code,
      identityName: !!identity.business_name,
      identityPhone: !!identity_phone.phone_number,
      identityWebsite: !!identity.business_website,
      email: !!owner.email,
      ownerFirstName: !!owner_name.first,
      ownerLastName: !!owner_name.last,
      ownerPhone: !!owner_phone.phone_number,
      billingStatementDescriptor: !!model.card_statement.billing_statement_descriptor,
      customerServicePhone: !!model.card_statement.customer_service_phone.phone_number
    };
  }

  function badValueCheck(_ref) {
    var _this = this;

    var form = _ref.form,
        field = _ref.field,
        validate = _ref.validate,
        badValues = _ref.badValues;
    var isValid = true;

    if (badValues.length > 0) {
      isValid = validate();
      $timeout(function () {
        // wait for content to render
        _this.molestField(form, field);
      });
    }

    return isValid;
  }

  function showFieldErrors(form, step) {
    if (step === this.steps.BUSINESS_IDENTITY) {
      molestFields(form, this.formFields.BUSINESS_IDENTITY);
    }

    if (step === this.steps.ABOUT_BUSINESS) {
      molestFields(form, this.formFields.ABOUT_BUSINESS);
    }

    if (step === this.steps.BUSINESS_OWNER) {
      molestFields(form, this.formFields.BUSINESS_OWNER);
    }

    if (step === this.steps.CARD_STATEMENT) {
      molestFields(form, this.formFields.CARD_STATEMENT);
    }

    if (step === this.steps.BANKING) {
      molestFields(form, this.formFields.BANKING);
    }
  }

  function molestFields(form, fields) {
    return fields.map(function (field) {
      return molestField(form, field);
    });
  }

  function molestField(form, field) {
    if (!form || !form[field]) return;
    form[field].$setTouched();
    form[field].$setDirty();
  }

  function basicDialogController(scopeVars) {
    return ["$scope", "$mdDialog", function DialogController($scope, $mdDialog) {
      // eslint-disable-line no-shadow
      'ngInject'; // eslint-disable-line lines-around-directive

      (0, _assign.default)($scope, scopeVars);

      $scope.closeDialog = function () {
        $mdDialog.hide();
      };
    }];
  }

  function updateSignupSubmitted() {
    var props = {
      isPaymentsSignupSubmitted: true
    };
    return assignToStoreInfoAuthorizeNet(props);
  }

  function updateAuthorizeNetEnabled(isEnabled) {
    var props = {
      isEnabled: isEnabled,
      isStripePreferred: !isEnabled
    };
    return assignToStoreInfoAuthorizeNet(props).then(expireCache);
  }

  function updateStripePreferred(isPreferred) {
    var props = {
      isStripePreferred: isPreferred,
      isEnabled: !isPreferred
    };
    return assignToStoreInfoAuthorizeNet(props).then(expireCache);
  }

  function refreshStoreInfo() {
    return getFreshStoreInfoModel();
  }

  function getFreshStoreInfoModel() {
    var force = true;
    return storeInformationService.getStore(force).then(function (response) {
      return modelService.makeModel(response, 'storeInformationModel');
    });
  }

  function isWhitelisted(email) {
    return /^spinaltaptest[0-9]+@gmail.com$/.test(email) || /@volusion.com$/.test(email) || /@lolay.com$/.test(email);
  }

  function hasAccount(storeInfo) {
    return !!(0, _get.default)(storeInfo, 'authorizeNet.isAccountCreated');
  }

  function hasOauthConnection(_ref2) {
    var storeInfo = _ref2.storeInfo,
        authorizeNet = _ref2.authorizeNet;
    var authNet = authorizeNet || (0, _get.default)(storeInfo, 'authorizeNet');
    return !!(0, _get.default)(authNet, 'accessToken') && !!(0, _get.default)(authNet, 'accessTokenExpiration');
  }

  function getUserState(storeInfo) {
    var userState;

    if (this.hasOauthConnection({
      storeInfo: storeInfo
    })) {
      userState = this.userStates.COMPLETE;
    } else if (this.hasAccount(storeInfo)) {
      userState = this.userStates.READY_FOR_OAUTH;
    } else {
      userState = this.userStates.SIGN_UP;
    }

    return userState;
  }

  function getOauthUrl(stateParam) {
    var base = "".concat("https://sandbox.authorize.net", "/oauth/authorize?sub=oauth");
    var client = "&client_id=".concat("MAHgxUM5JB", "&state=").concat(stateParam, "&scope=read,write");
    var redirect = "&redirect_uri=".concat("https://admin-sandbox.volusion.com", "/settings/volusion-payments");
    return "".concat(base).concat(client).concat(redirect);
  }

  function getLoginUrl() {
    return "https://logintest.authorize.net";
  }

  function getTestModeUrl() {
    return "".concat("https://sandbox.authorize.net").concat("/UI/themes/sandbox/view/pages/TestMode.aspx");
  }

  function saveAccountCreated() {
    return saveAccountSignupStatus(true);
  }

  function saveAccountDenied() {
    return saveAccountSignupStatus(false);
  }

  function saveAccountSignupStatus(isCreated) {
    var props = {
      isAccountCreated: !!isCreated,
      isAccountDenied: !isCreated
    };
    return assignToStoreInfoAuthorizeNet(props);
  }

  function savePaymentsSignupStarted() {
    var props = {
      isPaymentsSignupStarted: true
    };
    return assignToStoreInfoAuthorizeNet(props);
  }

  function isPaymentSignupReminderNeeded(storeInformation) {
    var started = (0, _get.default)(storeInformation, 'authorizeNet.isPaymentsSignupStarted');
    var finished = (0, _get.default)(storeInformation, 'authorizeNet.isPaymentsSignupSubmitted');
    return !!(started && !finished);
  }

  function shouldShowAuthorizeNet(storeInformation) {
    return (0, _get.default)(storeInformation, 'authorizeNet.isPaymentsSignupStarted', false) || !(0, _get.default)(storeInformation, 'authorizeNet.isStripePreferred');
  }

  function isInTestMode() {
    return dataService.get(settings.api.volusionPaymentsTestMode).then(function (response) {
      return response.isTestMode;
    }).catch(function (err) {
      if (err.status === 409) {
        return isInTestMode();
      }
    });
  }

  function goToAuthorizeNetOauth() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$state = _ref3.state,
        state = _ref3$state === void 0 ? (0, _uuidV.default)() : _ref3$state,
        _ref3$isExisting = _ref3.isExisting,
        isExisting = _ref3$isExisting === void 0 ? false : _ref3$isExisting;

    var oauthState = isExisting ? "existing-".concat(state) : state;
    var url = getOauthUrl(oauthState);
    var props = {
      oauthState: oauthState
    };
    return assignToStoreInfoAuthorizeNet(props).then(function () {
      return $window.open(url, '_self');
    });
  }

  function completeOauth(code, state) {
    return getFreshStoreInfoModel().then(function (storeInformation) {
      var isExistingOauthState = (0, _startsWith.default)(state, 'existing');

      if (isExistingOauthState !== storeInformation.authorizeNet.isExistingAccount) {
        var err = {
          data: {
            items: [{
              message: 'Unclear if Volusion Payments or Authorize.net'
            }]
          }
        };
        return $q.reject(err);
      }

      if (state !== storeInformation.authorizeNet.oauthState) {
        var _err = {
          data: {
            items: [{
              message: 'Invalid OAuth state param.'
            }]
          }
        };
        return $q.reject(_err);
      }

      return dataService.get(settings.api.volusionPaymentsComplete, code);
    });
  }

  function getOauthError(err) {
    var defaultError = 'Unknown error.';

    if (err && err.data && err.data.items && err.data.items.length > 0) {
      return err.data.items[0].message || defaultError;
    }

    return defaultError;
  }

  function setShouldShowConnectedMessage(shouldShow) {
    var props = {
      shouldShowConnectedMessage: shouldShow
    };
    return assignToStoreInfoAuthorizeNet(props);
  }

  function setIsEnabled(isEnabled) {
    var props = {
      isEnabled: isEnabled
    };
    return assignToStoreInfoAuthorizeNet(props).then(expireCache);
  }

  function disconnectAuthorizeNet() {
    var props = {
      accessToken: '',
      accessTokenExpiration: '',
      isAccountCreated: true,
      isAccountDenied: false,
      isEnabled: false,
      isPaymentsSignupStarted: true,
      isPaymentsSignupSubmitted: true,
      isStripePreferred: false,
      refreshToken: '',
      refreshTokenExpiration: '',
      shouldShowConnectedMessage: false,
      publicClientKey: '',
      apiLoginId: '',
      wasDisconnected: true
    };
    return assignToStoreInfoAuthorizeNet(props).then(expireCache);
  }

  function assignToStoreInfoAuthorizeNet(obj) {
    return getFreshStoreInfoModel().then(function (storeInfo) {
      (0, _assign.default)(storeInfo.authorizeNet, obj);
      return storeInformationService.save(storeInfo);
    });
  }

  function getActiveProvider() {
    var authorizeNetData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (authorizeNetData.isStripePreferred) return this.paymentProviders.STRIPE;
    if (authorizeNetData.isExistingAccount) return this.paymentProviders.AUTHORIZE_NET;
    return this.paymentProviders.VOLUSION_PAYMENTS;
  }

  function setActiveProvider(provider, oldAuthorizeNet) {
    var props = {
      shouldShowConnectedMessage: false
    };
    var isAuthorizeNetConnected = this.hasOauthConnection({
      authorizeNet: oldAuthorizeNet
    });

    if (provider === this.paymentProviders.STRIPE) {
      props.isStripePreferred = true;
      props.isEnabled = false;
    } else {
      props.isExistingAccount = provider === this.paymentProviders.AUTHORIZE_NET;

      if (isAuthorizeNetConnected) {
        props.isStripePreferred = false;
        props.isEnabled = true;
      }
    }

    var switchFromAuthnetToVolusionPayments = provider === this.paymentProviders.VOLUSION_PAYMENTS && oldAuthorizeNet.isExistingAccount;
    var switchFromVolusionPaymentsToAuthnet = provider === this.paymentProviders.AUTHORIZE_NET && !oldAuthorizeNet.isExistingAccount;

    if (switchFromAuthnetToVolusionPayments || switchFromVolusionPaymentsToAuthnet) {
      props.accessToken = '';
      props.accessTokenExpiration = '';
      props.isAccountCreated = false;
      props.isAccountDenied = false;
      props.isPaymentsSignupStarted = true;
      props.isPaymentsSignupSubmitted = false;
      props.isTestMode = false;
      props.refreshToken = '';
      props.refreshTokenExpiration = '';
      props.publicClientKey = '';
      props.apiLoginId = '';
      props.wasDisconnected = false;
    }

    return assignToStoreInfoAuthorizeNet(props).then(expireCache);
  }

  function getBadgeText(authorizeNet, currentStep) {
    var isConnected = this.hasOauthConnection({
      authorizeNet: authorizeNet
    });
    if (!authorizeNet) return 'Inactive';

    if (authorizeNet.wasDisconnected && !authorizeNet.isEnabled && !isConnected) {
      return 'Inactive';
    }

    var isComplete = currentStep >= this.userStates.COMPLETE;
    if (!isComplete && authorizeNet.isPaymentsSignupSubmitted) return 'Pending';
    if (isComplete && !authorizeNet.isEnabled && authorizeNet.isStripePreferred) return 'Disabled';
    if (isComplete && !authorizeNet.isEnabled) return 'Checkout Disabled';
    if (isComplete && authorizeNet.isTestMode) return 'Test Mode';
    if (isComplete) return 'Active';
    return 'Inactive';
  }
}]).name;
exports.VolusionPaymentsServiceModule = VolusionPaymentsServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderModule = void 0;

var _headerScroll = __webpack_require__(1405);

var _launchDarkly = __webpack_require__(30);

var _statusPage = __webpack_require__(1406);

var _savebar = __webpack_require__(1411);

var _search = __webpack_require__(1416);

var _videoSlider = __webpack_require__(156);

var _trial = __webpack_require__(60);

var _pageHeader = __webpack_require__(1419);

var _backButton = __webpack_require__(1430);

var _tabs = __webpack_require__(1432);

var _calendlyButton = __webpack_require__(1435);

var _supportPin = __webpack_require__(1440);

var _overflowMenuBulkProcess = __webpack_require__(1443);

var _overflowMenuCalendly = __webpack_require__(1444);

var _overflowMenu = __webpack_require__(1445);

var _overflowMenuHelp = __webpack_require__(1447);

var _overflowMenuIntercom = __webpack_require__(1448);

var _overflowMenuLogout = __webpack_require__(1450);

var _overflowMenuSearch = __webpack_require__(1451);

var _overflowMenuStorefrontCache = __webpack_require__(1452);

var _overflowMenuStorefrontPreview = __webpack_require__(1453);

var PageHeaderModule = angular.module('app.components.pageHeader', [_headerScroll.HeaderScrollDirectiveModule, _statusPage.StatusPageModule, _savebar.SaveBarModule, _search.SearchDirectiveModule, _pageHeader.PageHeaderComponentModule, _backButton.BackButtonComponentModule, _tabs.TabsComponentModule, _launchDarkly.LaunchDarklyServiceModule, _videoSlider.VideoSliderServiceModule, _trial.TrialServiceModule, _calendlyButton.CalendlyButtonComponentModule, _supportPin.SupportPinComponentModule, _overflowMenu.OverflowMenuComponentModule, _overflowMenuHelp.OverflowMenuHelpComponentModule, _overflowMenuIntercom.OverflowMenuIntercomComponentModule, _overflowMenuCalendly.OverflowMenuCalendlyComponentModule, _overflowMenuLogout.OverflowMenuLogoutComponentModule, _overflowMenuSearch.OverflowMenuSearchComponentModule, _overflowMenuStorefrontPreview.OverflowMenuStorefrontPreviewComponentModule, _overflowMenuBulkProcess.OverflowMenuBulkProcessModule, _overflowMenuStorefrontCache.OverflowMenuStorefrontCacheModule]).name;
exports.PageHeaderModule = PageHeaderModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 623 */,
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostageServiceModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _reduce = _interopRequireDefault(__webpack_require__(160));

var _isString = _interopRequireDefault(__webpack_require__(373));

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

var _storeAddresses = __webpack_require__(626);

var _storeInformation = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostageServiceModule = angular.module('app.services.postage', ['ngMaterial', _angularjs.default, _angularTranslate.default, _data.DataServiceModule, _settings.AppSettingsModule, _storeInformation.StoreInformationServiceModule, _storeAddresses.StoreAddressesModule]).constant('LABEL_FILE_TYPES', [{
  label: 'Original file (PNG)',
  code: 'PNG'
}, {
  label: '8.5x11in PDF',
  code: 'PDF'
}, {
  label: '4x6in PDF',
  code: 'PDF_4x6'
}, {
  label: 'ZPL II Image Format',
  code: 'ZPLII'
}]).service('postageService', ["dataService", "settings", "$mdDialog", "$q", "storeInformationService", "storeAddressesService", "$filter", "$mdToast", "$state", "$translate", function (dataService, settings, $mdDialog, $q, storeInformationService, storeAddressesService, $filter, $mdToast, $state, $translate) {
  var service = {
    getRates: getRates,
    getDefaults: getDefaults,
    createDefaults: createDefaults,
    purchaseLabel: purchaseLabel,
    getPurchasedLabel: getPurchasedLabel,
    refundLabel: refundLabel,
    saveDefaults: saveDefaults,
    openRefundShippingLabelModal: openRefundShippingLabelModal,
    generateRecipient: generateRecipient,
    generateSender: generateSender,
    getWeightOfCartItems: getWeightOfCartItems,
    getQuantityOfCartItems: getQuantityOfCartItems,
    getCarrierFromToken: getCarrierFromToken,
    getNumOfItemsMissingWeight: getNumOfItemsMissingWeight,
    showErrorToast: showErrorToast,
    hasConfiguredDefaults: hasConfiguredDefaults,
    openRedirectToSetupModal: openRedirectToSetupModal
  };

  function getRates(customer, sender, parcel) {
    return dataService.create(settings.api.postage, {
      to: customer,
      from: sender,
      parcel: parcel
    });
  }

  function getDefaults() {
    return dataService.getAll("".concat(settings.api.postage, "/packagesize"));
  }

  function createDefaults(defaults) {
    return dataService.create("".concat(settings.api.postage, "/packagesize"), defaults);
  }

  function purchaseLabel(rateId, orderId, labelType, printReturnLabel) {
    return dataService.create("".concat(settings.api.postage, "/paid"), {
      rateId: rateId,
      orderId: orderId,
      labelType: labelType,
      printReturnLabel: printReturnLabel
    });
  }

  function getPurchasedLabel(orderId) {
    return dataService.get("".concat(settings.api.postage, "/purchasedlabel"), orderId);
  }

  function refundLabel(shippoLabelId) {
    return dataService.save("".concat(settings.api.postage, "/refund"), shippoLabelId);
  }

  function saveDefaults(postageDefaults, primaryStoreAddress) {
    var promises = [dataService.saveAll("".concat(settings.api.postage, "/packagesize"), postageDefaults)];

    if (primaryStoreAddress) {
      promises.push(storeAddressesService.updatePrimaryAddress(primaryStoreAddress));
    }

    return $q.all(promises);
  }

  function openRefundShippingLabelModal(label, event) {
    return $translate(['BUTTON.CANCEL', 'POSTAGEFULFILLMENT.REFUNDMODAL_TITLE', 'POSTAGEFULFILLMENT.REFUNDMODAL_DESCRIPTION', 'POSTAGEFULFILLMENT.REFUNDMODAL_OKBUTTON'], {
      refundamount: convertCentsToDollars(label.invoice.amount)
    }).then(function (translations) {
      return $mdDialog.show($mdDialog.confirm().title(translations['POSTAGEFULFILLMENT.REFUNDMODAL_TITLE']).htmlContent("<p class=\"refund-label-modal-content\">\n                            ".concat(translations['POSTAGEFULFILLMENT.REFUNDMODAL_DESCRIPTION'], "\n                        </p>")).targetEvent(event).ok(translations['POSTAGEFULFILLMENT.REFUNDMODAL_OKBUTTON']).cancel(translations['BUTTON.CANCEL']));
    });
  }

  function openRedirectToSetupModal(error) {
    return $translate(['BUTTON.CANCEL', 'POSTAGEDEFAULTSSETUP.REDIRECTMODAL_TITLE_NOCARD', 'POSTAGEDEFAULTSSETUP.REDIRECTMODAL_TITLE_NOADDRESS', 'POSTAGEDEFAULTSSETUP.REDIRECTMODAL_TITLE_NODEFAULTS', 'POSTAGEDEFAULTSSETUP.REDIRECTMODAL_DESCRIPTION', 'POSTAGEDEFAULTSSETUP.REDIRECTMODAL_OKBUTTON']).then(function (translations) {
      var modalTitle;

      if (error.errorType === 'noStoreAddress') {
        modalTitle = translations['POSTAGEDEFAULTSSETUP.REDIRECTMODAL_TITLE_NOADDRESS'];
      } else if (error.errorType === 'noPaymentMethod') {
        modalTitle = translations['POSTAGEDEFAULTSSETUP.REDIRECTMODAL_TITLE_NOCARD'];
      } else if (error.errorType === 'noDefaults') {
        modalTitle = translations['POSTAGEDEFAULTSSETUP.REDIRECTMODAL_TITLE_NODEFAULTS'];
      }

      return $mdDialog.show($mdDialog.confirm().title(modalTitle).textContent(translations['POSTAGEDEFAULTSSETUP.REDIRECTMODAL_DESCRIPTION']).ok(translations['POSTAGEDEFAULTSSETUP.REDIRECTMODAL_OKBUTTON']).cancel(translations['BUTTON.CANCEL'])).then(function () {
        $state.go('postage.setup');
      });
    });
  }

  function generateRecipient(order) {
    return {
      name: "".concat(order.deliverTo.firstName, " ").concat(order.deliverTo.lastName),
      street: order.deliverTo.address.address1,
      street2: order.deliverTo.address.address2,
      city: order.deliverTo.address.city,
      state: order.deliverTo.address.state,
      zip: order.deliverTo.address.postalCode,
      phone: order.deliverTo.phoneNumber,
      email: order.placedBy.emailAddress
    };
  }

  function generateSender(address, storeAdmin) {
    return {
      name: "".concat(storeAdmin.firstName, " ").concat(storeAdmin.lastName),
      street: address.mailingAddress.address1,
      street2: address.mailingAddress.address2,
      city: address.mailingAddress.city,
      state: address.mailingAddress.state,
      zip: address.mailingAddress.postalCode,
      phone: address.phoneNumber,
      email: storeAdmin.email
    };
  }

  function hasConfiguredDefaults(defaults) {
    return angular.isDefined(defaults.labelType);
  }

  function showErrorToast(message) {
    $mdToast.show($mdToast.simple().textContent(message).position('bottom left'));
  }

  function convertCentsToDollars(cents) {
    return $filter('currency')((cents / 100).toFixed(2));
  }

  function getWeightOfCartItems(cartItems) {
    return (0, _reduce.default)(cartItems, function (total, item) {
      return item.product.weight ? total + item.product.weight * item.quantity : total;
    }, 0);
  }

  function getQuantityOfCartItems(cartItems) {
    return (0, _reduce.default)(cartItems, function (total, item) {
      return total + item.quantity;
    }, 0);
  }

  function getCarrierFromToken(token) {
    if (!(0, _isString.default)(token)) return;
    return token === 'custom' ? token : token.split('_', 1)[0].toLowerCase();
  }

  function getNumOfItemsMissingWeight(cartItems) {
    return (0, _reduce.default)(cartItems, function (total, item) {
      return !item.product.weight || item.product.weight === 0 ? total + 1 : total;
    }, 0);
  }

  return service;
}]).name;
exports.PostageServiceModule = PostageServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 625 */,
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoreAddressesModule = void 0;

var _data = __webpack_require__(11);

var StoreAddressesModule = angular.module('app.services.data.storeAddresses', [_data.DataServiceModule]).service('storeAddressesService', ["$q", "dataService", "settings", function ($q, dataService, settings) {
  return {
    getAddresses: getAddresses,
    getPrimaryAddress: getPrimaryAddress,
    updatePrimaryAddress: updatePrimaryAddress,
    hasPrimaryStoreAddress: hasPrimaryStoreAddress,
    add: add,
    save: save
  };

  function add(address) {
    return dataService.create(settings.api.storeAddress, {
      address: address
    });
  }

  function getAddresses() {
    return dataService.get(settings.api.storeAddresses);
  }

  function getPrimaryAddress() {
    return dataService.get(settings.api.storeAddressesPrimary).then(function (primaryAddress) {
      if (!primaryAddress || !primaryAddress.mailingAddress) {
        return $q.reject({});
      }

      return primaryAddress;
    });
  }

  function updatePrimaryAddress(address) {
    if (!address.isPrimary) {
      address.isPrimary = true;
    }

    return dataService.create(settings.api.storeAddressesPrimary, {
      address: address
    });
  }

  function save(data) {
    return dataService.create(settings.api.storeAddresses, {
      storeAddresses: data
    });
  }

  function hasPrimaryStoreAddress() {
    return dataService.get(settings.api.storeAddressesPrimary).then(function (primaryAddress) {
      return primaryAddress && primaryAddress.mailingAddress;
    }).catch(function () {
      return false;
    });
  }
}]).name;
exports.StoreAddressesModule = StoreAddressesModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridServiceModule = void 0;

var _data = __webpack_require__(11);

var _settings = __webpack_require__(15);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GridServiceModule = angular.module('app.components.grid.gridService', [_settings.AppSettingsModule, _data.DataServiceModule]).factory('gridService', ["$q", "dataService", "settings", function ($q, dataService, settings) {
  return {
    getItems: getItems,
    copy: copy,
    copyAll: copyAll,
    remove: remove,
    removeAll: removeAll,
    getDefaultOptions: getDefaultOptions,
    updateGridCallbacks: updateGridCallbacks
  };

  function getItems(endpoint, page, count, sort, filter) {
    var additionalParams = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var options;
    page = page || 1;
    count = count || 25;
    var isRestEndpoint = [settings.api.cartsREST].includes(endpoint);

    if (isRestEndpoint) {
      options = {
        first: count,
        skip: (page - 1) * count
      };
    } else {
      options = {
        pageSize: count,
        startIndex: (page - 1) * count
      };
    }

    Object.assign(options, _objectSpread({
      filter: filter || null
    }, additionalParams));

    if (sort && sort.length) {
      options.sortBy = sort[0].replace(' ', '+');
    }

    return dataService.getAll(endpoint, options);
  }

  function copy(endpoint) {
    return function (item, nameLength) {
      var copyItem = angular.copy(item);
      return dataService.copy(endpoint, copyItem, nameLength);
    };
  }

  function copyAll(endpoint) {
    return function (items, nameLength) {
      var promises = items.map(function (item) {
        return copy(endpoint)(item, nameLength);
      });
      return $q.all(promises);
    };
  }

  function promiseSerial(funcs) {
    return funcs.reduce(function (result, value) {
      return result.then(function (response) {
        return value().then(Array.prototype.concat.bind(response));
      });
    }, $q.resolve([]));
  }

  function remove(endpoint, item) {
    return dataService.remove(endpoint, item.id);
  }

  function removeAll(endpoint, items) {
    var functions = [];

    var _loop = function _loop(i) {
      functions.push(function () {
        return dataService.remove(endpoint, items[i].id);
      });
    };

    for (var i = 0; i < items.length; i += 1) {
      _loop(i);
    }

    return promiseSerial(functions);
  }

  function getDefaultOptions(endpoint, onDataResponse, filter) {
    var gridOptions = {
      isLoading: false,
      onLoad: function onLoad() {},
      paging: {
        pageSize: 25,
        pageSizeOptions: [10, 25, 50, 100],
        onPageChange: null
      },
      sorting: {
        onSortChange: null
      }
    };
    updateGridCallbacks(endpoint, filter, gridOptions, onDataResponse);
    return gridOptions;
  }

  function updateGridCallbacks(endpoint, filter, gridOptions, onDataResponse) {
    var pageChange = createChangeCallback(endpoint, onDataResponse, filter, gridOptions, 'page');
    var sortChange = createChangeCallback(endpoint, onDataResponse, filter, gridOptions, 'sort');
    gridOptions.paging.onPageChange = pageChange;
    gridOptions.sorting.onSortChange = sortChange;
  }

  function createChangeCallback(endpoint, callback, filter, gridOptions, changeType) {
    return function (page, count, sort) {
      var options;
      page = page || 1;
      count = count || 25;

      if (gridOptions && changeType !== 'page') {
        gridOptions.isLoading = true;
      }

      options = {
        pageSize: this.pageSize || count,
        startIndex: (page - 1) * count,
        filter: filter || null
      };

      if (sort && sort.length) {
        options.sortBy = sort[0].replace(' ', '+');
      }

      dataService.getAll(endpoint, options).then(function (data) {
        callback(data, changeType);
      });
    };
  }
}]).name;
exports.GridServiceModule = GridServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 628 */,
/* 629 */,
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingModalService = void 0;

__webpack_require__(1519);

var LoadingModalService = angular.module('app.components.modals.loadingModal', ['ngMaterial']).service('loadingModalService', ["$mdDialog", function ($mdDialog) {
  return {
    show: show,
    hide: hide
  };

  function show() {
    return $mdDialog.show({
      template: "\n                    <md-dialog class=\"loading-modal\">\n                        <md-progress-circular class=\"loading-modal__loader\" md-mode=\"indeterminate\" md-diameter=\"35\">\n                        </md-progress-circular>\n                    </md-dialog>\n                ",
      parent: angular.element('body'),
      clickOutsideToClose: false
    });
  }

  function hide() {
    return $mdDialog.hide();
  }
}]).name;
exports.LoadingModalService = LoadingModalService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ORDER_FULFILLMENT_STATUS: {
    FULFILLED: 'fulfilled',
    PARTIAL: 'partial',
    UNFULFILLED: 'unfulfilled'
  },
  FULFILLMENT_MODAL_STATUS: {
    FULL: 'full',
    PARTIAL: 'partial',
    NONE: 'none'
  },
  DEFAULT_FULFILLER: 'Local Inventory',
  FULFILLMENT_METHOD: {
    MANUAL: 'manual',
    LABEL: 'label'
  },
  PAYMENT_METHODS: {
    CASH: 'Cash',
    CREDIT: 'Credit Card',
    PO: 'Purchase Order',
    PAYPAL: 'PayPal'
  },
  SHIPPING_METHODS: {
    UPS: 'UPS',
    FEDEX: 'FedEx',
    USPS: 'USPS',
    DHL: 'DHL',
    PICKUP: 'In-person pickup'
  },
  NO_SHIPPING: 'Service - no shipping',
  SHIPPING_SETUP_ERRORS: {
    NO_STORE_ADDRESS: 'noStoreAddress',
    NO_PAYMENT_METHOD: 'noPaymentMethod',
    NO_DEFAULTS: 'noDefaults'
  },
  DISCOUNT_TYPE: {
    CUSTOM: 'custom',
    FIXED: 'fixed',
    PERCENT: 'percent'
  },
  PAYMENT_EVENT_TYPE: {
    ADJUSTMENT_CHARGE: 'AdjustmentCharge',
    CHARGE: 'charge',
    REAUTHORIZE: 'Reauthorize',
    REFUND: 'refund'
  }
};
exports.default = _default;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerServiceModule = void 0;

var _angularFileSaver = _interopRequireDefault(__webpack_require__(426));

var _data = __webpack_require__(11);

var _authToken = __webpack_require__(43);

var _settings = __webpack_require__(15);

var _search = __webpack_require__(120);

var _onboarding = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerServiceModule = angular.module('app.pages.customers.customersService', [_angularFileSaver.default, _data.DataServiceModule, _authToken.AuthTokenServiceModule, _settings.AppSettingsModule, _search.SearchServiceModule, _onboarding.OnboardingServiceModule]).service('customerService', ["$q", "$filter", "$window", "dataService", "authTokenService", "searchService", "settings", "FileSaver", "onboardingService", function ($q, $filter, $window, dataService, authTokenService, searchService, settings, FileSaver, onboardingService) {
  return {
    save: save,
    saveAll: saveAll,
    create: create,
    removeCustomer: removeCustomer,
    bulkUpload: bulkUpload,
    copyCustomer: copyCustomer,
    copyCustomers: copyCustomers,
    getCustomer: getCustomer,
    getCustomers: getCustomers,
    getMetrics: getMetrics,
    getCustomerCount: getCustomerCount,
    getCustomersSorted: getCustomersSorted,
    getBulkUploadStatus: getBulkUploadStatus,
    exportCustomers: exportCustomers,
    getShippingAddresses: getShippingAddresses,
    getShippingAddress: getShippingAddress,
    addShippingAddress: addShippingAddress,
    updateShippingAddress: updateShippingAddress,
    deleteShippingAddress: deleteShippingAddress,
    getAvalaraEntityUseCodes: getAvalaraEntityUseCodes
  };

  function save(customer) {
    return dataService.save(settings.api.customers, customer.id, customer);
  }

  function saveAll(customers) {
    var promises = [];

    for (var i = 0; i < customers.length; i += 1) {
      var customer = angular.copy(customers[i]);
      promises.push(dataService.save(settings.api.customers, customer.id, customer));
    }

    return $q.all(promises);
  }

  function create(customer) {
    return dataService.create(settings.api.customers, customer).then(function (newCustomer) {
      var taskId = 'organize.addCustomer';
      var sessionKey = 'customersService:firstCustomerCreated';
      $window.sessionStorage.setItem('customersService:customerCreated', true);
      return onboardingService.completeInitialTask(taskId, sessionKey).then(function () {
        return newCustomer;
      });
    });
  }

  function removeCustomer(customer) {
    return dataService.remove(settings.api.customers, customer.id);
  }

  function bulkUpload(csvObj) {
    return dataService.saveAll(settings.api.customerBulkUpload, csvObj);
  }

  function getBulkUploadStatus() {
    return dataService.get(settings.api.customerBulkUploadStatus);
  }

  function copyCustomer(item, nameLength) {
    nameLength = nameLength || 35;
    var strLength = nameLength - 7;
    var copyItem = angular.copy(item);
    copyItem.name = "".concat(item.name.substring(0, strLength), " - COPY");
    return dataService.create(settings.api.customers, copyItem);
  }

  function copyCustomers(items, nameLength) {
    var promises = [];
    Object.keys(items).forEach(function (i) {
      var copyItem = angular.copy(items[i]);
      promises.push(dataService.copy(settings.api.customers, copyItem, nameLength));
    });
    return $q.all(promises);
  }

  function getCustomer(id) {
    return dataService.get(settings.api.customers, id);
  }

  function getCustomers(page, count, sortBy, sortDirection, options) {
    options = options || {};
    page = page || 1;
    count = count || 50;
    options.pageSize = count;
    options.startIndex = (page - 1) * count;

    if (sortBy && sortDirection) {
      options.sortBy = sortBy;
      options.sortDirection = sortDirection;
    }

    return dataService.getAll(settings.api.customers, options);
  }

  function getMetrics() {
    var newCustomerCountPromise = getCustomerCountLast30Days();
    var totalCustomerCountPromise = getCustomerCount();
    return $q.all([newCustomerCountPromise, totalCustomerCountPromise]).then(function (response) {
      return {
        newCustomerCount: response[0],
        totalCustomerCount: response[1]
      };
    });
  }

  function getCustomersSorted() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var hitsPerPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
    var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'customers_lastname_asc';
    var searchOptions = {
      page: page - 1,
      hitsPerPage: hitsPerPage
    };
    return searchService.getAll(sort, '', searchOptions).then(function (data) {
      return {
        items: data.hits,
        totalCount: data.nbHits
      };
    });
  }

  function getCustomerCountLast30Days() {
    return dataService.getAll(settings.api.customersCount, {}).then(function (response) {
      return response;
    });
  }

  function getCustomerCount() {
    return dataService.getAll(settings.api.customers, {}).then(function (response) {
      return response.totalCount;
    });
  }

  function exportCustomers() {
    return dataService.get("".concat(settings.api.customers, "/export")).then(function (response) {
      return saveStringToCsv(response.csvData, 'VolusionCustomerExport.csv');
    });
  }

  function saveStringToCsv(string, fileName) {
    var blob = new Blob([string], {
      type: 'text/csv'
    });
    FileSaver.saveAs(blob, fileName);
    return blob;
  }

  function getShippingAddresses(customerId) {
    return dataService.getAll("".concat(settings.api.customers, "/").concat(customerId, "/shippingaddress"));
  }

  function getShippingAddress(customerId, addressId) {
    return dataService.get("".concat(settings.api.customers, "/").concat(customerId, "/shippingaddress/").concat(addressId));
  }

  function addShippingAddress(customerId, address) {
    return dataService.create("".concat(settings.api.customers, "/").concat(customerId, "/shippingaddress"), address);
  }

  function updateShippingAddress(customerId, address) {
    return dataService.save("".concat(settings.api.customers, "/").concat(customerId, "/shippingaddress"), address.id, address);
  }

  function deleteShippingAddress(customerId, addressId) {
    return dataService.remove("".concat(settings.api.customers, "/").concat(customerId, "/shippingaddress/").concat(addressId));
  }

  function getAvalaraEntityUseCodes() {
    return dataService.get(settings.api.avalaraEntityUseCodes);
  }
}]).name;
exports.CustomerServiceModule = CustomerServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 633 */,
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageTitle = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageTitle = _styledComponents.default.span.withConfig({
  displayName: "Typography__PageTitle",
  componentId: "sc-1042j1e-0"
})(["font-size:16px;font-weight:bold;letter-spacing:0.1em;vertical-align:middle;text-transform:uppercase;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"]);

exports.PageTitle = PageTitle;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = __webpack_require__(379);

var theme = (0, _styles.createMuiTheme)({
  palette: {
    primary: {
      main: '#FFAB00',
      light: 'rgba(0, 0, 0, 0.87)',
      dark: '#FFAB00'
    },
    secondary: {
      main: '#757575'
    },
    error: {
      main: 'rgb(221,44,0)'
    }
  },
  typography: {
    fontFamily: '"Lato", sans-serif'
  }
});
var _default = theme;
exports.default = _default;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestrictCurrency = void 0;

var _chunk = _interopRequireDefault(__webpack_require__(737));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RestrictCurrency = angular.module('app.directives.restrictCurrency', []).directive('restrictCurrency', function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, ele, attrs, ngModel) {
      //group 1 returns all values in front of decimal and 2 decimals following
      var priceRegex = /^((\d*|,\d*)*(\.\d{0,2})?)/g;

      var formatCurrency = function formatCurrency() {
        var value = ele.val();
        var oldVal = value;
        var cursor = ele[0].selectionEnd;
        value = value.replace(/,/g, '');

        if (value) {
          var splitVal = new RegExp(priceRegex).exec(value.toString());

          if (splitVal[1] != null && splitVal[1] !== '') {
            var newVal = getCommaVal(splitVal[1]);
            ele.val(newVal);
            cursor += newVal.length - oldVal.length >= 1 && cursor > newVal.indexOf(',') ? 1 : 0; // We've added a comma and updated our cursor position accordingly

            ele[0].setSelectionRange(cursor, cursor);
          } else {
            ngModel.$setViewValue('');
            ngModel.$render();
            return false;
          }
        }

        return false;
      };

      ele.on('input', formatCurrency);
      ngModel.$formatters.push(function (value) {
        if (value) {
          var splitVal = new RegExp(priceRegex).exec(value.toString());

          if (splitVal[1] != null && splitVal[1] !== '') {
            var val = getCommaVal(splitVal[1]);
            var decimalSplit = val.split('.');

            if (!decimalSplit[1]) {
              decimalSplit[1] = '00';
            } else if (decimalSplit[1].length === 1) {
              decimalSplit[1] += '0';
            }

            return decimalSplit.join('.');
          }

          ngModel.$setViewValue('');
          ngModel.$render();
          return value;
        }

        return value;
      });
      ngModel.$parsers.push(function (value) {
        var splitVal = new RegExp(priceRegex).exec(value.toString());

        if (splitVal[1] != null && splitVal[1] !== '') {
          return parseFloat(splitVal[1].replace(/,/g, ''));
        }

        ngModel.$setViewValue('');
        ngModel.$render();
        return value;
      });

      function getCommaVal(value) {
        if (value === '' || value == null) {
          return value;
        }

        var val = value.replace(/,/g, '');
        var decSplit = val.toString().split('.');
        var decValue = decSplit[1] || null;
        var arr = decSplit[0].split('');
        var res = '';

        if (arr.length) {
          var chunked = (0, _chunk.default)(arr.reverse(), 3);
          res = chunked[chunked.length - 1].reverse().join('');

          for (var i = chunked.length - 2; i >= 0; i--) {
            res += ",".concat(chunked[i].reverse().join(''));
          }
        }

        if (decSplit.length === 2) {
          res += '.';
        }

        res += decValue || '';
        return res;
      }
    }
  };
}).name;
exports.RestrictCurrency = RestrictCurrency;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoreSettingsServiceModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _data = __webpack_require__(11);

var _storeInformation = __webpack_require__(38);

var _settings = __webpack_require__(15);

var _expireCache = __webpack_require__(255);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreSettingsServiceModule = angular.module('app.services.data.storeSettings', [_data.DataServiceModule, _storeInformation.StoreInformationServiceModule, _settings.AppSettingsModule, _expireCache.ExpireCacheServiceModule]).service('storeSettingsService', ["$q", "dataService", "storeInformationService", "settings", "expireCache", function ($q, dataService, storeInformationService, settings, expireCache) {
  return {
    tabs: {
      STOREINFO: 0,
      PAYMENT: 1,
      SHIPPING: 2,
      SEO: 3
    },
    get: get,
    save: save,
    getShippingMethods: getShippingMethods,
    getShippingMethodsOrDefault: getShippingMethodsOrDefault,
    getStoreSettings: getStoreSettings,
    isPlaceholderShipping: isPlaceholderShipping,
    createDefaultShippingMethods: createDefaultShippingMethods
  };

  function get() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return $q.all([storeInformationService.getStore(force), getShippingMethods()]).then(function (response) {
      return {
        storeInformation: response[0],
        shippingMethods: response[1]
      };
    });
  }

  function save(storeInformation, shippingMethods) {
    var _this = this;

    return $q.all([storeInformationService.save(storeInformation), saveShippingMethods(shippingMethods)]).then(expireCache).then(function (response) {
      return {
        storeInformation: response[0],
        shippingMethods: response[1]
      };
    }).catch(function (error) {
      if (isConflictError(error)) {
        var force = true;
        return _this.get(force).then(function (response) {
          if (response.storeInformation.emailVerified && !storeInformation.emailVerified) {
            storeInformation.emailVerified = true;
            storeInformation.revision = response.storeInformation.revision;
            shippingMethods.revision = response.shippingMethods.revision;
            return _this.save(storeInformation, shippingMethods);
          }

          return $q.reject({
            onCatch: 'resetModel'
          });
        });
      }

      if (isStoreUrlInUseError(error)) {
        return $q.reject({
          onCatch: 'showStoreUrlInUseError',
          message: error.data.message
        });
      }

      return $q.reject(error);
    });
  }

  function isConflictError(error) {
    return error.data && error.data.statusCode === 409 || error.status === 409;
  }

  function isStoreUrlInUseError(error) {
    return error.data && error.data.statusCode === 400 && error.data.message.indexOf('is being used by another store') >= 0;
  }

  function getStoreSettings() {
    return dataService.get(settings.api.storeSettings);
  }

  function getShippingMethods(clearCache) {
    var endpoint = settings.api.shippingMethods;
    if (clearCache) endpoint = "".concat(endpoint, "?").concat(new Date().getTime());
    return getShippingMethodsFromEndpoint(endpoint);
  }

  function getShippingMethodsOrDefault() {
    var _this2 = this;

    var force = true;
    return this.getShippingMethods(force).then(function (response) {
      if (response === null) {
        return storeInformationService.getStore(force).then(function (storeInformation) {
          return _this2.save(storeInformation, _this2.createDefaultShippingMethods());
        }).then(function (data) {
          return data.shippingMethods;
        });
      }

      if (_this2.isPlaceholderShipping(response)) {
        return _this2.createDefaultShippingMethods(response);
      }

      return response;
    });
  }

  function getShippingMethodsFromEndpoint(endpoint) {
    return dataService.get(endpoint).then(function (response) {
      if (response.items && response.items[0]) return response.items[0]; // old endpoint

      return response;
    }).catch(function () {
      return null;
    });
  }

  function saveShippingMethods(shippingMethods) {
    return saveShippingMethodsToEndpoint(settings.api.shippingMethods, shippingMethods);
  }

  function saveShippingMethodsToEndpoint(endpoint, shippingMethods) {
    if (shippingMethods.id) {
      return dataService.save(endpoint, null, shippingMethods);
    }

    return dataService.create(endpoint, shippingMethods);
  }

  function isPlaceholderShipping(shippingMethods) {
    if (shippingMethods === null) return false;
    if (shippingMethods.shippingBand) return false; // Legacy shipping, will be migrated by settings detail

    if (!shippingMethods.shippingBands) return false;
    var bands = shippingMethods.shippingBands;
    return !(bands.byPrice.enabled || bands.byWeight.enabled || bands.free.enabled);
  }

  function createDefaultShippingMethods() {
    var shippingMethods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _assign.default)(shippingMethods, {
      shippingBands: {
        byPrice: {
          enabled: false,
          bands: []
        },
        byWeight: {
          enabled: false,
          bands: []
        },
        free: {
          enabled: true,
          deliveryEstimate: '',
          priceThreshold: 0
        }
      }
    });
  }
}]).name;
exports.StoreSettingsServiceModule = StoreSettingsServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotspotModule = void 0;

var _react2angular = __webpack_require__(97);

var _index = _interopRequireDefault(__webpack_require__(1377));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HotspotModule = angular.module('app.components.hotspot', []).component('hotspot', (0, _react2angular.react2angular)(_index.default)).name;
exports.HotspotModule = HotspotModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeoHelperServiceModule = void 0;

var _seo = __webpack_require__(1472);

var _stripHtml = __webpack_require__(407);

var _constants = __webpack_require__(24);

var SeoHelperServiceModule = angular.module('app.services.utilities.seoHelperService', [_seo.SeoFilterModule, _stripHtml.StripHtmlFilterModule]).factory('seoHelperService', ["$filter", function ($filter) {
  var nameChanged = false;

  function shouldUpdateTitle(model) {
    if (!model.name) {
      return false;
    }

    var hasNameChanged = nameChanged || model.hasChanges('name');
    var hasTitleChanged = model.seo.hasChanges('title');
    var hasTitle = model.seo.title;
    return hasNameChanged && !hasTitleChanged || !hasTitle;
  }

  function shouldUpdateFriendlyName(model, state) {
    var hasName = model.seo.friendlyName;
    var hasChanges = model.seo.hasChanges('friendlyName');
    nameChanged = model.hasChanges('name');
    return !hasName || hasName && !hasChanges && (state.add || nameChanged);
  }

  function fillDefaultValues(model, state) {
    var isPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (shouldUpdateFriendlyName(model, state)) {
      model.seo.friendlyName = $filter('seoFilter')(model.name.substring(0, 255));
      model.seo.update('friendlyName');
    } else {
      model.seo.friendlyName = $filter('seoFilter')(model.seo.friendlyName);
    }

    if (shouldUpdateTitle(model)) {
      nameChanged = true;
      model.seo.title = model.name.substring(0, 60);
      model.seo.update('title');
    }

    if (model.seo.hasChanges('title')) {
      nameChanged = false;
    }

    if (isPage && !model.seo.metaDescription && model.content) {
      model.seo.metaDescription = $filter('stripHTML')(model.content.substring(0, 160));
      model.seo.metaDescription = model.seo.metaDescription.replace(/[\n\r]/g, ' ').trim();
      model.seo.update('metaDescription');
    }

    if (!isPage && !model.seo.metaDescription && model.descriptions.long) {
      model.seo.metaDescription = $filter('stripHTML')(model.descriptions.long).substring(0, 160);
      model.seo.update('metaDescription');
    } // category


    if (!isPage && !model.categoryIds && model.descriptions.long) {
      model.descriptions.long = $filter('stripHTML')(model.descriptions.long, _constants.ALLOWED_TAGS);
      model.descriptions.update('long');
    } // product


    if (!isPage && model.categoryIds && model.descriptions.long) {
      model.descriptions.long = $filter('stripHTML')(model.descriptions.long, _constants.ALLOWED_TAGS);
    }
  }

  return {
    fillDefaultValues: fillDefaultValues
  };
}]).name;
exports.SeoHelperServiceModule = SeoHelperServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidateMin = void 0;
var ValidateMin = angular.module('app.directives.vlnMin', []).directive('vlnMin', ["$parse", function ($parse) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, ele, attrs, ngModel) {
      if (!attrs.vlnMin) {
        throw new Error('Min attribute required for vln-min');
      }

      scope.$watch(attrs.vlnMin, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          ngModel.$validate();
        }
      });

      ngModel.$validators.min = function (modelValue) {
        var other = $parse(attrs.vlnMin)(scope);

        if (other != null && modelValue != null && modelValue !== '') {
          return modelValue >= other;
        }

        return true;
      };
    }
  };
}]).name;
exports.ValidateMin = ValidateMin;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidateMax = void 0;
var ValidateMax = angular.module('app.directives.vlnMax', []).directive('vlnMax', ["$parse", function ($parse) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, ele, attrs, ngModel) {
      if (!attrs.vlnMax) {
        throw new Error('Max attribute required for vln-max');
      }

      ele.on('input', function () {
        var max = $parse(attrs.vlnMax)(scope);
        var value = ele.val();
        value = value.replace(/,/g, '');
        value = parseFloat(value);

        if (value > max) {
          ngModel.$setViewValue(max);
          ngModel.$render();
        }
      });
      scope.$watch(attrs.vlnMax, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          ngModel.$validate();
        }
      });

      ngModel.$validators.max = function (modelValue) {
        var max = $parse(attrs.vlnMax)(scope);

        if (max != null && modelValue != null && modelValue !== '') {
          return modelValue <= max;
        }

        return true;
      };
    }
  };
}]).name;
exports.ValidateMax = ValidateMax;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 642 */,
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidatePhoneDirectiveModule = void 0;

var _constants = __webpack_require__(24);

var ValidatePhoneDirectiveModule = angular.module('app.directives.validatePhone', []).directive('vlnValidatePhone', function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModelCtrl) {
      ngModelCtrl.$validators.validPhone = function (modelValue, viewValue) {
        var value = modelValue || viewValue;
        if (value == null || value === '' || value === '(') return true;
        var regExp = new RegExp("^\\s*(\\d{".concat(_constants.PHONE_NUM_MIN, ",").concat(_constants.PHONE_NUM_MAX, "})\\s*$"));
        return regExp.test(value);
      };
    }
  };
}).name;
exports.ValidatePhoneDirectiveModule = ValidatePhoneDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

var _thread = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconButton = (0, _styledComponents.default)(_thread.Button).attrs({
  variant: 'icon'
}).withConfig({
  displayName: "IconButton",
  componentId: "xx7z5t-0"
})(["width:", ";height:", ";min-width:", ";padding:0;background-color:transparent !important;i{font-size:", " !important;}"], function (props) {
  return props.iconSize || '24px';
}, function (props) {
  return props.iconSize || '24px';
}, function (props) {
  return props.iconSize || '24px';
}, function (props) {
  return props.iconSize || '24px';
});
var _default = IconButton;
exports.default = _default;

/***/ }),
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageManagerModule = void 0;

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _ngFileUpload = _interopRequireDefault(__webpack_require__(205));

var _uniq = _interopRequireDefault(__webpack_require__(394));

var _remove = _interopRequireDefault(__webpack_require__(193));

var _extend = _interopRequireDefault(__webpack_require__(415));

var _isArray = _interopRequireDefault(__webpack_require__(18));

var _findIndex = _interopRequireDefault(__webpack_require__(192));

var _isEqual = _interopRequireDefault(__webpack_require__(633));

var _index = __webpack_require__(527);

var _dialog = __webpack_require__(569);

var _imageReader = __webpack_require__(421);

var _images = __webpack_require__(405);

var _model = __webpack_require__(165);

var _imageLibrary = __webpack_require__(372);

var _cameraIcon = __webpack_require__(1261);

var _imageScroller = __webpack_require__(1263);

var _imageManager = _interopRequireDefault(__webpack_require__(1264));

__webpack_require__(1265);

var _imageMetadataModal = _interopRequireDefault(__webpack_require__(1266));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageManagerModule = angular.module('app.components.imageManager', [_angularTranslate.default, 'ngMaterial', _ngFileUpload.default, _index.ImageEditorModule, _dialog.VlnDialogControllerModule, _imageReader.ImageReaderServiceModule, _images.ImagesServiceModule, _model.ModelServiceModule, _imageScroller.ImageScrollerModule, _imageLibrary.ImageLibraryModule, _cameraIcon.CameraIconModule]).directive('imageManager', ["$window", "$translate", "$mdToast", "$timeout", "$rootScope", "modelService", "$mdDialog", "imageReader", "imagesService", function ($window, $translate, $mdToast, $timeout, $rootScope, modelService, $mdDialog, imageReader, imagesService) {
  return {
    restrict: 'E',
    template: _imageManager.default,
    scope: {
      images: '=?',
      image: '=?',
      whitelist: '=?',
      preWhitelist: '<?',
      onWhitelistChange: '&?',
      libraryOverride: '&?',
      singleMode: '=',
      galleryMode: '=',
      imageLibraryContext: '@',
      imageLibraryAssociationTags: '=',
      size: '@',
      onRemoveImageClicked: '&',
      onImageUploaded: '&',
      retrieveStorefrontInfo: '&',
      isPinterestEnabled: '=',
      bypassImageTransformation: '<'
    },
    link: function link(scope, ele, attrs) {
      scope.gtmid = attrs.gtmid || null;
    },
    controller: ["$scope", function imageManagerController($scope) {
      this.registerScroller = registerScroller;
      var imageLimit = 2500;
      var vm = {
        files: [],
        singleMode: $scope.singleMode,
        size: $scope.size || 'lg',
        galleryMode: $scope.galleryMode,
        croppedImage: null,
        scroller: null,
        cropHeight: 0,
        cropWidth: 0,
        preWhitelist: $scope.preWhitelist,
        hasWhitelist: !!$scope.whitelist,
        imageLimitReached: false,
        isPinterestEnabled: $scope.isPinterestEnabled,
        isImageEditModalOpen: false,
        imageId: '',
        imageUrl: '',
        gtmImageSaveEventName: '',
        onLibraryImagesSelected: onLibraryImagesSelected,
        uploadImages: uploadImages,
        uploadFile: uploadFile,
        openEditor: openEditor,
        openImageMetadataModal: openImageMetadataModal,
        removeImage: removeImage,
        trackDrop: trackDrop,
        hasImage: hasImage,
        moveImageRight: moveImageRight,
        moveImageLeft: moveImageLeft,
        shouldShowMoveImageLeft: shouldShowMoveImageLeft,
        shouldShowMoveImageRight: shouldShowMoveImageRight,
        whitelistFilter: whitelistFilter,
        preWhitelistFilter: preWhitelistFilter,
        postImageToPinterest: postImageToPinterest,
        onCloseImageEditor: onCloseImageEditor
      };
      init();

      function init() {
        $scope.vm = vm;
        $scope.$on('resetImages', function () {
          vm.scroller.resetScroll();
        });
        getImagesCount();
        $scope.$on('draggableDropSuccess', resetImages);

        if ($scope.libraryOverride) {
          vm.libraryOverrideFunc = function () {
            $scope.libraryOverride()();
            $scope.$apply();
          };

          vm.hasLibraryOverride = true;
        }

        $scope.$on('imageManager:onLibrarySelected', function (event, images) {
          onLibraryImagesSelected(images);
        });
      }

      function resetImages() {
        var imagesCopy = angular.copy($scope.images);
        $scope.images = [];
        $scope.$apply();
        $scope.images = imagesCopy;
        $scope.$apply();
      }

      function getImagesCount() {
        var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return imagesService.getImagesFromAlgolia(tags, page, count).then(function (data) {
          return data.nbHits;
        }).then(function (totalCount) {
          imagesService.getImageLimit().then(function (limit) {
            imageLimit = limit;
            vm.imageLimitReached = totalCount >= imageLimit;
          });
        });
      }

      function onLibraryImagesSelected(selectedImages) {
        if (!vm.singleMode) {
          angular.forEach(selectedImages, function (image) {
            var newImage = {
              imageLink: image
            };

            if (!isAlreadyInImages(newImage)) {
              $scope.images.push(modelService.makeModel(newImage, 'imageMetadataModel'));
            }

            if ($scope.whitelist) {
              $scope.whitelist.push(newImage.imageLink.id);
              $scope.whitelist = (0, _uniq.default)($scope.whitelist);
              $scope.onWhitelistChange()($scope.whitelist);
              $scope.$emit('imageManager:onLibrarySelectedComplete');
            }
          });
        } else {
          var newImage = {
            imageLink: selectedImages
          };
          angular.extend($scope.image, newImage);
        }

        $scope.onImageUploaded();
      }

      function isAlreadyInImages(newImage) {
        var existingImageIds = $scope.images.map(function (img) {
          return img.imageLink.id;
        });
        return existingImageIds.indexOf(newImage.imageLink.id) !== -1;
      }

      function registerScroller(scroller) {
        vm.scroller = scroller;
      }

      function uploadImages(files, rejected) {
        if (vm.imageLimitReached) {
          $translate('ERROR.IMAGELIMITREACHED').then(function (error) {
            $mdToast.show($mdToast.simple().textContent(error).position('bottom left'));
          });
          return;
        }

        if (rejected && rejected.length) {
          $translate('ERROR.IMAGEVALIDATION').then(function (error) {
            $mdToast.show($mdToast.simple().textContent(error).position('bottom left'));
          });
        }

        if (!files) {
          return;
        }

        vm.files = vm.files.concat(files);
        files.forEach(function (file) {
          return vm.uploadFile(file);
        });
        $window.dataLayer.push({
          event: "".concat($scope.gtmid, "-uploadImage")
        });
      }

      function uploadFile(file, idx) {
        file.progress = 0;
        imageReader.getImageData(file).then(function (data) {
          return imagesService.saveImage(data);
        }, function () {
          (0, _remove.default)(vm.files, file);
        }, function (completedPercentage) {
          file.progress = completedPercentage;
        }).then(function (response) {
          $scope.onImageUploaded();
          (0, _remove.default)(vm.files, file);
          var newImage = {
            imageLink: response
          };

          if (vm.singleMode) {
            $scope.image = modelService.makeModel(newImage, 'imageMetadataModel');
          } else {
            if (idx != null) {
              newImage = (0, _extend.default)({}, $scope.images[idx], newImage);
              $scope.images.splice(idx, 1, modelService.makeModel(newImage, 'imageMetadataModel'));
            } else {
              $scope.images.push(modelService.makeModel(newImage, 'imageMetadataModel'));
            }
          }

          if ($scope.whitelist) {
            $scope.whitelist.push(newImage.imageLink.id);
            $scope.whitelist = (0, _uniq.default)($scope.whitelist);
            $scope.onWhitelistChange()($scope.whitelist);
          }

          vm.isImageEditModalOpen = false;
          $mdToast.show($mdToast.simple().textContent('Image edited successfully').position('bottom left'));
          $window.dataLayer.push({
            event: "".concat($scope.gtmid, "-editImage")
          });
        }).catch(function () {
          (0, _remove.default)(vm.files, file);
          $translate('ERROR.GENERAL_FAILURE_ERROR').then(function (error) {
            $mdToast.show($mdToast.simple().textContent(error).position('bottom left'));
          });
        });
      }

      function openImageMetadataModal(image) {
        $window.dataLayer.push({
          event: "".concat($scope.gtmid, "-imageMetadata")
        });
        vm.selectedImage = angular.copy(image);
        var dialogOptions = {
          clickOutsideToClose: true,
          template: _imageMetadataModal.default,
          scope: $scope,
          preserveScope: true,
          controller: 'vlnDialogController'
        };
        return $mdDialog.show(dialogOptions).then(function () {
          if (vm.singleMode) {
            $scope.image = vm.selectedImage;
          } else {
            var idx = $scope.images.indexOf(image);
            $scope.images.splice(idx, 1, vm.selectedImage);
          }
        });
      }

      function removeImage(image) {
        if ($scope.whitelist) {
          removeFromWhitelist(image.imageLink.id);
          return;
        }

        $rootScope.$broadcast('imageManager:imageRemoved');
        $window.dataLayer.push({
          event: "".concat($scope.gtmid, "-removeImage")
        });

        if (vm.singleMode) {
          $scope.onRemoveImageClicked(image);
        } else {
          var idx = $scope.images.indexOf(image);
          $scope.images.splice(idx, 1);
        }

        $timeout(function () {
          vm.scroller.moveIntoPosition();
        });
      }

      function removeFromWhitelist(imageLinkId) {
        var index = $scope.whitelist.indexOf(imageLinkId);

        if (index !== -1) {
          $scope.whitelist.splice(index, 1);
          $scope.onWhitelistChange()($scope.whitelist);
        }
      }

      function trackDrop() {
        $window.dataLayer.push({
          event: "".concat($scope.gtmid, "-dropImage")
        });
      }

      function openEditor(image) {
        vm.selectedImage = image;
        var idx = (0, _isArray.default)($scope.images) ? (0, _findIndex.default)($scope.images, function (img) {
          return (0, _isEqual.default)(img, vm.selectedImage);
        }) : -1;
        vm.isImageEditModalOpen = true;
        vm.imageId = image.imageLink.id;
        vm.imageUrl = image.imageLink.fullUri;
        vm.onSave = vm.uploadFile;
        vm.imageIndex = idx;
      }

      function onCloseImageEditor() {
        vm.isImageEditModalOpen = false;
        $scope.$apply();
      }

      function hasImage() {
        if (vm.singleMode) {
          return $scope.image && $scope.image.imageLink;
        }

        return $scope.images && $scope.images.length;
      }

      function moveImageRight(index) {
        if (!shouldShowMoveImageRight(index)) return;
        moveItem(index, index + 1, $scope.images);
      }

      function moveImageLeft(index) {
        if (!shouldShowMoveImageLeft(index)) return;
        moveItem(index, index - 1, $scope.images);
      }

      function moveItem(from, to, items) {
        items.splice(to, 0, $scope.images.splice(from, 1)[0]);
      }

      function shouldShowMoveImageLeft(index) {
        return $scope.images.length > 1 && index !== 0;
      }

      function shouldShowMoveImageRight(index) {
        return $scope.images.length > 1 && index !== $scope.images.length - 1;
      }

      function whitelistFilter(item) {
        if ($scope.whitelist) {
          return $scope.whitelist.indexOf(item.imageLink.id) !== -1;
        }

        return true;
      }

      function preWhitelistFilter(item) {
        if ($scope.preWhitelist) {
          return $scope.preWhitelist.indexOf(item.imageLink.id) !== -1;
        }

        return true;
      } // (image, storefrontInfo) -> { media, url, description }


      function _createPin(image, storefrontInfo) {
        return {
          media: image.imageLink.fullUri,
          url: storefrontInfo.url,
          description: storefrontInfo.name
        };
      } // see https://developers.pinterest.com/docs/widgets/save/?
      // image -> Promise(pin)


      function postImageToPinterest(image) {
        return $scope.retrieveStorefrontInfo().then(function (storefrontInfo) {
          var pin = _createPin(image, storefrontInfo);

          $window.PinUtils.pinOne(pin);
          return pin;
        });
      }
    }]
  };
}]).name;
exports.ImageManagerModule = ImageManagerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _styledComponents = _interopRequireWildcard(__webpack_require__(21));

var _thread = __webpack_require__(64);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomToolbar = (0, _styledComponents.default)(_thread.Toolbar).withConfig({
  displayName: "ModalToolbar__CustomToolbar",
  componentId: "st8e8a-0"
})(["background-color:", ";", ""], function (props) {
  return props.bgColor;
}, function (props) {
  return props.twoLineOnMobile ? (0, _styledComponents.css)(["@media (max-width:", "px){flex-direction:column;flex-flow:column-reverse;align-items:start;padding:8px 8px 16px 8px;min-height:100px;}"], _thread.mediaSizes.sm) : null;
});

var ModalToolbar = function ModalToolbar(props) {
  return _react.default.createElement(_thread.ThemeProvider, {
    theme: props.theme
  }, _react.default.createElement(CustomToolbar, props, props.children));
};

ModalToolbar.propTypes = {
  theme: _propTypes.default.object,
  bgColor: _propTypes.default.string,
  children: _propTypes.default.node
};
ModalToolbar.defaultProps = {
  theme: _thread.darkTheme,
  bgColor: '#FF8055'
};
var _default = ModalToolbar;
exports.default = _default;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneInputDirectiveModule = void 0;

var _telephone = __webpack_require__(712);

var PhoneInputDirectiveModule = angular.module('app.directives.phoneInput', [_telephone.TelephoneFilterModule]).directive('vlnPhoneInput', ["$filter", "$browser", function ($filter, $browser) {
  return {
    require: 'ngModel',
    link: function link($scope, $element, $attrs, ngModelCtrl) {
      var listener = function listener() {
        var value = $element.val().replace(/[^0-9]/g, '');
        $element.val($filter('tel')(value, false)); // if checkout form, trigger input to update model value

        if ($element[0] && !$element[0].form && $element[0].id === 'phone') {
          $element.trigger('input');
        }
      };

      ngModelCtrl.$parsers.push(function (viewValue) {
        if (viewValue) return viewValue.replace(/[^0-9]/g, '').slice(0, 17);
      });
      ngModelCtrl.$formatters.push(function (value) {
        if (value) return value.replace(/[^0-9]/g, '').slice(0, 17);
      });

      ngModelCtrl.$render = function () {
        $element.val($filter('tel')(ngModelCtrl.$viewValue, false));
        $browser.defer(listener);
      };

      $element.bind('change', listener);
      $element.bind('keydown', function (event) {
        var key = event.keyCode; // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
        // This lets us support copy and paste too

        if (key === 91 || key > 15 && key < 19 || key >= 37 && key <= 40) {
          return;
        }

        $browser.defer(listener); // Have to do this or changes don't get picked up properly
      });
      $element.bind('paste cut', function () {
        $browser.defer(listener);
      });
    }
  };
}]).name;
exports.PhoneInputDirectiveModule = PhoneInputDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuServiceModule = void 0;

var _founderGuide = __webpack_require__(155);

var _stripHtml = __webpack_require__(407);

var _data = __webpack_require__(11);

var MenuServiceModule = angular.module('app.services.data.menuService', [_data.DataServiceModule, _founderGuide.FounderGuideServiceModule, _stripHtml.StripHtmlFilterModule]).service('menuService', ["dataService", "settings", "$filter", "$timeout", "founderGuideService", function (dataService, settings, $filter, $timeout, founderGuideService) {
  return {
    getMenus: getMenus,
    getMenu: getMenu,
    removeMenu: removeMenu,
    copyMenu: copyMenu,
    save: save,
    create: create,
    sanitizeMenu: sanitizeMenu,
    addItem: addItem,
    highlightItem: highlightItem
  };

  function getMenus() {
    return dataService.getAll(settings.api.menus);
  }

  function getMenu(id) {
    return dataService.get(settings.api.menus, id);
  }

  function removeMenu(menu) {
    return dataService.remove(settings.api.menus, menu.id);
  }

  function copyMenu(item, nameLength) {
    nameLength = nameLength || 35;
    var strLength = nameLength - 7;
    var copyItem = angular.copy(item);
    copyItem.name = "".concat(item.name.substring(0, strLength), " - COPY");
    return dataService.create(settings.api.menus, copyItem);
  }

  function save(menu, id) {
    var completeTask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return dataService.save(settings.api.menus, id, menu).then(function (data) {
      if (completeTask) {
        var MILESTONE = 2;
        return founderGuideService.completeFounderGuideTask('organize.addMenu', MILESTONE).then(function () {
          return data;
        });
      }

      return data;
    });
  }

  function create(menu) {
    return dataService.create(settings.api.menus, menu);
  }

  function sanitizeMenu(item) {
    if (item.name) {
      item.name = $filter('stripHTML')(item.name);
    }

    if (item.url) {
      item.url = $filter('stripHTML')(item.url);
    }
  }

  function addItem(parent, index, item) {
    parent.splice(index + 1, 0, {
      id: item.id,
      code: item.code,
      name: item.name,
      type: item.type,
      url: item.url,
      items: []
    });
  }

  function highlightItem(parent, index) {
    var itemIndex;

    if (typeof index === 'undefined') {
      itemIndex = 0;
    } else {
      itemIndex = index + 1;
    }

    parent[itemIndex].highlight = true;
    $timeout(function () {
      parent[itemIndex].highlight = false;
    }, 1000);
  }
}]).name;
exports.MenuServiceModule = MenuServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaypalServiceModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _merge = _interopRequireDefault(__webpack_require__(277));

var _isEmpty = _interopRequireDefault(__webpack_require__(190));

var _settings = __webpack_require__(15);

var _storeInformation = __webpack_require__(38);

var _data = __webpack_require__(11);

var _model = __webpack_require__(165);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaypalServiceModule = angular.module('app.services.payment.paypalService', [_angularjs.default, _settings.AppSettingsModule, _storeInformation.StoreInformationServiceModule, _data.DataServiceModule, _model.ModelServiceModule]).service('paypalService', ["settings", "dataService", "modelService", "storeInformationService", "$window", "$q", "$state", function (settings, dataService, modelService, storeInformationService, $window, $q, $state) {
  return {
    prefill: prefill,
    isPayPalReturn: isPayPalReturn,
    handleMerchantReturn: handleMerchantReturn,
    isConnectedComplete: isConnectedComplete,
    isConnectedNeedsUpgrade: isConnectedNeedsUpgrade,
    isConnectedUnverified: isConnectedUnverified,
    connect: connect,
    disconnect: disconnect,
    hasConnectedPaypalPermissions: hasConnectedPaypalPermissions,
    setPaypalConnected: setPaypalConnected,
    getBoolean: getBoolean
  };

  function prefill(initPaypal) {
    var returnUrl = "".concat($window.location.origin).concat($state.href('settings.payments'));
    return dataService.create(settings.api.paypalPrefill, {
      returnUrl: returnUrl
    }).then(function (response) {
      if (initPaypal && $window.PAYPAL) {
        if ($window.PAYPAL.apps.Signup.loadScripts) {
          $window.PAYPAL.apps.Signup.loadScripts();
        }

        $window.PAYPAL.apps.Signup.MiniBrowser.init();
      }

      return response;
    });
  }

  function handleMerchantReturn(data, params) {
    return dataService.create(settings.api.paypalUpsert, {
      paypalMerchantId: params.merchantIdInPayPal
    }).then(function (response) {
      data.paypal = (0, _merge.default)({}, data.paypal, response);
      return data;
    });
  }

  function isPayPalReturn(params) {
    return !(0, _isEmpty.default)(params) && !!params.merchantIdInPayPal;
  }

  function isConnectedComplete(storeInfo) {
    var paypalInfo = (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.paypal) || {};
    return !(0, _isEmpty.default)(paypalInfo) && angular.isDefined(paypalInfo.acpStatus) && !!paypalInfo.merchantPayerId && getBoolean(paypalInfo.primaryEmailConfirmed) && getBoolean(paypalInfo.paymentsReceivable) && getBoolean(paypalInfo.oauthThirdPartyConfirmed);
  }

  function isConnectedUnverified(storeInfo) {
    var paypalInfo = (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.paypal) || {};
    return !(0, _isEmpty.default)(paypalInfo) && !!paypalInfo.merchantPayerId && getBoolean(paypalInfo.oauthThirdPartyConfirmed) && (getBoolean(paypalInfo.primaryEmailConfirmed) === false || getBoolean(paypalInfo.paymentsReceivable) === false);
  }

  function isConnectedNeedsUpgrade(storeInfo) {
    var paypalInfo = (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.paypal) || {};
    return !(0, _isEmpty.default)(paypalInfo) && !!paypalInfo.merchantPayerId && angular.isUndefined(paypalInfo.acpStatus);
  }

  function getBoolean(value) {
    return typeof value === 'string' ? value === 'true' : value;
  }

  function setPaypalConnected() {
    return getFreshStoreInfoModel().then(function (store) {
      store.paypal.permissionsGranted = true;
      return store;
    }).then(storeInformationService.save);
  }

  function getFreshStoreInfoModel() {
    var force = true;
    return storeInformationService.getStore(force).then(function (response) {
      return modelService.makeModel(response, 'storeInformationModel');
    });
  }

  function saveStoreInformation(updatedInfo) {
    return storeInformationService.save(updatedInfo).then(function (response) {
      return response;
    });
  }

  function connect() {
    return dataService.create(settings.api.paypalConnect, {});
  }

  function disconnect(data) {
    var info = angular.copy(data);
    var paypalPropertiesToRetain = {
      isEnabled: info.paypal.isEnabled
    };
    info.paypal = paypalPropertiesToRetain;
    return $q.all([saveStoreInformation(info), dataService.create(settings.api.paypalDisconnect, {})]);
  }

  function hasConnectedPaypalPermissions(data) {
    return !!(data.paypal && data.paypal.permissions && data.paypal.permissions.indexOf('EXPRESS_CHECKOUT') !== -1 && data.paypal.permissions.indexOf('REFUND') !== -1 && data.paypal.permissions.indexOf('AUTH_CAPTURE') !== -1);
  }
}]).name;
exports.PaypalServiceModule = PaypalServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoModule = void 0;

var _logo = __webpack_require__(1370);

var LogoModule = angular.module('app.components.logo', []).component('logo', _logo.logoComponent).name;
exports.LogoModule = LogoModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LaunchCalendlyModalModule = void 0;

var _subscription = __webpack_require__(42);

var _trial = __webpack_require__(60);

var _calendlyModal = __webpack_require__(1436);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LaunchCalendlyModalModule = angular.module('app.components.launchCalendly', [_calendlyModal.CalendlyModalModule, _subscription.SubscriptionServiceModule, _trial.TrialServiceModule]).service('launchCalendlyModal', ["$mdDialog", "$q", "subscriptionsService", "trialService", function ($mdDialog, $q, subscriptionsService, trialService) {
  function open(link) {
    return $mdDialog.show({
      parent: angular.element('body'),
      clickOutsideToClose: true,
      fullscreen: true,
      hasBackdrop: true,
      template: "\n                <md-dialog\n                    class=\"calendly-modal\"\n                    aria-label=\"Schedule a call dialog\">\n                        <calendly-modal link=\"'".concat(link, "'\"></calendly-modal>\n                </md-dialog>")
    });
  }

  function isProPlan(planId) {
    return ["NOTCREATED", "NOTCREATED", "plan_EOIuLBzWsZ7trN", "plan_DTeJsSf8gMNfes", "plan_D2iY7XoadtSZRb", "e69ecc42709f4dc5a5cdb11434417873"].includes(planId);
  }

  function getSupportUrl() {
    return $q.all([subscriptionsService.getPlan(), trialService.getTrialStatus()]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          plan = _ref2[0],
          trialStatus = _ref2[1];

      if (trialStatus !== _trial.NOT_TRIAL) {
        return 'https://calendly.com/v2-ce-call-scheduling';
      }

      return isProPlan(plan.id) ? 'https://calendly.com/professional-plan-schedule-a-call' : 'https://calendly.com/v2-ce-call-scheduling';
    });
  }

  function openSupportScheduler() {
    return getSupportUrl().then(open);
  }

  function openCancellationScheduler() {
    return open('https://calendly.com/happiness-2/15min');
  }

  function openOnboardingScheduler() {
    return open('https://calendly.com/volusion-advisors-v2/call');
  }

  return {
    openOnboardingScheduler: openOnboardingScheduler,
    openSupportScheduler: openSupportScheduler,
    openCancellationScheduler: openCancellationScheduler
  };
}]).name;
exports.LaunchCalendlyModalModule = LaunchCalendlyModalModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePlanButtonModule = void 0;

var _constants = __webpack_require__(24);

var _launchChangePlan = __webpack_require__(102);

var _trial = __webpack_require__(60);

__webpack_require__(1528);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ChangePlanButtonModule = angular.module('app.components.changePlan.changePlanButton', [_launchChangePlan.LaunchChangePlanServiceModule, _trial.TrialServiceModule]).component('changePlanButton', {
  template: "\n            <md-button\n                class=\"md-accent md-raised md-button--has-icon-left\"\n                ng-if=\"$ctrl.allowPlanChange\"\n                ng-click=\"$ctrl.openChangePlanModal($event)\">\n                <md-icon\n                    aria-label=\"Change Plan Button\"\n                    class=\"material-plus\"\n                    md-svg-src=\"//d3ggqrmoaaez04.cloudfront.net/images/logos/logo_symbol_light.svg\">\n                </md-icon>\n                <span>{{'CHANGEPLAN.CHANGEPLAN' | translate}}</span>\n            </md-button>\n        ",
  controller:
  /*#__PURE__*/
  function () {
    ChangePlanButtonCtrl.$inject = ["launchChangePlanService", "trialService"];

    function ChangePlanButtonCtrl(launchChangePlanService, trialService) {
      'ngInject';

      _classCallCheck(this, ChangePlanButtonCtrl);

      angular.extend(this, {
        launchChangePlanService: launchChangePlanService,
        trialService: trialService,
        allowPlanChange: false
      });
    }

    _createClass(ChangePlanButtonCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.trialService.getSubscription().then(function (subscription) {
          _this.allowPlanChange = !_constants.RESTRICTED_PLANS.includes(subscription.plan.id);
        });
      }
    }, {
      key: "openChangePlanModal",
      value: function openChangePlanModal(event) {
        this.launchChangePlanService.openModal(event);
      }
    }]);

    return ChangePlanButtonCtrl;
  }()
}).name;
exports.ChangePlanButtonModule = ChangePlanButtonModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _countryData = __webpack_require__(256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var CountryName = function CountryName(_ref) {
  var code = _ref.code;
  return _react.default.createElement(_react.Fragment, null, code && _countryData.countries[code] && _countryData.countries[code].name ? _countryData.countries[code].name : code);
};

CountryName.propTypes = {
  code: _propTypes.default.string
};
var _default = CountryName;
exports.default = _default;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(__webpack_require__(390));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var IntlShippingService =
/*#__PURE__*/
function () {
  function IntlShippingService() {
    _classCallCheck(this, IntlShippingService);
  }

  _createClass(IntlShippingService, [{
    key: "fetchShipToLocations",
    value: function fetchShipToLocations() {
      return _index.default.get('/store/shiptolocations', true);
    }
  }, {
    key: "saveShipToLocations",
    value: function saveShipToLocations(locations) {
      return _index.default.put('/admin/shiptolocations', locations, true);
    }
  }]);

  return IntlShippingService;
}();

var _default = new IntlShippingService();

exports.default = _default;

/***/ }),
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiscountsRESTServiceModule = void 0;

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

var DiscountsRESTServiceModule = angular.module('app.services.data.discountsRESTService', [_data.DataServiceModule, _settings.AppSettingsModule]).service('discountsRESTService', ["dataService", "settings", function (dataService, settings) {
  return {
    create: create,
    searchDiscounts: searchDiscounts,
    updateDiscount: updateDiscount
  };

  function searchDiscounts(filter) {
    var filterString = filter ? "?filter=discountCode+cont+".concat(filter, "+and+discountStatus+eq+active") : '';
    return dataService.get("".concat(settings.api.discountsREST).concat(filterString)).then(function (_ref) {
      var _ref$discounts = _ref.discounts,
          discounts = _ref$discounts === void 0 ? [] : _ref$discounts;
      return discounts.filter(function (discount) {
        return discount.discountCode && discount.name !== 'Custom';
      }).map(transformDiscount);
    });
  }

  function create(discount) {
    return dataService.create(settings.api.discountsREST, discount).then(function (response) {
      return transformDiscount(response);
    });
  }

  function transformDiscount(restDiscount) {
    return {
      code: restDiscount.discountCode,
      discount: restDiscount
    };
  }

  function updateDiscount(discount, updatedDiscountAmount) {
    if (!discount || !discount.discountId || !discount.targets || updatedDiscountAmount === undefined || updatedDiscountAmount === null) {
      return;
    }

    var patches = [];
    var discountTargetId = Object.keys(discount.targets)[0];
    var updateDiscountAmountPatch = {
      op: 'replace',
      path: "/targets/".concat(discountTargetId, "/discountAmount"),
      value: updatedDiscountAmount
    };
    patches.push(updateDiscountAmountPatch);
    return dataService.patch(settings.api.discountsREST, discount.discountId, patches).then(function () {
      discount.targets[discountTargetId].discountAmount = updatedDiscountAmount;
      return transformDiscount(discount);
    });
  }
}]).name;
exports.DiscountsRESTServiceModule = DiscountsRESTServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LandingServiceModule = void 0;

var _settings = __webpack_require__(15);

var _launchDarkly = __webpack_require__(30);

var _features = __webpack_require__(258);

var _onboarding = __webpack_require__(59);

var _data = __webpack_require__(11);

var LandingServiceModule = angular.module('app.services.data.landingService', [_settings.AppSettingsModule, _launchDarkly.LaunchDarklyServiceModule, _features.FeaturesServiceModule, _onboarding.OnboardingServiceModule, _data.DataServiceModule]).service('landingService', ["settings", "dataService", "featureService", "DEFAULT_APPS", function (settings, dataService, featureService, DEFAULT_APPS) {
  function getItems() {
    var includeDefault = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return featureService.getInstalledApps().then(function (installedApps) {
      var apps = [];
      if (includeDefault) apps = angular.copy(DEFAULT_APPS);

      if (installedApps.discounts) {
        apps.push({
          type: 'discounts',
          sku: 'discounts',
          label: 'LABEL.DISCOUNTS',
          link: 'discounts.list',
          svgSrc: '/assets/percent.svg',
          color: '#44D1A3',
          hideInQuickMenu: true
        });
      }

      if (installedApps.shipping) {
        apps.push({
          type: 'postage',
          sku: 'shipping',
          label: 'POSTAGE.LABEL',
          icon: 'local_shipping',
          link: 'postage.edit',
          color: '#03A9F4',
          svgSrc: '/assets/shippo.svg',
          hideInQuickMenu: true
        });
      }

      if (installedApps.pinterest) {
        apps.push({
          type: 'pinterest',
          sku: 'pinterest',
          label: 'LABEL.PINTEREST',
          link: 'pinterest',
          color: '#BD081C',
          svgSrc: '/assets/pinterest.svg',
          hideInQuickMenu: true
        });
      }

      if (installedApps.facebookPixel) {
        apps.push({
          type: 'facebookPixel',
          sku: 'facebookPixel',
          label: 'LABEL.FACEBOOKPIXEL',
          link: 'facebookPixel',
          color: '#3A5A98',
          icon: 'code',
          hideInQuickMenu: true
        });
      }

      if (installedApps.zapier) {
        apps.push({
          type: 'zapier',
          sku: 'zapier',
          label: 'LABEL.ZAPIER',
          link: 'zapier',
          color: '#FF4A00',
          svgSrc: '/assets/zapier_icon_reverse.svg',
          hideInQuickMenu: true
        });
      }

      if (installedApps.avalara) {
        apps.push({
          type: 'avalara',
          sku: 'avalara',
          label: 'LABEL.AVALARA',
          link: 'avalara',
          externalLink: '/admin/avalara',
          color: '#FFFFFF',
          svgSrc: '/assets/avalara.svg',
          hideInQuickMenu: true
        });
      }

      if (installedApps.fullstory) {
        apps.push({
          type: 'fullstory',
          sku: 'fullstory',
          label: 'LABEL.FULLSTORY',
          link: 'fullstory',
          color: '#F0617D',
          svgSrc: '/assets/fullstoryLogo.svg',
          hideInQuickMenu: true
        });
      }

      if (installedApps.privy) {
        apps.push({
          type: 'privy',
          sku: 'privy',
          label: 'LABEL.PRIVY',
          link: 'privy',
          color: '#57C9AC',
          svgSrc: '/assets/privy-logo.svg',
          hideInQuickMenu: true
        });
      }

      if (installedApps.fulfillers) {
        apps.push({
          type: 'fulfillers',
          sku: 'fulfillers',
          label: 'LABEL.FULFILLERS',
          link: 'fulfillers.list',
          color: '#4747cd',
          svgSrc: '/assets/fulfillersLogo.svg',
          hideInQuickMenu: true
        });
      }

      if (installedApps.mailchimp) {
        apps.push({
          type: 'mailchimp',
          sku: 'mailchimp',
          label: 'LABEL.MAILCHIMP',
          hideInQuickMenu: true,
          svgSrc: '/assets/mailchimp_logo.svg',
          link: 'mailchimp',
          color: '#52BAD5'
        });
      }

      if (installedApps.yotpo) {
        apps.push({
          type: 'yotpo',
          sku: 'yotpo',
          label: 'LABEL.YOTPO',
          link: 'yotpo',
          color: '#2f84ed',
          svgSrc: '/assets/yotpo.svg'
        });
      }

      if (installedApps.googleAnalytics) {
        apps.push({
          type: 'googleAnalytics',
          sku: 'googleAnalytics',
          label: 'LABEL.GOOGLEANALYTICS',
          link: 'googleAnalytics',
          color: '#eeeeee',
          svgSrc: '/assets/GA_icon.svg',
          hideInQuickMenu: true
        });
      }

      if (installedApps.chat) {
        apps.push({
          type: 'chat',
          sku: 'chat',
          label: 'LABEL.CHAT',
          link: 'chat',
          color: '#887AAD',
          svgSrc: '/assets/chat_icon_light.svg',
          hideInQuickMenu: true
        });
      }

      if (installedApps.quickbooks) {
        apps.push({
          type: 'quickbooks',
          sku: 'quickbooks',
          label: 'LABEL.QUICKBOOKS',
          link: 'quickbooks',
          color: '#09A639',
          svgSrc: '/assets/quickbooks_logo.svg'
        });
      }

      if (installedApps.xero) {
        apps.push({
          type: 'xero',
          sku: 'xero',
          label: 'LABEL.XERO',
          link: 'xero',
          color: '#32B7EF',
          svgSrc: '/assets/xero_logo.svg'
        });
      }

      apps.push({
        type: 'add-app',
        label: 'LABEL.ADDAPP',
        icon: 'add',
        link: 'appstore2.allapps2',
        color: 'transparent',
        hideInQuickMenu: true,
        bypassAnimationOut: true
      });
      return apps;
    });
  }

  function getNewOrdersCount() {
    var options = {
      filter: 'status eq New',
      pageSize: 1
    };
    return dataService.getAll(settings.api.orders, options).then(function (response) {
      return response.totalCount;
    });
  }

  return {
    getNewOrdersCount: getNewOrdersCount,
    getItems: getItems
  };
}]).constant('DEFAULT_APPS', [{
  type: 'get-started',
  label: 'LABEL.GET_STARTED',
  icon: 'star',
  color: '#ffab00'
}, {
  type: 'orders',
  label: 'LABEL.ORDERS',
  icon: 'shopping_cart',
  link: 'order.list',
  color: '#3EC671',
  hasBadge: true
}, {
  type: 'products',
  label: 'LABEL.PRODUCTS',
  icon: 'local_offer',
  link: 'product.list',
  color: '#0FB3CC'
}, {
  type: 'categories',
  label: 'LABEL.CATEGORIES',
  icon: 'list',
  link: 'category.list',
  color: '#1E66C3'
}, {
  type: 'customers',
  label: 'LABEL.CUSTOMERS',
  icon: 'people',
  link: 'customer.list',
  color: '#684BB6'
}, {
  type: 'pages',
  label: 'LABEL.PAGES',
  icon: 'insert_drive_file',
  link: 'pages.list',
  color: '#79729d',
  linkedApp: true
}, {
  type: 'app-store',
  label: 'LABEL.APPSTORE',
  icon: 'apps',
  link: 'appstore2.installedapps2',
  color: '#EC6060'
}, {
  type: 'settings',
  label: 'LABEL.STORESETTINGS',
  icon: 'settings',
  color: '#FF8055',
  link: 'settings.detail',
  hasBadge: true
}, {
  type: 'edit-menu',
  label: 'Menu Editor',
  icon: 'menu',
  link: 'editstore.menu',
  color: '#79729d',
  linkedAppEnd: true
}, {
  type: 'analytics',
  label: 'LABEL.ANALYTICS',
  icon: 'trending_up',
  link: 'analytics.main',
  color: '#4D98F0'
}, {
  type: 'designer',
  icon: 'layers',
  link: 'designer',
  label: 'LABEL.SITE_DESIGNER',
  color: '#79729d',
  linkedAppStart: true
}]).name;
exports.LandingServiceModule = LandingServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _grid = __webpack_require__(83);

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "Footer__Wrapper",
  componentId: "sc-1itoml0-0"
})(["padding:16px;border-top:1px solid #ddd;"]);

var Footer = function Footer(_ref) {
  var children = _ref.children;
  return _react.default.createElement(Wrapper, {
    justifyContent: "flex-end"
  }, children);
};

Footer.propTypes = {
  children: _propTypes.default.node
};
var _default = Footer;
exports.default = _default;

/***/ }),
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnScrollEndDirective = void 0;
var OnScrollEndDirective = angular.module('app.directives.onScrollEnd', []).directive('onScrollEnd', function () {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var element = angular.element(attrs.scrollElement || elem);
      var raw = element[0];
      element.bind('scroll', function () {
        if (raw.scrollTop + raw.offsetHeight + 5 >= raw.scrollHeight) {
          scope.loading = true;
          scope.$apply(attrs.onScrollEnd);
        }
      });
    }
  };
}).name;
exports.OnScrollEndDirective = OnScrollEndDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = "<md-bottom-sheet class=\"confirm-delete\"> <span layout=\"column\" layout-gt-sm=\"row\" layout-align=\"end center\" layout-align-gt-sm=\"center end\"> <span flex=\"60\" class=\"confirm-delete__text\"> <span class=\"line line--1\">{{'IMAGELIBRARY.DELETECONFIRMATION' | translate}} <ng-pluralize count=\"vm.getSelectedImagesSize()\" when=\"{'0': 'nothing',\n                 'one': 'this image',\n                 'other': '{} images'}\"> </ng-pluralize>?</span> <span class=\"line line--2\">{{'IMAGELIBRARY.DELETEMESSAGE' | translate}}</span> </span> <span flex=\"20\" class=\"confirm-delete__sub-text\"> <md-checkbox ng-model=\"vm.userUnderstands\" class=\"confirm-delete__checkbox\"> {{'IMAGELIBRARY.IUNDERSTAND' | translate}} </md-checkbox> </span> <span flex=\"20\" class=\"confirm-delete__buttons\"> <md-button class=\"md-default md-flat cancel-btn\" ng-click=\"vm.cancelDelete()\">{{'IMAGELIBRARY.CANCEL' | translate}}</md-button> <md-button class=\"md-accent md-raised md-editstore-theme delete-btn\" ng-click=\"vm.confirmDelete()\" ng-disabled=\"!vm.userUnderstands\">{{'IMAGELIBRARY.DELETE' | translate}}</md-button> </span> </span> </md-bottom-sheet> ";

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageLibraryItemModule = void 0;

var _imageLibraryItem = _interopRequireDefault(__webpack_require__(1260));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLibraryItemModule = angular.module('app.component.imageLibrary.imageLibraryItem', []).component('imageLibraryItem', {
  bindings: {
    onImageToggle: '&',
    onSelectAndUse: '&',
    image: '<',
    index: '<'
  },
  template: _imageLibraryItem.default
}).name;
exports.ImageLibraryItemModule = ImageLibraryItemModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePlanModule = void 0;

var _find = _interopRequireDefault(__webpack_require__(66));

var _map = _interopRequireDefault(__webpack_require__(75));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _includes = _interopRequireDefault(__webpack_require__(287));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _moment = _interopRequireDefault(__webpack_require__(74));

var _logout = __webpack_require__(593);

var _myAccount = __webpack_require__(84);

var _plans = __webpack_require__(710);

var _subscription = __webpack_require__(42);

var _trial = __webpack_require__(60);

var _checkout = __webpack_require__(711);

var _checkout2 = __webpack_require__(154);

var _app = __webpack_require__(375);

var _mobileAnalytics = __webpack_require__(191);

var _selectPlan = __webpack_require__(1355);

var _changePlan = _interopRequireDefault(__webpack_require__(1361));

__webpack_require__(1362);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var steps = {
  plans: 1,
  checkout: 2
};
var ChangePlanModule = angular.module('app.components.changePlan', ['ngMaterial', _angularjs.default, _myAccount.MyAccountServiceModule, _subscription.SubscriptionServiceModule, _trial.TrialServiceModule, _checkout.CheckoutComponentModule, _checkout2.CheckoutServiceModule, _plans.PlansService, _app.AppServiceModule, _selectPlan.SelectPlanModule, _mobileAnalytics.MobileAnalyticsServiceModule, _logout.LogoutDirectiveModule]).component('changePlan', {
  template: _changePlan.default,
  bindings: {
    isCloseAllowed: '<',
    showLogoutButton: '<',
    trialDaysRemaining: '<',
    selectPlanNote: '<',
    hideGreeting: '<',
    isModal: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    ChangePlan.$inject = ["$mdDialog", "$state", "$mdMedia", "$scope", "plansService", "myAccountService", "subscriptionsService", "trialService", "$q", "checkoutService", "mobileAnalyticsService", "appService"];

    function ChangePlan($mdDialog, $state, $mdMedia, $scope, plansService, myAccountService, subscriptionsService, trialService, $q, checkoutService, mobileAnalyticsService, appService) {
      'ngInject';

      _classCallCheck(this, ChangePlan);

      angular.extend(this, {
        cart: {},
        steps: steps,
        step: steps.plans,
        planUiDataB: [{
          id: "plan_DTM2cLR4fcshXU",
          icon: 'add'
        }, {
          id: "plan_DTM4c74MCVV6pv",
          icon: 'add'
        }, {
          id: "plan_EsCk40izFJMh7q",
          icon: 'add',
          highlight: true
        }, {
          id: "plan_EsClPFjzuoK1Nq",
          icon: 'add'
        }],
        planUiData: [{
          id: "plan_DTM2cLR4fcshXU",
          icon: 'add'
        }, {
          id: "plan_DTM4c74MCVV6pv",
          icon: 'add'
        }, {
          id: "plan_EsCk40izFJMh7q",
          icon: 'add',
          highlight: true
        }, {
          id: "plan_EsClPFjzuoK1Nq",
          icon: 'add'
        }],
        showAlternate: false,
        $mdDialog: $mdDialog,
        $state: $state,
        $mdMedia: $mdMedia,
        $scope: $scope,
        plansService: plansService,
        myAccountService: myAccountService,
        subscriptionsService: subscriptionsService,
        trialService: trialService,
        checkoutService: checkoutService,
        appService: appService,
        mobileAnalyticsService: mobileAnalyticsService,
        $q: $q
      });
    }

    _createClass(ChangePlan, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.getStepOneData();

        if (angular.isUndefined(this.isCloseAllowed)) {
          this.isCloseAllowed = true;
        }

        if (angular.isUndefined(this.showLogoutButton)) {
          this.showLogoutButton = false;
        }

        this.$scope.$watch(function () {
          return _this.$mdMedia('gt-sm');
        }, function (gtSm) {
          _this.planSortExpression = gtSm ? '' : 'highlight';
        });
        this.mobileAnalyticsService.trackEvent('Plans', {});
        this.onBackClick = this.goToStep.bind(this, 1);

        if (this.isModal === undefined) {
          this.isModal = true;
        }
      }
    }, {
      key: "getStepOneData",
      value: function getStepOneData() {
        var _this2 = this;

        var offerPlans = this.planUiData;

        if (angular.element('body').hasClass('data-plans--alternate')) {
          this.showAlternate = true;
        }

        this.$q.all([this.plansService.getPlans(), this.subscriptionsService.getSubscription(), this.myAccountService.getUser()]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 3),
              plans = _ref2[0],
              subscription = _ref2[1],
              user = _ref2[2];

          _this2.user = user;
          _this2.allPlans = plans;
          _this2.cart.billingPeriodEnd = _moment.default.unix(subscription.current_period_end).format('MMMM Do');
          _this2.currentPlan = subscription.plan;
          var startupBusinessPlanIds = ["plan_EsCk40izFJMh7q", "plan_EsClPFjzuoK1Nq", "plan_F4Km1YPm31nFdr", "plan_F4KhkrRxWGs1TT"];

          if ((0, _includes.default)(startupBusinessPlanIds, _this2.currentPlan.id)) {
            offerPlans = _this2.planUiDataB;
          }

          _this2.annotatePlans();

          var hasAlternate = _this2.setUpAlternatesProperty();

          _this2.currentPlans = _this2.mergeObjectArraysById(offerPlans, plans);

          _this2.currentPlans.forEach(function (plan) {
            if (plan.id === subscription.plan.id) {
              plan.isCurrentPlan = true;
            }

            if (hasAlternate[plan.id]) {
              plan.alternates = hasAlternate[plan.id].map(function (planId) {
                return (0, _find.default)(_this2.allPlans, {
                  id: planId
                });
              });
            }
          });

          return _this2.trialService.getTrialStatusFromSubscription(subscription).then(function (trialStatus) {
            _this2.isTrial = _this2.trialService.isValidTrialPlanStatus(trialStatus);
            _this2.showCouponCodeField = _this2.isTrial || trialStatus === _trial.PARKED || trialStatus === _trial.EXPIRED;
          });
        }).catch(function () {
          _this2.close();
        });
      }
    }, {
      key: "annotatePlans",
      value: function annotatePlans() {
        var _this3 = this;

        var threeMonthPlanIds = ["plan_F4KiMHzfRlPbaH", "plan_F4KkTTatRD4wdz", "plan_F4KhkrRxWGs1TT", "plan_F4Km1YPm31nFdr", "plan_F4KhkrRxWGs1TT"];
        this.allPlans.forEach(function (plan) {
          if (threeMonthPlanIds.includes(plan.id)) {
            Object.assign(plan, {
              planType: '3-month prepaid',
              displayAmount: plan.amount / plan.interval_count,
              displayFirst: true,
              pricePeriodLabel: 'billed quarterly'
            });
          } else {
            plan.planType = 'Month to month';
            plan.displayAmount = plan.amount;
          } // show/hide selection menu for pricing test


          plan.showMenu = !_this3.showAlternate || plan.id !== "plan_DTM2cLR4fcshXU" && plan.id !== "plan_F4KiMHzfRlPbaH";
        });
      }
    }, {
      key: "setUpAlternatesProperty",
      value: function setUpAlternatesProperty() {
        var hasAlternate = {};
        hasAlternate["plan_DTM2cLR4fcshXU"] = ["plan_EsClPFjzuoK1Nq"]; // original plans

        var originalPlans = this.planUiData.map(function (plan) {
          return plan.id;
        });
        var originalPlansAlternates = [["plan_F4KiMHzfRlPbaH"], ["plan_F4KkTTatRD4wdz"], ["plan_F4KhkrRxWGs1TT"]];
        originalPlans.forEach(function (plan, index) {
          hasAlternate[plan] = originalPlansAlternates[index];
        }); // alternate plans

        var alternatePlans = this.planUiDataB.map(function (plan) {
          return plan.id;
        });
        var alternatePlansAlternates = [["plan_F4KiMHzfRlPbaH"], ["plan_F4KkTTatRD4wdz"], ["plan_F4Km1YPm31nFdr"], ["plan_F4KhkrRxWGs1TT"]];
        alternatePlans.forEach(function (plan, index) {
          hasAlternate[plan] = alternatePlansAlternates[index];
        });
        return hasAlternate;
      }
    }, {
      key: "mergeObjectArraysById",
      value: function mergeObjectArraysById(arr1, arr2) {
        return (0, _map.default)(arr1, function (item) {
          return (0, _assign.default)(item, (0, _find.default)(arr2, {
            id: item.id
          }));
        });
      }
    }, {
      key: "close",
      value: function close() {
        if (this.purchaseComplete) {
          this.finish();
        } else {
          this.$mdDialog.hide();
        }
      }
    }, {
      key: "finish",
      value: function finish() {
        this.appService.initLogging();
        this.$mdDialog.hide();
        this.$state.reload();
      }
    }, {
      key: "selectPlan",
      value: function selectPlan(plan) {
        this.checkoutService.logProductClick(plan);
        this.checkoutService.logProductDetails(plan);

        if (plan.onPlanSelected) {
          return plan.onPlanSelected();
        }

        this.cart.planDetails = plan;
        this.cart.planId = plan.id;
        this.cart.isDowngrade = (0, _subscription.isDowngrade)(this.currentPlan, plan);
        this.trackPlan(plan.name);
        this.goToStep(2);
      }
    }, {
      key: "trackPlan",
      value: function trackPlan(planName) {
        if (planName.length > 0) {
          this.mobileAnalyticsService.trackEvent("Plans:".concat(planName), {});
        }
      }
    }, {
      key: "goToStep",
      value: function goToStep(stepNumber) {
        this.step = stepNumber;
      }
    }, {
      key: "onPurchaseComplete",
      value: function onPurchaseComplete() {
        this.purchaseComplete = true;
      }
    }]);

    return ChangePlan;
  }()
}).name;
exports.ChangePlanModule = ChangePlanModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlansService = void 0;
var PlansService = angular.module('app.services.data.plansService', []).service('plansService', ["$http", function ($http) {
  function getPlans() {
    return $http.get("".concat("https://sandbox.api-v2.volusion.com", "/plans")).then(function (response) {
      return response.data;
    });
  }

  return {
    getPlans: getPlans
  };
}]).name;
exports.PlansService = PlansService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutComponentModule = void 0;

var _merge = _interopRequireDefault(__webpack_require__(277));

var _constants = __webpack_require__(24);

var _mobileAnalytics = __webpack_require__(191);

var _auth0auth = __webpack_require__(166);

var _phone = __webpack_require__(594);

var _checkoutComponents = __webpack_require__(1275);

var _checkout = __webpack_require__(154);

var _checkout2 = _interopRequireDefault(__webpack_require__(1315));

__webpack_require__(1316);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CheckoutComponentModule = angular.module('app.components.checkout.checkoutComponent', [_auth0auth.Auth0AuthServiceModule, _checkout.CheckoutServiceModule, _checkoutComponents.CheckoutComponentsModule, _phone.PhoneFilterModule, _mobileAnalytics.MobileAnalyticsServiceModule]).component('checkout', {
  template: _checkout2.default,
  bindings: {
    cart: '<',
    expireTrialInFiveMinutes: '<',
    hideBackButton: '<',
    isModal: '<',
    materialTheme: '@',
    onBackClick: '<',
    onExitCheckout: '&',
    onPurchaseComplete: '&',
    returnUrl: '<',
    couponCode: '<',
    showCouponCodeField: '<',
    trialDaysRemaining: '<',
    isTrial: '<',
    showAlternate: '<',
    hasAccount: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    CheckoutComponent.$inject = ["$window", "checkoutService", "$q", "mobileAnalyticsService", "auth0AuthService", "$cookies"];

    function CheckoutComponent($window, checkoutService, $q, mobileAnalyticsService, auth0AuthService, $cookies) {
      'ngInject';

      _classCallCheck(this, CheckoutComponent);

      angular.extend(this, {
        user: {
          isLoggedIn: false
        },
        selectedPaymentMethod: 'card',
        isSignupFormValid: false,
        purchaseComplete: false,
        $window: $window,
        $cookies: $cookies,
        checkoutService: checkoutService,
        auth0AuthService: auth0AuthService,
        $q: $q,
        mobileAnalyticsService: mobileAnalyticsService,
        LOGO_URL: _constants.LOGO_URL
      });
    }

    _createClass(CheckoutComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.initData();
        this.mobileAnalyticsService.trackEvent('Order:Payment', {});
        this.onPaymentMethodSelected = this.onPaymentMethodSelected.bind(this);
      }
    }, {
      key: "initData",
      value: function initData() {
        var _this = this;

        this.loading = true;
        var promises = [this.checkoutService.createUser(), this.auth0AuthService.isAuthenticated().then(function (authenticated) {
          if (authenticated) {
            _this.$cookies.put('loginTimestamp', Date.now(), {
              secure: true
            });

            _this.$window.dataLayer.push({
              event: 'storeLogin'
            });

            return _this.getLoggedInUserDetails();
          }
        })];
        if (!this.cart.planDetails) promises.push(this.getPlanDetails());
        this.$q.all(promises).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
              user = _ref2[0];

          (0, _merge.default)(_this.user, user);
          _this.loading = false;

          _this.checkoutService.logAddToCart(_this.cart.planDetails);

          _this.checkoutService.logCheckoutStep(_this.checkoutService.STEP_ENTRANCE, _this.cart.planDetails);
        });
      }
    }, {
      key: "getPlanDetails",
      value: function getPlanDetails() {
        var _this2 = this;

        return this.checkoutService.getPlanDetails(this.cart.planId).then(function (planDetails) {
          _this2.cart.planDetails = planDetails;
        });
      }
    }, {
      key: "getLoggedInUserDetails",
      value: function getLoggedInUserDetails() {
        var _this3 = this;

        return this.checkoutService.getLoggedInUserDetails().then(function (details) {
          if (details.user) {
            details.user.contactInfo = details.user[_constants.AUTH0_METADATA_CLAIM];
          }

          (0, _merge.default)(_this3.user, _this3.checkoutService.setDetailsToUser(details.user, details.storeInfo, details.paymentMethod));
          _this3.user.forceEdit = false;
          _this3.hasAccount = details.user.isLoggedIn && details.user.payment && details.user.payment.lastFour && details.user.payment.lastFour.length;
          return _this3.user;
        });
      }
    }, {
      key: "backToMarketing",
      value: function backToMarketing() {
        this.checkoutService.logRemoveFromCart(this.cart.planDetails);

        if (this.onBackClick) {
          this.onBackClick();
        } else {
          this.$window.location = this.returnUrl;
        }
      }
    }, {
      key: "onSignupFormValidityChange",
      value: function onSignupFormValidityChange(isValid) {
        this.isSignupFormValid = isValid;
      }
    }, {
      key: "onCouponEntered",
      value: function onCouponEntered(coupon) {
        this.coupon = coupon;
      }
    }, {
      key: "_onPurchaseComplete",
      value: function _onPurchaseComplete() {
        this.purchaseComplete = true;
        this.$cookies.remove('friendCode');
        this.mobileAnalyticsService.trackEvent('Order:Success', {});
        this.onPurchaseComplete();
      }
    }, {
      key: "onLogout",
      value: function onLogout() {
        var _this4 = this;

        this.checkoutService.createUser().then(function (user) {
          _this4.user = user;
        });
      }
    }, {
      key: "_onExitCheckout",
      value: function _onExitCheckout() {
        if (this.isModal) this.onExitCheckout();else this.$window.location = this.$window.location.origin;
      }
    }, {
      key: "onPaymentMethodSelected",
      value: function onPaymentMethodSelected(selected) {
        this.selectedPaymentMethod = selected;
      }
    }]);

    return CheckoutComponent;
  }()
}).name;
exports.CheckoutComponentModule = CheckoutComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TelephoneFilterModule = void 0;
var TelephoneFilterModule = angular.module('app.filters.telephone', []).filter('tel', function () {
  return function (tel) {
    if (tel === null || tel === undefined) {
      return '';
    }

    if (typeof tel === 'string' && !tel.length) {
      return '';
    }

    var value = tel.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
      return tel;
    }

    switch (true) {
      case value.length <= 3:
        return "(".concat(value);

      case value.length <= 6:
        return "(".concat(value.slice(0, 3), ") ").concat(value.slice(3, 6));

      case value.length <= 10:
        return "(".concat(value.slice(0, 3), ") ").concat(value.slice(3, 6), "-").concat(value.slice(6, 10));

      default:
        return value;
    }
  };
}).name;
exports.TelephoneFilterModule = TelephoneFilterModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidatePasswordDirectiveModule = void 0;
var ValidatePasswordDirectiveModule = angular.module('app.directives.validatePassword', []).directive('vlnValidatePassword', function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, ele, attrs, modelCtrl) {
      modelCtrl.$validators.validPassword = function (pass) {
        if (!pass) return true;
        var hasUppercase = /[A-Z]/.test(pass);
        var hasLowercase = /[a-z]/.test(pass);
        var hasNumberOrSpecial = /[0-9]|[^A-Za-z0-9]/.test(pass);
        return hasUppercase && hasLowercase && hasNumberOrSpecial;
      };
    }
  };
}).name;
exports.ValidatePasswordDirectiveModule = ValidatePasswordDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentServiceModule = void 0;

var _angularCookies = _interopRequireDefault(__webpack_require__(103));

var _data = __webpack_require__(11);

var _settings = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentServiceModule = angular.module('app.services.payment.paymentService', [_angularCookies.default, _data.DataServiceModule, _settings.AppSettingsModule]).service('paymentService', ["$http", "$location", "$window", "dataService", "settings", function ($http, $location, $window, dataService, settings) {
  var Stripe = {
    requestAuthorization: function requestAuthorization(queryStrings) {
      return $http.get("".concat("https://sandbox.api-v2.volusion.com", "/store/paymentkeys")).then(function (stripeData) {
        var optArray = [];
        var options = {
          response_type: 'code',
          client_id: stripeData.data.stripePlatformClientId,
          stripe_landing: 'login',
          scope: 'read_write',
          redirect_uri: queryStrings ? "".concat($location.absUrl(), "?").concat(queryStrings) : $location.absUrl()
        };
        Object.keys(options).forEach(function (key) {
          optArray.push("".concat(key, "=").concat(options[key]));
        });
        optArray = optArray.join('&');
        var url = "https://connect.stripe.com/oauth/authorize?".concat(optArray);
        $window.location.href = url;
      });
    },
    connectAccount: function connectAccount(code) {
      return dataService.create(settings.api.stripe, {
        stripeAuthorizationCode: code
      });
    },
    disconnectAccount: function disconnectAccount() {
      return dataService.remove(settings.api.stripe);
    },
    isConnectedComplete: function isConnectedComplete(storeInfo) {
      return storeInfo.stripeAccountStatus === 'Activated' && storeInfo.stripeAccountId;
    },
    isConnectedPending: function isConnectedPending(storeInfo) {
      return storeInfo.stripeAccountStatus === 'Pending' && storeInfo.stripeAccountId;
    },
    validateCoupon: function validateCoupon(coupon) {
      return dataService.get(settings.api.validateStripeCoupon, volCouponMapping(coupon));
    }
  };

  function volCouponMapping(coupon) {
    var valid = /^VOL[0-9]{1,6}$/.test(coupon);
    return valid ? 'VOL-SLM1' : coupon;
  }

  return {
    stripe: Stripe
  };
}]).name;
exports.PaymentServiceModule = PaymentServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationServiceModule = void 0;

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _moment = _interopRequireDefault(__webpack_require__(74));

var _storage = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationServiceModule = angular.module('app.services.utilities.notificationService', [_angularTranslate.default, _storage.StorageServiceModule]).factory('notificationService', ["$window", "$filter", "$translate", "storageService", function ($window, $filter, $translate, storageService) {
  return {
    requestAuthorization: requestAuthorization,
    hideNotificationBanner: hideNotificationBanner,
    create: create,
    createOrderNotification: createOrderNotification
  };

  function requestAuthorization() {
    if ('Notification' in $window) {
      if ('localStorage' in $window && storageService.supported()) {
        $window.localStorage.setItem('notificationSupport', true);
      }

      $window.Notification.requestPermission(authorizationCallback);
    } else {
      $window.localStorage.setItem('notificationSupport', false);
    }
  }

  function hideNotificationBanner() {
    if ('localStorage' in $window && storageService.supported()) {
      $window.localStorage.setItem('notificationsAuthorized', false);
      $window.localStorage.setItem('hideNotificationBanner', true);
    }

    if ('Notification' in $window && 'localStorage' in $window && storageService.supported()) {
      $window.localStorage.setItem('notificationSupport', true);
    }
  }

  function authorizationCallback(res) {
    if ('localStorage' in $window && storageService.supported()) {
      if (res === 'denied' || res === 'default') {
        $window.localStorage.setItem('notificationsAuthorized', false);
      } else {
        $window.localStorage.setItem('hideNotificationBanner', true);
        $window.localStorage.setItem('notificationsAuthorized', true);
      }
    }
  }

  function create(title, body, icon, url) {
    if ('localStorage' in $window) {
      if ($window.localStorage.notificationSupport === false || $window.localStorage.notificationsAuthorized === 'false') {
        return;
      }

      if ($window.localStorage.notificationsAuthorized === undefined) {
        return;
      }
    }

    if ('Notification' in $window) {
      var notification = new $window.Notification(title, {
        body: body,
        icon: icon
      });

      notification.onclick = function () {
        var orderWindow = $window.open(url, '_blank');
        orderWindow.focus();
      };
    }
  }

  function createOrderNotification(order, store) {
    getOrderNotificationTitle(store).then(function (title) {
      var body = "".concat($filter('currency')(order.grandTotal), " (").concat((0, _moment.default)(order.createdOn).fromNow(), ")");
      var icon;

      if (order.cart.items.length && order.cart.items[0].product.imageMetadata) {
        icon = order.cart.items[0].product.imageMetadata.imageLink.fullUri;
      }

      var url = '/order/list?filter=New';
      create(title, body, icon, url);
    });
  }

  function getOrderNotificationTitle(store) {
    if (store === undefined) {
      return $translate('NOTIFICATION.NEWORDERNOSTORENAME');
    }

    return $translate('NOTIFICATION.NEWORDER', {
      STORE: store
    });
  }
}]).name;
exports.NotificationServiceModule = NotificationServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 720 */,
/* 721 */,
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerifyEmailReminderServiceModule = void 0;

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

var _myAccount = __webpack_require__(84);

var _verifyEmailReminder = __webpack_require__(1333);

var VerifyEmailReminderServiceModule = angular.module('app.components.verifyEmailReminder.verifyEmailReminderService', ['ngMaterial', _settings.AppSettingsModule, _data.DataServiceModule, _myAccount.MyAccountServiceModule, _verifyEmailReminder.VerifyEmailReminderModule]).service('verifyEmailReminderService', ["$mdToast", "dataService", "settings", "$interval", "myAccountService", function ($mdToast, dataService, settings, $interval, myAccountService) {
  var reminderToast = null;
  var checkInterval = null;
  var checkForVerificationInterval = 300000;
  return {
    verifyNewEmail: verifyNewEmail,
    showEmailReminder: showEmailReminder,
    checkIfEmailVerified: checkIfEmailVerified,
    initVerifyEmailReminder: initVerifyEmailReminder
  };

  function verifyNewEmail(newUser, oldUser) {
    if (oldUser && newUser.email !== oldUser.email) {
      myAccountService.resendVerification(newUser);
      initVerifyEmailReminder();
    }
  }

  function initVerifyEmailReminder() {
    showEmailReminder();
    startEmailVerifiedCheck();
  }

  function showEmailReminder() {
    show().then(function () {
      stopBackgroundCheck();
    });
  }

  function startEmailVerifiedCheck() {
    checkInterval = $interval(function () {
      checkIfEmailVerified();
    }, checkForVerificationInterval);
  }

  function checkIfEmailVerified() {
    var userPromise = myAccountService.getUser(true);
    userPromise.then(function (user) {
      if (user.emailVerified) {
        hide();
        stopBackgroundCheck();
      }
    });
  }

  function stopBackgroundCheck() {
    $interval.cancel(checkInterval);
  }

  function show() {
    reminderToast = $mdToast.show({
      hideDelay: 0,
      position: 'top',
      template: '<verify-email-reminder></verify-email-reminder>'
    });
    return reminderToast;
  }

  function hide() {
    $mdToast.hide(reminderToast);
  }
}]).name;
exports.VerifyEmailReminderServiceModule = VerifyEmailReminderServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartServiceModule = void 0;

var _cloneDeep = _interopRequireDefault(__webpack_require__(189));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-useless-escape */
var CartServiceModule = angular.module('app.services.data.cartService', [_data.DataServiceModule, _settings.AppSettingsModule]).factory('cartService', ["dataService", "settings", function (dataService, settings) {
  return {
    getCart: getCart,
    getCarts: getCarts,
    getLegacyCart: getLegacyCart,
    getLegacyAbandonedCarts: getLegacyAbandonedCarts,
    create: create,
    save: save
  };

  function getCart(cartId) {
    return dataService.get(settings.api.publicCartsREST, cartId);
  }

  function getCarts(options) {
    var returnHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var headers = null;
    return dataService.getAll(settings.api.cartsREST, options, headers, returnHeaders);
  }

  function getLegacyCart(cartId) {
    return dataService.get(settings.api.cart, cartId);
  }

  function getLegacyAbandonedCarts(options) {
    return dataService.getAll(settings.api.abandonedCartsLegacy, options);
  }

  function create(cart) {
    return dataService.create(settings.api.cart).then(function (newCart) {
      if (cart) {
        var oldCart = (0, _cloneDeep.default)(cart);
        delete oldCart.id;
        delete oldCart.revision;
        delete oldCart.createdOn;
        delete oldCart.updatedOn;
        (0, _assign.default)(newCart, oldCart);
      }

      return newCart;
    });
  }

  function save(cart) {
    return dataService.save(settings.api.cart, cart.id, cart);
  }
}]).name;
/* eslint-enable no-useless-escape */

exports.CartServiceModule = CartServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconCircle = _styledComponents.default.div.withConfig({
  displayName: "IconCircle",
  componentId: "eakn29-0"
})(["background-color:", ";color:", ";height:", ";width:", ";line-height:", ";text-align:center;border-radius:50%;user-select:none;i{vertical-align:middle;}"], function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.color;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

IconCircle.propTypes = {
  backgroundColor: _propTypes.default.string,
  color: _propTypes.default.string,
  size: _propTypes.default.string
};
IconCircle.defaultProps = {
  backgroundColor: '#ccc',
  color: '#fff',
  size: '96px'
};
var _default = IconCircle;
exports.default = _default;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BulkImportServiceModule = void 0;

var _flatten = _interopRequireDefault(__webpack_require__(259));

var _sortBy = _interopRequireDefault(__webpack_require__(195));

var _segment = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BulkImportServiceModule = angular.module('app.services.data.bulkImportService', [_segment.SegmentServiceModule]).factory('bulkImportService', function () {
  return {
    getFormattedErrors: getFormattedErrors,
    hasErrors: hasErrors,
    isImportSuccessful: isImportSuccessful,
    isInvalidImageError: isInvalidImageError,
    isTimeoutError: isTimeoutError,
    isUploadError: isUploadError
  };

  function getFormattedErrors(errorKeys) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'product';

    if (!errorKeys || errorKeys.length === 0) {
      return;
    }

    return type === 'orderUpdate' ? formatErrorsForBulkUpdate(errorKeys) : errorKeys.map(formatErrorObj);
  }

  function formatErrorObj(errorObj) {
    var lines = getErrorLinesSnippet(errorObj.lines);
    var linesError = "On ".concat(lines);
    var keyError = "for product with key '".concat(errorObj.key, "'");
    var errorMsgs = "we found these errors: ".concat(errorObj.errors.join(','));
    return "".concat(linesError, ", ").concat(keyError, ", ").concat(errorMsgs);
  }

  function getErrorLinesSnippet(errorLines) {
    var lines = "line ".concat(errorLines[0]);

    if (errorLines.length > 1) {
      lines = "lines ".concat(errorLines.join(', '));

      if (isSequentialNumbers(errorLines)) {
        lines = "lines ".concat(errorLines[0], " - ").concat(errorLines[errorLines.length - 1]);
      }
    }

    return lines;
  }

  function isSequentialNumbers(numbers) {
    // for display as 6-10 if sequential
    if (numbers.length < 2) return false;
    var span = numbers[numbers.length - 1] - numbers[0] + 1;
    return span === numbers.length;
  }

  function formatErrorsForBulkUpdate(errorKeys) {
    var errorLineAndMessages = errorKeys.map(collectErrorsForBulkUpdate);
    return (0, _sortBy.default)((0, _flatten.default)(errorLineAndMessages), 'line');
  }

  function collectErrorsForBulkUpdate(error) {
    return error.lines.map(function (line) {
      return {
        line: line,
        message: error.errors.join(', ')
      };
    });
  }

  function hasErrors(response) {
    return !!(response.errorKeys && response.errorKeys.length > 0);
  }

  function isImportSuccessful(response) {
    var imported = response.importedProducts || response.updatedOrders || response.itemsAdded;
    return imported > 0;
  }

  function isTimeoutError(error) {
    return !!(error && (error.status === 504 || error.status === -1));
  }

  function isUploadError(error) {
    return !!(error && error.xhrStatus === 'error' && error.status === -1);
  }

  function isInvalidImageError(errorMessage) {
    var errorPrefix1 = 'Could not find an image at ';
    return !!(errorMessage && errorMessage.length > errorPrefix1.length && errorMessage.substring(0, errorPrefix1.length) === errorPrefix1);
  }
}).name;
exports.BulkImportServiceModule = BulkImportServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _countryData = __webpack_require__(256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var StateName = function StateName(_ref) {
  var stateCode = _ref.stateCode,
      countryCode = _ref.countryCode;
  return _react.default.createElement(_react.Fragment, null, _countryData.countries[countryCode] && _countryData.countries[countryCode].provinces[stateCode] ? _countryData.countries[countryCode].provinces[stateCode] : stateCode);
};

StateName.propTypes = {
  stateCode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  countryCode: _propTypes.default.string
};
var _default = StateName;
exports.default = _default;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _api = _interopRequireDefault(__webpack_require__(390));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StoreAddressesService = function StoreAddressesService() {
  var _this = this;

  _classCallCheck(this, StoreAddressesService);

  this.apiUrl = '/admin/storeaddresses';
  this.primaryUrl = "".concat(this.apiUrl, "/primary");
  this.addressUrl = "".concat(this.apiUrl, "/address");

  this.add = function (address) {
    return _api.default.post(_this.addressUrl, {
      address: address
    });
  };

  this.getAddresses = function () {
    return _api.default.get(_this.apiUrl, true);
  };

  this.getPrimaryAddress = function () {
    return _api.default.get(_this.primaryUrl, true).then(function (primaryAddress) {
      if (!primaryAddress || !primaryAddress.mailingAddress) {
        return Promise.reject({});
      }

      return primaryAddress;
    });
  };

  this.updatePrimaryAddress = function (address) {
    if (!address.isPrimary) {
      address.isPrimary = true;
    }

    return _api.default.post(_this.primaryUrl, {
      address: address
    }, true);
  };

  this.save = function (data) {
    return _api.default.post(_this.apiUrl, {
      storeAddresses: data
    }, true);
  };

  this.hasPrimaryStoreAddress = function () {
    return _api.default.get(_this.primaryUrl, true).then(function (primaryAddress) {
      return primaryAddress && primaryAddress.mailingAddress;
    }).catch(function () {
      return false;
    });
  };
};

var _default = new StoreAddressesService();

exports.default = _default;

/***/ }),
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LaunchUpdatePaymentModalService = void 0;

var _updatePaymentModal = __webpack_require__(1559);

var _updatePaymentModal2 = _interopRequireDefault(__webpack_require__(1562));

__webpack_require__(1563);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LaunchUpdatePaymentModalService = angular.module('app.components.updatePayment.modal.launchUpdatePaymentModalService', ['ngMaterial', _updatePaymentModal.UpdatePaymentModalController]).service('launchUpdatePaymentService', ["$mdDialog", function ($mdDialog) {
  return {
    launchModal: function launchModal(editMode, prefillData, ev) {
      return $mdDialog.show({
        controller: 'UpdatePaymentModalController',
        template: _updatePaymentModal2.default,
        parent: angular.element('body'),
        clickOutsideToClose: true,
        targetEvent: ev,
        locals: {
          editMode: editMode,
          prefillData: prefillData
        }
      });
    }
  };
}]).name;
exports.LaunchUpdatePaymentModalService = LaunchUpdatePaymentModalService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressEditorModule = void 0;

var _constants = __webpack_require__(24);

var _addressEditorDropdown = __webpack_require__(1560);

var _addressEditor = _interopRequireDefault(__webpack_require__(1561));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressEditorModule = angular.module('app.components.addressEditor', [_addressEditorDropdown.AddressEditorDropdownModule]).directive('addressEditor', function () {
  return {
    restrict: 'EA',
    scope: {
      address: '=',
      addressForm: '=formController'
    },
    template: _addressEditor.default,
    link: function postlink(scope) {
      var unitedStates;
      angular.forEach(_constants.COUNTRIES, function (country) {
        if (country.name === 'United States') unitedStates = country;
      });
      scope.states = unitedStates.states;
      scope.address = scope.address || {};
      scope.address.country = unitedStates.name;

      scope.onStateChanged = function (chosenState) {
        scope.address.state = chosenState.code;
      };
    }
  };
}).name;
exports.AddressEditorModule = AddressEditorModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdatePaymentServiceModule = void 0;

var _get = _interopRequireDefault(__webpack_require__(34));

var _paymentMethod = __webpack_require__(269);

var _creditCard = __webpack_require__(164);

var _myAccount = __webpack_require__(84);

var _authToken = __webpack_require__(43);

var _GtmTracking = __webpack_require__(278);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var UpdatePaymentServiceModule = angular.module('app.components.updatePayment.updatePaymentService', [_paymentMethod.PaymentMethodServiceModule, _creditCard.CreditCardServiceModule, _myAccount.MyAccountServiceModule, _authToken.AuthTokenServiceModule]).service('updatePaymentService', ["myAccountService", "creditCardService", "paymentMethodService", "$q", "authTokenService", function (myAccountService, creditCardService, paymentMethodService, $q, authTokenService) {
  function changePaymentMethod(card, billingAddress) {
    var userPromise = myAccountService.getUser();
    var tenantPromise = authTokenService.getTenantId();
    return $q.all([userPromise, tenantPromise]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          storeAdmin = _ref2[0],
          tenantID = _ref2[1];

      var user = {
        firstName: storeAdmin.firstName,
        lastName: storeAdmin.lastName
      };
      return creditCardService.createStripeCcToken(card, user, billingAddress).then(function (cardResponse) {
        if (cardResponse.card && cardResponse.card.funding === 'prepaid') {
          (0, _GtmTracking.trackEvent)('prepaidCard', {
            type: 'change_attempt',
            tenantID: tenantID
          });
          throw new Error("Prepaid cards are not currently accepted.\n                            Please provide a credit or debit card, or contact us for help.");
        }

        var stripeCcToken = (0, _get.default)(cardResponse, 'id', null);
        return paymentMethodService.updatePaymentMethod(stripeCcToken);
      }, function (error) {
        return $q.reject({
          description: 'Stripe Token Error',
          data: error
        });
      });
    });
  }

  return {
    changePaymentMethod: changePaymentMethod
  };
}]).name;
exports.UpdatePaymentServiceModule = UpdatePaymentServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 737 */,
/* 738 */,
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  APPS: [{
    sku: 'chat',
    link: 'chat'
  }, {
    sku: 'discounts',
    link: 'discounts.list'
  }, {
    sku: 'facebookPixel',
    link: 'facebookPixel'
  }, {
    sku: 'fulfillers',
    link: 'fulfillers.list'
  }, {
    sku: 'fullstory',
    link: 'fullstory'
  }, {
    sku: 'googleAnalytics',
    link: 'googleAnalytics'
  }, {
    sku: 'mailchimp',
    link: 'mailchimp'
  }, {
    sku: 'pinterest',
    link: 'pinterest'
  }, {
    sku: 'postage',
    link: 'postage.edit'
  }, {
    sku: 'privy',
    link: 'privy'
  }, {
    sku: 'shipping',
    link: 'postage.edit'
  }, {
    sku: 'yotpo',
    link: 'yotpo'
  }, {
    sku: 'zapier',
    link: 'zapier'
  }, {
    sku: 'avalara',
    link: 'avalara'
  }]
};
exports.default = _default;

/***/ }),
/* 740 */,
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductPickerServiceModule = void 0;

var _products = __webpack_require__(98);

var _categories = __webpack_require__(100);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var ProductPickerServiceModule = angular.module('app.service.data.productPickerService', [_products.ProductServiceModule, _categories.CategoryServiceModule]).service('productPicker', ["productService", "categoryService", "$q", function (productService, categoryService, $q) {
  return {
    getProductsAndCategories: getProductsAndCategories,
    getMinimalProductsAndCategories: getMinimalProductsAndCategories,
    getMinimalProductVariantsAndCategories: getMinimalProductVariantsAndCategories
  };

  function getCommonProductsAndCategories(getProductsFn) {
    var promises = [getAllProducts(getProductsFn), categoryService.getCategoryTree().then(function (categories) {
      return categoryService.flattenCategories(categories, true);
    })];
    return $q.all(promises).then(function (data) {
      return {
        products: data[0],
        categories: data[1]
      };
    });
  }

  function getProductsAndCategories() {
    return getCommonProductsAndCategories(productService.getProducts);
  }

  function getMinimalProductsAndCategories() {
    return getCommonProductsAndCategories(productService.getMinimalProducts);
  }

  function getMinimalProductVariantsAndCategories() {
    return getCommonProductsAndCategories(productService.getMinimalProductsWithVariants);
  }

  function getAllProducts(getProductsFn, page, results) {
    page = page || 1;
    results = results || [];
    var pageSize = 100;
    return getProductsFn(page, pageSize).then(function (products) {
      var _results;

      if (products.length === 0) {
        return results;
      }

      (_results = results).push.apply(_results, _toConsumableArray(products.items));

      if (page * pageSize < products.totalCount) {
        return getAllProducts(getProductsFn, page + 1, results);
      }

      return results;
    });
  }
}]).name;
exports.ProductPickerServiceModule = ProductPickerServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppModule = void 0;

__webpack_require__(745);

__webpack_require__(746);

__webpack_require__(747);

__webpack_require__(750);

__webpack_require__(751);

__webpack_require__(752);

__webpack_require__(298);

__webpack_require__(755);

__webpack_require__(756);

__webpack_require__(758);

__webpack_require__(759);

__webpack_require__(761);

__webpack_require__(762);

__webpack_require__(763);

__webpack_require__(764);

__webpack_require__(765);

__webpack_require__(766);

__webpack_require__(767);

__webpack_require__(768);

__webpack_require__(769);

__webpack_require__(770);

__webpack_require__(771);

__webpack_require__(773);

__webpack_require__(774);

__webpack_require__(775);

__webpack_require__(776);

__webpack_require__(777);

__webpack_require__(778);

__webpack_require__(779);

__webpack_require__(780);

__webpack_require__(781);

__webpack_require__(782);

__webpack_require__(783);

__webpack_require__(784);

__webpack_require__(785);

__webpack_require__(786);

__webpack_require__(787);

__webpack_require__(788);

__webpack_require__(789);

__webpack_require__(790);

__webpack_require__(792);

__webpack_require__(794);

__webpack_require__(795);

__webpack_require__(796);

__webpack_require__(797);

__webpack_require__(798);

__webpack_require__(799);

__webpack_require__(800);

__webpack_require__(801);

__webpack_require__(802);

__webpack_require__(803);

__webpack_require__(804);

__webpack_require__(805);

__webpack_require__(806);

__webpack_require__(808);

__webpack_require__(809);

__webpack_require__(810);

__webpack_require__(811);

__webpack_require__(812);

__webpack_require__(813);

__webpack_require__(814);

__webpack_require__(815);

__webpack_require__(818);

__webpack_require__(819);

__webpack_require__(820);

__webpack_require__(822);

__webpack_require__(823);

__webpack_require__(824);

__webpack_require__(825);

__webpack_require__(826);

__webpack_require__(827);

__webpack_require__(828);

__webpack_require__(829);

__webpack_require__(830);

__webpack_require__(831);

__webpack_require__(832);

__webpack_require__(833);

__webpack_require__(445);

__webpack_require__(834);

__webpack_require__(835);

__webpack_require__(836);

__webpack_require__(837);

__webpack_require__(838);

__webpack_require__(839);

__webpack_require__(840);

__webpack_require__(842);

__webpack_require__(843);

__webpack_require__(844);

__webpack_require__(845);

__webpack_require__(846);

__webpack_require__(847);

__webpack_require__(849);

__webpack_require__(850);

__webpack_require__(851);

__webpack_require__(852);

__webpack_require__(853);

__webpack_require__(854);

__webpack_require__(855);

__webpack_require__(856);

__webpack_require__(857);

__webpack_require__(858);

__webpack_require__(859);

__webpack_require__(860);

__webpack_require__(861);

__webpack_require__(862);

__webpack_require__(863);

__webpack_require__(864);

__webpack_require__(865);

__webpack_require__(866);

__webpack_require__(867);

__webpack_require__(868);

__webpack_require__(869);

__webpack_require__(870);

__webpack_require__(871);

__webpack_require__(872);

__webpack_require__(873);

__webpack_require__(874);

__webpack_require__(875);

__webpack_require__(876);

__webpack_require__(877);

__webpack_require__(878);

__webpack_require__(879);

__webpack_require__(880);

__webpack_require__(881);

var _angularjs = _interopRequireDefault(__webpack_require__(7));

__webpack_require__(908);

__webpack_require__(909);

__webpack_require__(910);

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

__webpack_require__(679);

__webpack_require__(680);

var _angularAnimate = _interopRequireDefault(__webpack_require__(681));

var _angularAria = _interopRequireDefault(__webpack_require__(912));

var _angularMessages = _interopRequireDefault(__webpack_require__(481));

var _angularCookies = _interopRequireDefault(__webpack_require__(103));

var _angularSanitize = _interopRequireDefault(__webpack_require__(482));

var _angularCreditCards = _interopRequireDefault(__webpack_require__(483));

__webpack_require__(941);

var _mobileDragDrop = __webpack_require__(943);

var _api = __webpack_require__(944);

var _settings = __webpack_require__(15);

var _titleCase = __webpack_require__(945);

var _gtmClickEvent = __webpack_require__(946);

var _analyticsClickEvent = __webpack_require__(947);

var _ieSmoothScroll = __webpack_require__(948);

var _browserClasses = __webpack_require__(949);

var _auth = __webpack_require__(77);

var _auth0sdk = __webpack_require__(328);

var _auth0auth = __webpack_require__(166);

var _nativePlatform = __webpack_require__(125);

var _mdMenuCleaner = __webpack_require__(962);

var _launchAppExtensionPreview = __webpack_require__(401);

var _optimizely = __webpack_require__(264);

var _app = __webpack_require__(1368);

var _app2 = __webpack_require__(375);

var _pages = __webpack_require__(1398);

var _labels = __webpack_require__(1648);

var _redirects = __webpack_require__(1649);

var _appCardConstants = _interopRequireDefault(__webpack_require__(739));

var _constants = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _mobileDragDrop.polyfill)();
var AppModule = angular.module('app', [_angularjs.default, 'ui.router.state.events', _angularTranslate.default, 'ngMaterial', _angularAnimate.default, _angularAria.default, _angularMessages.default, _angularSanitize.default, _angularCookies.default, _angularCreditCards.default, 'cloudinary', _labels.AppLabelsModule, _pages.PagesModule, _api.ApiInterceptorModule, _settings.AppSettingsModule, _titleCase.TitleCaseFilterModule, _gtmClickEvent.GtmClickEventDirectiveModule, _analyticsClickEvent.AnalyticsClickEventDirectiveModule, _ieSmoothScroll.IeSmoothScrollModule, _browserClasses.BrowserClassesModule, _auth.AuthServiceModule, _auth0sdk.Auth0SdkServiceModule, _auth0auth.Auth0AuthServiceModule, _nativePlatform.NativePlatformServiceModule, _mdMenuCleaner.MdMenuCleanerServiceModule, _app.AppComponentModule, _app2.AppServiceModule, _launchAppExtensionPreview.LaunchAppExtensionPreviewServiceModule, _optimizely.OptimizelyServiceModule, _redirects.RedirectsModule]).config(["$provide", "$httpProvider", function ($provide, $httpProvider) {
  $httpProvider.interceptors.push('apiInterceptor');
}]).config(["$sceDelegateProvider", function ($sceDelegateProvider) {
  $sceDelegateProvider.resourceUrlWhitelist(['**']);
}]).config(["$locationProvider", "$urlRouterProvider", "$stateProvider", function ($locationProvider, $urlRouterProvider, $stateProvider) {
  // We defer routing initialization until we've registered redirects to the new admin.
  // This is due to the integration with launch darkly to control the redirects at a user
  // level, which requires a network call.
  $urlRouterProvider.deferIntercept();
  $locationProvider.html5Mode(true);
  $urlRouterProvider.when('/', ["$match", "$state", "$cookies", "$window", "auth0AuthService", function ($match, $state, $cookies, $window, auth0AuthService) {
    'ngInject';

    var handleAuthenticated = function handleAuthenticated() {
      auth0AuthService.getUser().then(function (user) {
        var redirect = $cookies.get(_constants.LOGIN_REDIRECT_COOKIE);
        $cookies.remove(_constants.LOGIN_REDIRECT_COOKIE);

        if (user[_constants.AUTH0_PASSWORD_EXPIRED_CLAIM]) {
          $state.transitionTo('myAccount', $match, false);
        } else if (redirect && redirect.length > 1 && redirect.charAt(0) === '/') {
          $window.location.href = "https://admin-sandbox.volusion.com" + redirect;
        } else {
          $state.transitionTo('dashboard', $match, false);
        }
      });
    };

    var checkForAuthentications = function checkForAuthentications(checkForToken) {
      return auth0AuthService.isAuthenticated().then(function (authenticated) {
        if (authenticated) {
          handleAuthenticated();
        } else if (checkForToken) {
          auth0AuthService.getTokenSilently().then(function () {
            return checkForAuthentications(false);
          }).catch(function () {
            auth0AuthService.unauthenticatedHandler($window.location.search, $match);
          });
        } else {
          auth0AuthService.unauthenticatedHandler($window.location.search, $match);
        }
      });
    };

    auth0AuthService.clearLegacyUserCookies();
    checkForAuthentications(true).catch(function () {
      auth0AuthService.unauthenticatedHandler($window.location.search, $match);
    });
  }]);
  $urlRouterProvider.otherwise('/dashboard');
  $stateProvider.state('logout', {
    url: '/logout',
    controller: ["auth0AuthService", function controller(auth0AuthService) {
      'ngInject';

      auth0AuthService.logout();
    }]
  });
}]).config(["$translateProvider", "appLabels", function ($translateProvider, appLabels) {
  $translateProvider.translations('en', appLabels);
  $translateProvider.useSanitizeValueStrategy(null);
  $translateProvider.preferredLanguage('en').fallbackLanguage('en');
}]).config(["$mdThemingProvider", function ($mdThemingProvider) {
  var vlnAmber = $mdThemingProvider.extendPalette('amber', {
    contrastLightColors: ['A700']
  });
  $mdThemingProvider.definePalette('vln-secondary', vlnAmber);
  var vlnWarn = $mdThemingProvider.extendPalette('grey', {
    500: '#FFF',
    A700: '#FFF'
  });
  $mdThemingProvider.definePalette('vln-warn', vlnWarn);
  $mdThemingProvider.theme('default').primaryPalette('grey').accentPalette('vln-secondary', {
    default: 'A700'
  });
  $mdThemingProvider.theme('delete-confirm').primaryPalette('grey');
  $mdThemingProvider.theme('dark').accentPalette('vln-warn').warnPalette('vln-warn').dark();
}]).config(["$provide", "$compileProvider", function ($provide, $compileProvider) {
  $compileProvider.commentDirectivesEnabled(false);

  if (false) {
    $compileProvider.debugInfoEnabled(false);
  }

  $provide.decorator('$window', ["$delegate", function ($delegate) {
    var location = $delegate.location; // IE doesn't support window.location.origin

    if (!location.origin) {
      location.origin = "".concat(location.protocol, "//").concat(location.hostname).concat(location.port ? ":".concat(location.port) : '');
    }

    return $delegate;
  }]);
}]).config(["CloudinaryProvider", function (CloudinaryProvider) {
  CloudinaryProvider.configure({
    cloud_name: "materialsandbox"
  });
}]).run(["$rootScope", "$window", "$transitions", "$translate", "$mdDialog", "$state", "mdMenuCleaner", "$filter", "$location", "appsService", "launchAppExtensionModalService", "optimizelyService", "auth0AuthService", "$stateParams", function ($rootScope, $window, $transitions, $translate, $mdDialog, $state, mdMenuCleaner, $filter, $location, appsService, launchAppExtensionModalService, optimizelyService, auth0AuthService, $stateParams) {
  var $body = angular.element($window.document.body);
  var pageClass;
  $rootScope.$on('$locationChangeSuccess', function (e, toUrl) {
    auth0AuthService.isAuthenticated().then(function (authenticated) {
      var url = new URL(toUrl);

      if (!authenticated && url.pathname !== '/login') {
        return auth0AuthService.getTokenSilently();
      }

      return false;
    }).then(function (token) {
      if (token) {
        return !auth0AuthService.isAuthenticated();
      }

      return false;
    }).then(function (shouldHandle) {
      if (shouldHandle) {
        return auth0AuthService.unauthenticatedHandler($window.location.search);
      }
    });
  }); // add page-controllerName class to body on route changes

  $rootScope.$on('$stateChangeSuccess', function (e, toState, toParams, fromState) {
    if (toState) {
      $body.removeClass(pageClass);
      var pageName = toState.data && toState.data.page ? toState.data.page : toState.name;
      pageClass = "page--".concat(pageName);
      $body.addClass(pageClass);

      if (fromState.name === 'dashboard') {
        $body.addClass('page--from-dashboard');
      } else {
        $body.removeClass('page--from-dashboard');
      }
    }

    var sku = $location.search().installApp || $stateParams.installApp;

    if (sku) {
      appsService.getApps().then(function (apps) {
        var filterApps = apps.filter(function (app) {
          return app.sku === sku;
        });
        return filterApps[0];
      }).then(function (app) {
        if (app) {
          return launchAppExtensionModalService.launchPreview('application', app, app.enabled).then(function (appResult) {
            var link = 'dashboard';

            if (appResult.event === 'apps:newInstalled') {
              var appInfo = _appCardConstants.default.APPS.filter(function (apps) {
                return apps.sku === appResult.sku;
              });

              link = appInfo.length ? appInfo[0].link : 'dashboard';
            }

            $state.go(link);
          });
        }
      });
    } //Hint: Check service's definition for docs on why we need this.


    mdMenuCleaner.clean();
    $mdDialog.cancel();
    optimizelyService.getExperiments();
  });
  $rootScope.$on('$viewContentLoaded', function () {
    angular.element($window).scrollTop(0);
    angular.element('body.safari-mobile .layout__scope').scrollTop(0);
  });
  $transitions.onSuccess({}, function (transition) {
    var fromState = transition.$from();
    var toState = transition.$to();

    if ($window.dataLayer && fromState.name) {
      $window.dataLayer.push({
        event: 'virtualPageView',
        virtualPage: $location.path(),
        virtualTitle: toState.name
      });
    }

    if (toState.data && toState.data.title) {
      $translate(toState.data.title).then(function (data) {
        $rootScope.title = $filter('titleCase')(data || toState.name);
      });
    } else if (toState && toState.data && toState.data.rawTitle) {
      $rootScope.rawTitle = toState.data.rawTitle;
    } else {
      $rootScope.title = '';
    }
  });
  $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
    if (error.detail && error.detail.redirectTo && error.detail.redirectTo === fromState.name) {
      $state.reload().then(errorAlert);
      return;
    }

    if (error.detail && error.detail.redirectTo) {
      $state.go(error.detail.redirectTo, error.detail.params).then(errorAlert);
      return;
    }

    if (toState.name !== 'dashboard') {
      $state.go('dashboard', null, {
        reload: true
      }).then(function () {
        showAlert({
          title: 'Error loading page',
          body: 'Please try again later'
        });
      });
    } else {
      $state.go('error');
    }

    function errorAlert() {
      if (error.detail.errorMessage) {
        showAlert(error.detail.errorMessage);
      }
    }

    function showAlert(errorMessage) {
      var title = errorMessage.title,
          body = errorMessage.body;
      var errorOk = 'Ok';
      return $mdDialog.show($mdDialog.alert().title(title).htmlContent(body).ariaLabel(title).ok(errorOk));
    }
  });
}]).run(["redirectsService", "$urlRouter", function (redirectsService, $urlRouter) {
  // Register user redirects to new admin, then re-enable routing.
  redirectsService.registerRedirects().then(function () {
    $urlRouter.sync();
    $urlRouter.listen();
  });
}]).run(["$window", "authTokenService", function ($window, authTokenService) {
  authTokenService.getTenantId();
}]).name;
exports.AppModule = AppModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiInterceptorModule = void 0;

var _constants = __webpack_require__(24);

var ApiInterceptorModule = angular.module('app.services.interceptors.apiInterceptor', []).factory('apiInterceptor', ["$q", "auth0AuthService", "jwtHelper", function ($q, auth0AuthService, jwtHelper) {
  function shouldNotIntercept(url) {
    var baseUrl = "https://sandbox.api-v2.volusion.com";
    var themeUrl = "".concat(baseUrl, "/marketplace");
    var customDomainUrl = "".concat(baseUrl, "/admin/customdomains");
    return url.indexOf(baseUrl) === -1 && url.indexOf(themeUrl) === -1 && url.indexOf("https://t41cezqof9.execute-api.us-east-1.amazonaws.com/development") === -1 && url.indexOf("https://kvxf522wci.execute-api.us-east-1.amazonaws.com/sand") === -1 && url.indexOf(customDomainUrl) === -1 || url.indexOf("".concat(baseUrl, "/plans")) !== -1;
  }

  function getDecodedJWT(token) {
    if (token) {
      return jwtHelper.decodeToken(token);
    }

    return null;
  }

  function getTenantId(decoded) {
    if (decoded) {
      var tenantId = decoded[_constants.AUTH0_TENANT_CLAIM] || decoded.tenant;
      return tenantId;
    }
  }

  return {
    requestError: function requestError(rejection) {
      return $q.reject(rejection);
    },
    responseError: function responseError(rejection) {
      if (rejection.status === 403 && rejection.config.url && rejection.config.url.includes("https://sandbox.api-v2.volusion.com")) {
        return auth0AuthService.unauthenticatedHandler();
      }

      return $q.reject(rejection);
    },
    request: function request(config) {
      if (shouldNotIntercept(config.url)) return config;
      return auth0AuthService.getTokenSilently().then(function (accessToken) {
        if (!config.bypassAuth) {
          config.headers.Authorization = "Bearer ".concat(accessToken);
        }

        var decoded = getDecodedJWT(accessToken);
        var tenantId = getTenantId(decoded);
        config.headers['x-mat-tenant'] = tenantId;
        return config;
      });
    }
  };
}]).name;
exports.ApiInterceptorModule = ApiInterceptorModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleCaseFilterModule = void 0;
var TitleCaseFilterModule = angular.module('app.filters.titleCaseFilter', []).filter('titleCase', function () {
  return function (s) {
    s = s === undefined || s === null ? '' : s;
    return s.toString().replace(/(\b([a-z])|[A-Z])/g, function (ch) {
      return " ".concat(ch.toUpperCase());
    }).trim();
  };
}).name;
exports.TitleCaseFilterModule = TitleCaseFilterModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GtmClickEventDirectiveModule = void 0;
var GtmClickEventDirectiveModule = angular.module('app.directives.gtmClickEvent', []).directive('gtmClickEvent', ["$window", function ($window) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var logGtmEvent = function logGtmEvent() {
        if (typeof $window.dataLayer !== 'undefined') {
          $window.dataLayer.push({
            event: attrs.gtmClickEvent
          });
        }
      };

      element.on('click touchstart', logGtmEvent);
      scope.$on('$destroy', function () {
        element.off('click touchstart', logGtmEvent);
      });
    }
  };
}]).name;
exports.GtmClickEventDirectiveModule = GtmClickEventDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsClickEventDirectiveModule = void 0;

var _segment = __webpack_require__(58);

var AnalyticsClickEventDirectiveModule = angular.module('app.directives.analyticsClickEvent', [_segment.SegmentServiceModule]).directive('analyticsClickEvent', ["$window", "segmentService", "$timeout", function ($window, segmentService, $timeout) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var gtmEvent = function gtmEvent() {
        $timeout(function () {
          return segmentService.trackGtmEvent(attrs, {});
        });
      };

      element.on('click touchstart', gtmEvent);
      scope.$on('$destroy', function () {
        element.off('click touchstart', gtmEvent);
      });
    }
  };
}]).name;
exports.AnalyticsClickEventDirectiveModule = AnalyticsClickEventDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IeSmoothScrollModule = void 0;
var IeSmoothScrollModule = angular.module('app.directives.ieSmoothScroll', []).directive('ieSmoothScroll', ["$window", function ($window) {
  return {
    link: function link() {
      // IE smooth scrolling fix
      if ($window.navigator.userAgent.match(/MSIE 10/i) || $window.navigator.userAgent.match(/Trident\/7\./) || $window.navigator.userAgent.match(/Edge\/12\./)) {
        angular.element('body').on('mousewheel', function () {
          $window.event.preventDefault();
          var wd = $window.event.wheelDelta;
          var csp = $window.pageYOffset;
          $window.scrollTo(0, csp - wd);
        });
      }
    }
  };
}]).name;
exports.IeSmoothScrollModule = IeSmoothScrollModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserClassesModule = void 0;
var BrowserClassesModule = angular.module('app.directives.browserClasses', []).directive('browserClasses', ["$window", function ($window) {
  'ngInject';

  return {
    restrict: 'A',
    link: function link() {
      var ua = $window.navigator.userAgent;
      var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      var webkit = !!ua.match(/WebKit/i);
      var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
      var safari = ua.match(/Safari/i) && !ua.match(/Chrome/i);

      if (iOSSafari && !angular.element('body').hasClass('safari-mobile')) {
        angular.element('body').addClass('safari-mobile');
      }

      if (safari && !angular.element('body').hasClass('safari')) {
        angular.element('body').addClass('safari');
      }
    }
  };
}]).name;
exports.BrowserClassesModule = BrowserClassesModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionTimeoutModalServiceModule = void 0;

var _sessionTimeoutModal = _interopRequireDefault(__webpack_require__(958));

var _sessionTimeoutModal2 = __webpack_require__(959);

__webpack_require__(960);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SessionTimeoutModalServiceModule = angular.module('app.components.sessionTimeoutModal.sessionTimeoutModalService', ['ngMaterial', _sessionTimeoutModal2.SessionTimeoutModalController]).service('sessionTimeoutModalService', ["$mdDialog", function ($mdDialog) {
  function openModal() {
    return $mdDialog.show({
      template: _sessionTimeoutModal.default,
      controller: 'SessionTimeoutModalController',
      parent: angular.element('body'),
      clickOutsideToClose: false
    });
  }

  return {
    openModal: openModal
  };
}]).name;
exports.SessionTimeoutModalServiceModule = SessionTimeoutModalServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = "<md-dialog class=\"session-timeout-modal\"> <md-dialog-content> <div class=\"md-dialog-content\"> <h3 class=\"modal__header\">Please log in again</h3> <div> <p>{{'ERRORPAGE.SESSIONTIMEOUT' | translate}}</p> </div> </div> </md-dialog-content> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button class=\"md-raised md-accent\" ng-click=\"close()\" md-autofocus> Log In </md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionTimeoutModalController = void 0;
var SessionTimeoutModalController = angular.module('app.components.sessionTimeoutModal.sessionTimeoutModalController', ['ngMaterial']).controller('SessionTimeoutModalController', ["$scope", "$mdDialog", function ($scope, $mdDialog) {
  $scope.close = $mdDialog.hide;
}]).name;
exports.SessionTimeoutModalController = SessionTimeoutModalController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConciergeAuthServiceModule = void 0;

var _angularCookies = _interopRequireDefault(__webpack_require__(103));

var _angularJwt = _interopRequireDefault(__webpack_require__(167));

var _authToken = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConciergeAuthServiceModule = angular.module('app.services.auth.conciergeAuthService', [_angularCookies.default, _angularJwt.default, _authToken.AuthTokenServiceModule]).service('conciergeAuthService', ["$cookies", "$q", "$state", "jwtHelper", "authTokenService", function ($cookies, $q, $state, jwtHelper, authTokenService) {
  function isImpersonator() {
    return authTokenService.getDecodedIdToken().then(function (decoded) {
      if (decoded) {
        return !!decoded.impersonated || !!decoded['https://api.material.com/concierge'];
      }

      return false;
    });
  }

  function getDecodedJWT(token) {
    if (token) {
      var decoded = jwtHelper.decodeToken(token);

      if (decoded) {
        return decoded;
      }
    }

    return null;
  }

  return {
    isImpersonator: isImpersonator,
    getDecodedJWT: getDecodedJWT
  };
}]).name;
exports.ConciergeAuthServiceModule = ConciergeAuthServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MdMenuCleanerServiceModule = void 0;
var MdMenuCleanerServiceModule = angular.module('app.services.utilities.mdMenuCleanerService', []).service('mdMenuCleaner', ["$mdUtil", function ($mdUtil) {
  return {
    clean: clean
  };
  /**
  * We use `md-menu` everywhere in the app. Every time we open a md-menu
  * instance, two things happens: An element called `md-backdrop` is added
  * to the DOM and the scroll is disabled adding dom elements and other
  * techniques.
  *
  *`md-backdrop` basically prevents clicking on any element of the page,
  * expect for the menu itself. `md-backdrop` listens for clicks and closes
  * the menu if clicked anywhere outside of the opened menu.
  *
  * When you click either outside of the opened menu or in one of the menu
  * options, these two steps are reverted. This means that both the
  * `md-backdrop` and the actions applied to block the scroll are reverted.
  *
  * Before this fix, there was a bug related to these elements.
  * If you open a menu in the exact moment when the page is about to transition
  * to a new page and the menu is visible for a few ms in the screen, then in the
  * new page **you can’t scroll or click anything. All the UI is blocked by that
  * `md-backdrop` element and you can't scroll either**
  *
  * My theory for this behaviour is that the menu element is mounted too late
  * in the screen, possibly in the destroy phase of the parent component, so
  * the destroy events are not triggered again to perform a proper cleanup of
  * the menu state.
  *
  * If you open the menu too early, before the transition, the destroy phase
  * would happen correctly and the issue is not reproducible.
  *
  * This `clean` function tries to fix that, in a somewhat hacky way, by removing
  * the `md-backdrop` element and also, by calling the miraculously exposed
  * `_restoreScroll` function to unblock the scroll. However, if there are any
  * memory leaks related to the issue, this function won’t fix them.
  *
  * This function should only be called in the `$rootScope.$on('$stateChangeSuccess')`
  * event handler, so we perform the cleanup after we have made a transition from a
  * potentially dirty page.
  */

  function clean() {
    var menuBackdrop = angular.element('md-backdrop.md-menu-backdrop');

    if (menuBackdrop.length) {
      menuBackdrop.remove();

      $mdUtil.disableScrollAround._restoreScroll();
    }
  }
}]).name;
exports.MdMenuCleanerServiceModule = MdMenuCleanerServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppExtensionPreviewModule = void 0;

var _find = _interopRequireDefault(__webpack_require__(66));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _subscription = __webpack_require__(42);

var _extension = __webpack_require__(232);

var _apps = __webpack_require__(76);

var _imageManager = __webpack_require__(648);

var _vlnBackImage = __webpack_require__(263);

var _appBadge = __webpack_require__(1268);

var _appExtensionPreview = _interopRequireDefault(__webpack_require__(1271));

__webpack_require__(1272);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AppExtensionPreviewModule = angular.module('app.components.appExtensionPreview.appExtensionPreview', ['ngMaterial', _angularjs.default, _subscription.SubscriptionServiceModule, _extension.ExtensionServiceModule, _apps.AppsServiceModule, _imageManager.ImageManagerModule, _vlnBackImage.VlnBackImageModule, _appBadge.AppBadgeModule]).component('appExtensionPreview', {
  template: _appExtensionPreview.default,
  bindings: {
    app: '<',
    appType: '@',
    isInstalled: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    AppExtensionPreview.$inject = ["$scope", "$mdDialog", "appsService", "extensionService", "$state", "$q", "subscriptionsService"];

    function AppExtensionPreview($scope, $mdDialog, appsService, extensionService, $state, $q, subscriptionsService) {
      'ngInject';

      _classCallCheck(this, AppExtensionPreview);

      (0, _assign.default)(this, {
        $scope: $scope,
        $mdDialog: $mdDialog,
        appsService: appsService,
        extensionService: extensionService,
        $state: $state,
        $q: $q,
        subscriptionsService: subscriptionsService,
        isInstalled: false,
        isLoading: true,
        gtmid: "admin_".concat($state.current.name)
      });
    }

    _createClass(AppExtensionPreview, [{
      key: "$onInit",
      value: function $onInit() {
        this.setIsInstalledFlag();
      }
    }, {
      key: "closePreview",
      value: function closePreview() {
        this.$mdDialog.cancel('cancel');
      }
    }, {
      key: "setIsInstalledFlag",
      value: function setIsInstalledFlag() {
        var _this = this;

        if (this.isExtension()) {
          this.$q.all([this.extensionService.getTenantExtensions(), this.subscriptionsService.getSubscription()]).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                getTenantExtensionsResponse = _ref2[0],
                getSubscriptionResponse = _ref2[1];

            _this.installedExtensions = getTenantExtensionsResponse;
            _this.isInstalled = (0, _find.default)(_this.installedExtensions, {
              extensionId: _this.app.id
            });
            _this.showUpsell = !_this.isInstalled && !_this.isFeatureAvailableInSubscription(getSubscriptionResponse, _this.app.sku);
            _this.isLoading = false;
          });
        } else if (this.isApplication()) {
          this.isInstalled = this.app.enabled;
          this.subscriptionsService.getSubscription().then(function (subscription) {
            _this.showUpsell = !_this.isInstalled && !_this.isFeatureAvailableInSubscription(subscription, _this.app.sku);
            _this.isLoading = false;
          });
        }
      }
    }, {
      key: "isApplication",
      value: function isApplication() {
        return this.appType === 'application';
      }
    }, {
      key: "isExtension",
      value: function isExtension() {
        return this.appType === 'extension';
      }
    }, {
      key: "isFeatureAvailableInSubscription",
      value: function isFeatureAvailableInSubscription(subscription, featureName) {
        return angular.isUndefined(subscription.features[featureName]) || subscription.features[featureName] === true;
      }
    }, {
      key: "installClicked",
      value: function installClicked() {
        // hide() resolves the promise on the launching $mdDialog, executing the .then() block there.
        // This in turn launches the appExtensionConfirmInstall component.
        // See launchAppExtensionPreview.service.js - launchPreview() to follow the chain.
        this.$mdDialog.hide(); // <- dark magic
      }
    }]);

    return AppExtensionPreview;
  }()
}).name;
exports.AppExtensionPreviewModule = AppExtensionPreviewModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(__webpack_require__(234));

var _ApiConfig = _interopRequireDefault(__webpack_require__(235));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var OnboardingService =
/*#__PURE__*/
function () {
  function OnboardingService() {
    _classCallCheck(this, OnboardingService);

    this.baseApiUrl = "https://kvxf522wci.execute-api.us-east-1.amazonaws.com/sand";
  }

  _createClass(OnboardingService, [{
    key: "getOnboardingData",
    value: function getOnboardingData() {
      return _axios.default.get(this.baseApiUrl, _ApiConfig.default.getHttpConfig(true, true));
    }
  }, {
    key: "updateTask",
    value: function updateTask(data) {
      return _axios.default.patch(this.baseApiUrl, data, this.getPatchConfig());
    }
  }, {
    key: "dismissHotspot",
    value: function dismissHotspot(hotspotId) {
      return _axios.default.patch("".concat(this.baseApiUrl, "/hotspot"), hotspotId, this.getPatchConfig());
    }
  }, {
    key: "getPatchConfig",
    value: function getPatchConfig() {
      var patchConfig = _ApiConfig.default.getHttpConfig(true, true);

      patchConfig.headers['Content-Type'] = 'application/json';
      return patchConfig;
    }
  }]);

  return OnboardingService;
}();

var _default = new OnboardingService();

exports.default = _default;

/***/ }),
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(__webpack_require__(234));

var _ApiConfig = _interopRequireDefault(__webpack_require__(235));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ADD_AUTH_TOKEN = false;
var USE_OLD_TENANT_HEADER = true;

var OptimizelyService =
/*#__PURE__*/
function () {
  function OptimizelyService() {
    _classCallCheck(this, OptimizelyService);

    this.baseApiUrl = "https://mrkt-data-analytics-dot-v1-dev-main.appspot.com/opt";
  }

  _createClass(OptimizelyService, [{
    key: "getVariationState",
    value: function getVariationState() {
      return _axios.default.get("".concat(this.baseApiUrl, "/g/state"), _ApiConfig.default.getHttpConfig(ADD_AUTH_TOKEN, USE_OLD_TENANT_HEADER));
    }
  }, {
    key: "setVariationState",
    value: function setVariationState(state) {
      return _axios.default.post("".concat(this.baseApiUrl, "/s/state"), {
        state: JSON.stringify(state)
      }, this.getPostConfig());
    }
  }, {
    key: "getPostConfig",
    value: function getPostConfig() {
      var postConfig = _ApiConfig.default.getHttpConfig(ADD_AUTH_TOKEN, USE_OLD_TENANT_HEADER);

      postConfig.headers['Content-Type'] = 'application/json';
      return postConfig;
    }
  }]);

  return OptimizelyService;
}();

var _default = new OptimizelyService();

exports.default = _default;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hotspotAreas = void 0;
var hotspotAreas = {
  dashboard: {
    taskName: 'welcome.dashboardWalkthrough',
    hotspots: ['dashboard.progress', 'dashboard.settings', 'dashboard.account']
  },
  quickmenu: {
    taskName: 'welcome.menuWalkthrough',
    hotspots: ['quickmenu.quickmenu']
  },
  slider: {
    taskName: 'welcome.sliderWalkthrough',
    hotspots: ['slider.slider', 'slider.resize', 'slider.storeUrl', 'slider.devices', 'slider.editor']
  },
  analytics: {
    hotspots: ['analytics.exportorders', 'analytics.analyticsapp', 'analytics.exportAbandonedCarts']
  },
  customers: {
    hotspots: ['customers.exportcustomers']
  },
  header: {
    taskName: 'welcome.dashboardHeaderImage',
    hotspots: ['header.dashboardimage']
  },
  settings: {
    hotspots: ['settings.addresses']
  },
  founderguide: {
    hotspots: ['founderguide.progressbar']
  }
};
exports.hotspotAreas = hotspotAreas;

/***/ }),
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ImageEditor = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

var _grid = __webpack_require__(83);

var _thread = __webpack_require__(64);

var _reactCropper = _interopRequireDefault(__webpack_require__(1137));

__webpack_require__(1139);

var _Footer = _interopRequireDefault(__webpack_require__(692));

var _Modal = __webpack_require__(385);

var _ModalToolbar = _interopRequireDefault(__webpack_require__(652));

var _Typography = __webpack_require__(634);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin-right: 20px;\n    width: auto;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    min-width: 900px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = (0, _styledComponents.default)(_grid.Flex).attrs({
  flexDirection: 'column'
}).withConfig({
  displayName: "ImageEditor__Wrapper",
  componentId: "hhleis-0"
})(["background-color:", ";max-height:90vh;", ""], _thread.colors.black10, _thread.media.md(_templateObject()));
var Menu = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "ImageEditor__Menu",
  componentId: "hhleis-1"
})(["list-style:none;li{margin:8px;}li:hover{cursor:pointer;}"]);
var CenteredMenu = (0, _styledComponents.default)(Menu).withConfig({
  displayName: "ImageEditor__CenteredMenu",
  componentId: "hhleis-2"
})(["margin:0 auto;"]);
var Footer = (0, _styledComponents.default)(_Footer.default).withConfig({
  displayName: "ImageEditor__Footer",
  componentId: "hhleis-3"
})(["border-top:1px solid #ddd;background:#fff;min-height:64px;"]);
var SecondaryButton = (0, _styledComponents.default)(_thread.Button).attrs({
  large: true
}).withConfig({
  displayName: "ImageEditor__SecondaryButton",
  componentId: "hhleis-4"
})(["color:", ";width:100%;margin:0;", " *{pointer-events:none;}"], _thread.colors.darkGray, _thread.media.sm(_templateObject2()));
var PrimaryButton = (0, _styledComponents.default)(SecondaryButton).attrs({
  variant: 'primary'
}).withConfig({
  displayName: "ImageEditor__PrimaryButton",
  componentId: "hhleis-5"
})(["box-shadow:none;&:hover{background-color:", ";}&:disabled{background-color:", ";}&:hover:disabled{cursor:not-allowed;}"], _thread.colors.black54, _thread.colors.black38);

var ImageEditor =
/*#__PURE__*/
function (_Component) {
  _inherits(ImageEditor, _Component);

  function ImageEditor(props) {
    var _this;

    _classCallCheck(this, ImageEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageEditor).call(this, props));

    _this.reset = function () {
      _this.setState({
        editedCanvas: null
      });
    };

    _this.setCropperRef = function (cropper) {
      _this.cropper = cropper;
    };

    _this.crop = function () {
      _this.setState({
        editedCanvas: _this.cropper.getCroppedCanvas()
      });
    };

    _this.rotate = function () {
      _this.cropper.enable();

      _this.cropper.clear();

      _this.cropper.rotate(-90);

      _this.setState({
        editedCanvas: _this.cropper.getCroppedCanvas()
      });
    };

    _this.handleSave = function () {
      var _this$props = _this.props,
          onSave = _this$props.onSave,
          imageIndex = _this$props.imageIndex;
      var editedCanvas = _this.state.editedCanvas;

      if (editedCanvas) {
        editedCanvas.toBlob(function (blob) {
          onSave(blob, imageIndex);

          _this.reset();
        });
      }
    };

    _this.handleClose = function () {
      _this.reset();

      _this.props.onClose();
    };

    _this.imageDimension = '350px';
    _this.state = {
      editedCanvas: null
    };
    return _this;
  }

  _createClass(ImageEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.cropper) {
        this.setState({
          editedCanvas: this.cropper.getCroppedCanvas()
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.reset();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          isOpen = _this$props2.isOpen,
          onClose = _this$props2.onClose,
          url = _this$props2.url;
      return _react.default.createElement(_Modal.Modal, {
        open: isOpen
      }, _react.default.createElement(Wrapper, null, _react.default.createElement(_ModalToolbar.default, {
        bgColor: "#0FB3CC",
        height: "64px"
      }, _react.default.createElement(_Typography.PageTitle, null, "Image Editor"), _react.default.createElement(_thread.Button, {
        variant: "icon",
        icon: "close",
        onClick: onClose
      })), _react.default.createElement(_ModalToolbar.default, {
        bgColor: "#0DA1B7",
        height: "48px"
      }, _react.default.createElement(CenteredMenu, null, _react.default.createElement(_thread.Button, {
        variant: "link",
        icon: "crop",
        onClick: this.crop
      }, "Crop"), _react.default.createElement(_thread.Button, {
        variant: "link",
        icon: "rotate_90_degrees_ccw",
        onClick: this.rotate
      }, "Rotate"))), _react.default.createElement(_grid.Box, {
        width: ['100%', 'auto'],
        pb: ['8px', 0]
      }, _react.default.createElement(_grid.Flex, {
        justifyContent: ['space-between', 'center'],
        pt: 15,
        pb: 15
      }, _react.default.createElement(_reactCropper.default, {
        background: false,
        crop: this.crop,
        id: "img-".concat(id),
        ref: this.setCropperRef,
        src: url,
        style: {
          width: this.imageDimension,
          height: this.imageDimension
        } // Does not allow the cropbox to exceed the size of the image container
        ,
        viewMode: 2
      }))), _react.default.createElement(Footer, null, _react.default.createElement(SecondaryButton, {
        onClick: this.handleClose
      }, "Cancel"), _react.default.createElement(PrimaryButton, {
        onClick: this.handleSave,
        disabled: !this.state.editedCanvas
      }, "Save New Image"))));
    }
  }]);

  return ImageEditor;
}(_react.Component);

exports.ImageEditor = ImageEditor;
ImageEditor.propTypes = {
  id: _propTypes.default.string,
  imageIndex: _propTypes.default.number,
  isOpen: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  onSave: _propTypes.default.func,
  url: _propTypes.default.string
};
var _default = ImageEditor;
exports.default = _default;

/***/ }),
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageLibraryControllerModule = void 0;

var _angularClipboard = _interopRequireDefault(__webpack_require__(702));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _ngFileUpload = _interopRequireDefault(__webpack_require__(205));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _uniq = _interopRequireDefault(__webpack_require__(394));

var _forEach = _interopRequireDefault(__webpack_require__(393));

var _forEachRight = _interopRequireDefault(__webpack_require__(703));

var _size = _interopRequireDefault(__webpack_require__(704));

var _index = __webpack_require__(527);

var _images = __webpack_require__(405);

var _imageReader = __webpack_require__(421);

var _onScrollEnd = __webpack_require__(706);

var _imageLibraryDelete = _interopRequireDefault(__webpack_require__(707));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLibraryControllerModule = angular.module('app.components.imageLibrary.imageLibraryController', ['ngMaterial', _angularClipboard.default.name, _angularTranslate.default, _ngFileUpload.default, _images.ImagesServiceModule, _index.ImageEditorModule, _imageReader.ImageReaderServiceModule, _onScrollEnd.OnScrollEndDirective, _angularjs.default]).controller('ImageLibraryController', ["$scope", "$q", "$window", "$mdDialog", "$mdBottomSheet", "$mdToast", "$mdMedia", "imagesService", "imageReader", "$timeout", "context", "associationTags", "multiSelect", "clearImage", "clipboard", "$translate", "$document", "$state", function ($scope, $q, $window, $mdDialog, $mdBottomSheet, $mdToast, $mdMedia, imagesService, imageReader, $timeout, context, associationTags, multiSelect, clearImage, clipboard, $translate, $document, $state) {
  var imageLimit = 2500;
  var vm = {
    currentPage: 0,
    pageSize: 25,
    totalImagesCount: 0,
    imageLimitReached: false,
    translationsArray: ['IMAGELIBRARY.CLIPBOARDSUCCESS', 'IMAGELIBRARY.DELETESUCCESS', 'IMAGELIBRARY.IMAGE', 'IMAGELIBRARY.IMAGES', 'ERROR.IMAGEVALIDATION'],
    translations: [],
    images: [],
    selectedImages: {},
    shouldBeFullscreen: false,
    hasTriedToGetData: false,
    noMoreResults: false,
    isLoading: false,
    isLoadingMoreResults: false,
    isImageEditModalOpen: false,
    context: context,
    associationTags: associationTags,
    multiSelect: multiSelect,
    selectImage: selectImage,
    deselectImage: deselectImage,
    toggleImageSelect: toggleImageSelect,
    selectAll: selectAll,
    deselectAll: deselectAll,
    getSelectedImage: getSelectedImage,
    deleteSelectedImages: deleteSelectedImages,
    showDeleteConfirmation: showDeleteConfirmation,
    confirmDelete: confirmDelete,
    cancelDelete: cancelDelete,
    supportsCopy: false,
    showValidationError: showValidationError,
    onClipboardCopySuccess: onClipboardCopySuccess,
    useImages: useImages,
    editSelectedImage: editSelectedImage,
    noImagesToModify: noImagesToModify,
    getSelectedImagesSize: getSelectedImagesSize,
    resetImages: resetImages,
    doubleClickImage: doubleClickImage,
    cancel: cancel,
    setPreviouslyUsedTitle: setPreviouslyUsedTitle,
    previouslyUsedTitle: context,
    previouslyUsedImages: [],
    previouslyUsedImagesPage: 0,
    previouslyUsedImagesTotalCount: 0,
    enterPreviouslyUsedState: enterPreviouslyUsedState,
    exitPreviouslyUsedState: exitPreviouslyUsedState,
    previouslyUsedImagesMode: 'preview',
    maxNumberInPreview: 3,
    getImages: getImages,
    getPreviouslyUsedImages: getPreviouslyUsedImages,
    getAllImages: getAllImages,
    previouslyUsedImagesPreview: [],
    hidePreviouslyUsedPreview: hidePreviouslyUsedPreview,
    onScroll: onScroll,
    onCloseImageEditor: onCloseImageEditor,
    clearImage: clearImage,
    clearSelectedHeaderImage: clearSelectedHeaderImage,
    $state: $state
  };

  function init() {
    $scope.vm = vm; // Get Images

    getPreviouslyUsedImages().then(function (images) {
      setPreviouslyUsedTitle();
      setPreviewImages(images);
    });
    $q.all([getAllImages(), imagesService.getImageLimit()]).then(function (response) {
      imageLimit = response[1];
      vm.imageLimitReached = vm.totalImagesCount >= imageLimit;
    });
    initCopyToClipboard();
    $translate(vm.translationsArray).then(function (translations) {
      vm.translations = translations;
    });
    $scope.$watch(function () {
      return $mdMedia('gt-xs');
    }, function (isGreaterThanXS) {
      vm.shouldBeFullscreen = !isGreaterThanXS;
    });
    $scope.$watch('vm.files', function () {
      if (vm.imageLimitReached) {
        $translate('ERROR.IMAGELIMITREACHED').then(function (error) {
          $mdToast.show($mdToast.simple().textContent(error).position('bottom left'));
        });
        return;
      }

      if (vm.files && vm.files.length > 0) {
        vm.isLoading = true;
        $window.dataLayer.push({
          event: 'admin_image-gallery-upload'
        });
        uploadImages(vm.files).then(function (images) {
          addImagesToGrid(images, true);
          vm.isLoading = false;
        }).catch(function () {
          vm.isLoading = false;
          $translate('ERROR.GENERAL_FAILURE_ERROR').then(function (error) {
            $mdToast.show($mdToast.simple().textContent(error).position('bottom left'));
          });
        });
      }
    });
    $scope.$watch('vm.invalidFiles', function (newVal) {
      if (newVal && newVal.length > 0) vm.showValidationError();
    });
  }

  function showValidationError() {
    $mdToast.show($mdToast.simple().textContent(vm.translations['ERROR.IMAGEVALIDATION']).position('bottom left').parent('.image-library').hideDelay(4000));
  }

  function initCopyToClipboard() {
    if ($document[0].execCommand('copy', false)) vm.supportsCopy = true;
  }

  function setPreviewImages(images) {
    vm.previouslyUsedImagesPreview = images.slice(0, vm.maxNumberInPreview);
  }

  function setPreviouslyUsedTitle() {
    vm.previouslyUsedTitle = vm.context === 'editstore' && vm.associationTags.length > 0 ? vm.associationTags[0] : vm.context;
  }

  function getImages(tags, page, count) {
    vm.isLoadingMoreResults = true;
    return imagesService.getImagesFromAlgolia(tags, page, count).then(function (data) {
      vm.hasTriedToGetData = true;
      vm.isLoadingMoreResults = false;
      return data;
    });
  }

  function getPreviouslyUsedImages() {
    return getImages(associationTags, vm.previouslyUsedImagesPage, 20).then(function (data) {
      vm.previouslyUsedImagesTotalCount = data.nbHits;

      if (data.hits.length > 0) {
        vm.previouslyUsedImages = (0, _uniq.default)(vm.previouslyUsedImages, function (el) {
          return el.id;
        }).concat(data.hits);
      }

      vm.previouslyUsedImagesPage += 1;
      return data.hits;
    });
  }

  function getAllImages() {
    if (!vm.noMoreResults) {
      return getImages([], vm.currentPage, vm.pageSize).then(function (data) {
        vm.totalImagesCount = data.nbHits;
        if (data.hits.length > 0) vm.images = (0, _uniq.default)(vm.images, function (el) {
          return el.id;
        }).concat(data.hits);
        vm.currentPage += 1;
        if (data.hits.length === 0 || data.page === data.nbPages - 1) vm.noMoreResults = true;
        vm.imageLimitReached = vm.totalImagesCount >= imageLimit;
      });
    }

    return $q.resolve();
  }

  function onScroll() {
    if (!vm.isLoadingMoreResults && !vm.noMoreResults) {
      if (vm.previouslyUsedImagesMode === 'full') {
        vm.getPreviouslyUsedImages();
      } else {
        vm.getAllImages();
      }
    }
  }

  function enterPreviouslyUsedState() {
    vm.resetImages();
    vm.deselectAll();
    vm.previouslyUsedImagesMode = 'full';
    vm.images = angular.copy(vm.previouslyUsedImages);
  }

  function exitPreviouslyUsedState() {
    vm.deselectAll();
    vm.previouslyUsedImagesMode = 'preview';
    vm.resetImages();
    getAllImages();
  }

  function hidePreviouslyUsedPreview() {
    vm.previouslyUsedImagesMode = 'hidden';
  }

  function addImagesToGrid(images, selectOnAdd) {
    angular.forEach(images, function (image) {
      vm.images.splice(0, 0, image);

      if (multiSelect && selectOnAdd) {
        selectImage(0);
      }
    });
  }

  function resetImages() {
    vm.deselectAll();
    vm.noMoreResults = false;
    vm.currentPage = 0;
    vm.images = [];
  }

  function doubleClickImage(index) {
    vm.selectImage(index);
    vm.useImages();
  }

  function selectImage(index) {
    vm.images[index].selected = true;
    vm.selectedImages[vm.images[index].id] = vm.images[index];
  }

  function deselectImage(index) {
    vm.images[index].selected = false;
    delete vm.selectedImages[vm.images[index].id];
  }

  function toggleImageSelect(index) {
    if (vm.images[index].selected) {
      deselectImage(index);
    } else {
      if (!multiSelect && getSelectedImagesSize() === 1) {
        deselectAll();
      }

      selectImage(index);
    }
  }

  function selectAll() {
    vm.selectedImages = {};
    (0, _forEach.default)(vm.images, function (image, key) {
      selectImage(key);
    });
  }

  function deselectAll() {
    if (getSelectedImagesSize() > 0) {
      vm.selectedImages = {};
      (0, _forEach.default)(vm.images, function (image, key) {
        vm.images[key].selected = false;
      });
    }
  }

  function useImages() {
    if (associationTags.length > 0) {
      imagesService.updateTags(vm.selectedImages, associationTags);
    }

    var returnData = multiSelect ? vm.selectedImages : getSelectedImage();
    $mdDialog.hide(returnData);
  }

  function editSelectedImage() {
    vm.isImageEditModalOpen = true;
    var image = getSelectedImage();
    vm.selectedImage = image;
    vm.imageId = image.id;
    vm.imageUrl = image.fullUri;
    vm.onSave = uploadFile;
  }

  function uploadFile(blob) {
    vm.isLoading = true;
    vm.isImageEditModalOpen = false;
    return uploadImages([blob]).then(function (data) {
      $mdToast.show($mdToast.simple().textContent('Image edited successfully').position('bottom left'));
      $window.dataLayer.push({
        event: 'admin_image-editor_image-edit-save-success'
      });
      deselectAll();
      addImagesToGrid(data, true);
    }).finally(function () {
      vm.isLoading = false;
      vm.isImageEditModalOpen = false;
    });
  }

  function getSelectedImage() {
    return vm.selectedImages[Object.keys(vm.selectedImages)[0]];
  }

  function onClipboardCopySuccess() {
    $mdToast.show($mdToast.simple().textContent(vm.translations['IMAGELIBRARY.CLIPBOARDSUCCESS']).position('bottom left').parent('.image-library').hideDelay(3000));
  }

  function showDeleteSuccess(numberDeleted) {
    var deleteMessagePlurality = numberDeleted === 1 ? vm.translations['IMAGELIBRARY.IMAGE'] : vm.translations['IMAGELIBRARY.IMAGES'];
    var deleteMessage = "".concat(numberDeleted, " ").concat(deleteMessagePlurality, "\n                ").concat(vm.translations['IMAGELIBRARY.DELETESUCCESS']);
    $mdToast.show($mdToast.simple().textContent(deleteMessage).position('bottom left').parent('.image-library').hideDelay(3000));
  }

  function showDeleteConfirmation() {
    $mdBottomSheet.show({
      template: _imageLibraryDelete.default,
      parent: '.image-library',
      preserveScope: true,
      scope: $scope,
      clickOutsideToClose: false
    }).then(function (resolve) {
      if (resolve !== false) {
        // hack to prevent image from being deleted on dialog close
        deleteSelectedImages();
      }
    });
  }

  function cancelDelete() {
    $mdBottomSheet.cancel();
  }

  function confirmDelete() {
    $mdBottomSheet.hide();
  }

  function deleteSelectedImages() {
    vm.isLoading = true;
    imagesService.removeImages(vm.selectedImages).then(function () {
      showDeleteSuccess(getSelectedImagesSize());
      vm.isLoading = false;
      (0, _forEachRight.default)(vm.images, function (image, key) {
        if (image.selected) {
          vm.images.splice(key, 1);
        }
      });
      vm.selectedImages = {};
    }).catch(function (err) {
      var message = 'There was an error deleting the image';
      if (err.data && err.data.message) message = "".concat(message, ":<p>").concat(err.data.message, "</p>");
      return $mdDialog.show($mdDialog.alert().title('Error').htmlContent(message).ariaLabel('Error').ok('OK'));
    });
  }

  function noImagesToModify() {
    return vm.images.length === 0 || !multiSelect && getSelectedImagesSize() === 0;
  }

  function getSelectedImagesSize() {
    return (0, _size.default)(vm.selectedImages);
  }

  function cancel() {
    if (vm.isImageEditModalOpen) {
      onCloseImageEditor();
    }

    $mdDialog.cancel();
  }

  function onCloseImageEditor() {
    vm.isImageEditModalOpen = false;
    $scope.$apply();
  }

  function uploadImages(files) {
    return imageReader.getImagesData(files).then(function (dataFiles) {
      return imagesService.saveImages(dataFiles);
    });
  }

  function clearSelectedHeaderImage() {
    if (vm.clearImage) {
      vm.clearImage();
      $mdDialog.cancel();
    }
  }

  init();
}]).name;
exports.ImageLibraryControllerModule = ImageLibraryControllerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */
/***/ (function(module, exports) {

module.exports = "<md-dialog aria-label=\"Select Image\" ng-cloak class=\"image-library image-library--{{::vm.context}}\" ng-class=\"{'md-dialog-fullscreen': vm.shouldBeFullscreen}\"> <md-toolbar class=\"image-library__header\" ng-class=\"{'image-library__header--images-selected': vm.getSelectedImagesSize() > 0}\" ng-show=\"!vm.isImageEditModalOpen\"> <div class=\"md-toolbar-tools selected-toolbar\"> <md-button class=\"md-icon-button image-library__back\" ng-click=\"vm.deselectAll()\" hide show-gt-sm> <md-icon>arrow_back</md-icon> </md-button> <span class=\"selected-items\"> <span class=\"selected-items__text\"> <span class=\"selected-items__number\"> {{vm.getSelectedImagesSize()}} </span> {{'IMAGELIBRARY.SELECTED' | translate}} </span> <md-menu class=\"selected-items__menu\" md-offset=\"0 45\" md-position-mode=\"target-right target\"> <md-button aria-label=\"Open selection menu\" class=\"md-icon-button selected-items__open-btn\" ng-click=\"$mdMenu.open($event)\"> <md-icon md-menu-origin>keyboard_arrow_down</md-icon> </md-button> <md-menu-content class=\"selected-items__menu-content\"> <md-menu-item hide-gt-sm> <md-button ng-click=\"vm.showDeleteConfirmation()\"> {{'IMAGELIBRARY.TOOLTIPDELETE' | translate}} </md-button> </md-menu-item> <md-menu-item ng-if=\"vm.getSelectedImagesSize() == 1 && vm.supportsCopy\" hide-gt-sm> <md-button clipboard text=\"vm.getSelectedImage().fullUri\" on-copied=\"vm.onClipboardCopySuccess()\" on-error=\"vm.onClipboardCopyFail(err)\"> {{'IMAGELIBRARY.TOOLTIPCLIPBOARD' | translate}} </md-button> </md-menu-item> <md-menu-item ng-if=\"vm.multiSelect\"> <md-button ng-click=\"vm.selectAll()\" class=\"image-library__select-all\"> {{'IMAGELIBRARY.SELECTALL' | translate}} </md-button> </md-menu-item> <md-menu-item> <md-button ng-click=\"vm.deselectAll()\" class=\"image-library__select-none\"> {{'IMAGELIBRARY.SELECTNONE' | translate}} </md-button> </md-menu-item> </md-menu-content> </md-menu> </span> <span flex></span> <span class=\"action-buttons\" hide show-gt-sm> <span ng-if=\"vm.getSelectedImagesSize() == 1\"> <md-button class=\"md-icon-button action-button action-button--copy-to-clipboard\" ng-if=\"vm.supportsCopy\" clipboard text=\"vm.getSelectedImage().fullUri\" on-copied=\"vm.onClipboardCopySuccess()\"> <md-tooltip md-delay=\"300\" md-direction=\"bottom\">{{'IMAGELIBRARY.TOOLTIPCLIPBOARD' | translate}}</md-tooltip> <md-icon>link</md-icon> </md-button> <md-button class=\"md-icon-button action-button action-button--edit\" data-ng-click=\"vm.editSelectedImage()\"> <md-tooltip md-delay=\"300\" md-direction=\"bottom\">{{'IMAGELIBRARY.TOOLTIPEDIT' | translate}}</md-tooltip> <md-icon>mode_edit</md-icon> </md-button> </span> <md-button class=\"md-icon-button action-button action-button--delete\" ng-click=\"vm.showDeleteConfirmation()\"> <md-tooltip md-delay=\"300\" md-direction=\"bottom\">{{'IMAGELIBRARY.TOOLTIPDELETE' | translate}}</md-tooltip> <md-icon>delete</md-icon> </md-button> </span> <md-button class=\"md-accent md-raised image-library__use\" ng-click=\"vm.useImages()\">{{'IMAGELIBRARY.USE' | translate}}</md-button> </div> <div class=\"md-toolbar-tools default-toolbar\"> <div ng-hide=\"vm.previouslyUsedImagesMode == 'full'\"> <span class=\"image-library__title\">{{'IMAGELIBRARY.TITLE' | translate}}</span> <p class=\"image-library__limit-reached\" ng-if=\"vm.imageLimitReached\">{{'IMAGELIBRARY.UPLOADLIMIT' | translate}}</p> </div> <div ng-if=\"vm.previouslyUsedImagesMode == 'full'\"> <md-button class=\"md-icon-button image-library__back\" ng-click=\"vm.exitPreviouslyUsedState()\"> <md-icon>arrow_back</md-icon> </md-button> <span class=\"image-library__title\">{{'IMAGELIBRARY.RECENTLYUSED' | translate}} <span hide show-gt-sm>{{'IMAGELIBRARY.IN' | translate}} {{vm.previouslyUsedTitle}}</span></span> </div> <span flex></span> <md-button ng-if=\"vm.$state.current.name === 'dashboard'\" ng-click=\"vm.clearSelectedHeaderImage()\" class=\"image-library__remove-header-image-button\"> <md-icon class=\"image-library__remove-header-image-icon\" aria-label=\"Clear header image\">delete</md-icon> <span hide-xs>Remove Image</span> </md-button> <md-button class=\"md-raised md-accent image-library__add-button\" aria-label=\"Upload Images\" ngf-select ngf-multiple=\"true\" ng-model=\"vm.files\" ngf-model-invalid=\"vm.invalidFiles\" ngf-max-size=\"5000000\" ngf-accept=\"'image/*'\" ngf-pattern=\"'.jpg,.jpeg,.png,.gif'\" ng-disabled=\"vm.imageLimitReached\" ng-if=\"!vm.isImageEditModalOpen && vm.getSelectedImagesSize() == 0 && vm.previouslyUsedImagesMode != 'full'\"> <md-tooltip>Max file size: 5MB. Allowed file types: png, jpg, jpeg, gif.</md-tooltip> <md-icon>add_to_photos</md-icon> <span hide-xs>Upload Images</span> </md-button> <md-button class=\"md-icon-button image-library__close\" ng-click=\"vm.cancel()\"> <md-icon aria-label=\"Close dialog\">close</md-icon> </md-button> </div> </md-toolbar> <md-content layout=\"row\" flex class=\"image-library__content-wrap\" ng-show=\"!vm.isImageEditModalOpen\"> <md-dialog-content class=\"image-library__content\" flex on-scroll-end=\"vm.onScroll()\"> <div class=\"md-dialog-content\"> <div class=\"previously-used-preview\" ng-if=\"vm.images.length > 0 && vm.previouslyUsedImages.length > 0 && vm.previouslyUsedImagesMode == 'preview' && vm.associationTags.length > 0\"> <div class=\"previously-used-preview__header\"> <h4 class=\"image-library__section-title\">{{'IMAGELIBRARY.RECENTLYUSED' | translate}} <span hide show-gt-sm>{{'IMAGELIBRARY.IN' | translate}} {{vm.previouslyUsedTitle}}</span></h4> <span flex></span> <md-button ng-click=\"vm.hidePreviouslyUsedPreview()\" class=\"previously-used-preview__dismiss\">{{'IMAGELIBRARY.DISMISS' | translate}}</md-button> </div> <ul class=\"previously-used-preview__list\" layout=\"row\" ng-click=\"vm.enterPreviouslyUsedState()\"> <li class=\"previously-used-preview__item\" flex=\"25\" ng-repeat=\"image in vm.previouslyUsedImagesPreview track by image.id\" style=\"background-image:url({{::image.fullUri}})\"> </li> <li class=\"previously-used-preview__item previously-used-preview__item--load-more\" flex=\"25\" ng-if=\"vm.previouslyUsedImages.length > vm.maxNumberInPreview\"> {{::vm.previouslyUsedImagesTotalCount - vm.maxNumberInPreview}}+ {{'IMAGELIBRARY.MORE' | translate}} </li> </ul> </div> <div class=\"all-images\" ng-if=\"vm.images.length > 0\"> <h4 class=\"image-library__section-title\" ng-if=\"vm.previouslyUsedImagesMode == 'preview' && vm.previouslyUsedImagesTotalCount > 0\"> {{'IMAGELIBRARY.ALLIMAGES' | translate}} </h4> <md-grid-list md-cols=\"2\" md-cols-sm=\"2\" md-cols-md=\"3\" md-cols-gt-md=\"4\" md-gutter=\"8px\" md-row-height=\"4:3\"> <md-grid-tile ng-repeat=\"image in vm.images track by image.id\"> <image-library-item image=\"image\" index=\"$index\" on-image-toggle=\"vm.toggleImageSelect(index)\" on-select-and-use=\"vm.doubleClickImage(index)\"> </image-library-item> </md-grid-tile> </md-grid-list> </div> <div class=\"loading-more-results\" ng-if=\"vm.isLoadingMoreResults\"> <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\" class=\"loading-more-results__loader\"></md-progress-circular> </div> </div> </md-dialog-content> <div ng-if=\"vm.images.length == 0 && vm.hasTriedToGetData\" class=\"image-library__empty\"> <p class=\"md-title\">{{'IMAGELIBRARY.NOIMAGES' | translate}}</p> </div> </md-content> <image-library-dropzone files=\"vm.files\" invalid-files=\"vm.invalidFiles\"></image-library-dropzone> <div class=\"loader\" ng-if=\"vm.isLoading && !vm.isImageEditModalOpen\"> <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"60\" class=\"loader__loader\"></md-progress-circular> </div> </md-dialog> <image-editor is-open=\"vm.isImageEditModalOpen\" id=\"vm.imageId\" url=\"vm.imageUrl\" gtm-save-event-name=\"vm.gtmImageSaveEventName\" on-close=\"vm.onCloseImageEditor\" on-save=\"vm.onSave\"/> ";

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageLibraryDropzoneModule = void 0;

var _ngFileUpload = _interopRequireDefault(__webpack_require__(205));

var _imageLibraryDropzone = _interopRequireDefault(__webpack_require__(1258));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLibraryDropzoneModule = angular.module('app.components.imageLibrary.imageLibraryDropzone', [_ngFileUpload.default]).directive('imageLibraryDropzone', function () {
  return {
    restrict: 'E',
    template: _imageLibraryDropzone.default,
    scope: {
      files: '=',
      invalidFiles: '='
    },
    link: function link(scope) {
      var dz = angular.element('.image-library-dropzone');
      var body = angular.element('body');
      body.on('dragover', function (e) {
        var dataTypes = e.originalEvent.dataTransfer.types;
        var isFile = Array.isArray(dataTypes) ? dataTypes.indexOf('Files') !== -1 : dataTypes.contains('Files');

        if (isFile) {
          dz.addClass('dragover--isfile');
        }
      });
      body.on('dragleave', function (e) {
        var target = angular.element(e.target);

        if (target.is(dz)) {
          dz.removeClass('dragover--isfile');
        }
      });
      body.on('dragend', function () {
        dz.removeClass('dragover--isfile');
      });
      body.on('drop', function () {
        dz.removeClass('dragover--isfile');
      });
      scope.$on('$destroy', function () {
        angular.element('body').off('dragover');
        angular.element('body').off('drop');
        angular.element('body').off('dragend');
        angular.element('body').off('dragleave');
      });
    }
  };
}).name;
exports.ImageLibraryDropzoneModule = ImageLibraryDropzoneModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

module.exports = "<div class=\"image-library-dropzone\" ngf-drop=\"\" ng-model=\"files\" ngf-model-invalid=\"invalidFiles\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-max-size=\"5000000\" ngf-accept=\"'image/*'\" ngf-pattern=\"'.jpg,.jpeg,.png,.gif'\"> <div class=\"image-library-dropzone__content\"> <div class=\"image-library-dropzone__circle\"> <md-icon class=\"image-library-dropzone__icon\">file_upload</md-icon> </div> <div class=\"image-library-dropzone__text\">{{'IMAGELIBRARY.UPLOAD' | translate}}</div> </div> </div> ";

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageLibraryLaunchModule = void 0;

var _imageLibrary = __webpack_require__(592);

var ImageLibraryLaunchModule = angular.module('app.components.imageLibrary.imageLibraryLaunch', [_imageLibrary.ImageLibraryServiceModule]).directive('imageLibraryLaunch', ["imageLibraryService", function (imageLibraryService) {
  return {
    restrict: 'A',
    scope: {
      imageLibraryOnClearImage: '<',
      imageLibraryOnImagesSelected: '&',
      imageLibraryContext: '=',
      imageLibraryAssociationTags: '=',
      imageLibraryMultiSelect: '=',
      imageLibraryOverrideFunc: '&?',
      hasLibraryOverride: '<?'
    },
    link: function link(scope, element) {
      element.on('click', function (event) {
        if (scope.hasLibraryOverride) {
          scope.imageLibraryOverrideFunc()();
          return;
        }

        imageLibraryService.open({
          event: event,
          multiSelect: scope.imageLibraryMultiSelect,
          context: scope.imageLibraryContext,
          associationTags: scope.imageLibraryAssociationTags,
          clearImage: scope.imageLibraryOnClearImage
        }).then(function (images) {
          scope.imageLibraryOnImagesSelected({
            selectedImages: images
          });
        });
      });
    }
  };
}]).name;
exports.ImageLibraryLaunchModule = ImageLibraryLaunchModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

module.exports = "<div class=\"image-library__item\" ng-click=\"$ctrl.onImageToggle({ index: $ctrl.index })\" ng-class=\"{'image-library__item--selected': $ctrl.image.selected}\" ng-dblclick=\"$ctrl.onSelectAndUse({ index: $ctrl.index })\"> <div class=\"image-library__item-inner\"> <md-icon class=\"image-library__item-check\">check_circle</md-icon> <md-icon class=\"image-library__item-check image-library__item-check--hack\">brightness_1</md-icon> <cl-image public-id=\"{{$ctrl.image.imagePath}}\" class=\"image-library__item-img\" id=\"editable-image-{{::$ctrl.image.id}}\"> <cl-transformation crop=\"limit\" width=\"300\"/> </cl-image> </div> </div> ";

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraIconModule = void 0;

var _cameraIcon = _interopRequireDefault(__webpack_require__(1262));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CameraIconModule = angular.module('app.components.imageManager.components.cameraIcon', []).component('cameraIcon', {
  template: _cameraIcon.default
}).name;
exports.CameraIconModule = CameraIconModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 74 58\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\"> <title>camera</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"Desktop\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"> <g id=\"Default-State\" sketch:type=\"MSArtboardGroup\" transform=\"translate(-573.000000, -371.000000)\" fill=\"#000000\" opacity=\"0.197411381\"> <g id=\"Images\" sketch:type=\"MSLayerGroup\" transform=\"translate(290.000000, 296.000000)\"> <g id=\"Bitmap-+-add-+-Add-Photos\" transform=\"translate(261.000000, 75.000000)\" sketch:type=\"MSShapeGroup\"> <path d=\"M94,58 L81,58 C79.896,58 79,57.104 79,56 C79,54.895 79.896,54 81,54 L92,54 L92,14 L74,14 C73.393,14 72.818,13.724 72.439,13.25 L65.039,4 L52.961,4 L45.561,13.25 C45.182,13.724 44.608,14 44,14 L26,14 L26,54 L37,54 C38.105,54 39,54.895 39,56 C39,57.104 38.105,58 37,58 L24,58 C22.896,58 22,57.104 22,56 L22,12 C22,10.896 22.896,10 24,10 L43.039,10 L50.439,0.75 C50.818,0.276 51.393,0 52,0 L66,0 C66.607,0 67.182,0.276 67.561,0.75 L74.961,10 L94,10 C95.104,10 96,10.896 96,12 L96,56 C96,57.104 95.104,58 94,58 L94,58 Z M59,22 C51.28,22 45,28.28 45,36 C45,43.72 51.28,50 59,50 C66.72,50 73,43.72 73,36 C73,28.28 66.72,22 59,22 L59,22 Z M59,18 C68.941,18 77,26.059 77,36 C77,45.941 68.941,54 59,54 C49.059,54 41,45.941 41,36 C41,26.059 49.059,18 59,18 L59,18 Z\" id=\"camera\"></path> </g> </g> </g> </g> </svg>";

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageScrollerModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageScrollerModule = angular.module('app.components.imageManager.imageScroller', []).directive('imageScroller', ["$window", function ($window) {
  return {
    require: '^imageManager',
    link: function link(scope, element, attrs, ctrl) {
      var vm = scope.scrollCtrl;
      vm.init();
      ctrl.registerScroller(scope.scrollCtrl);
      vm.content.on('touchstart', function (e) {
        vm.dragging = true;
        vm.currentPos = getXPos(e);
        vm.lastPos = vm.currentPos;
        $window.requestAnimationFrame(vm.touchScroll);
      });
      vm.content.on('touchmove', function (e) {
        vm.currentPos = getXPos(e);
        $window.requestAnimationFrame(vm.touchScroll);
      });
      angular.element($window).on('touchend', dragEnd);
      scope.$on('$destroy', function () {
        angular.element($window).off('touchend', dragEnd);
      });

      function dragEnd() {
        vm.dragging = false;
        $window.requestAnimationFrame(vm.touchScroll);
      }

      function getXPos(e) {
        return e.originalEvent.touches ? e.originalEvent.touches[0].pageX : e.pageX;
      }
    },
    controller: ["$scope", function scrollCtrl($scope) {
      var spd;
      var maxSpeed = 15;
      var friction = 0.3;
      var vm = (0, _assign.default)(this, {
        leftArrow: null,
        rightArrow: null,
        content: null,
        currentPos: null,
        lastPos: null,
        dragging: false,
        registerArrow: registerArrow,
        registerContent: registerContent,
        scrollLeft: scrollLeft,
        scrollRight: scrollRight,
        touchScroll: touchScroll,
        resetScroll: resetScroll,
        init: init,
        moveIntoPosition: moveIntoPosition
      });
      $scope.$watchCollection(function () {
        return [vm.content.parent().width(), vm.content[0].scrollWidth];
      }, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          var left = vm.content.css('left');
          checkArrows(parseFloat(left));
        } else {
          vm.init();
        }
      });

      function init() {
        if (vm.content) {
          vm.content.css('left', 0);

          if (vm.rightArrow) {
            if (vm.content.parent().width() >= vm.content[0].scrollWidth) {
              vm.rightArrow.css('display', 'none');
            } else {
              vm.rightArrow.css('display', '');
            }
          }

          if (vm.leftArrow) {
            vm.leftArrow.css('display', 'none');
          } else {
            vm.leftArrow.css('display', '');
          }
        }
      }

      function registerContent(element) {
        vm.content = element;
      }

      function registerArrow(dir, element) {
        switch (dir) {
          case 'left':
            vm.leftArrow = element;
            element.on('click', leftClicked);
            break;

          case 'right':
            vm.rightArrow = element;
            element.on('click', rightClicked);
          //no default
        }
      }

      function leftClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        var move = parseFloat(vm.content.parent().width());
        var oldLeft = vm.content.css('left');
        var newLeft = parseFloat(oldLeft) + move;
        newLeft = checkArrows(newLeft);
        vm.content.css('left', newLeft);
      }

      function rightClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        var move = parseFloat(vm.content.parent().width());
        var oldLeft = vm.content.css('left');
        var newLeft = parseFloat(oldLeft) - move;
        newLeft = checkArrows(newLeft);
        vm.content.css('left', newLeft);
      }

      function resetScroll() {
        vm.content.css('left', 0);
      }

      function scrollLeft(speed) {
        var move = speed || 100;
        var oldLeft = vm.content.css('left');
        var newLeft = parseFloat(oldLeft) + move;
        newLeft = checkArrows(newLeft);
        vm.content.css('left', newLeft);
      }

      function scrollRight(speed) {
        var move = speed || 100;
        var oldLeft = vm.content.css('left');
        var newLeft = parseFloat(oldLeft) - move;
        newLeft = checkArrows(newLeft);
        vm.content.css('left', newLeft);
      }

      function checkArrows(newLeft) {
        if (Math.ceil(vm.content.parent().width()) - newLeft >= vm.content[0].scrollWidth) {
          newLeft = -(vm.content[0].scrollWidth - Math.ceil(vm.content.parent().width()));
          vm.rightArrow.css('display', 'none');
        } else {
          vm.rightArrow.css('display', '');
        }

        if (newLeft >= 0) {
          newLeft = 0;
          vm.leftArrow.css('display', 'none');
        } else {
          vm.leftArrow.css('display', '');
        }

        return newLeft;
      }

      function moveIntoPosition() {
        var newPos = checkArrows(parseInt(vm.content.css('left')));
        vm.content.css('left', newPos);
      }

      function touchScroll() {
        vm.content.css('transition', 'none');
        var parentWidth = vm.content.parent().width();
        var childWidth = vm.content[0].scrollWidth;
        spd = spd || 0;

        if (vm.dragging) {
          spd = vm.currentPos - vm.lastPos;
        } else {
          spd = spd > 0 ? spd - friction : spd + friction;

          if (spd > maxSpeed) {
            spd = maxSpeed;
          }
        }

        var oldLeft = parseFloat(vm.content.css('left'));
        var newLeft = oldLeft + spd; // disallow overscroll left

        if (newLeft > 0) {
          newLeft = 0;
        } // disallow overscroll right


        if (parentWidth > childWidth + newLeft) {
          newLeft = parentWidth - childWidth;
        }

        vm.content.css('left', "".concat(newLeft, "px"));
        vm.content.css('transition', '');
        vm.lastPos = vm.currentPos;
        checkArrows(newLeft); // momentum scroll

        if (!vm.dragging && Math.abs(spd) > friction) {
          $window.requestAnimationFrame(touchScroll);
        }
      }
    }],
    controllerAs: 'scrollCtrl'
  };
}]).directive('imageScrollerArrow', function () {
  return {
    require: '^imageScroller',
    link: function link(scope, element, attrs, ctrl) {
      if (attrs.imageScrollerArrow === 'left') {
        ctrl.registerArrow('left', element);
      } else if (attrs.imageScrollerArrow === 'right') {
        ctrl.registerArrow('right', element);
      } else {
        throw new Error('Invalid scroll direction');
      }
    }
  };
}).directive('imageContainer', function () {
  return {
    require: '^imageScroller',
    link: function link(scope, element, attrs, ctrl) {
      ctrl.registerContent(element);
    }
  };
}).name;
exports.ImageScrollerModule = ImageScrollerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

module.exports = "<div class=\"image-manager\" image-scroller ng-class=\"{\n        'image-manager--single': vm.singleMode,\n        'image-manager--sm': vm.size === 'sm',\n        'image-manager--md': vm.size === 'md',\n        'image-manager--lg': vm.size === 'lg'\n     }\"> <md-button class=\"image-manager__arrow image-manager__arrow--left md-icon-button\" image-scroller-arrow=\"left\" ng-show=\"!vm.singleMode\"><md-icon>keyboard_arrow_left</md-icon></md-button> <md-button class=\"image-manager__arrow image-manager__arrow--right md-icon-button\" image-scroller-arrow=\"right\" ng-show=\"!vm.singleMode\"><md-icon>keyboard_arrow_right</md-icon></md-button> <div class=\"image-manager__container\"> <ul class=\"image-manager__list\" image-container vln-drag=\"images\"> <li ng-if=\"vm.preWhitelist\" ng-repeat=\"file in images | filter: vm.preWhitelistFilter track by $index\" class=\"image-manager__item hover image-manager__item--group-image\" ng-show=\"!vm.singleMode\"> <img ng-src=\"{{file.imageLink.fullUri}}\" id=\"editable-image-{{::file.imageLink.id}}\"/> <div class=\"badge-container\"> <div class=\"badge badge-update\">{{'PRODUCT.VARIANTIMAGESMODALGROUPIMAGE' | translate}}</div> </div> </li> <li ng-if=\"vm.hasWhitelist\" ng-repeat=\"file in images | filter: vm.whitelistFilter track by $index\" class=\"image-manager__item hover\" ng-show=\"!vm.singleMode\"> <img ng-if=\"bypassImageTransformation\" ng-src=\"{{file.imageLink.fullUri}}\" id=\"editable-image-{{::file.imageLink.id}}\"/> <cl-image ng-if=\"!bypassImageTransformation\" public-id=\"{{file.imageLink.imagePath}}\" id=\"editable-image-{{::file.imageLink.id}}\"> <cl-transformation crop=\"limit\" width=\"300\"/> </cl-image> <div class=\"image-manager__hover\" ng-class=\"{'visible': file.isOpen}\" ng-if=\"!vm.galleryMode\"> <span class=\"main-actions\"> <md-button ng-click=\"vm.removeImage(file)\" class=\"md-icon-button image-manager__action image-manager__action--remove\"> <md-icon>clear</md-icon> <md-tooltip md-delay=\"350\" md-direction=\"top\">Remove image</md-tooltip> </md-button> </span> </div> </li> <li ng-if=\"!vm.hasWhitelist\" ng-repeat=\"file in images\" class=\"image-manager__item hover\" vln-drag-item=\"file\" ng-show=\"!vm.singleMode\"> <img ng-if=\"bypassImageTransformation\" ng-src=\"{{file.imageLink.fullUri}}\" vln-drag-handle id=\"editable-image-{{::file.imageLink.id}}\"/> <cl-image ng-if=\"!bypassImageTransformation\" public-id=\"{{file.imageLink.imagePath}}\" vln-drag-handle id=\"editable-image-{{::file.imageLink.id}}\"> <cl-transformation crop=\"limit\" width=\"300\"/> </cl-image> <div class=\"image-manager__hover\" ng-class=\"{'visible': file.isOpen}\" ng-if=\"!vm.galleryMode\"> <span> <md-button ng-if=\"vm.shouldShowMoveImageLeft($index)\" ng-click=\"vm.moveImageLeft($index)\" class=\"md-icon-button image-manager__action\"> <md-icon>keyboard_arrow_left</md-icon> <md-tooltip md-delay=\"350\" md-direction=\"top\">Move left</md-tooltip> </md-button> </span> <span class=\"main-actions\"> <md-button ng-if=\"vm.isPinterestEnabled\" ng-click=\"vm.postImageToPinterest(file)\" class=\"md-icon-button image-manager__action image-manager__action--remove\" gtm-click-event=\"{{gtmid}}_postImageToPinterest\" aria-label=\"Pin Image to Pinterest\"> <md-icon md-svg-src=\"/assets/app/pinterest-icon.svg\"></md-icon> <md-tooltip md-delay=\"350\" md-direction=\"top\">Pin Image to Pinterest</md-tooltip> </md-button> <md-button ng-click=\"vm.openEditor(file)\" class=\"md-icon-button image-manager__action\" hide-xs> <md-icon>mode_edit</md-icon> <md-tooltip md-delay=\"350\" md-direction=\"top\">Edit image</md-tooltip> </md-button> <md-button ng-click=\"vm.openImageMetadataModal(file)\" class=\"md-icon-button image-manager__action\"> <md-icon>info</md-icon> <md-tooltip md-delay=\"350\" md-direction=\"top\">Edit metadata</md-tooltip> </md-button> <md-button ng-click=\"vm.removeImage(file)\" class=\"md-icon-button image-manager__action image-manager__action--remove\"> <md-icon>clear</md-icon> <md-tooltip md-delay=\"350\" md-direction=\"top\">Remove image</md-tooltip> </md-button> </span> <span> <md-button ng-if=\"vm.shouldShowMoveImageRight($index)\" ng-click=\"vm.moveImageRight($index)\" class=\"md-icon-button image-manager__action\"> <md-icon>keyboard_arrow_right</md-icon> <md-tooltip md-direction=\"top\">Move right</md-tooltip> </md-button> </span> </div> </li> <li class=\"image-manager__item image-manager__item--single hover\" ng-if=\"vm.singleMode && vm.hasImage()\"> <img src=\"{{image.imageLink.fullUri}}\" id=\"editable-image-{{::image.imageLink.id}}\"/> <div class=\"image-manager__hover\" ng-class=\"{'visible': image.isOpen}\" ng-if=\"!vm.galleryMode\"> <span class=\"main-actions\" flex> <md-button ng-click=\"vm.openEditor(image)\" class=\"md-icon-button image-manager__action hide-mobile\"> <md-icon>mode_edit</md-icon> <md-tooltip md-delay=\"350\" md-direction=\"top\">Edit image</md-tooltip> </md-button> <md-button ng-click=\"vm.openImageMetadataModal(image)\" class=\"md-icon-button image-manager__action image-manager__action--hide-overflow\"> <md-icon>info</md-icon> <md-tooltip md-delay=\"350\" md-direction=\"top\">Edit metadata</md-tooltip> </md-button> <md-button ng-click=\"vm.removeImage(image)\" class=\"md-icon-button image-manager__action image-manager__action--remove image-manager__action--hide-overflow\"> <md-icon>clear</md-icon> <md-tooltip md-delay=\"350\" md-direction=\"top\">Remove image</md-tooltip> </md-button> </span> <md-menu md-position-mode=\"target-left target\" md-helper> <md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon>more_vert</md-icon></md-button> <md-menu-content class=\"image-manager-overflow-content\"> <md-menu-item><md-button ng-click=\"vm.openImageMetadataModal(image)\">Image Attributes</md-button></md-menu-item> <md-menu-item class=\"image-manager-overflow-content__delete\"><md-button ng-click=\"vm.removeImage(image)\">Delete</md-button></md-menu-item> </md-menu-content> </md-menu> </div> </li> <li class=\"image-manager__item image-manager__item--loading\" ng-class=\"{'image-manager__item--single' : vm.singleMode}\" ng-repeat=\"file in vm.files track by $index\"> <md-progress-circular class=\"md-accent\" md-diameter=\"50\" md-mode=\"indeterminate\"></md-progress-circular> </li> <div class=\"image-upload\" ngf-drop ngf-multiple=\"!vm.singleMode\" ngf-allow-dir=\"!vm.singleMode\" ngf-change=\"vm.uploadImages($files, $invalidFiles); vm.trackDrop();\" ngf-drag-over-class=\"'image-upload--dropzone-active'\" ngf-max-size=\"5000000\" ngf-accept=\"'image/*'\" ngf-pattern=\"'.jpg,.jpeg,.png,.gif'\" ng-show=\"!vm.singleMode || (vm.singleMode && !vm.hasImage() && !vm.files.length)\" ng-if=\"!vm.galleryMode\"> <div class=\"image-upload__camera\" ngf-select ngf-multiple=\"true\" ngf-change=\"vm.uploadImages($files, $invalidFiles);\" ngf-max-size=\"5000000\" ngf-accept=\"'image/*'\" ngf-pattern=\"'.jpg,.jpeg,.png,.gif'\"> <div class=\"image-upload__camera-icon\"> <camera-icon></camera-icon> </div> <p class=\"image-upload__text\"> <span class=\"image-upload__mobile-text\"> Tap to upload </span> <span class=\"image-upload__desktop-text\"> Drag &amp; drop to upload </span> </p> </div> <div class=\"image-upload__camera-gallery\" image-library-launch image-library-context=\"imageLibraryContext\" image-library-association-tags=\"imageLibraryAssociationTags\" image-library-multi-select=\"!vm.singleMode\" image-library-on-images-selected=\"vm.onLibraryImagesSelected(selectedImages)\" image-library-in-new-modal-tab=\"vm.isImageLibraryInNewModalTab\"> <div class=\"image-upload__camera-icon\"> <camera-icon></camera-icon> </div> </div> <div class=\"or\"> <span class=\"or__line\"></span> <span class=\"or__text\">Or</span> <span class=\"or__line\"></span> </div> <div class=\"image-upload__browse\"> <md-button class=\"md-button--filled\" image-library-launch image-library-context=\"imageLibraryContext\" image-library-association-tags=\"imageLibraryAssociationTags\" image-library-multi-select=\"!vm.singleMode\" image-library-on-images-selected=\"vm.onLibraryImagesSelected(selectedImages)\" image-library-override-func=\"vm.libraryOverrideFunc\" has-library-override=\"vm.hasLibraryOverride\"> <md-icon>collections</md-icon> Browse Gallery </md-button> </div> <div class=\"image-upload__dropzone\"> <i class=\"image-upload__dropzone-icon text-dark-disabled mi\">cloud_upload</i> <p class=\"image-upload__dropzone-text text-bold text-dark-secondary\">Drop here to upload</p> </div> </div> </ul> </div> </div> <image-editor is-open=\"vm.isImageEditModalOpen\" id=\"vm.imageId\" url=\"vm.imageUrl\" gtm-save-event-name=\"vm.gtmImageSaveEventName\" on-close=\"vm.onCloseImageEditor\" on-save=\"vm.onSave\" image-index=\"vm.imageIndex\"/> ";

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

module.exports = "<md-dialog class=\"image-metadata\" md-theme=\"{{ theme }}\" layout=\"column\" layout-gt-sm=\"row\"> <div class=\"modal__media\"> <cl-image class=\"selected-image\" public-id=\"{{vm.selectedImage.imageLink.imagePath}}\"> <cl-transformation crop=\"limit\" width=\"300\"/> </cl-image> </div> <div layout=\"column\" flex> <md-dialog-content flex> <div class=\"md-dialog-content\" flex> <h3 class=\"modal__header\">{{'IMAGE.METADATATITLE' | translate}}</h3> <div layout=\"column\" layout-align=\"center stretch\"> <md-input-container class=\"md-block md-accent\"> <label> {{'IMAGE.TITLE' | translate}} </label> <input type=\"text\" ng-model=\"vm.selectedImage.title\" maxlength=\"75\"> </md-input-container> <md-input-container class=\"md-block md-accent\"> <label> {{'IMAGE.DESCRIPTION' | translate}} </label> <input type=\"text\" ng-model=\"vm.selectedImage.description\" maxlength=\"160\"> </md-input-container> <md-input-container class=\"md-block md-accent\"> <label> {{'IMAGE.ALTTEXT' | translate}} </label> <input type=\"text\" ng-model=\"vm.selectedImage.altText\" maxlength=\"75\"> </md-input-container> </div> </div> </md-dialog-content> <md-dialog-actions layout=\"row\"> <md-button ng-click=\"cancelDialog('cancel')\" gtm-click-event=\"{{gtmid}}_imageMetadataModal-cancel\">{{'BUTTON.CANCEL' | translate}}</md-button> <md-button class=\"md-accent\" gtm-click-event=\"{{gtmid}}_imageMetadataModal-save\" ng-click=\"closeDialog()\">{{'BUTTON.SAVE' | translate}}</md-button> </md-dialog-actions> </div> </md-dialog> ";

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppBadgeModule = void 0;

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _appBadge = _interopRequireDefault(__webpack_require__(1269));

__webpack_require__(1270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AppBadgeModule = angular.module('app.components.appBadges.appBadge', [_angularTranslate.default]).component('appBadge', {
  template: _appBadge.default,
  controller:
  /*#__PURE__*/
  function () {
    AppBadgeController.$inject = ["$translate", "$attrs"];

    function AppBadgeController($translate, $attrs) {
      'ngInject';

      _classCallCheck(this, AppBadgeController);

      (0, _assign.default)(this, {
        icon: '',
        color: '',
        translation: '',
        $translate: $translate,
        $attrs: $attrs
      });
    }

    _createClass(AppBadgeController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.$attrs.$observe('app', function (value) {
          switch (value) {
            case 'products':
              _this.setScope('TITLETAG.PRODUCTS', 'local_offer', '#0FB3CC');

              break;

            case 'orders':
              _this.setScope('TITLETAG.ORDERS', 'shopping_cart', '#3EC671');

              break;

            case 'categories':
              _this.setScope('TITLETAG.CATEGORIES', 'list', '#1E66C3');

              break;

            case 'pages':
              _this.setScope('TITLETAG.PAGES', 'insert_drive_file', '#C45898');

              break;

            case 'customers':
              _this.setScope('TITLETAG.CUSTOMERS', 'people', '#684BB6');

              break;

            case 'settings':
              _this.setScope('TITLETAG.SETTINGS', 'settings', '#FF8955');

              break;

            case 'custom':
              _this.setScope('TITLETAG.MORE_COUNT', '', 'rgba(0,0,0,0.30)', _this.$attrs.count);

              break;

            default:
          }
        });
      }
    }, {
      key: "setScope",
      value: function setScope(translation, icon, color, count) {
        var _this2 = this;

        this.icon = icon;
        this.color = color;
        this.$translate(translation, {
          COUNT: count
        }).then(function (message) {
          _this2.translation = message;
        });
      }
    }]);

    return AppBadgeController;
  }()
}).name;
exports.AppBadgeModule = AppBadgeModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-badge\"> <div class=\"badge\" ng-style=\"{background: $ctrl.color}\"> <md-icon ng-if=\"$ctrl.icon\">{{$ctrl.icon}}</md-icon> <span>{{$ctrl.translation}}</span> </div> </div> ";

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header__close\"> <md-button class=\"md-icon-button\" ng-click=\"$ctrl.closePreview()\" aria-label=\"close modal\"> <md-icon>close</md-icon> </md-button> </div> <form> <md-dialog-content class=\"modal--content\"> <div class=\"md-whiteframe-2dp modal--header\"> <div layout=\"row\" layout-align=\"start center\" class=\"header-row\"> <span class=\"image\" vln-back-img=\"{{$ctrl.app.logo.imageLink.uriBase}}/c_limit,w_160/{{$ctrl.app.logo.imageLink.imagePath}}\" alt=\"{{$ctrl.app.title}}\"></span> <div class=\"title\"> <span ng-if=\"$ctrl.isApplication()\">{{\"APPSTORE.APPLICATION\" | translate}}</span> <span ng-if=\"$ctrl.isExtension()\">{{\"APPSTORE.EXTENSION\" | translate}}</span> <p>{{$ctrl.app.title}}</p> </div> <span flex></span> <div class=\"install\"> <p ng-if=\"$ctrl.app.planLevel === 'Lite'\">{{\"APPSTORE.FREE\" | translate}}</p> <p ng-if=\"$ctrl.app.planLevel === 'Plus'\"> {{\"APPSTORE.FREEWITHPLUSPLANLONG\" | translate}} </p> <div layout=\"row\" layout-align=\"end center\"> <md-progress-circular ng-if=\"$ctrl.isLoading\" class=\"md-accent\" md-diameter=\"30\" md-mode=\"indeterminate\"></md-progress-circular> <md-button class=\"md-accent\" ng-if=\"!$ctrl.isLoading && $ctrl.isApplication() && !$ctrl.showUpsell\" ng-click=\"$ctrl.installClicked()\" ng-class=\"{\n                                    delete : $ctrl.isInstalled,\n                                    'md-raised': !$ctrl.isInstalled\n                                    }\" gtm-click-event=\"{{$ctrl.gtmid}}_installApp-{{$ctrl.app.title}}\" aria-label=\"install app\"> <span ng-if=\"!$ctrl.isInstalled\">{{\"APPSTORE.INSTALLAPP\" | translate}}</span> <span ng-if=\"$ctrl.isInstalled\">{{\"APPSTORE.UNINSTALL\" | translate}}</span> </md-button> <md-button class=\"md-raised md-accent\" ng-if=\"!$ctrl.isLoading && $ctrl.isExtension() && !$ctrl.showUpsell\" ng-click=\"$ctrl.installClicked()\" gtm-click-event=\"{{$ctrl.gtmid}}-installExtention-{{$ctrl.app.title}}\" aria-label=\"install extension\" ng-class=\"{'btn-disabled': $ctrl.isInstalled}\"> <span data-ng-hide=\"$ctrl.isInstalled\">{{\"APPSTORE.INSTALLEXTENSION\" | translate}}</span> <span data-ng-show=\"$ctrl.isInstalled\">{{\"APPSTORE.INSTALLED\" | translate}}</span> </md-button> <change-plan-button ng-if=\"!$ctrl.isLoading && $ctrl.showUpsell\"></change-plan-button> </div> </div> </div> </div> <div class=\"images\"> <image-manager bypass-image-transformation=\"true\" images=\"$ctrl.app.images\" single-image=\"false\" gallery-mode=\"true\"></image-manager> </div> <div class=\"md-dialog-content\"> <div> <div class=\"description\"> <span class=\"content_headers\">{{\"APPSTORE.DESCRIPTION\" | translate}}</span> <p class=\"description__content\" ng-bind-html=\"$ctrl.app.descriptionLong\"> </p></div> <div class=\"support_info\"> <span class=\"content_headers\">{{\"APPSTORE.SUPPORTINFO\" | translate}} </span> <div layout=\"row\" layout-xs=\"column\"> <div class=\"developer\" ng-if=\"$ctrl.app.developer\"> <p class=\"developer_title\">{{\"APPSTORE.DEVELOPER\" | translate}} </p> <span class=\"developer_value\">{{$ctrl.app.developer}}</span> </div> <div class=\"developer\" ng-if=\"$ctrl.app.webSite\"> <p class=\"developer_title\">{{\"APPSTORE.WEBSITE\" | translate}} </p> <span class=\"developer_value\">{{$ctrl.app.webSite}}</span> </div> <div class=\"developer\" ng-if=\"$ctrl.app.emailAddress\"> <p class=\"developer_title\">{{\"APPSTORE.EMAILADDRESS\" | translate}} </p> <span class=\"developer_value\">{{$ctrl.app.emailAddress}}</span> </div> </div> </div> <div class=\"extends\" ng-if=\"$ctrl.app.extends.length > 0\"> <span class=\"content_headers\">{{\"APPSTORE.EXTENDSAPPS\" | translate}} </span> <div class=\"page\" layout=\"row\"> <app-badge app=\"{{app}}\" ng-repeat=\"app in $ctrl.app.extends\"></app-badge> </div> </div> </div> </div> </md-dialog-content> </form> ";

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppExtensionConfirmInstallModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _apps = __webpack_require__(76);

var _extension = __webpack_require__(232);

var _authToken = __webpack_require__(43);

var _segment = __webpack_require__(58);

var _vlnBackImage = __webpack_require__(263);

var _mobileAnalytics = __webpack_require__(191);

var _storefrontCache = __webpack_require__(406);

var _launchChangePlan = __webpack_require__(102);

var _appExtensionConfirmInstall = _interopRequireDefault(__webpack_require__(1363));

__webpack_require__(1364);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AppExtensionConfirmInstallModule = angular.module('app.components.appExtensionPreview.appExtensionConfirmInstall', ['ngMaterial', _angularjs.default, _angularTranslate.default, _apps.AppsServiceModule, _extension.ExtensionServiceModule, _authToken.AuthTokenServiceModule, _vlnBackImage.VlnBackImageModule, _mobileAnalytics.MobileAnalyticsServiceModule, _segment.SegmentServiceModule, _storefrontCache.StorefrontCacheServiceModule, _launchChangePlan.LaunchChangePlanServiceModule]).component('appExtensionConfirmInstall', {
  template: _appExtensionConfirmInstall.default,
  bindings: {
    app: '<',
    appType: '@',
    isInstalled: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    AppExtensionConfirmInstall.$inject = ["$scope", "$mdDialog", "appsService", "extensionService", "$state", "$translate", "$window", "authTokenService", "segmentService", "mobileAnalyticsService", "storefrontCacheService", "launchChangePlanService"];

    function AppExtensionConfirmInstall($scope, $mdDialog, appsService, extensionService, $state, $translate, $window, authTokenService, segmentService, mobileAnalyticsService, storefrontCacheService, launchChangePlanService) {
      'ngInject';

      _classCallCheck(this, AppExtensionConfirmInstall);

      (0, _assign.default)(this, {
        $scope: $scope,
        $mdDialog: $mdDialog,
        appsService: appsService,
        extensionService: extensionService,
        $state: $state,
        $translate: $translate,
        $window: $window,
        authTokenService: authTokenService,
        mobileAnalyticsService: mobileAnalyticsService,
        storefrontCacheService: storefrontCacheService,
        launchChangePlanService: launchChangePlanService,
        isLoading: false,
        translationsArray: ['APPSTORE.CONFIRMINSTALLFREEAPPBLURB', 'APPSTORE.CONFIRMINSTALLFREEAPPWITHPLUSBLURB', 'APPSTORE.CONFIRMINSTALLFREEEXTNBLURB', 'APPSTORE.CONFIRMINSTALLFREEEXTNWITHPLUSBLURB', 'APPSTORE.CONFIRM_UNINSTALL_APP_BLURB'],
        blurbText: '',
        installing: false,
        installError: null,
        gtmid: "admin_".concat($state.current.name),
        segmentService: segmentService
      });
    }

    _createClass(AppExtensionConfirmInstall, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.$translate(this.translationsArray, {
          APP: this.app.title
        }).then(function (translations) {
          _this.setBlurbText(translations);
        });
      }
    }, {
      key: "setBlurbText",
      value: function setBlurbText(translationsHash) {
        if (this.isApplication()) {
          if (this.isInstalled) {
            this.blurbText = translationsHash['APPSTORE.CONFIRM_UNINSTALL_APP_BLURB'];
          } else if (this.app.planLevel === 'Lite') {
            this.blurbText = translationsHash['APPSTORE.CONFIRMINSTALLFREEAPPBLURB'];
          } else {
            this.blurbText = translationsHash['APPSTORE.CONFIRMINSTALLFREEAPPWITHPLUSBLURB'];
          }
        } else {
          if (this.app.planLevel === 'Lite') {
            this.blurbText = translationsHash['APPSTORE.CONFIRMINSTALLFREEEXTNBLURB'];
          } else {
            this.blurbText = translationsHash['APPSTORE.CONFIRMINSTALLFREEEXTNWITHPLUSBLURB'];
          }
        }
      }
    }, {
      key: "closeConfirmInstall",
      value: function closeConfirmInstall() {
        return this.$mdDialog.cancel('cancel');
      }
    }, {
      key: "isApplication",
      value: function isApplication() {
        return this.appType === 'application';
      }
    }, {
      key: "isExtension",
      value: function isExtension() {
        return this.appType === 'extension';
      }
    }, {
      key: "sendInstalledEvent",
      value: function sendInstalledEvent() {
        var _this2 = this;

        var isApp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        this.authTokenService.getTenantId().then(function (tenantID) {
          var eventPayload = isApp ? {
            event: 'InstalledApp',
            appName: name,
            tenantID: tenantID
          } : {
            event: 'InstalledExtension',
            extensionName: name,
            tenantID: tenantID
          };

          _this2.$window.dataLayer.push(eventPayload);
        });
      }
    }, {
      key: "sendUninstalledEvent",
      value: function sendUninstalledEvent() {
        var _this3 = this;

        var isApp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        this.authTokenService.getTenantId().then(function (tenantID) {
          var eventPayload = isApp ? {
            event: 'UninstalledApp',
            appName: name,
            tenantID: tenantID
          } : {
            event: 'UninstalledExtension',
            extensionName: name,
            tenantID: tenantID
          };

          _this3.$window.dataLayer.push(eventPayload);
        });
      }
    }, {
      key: "install",
      value: function install() {
        var _this4 = this;

        this.installing = true;

        if (this.isApplication()) {
          this.appsService.installApp(this.app).then(function () {
            _this4.onAppActionFinished('apps:newInstalled', 'App Store: Installed');
          }).catch(function () {
            _this4.installError = 'This app is not available to your current plan.';
          });
        } else {
          this.extensionService.installExtension({
            extensionId: this.app.id
          }).then(function () {
            _this4.onAppActionFinished('apps:newInstalled', 'App Store: Installed');
          });
        }
      }
    }, {
      key: "uninstall",
      value: function uninstall() {
        var _this5 = this;

        this.installing = true;
        var APP_UNINSTALLED = true;
        this.appsService.uninstallApp(this.app).then(function () {
          _this5.onAppActionFinished('apps:uninstalled', 'App Store: Uninstalled', APP_UNINSTALLED);
        }).catch(function () {
          _this5.installError = 'Something went wrong while uninstalling. Please refresh and try again.';
        });
      }
    }, {
      key: "openPlans",
      value: function openPlans(ev) {
        var _this6 = this;

        this.closeConfirmInstall().then(function () {
          _this6.launchChangePlanService.openModal(ev, null, true);
        });
      }
    }, {
      key: "onAppActionFinished",
      value: function onAppActionFinished(event, mobileEvent) {
        var appUninstalled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        this.$scope.$emit(event, this.app);
        this.installing = false;

        if (appUninstalled) {
          this.sendUninstalledEvent(this.isApplication(), this.app.title);
        } else {
          this.sendInstalledEvent(this.isApplication(), this.app.title);
        }

        this.mobileAnalyticsService.trackEvent(mobileEvent, {});
        this.storefrontCacheService.refresh('appstore');
        this.$mdDialog.hide({
          sku: this.app.sku,
          event: event
        });
      }
    }]);

    return AppExtensionConfirmInstall;
  }()
}).name;
exports.AppExtensionConfirmInstallModule = AppExtensionConfirmInstallModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1274 */,
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutComponentsModule = void 0;

var _accountForm = __webpack_require__(1276);

var _help = __webpack_require__(1281);

var _info = __webpack_require__(1284);

var _loginForm = __webpack_require__(1287);

var _orderSummary = __webpack_require__(1290);

var _signupForm = __webpack_require__(1295);

var _thankYou = __webpack_require__(1306);

var _userInfo = __webpack_require__(1309);

var _paymentMethodSelector = __webpack_require__(1312);

var CheckoutComponentsModule = angular.module('app.components.checkout.components', [_accountForm.CheckoutAccountFormModule, _help.CheckoutHelpModule, _info.CheckoutInfoModule, _loginForm.CheckoutLoginFormModule, _orderSummary.CheckoutOrderSummaryModule, _signupForm.CheckoutSignupFormModule, _thankYou.CheckoutThankYouModule, _userInfo.CheckoutUserInfoModule, _paymentMethodSelector.PaymentMethodModule]).name;
exports.CheckoutComponentsModule = CheckoutComponentsModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutAccountFormModule = void 0;

var _auth = __webpack_require__(77);

var _checkout = __webpack_require__(154);

var _accountForm = _interopRequireDefault(__webpack_require__(1279));

__webpack_require__(1280);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CheckoutAccountFormModule = angular.module('app.components.checkout.components.checkoutAccountForm', [_auth.AuthServiceModule, _checkout.CheckoutServiceModule]).component('checkoutAccountForm', {
  template: _accountForm.default,
  bindings: {
    coupon: '<',
    couponCode: '<',
    user: '<',
    cart: '<',
    onSignupFormValidityChange: '&',
    onLogout: '&',
    onCouponEntered: '&',
    onPaymentMethodSelected: '<',
    showCouponField: '<',
    purchaseComplete: '<',
    hasAccount: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    CheckoutAccountFormCtrl.$inject = ["checkoutService", "authService"];

    function CheckoutAccountFormCtrl(checkoutService, authService) {
      'ngInject';

      _classCallCheck(this, CheckoutAccountFormCtrl);

      angular.extend(this, {
        hasAccount: false,
        checkoutService: checkoutService,
        authService: authService
      });
    }

    _createClass(CheckoutAccountFormCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        this.preLoggedIn = angular.copy(this.user.isLoggedIn);
      }
    }, {
      key: "onAccountChange",
      value: function onAccountChange() {
        if (this.user.isLoggedIn && !this.hasAccount) {
          this.logout();
        }
      }
    }, {
      key: "logout",
      value: function logout() {
        this.authService.clearUser();
        this.onLogout();
      }
    }, {
      key: "setHasAccount",
      value: function setHasAccount(hasAccount) {
        this.hasAccount = hasAccount;
        this.onAccountChange();
      }
    }]);

    return CheckoutAccountFormCtrl;
  }()
}).name;
exports.CheckoutAccountFormModule = CheckoutAccountFormModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutTrackerServiceModule = void 0;

var _dataLayer = __webpack_require__(374);

var CheckoutTrackerServiceModule = angular.module('app.services.tracking.enhancedEcommerce.checkoutTracker', [_dataLayer.DataLayerServiceModule]).factory('checkoutTracker', ["$window", "dataLayer", function ($window, dataLayer) {
  function logCheckoutStep(product, categoryName, stepNumber, optionValue, listType, position) {
    dataLayer.logCheckoutStep(stepNumber, optionValue, [dataLayer.create(product, categoryName, listType, position)]);
  }

  function logAddToCart(currencyCode, product, categoryName, listType, position) {
    dataLayer.logAddToCart(currencyCode, [dataLayer.create(product, categoryName, listType, position)]);
  }

  function logRemoveFromCart(product, categoryName, listType, position) {
    dataLayer.logRemoveFromCart([dataLayer.create(product, categoryName, listType, position)]);
  }

  function logPurchase(_ref) {
    var orderNumber = _ref.orderNumber,
        affiliation = _ref.affiliation,
        grandTotal = _ref.grandTotal,
        taxAmount = _ref.taxAmount,
        product = _ref.product,
        category = _ref.category,
        paidWith = _ref.paidWith,
        couponCode = _ref.couponCode;
    dataLayer.logPurchase(orderNumber, affiliation, grandTotal, taxAmount, [dataLayer.create(product, category)], paidWith, couponCode);
  }

  return {
    logCheckoutStep: logCheckoutStep,
    logAddToCart: logAddToCart,
    logRemoveFromCart: logRemoveFromCart,
    logPurchase: logPurchase
  };
}]).name;
exports.CheckoutTrackerServiceModule = CheckoutTrackerServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductsTrackerServiceModule = void 0;

var _map = _interopRequireDefault(__webpack_require__(75));

var _dataLayer = __webpack_require__(374);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductsTrackerServiceModule = angular.module('app.services.tracking.enhancedEcommerce.productsTracker', [_dataLayer.DataLayerServiceModule]).factory('productsTracker', ["$window", "dataLayer", function ($window, dataLayer) {
  function logProductImpression(products, categoryName, listType) {
    var impressions = (0, _map.default)(products, function (item, index) {
      return dataLayer.create(item, categoryName, listType, index + 1);
    });
    dataLayer.logProductImpression(impressions);
  }

  function logProductClick(product, categoryName, listType, position) {
    if (angular.isDefined(position) && isFinite(parseInt(position))) {
      position = parseInt(position);
    }

    var payload = dataLayer.create(product, categoryName, listType, position);
    dataLayer.logProductClick([payload], listType);
  }

  function logProductDetails(product, categoryName, listType) {
    var impression = dataLayer.create(product, categoryName, listType);
    dataLayer.logProductDetails([impression], listType);
  }

  return {
    logProductImpression: logProductImpression,
    logProductClick: logProductClick,
    logProductDetails: logProductDetails
  };
}]).name;
exports.ProductsTrackerServiceModule = ProductsTrackerServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-account-form\"> <div class=\"checkout-account-form__title\"> <span ng-if=\"$ctrl.user.isLoggedIn\"> <span ng-if=\"$ctrl.preLoggedIn\" translate=\"CHECKOUT.READYTOGO\"></span> <span ng-if=\"!$ctrl.preLoggedIn\" translate=\"CHECKOUT.WELCOMEBACK\" translate-values=\"{ 'FIRST_NAME': $ctrl.user.contact.firstName }\"></span> </span> <span ng-if=\"!$ctrl.user.isLoggedIn\" translate=\"CHECKOUT.BEENHEREBEFORE\"></span> </div> <div class=\"checkout-account-form__notice\" ng-if=\"$ctrl.cart.isDowngrade\" layout layout-align=\"start center\"> <md-icon>info</md-icon> <span>This downgrade will take place on {{$ctrl.cart.billingPeriodEnd}} at the end of your billing cycle.</span> </div> <div class=\"checkout-account-form__form\"> <md-radio-group ng-model=\"$ctrl.hasAccount\" ng-change=\"$ctrl.onAccountChange()\" md-no-ink> <div class=\"checkout-account-form-radio checkout-account-form-radio--no-subtitle\" ng-if=\"!$ctrl.preLoggedIn\" ng-class=\"{'checkout-account-form-radio--selected': $ctrl.hasAccount}\"> <md-radio-button ng-value=\"true\" ng-if=\"!$ctrl.user.isLoggedIn\"> <div class=\"checkout-account-form-radio__title\"> <span ng-if=\"!$ctrl.user.isLoggedIn\" translate=\"CHECKOUT.YESIHAVEANACCOUNT\"></span> <span ng-if=\"$ctrl.user.isLoggedIn\" translate=\"CHECKOUT.IHAVEANACCOUNT\"></span> </div> </md-radio-button> <div ng-show=\"$ctrl.hasAccount\"> <hr ng-show=\"!$ctrl.user.isLoggedIn\"> <checkout-login-form ng-if=\"!$ctrl.user.isLoggedIn\" user=\"$ctrl.user\"> </checkout-login-form> <checkout-signup-form on-coupon-entered=\"$ctrl.onCouponEntered({ coupon: coupon })\" ng-cloak ng-if=\"$ctrl.user.isLoggedIn\" coupon=\"$ctrl.coupon\" coupon-code=\"$ctrl.couponCode\" user=\"$ctrl.user\" on-validity-change=\"$ctrl.onSignupFormValidityChange({ isValid: isValid })\" is-edit-mode=\"false\" purchase-complete=\"$ctrl.purchaseComplete\" on-payment-method-selected=\"$ctrl.onPaymentMethodSelected\" show-coupon-field=\"$ctrl.showCouponField\"> </checkout-signup-form> </div> </div> <div class=\"checkout-account-form-radio\" ng-if=\"!$ctrl.preLoggedIn\" ng-class=\"{'checkout-account-form-radio--selected': !$ctrl.hasAccount}\"> <md-radio-button ng-value=\"false\" ng-if=\"!$ctrl.user.isLoggedIn\"> <div class=\"checkout-account-form-radio__title\"> <span ng-if=\"!$ctrl.user.isLoggedIn\" translate=\"CHECKOUT.NOPEFIRSTTIME\"></span> </div> <div class=\"checkout-account-form-radio__subtitle\" ng-if=\"!$ctrl.user.isLoggedIn\" translate=\"CHECKOUT.CREATEACCOUNT\"></div> </md-radio-button> <div class=\"checkout-account-form__logout\" ng-if=\"$ctrl.user.isLoggedIn\"> <span translate=\"CHECKOUT.NOTYOU\" translate-values=\"{ 'FIRST_NAME': $ctrl.user.contact.firstName }\"></span> <a href=\"javascript:void(0)\" ng-click=\"$ctrl.setHasAccount(false)\" translate=\"CHECKOUT.CLICKTOCREATEACCOUNT\"></a> </div> <div ng-show=\"!$ctrl.hasAccount\" ng-cloak> <hr> <checkout-signup-form coupon=\"$ctrl.coupon\" coupon-code=\"$ctrl.couponCode\" on-coupon-entered=\"$ctrl.onCouponEntered({ coupon: coupon })\" user=\"$ctrl.user\" on-validity-change=\"$ctrl.onSignupFormValidityChange({ isValid: isValid })\" is-edit-mode=\"true\" purchase-complete=\"$ctrl.purchaseComplete\" on-payment-method-selected=\"$ctrl.onPaymentMethodSelected\" show-coupon-field=\"$ctrl.showCouponField\"> </checkout-signup-form> </div> </div> <div class=\"checkout-account-form-radio checkout-account-form-radio--selected\" ng-if=\"$ctrl.preLoggedIn\"> <checkout-signup-form coupon=\"$ctrl.coupon\" coupon-code=\"$ctrl.couponCode\" on-coupon-entered=\"$ctrl.onCouponEntered({ coupon: coupon })\" user=\"$ctrl.user\" on-validity-change=\"$ctrl.onSignupFormValidityChange({ isValid: isValid })\" is-edit-mode=\"false\" purchase-complete=\"$ctrl.purchaseComplete\" on-payment-method-selected=\"$ctrl.onPaymentMethodSelected\" show-coupon-field=\"$ctrl.showCouponField\"> </checkout-signup-form> </div> </md-radio-group> </div> </div> ";

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutHelpModule = void 0;

var _help = _interopRequireDefault(__webpack_require__(1282));

__webpack_require__(1283);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CheckoutHelpModule = angular.module('app.components.checkout.components.checkoutHelp', []).component('checkoutHelp', {
  template: _help.default,
  bindings: {},
  controller:
  /*#__PURE__*/
  function () {
    CheckoutHelpCtrl.$inject = ["$window"];

    function CheckoutHelpCtrl($window) {
      'ngInject';

      _classCallCheck(this, CheckoutHelpCtrl);

      angular.extend(this, {
        $window: $window
      });
    }

    _createClass(CheckoutHelpCtrl, [{
      key: "$onDestroy",
      value: function $onDestroy() {
        angular.element('body').removeClass('show-intercom');
      }
    }]);

    return CheckoutHelpCtrl;
  }()
}).name;
exports.CheckoutHelpModule = CheckoutHelpModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-help\"> <div class=\"checkout-help__title\" translate=\"CHECKOUTHELP.QUESTIONS\"></div> <div class=\"checkout-help__desc\" translate=\"CHECKOUTHELP.NEEDHELP\"></div> <div class=\"checkout-help__phone\"> <md-icon>phone</md-icon> <span translate=\"CHECKOUTHELP.PHONENUMBER\"></span> </div> <md-button ng-click=\"$ctrl.launchIntercom()\" class=\"checkout-help__button checkout-rounded-button\" md-no-ink> <md-icon>message</md-icon> <span translate=\"CHECKOUTHELP.CHATNOW\"></span> </md-button> </div>";

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutInfoModule = void 0;

var _info = _interopRequireDefault(__webpack_require__(1285));

__webpack_require__(1286);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutInfoModule = angular.module('app.components.checkout.components.checkoutInfo', []).component('checkoutInfo', {
  template: _info.default,
  bindings: {}
}).name;
exports.CheckoutInfoModule = CheckoutInfoModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-info\"> <div layout=\"row\" layout-align=\"start center\"> <div flex=\"45\"> <div class=\"checkout-info__img\"><img src=\"/assets/checkout-support.png\" width=\"100%\"></div> </div> <div flex=\"55\"> <div class=\"checkout-info__title\"> <md-icon>favorite</md-icon> <span translate=\"CHECKOUTINFO.HERETOHELP\"></span> </div> <div class=\"checkout-info__subtitle\"> <span translate=\"CHECKOUTINFO.YOURSUCCESSISOURS\"></span> </div> <div class=\"checkout-info__desc\"> <span translate=\"CHECKOUTINFO.ALWAYSAVAILABLE\"></span> </div> </div> </div> </div>";

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutLoginFormModule = void 0;

var _auth0auth = __webpack_require__(166);

var _validateEmail = __webpack_require__(389);

var _constants = __webpack_require__(24);

var _checkout = __webpack_require__(154);

var _loginForm = _interopRequireDefault(__webpack_require__(1288));

__webpack_require__(1289);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CheckoutLoginFormModule = angular.module('app.components.checkout.components.checkoutLoginForm', [_auth0auth.Auth0AuthServiceModule, _validateEmail.ValidateEmailDirectiveModule, _checkout.CheckoutServiceModule]).component('checkoutLoginForm', {
  template: _loginForm.default,
  bindings: {
    user: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    CheckoutLoginFormCtrl.$inject = ["$window", "$cookies", "auth0AuthService", "checkoutService"];

    function CheckoutLoginFormCtrl($window, $cookies, auth0AuthService, checkoutService) {
      'ngInject';

      _classCallCheck(this, CheckoutLoginFormCtrl);

      angular.extend(this, {
        loading: false,
        errorMessage: null,
        $window: $window,
        $cookies: $cookies,
        auth0AuthService: auth0AuthService,
        checkoutService: checkoutService
      });
    }

    _createClass(CheckoutLoginFormCtrl, [{
      key: "$onInit",
      value: function $onInit() {}
    }, {
      key: "login",
      value: function login() {
        this.clearError();
        this.loading = true;
        this.$cookies.put(_constants.LOGIN_REDIRECT_COOKIE, this.$window.location.pathname + this.$window.location.search);
        this.auth0AuthService.auth0login(this.loginUser.email);
      }
    }, {
      key: "inputNeedsAttention",
      value: function inputNeedsAttention(input) {
        return {
          'v-input--error': input.$invalid && input.$dirty && input.$touched && input.$invalid || this.errorMessage
        };
      }
    }, {
      key: "clearError",
      value: function clearError() {
        this.errorMessage = null;
      }
    }, {
      key: "setError",
      value: function setError(message) {
        this.errorMessage = message;
      }
    }]);

    return CheckoutLoginFormCtrl;
  }()
}).name;
exports.CheckoutLoginFormModule = CheckoutLoginFormModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-login-form\"> <div class=\"checkout-login-form__title\"><b translate=\"CHECKOUTLOGIN.TITLE\"></b></div> <form name=\"loginForm\" ng-submit=\"$ctrl.login()\" class=\"checkout-login-form__form\" novalidate> <div layout-xs=\"column\" layout-gt-xs=\"row\"> <div class=\"v-input\" flex ng-class=\"$ctrl.inputNeedsAttention(loginForm.email)\"> <label for=\"loginEmail\" translate=\"CHECKOUTLOGIN.EMAIL\"></label> <input id=\"loginEmail\" type=\"email\" name=\"email\" ng-model=\"$ctrl.loginUser.email\" autofill vln-validate-email required> <div class=\"v-input__errors\" ng-messages=\"loginForm.email.$error\"> <div ng-message=\"required\" translate=\"LOGIN.EMAILREQUIRED\"></div> <div ng-message=\"validEmail\" translate=\"LOGIN.EMAILVALID\"></div> </div> </div> </div> <div class=\"checkout-login-form__error\" ng-if=\"$ctrl.errorMessage\">{{$ctrl.errorMessage}}</div> <div class=\"checkout-login-form__actions\"> <md-button class=\"md-raised md-accent checkout-rounded-button\" type=\"submit\" ng-disabled=\"loginForm.$invalid || $ctrl.loading\"> <span ng-if=\"!$ctrl.loading\"><span translate=\"LOGIN.LOGIN\"></span> <md-icon>arrow_forward</md-icon></span> <md-progress-circular class=\"progress-white\" md-diameter=\"30\" md-mode=\"indeterminate\" ng-if=\"$ctrl.loading\"></md-progress-circular> </md-button> </div> </form> </div>";

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutOrderSummaryModule = void 0;

var _angularRecaptcha = _interopRequireDefault(__webpack_require__(1291));

var _mobileAnalytics = __webpack_require__(191);

var _creditCard = __webpack_require__(164);

var _checkout = __webpack_require__(154);

var _subscription = __webpack_require__(42);

var _toNumber = _interopRequireDefault(__webpack_require__(268));

var _constants = __webpack_require__(24);

var _orderSummary = _interopRequireDefault(__webpack_require__(1293));

__webpack_require__(1294);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CheckoutOrderSummaryModule = angular.module('app.components.checkout.components.checkoutOrderSummary', [_checkout.CheckoutServiceModule, _subscription.SubscriptionServiceModule, _mobileAnalytics.MobileAnalyticsServiceModule, _creditCard.CreditCardServiceModule, 'ngMaterial', _angularRecaptcha.default]).component('checkoutOrderSummary', {
  template: _orderSummary.default,
  bindings: {
    canPlaceOrder: '<',
    cart: '<',
    coupon: '<',
    expireTrialInFiveMinutes: '<',
    onPurchaseComplete: '&',
    trialDaysRemaining: '<',
    user: '<',
    selectedPaymentMethod: '<',
    requireRecaptcha: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    CheckoutOrderSummaryCtrl.$inject = ["checkoutService", "subscriptionsService", "$mdDialog", "$translate", "creditCardUtilities", "mobileAnalyticsService", "creditCardService", "vcRecaptchaService"];

    function CheckoutOrderSummaryCtrl(checkoutService, subscriptionsService, $mdDialog, $translate, creditCardUtilities, mobileAnalyticsService, creditCardService, vcRecaptchaService) {
      'ngInject';

      _classCallCheck(this, CheckoutOrderSummaryCtrl);

      angular.extend(this, {
        checkoutService: checkoutService,
        subscriptionsService: subscriptionsService,
        $mdDialog: $mdDialog,
        $translate: $translate,
        creditCardUtilities: creditCardUtilities,
        mobileAnalyticsService: mobileAnalyticsService,
        creditCardService: creditCardService,
        vcRecaptchaService: vcRecaptchaService,
        LEGAL_TERMS_URL: "https://www-dev.volusion.com/v2/terms-of-service/",
        PRIVACY_POLICY_URL: "https://www-dev.volusion.com/privacy-policy/",
        recaptchaSiteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
      });
    }

    _createClass(CheckoutOrderSummaryCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.$translate(['REGISTER.REGISTRATION_ERROR_TITLE', 'REGISTER.REGISTRATION_ERROR_DESCRIPTION', 'REGISTER.PROCESSINGSTEP1', 'CHANGEPLAN.ERROR_TITLE', 'CHANGEPLAN.ERROR_DESCRIPTION']).then(function (translations) {
          _this.translations = translations;
        });
        this.taxAmount = 0;
        this.onPaymentRequestTokenCreated = this.onPaymentRequestTokenCreated.bind(this);
        this.onShippingAddressChange = this.onShippingAddressChange.bind(this);
        var paymentRequest = this.buildPaymentRequest();
        this.setupElementPaymentRequest(paymentRequest);
        this.grandTotal = this.getGrandTotal();
      }
    }, {
      key: "buildPaymentRequest",
      value: function buildPaymentRequest() {
        this.stripe = this.creditCardService.getStripe();
        return this.stripe.paymentRequest(this.buildPaymentRequestOptions(this.cart.planDetails));
      }
    }, {
      key: "buildPaymentRequestOptions",
      value: function buildPaymentRequestOptions(plan) {
        return {
          country: 'US',
          currency: 'usd',
          total: {
            label: "".concat(plan.name),
            amount: plan.amount
          },
          requestPayerEmail: true,
          requestShipping: true,
          shippingOptions: [{
            id: 'digital-subscription',
            label: 'Digital Subscription',
            amount: 0
          }]
        };
      }
    }, {
      key: "setupElementPaymentRequest",
      value: function setupElementPaymentRequest(paymentRequest) {
        var elements = this.stripe.elements();
        var prButton = elements.create('paymentRequestButton', {
          paymentRequest: paymentRequest,
          style: {
            paymentRequestButton: {
              type: 'default'
            }
          }
        });
        paymentRequest.canMakePayment().then(function (result) {
          if (result) {
            prButton.mount('#payment-request-button');
          }
        });
        paymentRequest.on('shippingaddresschange', this.onShippingAddressChange);
        paymentRequest.on('token', this.onPaymentRequestTokenCreated);
      }
    }, {
      key: "onShippingAddressChange",
      value: function onShippingAddressChange(event) {
        var _this2 = this;

        this.checkoutService.logCheckoutStep(this.checkoutService.STEP_SHIPPINGADDRESS, this.cart.planDetails, this.selectedPaymentMethod);
        return this.subscriptionsService.getGrandTotal(this.cart.planDetails, event.shippingAddress.region, event.shippingAddress.postalCode).then(function (grandTotalData) {
          _this2.grandTotal = grandTotalData.grandTotalFormatted;
          _this2.taxAmount = grandTotalData.taxAmountFormatted;
          event.updateWith({
            status: 'success',
            total: {
              amount: grandTotalData.grandTotal,
              label: _this2.cart.planDetails.name
            }
          });
        });
      }
    }, {
      key: "onPaymentRequestTokenCreated",
      value: function onPaymentRequestTokenCreated(event) {
        var _this3 = this;

        this.checkoutService.logCheckoutStep(this.checkoutService.STEP_CONTACTINFO, this.cart.planDetails, this.selectedPaymentMethod);
        this.checkoutService.logCheckoutStep(this.checkoutService.STEP_PAYMENTMETHOD, this.cart.planDetails, this.selectedPaymentMethod);
        return this.subscriptionsService.changePlan({
          planId: this.cart.planDetails.id,
          stripeToken: event.token.id,
          couponCode: '',
          trialDaysRemaining: this.trialDaysRemaining,
          address: {
            state: event.shippingAddress.region,
            zip: event.shippingAddress.postalCode
          }
        }).then(function (subscription) {
          var subscriptionInfo = {
            id: subscription.id,
            tenantId: subscription.tenant,
            customerId: subscription.customer
          };
          _this3.cart.couponCode = _this3.coupon;

          _this3.checkoutService.logPurchase(_this3.cart, subscriptionInfo, _this3.user, _this3.selectedPaymentMethod);

          event.complete('success');
          _this3.purchaseComplete = true;

          _this3.onPurchaseComplete();
        });
      }
    }, {
      key: "onRecaptchaSuccess",
      value: function onRecaptchaSuccess(response) {
        this.placeOrder(response);
      }
    }, {
      key: "onPlaceOrderClicked",
      value: function onPlaceOrderClicked() {
        if (this.requireRecaptcha) {
          this.vcRecaptchaService.execute();
        } else {
          this.placeOrder();
        }
      }
    }, {
      key: "placeOrder",
      value: function placeOrder(recaptchaResponse) {
        var _this4 = this;

        this.checkoutService.logCheckoutStep(this.checkoutService.STEP_CONTACTINFO, this.cart.planDetails);
        this.checkoutService.logCheckoutStep(this.checkoutService.STEP_SHIPPINGADDRESS, this.cart.planDetails);
        this.loading = true;
        this.checkoutService.placeOrder(this.user, this.cart, this.expireTrialInFiveMinutes, this.trialDaysRemaining, recaptchaResponse).then(function () {
          _this4.purchaseComplete = true;

          _this4.onPurchaseComplete();

          _this4.loading = false;
        }).catch(function (error) {
          var errorTitle = _this4.user.isLoggedIn ? _this4.translations['CHANGEPLAN.ERROR_TITLE'] : _this4.translations['REGISTER.REGISTRATION_ERROR_TITLE'];
          var errorDescription;

          if (error && error.message) {
            errorDescription = error.message;
          } else if (_this4.user.isLoggedIn) {
            errorDescription = _this4.translations['CHANGEPLAN.ERROR_DESCRIPTION'];
          } else {
            errorDescription = _this4.translations['REGISTER.REGISTRATION_ERROR_DESCRIPTION'];
          }

          _this4.mobileAnalyticsService.trackEvent('Order:Failed', {});

          if (_this4.requireRecaptcha) {
            _this4.vcRecaptchaService.reload();
          }

          _this4.loading = false;

          _this4.$mdDialog.show(_this4.$mdDialog.alert().clickOutsideToClose(true).title(errorTitle).textContent(errorDescription).ariaLabel(errorTitle).ok('Ok').multiple(true));
        });
      }
    }, {
      key: "calculateSubtotal",
      value: function calculateSubtotal() {
        var planAmount = (0, _toNumber.default)(this.cart.planDetails.amount) / 100;
        var subtotal = planAmount - this.getDollarsOff(this.coupon);
        return subtotal > 0 ? subtotal : 0;
      }
    }, {
      key: "getGrandTotal",
      value: function getGrandTotal() {
        var subtotal = this.calculateSubtotal();
        return subtotal + this.taxAmount;
      }
    }, {
      key: "getGrandTotalPerInterval",
      value: function getGrandTotalPerInterval() {
        return this.grandTotal / this.cart.planDetails.interval_count;
      }
    }, {
      key: "getDollarsOff",
      value: function getDollarsOff(coupon) {
        var discountAmount;

        if (coupon) {
          var planAmount = this.getPlanAmountInDollars(this.cart.planDetails.amount);
          discountAmount = coupon.percent_off ? planAmount * ((0, _toNumber.default)(coupon.percent_off) / 100) : this.getAmountOffInDollars(coupon);
        } else {
          discountAmount = 0;
        }

        return discountAmount;
      }
    }, {
      key: "getPlanAmountInDollars",
      value: function getPlanAmountInDollars(planAmount) {
        return (0, _toNumber.default)(planAmount) / 100;
      }
    }, {
      key: "getAmountOffInDollars",
      value: function getAmountOffInDollars(coupon) {
        return (0, _toNumber.default)(coupon.amount_off / 100);
      }
    }, {
      key: "getDiscountLabel",
      value: function getDiscountLabel(coupon) {
        var labelDiscountAmount = coupon.percent_off ? "".concat(coupon.percent_off, "%") : "$".concat(this.getAmountOffInDollars(coupon));
        var labelDiscountDuration = coupon.duration === 'repeating' ? "for ".concat(coupon.duration_in_months, " months") : coupon.duration;
        return "".concat(labelDiscountAmount, " off ").concat(labelDiscountDuration);
      }
    }, {
      key: "shouldShowStripePaymentRequestButton",
      value: function shouldShowStripePaymentRequestButton() {
        return this.termsAndConditionsAccepted && (this.selectedPaymentMethod === _constants.STRIPE_ELEMENTS_GOOGLE_PAY || this.selectedPaymentMethod === _constants.STRIPE_ELEMENTS_APPLE_PAY);
      }
    }]);

    return CheckoutOrderSummaryCtrl;
  }()
}).name;
exports.CheckoutOrderSummaryModule = CheckoutOrderSummaryModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1291 */,
/* 1292 */,
/* 1293 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-summary\"> <div class=\"checkout-summary__header\"> <div class=\"checkout-summary__title\" ng-if=\"!$ctrl.cart.isDowngrade\">Today's Total</div> <div class=\"checkout-summary__price\"><sup>$</sup><span>{{$ctrl.getGrandTotal() | currency:''}}</span></div> </div> <div class=\"checkout-summary__body\"> <div class=\"checkout-summary__item\" layout=\"row\" layout-align=\"space-between start\"> <span class=\"checkout-summary__item-name checkout-summary__item-name--bold\">{{$ctrl.cart.planDetails.name}}</span> <span class=\"checkout-summary__item-price\">{{$ctrl.getGrandTotalPerInterval() | currency}}/mo</span> </div> <div class=\"checkout-summary__item\" ng-if=\"$ctrl.coupon\" layout=\"row\" layout-align=\"space-between start\"> <span class=\"checkout-summary__item-name\">{{$ctrl.getDiscountLabel($ctrl.coupon)}}</span> <span class=\"checkout-summary__item-price\">-{{$ctrl.getDollarsOff($ctrl.coupon) | currency}}</span> </div> <div class=\"checkout-summary__item\" layout=\"row\" layout-align=\"space-between start\"> <span class=\"checkout-summary__item-name checkout-summary__item-name\">Tax</span> <span ng-if=\"$ctrl.taxAmount\" class=\"checkout-summary__item-price\">{{$ctrl.taxAmount | currency}}</span> <span ng-if=\"!$ctrl.taxAmount\" class=\"checkout-summary__item-price\">May apply in MA, NM, NY, OH, PA, SC, TN, TX, UT, or WA</span> </div> <hr/> <div class=\"checkout-summary__item\" layout=\"row\" layout-align=\"space-between start\"> <span class=\"checkout-summary__item-name\">Total</span> <span class=\"checkout-summary__item-price\">{{$ctrl.getGrandTotal() | currency}}</span> </div> <div class=\"checkout-summary__item\" ng-if=\"$ctrl.cart.isDowngrade\" layout=\"row\" layout-align=\"space-between start\"> <span class=\"checkout-summary__item-name\">Effective</span> <span class=\"checkout-summary__item-price\">{{$ctrl.cart.billingPeriodEnd}}</span> </div> <div class=\"checkout-summary__terms\" ng-if=\"!$ctrl.purchaseComplete\"> <md-checkbox ng-model=\"$ctrl.termsAndConditionsAccepted\" md-no-ink aria-label=\"accept terms\"> </md-checkbox> <span>I have reviewed, understand and agree to the </span> <a ng-href=\"{{$ctrl.LEGAL_TERMS_URL}}\" target=\"_blank\">Terms of Service</a> and <a ng-href=\"{{$ctrl.PRIVACY_POLICY_URL}}\" target=\"_blank\">Privacy Policy</a> </div> <div ng-if=\"$ctrl.requireRecaptcha\" vc-recaptcha size=\"'invisible'\" theme=\"'light'\" key=\"$ctrl.recaptchaSiteKey\" on-success=\"$ctrl.onRecaptchaSuccess(response)\" on-expire=\"$ctrl.vcRecaptchaService.reload()\"></div> <md-button ng-show=\"$ctrl.selectedPaymentMethod === 'card' || !$ctrl.termsAndConditionsAccepted\" class=\"md-accent md-raised checkout-rounded-button\" ng-click=\"$ctrl.onPlaceOrderClicked()\" ng-disabled=\"\n                !$ctrl.canPlaceOrder ||\n                !$ctrl.termsAndConditionsAccepted ||\n                $ctrl.loading\n            \" ng-if=\"!$ctrl.purchaseComplete\"> <span ng-if=\"!$ctrl.loading\">Place Your Order</span> <md-progress-circular class=\"progress-white\" md-diameter=\"30\" md-mode=\"indeterminate\" ng-if=\"$ctrl.loading\"></md-progress-circular> </md-button> <div ng-show=\"$ctrl.shouldShowStripePaymentRequestButton()\" ng-if=\"!$ctrl.purchaseComplete\" id=\"payment-request-button\"> </div> </div> </div> ";

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutSignupFormModule = void 0;

var _get = _interopRequireDefault(__webpack_require__(34));

var _angularCreditCards = _interopRequireDefault(__webpack_require__(483));

var _phoneInput = __webpack_require__(653);

var _validatePhone = __webpack_require__(643);

var _validatePassword = __webpack_require__(713);

var _validateEmail = __webpack_require__(389);

var _checkEmail = __webpack_require__(1296);

var _payment = __webpack_require__(714);

var _dataLayer = __webpack_require__(374);

var _constants = __webpack_require__(24);

var _creditCardUtilities = __webpack_require__(86);

var _creditCards = __webpack_require__(1297);

var _googleAutocomplete = __webpack_require__(1302);

var _signupForm = _interopRequireDefault(__webpack_require__(1304));

__webpack_require__(1305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CheckoutSignupFormModule = angular.module('app.components.checkout.components.checkoutSignupForm', [_angularCreditCards.default, _creditCardUtilities.CreditCardUtilitiesServiceModule, _creditCards.CreditCardsModule, _phoneInput.PhoneInputDirectiveModule, _validatePhone.ValidatePhoneDirectiveModule, _validatePassword.ValidatePasswordDirectiveModule, _validateEmail.ValidateEmailDirectiveModule, _checkEmail.CheckEmailDirectiveModule, _payment.PaymentServiceModule, _dataLayer.DataLayerServiceModule, _googleAutocomplete.GoogleAutoComplete]).component('checkoutSignupForm', {
  template: _signupForm.default,
  bindings: {
    couponData: '<coupon',
    couponCode: '<',
    user: '<',
    onValidityChange: '&',
    isEditMode: '<',
    onCouponEntered: '&',
    onPaymentMethodSelected: '<',
    showCouponField: '<',
    purchaseComplete: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    CheckoutSignupFormCtrl.$inject = ["creditCardUtilities", "$scope", "paymentService", "dataLayer", "$q"];

    function CheckoutSignupFormCtrl(creditCardUtilities, $scope, paymentService, dataLayer, $q) {
      'ngInject';

      _classCallCheck(this, CheckoutSignupFormCtrl);

      angular.extend(this, {
        card: {
          ccClass: 'credit-card-img--unknown'
        },
        AUTOCOMPLETE_COUNTRIES: ['US'],
        creditCardUtilities: creditCardUtilities,
        $scope: $scope,
        STATES_US: _constants.STATES_US,
        paymentService: paymentService,
        dataLayer: dataLayer,
        $q: $q
      });
    }

    _createClass(CheckoutSignupFormCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.onToggleEditMode = this.onToggleEditMode.bind(this);
        this.$scope.$watch('signupForm.$valid', function (newValue) {
          if (angular.isDefined(newValue)) {
            _this.onValidityChange({
              isValid: newValue
            });
          }
        });
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changesObject) {
        if ((0, _get.default)(changesObject, 'user.currentValue.newPayment.brand')) {
          this.setCardInfo(this.user.newPayment.brand);
        }

        if ((0, _get.default)(changesObject, 'couponCode.currentValue')) {
          this.showCouponCodeInput = true;
          this.user.couponCode = this.couponCode;
          this.validateCoupon(this.couponCode);
        }

        if ((0, _get.default)(changesObject, 'couponData.currentValue.id')) {
          this.user.couponCode = this.couponData.id;
          this.showCouponCodeInput = true;
        }
      }
    }, {
      key: "setCardInfo",
      value: function setCardInfo(cardType) {
        this.card.ccClass = this.creditCardUtilities.getCssClass(cardType);
        this.card.brand = cardType;
      }
    }, {
      key: "toggleEditMode",
      value: function toggleEditMode() {
        this.isEditMode = !this.isEditMode;
        this.setCardInfo(this.user.newPayment.brand);
      }
    }, {
      key: "inputNeedsAttention",
      value: function inputNeedsAttention(input) {
        return {
          'v-input--error': input.$invalid && input.$dirty && input.$touched && input.$invalid
        };
      }
    }, {
      key: "setCouponCodeValidity",
      value: function setCouponCodeValidity(isValid) {
        if ((0, _get.default)(this, '$scope.signupForm.couponCode')) {
          this.$scope.signupForm.couponCode.$setDirty();
          this.$scope.signupForm.couponCode.$setTouched();
          this.$scope.signupForm.couponCode.$setValidity('couponValid', isValid);
        }
      }
    }, {
      key: "validateCoupon",
      value: function validateCoupon(coupon) {
        var _this2 = this;

        this.applyingCouponCode = true;
        return this.paymentService.stripe.validateCoupon(coupon).then(function (response) {
          if (!response.valid) return _this2.$q.reject();

          _this2.setCouponCodeValidity(true);

          _this2.couponData = Object.assign({}, response, {
            id: coupon
          });

          _this2.onCouponEntered({
            coupon: _this2.couponData
          });
        }).catch(function () {
          _this2.setCouponCodeValidity(false);

          _this2.dataLayer.logCouponError(coupon);
        }).finally(function () {
          _this2.applyingCouponCode = false;
        });
      }
    }, {
      key: "clearCoupon",
      value: function clearCoupon() {
        this.couponData = null;
        this.user.couponCode = '';
        this.onCouponEntered({
          coupon: null
        });
      }
    }, {
      key: "onCouponCodeChanged",
      value: function onCouponCodeChanged() {
        this.$scope.signupForm.couponCode.$setValidity('couponValid', true);
      }
    }, {
      key: "onToggleEditMode",
      value: function onToggleEditMode() {
        this.isEditMode = !this.isEditMode;
      }
    }]);

    return CheckoutSignupFormCtrl;
  }()
}).name;
exports.CheckoutSignupFormModule = CheckoutSignupFormModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckEmailDirectiveModule = void 0;

var _auth = __webpack_require__(77);

var CheckEmailDirectiveModule = angular.module('app.directives.checkEmail', [_auth.AuthServiceModule]).directive('vlnCheckEmail', ["$q", "authService", function ($q, authService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModelCtrl) {
      ngModelCtrl.$asyncValidators.emailAvailable = function (modelValue, viewValue) {
        var email = modelValue || viewValue;
        return authService.checkEmail(email).then(function (res) {
          if (res.data === true) {
            //username exists, this means validation fails
            return $q.reject('exists');
          }

          return true;
        });
      };
    }
  };
}]).name;
exports.CheckEmailDirectiveModule = CheckEmailDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditCardsModule = void 0;

var _cardInfo = __webpack_require__(595);

var _creditCardEditor = __webpack_require__(424);

var _formatCcExpiration = __webpack_require__(1300);

var _validateCcExpiration = __webpack_require__(1301);

var CreditCardsModule = angular.module('app.components.creditCards', [_cardInfo.CardInfoModule, _creditCardEditor.CreditCardEditorModule, _formatCcExpiration.FormatCcExpirationModule, _validateCcExpiration.ValidateCcExpirationModule]).name;
exports.CreditCardsModule = CreditCardsModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

module.exports = "<div class=\"m-credit-card-editor\"> <ng-form id=\"creditCardForm\" name=\"creditCardForm\" novalidate> <div layout=\"row\"> <md-input-container flex=\"100\" class=\"no-top-margin no-bottom-margin\" md-no-float> <input id=\"cardNumber\" name=\"cardNumber\" type=\"text\" placeholder=\"{{'REGISTER.CREDITCARD_NUMBER_LABEL' | translate}}\" data-ng-model=\"card.cardNumber\" ng-change=\"vm.setCardInfo(creditCardForm.cardNumber.$ccEagerType)\" ng-keypress=\"vm.setCardInfo(creditCardForm.cardNumber.$ccEagerType)\" cc-number cc-eager-type cc-format required/> <div ng-messages=\"creditCardForm.cardNumber.$error\" role=\"alert\"> <div ng-message=\"required\">{{'REGISTER.CREDITCARD_NUMBER_REQUIRED' | translate}}</div> <div ng-message=\"ccNumber\">{{'REGISTER.CREDITCARD_NUMBER_VALID' | translate}}</div> </div> <span class=\"credit-card-img\" data-ng-class=\"vm.ccClass\"></span> </md-input-container> </div> <div layout=\"row\"> <md-input-container flex-gt-xs=\"50\" flex-xs=\"100\" class=\"no-top-margin\" md-no-float> <input id=\"expiration\" name=\"expiration\" data-ng-model=\"card.expiration\" payments-format=\"expiry\" payments-validate=\"expiry\" placeholder=\"{{'REGISTER.CREDITCARD_EXP_LABEL' | translate}}\" ng-change=\"vm.setCardInfo(creditCardForm.cardNumber.$ccEagerType)\" required/> <div ng-messages=\"creditCardForm.expiration.$error\" role=\"alert\"> <div ng-message=\"required\">{{'REGISTER.CREDITCARD_EXP_REQUIRED' | translate}}</div> <div ng-message=\"expiry\">{{'REGISTER.CREDITCARD_EXP_VALID' | translate}}</div> </div> </md-input-container> <md-input-container flex-gt-xs=\"50\" flex-xs=\"100\" class=\"no-top-margin\" md-no-float> <input id=\"cvv\" name=\"cvv\" data-ng-model=\"card.CVV\" placeholder=\"{{'REGISTER.CREDITCARD_CVV_LABEL' | translate}}\" ng-change=\"vm.setCardInfo(creditCardForm.cardNumber.$ccEagerType)\" required cc-cvc/> <div ng-messages=\"creditCardForm.cvv.$error\" role=\"alert\"> <div ng-message=\"required\">{{'REGISTER.CREDITCARD_CVV_REQUIRED' | translate}}</div> <div ng-message=\"ccCvc\">{{'REGISTER.CREDITCARD_CVV_VALID' | translate}}</div> </div> </md-input-container> </div> </ng-form> </div> ";

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormatCcExpirationModule = void 0;

var _creditCardUtilities = __webpack_require__(86);

var FormatCcExpirationModule = angular.module('app.components.creditCards.formatCcExpiration', [_creditCardUtilities.CreditCardUtilitiesServiceModule]).factory('_Format', ["$filter", "$document", "creditCardUtilities", function ($filter, $document, creditCardUtilities) {
  var formats = {};

  var hasTextSelected = function hasTextSelected($target) {
    var ref;

    if ($target.prop('selectionStart') != null && $target.prop('selectionStart') !== $target.prop('selectionEnd')) {
      return true;
    }

    if (typeof $document !== 'undefined' && $document !== null && (ref = $document.selection) != null && typeof ref.createRange === 'function' && ref.createRange().text) {
      return true;
    }

    return false;
  }; // expiry


  var restrictExpiry = function restrictExpiry(e) {
    var $target;
    var digit;
    var value;
    $target = angular.element(e.currentTarget);
    digit = String.fromCharCode(e.which);

    if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
      e.preventDefault();
      return;
    }

    if (hasTextSelected($target)) return;
    value = $target.val() + digit;
    value = value.replace(/\D/g, '');

    if (value.length > 6) {
      e.preventDefault();
    }
  };

  var formatExpiry = function formatExpiry(e) {
    var $target;
    var digit;
    var val;
    digit = String.fromCharCode(e.which);

    if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
      e.preventDefault();
      return;
    }

    $target = angular.element(e.currentTarget);
    val = $target.val() + digit;

    if (/^\d$/.test(val) && val !== '0' && val !== '1') {
      e.preventDefault();
      return $target.val("0".concat(val, " / "));
    } else if (/^\d\d$/.test(val)) {
      e.preventDefault();
      return $target.val(" ".concat(val, " / "));
    }
  };

  var formatForwardExpiry = function formatForwardExpiry(e) {
    var $target;
    var digit;
    var val;
    digit = String.fromCharCode(e.which);
    if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) return;
    $target = angular.element(e.currentTarget);
    val = $target.val();

    if (/^\d\d$/.test(val)) {
      return $target.val(" ".concat(val, " / "));
    }
  };

  var formatForwardSlash = function formatForwardSlash(e) {
    var $target;
    var slash;
    var val;
    slash = String.fromCharCode(e.which);
    if (slash !== '/') return;
    $target = angular.element(e.currentTarget);
    val = $target.val();

    if (/^\d$/.test(val) && val !== '0') {
      return $target.val("0".concat(val, " / "));
    }
  };

  var formatBackExpiry = function formatBackExpiry(e) {
    var $target;
    var value;
    if (e.meta) return;
    $target = angular.element(e.currentTarget);
    value = $target.val();
    if (e.which !== 8) return;
    if ($target.prop('selectionStart') != null && $target.prop('selectionStart') !== value.length) return;

    if (/\d(\s|\/)+$/.test(value)) {
      e.preventDefault();
      return $target.val(value.replace(/\d(\s|\/)*$/, ''));
    } else if (/\s\/\s?\d?$/.test(value)) {
      e.preventDefault();
      return $target.val(value.replace(/\s\/\s?\d?$/, ''));
    }
  };

  var parseExpiry = function parseExpiry(value) {
    if (value != null) {
      var obj = creditCardUtilities.parseExpiration(value);
      var expiry = new Date(obj.year, obj.month - 1);
      return $filter('date')(expiry, 'MM/yyyy');
    }

    return null;
  };

  var getFormattedExpiry = function getFormattedExpiry(value) {
    if (value != null) {
      var obj = creditCardUtilities.parseExpiration(value);
      var expiry = new Date(obj.year, obj.month - 1);
      return $filter('date')(expiry, 'MM / yyyy');
    }

    return null;
  };

  formats.expiry = function (elem, ctrl) {
    elem.bind('keypress', restrictExpiry);
    elem.bind('keypress', formatExpiry);
    elem.bind('keypress', formatForwardSlash);
    elem.bind('keypress', formatForwardExpiry);
    elem.bind('keydown', formatBackExpiry);
    ctrl.$parsers.push(parseExpiry);
    ctrl.$formatters.push(getFormattedExpiry);
  };

  return function (type, elem, ctrl) {
    if (!formats[type]) {
      var types = Object.keys(formats);
      var errstr = "Unknown type for formatting: ".concat(type, ".");
      errstr += "Should be one of: ".concat(types.join(', '));
      throw errstr;
    }

    return formats[type](elem, ctrl);
  };
}]).directive('paymentsFormat', ["$window", "_Format", function ($window, _Format) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, elem, attr, ctrl) {
      _Format(attr.paymentsFormat, elem, ctrl);
    }
  };
}]).name;
exports.FormatCcExpirationModule = FormatCcExpirationModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidateCcExpirationModule = void 0;

var _creditCardUtilities = __webpack_require__(86);

var ValidateCcExpirationModule = angular.module('app.components.creditCards.validateCcExpiration', [_creditCardUtilities.CreditCardUtilitiesServiceModule]).factory('_Validate', ["creditCardUtilities", function (creditCardUtilities) {
  var validators = {};

  validators.expiry = function (val) {
    // valid if empty - let ng-required handle empty
    if (val === null || val.length === 0) return true;
    var obj = creditCardUtilities.parseExpiration(val);
    var month = obj.month;
    var year = obj.year;
    var currentTime;
    var expiry;
    var prefix;

    if (!(month && year)) {
      return false;
    }

    if (!/^\d+$/.test(month)) {
      return false;
    }

    if (!/^\d+$/.test(year)) {
      return false;
    }

    if (!(parseInt(month) <= 12)) {
      return false;
    }

    if (year.length === 2) {
      prefix = new Date().getFullYear();
      prefix = prefix.toString().slice(0, 2);
      year = prefix + year;
    }

    expiry = new Date(year, month);
    currentTime = new Date();
    expiry.setMonth(expiry.getMonth() - 1);
    expiry.setMonth(expiry.getMonth() + 1, 1);
    return expiry > currentTime;
  };

  return function (type, val, ctrl, scope, attr) {
    if (!validators[type]) {
      var types = Object.keys(validators);
      var errstr = "Unknown type for validation: ".concat(type, ". Should be one of: ").concat(types.join(', '));
      throw errstr;
    }

    return validators[type](val, ctrl, scope, attr);
  };
}]).factory('_ValidateWatch', ["_Validate", function (_Validate) {
  var _validatorWatches = {};

  _validatorWatches.cvc = function (type, ctrl, scope, attr) {
    if (attr.paymentsTypeModel) {
      scope.$watch(attr.paymentsTypeModel, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          var valid = _Validate(type, ctrl.$modelValue, ctrl, scope, attr);

          ctrl.$setValidity(type, valid);
        }
      });
    }
  };

  return function (type, ctrl, scope, attr) {
    if (_validatorWatches[type]) {
      return _validatorWatches[type](type, ctrl, scope, attr);
    }
  };
}]).directive('paymentsValidate', ["$window", "_Validate", "_ValidateWatch", function ($window, _Validate, _ValidateWatch) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, elem, attr, ctrl) {
      var type = attr.paymentsValidate;

      _ValidateWatch(type, ctrl, scope, attr);

      var validateFn = function validateFn(val) {
        var valid = _Validate(type, val, ctrl, scope, attr);

        ctrl.$setValidity(type, valid);
        return valid ? val : undefined;
      };

      ctrl.$formatters.push(validateFn);
      ctrl.$parsers.push(validateFn);
    }
  };
}]).name;
exports.ValidateCcExpirationModule = ValidateCcExpirationModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleAutoComplete = void 0;

__webpack_require__(1303);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GoogleAutoComplete = angular.module('app.components.googleAutocomplete', []).component('googleAutocomplete', {
  template: '<ng-transclude></ng-transclude>',
  bindings: {
    model: '=',
    formController: '=',
    country: '<',
    autocompleteCountries: '<'
  },
  transclude: true,
  controller:
  /*#__PURE__*/
  function () {
    GoogleAutocompleteCtrl.$inject = ["$window", "$timeout", "$rootScope", "$element"];

    function GoogleAutocompleteCtrl($window, $timeout, $rootScope, $element) {
      _classCallCheck(this, GoogleAutocompleteCtrl);

      angular.extend(this, {
        $window: $window,
        $timeout: $timeout,
        $rootScope: $rootScope,
        $element: $element
      });
    }

    _createClass(GoogleAutocompleteCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.$timeout(function () {
          _this.initGoogleAutocomplete();
        });
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changesObj) {
        if (changesObj && changesObj.country && !changesObj.country.isFirstChange()) {
          if (this.autocompleteCountries.includes(changesObj.country.currentValue)) {
            this.setAutoCompleteVisible(true);
            this.setCountryRestriction(changesObj.country.currentValue);
          } else {
            this.setAutoCompleteVisible(false);
          }
        }
      }
    }, {
      key: "setAutoCompleteVisible",
      value: function setAutoCompleteVisible(visibility) {
        angular.element(this.$window.document.body).toggleClass('google-autocomplete-hidden', !visibility);
      }
    }, {
      key: "initGoogleAutocomplete",
      value: function initGoogleAutocomplete() {
        this.autocomplete = new this.$window.google.maps.places.Autocomplete(this.$element[0].querySelector('input[google-maps-autocomplete-input]'), {
          types: ['address']
        });

        if (this.model && this.model.country) {
          this.setCountryRestriction(this.model.country);
        }

        this.autocomplete.addListener('place_changed', this.onPlaceChanged.bind(this));
      }
    }, {
      key: "clearAddress",
      value: function clearAddress() {
        this.model.address1 = '';
        this.model.address2 = '';
        this.model.city = '';
        this.model.state = '';
        this.model.country = '';
        this.model.postalCode = '';
        this.formController.$setUntouched();
        this.$rootScope.$apply();
      }
    }, {
      key: "setGoogleAddressToModel",
      value: function setGoogleAddressToModel(addressFromGoogle) {
        if (addressFromGoogle.street_number && addressFromGoogle.route) {
          this.model.address1 = "".concat(addressFromGoogle.street_number, " ").concat(addressFromGoogle.route);
        } else if (addressFromGoogle.route) {
          this.model.address1 = addressFromGoogle.route;
        }

        this.model.city = addressFromGoogle.locality || addressFromGoogle.neighborhood || addressFromGoogle.administrative_area_level_2;
        this.model.state = addressFromGoogle.administrative_area_level_1;
        this.model.country = addressFromGoogle.country;
        this.model.postalCode = addressFromGoogle.postal_code;
      }
    }, {
      key: "getFlattenedAddressObject",
      value: function getFlattenedAddressObject(place) {
        var addressFromGoogle = {};
        angular.forEach(place.address_components, function (addressComponent) {
          var componentType = addressComponent.types[0];
          addressFromGoogle[componentType] = addressComponent.short_name;
        });
        return addressFromGoogle;
      }
    }, {
      key: "onPlaceChanged",
      value: function onPlaceChanged() {
        var place = this.autocomplete.getPlace();

        if (place.address_components.length > 0) {
          this.clearAddress();
          this.setGoogleAddressToModel(this.getFlattenedAddressObject(place));
          this.$rootScope.$apply();
        }
      }
    }, {
      key: "setCountryRestriction",
      value: function setCountryRestriction(setCountry) {
        this.autocomplete.setComponentRestrictions({
          country: setCountry
        });
      }
    }]);

    return GoogleAutocompleteCtrl;
  }()
}).name;
exports.GoogleAutoComplete = GoogleAutoComplete;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-signup-form\" ng-form=\"signupForm\" novalidate> <md-button class=\"checkout-signup-form__edit-mode-toggle\" ng-click=\"$ctrl.toggleEditMode()\" ng-if=\"$ctrl.user.isLoggedIn && !$ctrl.user.forceEdit\" md-no-ink> <span ng-show=\"$ctrl.isEditMode\" translate=\"CHECKOUTSIGNUP.CANCELCHANGES\"></span> <span ng-show=\"!$ctrl.isEditMode\"> <md-icon>edit</md-icon> <span>Edit</span> </span> </md-button> <checkout-user-info user=\"$ctrl.user\" purchase-complete=\"$ctrl.purchaseComplete\" on-toggle-edit-mode=\"$ctrl.onToggleEditMode\" on-payment-method-selected=\"$ctrl.onPaymentMethodSelected\" ng-if=\"!$ctrl.isEditMode && !$ctrl.user.forceEdit\"> </checkout-user-info> <div ng-if=\"$ctrl.isEditMode || $ctrl.user.forceEdit\" ng-cloak> <div class=\"checkout-signup-form__section\" ng-if=\"!$ctrl.user.isLoggedIn\"> <div class=\"checkout-signup-form__title\" translate=\"CHECKOUTSIGNUP.CREATEYOURACCOUNT\"></div> <div class=\"checkout-signup-form__desc\" translate=\"CHECKOUTSIGNUP.ENTEREMAILPASSWORD\"></div> <div layout-xs=\"column\" layout-gt-xs=\"row\"> <div class=\"v-input\" flex ng-class=\"$ctrl.inputNeedsAttention(signupForm.email)\"> <label for=\"email\">{{'PLACEHOLDER.EMAILADDRESS' | translate}} *</label> <input id=\"email\" name=\"email\" ng-model=\"$ctrl.user.account.email\" ng-model-options=\"{ updateOn: 'default blur', debounce: { 'default' : 300, 'blur': 0 } }\" type=\"email\" vln-validate-email vln-check-email required/> <div class=\"v-input__errors\" ng-messages=\"signupForm.email.$error\"> <div ng-message=\"required\">{{\"LOGIN.EMAILREQUIRED\" | translate}}</div> <div ng-message=\"validEmail\">{{\"LOGIN.EMAILVALID\" | translate }}</div> <div ng-message=\"emailAvailable\">{{'LOGIN.EMAILTAKEN' | translate}}</div> </div> </div> <div class=\"v-input\" flex ng-class=\"$ctrl.inputNeedsAttention(signupForm.password)\"> <label for=\"password\">{{'LOGIN.PASSWORD' | translate}} *</label> <input id=\"password\" name=\"password\" ng-model=\"$ctrl.user.account.password\" type=\"password\" ng-minlength=\"8\" vln-validate-password required/> <div class=\"v-input__errors\" ng-messages=\"signupForm.password.$error\"> <div ng-message=\"required\">{{\"LOGIN.PASSREQUIRED\" | translate}}</div> <div ng-message=\"minlength\">{{\"LOGIN.PASSLENGTH\" | translate: {COUNT: 8} }}</div> <div ng-message=\"validPassword\">{{\"LOGIN.PASSVALID\" | translate}}</div> </div> </div> </div> </div> <div class=\"checkout-signup-form__section\"> <div class=\"checkout-signup-form__title\" translate=\"CHECKOUTSIGNUP.CONTACTINFO\"></div> <div layout-xs=\"column\" layout-gt-xs=\"row\"> <div class=\"v-input\" flex ng-class=\"$ctrl.inputNeedsAttention(signupForm.firstName)\"> <label for=\"firstName\">{{'LOGIN.FIRSTNAME' | translate}} *</label> <input id=\"firstName\" name=\"firstName\" ng-model=\"$ctrl.user.contact.firstName\" type=\"text\" maxlength=\"75\" required/> <div class=\"v-input__errors\" ng-messages=\"signupForm.firstName.$error\"> <div ng-message=\"required\">{{'ERROR.FIRSTREQUIRED' | translate}}</div> </div> </div> <div class=\"v-input\" flex ng-class=\"$ctrl.inputNeedsAttention(signupForm.lastName)\"> <label for=\"lastName\">{{'LOGIN.LASTNAME' | translate}} *</label> <input id=\"lastName\" name=\"lastName\" ng-model=\"$ctrl.user.contact.lastName\" type=\"text\" maxlength=\"75\" required/> <div class=\"v-input__errors\" ng-messages=\"signupForm.lastName.$error\"> <div ng-message=\"required\">{{'ERROR.FIRSTREQUIRED' | translate}}</div> </div> </div> </div> <div layout-xs=\"column\" layout-gt-xs=\"row\"> <div class=\"v-input\" flex ng-if=\"$ctrl.user.isLoggedIn\"> <label>{{'PLACEHOLDER.EMAILADDRESS' | translate}} *</label> <input tabindex=\"-1\" name=\"email\" ng-model=\"$ctrl.user.account.email\" type=\"email\" readonly=\"readonly\"/> </div> <div class=\"v-input\" flex ng-class=\"$ctrl.inputNeedsAttention(signupForm.phone)\"> <label for=\"phone\">{{'PLACEHOLDER.PHONENUMBER' | translate}} *</label> <input id=\"phone\" name=\"phone\" ng-model=\"$ctrl.user.contact.phoneNumber\" type=\"tel\" vln-validate-phone vln-phone-input required/> <div class=\"v-input__errors\" ng-messages=\"signupForm.phone.$error\"> <div ng-message=\"required\">Phone number is required.</div> <div ng-message=\"validPhone\">{{'ERROR.VALIDPHONE' | translate}}</div> </div> </div> </div> </div> <div class=\"checkout-signup-form__section\"> <div class=\"checkout-signup-form__title\" translate=\"CHECKOUTSIGNUP.PAYMENTMETHOD\"></div> <div class=\"checkout-signup-form__desc\" translate=\"CHECKOUTSIGNUP.CARDMESSAGE\"></div> <div layout-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"row\"> <div class=\"v-input checkout-signup-form__cardnumber\" flex-xs=\"100\" flex-sm=\"100\" flex-gt-xs=\"50\" ng-class=\"$ctrl.inputNeedsAttention(signupForm.cardNumber)\"> <label for=\"cardNumber\">{{'REGISTER.CREDITCARD_NUMBER_LABEL' | translate}} *</label> <div class=\"credit-card-img-container\"> <input id=\"cardNumber\" name=\"cardNumber\" type=\"text\" ng-model=\"$ctrl.user.newPayment.cardNumber\" ng-keypress=\"$ctrl.setCardInfo(signupForm.cardNumber.$ccEagerType)\" cc-number cc-eager-type cc-format required/> <span class=\"credit-card-img\" data-ng-class=\"$ctrl.card.ccClass\"></span> </div> <div class=\"v-input__errors\" ng-messages=\"signupForm.cardNumber.$error\"> <div ng-message=\"required\">{{'REGISTER.CREDITCARD_NUMBER_REQUIRED' | translate}}</div> <div ng-message=\"ccNumber\">{{'REGISTER.CREDITCARD_NUMBER_VALID' | translate}}</div> </div> </div> <div flex-xs=\"100\" flex-sm=\"100\" flex-gt-xs=\"50\"> <div layout=\"row\"> <div class=\"v-input\" flex=\"50\" ng-class=\"$ctrl.inputNeedsAttention(signupForm.expiration)\"> <label for=\"expiration\">{{'REGISTER.CREDITCARD_EXP_LABEL' | translate}} *</label> <input id=\"expiration\" name=\"expiration\" data-ng-model=\"$ctrl.user.newPayment.expiration\" payments-format=\"expiry\" payments-validate=\"expiry\" required/> <div class=\"v-input__errors\" ng-messages=\"signupForm.expiration.$error\"> <div ng-message=\"required\">{{'REGISTER.CREDITCARD_EXP_REQUIRED' | translate}}</div> <div ng-message=\"expiry\">{{'REGISTER.CREDITCARD_EXP_VALID' | translate}}</div> </div> </div> <div class=\"v-input\" flex=\"50\" ng-class=\"$ctrl.inputNeedsAttention(signupForm.cvv)\"> <label for=\"cvv\">{{'REGISTER.CREDITCARD_CVV_LABEL' | translate}} *</label> <input id=\"cvv\" name=\"cvv\" data-ng-model=\"$ctrl.user.newPayment.cvv\" required cc-cvc/> <div class=\"v-input__errors\" ng-messages=\"signupForm.cvv.$error\"> <div ng-message=\"required\">{{'REGISTER.CREDITCARD_CVV_REQUIRED' | translate}}</div> <div ng-message=\"ccCvc\">{{'REGISTER.CREDITCARD_CVV_VALID' | translate}}</div> </div> </div> </div> </div> </div> <google-autocomplete model=\"$ctrl.user.billingAddress\" country=\"$ctrl.user.billingAddress.country\" autocomplete-countries=\"$ctrl.AUTOCOMPLETE_COUNTRIES\" form-controller=\"signupForm\"> <div layout-xs=\"column\" layout-gt-xs=\"row\"> <div class=\"v-input\" flex ng-class=\"$ctrl.inputNeedsAttention(signupForm.address1)\"> <label for=\"address1\">{{'ADDRESS.BILLINGADDRESS' | translate}} *</label> <input id=\"address1\" name=\"address1\" ng-model=\"$ctrl.user.billingAddress.address1\" google-maps-autocomplete-input autocomplete=\"address-line1\" type=\"text\" maxlength=\"75\" required/> </div> </div> <div layout-xs=\"column\" layout-gt-xs=\"row\" flex=\"100\"> <div class=\"v-input\" flex=\"40\"> <label for=\"city\">{{'ADDRESS.CITY' | translate}} *</label> <input id=\"city\" name=\"city\" ng-model=\"$ctrl.user.billingAddress.city\" autocomplete=\"address-level2\" type=\"text\" maxlength=\"35\" required/> </div> <div class=\"v-input\"> <label for=\"state\">{{'ADDRESS.STATE' | translate}} *</label> <select name=\"state\" ng-model=\"$ctrl.user.billingAddress.state\" autocomplete=\"address-level1\" maxlength=\"30\"> <option ng-repeat=\"(key,val) in $ctrl.STATES_US\" value=\"{{key}}\"> {{val}} </option> </select> </div> <div class=\"v-input\" flex=\"30\"> <label for=\"postalCode\">{{'ADDRESS.POSTALCODE' | translate}} *</label> <input id=\"postalCode\" name=\"postalCode\" ng-model=\"$ctrl.user.billingAddress.postalCode\" autocomplete=\"postal-code\" type=\"text\" maxlength=\"30\" required/> </div> </div> </google-autocomplete> </div> <div layout=\"column\" class=\"coupon-code\" ng-if=\"$ctrl.showCouponField\"> <a ng-click=\"$ctrl.showCouponCodeInput = true\" ng-if=\"!$ctrl.showCouponCodeInput\" class=\"coupon-code__toggle\">{{'CHECKOUTSIGNUP.HAVE_A_COUPON' | translate}}</a> <div class=\"v-input\" flex ng-class=\"$ctrl.inputNeedsAttention(signupForm.couponCode)\" ng-if=\"$ctrl.showCouponCodeInput\"> <div layout=\"row\"> <div flex> <label for=\"couponCode\">{{'CHECKOUTSIGNUP.COUPON_INPUT_LABEL' | translate}}</label> <input id=\"couponCode\" name=\"couponCode\" ng-model=\"$ctrl.user.couponCode\" ng-change=\"$ctrl.onCouponCodeChanged()\" type=\"text\" maxlength=\"100\" ng-disabled=\"$ctrl.couponData\"/> <div class=\"v-input__errors\" ng-messages=\"signupForm.couponCode.$error\"> <div ng-message=\"couponValid\">{{'CHECKOUTSIGNUP.COUPON_NOT_VALID' | translate}}</div> </div> </div> <md-button class=\"md-raised coupon-code__apply\" ng-click=\"$ctrl.clearCoupon()\" ng-if=\"$ctrl.couponData\"> {{'CHECKOUTSIGNUP.COUPON_CLEAR' | translate}} </md-button> <md-button class=\"md-raised coupon-code__apply\" ng-click=\"$ctrl.validateCoupon($ctrl.user.couponCode)\" ng-disabled=\"!$ctrl.user.couponCode || $ctrl.user.couponCode === ''\" ng-if=\"!$ctrl.couponData\"> <span ng-if=\"!$ctrl.applyingCouponCode\">{{'CHECKOUTSIGNUP.COUPON_APPLY' | translate}}</span> <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-if=\"$ctrl.applyingCouponCode\"></md-progress-circular> </md-button> </div> </div> </div> </div> </div> ";

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutThankYouModule = void 0;

var _thankYou = _interopRequireDefault(__webpack_require__(1307));

__webpack_require__(1308);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutThankYouModule = angular.module('app.components.checkout.components.checkoutThankYou', []).component('checkoutThankYou', {
  template: _thankYou.default,
  bindings: {
    onExitCheckout: '&',
    user: '<'
  }
}).name;
exports.CheckoutThankYouModule = CheckoutThankYouModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-thank-you\"> <checkout-user-info user=\"$ctrl.user\" purchase-complete=\"true\" show-container=\"true\"></checkout-user-info> </div> ";

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutUserInfoModule = void 0;

var _userInfo = _interopRequireDefault(__webpack_require__(1310));

__webpack_require__(1311);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutUserInfoModule = angular.module('app.components.checkout.components.checkoutUserInfo', []).component('checkoutUserInfo', {
  template: _userInfo.default,
  bindings: {
    user: '<',
    showContainer: '<',
    onPaymentMethodSelected: '<',
    purchaseComplete: '<',
    onToggleEditMode: '<'
  }
}).name;
exports.CheckoutUserInfoModule = CheckoutUserInfoModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-user-info\" ng-class=\"{'checkout-user-info--show-container': $ctrl.showContainer}\"> <div class=\"checkout-user-info__section\"> <div class=\"checkout-user-info__title\" translate=\"CHECKOUTCONTACTINFO.CONTACTINFO\"></div> <div class=\"checkout-user-info__data\"> <div class=\"checkout-user-info__name\">{{$ctrl.user.contact.firstName}} {{$ctrl.user.contact.lastName}}</div> <div class=\"checkout-user-info__email\">{{$ctrl.user.account.email}}</div> <div class=\"checkout-user-info__phone\">{{$ctrl.user.contact.phoneNumber | phone}}</div> </div> </div> <div class=\"checkout-user-info__section\"> <div class=\"checkout-user-info__title\" translate=\"CHECKOUTCONTACTINFO.PAYMENTMETHOD\"></div> <div class=\"checkout-user-info__subtext\">This payment method will be charged for all recurring charges and will be linked to your store for any future purchases.</div> <payment-method-selector ng-if=\"$ctrl.user.payment\" payment=\"$ctrl.user.payment\" on-payment-selected=\"$ctrl.onPaymentMethodSelected\" on-toggle-edit-mode=\"$ctrl.onToggleEditMode\" purchase-complete=\"$ctrl.purchaseComplete\"></payment-method-selector> <md-progress-circular indeterminate=\"true\" md-diameter=\"30\" ng-if=\"!$ctrl.user.payment\"></md-progress-circular> </div> </div> ";

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentMethodModule = void 0;

var _creditCard = __webpack_require__(164);

__webpack_require__(596);

var _constants = __webpack_require__(24);

var _paymentMethodSelector = _interopRequireDefault(__webpack_require__(1313));

__webpack_require__(1314);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PaymentMethodModule = angular.module('app.components.checkout.components.paymentMethodSelector', [_creditCard.CreditCardServiceModule, 'ngMaterial']).component('paymentMethodSelector', {
  template: _paymentMethodSelector.default,
  bindings: {
    payment: '<',
    purchaseComplete: '<',
    onPaymentSelected: '<',
    onToggleEditMode: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    PaymentMethodCtrl.$inject = ["$scope", "$window", "creditCardService"];

    function PaymentMethodCtrl($scope, $window, creditCardService) {
      'ngInject';

      _classCallCheck(this, PaymentMethodCtrl);

      angular.extend(this, {
        $scope: $scope,
        $window: $window,
        creditCardService: creditCardService,
        paymentOptions: [],
        supportsMultiplePayments: false,
        STRIPE_ELEMENTS_APPLE_PAY: _constants.STRIPE_ELEMENTS_APPLE_PAY,
        STRIPE_ELEMENTS_GOOGLE_PAY: _constants.STRIPE_ELEMENTS_GOOGLE_PAY
      });
    }

    _createClass(PaymentMethodCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.creditCardService.canUsePaymentRequestAPI().then(function (isPaymentRequestAPISupported) {
          if (isPaymentRequestAPISupported) {
            _this.updateStateWithMobilePaymentOption();
          } else if (!_this.isSavedPaymentValid()) {
            _this.onToggleEditMode();
          }

          _this.$scope.$apply();
        });
      }
    }, {
      key: "updateStateWithMobilePaymentOption",
      value: function updateStateWithMobilePaymentOption() {
        this.supportsMultiplePayments = true;
        this.paymentOption = this.getPaymentOptionDisplayName();
        this.paymentOptions.push({
          name: this.getPaymentOptionDisplayName()
        });
        this.onPaymentOptionSelected(this.paymentOption);
      }
    }, {
      key: "onPaymentOptionSelected",
      value: function onPaymentOptionSelected(selectedPayment) {
        if (!this.isSavedPaymentValid() && this.paymentOption === 'card') {
          this.onToggleEditMode();
        }

        this.onPaymentSelected(selectedPayment);
      }
    }, {
      key: "isSavedPaymentValid",
      value: function isSavedPaymentValid() {
        return this.payment !== undefined && this.payment !== null && this.payment.brand !== undefined && this.payment.brand !== null;
      }
    }, {
      key: "getPaymentOptionDisplayName",
      value: function getPaymentOptionDisplayName() {
        if (this.isCurrentBrowserChrome()) {
          return _constants.STRIPE_ELEMENTS_GOOGLE_PAY;
        }

        return _constants.STRIPE_ELEMENTS_APPLE_PAY;
      }
    }, {
      key: "isCurrentBrowserChrome",
      value: function isCurrentBrowserChrome() {
        return this.$window.navigator.userAgent.includes('Chrome');
      }
    }]);

    return PaymentMethodCtrl;
  }()
}).name;
exports.PaymentMethodModule = PaymentMethodModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

module.exports = "<div class=\"payment-method\"> <div ng-if=\"$ctrl.supportsMultiplePayments && !$ctrl.purchaseComplete\" class=\"payment-method__payment-options\"> <md-radio-group ng-model=\"$ctrl.paymentOption\" ng-change=\"$ctrl.onPaymentOptionSelected($ctrl.paymentOption)\"> <div class=\"payment-method__credit-cart-option\"> <div class=\"payment-method__payment-option\"> <md-radio-button class=\"payment-method__payment-radio-button\" value=\"card\"> Credit Card </md-radio-button> <div class=\"payment-method__image-container\"> <div class=\"payment-method__image-small\"> <span class=\"credit-card-img credit-card-img--visa\"></span> </div> <div class=\"payment-method__image-small\"> <span class=\"credit-card-img credit-card-img--mastercard\"></span> </div> <div class=\"payment-method__image-small\"> <span class=\"credit-card-img credit-card-img--amex\"></span> </div> <div class=\"payment-method__image-small\"> <span class=\"credit-card-img credit-card-img--discover\"></span> </div> </div> </div> <card-info ng-show=\"$ctrl.isSavedPaymentValid() && $ctrl.paymentOption === 'card'\" class=\"checkout-user-info__data\" brand=\"$ctrl.payment.brand\" last-four=\"$ctrl.payment.lastFour\" expiration=\"$ctrl.payment.expiration\"> </card-info> </div> <div class=\"payment-method__divider\"></div> <div class=\"payment-method__payment-option\" ng-repeat=\"paymentOption in $ctrl.paymentOptions\"> <md-radio-button class=\"payment-method__payment-radio-button\" ng-value=\"paymentOption.name\"> {{paymentOption.name}} </md-radio-button> <div class=\"payment-method__image\"> <img ng-if=\"paymentOption.name === $ctrl.STRIPE_ELEMENTS_APPLE_PAY\" src=\"/assets/Apple_Pay_logo.svg\" alt=\"ApplePay\" class=\"credit-card-img\"/> <img ng-if=\"paymentOption.name === $ctrl.STRIPE_ELEMENTS_GOOGLE_PAY\" src=\"/assets/GPay+Brand+Mark.svg\" alt=\"GooglePay\" class=\"credit-card-img\"/> </div> </div> </md-radio-group> </div> <div ng-if=\"!$ctrl.supportsMultiplePayments || $ctrl.purchaseComplete\"> <card-info class=\"checkout-user-info__data\" brand=\"$ctrl.payment.brand\" last-four=\"$ctrl.payment.lastFour\" expiration=\"$ctrl.payment.expiration\"> </card-info> </div> </div> ";

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout\" md-theme=\"{{$ctrl.materialTheme || 'checkout'}}\"> <div class=\"checkout__header checkout-header\" layout=\"column\"> <md-button ng-click=\"$ctrl.backToMarketing()\" ng-if=\"!$ctrl.purchaseComplete && !$ctrl.hideBackButton\"> <md-icon>arrow_back</md-icon> <span translate=\"CHECKOUT.CHOOSEMOREOPTIONS\"></span> </md-button> <div> <img class=\"checkout-header__logo\" ng-src=\"{{$ctrl.LOGO_URL}}\" height=\"30px\"> </div> <span ng-if=\"!$ctrl.user.isLoggedIn && !$ctrl.purchaseComplete\" translate=\"CHECKOUT.SUCCESSISASTEPAWAY\"></span> <span ng-if=\"$ctrl.user.isLoggedIn && !$ctrl.purchaseComplete\" translate=\"CHECKOUT.LASTSTEP\" translate-values=\"{ FIRST_NAME: $ctrl.user.contact.firstName }\"></span> <span ng-if=\"$ctrl.purchaseComplete\" translate=\"CHECKOUT.THANKYOU\" translate-values=\"{ FIRST_NAME: $ctrl.user.contact.firstName }\"></span> <md-button ng-if=\"$ctrl.purchaseComplete\" class=\"md-accent md-raised checkout-rounded-button checkout-header__exit-button\" ng-click=\"$ctrl._onExitCheckout()\"> <span translate=\"CHECKOUTTHANKYOU.CONTINUEBUTTON\"></span> <md-icon>arrow_forward</md-icon> </md-button> </div> <md-progress-circular class=\"md-accent checkout__loading\" ng-if=\"$ctrl.loading\" md-diameter=\"60\" md-mode=\"indeterminate\"> </md-progress-circular> <div class=\"checkout__body\" layout-xs=\"column\" layout-gt-xs=\"row\" ng-form=\"signupForm\" ng-if=\"!$ctrl.loading\"> <div flex-xs=\"100\" flex-sm=\"55\" flex-gt-sm=\"65\" class=\"checkout__body-col\"> <checkout-thank-you ng-if=\"$ctrl.purchaseComplete\" on-exit-checkout=\"$ctrl._onExitCheckout()\" user=\"$ctrl.user\"> </checkout-thank-you> <checkout-account-form ng-if=\"!$ctrl.purchaseComplete\" cart=\"$ctrl.cart\" user=\"$ctrl.user\" has-account=\"$ctrl.hasAccount\" on-signup-form-validity-change=\"$ctrl.onSignupFormValidityChange(isValid)\" coupon=\"$ctrl.coupon\" coupon-code=\"$ctrl.couponCode\" on-coupon-entered=\"$ctrl.onCouponEntered(coupon)\" on-logout=\"$ctrl.onLogout()\" show-coupon-field=\"$ctrl.showCouponCodeField\" on-payment-method-selected=\"$ctrl.onPaymentMethodSelected\"> </checkout-account-form> <checkout-info hide-xs ng-if=\"(!$ctrl.isModal || $ctrl.isTrial) && !$ctrl.showAlternate\"></checkout-info> <div ng-if=\"$ctrl.showAlternate\" layout=\"row\" hide-xs layout-align=\"center center\" class=\"checkout__guarantee\"> <img src=\"/assets/volusion-guarantee.svg\" width=\"136\"> <div layout=\"column\" layout-align=\"center center\" layout-align-gt-xs=\"center start\"> <h3><md-icon>favorite</md-icon> Our Commitment to You</h3> <h2>30-Day Guarantee</h2> <p> At Volusion we focus on creating exceptional ecommerce solutions. If you are not 100% satisfied within the first 30 days, just contact us to receive a full refund. </p> </div> </div> </div> <div flex-xs=\"100\" flex-sm=\"45\" flex-gt-sm=\"35\" class=\"checkout__body-col\"> <checkout-order-summary cart=\"$ctrl.cart\" user=\"$ctrl.user\" expire-trial-in-five-minutes=\"$ctrl.expireTrialInFiveMinutes\" can-place-order=\"$ctrl.isSignupFormValid\" trial-days-remaining=\"$ctrl.trialDaysRemaining\" on-purchase-complete=\"$ctrl._onPurchaseComplete()\" selected-payment-method=\"$ctrl.selectedPaymentMethod\" coupon=\"$ctrl.coupon\" require-recaptcha=\"!$ctrl.user.isLoggedIn\"> </checkout-order-summary> <checkout-help ng-if=\"!$ctrl.isModal || $ctrl.isTrial\"></checkout-help> </div> </div> </div> ";

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HubspotServiceModule = void 0;

var _angularJwt = _interopRequireDefault(__webpack_require__(167));

var _authToken = __webpack_require__(43);

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HubspotServiceModule = angular.module('app.services.data.hubspotService', [_angularJwt.default, _settings.AppSettingsModule, _authToken.AuthTokenServiceModule, _data.DataServiceModule]).service('hubspotService',
/*#__PURE__*/
function () {
  HubspotService.$inject = ["$http", "$log", "$q", "$timeout", "$window", "authTokenService", "jwtHelper", "settings", "dataService"];

  function HubspotService($http, $log, $q, $timeout, $window, authTokenService, jwtHelper, settings, dataService) {
    'ngInject';

    _classCallCheck(this, HubspotService);

    angular.extend(this, {
      $http: $http,
      $log: $log,
      $q: $q,
      $timeout: $timeout,
      $window: $window,
      authTokenService: authTokenService,
      jwtHelper: jwtHelper,
      settings: settings,
      dataService: dataService
    });
  }

  _createClass(HubspotService, [{
    key: "getTokenFromLocalStorage",
    value: function getTokenFromLocalStorage() {
      if (this.$window.localStorage.getItem('hubspotToken') !== null) {
        var tokenResponseJson = this.$window.localStorage.getItem('hubspotToken');
        return JSON.parse(tokenResponseJson);
      }
    }
  }, {
    key: "setTokenIntoLocalStorage",
    value: function setTokenIntoLocalStorage(tokenResponse) {
      this.$window.localStorage.setItem('hubspotToken', JSON.stringify(tokenResponse));
    }
  }, {
    key: "removeTokenFromLocalStorage",
    value: function removeTokenFromLocalStorage() {
      this.$window.localStorage.removeItem('hubspotToken');
    }
  }, {
    key: "isTokenValid",
    value: function isTokenValid(token) {
      var _this = this;

      var isExpired = this.jwtHelper.isTokenExpired(token);

      if (isExpired) {
        this.removeTokenFromLocalStorage();
        return this.$q.resolve(false);
      }

      return this.authTokenService.getEmail().then(function (email) {
        var decoded = _this.jwtHelper.decodeToken(token);

        if (decoded.sub !== email) {
          _this.removeTokenFromLocalStorage();

          return false;
        }

        return true;
      });
    }
  }, {
    key: "createToken",
    value: function createToken() {
      var _this2 = this;

      return this.dataService.create(this.settings.api.hubspotToken).then(function (tokenResponse) {
        _this2.setTokenIntoLocalStorage(tokenResponse);

        return tokenResponse;
      });
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var _this3 = this;

      var cachedTokenResponse = this.getTokenFromLocalStorage();

      if (cachedTokenResponse && cachedTokenResponse.token) {
        return this.isTokenValid(cachedTokenResponse.token).then(function (tokenIsValid) {
          if (tokenIsValid) {
            return cachedTokenResponse;
          }

          return _this3.createToken();
        });
      }

      return this.createToken();
    }
  }, {
    key: "loadChatWidget",
    value: function loadChatWidget() {
      var _this4 = this;

      return this.getToken().then(function (tokenResponse) {
        if (_this4.$window.hsConversationsSettings) {
          _this4.$window.hsConversationsSettings = {
            identificationEmail: tokenResponse.email,
            identificationToken: tokenResponse.token
          };

          if (_this4.$window.HubSpotConversations && _this4.$window.HubSpotConversations.widget) {
            var status = _this4.$window.HubSpotConversations.widget.status();

            if (status) {
              if (status.loaded) {
                _this4.$window.HubSpotConversations.widget.refresh();
              } else {
                _this4.$window.HubSpotConversations.widget.load();
              }
            }
          }
        }
      }).catch(function (err) {
        _this4.$log.error('Cannot identify visitor with Hubspot, error creating token:', err);

        if (_this4.$window.HubSpotConversations && _this4.$window.HubSpotConversations.widget) {
          _this4.$window.HubSpotConversations.widget.remove();
        }
      });
    }
  }]);

  return HubspotService;
}()).name;
exports.HubspotServiceModule = HubspotServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiscountsAnalyticsServiceModule = void 0;

var _countBy = _interopRequireDefault(__webpack_require__(1325));

var _keys = _interopRequireDefault(__webpack_require__(62));

var _map = _interopRequireDefault(__webpack_require__(75));

var _join = _interopRequireDefault(__webpack_require__(1328));

var _toPairs = _interopRequireDefault(__webpack_require__(1329));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscountsAnalyticsServiceModule = angular.module('app.services.data.discountsAnalyticsService', []).service('discountsAnalyticsService', ["$window", function ($window) {
  return {
    sendDiscountCreateEvent: sendDiscountCreateEvent,
    sendDiscountUpdateEvent: sendDiscountUpdateEvent
  };

  function getScopeAppliesTo(discount) {
    var _discount$scope = discount.scope,
        scope = _discount$scope === void 0 ? {
      entireStore: true,
      items: []
    } : _discount$scope;

    if (scope.entireStore === true) {
      return 'entire store';
    }

    var groupedItems = (0, _countBy.default)(scope.items, 'type');
    var groupedItemKeys = (0, _keys.default)(groupedItems);
    var mapped = (0, _map.default)(groupedItemKeys, function (key) {
      return "".concat(groupedItems[key], " ").concat(key);
    });
    return (0, _join.default)(mapped, ' and ');
  }

  function getDiscountAmount(discount) {
    return isDiscountTypeFixed(discount) ? "$".concat(discount.fixedPriceReduction) : "".concat(discount.percentagePriceReduction, "%");
  }

  function getDiscountOfferType(discount) {
    return isDiscountTypeFixed(discount) ? 'dollar' : 'percent';
  }

  function isDiscountTypeFixed(discount) {
    return discount.discountType === 'fixed';
  }

  function convertObjectToString(obj) {
    return (0, _toPairs.default)(obj).map(function (pair) {
      return pair.join(':');
    }).join(',');
  }

  function getDiscountUses(discount) {
    return discount.unlimited ? 'Unlimited' : discount.usageLimit;
  }

  function sendDiscountCreateEvent() {
    var discount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var discountObject = {
      type: 'create',
      date: encodeURIComponent(discount.createdOn),
      active: discount.isActive,
      discountCode: discount.code,
      status: discount.status.text,
      discountId: discount.id,
      discountLabel: discount.name,
      offerType: getDiscountOfferType(discount),
      amount: getDiscountAmount(discount),
      appliedTo: getScopeAppliesTo(discount),
      duration: discount.duration,
      uses: getDiscountUses(discount)
    };
    var discountCreatedEvent = {
      event: 'discount',
      discount_id: discount.id,
      discount: convertObjectToString(discountObject)
    };
    $window.dataLayer.push(discountCreatedEvent);
  }

  function sendDiscountUpdateEvent(discount) {
    var discountObject = {
      type: 'update',
      date: encodeURIComponent(discount.updatedOn),
      active: discount.isActive,
      discountCode: discount.code,
      status: discount.status.text,
      discountId: discount.id,
      discountLabel: discount.name,
      offerType: getDiscountOfferType(discount),
      amount: getDiscountAmount(discount),
      appliedTo: getScopeAppliesTo(discount),
      duration: discount.duration,
      uses: getDiscountUses(discount)
    };
    var discountUpdatedEvent = {
      event: 'discount',
      discount_id: discount.id,
      discount: convertObjectToString(discountObject)
    };
    $window.dataLayer.push(discountUpdatedEvent);
  }
}]).name;
exports.DiscountsAnalyticsServiceModule = DiscountsAnalyticsServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerifyEmailReminderModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _model = __webpack_require__(251);

var _myAccount = __webpack_require__(84);

var _verifyEmailReminder = _interopRequireDefault(__webpack_require__(1351));

__webpack_require__(1352);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VerifyEmailReminderModule = angular.module('app.components.verifyEmailReminder', [_angularTranslate.default, 'ngMaterial', _model.ModelModule, _myAccount.MyAccountServiceModule]).component('verifyEmailReminder', {
  template: _verifyEmailReminder.default,
  controller:
  /*#__PURE__*/
  function () {
    VerifyEmailReminderController.$inject = ["$scope", "$translate", "$q", "$mdToast", "$mdDialog", "myAccountService", "modelService"];

    function VerifyEmailReminderController($scope, $translate, $q, $mdToast, $mdDialog, myAccountService, modelService) {
      _classCallCheck(this, VerifyEmailReminderController);

      (0, _assign.default)(this, {
        loading: false,
        user: {},
        $scope: $scope,
        $translate: $translate,
        $q: $q,
        $mdToast: $mdToast,
        $mdDialog: $mdDialog,
        myAccountService: myAccountService,
        modelService: modelService
      });
    }

    _createClass(VerifyEmailReminderController, [{
      key: "$onInit",
      value: function $onInit() {
        this.getUser();
      }
    }, {
      key: "getUser",
      value: function getUser() {
        var _this = this;

        this.myAccountService.getUser().then(function (response) {
          _this.user = _this.modelService.makeModel(response, 'userModel');
        });
      }
    }, {
      key: "resend",
      value: function resend() {
        this.myAccountService.resendVerification(this.user);
        this.presentEmailSentModal();
      }
    }, {
      key: "dismiss",
      value: function dismiss() {
        this.$mdToast.hide();
      }
    }, {
      key: "presentEmailSentModal",
      value: function presentEmailSentModal() {
        var _this2 = this;

        this.$q.all([this.$translate('NOTIFICATION.RESENT'), this.$translate('ONBOARDING.VERIFICATION_EMAIL_TOAST')]).then(function (translations) {
          _this2.$mdDialog.show(_this2.$mdDialog.alert().title(translations[0]).textContent(translations[1]).ok('Ok').clickOutsideToClose(true));
        });
      }
    }]);

    return VerifyEmailReminderController;
  }()
}).name;
exports.VerifyEmailReminderModule = VerifyEmailReminderModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModelsModule = void 0;

var _category = __webpack_require__(1335);

var _customer = __webpack_require__(1336);

var _discounts = __webpack_require__(1337);

var _fulfiller = __webpack_require__(1338);

var _imageMetadata = __webpack_require__(1339);

var _orders = __webpack_require__(1340);

var _pages = __webpack_require__(1341);

var _postageDefaults = __webpack_require__(1342);

var _products = __webpack_require__(1343);

var _shippingMethods = __webpack_require__(1344);

var _storeInformation = __webpack_require__(1345);

var _themeStyles = __webpack_require__(1346);

var _user = __webpack_require__(1347);

var _variant = __webpack_require__(1348);

var _address = __webpack_require__(1349);

var _volusionPaymentsKYC = __webpack_require__(1350);

var ModelsModule = angular.module('app.components.model.models', [_address.AddressModelModule, _category.CategoryModelModule, _customer.CustomerModelModule, _discounts.DiscountsModelModule, _fulfiller.FulfillerModelModule, _imageMetadata.ImageMetadataModelModule, _orders.OrderModelModule, _pages.PagesModelModule, _postageDefaults.PostageDefaultsModelModule, _products.ProductsModelModule, _shippingMethods.ShippingMethodsModelModule, _storeInformation.StoreInformationModelModule, _themeStyles.ThemeStylesModelModule, _user.UserModelModule, _variant.VariantModelModule, _volusionPaymentsKYC.VolusionPaymentsKYCModelModule]).name;
exports.ModelsModule = ModelsModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryModelModule = void 0;
var CategoryModelModule = angular.module('app.services.model.models.category', []).value('categoryModel', {
  categoryId: 'Number',
  name: 'String',
  seo: {
    title: 'String',
    metaDescription: 'String',
    friendlyName: 'String'
  },
  contentPageId: ['String', null],
  descriptions: {
    long: 'String',
    short: 'String',
    extended: 'String'
  },
  state: ['String', 'Active'],
  parentId: 'String',
  isInMenu: 'Boolean',
  images: 'Array',
  productIds: 'Array',
  productCount: 'Number',
  subCategories: 'Array'
}).name;
exports.CategoryModelModule = CategoryModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerModelModule = void 0;
var CustomerModelModule = angular.module('app.services.model.models.customer', []).value('customerModel', {
  contactInformation: {
    firstName: 'String',
    lastName: 'String',
    phoneNumber: 'String',
    address: 'String'
  },
  merchantNote: 'String',
  tags: 'Array',
  emailAddress: 'String',
  firstName: 'String',
  lastName: 'String',
  company: 'String',
  phoneNumber: 'String',
  revision: 'Number',
  textMessageOptIn: 'Boolean',
  emailOptIn: 'Boolean',
  auditLogId: 'String',
  orderCount: 'Number',
  ordersTotalPrice: 'Number',
  averageOrderPrice: 'Number',
  isRepeat: 'Boolean',
  marketToCustomer: ['Boolean', true],
  tenant: 'String',
  avalaraEntityUseCode: 'String'
}).name;
exports.CustomerModelModule = CustomerModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiscountsModelModule = void 0;
var DiscountsModelModule = angular.module('app.services.model.models.discounts', []).value('discountModel', {
  code: 'String',
  createdOn: 'String',
  criteria: {
    couponCode: 'String',
    maximumPurchaseQuantity: 'Number',
    minimumPurchaseQuantity: 'Number',
    requiresCouponCode: ['Boolean', true]
  },
  currentUsageCount: ['Number', 0],
  customerUsageLimit: 'Number',
  discountType: 'String',
  endDateTime: 'String',
  fixedPriceReduction: 'Number',
  hasEndDateTime: 'Boolean',
  hasStartDateTime: 'Boolean',
  id: 'String',
  isActive: ['Boolean', true],
  isHidden: 'Boolean',
  isLimitedPerCustomer: 'Boolean',
  percentagePriceReduction: 'Number',
  revision: 'Number',
  scope: {
    entireStore: 'Boolean',
    items: 'Array'
  },
  startDateTime: 'String',
  tenant: 'String',
  totalUsageCount: ['Number', 0],
  unlimited: 'Boolean',
  unlimitedDuration: 'Boolean',
  updatedOn: 'String',
  usageLimit: 'Number'
}).name;
exports.DiscountsModelModule = DiscountsModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FulfillerModelModule = void 0;
var FulfillerModelModule = angular.module('app.services.model.models.fulfiller', []).value('fulfillerModel', {
  name: 'String',
  id: 'String',
  email_contact: 'String',
  email_order: 'String',
  method: 'String',
  redirectUrl: 'String',
  redirectAppKey: 'String',
  phoneNumber: 'String',
  hasPhysicalAddress: 'Boolean',
  physicalAddress: {
    address1: 'String',
    address2: 'String',
    city: 'String',
    state: 'String',
    postalCode: 'String'
  },
  productCount: 'Number'
}).name;
exports.FulfillerModelModule = FulfillerModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageMetadataModelModule = void 0;
var ImageMetadataModelModule = angular.module('app.services.model.models.imageMetadata', []).value('imageMetadataModel', {
  imageLink: 'any',
  description: 'String',
  altText: 'String',
  title: 'String'
}).name;
exports.ImageMetadataModelModule = ImageMetadataModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderModelModule = void 0;
var OrderModelModule = angular.module('app.services.model.models.orderModel', []).value('orderModel', {
  orderNumber: 'Number',
  taxRate: 'Number',
  taxAmount: 'Number',
  grandTotal: 'Number',
  refundedAmount: 'Number',
  paymentMethod: 'String',
  paymentSource: 'String',
  creditCardType: 'String',
  creditCardLastFour: 'String',
  shopperNote: 'String',
  merchantNote: 'String',
  placedBy: {
    firstName: 'String',
    lastName: 'String',
    emailAddress: 'String',
    phoneNumber: 'String',
    address: 'String',
    emailOptIn: 'Boolean'
  },
  cart: {
    items: 'Array',
    totalItems: 'Number',
    total: 'Number',
    taxRate: 'Number',
    taxAmount: 'Number',
    grandTotal: 'Number',
    revision: 'Number',
    shippingMethod: {
      name: 'String',
      shippingBand: {
        totalThreshold: 'Number',
        shippingPrice: 'Number'
      },
      shippingCost: 'Number'
    },
    postalCode: 'String',
    state: 'String',
    country: 'String'
  },
  deliverTo: {
    firstName: 'String',
    lastName: 'String',
    address: 'String',
    isResidential: 'Boolean'
  },
  shipped: ['Boolean', false],
  paid: ['Boolean', false],
  status: 'String',
  revision: 'Number',
  isCanceled: ['Boolean', false],
  isRefunded: ['Boolean', false],
  auditLogId: 'String',
  customerId: 'String',
  trackingInformation: {
    carrier: 'String',
    number: 'String'
  },
  stripeChargeId: 'String',
  stripeRefunds: 'Array',
  stripeEvents: 'Array',
  payPalEvents: 'Array',
  payPalPaymentCustomId: 'String',
  paymentLifecycle: 'Array',
  purchaseOrderNumber: 'String',
  fulfillmentLifecycle: 'Array',
  tenant: 'String',
  isImport: ['Boolean', false],
  paymentRequests: 'Array'
}).name;
exports.OrderModelModule = OrderModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PagesModelModule = void 0;
var PagesModelModule = angular.module('app.services.model.models.pagesModel', []).value('pagesModel', {
  name: 'String',
  content: 'String',
  revision: 'Number',
  seo: {
    title: 'String',
    metaDescription: 'String',
    friendlyName: 'String',
    modifier: 'String'
  },
  isActive: ['Boolean', true],
  tenant: 'String'
}).name;
exports.PagesModelModule = PagesModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostageDefaultsModelModule = void 0;
var PostageDefaultsModelModule = angular.module('app.services.model.models.postageDefaultsModel', []).value('postageDefaultsModel', {
  revision: 'Number',
  tenant: 'String',
  materialPackageSize: {
    length: 'Number',
    width: 'Number',
    height: 'Number',
    name: 'String'
  },
  defaultId: 'String',
  hasReturnLabel: 'Boolean',
  labelType: 'String',
  handlingTime: 'Number'
}).name;
exports.PostageDefaultsModelModule = PostageDefaultsModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductsModelModule = void 0;
var ProductsModelModule = angular.module('app.services.model.models.productModel', []).value('productModel', {
  availability: {
    preOrder: {
      enabled: ['Boolean', false]
    },
    message: ['String', null]
  },
  name: 'String',
  price: 'Number',
  pricing: {
    listPrice: 'Number',
    salePrice: 'Number'
  },
  msrp: 'Number',
  descriptions: {
    long: 'String',
    short: 'String',
    extended: 'String'
  },
  weight: 'Number',
  state: ['String', 'Active'],
  categoryIds: 'Array',
  contentPageId: ['String', null],
  seo: {
    title: 'String',
    metaDescription: 'String',
    friendlyName: 'String'
  },
  images: 'Array',
  revision: 'Number',
  sku: 'String',
  tenant: 'String',
  variantOptions: 'Array',
  productVariants: 'Array',
  requiresShipping: ['Boolean', true],
  isTaxable: ['Boolean', true],
  relatedProductIds: 'Array',
  taxCode: 'String'
}).name;
exports.ProductsModelModule = ProductsModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShippingMethodsModelModule = void 0;
var ShippingMethodsModelModule = angular.module('app.services.model.models.shippingMethodsModel', []).value('shippingMethodsModel', {
  id: 'String',
  createdOn: ['String', undefined],
  updatedOn: ['String', undefined],
  name: 'String',
  shippingBand: {
    totalThreshold: 'Number',
    shippingPrice: 'Number'
  },
  shippingBands: {
    byPrice: {
      enabled: 'Boolean',
      bands: 'Array'
    },
    byWeight: {
      enabled: 'Boolean',
      bands: 'Array'
    },
    free: {
      enabled: 'Boolean',
      deliveryEstimate: 'String',
      priceThreshold: 'any',
      shippingZones: {
        exclude: 'Array'
      }
    },
    curbside: {
      enabled: 'Boolean',
      pickupAddress: {
        address1: ['String', undefined],
        address2: ['String', undefined],
        city: ['String', undefined],
        state: ['String', undefined],
        postalCode: ['String', undefined],
        phoneNumber: ['String', undefined]
      }
    }
  },
  revision: 'Number'
}).name;
exports.ShippingMethodsModelModule = ShippingMethodsModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoreInformationModelModule = void 0;
var StoreInformationModelModule = angular.module('app.services.model.models.storeInformationModel', []).value('storeInformationModel', {
  id: 'String',
  name: 'String',
  email: 'String',
  phoneNumber: 'String',
  mailingAddress: {
    address1: 'String',
    address2: 'String',
    city: 'String',
    state: 'String',
    postalCode: 'String',
    country: 'String'
  },
  logo: {
    imageLink: 'any',
    title: 'String',
    description: 'String',
    altText: 'String'
  },
  favicon: {
    imageLink: 'any',
    title: 'String',
    description: 'String',
    altText: 'String'
  },
  dashboardImage: {
    imageLink: 'any',
    title: 'String',
    description: 'String',
    altText: 'String'
  },
  storeUrl: 'String',
  urlHost: 'String',
  socialNetworks: {
    facebook: 'String',
    instagram: 'String',
    twitter: 'String',
    pinterest: 'String',
    google: 'String'
  },
  seo: {
    metaTitle: 'String',
    metaDescription: 'String',
    platformMetaTags: {
      google: 'any',
      bing: 'any',
      pinterest: 'any'
    }
  },
  revision: 'Number',
  stripeEmail: 'String',
  tenant: 'String',
  stripeAccountId: 'String',
  stripePublishableKey: 'String',
  stripeRefreshToken: 'String',
  stripeAccessToken: 'String',
  stripeUserSecretKey: 'String',
  shipsInDays: 'Number',
  shippingFees: 'Boolean',
  chargeTax: ['Boolean', true],
  taxNexus: 'String',
  launched: ['Boolean', false],
  completedLaunchRequirements: ['Boolean', false],
  launchedOn: 'String',
  stripeAccountStatus: 'String',
  acceptCashAsPayment: 'Boolean',
  termsAndConditions: {
    accepted: 'Boolean',
    acceptedBy: 'String',
    acceptedOn: 'String'
  },
  acceptApplePayBuyNowOnProductPages: 'Boolean',
  customAttributes: 'any',
  materialPlan: 'String',
  addedAtLeastOneProduct: 'Boolean',
  emailVerified: 'Boolean',
  stripeCustomerId: 'String',
  customDomain: 'String',
  paypal: {
    isEnabled: ['Boolean', false],
    merchantPayerId: 'String',
    paymentsReceivable: ['Boolean', false],
    permissions: 'Array',
    permissionsGranted: ['Boolean', false],
    prefillActionUrl: 'String',
    primaryEmailConfirmed: ['Boolean', false]
  },
  applePay: {
    isEnabled: ['Boolean', true]
  },
  authorizeNet: {
    accessToken: 'String',
    accessTokenExpiration: 'String',
    accountId: 'String',
    email: 'String',
    isAccountCreated: ['Boolean', false],
    isAccountDenied: ['Boolean', false],
    isEnabled: ['Boolean', false],
    isExistingAccount: ['Boolean', false],
    isPaymentsSignupStarted: ['Boolean', false],
    isPaymentsSignupSubmitted: ['Boolean', false],
    isStripePreferred: ['Boolean', true],
    isTestMode: ['Boolean', false],
    oauthState: 'String',
    refreshToken: 'String',
    refreshTokenExpiration: 'String',
    shouldShowConnectedMessage: ['Boolean', false],
    wasDisconnected: ['Boolean', false]
  },
  wepay: {
    accessToken: 'String',
    accountId: 'String',
    bankAccountLast4: 'String',
    bankAccountId: 'String',
    isConfirmationEmailSent: ['Boolean', false],
    isEnabled: ['Boolean', false],
    isStripePreferred: ['Boolean'],
    kycState: 'String',
    payoutSchedule: 'String',
    payoutType: ['String', 'bankAccount'],
    userState: 'String'
  },
  paymentAutoCapture: ['Boolean', false],
  createdOn: 'String',
  updatedOn: 'String',
  acceptsStripeAsPayment: 'Boolean',
  googleAnalyticsId: 'String',
  thirdPartyIntegrations: {
    adwordsConversionId: 'String',
    adwordsConversionLabel: 'String',
    fullstoryId: 'String',
    facebookTrackingPixelId: 'String',
    addThis: 'String',
    addThisEnabled: 'Boolean',
    privyId: 'String',
    chat: {
      liveChatId: 'String',
      liveChatEmail: 'String'
    },
    googleTagManagerId: 'String'
  },
  enableAddressVerification: 'Boolean'
}).name;
exports.StoreInformationModelModule = StoreInformationModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeStylesModelModule = void 0;
var ThemeStylesModelModule = angular.module('app.services.model.models.themeStyles', []).value('themeStyles', {
  selectedColorScheme: 'Number',
  selectedFontScheme: 'Number',
  colorSchemes: 'Array',
  fontSchemes: 'Array',
  editables: 'Array',
  aceModel: 'String'
}).name;
exports.ThemeStylesModelModule = ThemeStylesModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserModelModule = void 0;
var UserModelModule = angular.module('app.services.model.models.userModel', []).value('userModel', {
  firstName: 'String',
  lastName: 'String',
  phoneNumber: 'String',
  email: 'String'
}).name;
exports.UserModelModule = UserModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VariantModelModule = void 0;
var VariantModelModule = angular.module('app.services.model.models.variantModel', []).value('variantModel', {
  name: 'String',
  options: 'Array',
  priceDifferences: 'Array',
  tenant: 'String',
  revision: 'Number',
  imageLinkIds: 'Array'
}).name;
exports.VariantModelModule = VariantModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressModelModule = void 0;
var AddressModelModule = angular.module('app.services.model.models.addressModel', []).value('addressModel', {
  isPrimary: ['Boolean', false],
  mailingAddress: {
    address1: 'String',
    city: 'String',
    country: ['String', 'US'],
    postalCode: 'String',
    state: 'String'
  }
}).name;
exports.AddressModelModule = AddressModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VolusionPaymentsKYCModelModule = void 0;
var VolusionPaymentsKYCModelModule = angular.module('app.services.model.models.volusionPaymentsKYCModel', []).value('volusionPaymentsKYCModel', {
  tenant: 'String',
  subscriptionId: 'String',
  business_identity: {
    business_name: 'String',
    business_type: 'String',
    employer_id_number: 'String',
    business_website: 'String',
    business_phone: {
      country_code: ['String', '+1'],
      phone_number: 'String'
    },
    address: {
      address1: 'String',
      address2: 'String',
      city: 'String',
      postal_code: 'String',
      region: 'String',
      country: ['String', 'US']
    }
  },
  about_business: {
    business_description: 'String',
    years_in_business: 'Number',
    average_delivery: 'String',
    average_order: 'Number',
    annual_sales: 'String'
  },
  owner: {
    owner_name: {
      title: 'String',
      first: 'String',
      last: 'String'
    },
    owner_address: {
      address1: 'String',
      address2: 'String',
      city: 'String',
      postal_code: 'String',
      region: 'String',
      country: ['String', 'US']
    },
    ownership_type: 'String',
    owner_years_at_address: 'Number',
    email: 'String',
    owner_phone: {
      country_code: ['String', '+1'],
      phone_number: 'String'
    },
    date_of_birth: {
      year: 'Number',
      month: 'Number',
      day: 'Number'
    },
    social_security_number: 'String'
  },
  card_statement: {
    billing_statement_descriptor: 'String',
    customer_service_phone: {
      country_code: ['String', '+1'],
      phone_number: 'String'
    }
  },
  banking: {
    routing_number: 'String',
    account_number: 'String',
    terms_of_service: ['Boolean', false]
  }
}).name;
exports.VolusionPaymentsKYCModelModule = VolusionPaymentsKYCModelModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

module.exports = "<md-toast class=\"verify-email-reminder\"> <div class=\"md-toast-content\"> <span class=\"md-toast-text verify-email-reminder__text\" flex> <span>We sent {{$ctrl.user.email}} a verification email. Need another one?</span> </span> <md-button class=\"md-highlight verify-email-reminder__btn verify-email-reminder__btn--update\" ng-click=\"$ctrl.resend()\"> {{'NOTIFICATION.RESEND' | translate}} </md-button> <md-button class=\"verify-email-reminder__btn verify-email-reminder__btn--dismiss\" ng-click=\"$ctrl.dismiss()\"> {{'NOTIFICATION.DISMISS' | translate}} </md-button> </div> </md-toast> ";

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadBaremetricsRecoverWidget = void 0;

var _scriptLoader = __webpack_require__(1354);

var loadBaremetricsRecoverWidget = function loadBaremetricsRecoverWidget(customerId) {
  var barepay = window.document.createElement('barepay');
  window.document.body.appendChild(barepay);
  /* eslint-disable */

  (0, _scriptLoader.loadScriptTag)({
    innerContent: "!function(){if(window.barepay&&window.barepay.created)window.console&&console.error&&console.error(\"Barepay snippet included twice.\");else{window.barepay={created:!0};var a=document.createElement(\"script\");a.src=\"https://baremetrics-dunning.baremetrics.com/js/application.js\",a.async=!0;var b=document.getElementsByTagName(\"script\")[0];b.parentNode.insertBefore(a,b),window.barepay.params={access_token_id:\"2f3d6f54-11b2-4d3b-aa22-c1d023eeb3e7\",customer_oid:\"".concat(customerId, "\"}}}();")
  });
  /* eslint-enable */
};

exports.loadBaremetricsRecoverWidget = loadBaremetricsRecoverWidget;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadScriptTag = void 0;

var loadScriptTag = function loadScriptTag(options) {
  var script = window.document.createElement('script');
  if (options.innerContent) script.innerHTML = options.innerContent;
  if (options.src) script.src = options.src;
  if (options.async) script.async = true;
  window.document.body.appendChild(script);
};

exports.loadScriptTag = loadScriptTag;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPlanModule = void 0;

var _constants = __webpack_require__(24);

var _checkout = __webpack_require__(154);

var _planDetails = __webpack_require__(1356);

var _selectPlan = _interopRequireDefault(__webpack_require__(1359));

__webpack_require__(1360);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SelectPlanModule = angular.module('app.components.changePlan.selectPlan', [_checkout.CheckoutServiceModule, _planDetails.PlanDetailsModule]).component('selectPlan', {
  template: _selectPlan.default,
  bindings: {
    plans: '<',
    planSortExpression: '<',
    user: '<',
    onPlanSelected: '&',
    isTrial: '<',
    note: '<',
    hideGreeting: '<',
    showBorderOnPlans: '<',
    showAlternate: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    SelectPlanCtrl.$inject = ["checkoutService"];

    function SelectPlanCtrl(checkoutService) {
      _classCallCheck(this, SelectPlanCtrl);

      this.LOGO_URL = _constants.LOGO_URL;
      this.checkoutService = checkoutService;
    }

    _createClass(SelectPlanCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        this.checkoutService.logProductImpression(this.plans);
      }
    }]);

    return SelectPlanCtrl;
  }()
}).name;
exports.SelectPlanModule = SelectPlanModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanDetailsModule = void 0;

var _find = _interopRequireDefault(__webpack_require__(66));

var _planDetails = _interopRequireDefault(__webpack_require__(1357));

__webpack_require__(1358);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PlanDetailsModule = angular.module('app.components.changePlan.planDetails', []).component('planDetails', {
  template: _planDetails.default,
  bindings: {
    plan: '<',
    highlight: '<',
    showBorder: '<',
    selectPlanButtonText: '<',
    onPlanSelected: '&',
    isTrial: '<',
    showMenu: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    function PlanDetails() {
      _classCallCheck(this, PlanDetails);
    }

    _createClass(PlanDetails, [{
      key: "$onInit",
      value: function $onInit() {
        if (this.plan.alternates) {
          this.plans = _toConsumableArray(this.plan.alternates).concat([this.plan]);
          this.selectedPlanId = this.plans.reduce(function (id, plan) {
            if (plan.displayFirst) return plan.id;
            return id;
          }, null);
        }

        this.setDisplayedPlan();
        this.showMenu = this.displayedPlan.showMenu;
      }
    }, {
      key: "setDisplayedPlan",
      value: function setDisplayedPlan() {
        if (!this.plan.alternates) {
          this.displayedPlan = this.plan;
          return;
        }

        if (!this.selectedPlanId) this.selectedPlanId = this.plan.id;
        this.displayedPlan = (0, _find.default)(this.plans, {
          id: this.selectedPlanId
        });
        this.displayedPlan.nickname = this.displayedPlan.nickname ? this.cleanName(this.displayedPlan.nickname) : this.cleanName(this.displayedPlan.name);
      }
    }, {
      key: "cleanName",
      value: function cleanName(name) {
        if (!name) return;
        return name.replace(/^3M-/, '') // 3M-*
        .replace(/-\d+(-.+)?$/, '') // *-299-credits
        .replace(/-\dapp.?$/i, ''); // *-1App
      }
    }, {
      key: "isCurrentPlan",
      value: function isCurrentPlan() {
        return this.displayedPlan.isCurrentPlan && !this.isTrial;
      }
    }, {
      key: "getSelectPlanButtonText",
      value: function getSelectPlanButtonText() {
        if (this.selectPlanButtonText) {
          return this.selectPlanButtonText;
        } else if (this.isCurrentPlan()) {
          return 'Current Plan';
        }

        return 'Let\'s go!';
      }
    }]);

    return PlanDetails;
  }()
}).name;
exports.PlanDetailsModule = PlanDetailsModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

module.exports = "<div class=\"plan-details\" ng-class=\"{'plan-details--highlight': $ctrl.highlight, 'plan-details--border': $ctrl.showBorder}\" layout=\"column\"> <span class=\"plan-details__popular\" ng-if=\"$ctrl.highlight\">Most Popular</span> <div class=\"plan-details__name\">{{$ctrl.displayedPlan.nickname}}</div> <div class=\"plan-details__price\" ng-if=\"!$ctrl.displayedPlan.priceOverrideText\"> <sup>$</sup> <span>{{$ctrl.displayedPlan.displayAmount / 100}}<span class=\"per-month\">/mo</span></span> </div> <span class=\"plan-details__price-override\" ng-if=\"$ctrl.displayedPlan.priceOverrideText\"> {{$ctrl.displayedPlan.priceOverrideText}} </span> <span class=\"plan-details__price-period\" ng-if=\"$ctrl.displayedPlan.pricePeriodLabel\"> {{$ctrl.displayedPlan.pricePeriodLabel}} </span> <md-select ng-model=\"$ctrl.selectedPlanId\" ng-if=\"$ctrl.plans && $ctrl.showMenu\" ng-change=\"$ctrl.setDisplayedPlan()\"> <md-option ng-value=\"plan.id\" ng-repeat=\"plan in $ctrl.plans\">{{plan.planType}}</md-option> </md-select> <div class=\"plan-details__no-menu-label\" ng-if=\"$ctrl.plans && !$ctrl.showMenu\"> {{$ctrl.displayedPlan.planType}} </div> <div class=\"plan-details__features\"> <div class=\"plan-details__feature\" ng-repeat=\"feature in $ctrl.displayedPlan.marketingFeatures\">{{feature}}</div> </div> <span flex></span> <md-button aria-label=\"checkout button\" class=\"plan-details__button checkout-rounded-button\" ng-class=\"{ 'md-accent md-raised': $ctrl.highlight, 'plan-details__button--border': !$ctrl.highlight }\" ng-click=\"$ctrl.onPlanSelected({ plan: $ctrl.displayedPlan })\" ng-disabled=\"$ctrl.isCurrentPlan()\"> {{$ctrl.getSelectPlanButtonText()}} </md-button> </div> ";

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

module.exports = "<div class=\"select-plan\"> <div class=\"select-plan-header\" layout=\"column\"> <div> <img class=\"select-plan-header__logo\" ng-class=\"{'select-plan-header__logo--no-margin': $ctrl.showAlternate}\" ng-src=\"{{$ctrl.LOGO_URL}}\" height=\"30px\"> </div> <span ng-if=\"!$ctrl.hideGreeting && !$ctrl.showAlternate && $ctrl.user.firstName\">Success starts here, {{$ctrl.user.firstName}}!</span> <span ng-if=\"$ctrl.note\" class=\"select-plan__note-text\">{{$ctrl.note}}</span> </div> <div class=\"select-plan__loading\" layout=\"row\" layout-align=\"center center\" ng-if=\"!$ctrl.plans\"> <md-progress-circular class=\"md-accent\" md-diameter=\"60\" md-mode=\"indeterminate\"> </md-progress-circular> </div> <div class=\"select-plan-body\" ng-if=\"$ctrl.plans\"> <div class=\"select-plan__plan-container\"> <div layout=\"column\" layout-gt-sm=\"row\"> <plan-details flex ng-repeat=\"plan in $ctrl.plans | orderBy:$ctrl.planSortExpression\" plan=\"plan\" highlight=\"plan.highlight\" show-border=\"$ctrl.showBorderOnPlans\" on-plan-selected=\"$ctrl.onPlanSelected({plan: plan})\" select-plan-button-text=\"plan.actionText\" is-trial=\"$ctrl.isTrial\" ng-class=\"{'select-plan__highlighted-plan': plan.highlight}\"> </plan-details> </div> </div> </div> <div class=\"select-plan-footer\" ng-if=\"$ctrl.showAlternate\"> <div class=\"select-plan__guarantee\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center center\"> <img src=\"/assets/volusion-guarantee.svg\" width=\"95\"> <div>If you are not 100% satisfied within the first 30 days, contact us for a full refund, no questions asked!</div> </div> </div> </div> ";

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports = "<md-button ng-if=\"$ctrl.isCloseAllowed\" class=\"change-plan-modal__close md-icon-button\" ng-click=\"$ctrl.close()\"> <md-icon>close</md-icon> </md-button> <md-button logout ng-if=\"$ctrl.step === 1 && $ctrl.showLogoutButton\" class=\"change-plan-modal__back md-button md-button--has-icon-left\"> <md-icon>arrow_back</md-icon> <span>Go back</span> </md-button> <select-plan ng-if=\"$ctrl.step === $ctrl.steps.plans\" plans=\"$ctrl.currentPlans\" plan-sort-expression=\"$ctrl.planSortExpression\" on-plan-selected=\"$ctrl.selectPlan(plan)\" user=\"$ctrl.user\" is-trial=\"$ctrl.isTrial\" note=\"$ctrl.selectPlanNote\" hide-greeting=\"$ctrl.hideGreeting\" show-border-on-plans=\"!$ctrl.isModal\" show-alternate=\"false\"> </select-plan> <checkout cart=\"$ctrl.cart\" ng-if=\"$ctrl.step === $ctrl.steps.checkout\" is-modal=\"$ctrl.isModal\" is-trial=\"$ctrl.isTrial\" on-back-click=\"$ctrl.onBackClick\" on-exit-checkout=\"$ctrl.finish()\" trial-days-remaining=\"$ctrl.trialDaysRemaining\" on-purchase-complete=\"$ctrl.onPurchaseComplete()\" hide-back-button=\"$ctrl.hideBackButton\" material-theme=\"default\" show-coupon-code-field=\"$ctrl.showCouponCodeField\" show-alternate=\"false\"> </checkout> ";

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header__close\"> <md-button class=\"md-icon-button\" ng-click=\"$ctrl.closeConfirmInstall()\" aria-label=\"close modal\"> <md-icon>close</md-icon> </md-button> </div> <form> <md-dialog-content class=\"modal--content\"> <div class=\"md-whiteframe-2dp modal--header\"> <div layout=\"row\" layout-align=\"start center\" class=\"header-row\"> <span class=\"image\" vln-back-img=\"{{$ctrl.app.logo.imageLink.fullUri}}\" alt=\"{{$ctrl.app.title}}\"></span> <div class=\"title\"> <span ng-if=\"$ctrl.isApplication() && $ctrl.isInstalled\">{{\"APPSTORE.UNINSTALL\" | translate}} {{\"APPSTORE.APPLICATION\" | translate}}</span> <span ng-if=\"$ctrl.isApplication() && !$ctrl.isInstalled\">{{\"APPSTORE.APPLICATION\" | translate}}</span> <span ng-if=\"$ctrl.isExtension()\">{{\"APPSTORE.EXTENSION\" | translate}}</span> <p>{{$ctrl.app.title}}</p> </div> <span flex></span> <div class=\"install\"> <p ng-if=\"!$ctrl.isInstalled && $ctrl.app.planLevel === 'Lite'\">{{\"APPSTORE.FREE\" | translate}}</p> <p ng-if=\"!$ctrl.isInstalled && $ctrl.app.planLevel === 'Plus'\"> {{\"APPSTORE.FREEWITHPLUSPLANLONG\" | translate}} </p> </div> </div> <div layout=\"row\" layout-align=\"start center\" class=\"description__content\"> {{ $ctrl.blurbText }} </div> <div layout=\"row\" layout-align=\"end center\" class=\"footer-row\" ng-if=\"$ctrl.installError\"> <div layout=\"row\" layout-align=\"center center\">{{ $ctrl.installError | translate }}</div> <div layout=\"row\" layout-align=\"center center\"> <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.openPlans(event)\"> <span>Change Your Plan</span> </md-button> </div> </div> <div ng-if=\"!$ctrl.isInstalled && $ctrl.app.permissions.length > 0\"> <div> <div class=\"permission__header\">{{\"APPSTORE.PERMISSIONS\" | translate}}</div> <div class=\"permission__subheader\">{{\"APPSTORE.PERMISSIONS_BLURB\" | translate}}</div> <md-list class=\"permission__list\"> <li class=\"permission__list-item\" ng-repeat=\"permission in $ctrl.app.permissions\"> {{permission}} </li> </md-list> </div> </div> <div layout=\"row\" layout-align=\"end center\" class=\"footer-row\" ng-if=\"!$ctrl.installError\"> <md-button ng-click=\"$ctrl.closeConfirmInstall()\">{{\"BUTTON.CANCEL\" | translate}}</md-button> <md-button ng-if=\"!$ctrl.isInstalled\" class=\"md-raised md-accent md-button--has-spinner\" ng-click=\"$ctrl.install()\" gtm-click-event=\"{{$ctrl.gtmid}}_installApp-{{$ctrl.app.title}}\" aria-label=\"confirm install app\"> <span ng-if=\"!$ctrl.installing\">{{\"APPSTORE.CONFIRMINSTALLBUTTON\" | translate}}</span> <span ng-if=\"$ctrl.installing\"> <span>{{\"APPSTORE.INSTALLING\" | translate}}</span> <md-progress-circular class=\"progress-white\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular> </span> </md-button> <md-button ng-if=\"$ctrl.isInstalled\" class=\"md-accent delete md-button--has-spinner\" ng-click=\"$ctrl.uninstall()\" gtm-click-event=\"{{$ctrl.gtmid}}_installApp-{{$ctrl.app.title}}\" aria-label=\"confirm install app\"> <span ng-if=\"!$ctrl.installing\">{{\"APPSTORE.CONFIRM_UNINSTALL_BUTTON\" | translate}}</span> <span ng-if=\"$ctrl.installing\"> <span>{{\"APPSTORE.UNINSTALLING\" | translate}}</span> <md-progress-circular class=\"progress-white\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular> </span> </md-button> </div> </div> </md-dialog-content> </form> ";

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppExtensionUpgradePlanModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _launchChangePlan = __webpack_require__(102);

var _appExtensionUpgradePlan = _interopRequireDefault(__webpack_require__(1366));

__webpack_require__(1367);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AppExtensionUpgradePlanModule = angular.module('app.components.appExtensionPreview.appExtensionUpgradePlan', ['ngMaterial', _launchChangePlan.LaunchChangePlanServiceModule]).component('appExtensionUpgradePlan', {
  template: _appExtensionUpgradePlan.default,
  bindings: {
    app: '<',
    appType: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    AppExtentionUpgradePlan.$inject = ["$mdDialog", "launchChangePlanService"];

    function AppExtentionUpgradePlan($mdDialog, launchChangePlanService) {
      'ngInject';

      _classCallCheck(this, AppExtentionUpgradePlan);

      (0, _assign.default)(this, {
        $mdDialog: $mdDialog,
        launchChangePlanService: launchChangePlanService
      });
    }

    _createClass(AppExtentionUpgradePlan, [{
      key: "openUpgradePlanDialog",
      value: function openUpgradePlanDialog() {
        var _this = this;

        return this.$mdDialog.hide().then(function () {
          return _this.launchChangePlanService.openModal();
        });
      }
    }, {
      key: "closeConfirmUpgrade",
      value: function closeConfirmUpgrade() {
        return this.$mdDialog.cancel('cancel');
      }
    }]);

    return AppExtentionUpgradePlan;
  }()
}).name;
exports.AppExtensionUpgradePlanModule = AppExtensionUpgradePlanModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header__close\"> <md-button class=\"md-icon-button\" ng-click=\"$ctrl.closeConfirmUpgrade()\" aria-label=\"close modal\"> <md-icon>close</md-icon> </md-button> </div> <md-dialog-content class=\"modal--content\"> <div class=\"modal--header\"> <div layout=\"row\" layout-align=\"start center\" class=\"header-row\"> <span class=\"image\" vln-back-img=\"{{$ctrl.app.logo.imageLink.fullUri}}\" alt=\"{{$ctrl.app.title}}\"/> <div class=\"title\"> <span>App</span> <p>{{$ctrl.app.title}}</p> </div> </div> <span flex></span> </div> <div layout=\"row\" layout-align=\"start center\" class=\"description__content\"> You have reached your plan’s limit on apps. Please upgrade your plan or uninstall an existing app. </div> <div layout=\"row\" layout-align=\"end center\" class=\"footer-row\"> <md-button ng-click=\"$ctrl.closeConfirmUpgrade()\">Cancel</md-button> <mg-button class=\"md-button md-raised md-accent\" ng-click=\"$ctrl.openUpgradePlanDialog()\"> Upgrade Plan </mg-button> </div> </md-dialog-content>";

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppComponentModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _get = _interopRequireDefault(__webpack_require__(34));

var _ldclientJs = __webpack_require__(488);

var _uuidV = _interopRequireDefault(__webpack_require__(288));

var _ApiConfig = _interopRequireDefault(__webpack_require__(235));

var _SiteDesigner = _interopRequireDefault(__webpack_require__(601));

var _launchChangePlan = __webpack_require__(102);

var _navigationMenu = __webpack_require__(1369);

var _storefrontSlider = __webpack_require__(1375);

var _storeInformation = __webpack_require__(38);

var _trial = __webpack_require__(60);

var _trialStatusBar = __webpack_require__(1387);

var _videoSlider = __webpack_require__(1390);

var _auth = __webpack_require__(77);

var _auth0auth = __webpack_require__(166);

var _authToken = __webpack_require__(43);

var _onboarding = __webpack_require__(59);

var _founderGuide = __webpack_require__(155);

var _subscription = __webpack_require__(42);

var _greeting = __webpack_require__(597);

var _myAccount = __webpack_require__(84);

var _index = __webpack_require__(1394);

var _termsAndConditions = __webpack_require__(1396);

var _app = __webpack_require__(375);

__webpack_require__(1397);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SHOW_TERMS_TASK_ID = 'onboarding.termsAndConditions';
var AppComponentModule = angular.module('app.appComponent', [_trial.TrialServiceModule, _auth.AuthServiceModule, _authToken.AuthTokenServiceModule, _auth0auth.Auth0AuthServiceModule, _launchChangePlan.LaunchChangePlanServiceModule, _trialStatusBar.TrialStatusBarModule, _storefrontSlider.StorefrontSliderModule, _storeInformation.StoreInformationServiceModule, _app.AppServiceModule, _navigationMenu.NavigationMenuComponentModule, _videoSlider.VideoSliderModule, _onboarding.OnboardingServiceModule, _founderGuide.FounderGuideServiceModule, _subscription.SubscriptionServiceModule, _myAccount.MyAccountServiceModule, _index.TermsAndConditionsModule, _greeting.GreetingServiceModule, _termsAndConditions.TermsAndConditionsServiceModule]).component('app', {
  template: '<ui-view></ui-view>'
}).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state({
    name: 'app',
    component: 'app',
    abstract: true
  }).state({
    name: 'auth',
    parent: 'app',
    abstract: true,
    template: "<navigation-menu\n                            ng-if=\"app.shouldShowSideNavigationMenu()\"\n                            show-progress-bar=\"app.hasFounderGuideFeature\"\n                            progress-bar-value=\"app.founderGuideProgress\"\n                            trial-status=\"app.trialStatus\" />\n                       <ui-view id=\"main-app-view\"></ui-view>\n                       <terms-and-conditions-modal\n                            open=\"app.showTermsAndConditionsModal\"\n                            on-accept=\"app.acceptTermsAndConditions\"\n                            container=\"app.termsAndConditionsContainer\"\n                            />\n                       <trial-status-bar\n                           ng-if=\"app.shouldShowTrialStatusBar() && !app.hasFounderGuideFeature\"\n                           trial-status=\"app.trialStatus\">\n                       </trial-status-bar>\n                       <video-slider></video-slider>",
    data: {
      requiresLogin: true
    },
    resolve: {
      cacheAccessToken: ["authTokenService", function cacheAccessToken(authTokenService) {
        return authTokenService.getAccessToken();
      }],
      initLaunchDarkly: ["launchDarklyService", "myAccountService", function initLaunchDarkly(launchDarklyService, myAccountService) {
        launchDarklyService.unInit();
        myAccountService.getUser().then(function (user) {
          return launchDarklyService.initFromToken({
            createdOn: user.createdOn
          });
        });
      }],
      hasFounderGuideFeature: ["initLaunchDarkly", "launchDarklyService", function hasFounderGuideFeature(initLaunchDarkly, launchDarklyService) {
        return launchDarklyService.getFeature('founder-guide');
      }],
      isNewAccount: ["initLaunchDarkly", "launchDarklyService", "storeInformationService", function isNewAccount(initLaunchDarkly, launchDarklyService, storeInformationService) {
        return storeInformationService.getStore().then(function (storeInformation) {
          return launchDarklyService.isNewAccount(storeInformation);
        });
      }],
      setTenantAndAuthToken: ["authTokenService", function setTenantAndAuthToken(authTokenService) {
        authTokenService.getHeaders().then(function (headers) {
          _ApiConfig.default.setTenantId(headers.tenantId);

          _ApiConfig.default.setAuthToken(headers.token);

          _SiteDesigner.default.setAuthToken(headers.token);
        });
      }],
      isOnHold: ["subscriptionsService", "$state", function isOnHold(subscriptionsService, $state) {
        return subscriptionsService.getSubscription().then(function (subscription) {
          if (subscription.features.isOnHold) {
            return $state.go('onHold');
          }
        });
      }]
    },
    controllerAs: 'app',
    controller:
    /*#__PURE__*/
    function () {
      AppController.$inject = ["trialService", "$interval", "authService", "launchChangePlanService", "onboardingService", "founderGuideService", "subscriptionsService", "$rootScope", "appService", "$state", "$scope", "$http", "authTokenService", "auth0AuthService", "hasFounderGuideFeature", "isNewAccount", "termsAndConditionsService"];

      function AppController(trialService, $interval, authService, launchChangePlanService, onboardingService, founderGuideService, subscriptionsService, $rootScope, appService, $state, $scope, $http, authTokenService, auth0AuthService, hasFounderGuideFeature, isNewAccount, termsAndConditionsService) {
        'ngInject';

        _classCallCheck(this, AppController);

        (0, _assign.default)(this, {
          trialService: trialService,
          $interval: $interval,
          authService: authService,
          launchChangePlanService: launchChangePlanService,
          onboardingService: onboardingService,
          founderGuideService: founderGuideService,
          subscriptionsService: subscriptionsService,
          $rootScope: $rootScope,
          appService: appService,
          $state: $state,
          $scope: $scope,
          $http: $http,
          authTokenService: authTokenService,
          auth0AuthService: auth0AuthService,
          intervalDelay: 300000,
          progressBarIntervalDelay: 1000,
          hasFounderGuideFeature: hasFounderGuideFeature,
          isNewAccount: isNewAccount,
          termsAndConditionsService: termsAndConditionsService,
          showTermsAndConditionsModal: false,
          NOT_TRIAL: _trial.NOT_TRIAL,
          // Fixes bug with react modal being open at same time as angular modal
          termsAndConditionsContainer: document.querySelector('app')
        });
      }

      _createClass(AppController, [{
        key: "$onInit",
        value: function $onInit() {
          var _this = this;

          this.appService.init();
          this.getTrialStatus().then(function () {
            if (_this.trialService.isValidTrialPlanStatus(_this.trialStatus)) {
              _this.startPollingTrialStatus();

              if (_this.hasFounderGuideFeature) {
                _this.setFounderGuideProgressValue();
              }
            }

            if (_this.trialStatus !== _trial.NOT_TRIAL) {
              _this.startPollingProgressBarStatus();

              angular.element('body').addClass('trial-account');
            }

            _this.authService.isImpersonator().then(function (isImpersonator) {
              if (!isImpersonator && _this.trialStatus === _trial.NOT_TRIAL) {
                _this.handleTermsAndConditions();
              }
            });
          });
          this.acceptTermsAndConditions = this.acceptTermsAndConditions.bind(this);
        }
      }, {
        key: "$onDestroy",
        value: function $onDestroy() {
          this.stopPollingTrialStatus();
          this.stopPollingProgressBarStatus();
          this.unbindStateChangeSuccess();
        }
      }, {
        key: "handleTermsAndConditions",
        value: function handleTermsAndConditions() {
          var _this2 = this;

          return this.termsAndConditionsService.getTerms().then(function (termsResponse) {
            var latestTerms = (0, _get.default)(termsResponse, 'items[0]');

            if (latestTerms && latestTerms.termsId) {
              _this2.latestTerms = latestTerms;
              return _this2.termsAndConditionsService.getAcceptedTermsById(_this2.latestTerms.termsId);
            }
          }).catch(function (termsResponse) {
            if (termsResponse.status === 404) {
              _this2.showTermsAndConditionsModal = true;
            } else {
              throw new Error(termsResponse);
            }
          });
        }
      }, {
        key: "logout",
        value: function logout() {
          this.auth0AuthService.logout();
        }
      }, {
        key: "startPollingProgressBarStatus",
        value: function startPollingProgressBarStatus() {
          var _this3 = this;

          this.getProgressBarInterval = this.$interval(function () {
            return _this3.setFounderGuideProgressValue();
          }, this.progressBarIntervalDelay);
        }
      }, {
        key: "stopPollingProgressBarStatus",
        value: function stopPollingProgressBarStatus() {
          this.$interval.cancel(this.getProgressBarInterval);
        }
      }, {
        key: "startPollingTrialStatus",
        value: function startPollingTrialStatus() {
          var _this4 = this;

          this.getTrialStatusInterval = this.$interval(function () {
            return _this4.getTrialStatus();
          }, this.intervalDelay);
        }
      }, {
        key: "stopPollingTrialStatus",
        value: function stopPollingTrialStatus() {
          this.$interval.cancel(this.getTrialStatusInterval);
        }
      }, {
        key: "getTrialStatus",
        value: function getTrialStatus() {
          var _this5 = this;

          return this.trialService.getTrialStatus().then(function (trialStatus) {
            _this5.trialStatus = trialStatus;

            if (trialStatus === _trial.PARKED || trialStatus === _trial.EXPIRED) {
              _this5.launchChangePlanService.openModal(null, null, true);

              _this5.stopPollingTrialStatus();
            }
          }).catch(function () {
            return _this5.stopPollingTrialStatus();
          });
        }
      }, {
        key: "setFounderGuideProgressValue",
        value: function setFounderGuideProgressValue() {
          var _this6 = this;

          this.onboardingService.getState().then(function (state) {
            _this6.founderGuideService.updateStepsComplete(state);

            var completedSteps = _this6.founderGuideService.getCompletedStepCount();

            _this6.founderGuideProgress = completedSteps / _this6.founderGuideService.steps.length * 100;
          });
        }
      }, {
        key: "shouldShowTrialStatusBar",
        value: function shouldShowTrialStatusBar() {
          return angular.isDefined(this.trialStatus) && this.trialStatus !== _trial.NOT_TRIAL;
        }
      }, {
        key: "shouldShowSideNavigationMenu",
        value: function shouldShowSideNavigationMenu() {
          return angular.isDefined(this.$state.current.data.showSideNavigationMenu) ? this.$state.current.data.showSideNavigationMenu : true;
        }
      }, {
        key: "acceptTermsAndConditions",
        value: function acceptTermsAndConditions() {
          var _this7 = this;

          this.authTokenService.getEmail().then(function (email) {
            _this7.onboardingService.completeTask(SHOW_TERMS_TASK_ID);

            _this7.termsAndConditionsService.acceptTerms(_this7.latestTerms.termsId, email);

            _this7.showTermsAndConditionsModal = false;

            _this7.$scope.$apply();
          });
        }
      }]);

      return AppController;
    }()
  }).state({
    name: 'guest',
    parent: 'app',
    abstract: true,
    template: '<ui-view></ui-view>',
    resolve: {
      initLaunchDarkly: ["launchDarklyService", function initLaunchDarkly(launchDarklyService) {
        return launchDarklyService.init({
          key: (0, _uuidV.default)(),
          anonymous: true
        }, _ldclientJs.initialize);
      }]
    }
  });
}]).name;
exports.AppComponentModule = AppComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationMenuComponentModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _includes = _interopRequireDefault(__webpack_require__(287));

var _isEmpty = _interopRequireDefault(__webpack_require__(190));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _logo = __webpack_require__(656);

var _onboarding = __webpack_require__(59);

var _launchDarkly = __webpack_require__(30);

var _launchChangePlan = __webpack_require__(102);

var _trial = __webpack_require__(60);

var _navigationMenu = __webpack_require__(602);

var _navigationMenu2 = __webpack_require__(603);

var _navigationMenu3 = _interopRequireDefault(__webpack_require__(1373));

__webpack_require__(1374);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NavigationMenuComponentModule = angular.module('app.components.navigationMenu', ['ngMaterial', _logo.LogoModule, _navigationMenu.NavigationMenuServiceModule, _onboarding.OnboardingServiceModule, _launchDarkly.LaunchDarklyServiceModule, _launchChangePlan.LaunchChangePlanServiceModule, _angularjs.default]).component('navigationMenu', {
  template: _navigationMenu3.default,
  bindings: {
    showProgressBar: '<',
    progressBarValue: '<',
    trialStatus: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    SidenavLinksCtrl.$inject = ["$scope", "$rootScope", "$state", "$window", "$mdSidenav", "$mdMedia", "onboardingService", "navigationMenuService", "auth0SdkService", "launchDarklyService", "launchChangePlanService"];

    function SidenavLinksCtrl($scope, $rootScope, $state, $window, $mdSidenav, $mdMedia, onboardingService, navigationMenuService, auth0SdkService, launchDarklyService, launchChangePlanService) {
      _classCallCheck(this, SidenavLinksCtrl);

      (0, _assign.default)(this, {
        $scope: $scope,
        $rootScope: $rootScope,
        $state: $state,
        $window: $window,
        $mdSidenav: $mdSidenav,
        $mdMedia: $mdMedia,
        onboardingService: onboardingService,
        navigationMenuService: navigationMenuService,
        auth0SdkService: auth0SdkService,
        launchDarklyService: launchDarklyService,
        launchChangePlanService: launchChangePlanService,
        NAV_STATES: _navigationMenu2.NAV_STATES,
        myAccountLabel: 'MYACCOUNT.TITLE',
        smallNavStates: [_navigationMenu2.NAV_STATES.EDIT_STORE, _navigationMenu2.NAV_STATES.BLOCK_MANAGEMENT, _navigationMenu2.NAV_STATES.SITE_DESIGNER],
        hiddenApps: []
      });
    }

    _createClass(SidenavLinksCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.navigationMenuService.loadApps().then(function (apps) {
          _this.apps = apps;
        });
        this.onStateChangeSuccess = this.onStateChangeSuccess.bind(this);
        this.setUserName();
        this.setUserInitials();
        this.unbindRootStateChange = this.$rootScope.$on('$stateChangeSuccess', this.onStateChangeSuccess);
        var asyncLookup = true;
        this.$mdSidenav('nav-menu', asyncLookup).then(function (navMenu) {
          navMenu.onClose(function () {
            _this.navigationMenuService.removeNavOpenCssClassFromBody();
          });

          _this.updateNavigationView();
        });
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        if (changes.trialStatus) this.setIsTrial();
      }
    }, {
      key: "shouldShowApp",
      value: function shouldShowApp(app) {
        var showApp = !this.hiddenApps.includes(app);
        return app !== 'progress' && app !== 'get-started' && showApp;
      }
    }, {
      key: "setIsTrial",
      value: function setIsTrial() {
        this.isTrial = angular.isDefined(this.trialStatus) && this.trialStatus !== _trial.NOT_TRIAL;
      }
    }, {
      key: "shouldShowProgressBar",
      value: function shouldShowProgressBar() {
        return this.isTrial && this.showProgressBar;
      }
    }, {
      key: "trialStatusAsNumber",
      value: function trialStatusAsNumber() {
        if (this.isTrialExpired()) return '0';
        var status = parseInt(this.trialStatus);
        if (isNaN(status)) return '0';
        return status;
      }
    }, {
      key: "isTrialExpired",
      value: function isTrialExpired() {
        return this.trialStatus === 'PARKED' || this.trialStatus === 'EXPIRED';
      }
    }, {
      key: "onStateChangeSuccess",
      value: function onStateChangeSuccess() {
        this.navigationMenuService.close();

        if (this.clickedIndex !== null && this.clickedIndex !== undefined) {
          this.apps[this.clickedIndex].clicked = false;
        }

        this.updateNavigationView();
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.unbindRootStateChange();
      }
    }, {
      key: "updateNavigationView",
      value: function updateNavigationView() {
        this.selectedAppType = this.navigationMenuService.getSelectedAppType(this.$state.$current.name);
        this.navigationMenuService.setNavMenuMarginOnElements(this.selectedAppType);
      }
    }, {
      key: "goToApp",
      value: function goToApp(app, $index) {
        var _this2 = this;

        if (app.link === this.$state.current.name) {
          return;
        }

        this.clickedIndex = $index;
        this.apps[$index].clicked = true;
        this.$window.dataLayer.push({
          event: "admin_navMenu-".concat(app.type)
        });

        if (app.param) {
          return this.$state.go(app.link, app.param).catch(function () {
            _this2.apps[$index].clicked = false;
          });
        } else if (app.href) {
          // supports URLs only in the new admin client
          this.$window.location.href = app.href;
        } else {
          return this.$state.go(app.link).catch(function () {
            _this2.apps[$index].clicked = false;
          });
        }
      }
    }, {
      key: "setUserName",
      value: function setUserName() {
        var _this3 = this;

        this.auth0SdkService.getUser().then(function (user) {
          if (user && user.user_metadata) {
            var _user$user_metadata = user.user_metadata,
                firstname = _user$user_metadata.firstname,
                lastname = _user$user_metadata.lastname;
            _this3.myAccountLabel = "".concat(firstname, "\n\r").concat(lastname);
          }
        });
      }
    }, {
      key: "setUserInitials",
      value: function setUserInitials() {
        var _this4 = this;

        this.auth0SdkService.getUser().then(function (user) {
          if (user && user.user_metadata) {
            var _user$user_metadata2 = user.user_metadata,
                firstname = _user$user_metadata2.firstname,
                lastname = _user$user_metadata2.lastname;

            if ((0, _isEmpty.default)(firstname) || (0, _isEmpty.default)(lastname)) {
              _this4.myInitials = null;
            } else {
              _this4.myInitials = "".concat(firstname[0].toUpperCase()).concat(lastname[0].toUpperCase());
            }
          }
        });
      }
    }, {
      key: "isFullNavVisible",
      value: function isFullNavVisible() {
        return !(this.showSmallMenu() && this.$mdMedia('gt-sm'));
      }
    }, {
      key: "showSmallMenu",
      value: function showSmallMenu() {
        return (0, _includes.default)(this.smallNavStates, this.selectedAppType);
      }
    }, {
      key: "showFullMenu",
      value: function showFullMenu() {
        return this.selectedAppType !== this.NAV_STATES.EDIT_STORE && this.selectedAppType !== this.NAV_STATES.VOLUSION_PAYMENTS;
      }
    }, {
      key: "hideMenu",
      value: function hideMenu() {
        return this.selectedAppType === this.NAV_STATES.VOLUSION_PAYMENTS;
      }
    }, {
      key: "openPlans",
      value: function openPlans(ev) {
        this.launchChangePlanService.openModal(ev, null, true);
      }
    }]);

    return SidenavLinksCtrl;
  }()
}).name;
exports.NavigationMenuComponentModule = NavigationMenuComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logoComponent = void 0;

var _constants = __webpack_require__(24);

var _logo = _interopRequireDefault(__webpack_require__(1371));

__webpack_require__(1372);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var logoComponent = {
  template: _logo.default,
  bindings: {
    clickable: '<',
    logoType: '@'
  },
  controller:
  /*#__PURE__*/
  function () {
    LogoComponent.$inject = ["$window"];

    function LogoComponent($window) {
      'ngInject';

      _classCallCheck(this, LogoComponent);

      angular.extend(this, {
        $window: $window
      });
    }

    _createClass(LogoComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.logoUrl = this.logoType === 'full' ? _constants.LOGO_URL : _constants.LOGO_SYMBOL_URL;
      }
    }, {
      key: "onClick",
      value: function onClick() {
        if (!this.clickable) return;
        this.$window.open('https://volusion.com', '_self');
      }
    }]);

    return LogoComponent;
  }()
};
exports.logoComponent = logoComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

module.exports = "<img ng-src=\"{{$ctrl.logoUrl}}\" class=\"volusion-logo\" ng-class=\"{'volusion-logo--clickable': $ctrl.clickable}\" ng-click=\"$ctrl.onClick()\" alt=\"Volusion Logo\"> ";

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

module.exports = "<md-sidenav md-component-id=\"nav-menu\" md-is-locked-open=\"$mdMedia('gt-sm')\" ng-class=\"{'nav-menu--small': $ctrl.showSmallMenu(),\n                'nav-menu--none': $ctrl.hideMenu(),\n                'nav-menu--full': $ctrl.showFullMenu(),\n                'nav-menu--trial': $ctrl.isTrial}\" md-whiteframe=\"4\"> <div class=\"nav-menu__app__container\"> <div class=\"nav-menu__app__list\"> <a href=\"/dashboard\"> <div class=\"header__left nav-menu__app--logo\"> <logo ng-if=\"$ctrl.isFullNavVisible()\" logo-type=\"full\"></logo> <logo ng-if=\"!$ctrl.isFullNavVisible()\"></logo> </div> </a> <md-list> <hotspot ng-if=\"$ctrl.shouldShowProgressBar()\" hide-xs hotspot-id=\"'founderguide.progressbar'\" modal-title=\"'Founder Guide Progress'\" modal-description=\"'Track your progress as you complete the founder guide.'\" anchor=\"'left-top'\" class=\"hotspot--founderguide-progress\"> </hotspot> <md-list-item ng-repeat=\"app in $ctrl.apps\" ng-click=\"$ctrl.goToApp(app, $index)\" md-ink-ripple ng-if=\"$ctrl.shouldShowApp(app.type)\" class=\"nav-menu__app--app-row md-clickable\" ng-class=\"{\n                            'nav-menu__app--selected': app.type === $ctrl.selectedAppType && app.type !== 'dashboard',\n                            'nav-menu__app--dashboard': app.type === 'dashboard',\n                            'nav-menu__app--linked-app': app.linkedApp || app.linkedAppStart || app.linkedAppEnd,\n                            'nav-menu__app--linked-app-start': app.linkedAppStart,\n                            'nav-menu__app--linked-app-end': app.linkedAppEnd\n                        }\"> <div ng-if=\"$ctrl.shouldShowProgressBar() && app.type === 'dashboard' && $ctrl.isFullNavVisible()\" class=\"nav-menu__guide-progress--linear\" ng-click=\"$ctrl.goToApp(app, $index)\"> <div class=\"guide-progress__track\"> <div class=\"guide-progress__progress-bar\" ng-style=\"{width: $ctrl.progressBarValue + '%'}\"></div> </div> </div> <div ng-if=\"$ctrl.shouldShowProgressBar() && app.type === 'dashboard' && !$ctrl.isFullNavVisible()\" class=\"nav-menu__guide-progress--circular\" ng-click=\"$ctrl.goToApp(app, $index)\"> <md-progress-circular md-mode=\"determinate\" md-diameter=\"32\" value=\"{{$ctrl.progressBarValue}}\"/> </div> <a class=\"nav-menu__app\" id=\"nav-{{app.type}}\" ng-click=\"$ctrl.goToApp(app, $index)\" ng-style=\"{'background': app.type === $ctrl.selectedAppType ? '#5F2EE9' : '#221B43'}\"> <md-icon ng-if=\"!app.clicked && app.type !== 'discounts'\" class=\"nav-menu__app__icon\">{{app.icon}} </md-icon> <svg ng-if=\"!app.clicked && app.type === 'discounts'\" viewBox=\"0 0 30 30\" class=\"nav-menu__discount__icon\"> <path d=\"M18.501 3.5l-15 15.001l1.996 1.996l15-15zM7.002 5a2 2 0 1 0-.004 4a2 2 0 0 0 .004-4zm10 10a2 2 0 1 0-.004 4a2 2 0 0 0 .004-4z\"/> </svg> <spinner ng-if=\"app.clicked\"></spinner> </a> <span ng-if=\"$ctrl.isFullNavVisible()\" class=\"nav-menu__app__text\">{{app.label | translate }}</span> </md-list-item> </md-list> </div> <md-list class=\"nav-menu__account-list\"> <md-list-item class=\"nav-menu__app--my-account\" md-ink-ripple ng-class=\"{'nav-menu__app--selected': $ctrl.NAV_STATES.MY_ACCOUNT === $ctrl.selectedAppType}\"> <a href=\"/myaccount\" class=\"nav-menu__app--app-row\"> <div class=\"nav-menu__app\" style=\"background:#221b43\"> <md-icon ng-if=\"!$ctrl.myInitials\" class=\"nav-menu__app__icon\"> account_circle </md-icon> <div ng-if=\"$ctrl.myInitials\" class=\"nav-menu__app--initials\" layout=\"row\" layout-align=\"center center\" layout-fill> {{$ctrl.myInitials}} </div> </div> <span ng-if=\"$ctrl.isFullNavVisible()\" class=\"nav-menu__app__text\">{{$ctrl.myAccountLabel | translate}}</span> </a> </md-list-item> <md-list-item ng-if=\"$ctrl.shouldShowProgressBar()\" class=\"nav-menu__trial-status\"> <span ng-if=\"!$ctrl.isTrialExpired()\"> <span class=\"nav-menu__trial-status__status-text\">{{$ctrl.trialStatus}}</span> left in trial </span> <span ng-if=\"$ctrl.isTrialExpired()\">Trial expired.</span> <a ng-click=\"$ctrl.openPlans()\">Start Selling</a> </md-list-item> <md-list-item ng-if=\"$ctrl.shouldShowProgressBar()\" class=\"nav-menu__trial-status nav-menu__trial-status--small\" layout=\"row\" layout-align=\"center center\"> <div ng-click=\"$ctrl.openPlans()\" class=\"trial-status\" layout=\"row\" layout-align=\"center center\"> {{$ctrl.trialStatusAsNumber()}} </div> <md-tooltip md-delay=\"300\" md-direction=\"right\"> <span ng-if=\"!$ctrl.isTrialExpired()\"> {{$ctrl.trialStatus}} left in trial </span> <span ng-if=\"$ctrl.isTrialExpired()\"> Trial has expired. </span> </md-tooltip> </md-list-item> </md-list> </div> </md-sidenav> ";

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorefrontSliderModule = void 0;

var _storefrontSlider = __webpack_require__(198);

var _storefrontSlider2 = __webpack_require__(1376);

var _openStorefrontSlider = __webpack_require__(1386);

var StorefrontSliderModule = angular.module('vln.storefrontSlider', [_storefrontSlider.StorefrontSliderServiceModule, _storefrontSlider2.StorefrontSliderDirectiveModule, _openStorefrontSlider.OpenStorefrontSliderModule]).name;
exports.StorefrontSliderModule = StorefrontSliderModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorefrontSliderDirectiveModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _some = _interopRequireDefault(__webpack_require__(194));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _angularSanitize = _interopRequireDefault(__webpack_require__(482));

var _jquery = _interopRequireDefault(__webpack_require__(101));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _index = __webpack_require__(638);

var _storage = __webpack_require__(130);

var _videoSlider = __webpack_require__(156);

var _launchDarkly = __webpack_require__(30);

var _storeInformation = __webpack_require__(38);

var _storefrontSlider = _interopRequireDefault(__webpack_require__(1383));

__webpack_require__(1384);

__webpack_require__(1385);

var _storefrontSlider3 = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StorefrontSliderDirectiveModule = angular.module('app.components.storefrontSlider.storefrontSliderDirective', [_angularjs.default, _angularSanitize.default, _angularTranslate.default, _index.HotspotModule, _storage.StorageServiceModule, _storefrontSlider3.StorefrontSliderServiceModule, _videoSlider.VideoSliderServiceModule, _launchDarkly.LaunchDarklyServiceModule, _storeInformation.StoreInformationServiceModule]).directive('storefrontSlider', ["$rootScope", "$window", "$document", "$sce", "$state", "$timeout", "storefrontSliderService", "storageService", "videoSliderService", "launchDarklyService", "storeInformationService", function ($rootScope, $window, $document, $sce, $state, $timeout, storefrontSliderService, storageService, videoSliderService, launchDarklyService, storeInformationService) {
  return {
    restrict: 'E',
    controllerAs: 'storefrontCtrl',
    bindToController: true,
    template: _storefrontSlider.default,
    replace: true,
    scope: {
      onEvent: '&',
      controls: '=vlnControls'
    },
    link: function link(scope, element, attrs) {
      var vm = scope.storefrontCtrl;
      var $body = angular.element('body');

      if (attrs.controls !== '') {
        vm.controls = {
          open: vm.open,
          close: vm.close,
          edit: vm.edit
        };
      }

      $body.addClass('storefront-display');
      scope.$on('$destroy', function () {
        $body.removeClass('storefront-display');
      });
    },
    controller: ["$scope", function storefrontController($scope) {
      var eventManager = []; //page references;

      var $body;
      var $iframeWrap;
      var $adminPage;
      var $adminPageHeader;
      var $divider;
      var $storefrontSlider;
      var $mainAppView;
      var $storefrontSliderView;
      var $trialStatusBar;
      var $$window; //mouse

      var isMouseDown = false; //browser

      var isMobile = $window.matchMedia('(max-width: 599px)');
      var isTablet = $window.matchMedia('(max-width: 959px)');
      var sliderWidth = {
        pixels: 0,
        percentage: 0
      };
      var pageWidth = {
        pixels: 0,
        percentage: 0
      }; //constants

      var PAGE_MIN_WIDTH = 512;
      var SLIDER_MIN_WIDTH = 320;
      var NAV_WIDTH_SMALL = 64;
      var NAV_WIDTH_HIDDEN = 0;
      var NAV_WIDTH = 180;
      var SPLIT_VIEW_PAGES = ['product.detail', 'product.add', 'pages.detail', 'pages.add', 'category.detail', 'category.add', 'editstore.landing', 'editstore.logo', 'editstore.menu', 'editstore.styles', 'editstore.content.navigation', 'editstore.content.editItem', 'editstore.installedThemes', 'editstore.themedetails'];
      var DEVICE_WIDTH = {
        mobile: 400,
        tablet: 770,
        desktop: 1200
      };
      var hasSiteDesigner = false;
      launchDarklyService.isElementStore(storeInformationService).then(function (isElementStore) {
        return hasSiteDesigner = isElementStore;
      });
      var vm = (0, _assign.default)(this, {
        isOpen: false,
        isLoading: false,
        currentPage: $state.current.name,
        pageUrl: null,
        splitViewEnabled: true,
        canNavigate: true,
        browserWidth: -1,
        adminPageBaseWidth: -1,
        navWidth: 180,
        DEVICE_WIDTH: DEVICE_WIDTH,
        isThemePreview: false,
        hasStorefrontLoaded: false,
        themeTitle: null,
        sliderWidth: sliderWidth,
        SPLIT_VIEW_PAGES: SPLIT_VIEW_PAGES,
        open: open,
        close: close,
        edit: edit,
        toggleSplitView: toggleSplitView,
        resize: resize,
        checkSplitViewSupport: checkSplitViewSupport,
        setNavWidth: setNavWidth
      });
      $timeout(init);

      function init() {
        //page references
        $body = angular.element('body');
        $iframeWrap = angular.element('.storefront-slider__iframe-wrap');
        $adminPage = angular.element('.page');
        $adminPageHeader = angular.element('.page__header');
        $divider = angular.element('.storefront-slider__divider');
        $storefrontSlider = angular.element('.storefront-slider');
        $mainAppView = angular.element('#main-app-view');
        $storefrontSliderView = angular.element('#storefront-slider-view');
        $trialStatusBar = angular.element('.trial-status-bar');
        $$window = angular.element($window);

        if ($window.localStorage.getItem('splitViewEnabled') !== null) {
          vm.splitViewEnabled = $window.localStorage.getItem('splitViewEnabled') === 'true';
        }

        initEvents();
        browserResizeHandler();
        stateChangeHandler(null, $state.current);

        if (isEditStore($state.current.name)) {
          setSplitView(true);
        }

        storefrontSliderService.getPageUrl().then(setPageUrl);
        setNavWidth();
      }

      function setNavWidth() {
        vm.navWidth = $body.hasClass('nav-menu__small') ? NAV_WIDTH_SMALL : NAV_WIDTH;
        if (isTablet.matches) vm.navWidth = NAV_WIDTH_HIDDEN;
      }

      function setSliderUrl() {
        return storefrontSliderService.getMerchantUrl().then(function (response) {
          var currentUrl = storefrontSliderService.getSliderUrl();

          if (currentUrl) {
            storefrontSliderService.setSliderUrl(currentUrl);
          } else {
            storefrontSliderService.setSliderUrl(response);
          }
        });
      }

      function initEvents() {
        eventManager.push($rootScope.$on('$stateChangeStart', stateChangeStartHandler));
        eventManager.push($rootScope.$on('$stateChangeSuccess', stateChangeHandler));
        eventManager.push($rootScope.$on('$viewContentLoaded', pageLoadHandler));
        eventManager.push($rootScope.$on('storefrontSliderService:setUrlBarAddress', function (event, data) {
          return setPageUrl(data);
        }));
        eventManager.push($rootScope.$on('storefrontSliderService:sliderUrlChanged', function (event, data) {
          return updateSliderIframe(data);
        }));
        eventManager.push($rootScope.$on('storefrontSliderService:toggleLoader', function (event, data) {
          return toggleLoader(data);
        }));
        eventManager.push($rootScope.$on('storefrontSliderService:stateChanged', function (event, data) {
          return vm.canNavigate = data;
        }));
        eventManager.push($rootScope.$on('storefrontSliderService:openSlider', function (e, width) {
          getBaseWidths();
          var newWidth = width || vm.browserWidth - vm.navWidth;
          setWidth(sliderWidth, newWidth);
          setWidth(pageWidth, vm.adminPageBaseWidth - newWidth);
          vm.open();
        }));
        eventManager.push($rootScope.$on('storefrontSliderService:closeSlider', function () {
          vm.close();
        }));
        eventManager.push($rootScope.$on('storefrontSliderService:storeNameChanged', function (event, data) {
          return storeNameChangedHandler(data);
        }));
        $$window.on('resize', browserResizeHandler);
        $divider.on('mousedown', mouseDownHandler);
        $body.on('mouseup', mouseUpHandler);
        $body.on('mousemove', mouseMoveHandler);
        listenToStorefront();
        $scope.$on('$destroy', unbindEvents);
      }

      function storeNameChangedHandler(storeUrl) {
        storefrontSliderService.setSliderUrl(storeUrl);
        storefrontSliderService.getMerchantUrl(true);
      }

      function unbindEvents() {
        var event;

        while ((event = eventManager.pop()) != null) {
          event();
        }

        $$window.off('resize', browserResizeHandler);
        $divider.off('mousedown', mouseDownHandler);
        $body.off('mouseup', mouseUpHandler);
        $body.off('mousemove', mouseMoveHandler);
      }

      function listenToStorefront() {
        $window.addEventListener('message', processStorefrontMessage);
        $scope.$on('$destroy', function () {
          $window.removeEventListener('message', processStorefrontMessage);
        });
      }

      function processStorefrontMessage(e) {
        var key = e.message ? 'message' : 'data';
        var data = e[key];

        if (data[0] !== '{') {
          return;
        }

        var message = JSON.parse(data);

        if (message.sender !== 'theme' || e.origin === $window.location.origin) {
          return;
        }

        $rootScope.$emit('storefrontMessageReceived', message);

        switch (message.event) {
          case 'angularInitialized':
            var frame = angular.element('.storefront-slider__iframe-wrap iframe')[0];
            storefrontSliderService.setIframeReference(frame.contentWindow);
            $rootScope.$emit('storefrontSliderDirective:angularInitialized');
            break;

          case 'urlChanged':
            vm.pageUrl = message.data;
            $scope.$apply();
            break;

          case 'pageChange':
            storefrontSliderService.setStorefrontState(message.data);
            $scope.$apply();
            break;
          //no default
        }
      }

      function toggleLoader(data) {
        vm.isLoading = data !== undefined ? data : !vm.isLoading;
      }

      function shouldLoadStorefrontEvenIfNotOpen() {
        return (0, _some.default)(vm.SPLIT_VIEW_PAGES, $state.includes) || storefrontSliderService.getSliderHasOpened();
      }

      function updateSliderIframe(data) {
        var iFrameSourceUrl = new $window.URL(data);
        iFrameSourceUrl.pathname = "/storefront-preview".concat(iFrameSourceUrl.pathname);
        var waitTime = 0;

        if (!$iframeWrap || !data || !shouldLoadStorefrontEvenIfNotOpen()) {
          return;
        }

        if (!vm.hasStorefrontLoaded) {
          waitTime = 1000;
        } // setting a timeout to avoid the blank page while the iframe loads


        $timeout(function () {
          $iframeWrap.html("<iframe allowpaymentrequest \nframeborder=\"0\" src=\"".concat($sce.trustAsResourceUrl(iFrameSourceUrl.href), "\">"));
          var $frame = angular.element('.storefront-slider__iframe-wrap iframe');
          var frame = $frame[0];
          $frame.on('load', function () {
            vm.hasStorefrontLoaded = true;
            $scope.$apply();
          });

          if (angular.isDefined(frame)) {
            storefrontSliderService.setIframeReference(frame.contentWindow);
          }

          vm.isThemePreview = storefrontSliderService.isThemePreview();
          vm.themeTitle = storefrontSliderService.getThemeTitle();
        }, waitTime);
      }

      function stateChangeStartHandler(event, toState, toParams, fromState) {
        if (fromState.name.indexOf('.add') !== -1 && toState.name.indexOf('.detail') !== -1) {
          return;
        }

        if (isEditStore(toState.name)) {
          return;
        }

        storefrontSliderService.goToPage('home'); // close slider when navigating away from detail pages

        if (vm.isOpen) {
          vm.close();
        }
      }

      function stateChangeHandler(event, toState) {
        vm.currentPage = toState.name;
        refreshPageReference();

        if (isEditStore(vm.currentPage) && !isMobile.matches) {
          setSplitView(true);
          vm.open();
        } else {
          toggleSplitView(vm.splitViewEnabled);
        }
      }

      function setSplitView(val) {
        vm.splitViewEnabled = val !== undefined ? val : !vm.splitViewEnabled;
        $body.toggleClass('storefront-slider-split', vm.splitViewEnabled && checkSplitViewSupport());

        if (vm.splitViewEnabled) {
          resizeViews();
        } else {
          removeDynamicWidths();
        }
      }

      function toggleSplitView(val) {
        setSplitView(val);

        if (storageService.supported()) {
          $window.localStorage.setItem('splitViewEnabled', vm.splitViewEnabled);
        }
      }

      function setPageUrl(res) {
        vm.pageUrl = isAddPage(vm.currentPage) ? '' : res;
      }

      function pageLoadHandler() {
        //Wait for component to render
        $timeout(function () {
          refreshPageReference();
          storefrontSliderService.getPageUrl().then(setPageUrl);
          setNavWidth();
          setWidth(pageWidth, vm.adminPageBaseWidth - sliderWidth.pixels);
          resizeViews();

          if (isEditStore(vm.currentPage) && !isMobile.matches) {
            setSplitView(true);
            vm.open();
          }
        });
      }

      function getBaseWidths() {
        setNavWidth();
        var pagePaddingOffset = isTablet.matches ? 0 : 30;
        vm.browserWidth = (0, _jquery.default)($document).width();
        vm.adminPageBaseWidth = vm.browserWidth - vm.navWidth - pagePaddingOffset;
        if (isEditStore($state.current.name)) vm.adminPageBaseWidth = vm.browserWidth;
      }

      function browserResizeHandler() {
        getBaseWidths();

        if (!vm.isOpen) {
          return;
        }

        if (vm.splitViewEnabled && isMobile.matches) {
          vm.close();
        }

        setWidth(pageWidth, vm.adminPageBaseWidth - sliderWidth.pixels);
        setWidth(sliderWidth, sliderWidth.pixels);
        resizeViews();
      }

      function isWidthWithinThreshold() {
        return pageWidth.pixels >= PAGE_MIN_WIDTH && sliderWidth.pixels >= SLIDER_MIN_WIDTH;
      }

      function resizeViews() {
        if (!vm.isOpen) {
          return;
        }

        getBaseWidths();
        var maxWidth = vm.browserWidth - vm.navWidth;

        if (vm.splitViewEnabled && checkSplitViewSupport()) {
          // If widths are not within threshold, force within threshold
          if (!isWidthWithinThreshold()) {
            if (pageWidth.pixels < PAGE_MIN_WIDTH) {
              setWidth(pageWidth, PAGE_MIN_WIDTH);
              setWidth(sliderWidth, vm.adminPageBaseWidth - PAGE_MIN_WIDTH);
            } else {
              setWidth(pageWidth, vm.adminPageBaseWidth - SLIDER_MIN_WIDTH);
              setWidth(sliderWidth, SLIDER_MIN_WIDTH);
            }
          }

          $adminPageHeader.css('right', "".concat(sliderWidth.percentage, "%"));
          $adminPage.css('width', "".concat(pageWidth.percentage, "%"));
          $trialStatusBar.css('width', "calc(100% - ".concat(sliderWidth.percentage, "%)"));
        } else {
          if (sliderWidth.pixels > maxWidth) setWidth(sliderWidth, maxWidth);
          if (sliderWidth.pixels < SLIDER_MIN_WIDTH) setWidth(sliderWidth, SLIDER_MIN_WIDTH);
        }

        $storefrontSlider.css('width', "".concat(sliderWidth.percentage, "%"));
        $rootScope.$emit('storefrontSliderDirective:update');

        if (storageService.supported()) {
          $window.localStorage.setItem('storefrontSliderWidth', sliderWidth.pixels);
        }
      }

      function checkSplitViewSupport(page) {
        page = page || vm.currentPage;
        var hasSplit = false;
        if (SPLIT_VIEW_PAGES.indexOf(page) !== -1) hasSplit = true;
        return hasSplit;
      }

      function mouseDownHandler(e) {
        if (e.which !== 1) {
          return;
        }

        isMouseDown = true;
        $body.addClass('storefront-slider-divider--mousedown');
      }

      function mouseUpHandler() {
        isMouseDown = false;
        $body.removeClass('storefront-slider-divider--mousedown');
      }

      function mouseMoveHandler(e) {
        if (!isMouseDown) {
          return;
        }

        var DRAG_THUMB_WIDTH = 13;
        setWidth(sliderWidth, vm.browserWidth - e.pageX + DRAG_THUMB_WIDTH / 2);
        setWidth(pageWidth, vm.adminPageBaseWidth - sliderWidth.pixels);
        resizeViews();
      }

      function setWidth(obj, pixelValue, percentValue) {
        var page = obj === pageWidth;
        getBaseWidths();
        var fullWidth = page ? vm.adminPageBaseWidth : vm.browserWidth;

        if (pixelValue) {
          pixelValue = parseFloat(pixelValue);
          obj.pixels = pixelValue;
          obj.percentage = pixelValue / fullWidth * 100;
        } else if (percentValue) {
          percentValue = parseFloat(percentValue);
          obj.percentage = percentValue;
          obj.pixels = fullWidth * percentValue / 100;
        }
      } // Get fresh DOM elements. Used on page changes


      function refreshPageReference() {
        $adminPage = angular.element('.page');
        $adminPageHeader = angular.element('.page__header');
        $trialStatusBar = angular.element('.trial-status-bar');
      }

      function removeDynamicWidths() {
        $adminPage.css('width', '');
        $adminPageHeader.css('right', '');
        $trialStatusBar.css('width', '');
      }

      function open() {
        if (vm.isOpen) {
          return;
        }

        videoSliderService.closeSlider();
        storefrontSliderService.setSliderHasOpened();
        setSliderUrl().then(function () {
          vm.isOpen = true;
          $body.addClass('hide-overflow--mobile storefront-slider-open');
          $body.removeClass('hide-overflow');
          $mainAppView = angular.element('#main-app-view');
          $mainAppView.addClass('safari-mobile-hide');
          $storefrontSliderView = angular.element('#storefront-slider-view');
          $storefrontSliderView.removeClass('storefront-slider-view__collapsed');

          if (!sliderWidth.percentage) {
            if ($window.localStorage.getItem('storefrontSliderWidth')) {
              getBaseWidths();
              var oldSliderWidth = parseFloat($window.localStorage.getItem('storefrontSliderWidth'));
              setWidth(sliderWidth, oldSliderWidth);
              setWidth(pageWidth, vm.adminPageBaseWidth - oldSliderWidth);
            } else {
              resize('mobile');
            }
          }

          if (sliderWidth.percentage === 100) {
            // reset from fullscreen resize
            setWidth(sliderWidth, vm.browserWidth - SLIDER_MIN_WIDTH);
            setWidth(pageWidth, vm.adminPageBaseWidth - sliderWidth.pixels);
          }

          resizeViews();
          $rootScope.$emit('storefrontSlider:opened');
        });
      }

      function close() {
        vm.isOpen = false;
        $body.removeClass('hide-overflow hide-overflow--mobile storefront-slider-open');
        $mainAppView = angular.element('#main-app-view');
        $mainAppView.removeClass('safari-mobile-hide');
        $storefrontSliderView = angular.element('#storefront-slider-view');
        $storefrontSliderView.addClass('storefront-slider-view__collapsed');
        removeDynamicWidths();
        $rootScope.$emit('storefrontSlider:closed');

        if (isThemeStorePreview(vm.currentPage)) {
          storefrontSliderService.goToPage('home');
        }
      }

      function edit() {
        if (isMobile.matches) {
          vm.close();
        }

        return $state.go('editstore.landing');
      }

      function isAddPage(page) {
        return page && page.indexOf('.add') !== -1 && page.indexOf('customer') === -1;
      }

      function isEditStore(page) {
        if (hasSiteDesigner && page === 'editstore.menu') return false;
        return page && page.indexOf('editstore') !== -1;
      }

      function isThemeStorePreview(page) {
        return page && page.indexOf('themestore.themedetails') !== -1;
      }

      function resize(resolution) {
        if (resolution === 'fullscreen') {
          $body.addClass('hide-overflow');
        } else {
          $body.removeClass('hide-overflow');
        }

        switch (resolution) {
          case 'desktop':
            setWidth(sliderWidth, DEVICE_WIDTH.desktop);
            break;

          case 'tablet':
            setWidth(sliderWidth, DEVICE_WIDTH.tablet);
            break;

          case 'mobile':
            setWidth(sliderWidth, DEVICE_WIDTH.mobile);
            break;

          case 'fullscreen':
            setWidth(sliderWidth, vm.browserWidth);
            break;
          //no default
        }

        setWidth(pageWidth, Math.max(vm.adminPageBaseWidth - sliderWidth.pixels, PAGE_MIN_WIDTH));
        resizeViews();
      }
    }]
  };
}]).name;
exports.StorefrontSliderDirectiveModule = StorefrontSliderDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _random = _interopRequireDefault(__webpack_require__(1378));

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

var _OnboardingStore = _interopRequireDefault(__webpack_require__(414));

var _Pulse = _interopRequireDefault(__webpack_require__(1380));

var _Modal = _interopRequireDefault(__webpack_require__(1381));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Container = _styledComponents.default.aside.withConfig({
  displayName: "Hotspot__Container",
  componentId: "m8i410-0"
})(["z-index:2;position:relative;white-space:normal;text-align:left;outline:0;"]);

var BUTTON_LABELS = ['Got it', 'Awesome', 'Ok', 'Thanks', 'Cool'];

var Hotspot =
/*#__PURE__*/
function (_Component) {
  _inherits(Hotspot, _Component);

  function Hotspot() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Hotspot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Hotspot)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.onHotspotClicked = _this.onHotspotClicked.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onPulseClicked = _this.onPulseClicked.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onDismissButtonClicked = _this.onDismissButtonClicked.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onConfirmButtonClicked = _this.onConfirmButtonClicked.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.containerRef = _react.default.createRef();
    _this.state = {
      showModal: false,
      completed: true
    };
    return _this;
  }

  _createClass(Hotspot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        anchorClass: this.props.anchor,
        showModal: this.props.showModalOnInit
      });

      if (this.props.getStateFromStore) {
        _OnboardingStore.default.getState().then(function (state) {
          if (!state.hotspots.completed[_this2.props.hotspotId]) {
            _this2.setState({
              completed: false
            });
          }
        });
      } else {
        this.setState({
          completed: false
        });
      }
    }
  }, {
    key: "onHotspotClicked",
    value: function onHotspotClicked(event) {
      event.stopPropagation();
    }
  }, {
    key: "onPulseClicked",
    value: function onPulseClicked() {
      this.showModal();
    }
  }, {
    key: "showModal",
    value: function showModal() {
      this.setState({
        anchorClass: this.getAdjustedPosition(this.props.anchor, this.containerRef),
        showModal: true
      });
      window.dataLayer.push({
        event: "admin_hotspot-".concat(this.props.hotspotId, "-open")
      });
    }
  }, {
    key: "onConfirmButtonClicked",
    value: function onConfirmButtonClicked(event) {
      event.stopPropagation();

      if (!this.props.preserveModalOnConfirm) {
        this.setState({
          completed: true
        });
      }

      if (this.props.getStateFromStore) {
        this.saveCompletedState();
      }

      if (this.props.onConfirmButtonClicked) {
        this.props.onConfirmButtonClicked();
      }
    }
  }, {
    key: "onDismissButtonClicked",
    value: function onDismissButtonClicked(event) {
      event.stopPropagation();
      this.setState({
        completed: true
      });

      if (this.props.getStateFromStore) {
        this.saveCompletedState();
      }
    }
  }, {
    key: "saveCompletedState",
    value: function saveCompletedState() {
      _OnboardingStore.default.dismissHotspot(this.props.hotspotId);

      window.dataLayer.push({
        event: "admin_hotspot-".concat(this.props.hotspotId, "-dismiss")
      });
    }
  }, {
    key: "getAdjustedPosition",
    value: function getAdjustedPosition(position, containerRef) {
      // naively positions tooltip for best fit by updating anchorClass
      var hotspotRect = containerRef.current.getBoundingClientRect();
      var windowWidth = window.innerWidth;
      var fromLeft = hotspotRect.left;
      var fromRight = windowWidth - hotspotRect.right;
      var anchor = position.split('-'); // switch left/right if too close to edge

      if (fromRight < fromLeft && fromRight < 320 && anchor.indexOf('left') > -1) {
        anchor = anchor.map(function (pos) {
          return pos === 'left' ? 'right' : pos;
        });
      } else if (fromLeft < fromRight && fromLeft < 300 && anchor.indexOf('right') > -1) {
        anchor = anchor.map(function (pos) {
          return pos === 'right' ? 'left' : pos;
        });
      } // for left-/right- anchors, switch to top-/bottom- on narrower screens


      if (windowWidth < 960 && ['left', 'right'].indexOf(anchor[0]) > -1) {
        anchor = anchor.reverse();
      }

      return anchor.join('-');
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.completed ? null : _react.default.createElement(Container, {
        className: "hotspot",
        onClick: this.onHotspotClicked,
        ref: this.containerRef
      }, this.props.hotspotShowPulse && _react.default.createElement(_Pulse.default, {
        onClick: this.onPulseClicked
      }), this.state.showModal && _react.default.createElement(_Modal.default, {
        anchorClass: this.state.anchorClass,
        title: this.props.modalTitle,
        description: this.props.modalDescription,
        confirmButtonLabel: this.props.confirmButtonLabel,
        onDismissButtonClicked: this.onDismissButtonClicked,
        onConfirmButtonClicked: this.onConfirmButtonClicked,
        onSecondaryButtonClicked: this.props.onSecondaryButtonClicked,
        secondaryButtonLabel: this.props.secondaryButtonLabel
      }));
    }
  }]);

  return Hotspot;
}(_react.Component);

Hotspot.propTypes = {
  hotspotId: _propTypes.default.string.isRequired,
  modalTitle: _propTypes.default.string.isRequired,
  modalDescription: _propTypes.default.string.isRequired,
  anchor: _propTypes.default.string.isRequired,
  getStateFromStore: _propTypes.default.bool.isRequired,
  hotspotShowPulse: _propTypes.default.bool.isRequired,
  showModalOnInit: _propTypes.default.bool.isRequired,
  preserveModalOnConfirm: _propTypes.default.bool,
  onConfirmButtonClicked: _propTypes.default.func,
  confirmButtonLabel: _propTypes.default.string,
  onSecondaryButtonClicked: _propTypes.default.func,
  secondaryButtonLabel: _propTypes.default.string
};
Hotspot.defaultProps = {
  confirmButtonLabel: BUTTON_LABELS[(0, _random.default)(BUTTON_LABELS.length - 1)],
  hotspotShowPulse: true,
  preserveModalOnConfirm: false,
  getStateFromStore: true,
  showModalOnInit: false
};
var _default = Hotspot;
exports.default = _default;

/***/ }),
/* 1378 */,
/* 1379 */,
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(__webpack_require__(21));

var _thread = __webpack_require__(64);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var pulseAnimation = (0, _styledComponents.keyframes)(["from{opacity:1;}to{transform:scale(3);opacity:0;}"]);

var Pulse = _styledComponents.default.div.withConfig({
  displayName: "Pulse",
  componentId: "sc-11nx4i2-0"
})(["position:relative;height:30px;width:30px;outline:0;cursor:pointer;&:before,&:after{content:'';position:absolute;top:50%;left:50%;width:12px;height:12px;margin-left:-6px;margin-top:-6px;background:", ";border-radius:50%;}&:after{animation:", " 2s infinite;}"], function (props) {
  return (0, _thread.getTheme)(props).buttons.primary.backgroundColor;
}, pulseAnimation);

var _default = Pulse;
exports.default = _default;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

var _grid = __webpack_require__(83);

var _thread = __webpack_require__(64);

var _IconButton = _interopRequireDefault(__webpack_require__(644));

var _Triangle = _interopRequireDefault(__webpack_require__(604));

var _Container = _interopRequireDefault(__webpack_require__(1382));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = (0, _styledComponents.default)(_IconButton.default).attrs({
  icon: 'close'
}).withConfig({
  displayName: "Modal__CloseButton",
  componentId: "ysum7z-0"
})(["position:absolute;top:5px;right:5px;"]);

var Title = _styledComponents.default.h3.withConfig({
  displayName: "Modal__Title",
  componentId: "ysum7z-1"
})(["margin:4px 20px 14px 0;font-size:18px;font-weight:bold;color:", ";"], _thread.colors.black87);

var Description = _styledComponents.default.div.withConfig({
  displayName: "Modal__Description",
  componentId: "ysum7z-2"
})(["font-size:14px;color:", ";"], _thread.colors.black54);

var Modal = function Modal(_ref) {
  var title = _ref.title,
      description = _ref.description,
      confirmButtonLabel = _ref.confirmButtonLabel,
      secondaryButtonLabel = _ref.secondaryButtonLabel,
      onDismissButtonClicked = _ref.onDismissButtonClicked,
      onConfirmButtonClicked = _ref.onConfirmButtonClicked,
      onSecondaryButtonClicked = _ref.onSecondaryButtonClicked,
      anchorClass = _ref.anchorClass;
  return _react.default.createElement(_Container.default, {
    className: anchorClass
  }, _react.default.createElement(CloseButton, {
    onClick: onDismissButtonClicked
  }), _react.default.createElement(Title, null, title), _react.default.createElement(Description, null, description), _react.default.createElement(_grid.Flex, {
    justifyContent: 'flex-end',
    alignItems: 'center',
    mt: 3
  }, secondaryButtonLabel && _react.default.createElement(_grid.Box, {
    mr: 2
  }, _react.default.createElement(_thread.Button, {
    variant: "link",
    onClick: onSecondaryButtonClicked
  }, secondaryButtonLabel)), _react.default.createElement(_grid.Box, null, _react.default.createElement(_thread.Button, {
    variant: "primary",
    onClick: onConfirmButtonClicked
  }, confirmButtonLabel))), _react.default.createElement(_Triangle.default, null));
};

Modal.propTypes = {
  title: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  confirmButtonLabel: _propTypes.default.string.isRequired,
  secondaryButtonLabel: _propTypes.default.string,
  anchorClass: _propTypes.default.string.isRequired,
  onDismissButtonClicked: _propTypes.default.func.isRequired,
  onConfirmButtonClicked: _propTypes.default.func.isRequired,
  onSecondaryButtonClicked: _propTypes.default.func
};
var _default = Modal;
exports.default = _default;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

var _Triangle = _interopRequireDefault(__webpack_require__(604));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container",
  componentId: "sc-1smh23f-0"
})(["position:absolute;min-width:240px;padding:16px;background:#fff;box-shadow:0 2px 5px rgba(0,0,0,0.3);cursor:default;&.top-right{right:-11px;top:100%;margin-top:20px;", "{bottom:100%;right:6px;&:after{top:30px;right:5px;}}}&.top-left{left:-11px;top:100%;margin-top:20px;", "{bottom:100%;left:6px;&:after{top:30px;left:5px;}}}&.bottom-right{right:-11px;top:100%;margin-top:20px;", "{bottom:100%;right:6px;&:after{top:30px;right:5px;}}}&.bottom-left{left:-11px;top:100%;margin-top:20px;", "{bottom:100%;left:6px;&:after{top:30px;left:5px;}}}&.left-top{left:100%;top:-11px;margin-left:20px;", "{right:100%;top:6px;&:after{top:5px;left:30px;}}}&.left-bottom{left:100%;bottom:-11px;margin-left:20px;", "{right:100%;bottom:6px;&:after{bottom:5px;left:30px;}}}&.right-top{right:100%;top:-11px;margin-right:20px;", "{left:100%;top:6px;&:after{top:5px;right:30px;}}}&.right-bottom{right:100%;bottom:-11px;margin-right:20px;", "{left:100%;bottom:6px;&:after{bottom:5px;right:30px;}}}"], _Triangle.default, _Triangle.default, _Triangle.default, _Triangle.default, _Triangle.default, _Triangle.default, _Triangle.default, _Triangle.default);

var _default = Container;
exports.default = _default;

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

module.exports = "<div class=\"storefront-slider__scope\"> <div class=\"storefront-overlay\" ng-class=\"{'storefront-overlay--open': storefrontCtrl.isOpen}\" ng-click=\"storefrontCtrl.close()\"></div> <div class=\"storefront-slider\" id=\"storefront-slider\" ng-class=\"{\n        'storefront-slider--open': storefrontCtrl.isOpen,\n        'storefront-slider--tablet': storefrontCtrl.resolution === 'tablet',\n        'storefront-slider--mobile': storefrontCtrl.resolution === 'mobile',\n        'storefront-slider--fullscreen': storefrontCtrl.resolution === 'fullscreen'}\"> <div class=\"storefront-overlay\" ng-class=\"{'storefront-overlay--closed': !storefrontCtrl.isOpen}\" ng-click=\"storefrontCtrl.open()\" gtm-click-event=\"admin_{{storefrontCtrl.currentPage}}_storefront-preview-openPreview\"> <hotspot hotspot-id=\"'slider.slider'\" modal-title=\"'Your Storefront'\" modal-description=\"'Your store\\'s homepage. This panel lives on every admin page.'\" anchor=\"'right-top'\"/> </div> <hotspot hotspot-id=\"'slider.resize'\" modal-title=\"'Resize me!'\" modal-description=\"'You can grab the edge of the panel and resize it to any width.'\" anchor=\"'left-top'\" class=\"hotspot--resize\" ng-show=\"storefrontCtrl.isOpen\"/> <div class=\"storefront-slider__divider\" id=\"storefront-slider__divider\"> <div class=\"storefront-slider__divider-inner\"> <div class=\"storefront-slider__divider-drag\"> <span></span> <span></span> <span></span> </div> </div> </div> <div class=\"storefront-slider__header storefront-slider__header--open\" id=\"storefront-slider__header\" md-helper> <hotspot hotspot-id=\"'slider.storeUrl'\" modal-title=\"'Here\\'s your store URL'\" modal-description=\"'This is the address you can use to share with the world!'\" anchor=\"'top-left'\" class=\"hotspot--url\"/> <div class=\"header__left\"> <md-button ng-if=\"storefrontCtrl.isOpen\" id=\"storefront-slider__close-button\" class=\"md-icon-button header__icon header__icon--close\" ng-click=\"storefrontCtrl.close()\" gtm-click-event=\"admin_{{storefrontCtrl.currentPage}}_storefront-preview-closePreview\"> <md-icon>close</md-icon> </md-button> <md-button ng-if=\"!storefrontCtrl.isOpen\" class=\"md-icon-button header__icon header__icon--open\"> <md-icon>desktop_windows</md-icon> </md-button> </div> <div class=\"header__center\" ng-if=\"!storefrontCtrl.isThemePreview && storefrontCtrl.pageUrl\"> <div id=\"storefront-slider__address-bar\" class=\"storefront-slider__address-bar\"> <div class=\"address-bar__nav address-bar--no-content\" ng-if=\"storefrontCtrl.canNavigate\"></div> <span class=\"address-bar__nav address-bar__nav--disabled\" ng-if=\"!storefrontCtrl.canNavigate\"> <a class=\"address-bar_lock\"><md-icon>lock_outline</md-icon></a> </span> <span class=\"address-bar__text\">{{storefrontCtrl.pageUrl}}</span> <a class=\"address-bar__link\" id=\"storefront-slider__address-bar__link\" ng-href=\"{{storefrontCtrl.pageUrl}}\" target=\"_blank\" gtm-click-event=\"admin_{{storefrontCtrl.currentPage}}_storefront-preview-openStoreInNewTab\"> <md-icon>open_in_new</md-icon> </a> </div> </div> <div class=\"header__center\" ng-if=\"storefrontCtrl.isThemePreview\"> <span class=\"storefront-slider__title\">{{'LABEL.THEMEPREVIEW' | translate: {'TITLE': storefrontCtrl.themeTitle} }}</span> </div> <div class=\"header__right\"> <md-button id=\"storefront-slider__split-view-button\" class=\"md-icon-button header__icon\" ng-class=\"{'header__icon--active': storefrontCtrl.splitViewEnabled}\" gtm-click-event=\"admin_{{storefrontCtrl.currentPage}}_storefront-preview-toggleSplitView\" ng-if=\"storefrontCtrl.checkSplitViewSupport() && !storefrontCtrl.isEditStore && storefrontCtrl.browserWidth > storefrontCtrl.DEVICE_WIDTH.tablet\" ng-click=\"storefrontCtrl.toggleSplitView()\"> <md-icon>flip</md-icon> </md-button> <div class=\"storefront-slider__devices-button-wrap\" ng-if=\"storefrontCtrl.browserWidth > storefrontCtrl.DEVICE_WIDTH.tablet\"> <hotspot hotspot-id=\"'slider.devices'\" modal-title=\"'See device preview'\" modal-description=\"'Select different devices to see how your store will look on desktop, tablet, and mobile.'\" anchor=\"'top-right'\" class=\"hotspot--devices\"/> <md-menu md-position-mode=\"target-right target\"> <md-button class=\"md-icon-button header__menu-button header__icon\" ng-click=\"$mdMenu.open($event)\" gtm-click-event=\"admin_{{storefrontCtrl.currentPage}}_storefront-preview-openViewportMenu\" id=\"storefront-slider__browser-width-button\"> <md-icon>devices</md-icon> </md-button> <md-menu-content class=\"storefront-header\"> <md-menu-item ng-if=\"storefrontCtrl.browserWidth >= storefrontCtrl.DEVICE_WIDTH.desktop\"> <md-button class=\"header__menu-item\" ng-click=\"storefrontCtrl.resize('desktop')\" gtm-click-event=\"admin_{{storefrontCtrl.currentPage}}_storefront-preview-desktopViewport\"> <div class=\"item__content\"> <p>{{'LABEL.DESKTOPWIDTH' | translate}}</p> <md-icon>desktop_windows</md-icon> </div> </md-button> </md-menu-item> <md-menu-item ng-if=\"storefrontCtrl.browserWidth >= storefrontCtrl.DEVICE_WIDTH.tablet\"> <md-button class=\"header__menu-item\" ng-click=\"storefrontCtrl.resize('tablet')\" gtm-click-event=\"admin_{{storefrontCtrl.currentPage}}_storefront-preview-tabletViewport\"> <div class=\"item__content\"> <p>{{'LABEL.TABLETWIDTH' | translate}}</p> <md-icon>tablet</md-icon> </div> </md-button> </md-menu-item> <md-menu-item ng-if=\"storefrontCtrl.browserWidth >= storefrontCtrl.DEVICE_WIDTH.mobile\"> <md-button class=\"header__menu-item\" ng-click=\"storefrontCtrl.resize('mobile')\" gtm-click-event=\"admin_{{storefrontCtrl.currentPage}}_storefront-preview-mobileViewport\"> <div class=\"item__content\"> <p>{{'LABEL.MOBILEWIDTH' | translate}}</p> <md-icon>smartphone</md-icon> </div> </md-button> </md-menu-item> <md-menu-item> <md-button class=\"header__menu-item\" ng-click=\"storefrontCtrl.resize('fullscreen')\" gtm-click-event=\"admin_{{storefrontCtrl.currentPage}}_storefront-preview-fullscreenViewport\"> <div class=\"item__content\"> <p>{{'LABEL.FULLSCREEN' | translate}}</p> <md-icon>fullscreen</md-icon> </div> </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> <div class=\"storefront-slider__store-button-wrap\" ng-if=\"!storefrontCtrl.isEditStore && !storefrontCtrl.isThemePreview\"> <hotspot hotspot-id=\"'slider.editor'\" modal-title=\"'Edit your store!'\" modal-description=\"'Click the pencil to change your store’s content and styles.'\" anchor=\"'top-right'\" class=\"hotspot--editstore\"/> <md-button id=\"storefront-slider__store-button\" class=\"header__icon header__icon--store md-icon-button\" ng-click=\"storefrontCtrl.edit()\" gtm-click-event=\"admin_{{storefrontCtrl.currentPage}}_storefront-preview-editStore\"> <md-icon>mode_edit</md-icon> </md-button> </div> </div> </div> <div class=\"storefront-slider__content\"> <div class=\"storefront-slider__iframe-wrap\"></div> <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"60\" ng-if=\"!storefrontCtrl.hasStorefrontLoaded\" class=\"storefront-slider__circularloader md-theme md-accent\"> </md-progress-circular> </div> </div> </div> ";

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenStorefrontSliderModule = void 0;

var _storefrontSlider = __webpack_require__(198);

var OpenStorefrontSliderModule = angular.module('app.components.storefrontSlider.openStorefrontSliderDirective', [_storefrontSlider.StorefrontSliderServiceModule]).directive('openStorefrontSlider', ["storefrontSliderService", function (storefrontSliderService) {
  return {
    restrict: 'A',
    link: function link(scope, element) {
      element.on('click', storefrontSliderService.openSlider);
      scope.$on('$destroy', function () {
        element.off('click', storefrontSliderService.openSlider);
      });
    }
  };
}]).name;
exports.OpenStorefrontSliderModule = OpenStorefrontSliderModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrialStatusBarModule = void 0;

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _myAccount = __webpack_require__(84);

var _launchChangePlan = __webpack_require__(102);

var _launchDarkly = __webpack_require__(30);

var _storeInformation = __webpack_require__(38);

var _trial = __webpack_require__(60);

var _trialStatusBar = _interopRequireDefault(__webpack_require__(1388));

__webpack_require__(1389);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TrialStatusBarModule = angular.module('app.components.trialStatusBar', [_angularTranslate.default, _angularjs.default, _myAccount.MyAccountServiceModule, _launchChangePlan.LaunchChangePlanServiceModule, _launchDarkly.LaunchDarklyServiceModule, _storeInformation.StoreInformationServiceModule, _trial.TrialServiceModule]).component('trialStatusBar', {
  template: _trialStatusBar.default,
  bindings: {
    trialStatus: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    TrialStatusBar.$inject = ["launchChangePlanService", "trialService", "myAccountService", "launchDarklyService", "storeInformationService", "$translate", "$rootScope", "$state"];

    function TrialStatusBar(launchChangePlanService, trialService, myAccountService, launchDarklyService, storeInformationService, $translate, $rootScope, $state) {
      'ngInject';

      _classCallCheck(this, TrialStatusBar);

      (0, _assign.default)(this, {
        launchChangePlanService: launchChangePlanService,
        trialService: trialService,
        myAccountService: myAccountService,
        launchDarklyService: launchDarklyService,
        storeInformationService: storeInformationService,
        $translate: $translate,
        $rootScope: $rootScope,
        $state: $state,
        showClass: 'trial-status-bar-open',
        translationKeys: ['TRIALSTATUSBAR.TIMEREMAINING', 'TRIALSTATUSBAR.TIMEREMAININGSHORT', 'TRIALSTATUSBAR.TRIALEXPIRED', 'TRIALSTATUSBAR.TRIALEXPIREDSHORT']
      });
    }

    _createClass(TrialStatusBar, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.myAccountService.getUser().then(function (user) {
          _this.name = user.firstName;

          _this.$translate(_this.translationKeys, {
            NAME: _this.name,
            TIMEREMAINING: _this.trialStatus
          }).then(function (translations) {
            _this.translations = translations;

            _this.handlePageChange(_this.$state.current.name);
          });
        });
        this.unbindStateChangeSuccess = this.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
          _this.handlePageChange(toState.name);
        });
        this.launchDarklyService.isElementStore(this.storeInformationService).then(function (isElementStore) {
          return _this.isElementStore = isElementStore;
        });
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.hide();
        this.unbindStateChangeSuccess();
      }
    }, {
      key: "openPlans",
      value: function openPlans(ev) {
        this.launchChangePlanService.openModal(ev, null, true);
      }
    }, {
      key: "handlePageChange",
      value: function handlePageChange(stateName) {
        this.stateName = stateName;

        if (this.stateIsDashboard()) {
          this.hide();
        } else {
          this.show();
        }
      }
    }, {
      key: "stateIsDashboard",
      value: function stateIsDashboard() {
        return false; // The status bar is showing everywhere in the trial now
      }
    }, {
      key: "show",
      value: function show() {
        angular.element('body').addClass(this.showClass);
      }
    }, {
      key: "hide",
      value: function hide() {
        angular.element('body').removeClass(this.showClass);
      }
    }]);

    return TrialStatusBar;
  }()
}).name;
exports.TrialStatusBarModule = TrialStatusBarModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

module.exports = "<div class=\"trial-status-bar\" ng-class=\"{\n    'trial-status-bar--grey': !$ctrl.stateIsDashboard(),\n    'trial-status-bar--element-store': $ctrl.isElementStore\n}\"> <span class=\"trial-status-bar__text\"> <span ng-if=\"$ctrl.trialStatus !== 'EXPIRED' && $ctrl.trialStatus !== 'PARKED'\"> <span hide-xs ng-bind-html=\"$ctrl.translations['TRIALSTATUSBAR.TIMEREMAINING']\"></span> <span hide-gt-xs ng-bind-html=\"$ctrl.translations['TRIALSTATUSBAR.TIMEREMAININGSHORT']\"> </span> </span> <span ng-if=\"$ctrl.trialStatus === 'PARKED' || $ctrl.trialStatus === 'EXPIRED'\"> <span hide-xs>{{$ctrl.translations['TRIALSTATUSBAR.TRIALEXPIRED']}}</span> <span hide-gt-xs>{{$ctrl.translations['TRIALSTATUSBAR.TRIALEXPIREDSHORT']}}</span> </span> </span> <md-button class=\"trial-status-bar__button md-accent md-raised\" ng-click=\"$ctrl.openPlans($event)\"> <span>Start Selling</span> </md-button> </div>";

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoSliderModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _storefrontSlider = __webpack_require__(198);

var _storeInformation = __webpack_require__(38);

var _launchDarkly = __webpack_require__(30);

var _videoSlider = __webpack_require__(1391);

var _videoSlider2 = _interopRequireDefault(__webpack_require__(1392));

__webpack_require__(1393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VIDEO_SLIDER_CLASS = 'video-slider-open';
var SLIDER_WIDTH = 350;
var DESKTOP_WIDTH_BREAKPOINT = 992;
var MOBILE_WIDTH_BREAKPOINT = 600;
var NAV_WIDTH_SMALL = 64;
var NAV_WIDTH = 180;
var EMPTY_PAGE_WIDTH_OFFSET = 10;
var VideoSliderModule = angular.module('vln.videoSlider', [_angularjs.default, _videoSlider.VideoSliderData, _storefrontSlider.StorefrontSliderServiceModule, _storeInformation.StoreInformationServiceModule, _launchDarkly.LaunchDarklyServiceModule]).component('videoSlider', {
  template: _videoSlider2.default,
  bindings: {},
  controller:
  /*#__PURE__*/
  function () {
    VideoSliderController.$inject = ["videoSliderData", "$rootScope", "$window", "storefrontSliderService", "storeInformationService", "launchDarklyService", "$timeout", "$document", "$state"];

    function VideoSliderController(videoSliderData, $rootScope, $window, storefrontSliderService, storeInformationService, launchDarklyService, $timeout, $document, $state) {
      'ngInject';

      _classCallCheck(this, VideoSliderController);

      (0, _assign.default)(this, {
        videoSliderData: videoSliderData,
        $rootScope: $rootScope,
        $window: $window,
        $document: $document,
        $timeout: $timeout,
        $state: $state,
        storefrontSliderService: storefrontSliderService,
        storeInformationService: storeInformationService,
        launchDarklyService: launchDarklyService,
        events: [],
        isOpen: false,
        elements: {
          page: angular.element('.page'),
          pageHeader: angular.element('.page__header'),
          slider: angular.element('.vln-videoslider'),
          body: angular.element('body'),
          trialStatus: angular.element('.trial-status-bar')
        }
      });
    }

    _createClass(VideoSliderController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.initEvents();
        this.getBaseWidths();
        this.launchDarklyService.isElementStore(this.storeInformationService).then(function (isElementStore) {
          return _this.isElementStore = isElementStore;
        });
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.unbindEvents();
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) return;
        this.isOpen = true;
        if (!this.isElementStore) this.storefrontSliderService.closeSlider();
        angular.element('body').addClass(VIDEO_SLIDER_CLASS);
        this.resizeViews();
        this.$rootScope.$emit('videoSliderModule:sliderOpened');
      }
    }, {
      key: "close",
      value: function close() {
        angular.element('body').removeClass(VIDEO_SLIDER_CLASS);
        this.isOpen = false;
        this.video = undefined;
        this.resizeViews();
        this.$rootScope.$emit('videoSliderModule:sliderClosed');
      }
    }, {
      key: "initEvents",
      value: function initEvents() {
        var _this2 = this;

        this.events.push(this.$rootScope.$on('videoSliderService:openSlider', function (e, name) {
          _this2.video = _this2.videoSliderData.videos[name];

          _this2.open();
        }), this.$rootScope.$on('videoSliderService:closeSlider', function () {
          _this2.close();
        }), this.$rootScope.$on('$stateChangeSuccess', this.pageLoadHandler.bind(this)));
        angular.element(this.$window).on('resize', this.browserResizeHandler.bind(this));
      }
    }, {
      key: "unbindEvents",
      value: function unbindEvents() {
        this.events.forEach(function (handler) {
          handler();
        });
        angular.element(this.$window).off('resize', this.browserResizeHandler);
      }
    }, {
      key: "pageLoadHandler",
      value: function pageLoadHandler() {
        var _this3 = this;

        this.$timeout(function () {
          _this3.refreshPageReferences();

          _this3.resizeViews();
        }, 0);
      }
    }, {
      key: "refreshPageReferences",
      value: function refreshPageReferences() {
        this.elements.page = angular.element('.page');
        this.elements.pageHeader = angular.element('.page__header');
        this.elements.trialStatus = angular.element('.trial-status-bar');
      }
    }, {
      key: "getBaseWidths",
      value: function getBaseWidths() {
        this.setNavWidth();
        this.getBrowserWidth();
        this.adminPageBaseWidth = this.browserWidth - this.navWidth;
        if (this.isEditStorePage(this.$state.current.name)) this.adminPageBaseWidth = this.browserWidth;
      }
    }, {
      key: "setNavWidth",
      value: function setNavWidth() {
        this.navWidth = angular.element('body').hasClass('nav-menu__small') ? NAV_WIDTH_SMALL : NAV_WIDTH;
      }
    }, {
      key: "isEditStorePage",
      value: function isEditStorePage(page) {
        return page && page.indexOf('editstore') !== -1;
      }
    }, {
      key: "resizeViews",
      value: function resizeViews() {
        this.getBaseWidths();

        if (this.isOpen && this.isDesktop) {
          var pageWidth = this.adminPageBaseWidth;

          if (this.elements.page.hasClass('page--empty')) {
            pageWidth -= NAV_WIDTH - EMPTY_PAGE_WIDTH_OFFSET;
          } else {
            pageWidth -= SLIDER_WIDTH;
          }

          this.elements.pageHeader.css('right', "".concat(SLIDER_WIDTH, "px"));
          this.elements.page.css('width', "".concat(pageWidth, "px"));
          this.elements.trialStatus.css('width', "calc(100% - ".concat(SLIDER_WIDTH, "px"));
        } else {
          this.elements.pageHeader.css('right', '');
          this.elements.page.css('width', '');
          this.elements.trialStatus.css('width', '');
        }
      }
    }, {
      key: "getBrowserWidth",
      value: function getBrowserWidth() {
        this.browserWidth = $(this.$window).width();
        this.isMobile = this.browserWidth < MOBILE_WIDTH_BREAKPOINT;
        this.isDesktop = this.browserWidth >= DESKTOP_WIDTH_BREAKPOINT;
      }
    }, {
      key: "browserResizeHandler",
      value: function browserResizeHandler() {
        var _this4 = this;

        if (!this.isOpen) return;
        this.getBaseWidths();
        var transitionProperty = 'transition';
        var oldTransitionDuration = this.elements.page.css(transitionProperty);
        this.elements.page.css(transitionProperty, 'none');
        this.resizeViews();
        this.$timeout(function () {
          _this4.elements.page.css(transitionProperty, oldTransitionDuration);
        }, 0);
      }
    }]);

    return VideoSliderController;
  }()
}).name;
exports.VideoSliderModule = VideoSliderModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(101)))

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoSliderData = void 0;
var VideoSliderData = angular.module('vln.videoSlider.videoSliderData', []).constant('videoSliderData', {
  videos: {
    themes: {
      link: 'https://fast.wistia.net/embed/iframe/r9rc404gxc',
      title: 'VIDEOSLIDER.THEMES_TITLE',
      text: 'VIDEOSLIDER.THEMES_TEXT'
    },
    logo: {
      link: 'https://fast.wistia.net/embed/iframe/5hcygxcjo4',
      title: 'VIDEOSLIDER.LOGO_TITLE',
      text: 'VIDEOSLIDER.LOGO_TEXT'
    },
    products: {
      link: 'https://fast.wistia.net/embed/iframe/vjoqm3rle7',
      title: 'VIDEOSLIDER.PRODUCTS_TITLE',
      text: 'VIDEOSLIDER.PRODUCTS_TEXT'
    },
    categories: {
      link: 'https://fast.wistia.net/embed/iframe/jp1le6fnwz',
      title: 'VIDEOSLIDER.CATEGORIES_TITLE',
      text: 'VIDEOSLIDER.CATEGORIES_TEXT'
    },
    pages: {
      link: 'https://fast.wistia.net/embed/iframe/z8flvgf0hy',
      title: 'VIDEOSLIDER.PAGES_TITLE',
      text: 'VIDEOSLIDER.PAGES_TEXT'
    },
    settings: {
      link: 'https://fast.wistia.net/embed/iframe/xeb5wxz6p4',
      title: 'VIDEOSLIDER.SETTINGS_TITLE',
      text: 'VIDEOSLIDER.SETTINGS_TEXT'
    }
  }
}).name;
exports.VideoSliderData = VideoSliderData;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.video\"> <div class=\"vln-videoslider\"> <div class=\"vln-videoslider__header\" layout=\"row\" layout-align=\"center center\" ng-click=\"$ctrl.close()\"> <span layout=\"row\" layout-align=\"center center\"> <md-icon>close</md-icon> {{'LABEL.CLOSE_VIDEO' | translate}} </span> </div> <div class=\"vln-videoslider__iframe\"> <iframe width=\"350\" height=\"525\" ng-src=\"{{$ctrl.video.link}}\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe> </div> <div class=\"vln-videoslider__text-content\"> <div class=\"vln-videoslider__text-content__heading\">{{$ctrl.video.title | translate}}</div> <div class=\"vln-videoslider__text-content__text\" ng-bind-html=\"$ctrl.video.text | translate\"></div> </div> </div> <div class=\"vln-videoslider-overlay\" ng-if=\"!$ctrl.isDesktop\" ng-click=\"$ctrl.close()\"></div> </div>";

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsModule = void 0;

var _react2angular = __webpack_require__(97);

var _index = _interopRequireDefault(__webpack_require__(1395));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TermsAndConditionsModule = angular.module('app.components.TermsAndConditionsModal.termsAndConditionsModal', []).component('termsAndConditionsModal', (0, _react2angular.react2angular)(_index.default)).name;
exports.TermsAndConditionsModule = TermsAndConditionsModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _Modal = __webpack_require__(385);

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

var _grid = __webpack_require__(83);

var _thread = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOS_LINK = 'https://www.volusion.com/terms-of-service';
var ACCEPTABLE_USE_LINK = 'https://www.volusion.com/acceptable-use-policy';
var StyledModal = (0, _styledComponents.default)(_Modal.Modal).withConfig({
  displayName: "TermsAndConditionsModal__StyledModal",
  componentId: "ucofcn-0"
})(["overflow:auto;"]);
var ModalContent = (0, _styledComponents.default)(_grid.Flex).attrs({
  flexDirection: 'column'
}).withConfig({
  displayName: "TermsAndConditionsModal__ModalContent",
  componentId: "ucofcn-1"
})(["padding:16px;font-size:16px;color:", ";width:100%;max-width:400px;"], _thread.colors.black54);

var A = _styledComponents.default.a.withConfig({
  displayName: "TermsAndConditionsModal__A",
  componentId: "ucofcn-2"
})(["color:", ";&:visited,&:hover{color:", ";}"], _thread.colors.primaryOrange, _thread.colors.primaryOrange);

var P = _styledComponents.default.p.withConfig({
  displayName: "TermsAndConditionsModal__P",
  componentId: "ucofcn-3"
})(["padding:0 0 16px;"]);

var TermsAndConditionsModal = function TermsAndConditionsModal(props) {
  return _react.default.createElement(StyledModal, {
    open: props.open,
    container: props.container
  }, _react.default.createElement(ModalContent, null, _react.default.createElement(_grid.Box, null, _react.default.createElement(P, null, _react.default.createElement("span", null, "We have updated our "), _react.default.createElement(A, {
    href: TOS_LINK,
    target: "tos"
  }, "Terms of Service"), _react.default.createElement("span", null, " which incorporates our "), _react.default.createElement(A, {
    href: ACCEPTABLE_USE_LINK,
    target: "tos"
  }, "Acceptable Use Policy and Privacy Policy"), _react.default.createElement("span", null, " (collectively \u201CTerms\u201D). Please review each one carefully.")), _react.default.createElement(P, null, "After reviewing the updates, click \u201CAgree\u201D below to proceed to your admin.")), _react.default.createElement(_thread.Button, {
    onClick: props.onAccept,
    variant: "primary"
  }, "Agree")));
};

TermsAndConditionsModal.propTypes = {
  open: _propTypes.default.bool.isRequired,
  onAccept: _propTypes.default.func.isRequired,
  container: _propTypes.default.object
};
var _default = TermsAndConditionsModal;
exports.default = _default;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsServiceModule = void 0;

var _data = __webpack_require__(11);

var TermsAndConditionsServiceModule = angular.module('app.services.data.termsAndConditionsService', [_data.DataServiceModule]).service('termsAndConditionsService', ["dataService", "settings", function (dataService, settings) {
  return {
    getTerms: getTerms,
    getAcceptedTermsById: getAcceptedTermsById,
    acceptTerms: acceptTerms
  };

  function getTerms() {
    return dataService.get(settings.api.terms);
  }

  function getAcceptedTermsById(termsId) {
    return dataService.get(settings.api.acceptedTerms, termsId);
  }

  function acceptTerms(termsId, acceptedBy) {
    return dataService.create(settings.api.acceptedTerms, {
      termsId: termsId,
      acceptedBy: acceptedBy
    });
  }
}]).name;
exports.TermsAndConditionsServiceModule = TermsAndConditionsServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PagesModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _error = __webpack_require__(1399);

var _pinterest = __webpack_require__(1403);

var _siteDesigner = __webpack_require__(1457);

var _storeCredit = __webpack_require__(1459);

var _mailchimp = __webpack_require__(1460);

var _externalFulfiller = __webpack_require__(1462);

var _amazon = __webpack_require__(1464);

var _quickbooks = __webpack_require__(1466);

var _xero = __webpack_require__(1468);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PagesModule = angular.module('app.pages', [_angularjs.default, _error.ErrorPageModule, _pinterest.PinterestModule, _siteDesigner.SiteDesignerModule, _storeCredit.StoreCreditModule, _mailchimp.MailChimpModule, _externalFulfiller.ExternalFulfillerModule, _amazon.AmazonModule, _quickbooks.QuickbooksModule, _xero.XeroModule]).config(["$stateProvider", function ($stateProvider) {
  function loadLazyModule(transition, moduleName) {
    var $injector = transition.injector().get('$injector');
    return $injector.loadNewModules([moduleName]);
  }

  $stateProvider.state({
    parent: 'guest',
    name: 'login.**',
    url: '/login',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1715)).then(function (module) {
        return loadLazyModule(transition, module.LoginModule);
      });
    }
  }).state({
    name: 'checkout.**',
    url: '/checkout',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1716)).then(function (module) {
        return loadLazyModule(transition, module.CheckoutModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'dashboard.**',
    url: '/dashboard',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1717)).then(function (module) {
        return loadLazyModule(transition, module.DashboardModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'customer.**',
    url: '/customer',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1718)).then(function (module) {
        return loadLazyModule(transition, module.CustomersModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'postage.**',
    url: '/postage',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1719)).then(function (module) {
        return loadLazyModule(transition, module.PostageModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'pages.**',
    url: '/pages',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1720)).then(function (module) {
        return loadLazyModule(transition, module.PagesModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'appstore2.**',
    url: '/appstore2',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1721)).then(function (module) {
        return loadLazyModule(transition, module.AppStoreModule2);
      });
    }
  }).state({
    parent: 'auth',
    name: 'category.**',
    url: '/category',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1722)).then(function (module) {
        return loadLazyModule(transition, module.CategoriesOldModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'categories.**',
    url: '/categories',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1723)).then(function (module) {
        return loadLazyModule(transition, module.CategoriesModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'myAccount.**',
    url: '/myaccount',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1724)).then(function (module) {
        return loadLazyModule(transition, module.MyAccountModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'discounts.**',
    url: '/discounts',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1725)).then(function (module) {
        return loadLazyModule(transition, module.DiscountsModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'fulfillers.**',
    url: '/fulfillers',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1726)).then(function (module) {
        return loadLazyModule(transition, module.FulfillersModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'order.**',
    url: '/order',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1727)).then(function (module) {
        return loadLazyModule(transition, module.OrdersModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'editstore.**',
    url: '/editstore',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1728)).then(function (module) {
        return loadLazyModule(transition, module.EditStoreModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'product.**',
    url: '/product',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1729)).then(function (module) {
        return loadLazyModule(transition, module.ProductsModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'settings.**',
    url: '/settings',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1730)).then(function (module) {
        return loadLazyModule(transition, module.SettingsModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'analytics.**',
    url: '/analytics',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1731)).then(function (module) {
        return loadLazyModule(transition, module.AnalyticsModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'facebookPixel.**',
    url: '/facebookpixel',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1732)).then(function (module) {
        return loadLazyModule(transition, module.FacebookPixelModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'fullstory.**',
    url: '/fullstory',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1733)).then(function (module) {
        return loadLazyModule(transition, module.FullstoryModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'googleAnalytics.**',
    url: '/googleanalytics',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1734)).then(function (module) {
        return loadLazyModule(transition, module.GoogleAnalyticsModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'privy.**',
    url: '/privy',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1735)).then(function (module) {
        return loadLazyModule(transition, module.PrivyModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'chat.**',
    url: '/chat',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1736)).then(function (module) {
        return loadLazyModule(transition, module.ChatModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'zapier.**',
    url: '/zapier',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1737)).then(function (module) {
        return loadLazyModule(transition, module.ZapierModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'yotpo.**',
    url: '/yotpo',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1738)).then(function (module) {
        return loadLazyModule(transition, module.YotpoModule);
      });
    }
  }).state({
    parent: 'auth',
    name: 'avalara',
    url: '/avalara'
  }).state({
    parent: 'auth',
    name: 'cancelStore.**',
    url: '/cancel-store',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1739)).then(function (module) {
        return loadLazyModule(transition, module.CancelStoreModule);
      });
    }
  }).state({
    name: 'delinquentAccount.**',
    url: '/myaccount/pastdue',
    parent: 'auth',
    template: '<delinquent-account></delinquent-account>',
    data: {
      showSideNavigationMenu: false
    },
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1740)).then(function (module) {
        return loadLazyModule(transition, module.DelinquentAccountModule);
      });
    }
  }).state({
    name: 'onHold.**',
    url: '/onhold',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1741)).then(function (module) {
        return loadLazyModule(transition, module.OnHoldPage);
      });
    }
  }).state({
    name: 'siteTagging.**',
    url: '/site-tagging',
    lazyLoad: function lazyLoad(transition) {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1742)).then(function (module) {
        return loadLazyModule(transition, module.SiteTaggingPage);
      });
    }
  });
}]).name;
exports.PagesModule = PagesModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorPageModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _auth = __webpack_require__(77);

var _error = __webpack_require__(1400);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorPageModule = angular.module('app.pages.error', [_auth.AuthServiceModule, _angularjs.default]).component('errorPage', _error.errorPageComponent).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('error', {
    url: '/error',
    component: 'errorPage',
    data: {
      page: 'error'
    }
  });
}]).name;
exports.ErrorPageModule = ErrorPageModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorPageComponent = void 0;

var _error = _interopRequireDefault(__webpack_require__(1401));

__webpack_require__(1402);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var errorPageComponent = {
  template: _error.default,
  controller:
  /*#__PURE__*/
  function () {
    ErrorController.$inject = ["auth0AuthService"];

    function ErrorController(auth0AuthService) {
      'ngInject';

      _classCallCheck(this, ErrorController);

      this.auth0AuthService = auth0AuthService;
    }

    _createClass(ErrorController, [{
      key: "logout",
      value: function logout() {
        this.auth0AuthService.logout();
      }
    }]);

    return ErrorController;
  }()
};
exports.errorPageComponent = errorPageComponent;

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

module.exports = "<div class=\"error\"> <logo></logo> <div class=\"error__content\"> <div class=\"error__content-inner\"> <div> <md-icon md-svg-src=\"/assets/dead-eyed.svg\" class=\"error__emoticon\"></md-icon> </div> <div class=\"error__title\">{{'ERRORPAGE.TITLE' | translate}}</div> <div class=\"error__message\">{{'ERRORPAGE.MESSAGE' | translate}}</div> <div class=\"error__buttons\"> <status-page-link>{{'ERRORPAGE.STATUSPAGE' | translate}}</status-page-link> <md-button ui-sref=\"dashboard\">{{'ERRORPAGE.REFRESH' | translate}}</md-button> <md-button ng-click=\"$ctrl.logout()\">{{'ERRORPAGE.LOGOUT' | translate}}</md-button> </div> </div> </div> </div>";

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PinterestModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _appShell = __webpack_require__(117);

__webpack_require__(1456);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* pinterest module */
var PinterestModule = angular.module('app.pages.pinterest', [_angularjs.default, _appShell.AppShellModule]).config(["$stateProvider", function ($stateProvider) {
  'ngInject';

  $stateProvider.state({
    parent: 'apps',
    name: 'pinterest',
    url: '/pinterest',
    component: 'appShell',
    resolve: {
      title: function title() {
        return 'Pinterest';
      },
      trackingId: function trackingId() {
        return 'pinterest';
      },
      src: function src() {
        return 'https://volusion-pinterest-app-168120.appspot.com';
      }
    },
    data: {
      page: 'pinterest'
    }
  });
}]).name;
exports.PinterestModule = PinterestModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppShellComponent = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _pageHeader = __webpack_require__(622);

var _pageContent = __webpack_require__(620);

var _segment = __webpack_require__(58);

var _appShell = _interopRequireDefault(__webpack_require__(1455));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AppShellComponent = angular.module('app.pages.appShell.appShellComponent', [_angularjs.default, _pageHeader.PageHeaderModule, _pageContent.PageContentModule, _segment.SegmentServiceModule]).component('appShell', {
  template: _appShell.default,
  bindings: {
    title: '<',
    src: '<',
    trackingId: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    AppShellController.$inject = ["$scope", "$window", "$state", "$sce", "segmentService"];

    function AppShellController($scope, $window, $state, $sce, segmentService) {
      'ngInject';

      _classCallCheck(this, AppShellController);

      (0, _assign.default)(this, {
        $scope: $scope,
        $window: $window,
        $state: $state,
        $sce: $sce,
        segmentService: segmentService
      });
    }

    _createClass(AppShellController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.trustedSrc = this.$sce.trustAsResourceUrl(this.src);
        this.$window.addEventListener('message', function (e) {
          return _this.onIframeMessage(e, ["https://volusion-pinterest-app-168120.appspot.com","https://dropshipping.v2-sandbox.volusion.com","https://staging.mailchimp.volusion.citrusbyte.com","https://dev.mailchimp.volusion.citrusbyte.com","https://volusion-amazon.citrusbyte.host","https://design.v2-sandbox.volusion.com","https://sandbox.onesaas.com","https://l.toolkite.com"]);
        });
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        var _this2 = this;

        this.$window.removeEventListener('message', function (e) {
          return _this2.onIframeMessage(e, ["https://volusion-pinterest-app-168120.appspot.com","https://dropshipping.v2-sandbox.volusion.com","https://staging.mailchimp.volusion.citrusbyte.com","https://dev.mailchimp.volusion.citrusbyte.com","https://volusion-amazon.citrusbyte.host","https://design.v2-sandbox.volusion.com","https://sandbox.onesaas.com","https://l.toolkite.com"]);
        });
      }
    }, {
      key: "onIframeMessage",
      value: function onIframeMessage(event, origins) {
        if (!this.validateIframeEventOrigin(event.origin, origins)) {
          return;
        }

        var allowedStates = ['dashboard', 'order.list', 'product.list', 'category.list', 'customer.list'];

        if (allowedStates.includes(event.data.state)) {
          return this.$state.go(event.data.state);
        }

        var allowedDetailStates = ['product.detail', 'order.detail', 'category.detail', 'customer.add', 'customer.edit'];

        if (allowedDetailStates.includes(event.data.state)) {
          return this.$state.go(event.data.state, {
            id: event.data.id
          });
        }

        var allowedAppStates = ['app'];
        var allowedApps = ['mailchimp', 'siteDesigner'];

        if (allowedAppStates.includes(event.data.state) && allowedApps.includes(event.data.id)) {
          return this.$state.go(event.data.id, {
            queryString: event.data.queryString
          });
        }
      }
    }, {
      key: "validateIframeEventOrigin",
      value: function validateIframeEventOrigin(eventOrigin, validOrigins) {
        return validOrigins.indexOf(eventOrigin) >= 0;
      }
    }]);

    return AppShellController;
  }()
}).name;
exports.AppShellComponent = AppShellComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderScrollDirectiveModule = void 0;
var HeaderScrollDirectiveModule = angular.module('app.directives.headerScroll', []).directive('headerScroll', ["$window", function ($window) {
  return {
    link: function link(scope, ele) {
      angular.element($window).on('scroll', scrollWatcher);
      angular.element('.page').on('scroll', scrollWatcher);
      angular.element('body.safari-mobile .layout__scope').on('scroll', scrollWatcher);
      scope.$on('$destroy', function () {
        angular.element($window).off('scroll', scrollWatcher);
      });

      function scrollWatcher(e) {
        if (angular.element(e.target).scrollTop() > 0) {
          ele.addClass('page__header--scroll');
        } else {
          ele.removeClass('page__header--scroll');
        }
      }
    }
  };
}]).name;
exports.HeaderScrollDirectiveModule = HeaderScrollDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusPageModule = void 0;

var _statusPageLink = __webpack_require__(1407);

var _statusSummary = __webpack_require__(1408);

var StatusPageModule = angular.module('vln.statusPage', [_statusPageLink.StatusPageLinkModule, _statusSummary.StatusSummaryModule]).name;
exports.StatusPageModule = StatusPageModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusPageLinkModule = void 0;

var _constants = __webpack_require__(24);

var StatusPageLinkModule = angular.module('app.components.statusPage.statusPageLink', []).directive('statusPageLink', function () {
  return {
    restrict: 'E',
    template: "\n                <a class=\"md-button status-page-link\" ng-href=\"{{statusPageUrl}}\" target=\"_blank\" ng-transclude></a>\n            ",
    transclude: true,
    replace: true,
    link: function link($scope) {
      $scope.statusPageUrl = _constants.STATUS_PAGE_URL;
    }
  };
}).name;
exports.StatusPageLinkModule = StatusPageLinkModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusSummaryModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _get = _interopRequireDefault(__webpack_require__(34));

var _statusSummary = _interopRequireDefault(__webpack_require__(1409));

__webpack_require__(1410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var StatusSummaryModule = angular.module('app.components.statusPage.statusSummary', []).component('statusSummary', {
  template: _statusSummary.default,
  controller:
  /*#__PURE__*/
  function () {
    StatusSummaryController.$inject = ["$http"];

    function StatusSummaryController($http) {
      'ngInject';

      _classCallCheck(this, StatusSummaryController);

      (0, _assign.default)(this, {
        pageId: 'volusion',
        statusText: null,
        $http: $http,
        statusLabels: {
          operational: 'All Systems Operational',
          major_outage: 'Major Outage',
          partial_outage: 'Partial Outage',
          degraded_performance: 'Degraded Performance',
          under_maintenance: 'Under Maintenance'
        }
      });
    }

    _createClass(StatusSummaryController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.getStatusSummary().then(function (response) {
          var components = (0, _get.default)(response, 'data.components', []);
          var v2Component = components.find(function (c) {
            return c.name === 'V2';
          });

          if (v2Component) {
            _this.indicator = v2Component.status;
            _this.statusText = v2Component.description || _this.statusLabels[v2Component.status];
          }
        });
      }
    }, {
      key: "getStatusSummary",
      value: function getStatusSummary() {
        return this.$http({
          method: 'GET',
          url: "https://".concat(this.pageId, ".statuspage.io/api/v2/summary.json")
        });
      }
    }]);

    return StatusSummaryController;
  }()
}).name;
exports.StatusSummaryModule = StatusSummaryModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

module.exports = "<div class=\"status-summary\"> <div class=\"status-summary__label\">{{'SYSTEMSTATUS.STATUSLABELV2' | translate}}</div> <div class=\"status-summary__summary\"> <span class=\"status-summary__dot {{$ctrl.indicator}}\"></span> <span class=\"status-summary__text\">{{$ctrl.statusText || 'SYSTEMSTATUS.DEFAULTSTATUS' | translate}}</span> </div> </div> ";

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaveBarModule = void 0;

var _each = _interopRequireDefault(__webpack_require__(162));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _dialog = __webpack_require__(569);

var _spinner = __webpack_require__(380);

var _savebar = _interopRequireDefault(__webpack_require__(1413));

var _savebarModal = _interopRequireDefault(__webpack_require__(1414));

__webpack_require__(1415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveBarModule = angular.module('app.components.savebar', ['ngMaterial', _angularjs.default, _angularTranslate.default, _dialog.VlnDialogControllerModule, _spinner.SpinnerModule]).directive('saveBar', ["$rootScope", "$translate", "$state", "$window", "$timeout", "$mdDialog", "$location", function ($rootScope, $translate, $state, $window, $timeout, $mdDialog, $location) {
  return {
    restrict: 'E',
    template: _savebar.default,
    scope: {
      form: '=vlnForm',
      model: '=vlnModel',
      onReset: '&',
      onSave: '&',
      preferences: '=?',
      labels: '<'
    },
    link: function link(scope, element, attrs) {
      var lock = false;
      var STATE = {
        error: 0,
        default: 1,
        loading: 2,
        success: 3
      };
      var vm = {
        state: STATE.default,
        save: save,
        cancel: cancel,
        isDetail: attrs.isDetail !== 'false',
        disableAdd: attrs.disableAdd === 'true'
      };
      var currentState;
      init();

      function init() {
        scope.vm = vm;
        scope.STATE = STATE;
        scope.preferences = scope.preferences || {};
        scope.preferences.force = false;
        scope.preferences.muffle = false;
        scope.labels = (0, _assign.default)({
          loading: 'SAVEBAR.LOADING',
          error: 'BUTTON.ERROR',
          success: 'BUTTON.SUCCESS',
          default: 'BUTTON.SAVE'
        }, scope.labels);
        registerUnloadListeners();
        registerPreferenceListeners();

        if (attrs.vlnModel) {
          registerModelListeners();
        }

        var doIpadHack = $window.navigator.platform === 'iPhone' || $window.navigator.platform === 'iPad';

        if (doIpadHack) {
          element.css('transform', 'translate3d(0,0,0)');
        }

        currentState = $state.current.name;
      }

      function manageVisible(show) {
        if (lock) return;
        show = show || false;

        if (scope.preferences.muffle) {
          show = false;
        } else if (scope.preferences.force) {
          show = true;
        }

        toggleSavebar(show);
      }

      function hasChanged(model) {
        if (!model) return false;
        var hasChanges = false;

        if (Array.isArray(model)) {
          (0, _each.default)(model, function (item) {
            if (item.hasChanges && item.hasChanges()) {
              hasChanges = true;
            }
          });
        } else if (model.hasChanges()) {
          hasChanges = true;
        }

        return hasChanges;
      }

      function toggleSavebar(show) {
        if (lock) return;
        show = show || false;
        element.find('.save-bar').toggleClass('show', show);
        angular.element('body').toggleClass('savebar-active', show);
      }

      function isAddPage() {
        return /add/g.test($location.path());
      }

      function isAddOrList(saveType) {
        if ((saveType === 'list' || saveType === 'add') && !isAddPage() || saveType === 'list' && isAddPage()) {
          return true;
        }
      }

      function isAdd(saveType) {
        if (saveType === 'add' && isAddPage()) {
          return true;
        }
      }

      function save(saveType) {
        if (!scope.onSave) {
          throw new Error("No Save function declared in ".concat(currentState));
        }

        if (['list', 'add', 'stay'].indexOf(saveType) === -1) {
          saveType = scope.preferences.defaultAction;
        }

        if (vm.state === STATE.loading) return;
        vm.state = STATE.loading;
        pushGTMChanges('save', saveType);
        scope.onSave().then(function () {
          //Success
          toggleSavebar(true);
          lock = true;
          vm.state = STATE.success;
          $timeout(function () {
            clearPreferences();
            $rootScope.$broadcast('saveBarSave');

            if (isAddOrList(saveType)) {
              $window.dataLayer.push({
                event: "admin_".concat(currentState, "_saveAndGoTo-").concat(saveType)
              });
              $state.go("".concat(currentState.split('.')[0], ".").concat(saveType));
            } else if (isAdd(saveType)) {
              $window.dataLayer.push({
                event: "admin_".concat(currentState, "_saveAndAdd")
              });
              $state.reload();
            } else if (saveType === 'stay') {
              $window.dataLayer.push({
                event: "admin_".concat(currentState, "_saveAndStay")
              });
            }
          });
        }, function () {
          //Failure
          toggleSavebar(true);
          lock = true;
          vm.state = STATE.error;
          $timeout(function () {
            vm.state = STATE.default;
          });
        });
      }

      function cancel() {
        pushGTMChanges('cancel', false);

        if (scope.model) {
          if (Array.isArray(scope.model)) {
            for (var i = 0; i < scope.model.length; i += 1) {
              if (scope.model[i].hasChanges()) {
                scope.model[i].reset();
              }
            }
          } else if (scope.model.hasChanges()) {
            scope.model.reset();
          }
        }

        if (scope.form) {
          scope.form.$setUntouched();
        }

        if (scope.onReset) {
          scope.onReset();
        }

        $rootScope.$broadcast('saveBarCancel');
      }

      function pushGTMChanges(type, saveType) {
        if (!saveType) {
          if (scope.model && scope.model.changedValues) {
            scope.model.changedValues.forEach(function (el) {
              $window.dataLayer.push({
                event: "admin_".concat(currentState, "_").concat(type, "-changedVal-").concat(el)
              });
            });
          } else {
            $window.dataLayer.push({
              event: "admin_".concat(currentState, "-").concat(type)
            });
          }
        }
      }

      function registerPreferenceListeners() {
        scope.$watch('preferences', function () {
          if (scope.model) {
            manageVisible(hasChanged(scope.model));
          } else {
            manageVisible();
          }
        }, true);
      }

      function registerModelListeners() {
        scope.$watch(function () {
          return scope.model;
        }, function () {
          if (scope.model) {
            manageVisible(hasChanged(scope.model));
          }
        }, true);
      }

      function onPageChange(event, newUrl, newState) {
        if (hasChanged(scope.model) || scope.preferences.force) {
          event.preventDefault(); // transitionTo() promise will be rejected with
          // a 'transition prevented' error

          var saveModal = $mdDialog.show({
            clickOutsideToClose: true,
            scope: scope,
            preserveScope: true,
            controller: 'vlnDialogController',
            template: _savebarModal.default,
            theme: ''
          });
          saveModal.then(function () {
            //yes, navigate away
            vm.cancel();

            if (event.name === '$locationChangeStart') {
              var newUrlObject = new URL(newUrl);
              $location.url("".concat(newUrlObject.pathname).concat(newUrlObject.search));
            } else if (event.name === '$stateChangeStart') {
              $state.go(newState.name).catch(function () {
                $state.go(newState.name.replace('.**', '.list'));
              });
            }
          });
        }
      }

      function registerUnloadListeners() {
        var stopLocationWatch = $rootScope.$on('$locationChangeStart', function (event, newUrl) {
          return onPageChange(event, newUrl);
        });
        var stopStateWatch = $rootScope.$on('$stateChangeStart', function (event, newState) {
          return onPageChange(event, null, newState);
        });

        $window.onbeforeunload = function (event) {
          var message;

          if (hasChanged(scope.model) || scope.preferences.force) {
            message = $translate.instant('LEAVE.UNSAVEDCHANGES');

            if (typeof event == 'undefined') {
              event = $window.event;
            }

            if (event) {
              event.returnValue = message;
            }

            return message;
          }
        };

        scope.$on('$destroy', function () {
          $window.onbeforeunload = undefined;
          stopStateWatch();
          stopLocationWatch();
        });
      }

      function clearPreferences() {
        scope.preferences.muffle = false;
        scope.preferences.force = false;
        lock = false;
        manageVisible(false); //Hide savebar before changing state back

        $timeout(function () {
          vm.state = STATE.default;
        });
      }
    }
  };
}]).name;
exports.SaveBarModule = SaveBarModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"vln-spinner\" version=\"1.1\" id=\"L9\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 0 0\" xml:space=\"preserve\"> <path d=\"M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50\"></path> </svg>";

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

module.exports = "<div class=\"savebar__scope\" ng-class=\"{'is-detail': vm.isDetail}\"> <div class=\"save-bar\"> <md-button class=\"md-raised md-accent\" ng-class=\"{'md-accent' : vm.state === STATE.default || vm.state === STATE.loading || vm.state === STATE.success, 'save-bar__save--loading': vm.state === STATE.loading, 'md-warn': vm.state === STATE.error}\" ng-disabled=\"form.$invalid || vm.state === STATE.loading\" ng-click=\"vm.save()\" id=\"save-button\" ng-if=\"!vm.isDetail\"> <span ng-show=\"vm.state === STATE.loading\">{{labels.loading | translate}} <spinner class=\"save-bar__spinner\"></spinner></span> <span ng-show=\"vm.state === STATE.error\"><i class=\"mi mi-sm\">clear</i> {{labels.error | translate}}</span> <span ng-show=\"vm.state === STATE.success\"><i class=\"mi mi-sm\">check</i> {{labels.success | translate}}</span> <span ng-show=\"vm.state === STATE.default\">{{labels.default | translate}}</span> </md-button> <md-button class=\"md-raised md-accent save-bar__save\" data-cy=\"save\" ng-class=\"{'md-accent' : vm.state === STATE.default || vm.state === STATE.loading || vm.state === STATE.success, 'save-bar__save--loading': vm.state === STATE.loading, 'md-warn': vm.state === STATE.error}\" ng-click=\"vm.save()\" ng-disabled=\"form.$invalid || vm.state === STATE.loading\" ng-if=\"vm.isDetail\"> <span ng-show=\"vm.state === STATE.loading\">{{'SAVEBAR.LOADING' | translate}} <spinner class=\"save-bar__spinner\"></spinner></span> <span ng-show=\"vm.state === STATE.error\"><i class=\"mi mi-sm\">clear</i> {{'BUTTON.ERROR' | translate}}</span> <span ng-show=\"vm.state === STATE.success\"><i class=\"mi mi-sm\">check</i> {{'BUTTON.SUCCESS' | translate}}</span> <span ng-show=\"vm.state === STATE.default\">{{'BUTTON.SAVE' | translate}}</span> </md-button> <md-menu md-offset=\"-88 44\" ng-if=\"vm.isDetail\" md-helper> <md-button class=\"md-icon-button md-raised md-accent\" id=\"menu-trigger\" ng-click=\"$mdMenu.open($event)\" ng-disabled=\"form.$invalid || vm.state === STATE.loading\" ng-class=\"{'save-bar__save--loading': vm.state === STATE.loading}\"> <md-icon>arrow_drop_down</md-icon> </md-button> <md-menu-content> <md-menu-item> <md-button ng-click=\"vm.save('list')\"> {{'BUTTON.SAVERETURNLIST' | translate}} </md-button> </md-menu-item> <md-menu-item> <md-button ng-disabled=\"vm.disableAdd\" ng-click=\"vm.save('add')\"> {{'BUTTON.SAVECREATENEW' | translate}} </md-button> </md-menu-item> <md-menu-item> <md-button ng-click=\"vm.save('stay')\"> {{'BUTTON.SAVESTAY' | translate}} </md-button> </md-menu-item> </md-menu-content> </md-menu> <md-button ng-click=\"vm.cancel()\" id=\"cancel-button\"> <span>{{\"BUTTON.CANCEL\" | translate}}</span> </md-button> </div> </div> ";

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

module.exports = "<md-dialog> <md-dialog-content class=\"modal__content\"> <div class=\"md-dialog-content\"> <h3 class=\"modal__header\">{{\"LEAVE.AREYOUSURE\" | translate}}</h3> <p>{{\"LEAVE.UNSAVEDCHANGES\" | translate}}</p> </div> </md-dialog-content> <md-dialog-actions class=\"modal__buttons\"> <md-button ng-click=\"cancelDialog()\">{{\"BUTTON.CANCEL\" | translate}}</md-button> <md-button class=\"md-accent\" ng-click=\"closeDialog()\">{{\"LEAVE.CONTINUE\" | translate}}</md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchDirectiveModule = exports.setDefaultSearchAttributes = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _curry = _interopRequireDefault(__webpack_require__(423));

var _filter = _interopRequireDefault(__webpack_require__(157));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _search = __webpack_require__(120);

var _search2 = _interopRequireDefault(__webpack_require__(1417));

__webpack_require__(1418);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isListOf = function isListOf(type, locationPath) {
  return RegExp("".concat(type, "/list"), 'i').test(locationPath);
};

var setDefaultSearchAttributes = function setDefaultSearchAttributes(path) {
  if (isListOf('customer', path)) {
    return {
      restrictSearchableAttributes: ['firstName', 'lastName', 'company', 'emailAddress']
    };
  }

  if (isListOf('order', path)) {
    var orderAttrs = ['orderNumber', 'placedBy.firstName', 'placedBy.lastName', 'placedBy.emailAddress', 'placedBy.company'];
    return {
      restrictSearchableAttributes: orderAttrs
    };
  }

  if (isListOf('product', path)) {
    return {
      restrictSearchableAttributes: ['name', 'seo.friendlyName', 'productVariants.sku']
    };
  }

  return {
    restrictSearchableAttributes: 'name'
  };
};

exports.setDefaultSearchAttributes = setDefaultSearchAttributes;
var SearchDirectiveModule = angular.module('app.components.search', [_search.SearchServiceModule, _angularTranslate.default]).directive('search', ["$window", "searchService", "$location", "$timeout", function ($window, searchService, $location, $timeout) {
  return {
    restrict: 'E',
    template: _search2.default,
    controllerAs: 'searchCtrl',
    scope: {
      searchFunction: '&?',
      pageController: '<',
      searchDelay: '<'
    },
    controller: ["$scope", "$element", "$attrs", function searchController($scope, $element, $attrs) {
      var $searchInput = $('#searchInput');
      var defaultOptions = setDefaultSearchAttributes($location.$$path);
      var options = null;
      var oldPageChange = null;
      var oldSortChange = null;
      var vm = {
        searchOpen: false,
        searchDelay: $scope.searchDelay || 0,
        query: '',
        isMobile: $window.matchMedia('(max-width: 599px)'),
        translations: {
          COUNT: "<span class=\"search-results__count\">\n                                    {$ctrl.grid.pageController.options.paging.totalItemCount}}\n                                </span>\n                        ",
          QUERY: '<span class="search-results__query">{{searchCtrl.query}}</span>'
        },
        toggleSearch: toggleSearch,
        search: search,
        reset: reset
      };
      vm = (0, _assign.default)(this, vm);
      $attrs.$observe('options', function (res) {
        if (res && angular.isString(res)) {
          options = JSON.parse(res);
        }
      });
      $attrs.$observe('defaultOptions', function (res) {
        if (res && angular.isString(res)) {
          defaultOptions = JSON.parse(res);
        }
      });

      function toggleSearch() {
        vm.searchOpen = !vm.searchOpen;

        if (vm.searchOpen) {
          vm.query = ''; //200ms to wait until transition animation finishes

          $timeout(function () {
            $searchInput.focus();
          }, 200);
        } else {
          reset();
        }
      }

      function search(searchOptions) {
        options = searchOptions || options;
        $window.scrollTo(0, 0);
        vm.searchInitialized = true;
        searchPage('search', 1, 25, null);
      }

      function searchPage(type, page, count, sort) {
        page = page - 1 || 0;
        count = count || 25;

        if (sort != null) {
          var splitSort = sort[0].split(' ');
          sort = "".concat($attrs.index, "_").concat(splitSort[0], "_").concat(splitSort[1]).toLowerCase();
          delete options.restrictSearchableAttributes;
        }

        options = options || defaultOptions;
        options.page = page;
        options.hitsPerPage = count;
        $scope.pageController.grid.options.isLoading = true;
        var results = $scope.searchFunction ? $scope.searchFunction({
          params: {
            search: vm.query,
            sort: sort,
            count: count,
            page: page
          }
        }) : searchService.search(sort || $attrs.index, vm.query, options, false);
        results.then(function (res) {
          //Overwrite grid functions until grid is sorted, then revert to normal
          if (!oldPageChange) {
            oldPageChange = $scope.pageController.grid.options.paging.onPageChange;
          }

          if (!oldSortChange) {
            oldSortChange = $scope.pageController.grid.options.sorting.onSortChange;
          }

          $scope.pageController.grid.options.paging.onPageChange = (0, _curry.default)(searchPage)('page');
          $scope.pageController.grid.options.sorting.onSortChange = (0, _curry.default)(searchPage)('sort');
          $scope.pageController.grid.options.paging.currentPage = page + 1;
          var response;

          if ($scope.searchFunction) {
            response = res;
          } else {
            response = {
              items: res.hits,
              totalCount: res.nbHits
            };
          }

          $scope.pageController.onDataResponse(response, type || 'page');
          $scope.pageController.grid.selected = (0, _filter.default)($scope.pageController.grid.selected, function (item) {
            for (var i = 0; i < $scope.pageController.grid.items.length; i++) {
              if (item.id === $scope.pageController.grid.items[i].id) {
                return true;
              }
            }

            return false;
          });
        });
      }

      function reset() {
        vm.searchInitialized = false;
        vm.searchOpen = false;
        vm.query = '';
        options = defaultOptions || options;

        if (!oldPageChange || !oldSortChange) {
          var searchFilter = $location.search().filter;
          searchFilter = searchFilter && searchFilter !== 'All' ? "state eq \"".concat(searchFilter, "\"") : null;
          $scope.pageController.setFilter(searchFilter);
          $location.search({
            searchFilter: searchFilter
          });
        }

        oldPageChange = null;
        oldSortChange = null;
        $scope.pageController.grid.options.sorting.onSortChange(undefined, undefined, undefined);
      }
    }]
  };
}]).name;
exports.SearchDirectiveModule = SearchDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(101)))

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

module.exports = "<div class=\"search\" ng-class=\"{'search--open': searchCtrl.searchOpen}\" md-theme=\"dark\"> <md-button class=\"md-icon-button search__button\" ng-click=\"searchCtrl.toggleSearch()\"> <md-icon>search</md-icon> </md-button> <md-input-container class=\"md-accent md-light search__input\" md-no-float=\"true\"> <input id=\"searchInput\" type=\"text\" ng-model=\"searchCtrl.query\" ng-model-options=\"{debounce: searchCtrl.searchDelay}\" placeholder=\"{{'SEARCH.SEARCH' | translate}}\" ng-change=\"searchCtrl.search()\" maxlength=\"255\"> </md-input-container> <md-button class=\"md-icon-button search__button search__button--cancel\" ng-click=\"searchCtrl.reset()\"> <md-icon>cancel</md-icon> </md-button> </div> ";

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderComponentModule = void 0;

var _nativePlatform = __webpack_require__(125);

var _conciergeIndicator = __webpack_require__(1420);

var _subscription = __webpack_require__(42);

var _navigationMenu = __webpack_require__(602);

var _imageLibrary = __webpack_require__(372);

var _trial = __webpack_require__(60);

var _spinner = __webpack_require__(380);

var _constants = __webpack_require__(24);

var _changePlanClick = __webpack_require__(1426);

var _myAccount = __webpack_require__(84);

var _launchDarkly = __webpack_require__(30);

var _videoSlider = __webpack_require__(156);

var _assign = _interopRequireDefault(__webpack_require__(5));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _pageHeader = _interopRequireDefault(__webpack_require__(1427));

__webpack_require__(1428);

__webpack_require__(1429);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PageHeaderComponentModule = angular.module('app.components.pageHeader.pageHeaderComponent', ['ngMaterial', _angularjs.default, _conciergeIndicator.ConciergeIndicatorModule, _nativePlatform.NativePlatformServiceModule, _subscription.SubscriptionServiceModule, _navigationMenu.NavigationMenuServiceModule, _imageLibrary.ImageLibraryModule, _spinner.SpinnerModule, _changePlanClick.ChangePlanClickModule, _myAccount.MyAccountServiceModule, _launchDarkly.LaunchDarklyServiceModule, _videoSlider.VideoSliderServiceModule]).component('pageHeader', {
  template: _pageHeader.default,
  transclude: {
    overflowMenuItems: '?pageHeaderOverflowMenuItems',
    rightSideContent: '?pageHeaderRightSideContent',
    leftSideContent: '?pageHeaderLeftSideContent',
    afterAddButtonContent: '?pageHeaderAfterAddButtonContent'
  },
  bindings: {
    gtmId: '<',
    theme: '@',
    backButton: '@',
    onBackButtonClick: '&',
    pageTitle: '@',
    pageName: '<',
    hideNav: '<',
    headerClasses: '@',
    showSavebar: '<',
    savebarData: '<',
    savebarForm: '<',
    savebarOnSave: '&',
    savebarOnReset: '&',
    savebarDisableCancel: '<',
    savebarDisableAdd: '<',
    savebarPreferences: '<',
    savebarLabels: '<',
    isDetail: '<',
    showAddButton: '<',
    addButtonText: '@',
    addButtonState: '@',
    onAddButtonClicked: '&',
    showLockButton: '<',
    onLockButtonClicked: '&',
    pageController: '<',
    showSearch: '<',
    searchIndex: '@',
    searchOptions: '<',
    searchFunction: '&?',
    searchDelay: '<',
    exportData: '<',
    exportLoading: '<',
    exportTooltip: '@',
    openUpdateModal: '&',
    hotspotDescription: '@',
    hotspotId: '<',
    hotspotTitle: '@',
    storeInformation: '<',
    menuItemsPosition: '<',
    tabs: '<',
    onTabChange: '<',
    videoLink: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    PageHeaderCtrl.$inject = ["$attrs", "$mdMedia", "$scope", "$rootScope", "$state", "$window", "$mdSidenav", "nativePlatformService", "subscriptionsService", "navigationMenuService", "videoSliderService", "trialService", "myAccountService", "launchDarklyService"];

    function PageHeaderCtrl($attrs, $mdMedia, $scope, $rootScope, $state, $window, $mdSidenav, nativePlatformService, subscriptionsService, navigationMenuService, videoSliderService, trialService, myAccountService, launchDarklyService) {
      _classCallCheck(this, PageHeaderCtrl);

      this.hasOnBackButtonClick = angular.isDefined($attrs.onBackButtonClick);
      (0, _assign.default)(this, {
        $mdMedia: $mdMedia,
        $scope: $scope,
        $rootScope: $rootScope,
        $state: $state,
        $window: $window,
        $mdSidenav: $mdSidenav,
        LOGO_SYMBOL_LIGHT_URL: _constants.LOGO_SYMBOL_LIGHT_URL,
        LOGO_SYMBOL_URL: _constants.LOGO_SYMBOL_URL,
        nativePlatformService: nativePlatformService,
        subscriptionsService: subscriptionsService,
        navigationMenuService: navigationMenuService,
        videoSliderService: videoSliderService,
        trialService: trialService,
        myAccountService: myAccountService,
        launchDarklyService: launchDarklyService,
        showCallMenu: false,
        eventHandlers: [],
        hideVideoButton: false,
        hasFetchedUserInfo: false,
        showIntercomButton: true
      });
    }

    _createClass(PageHeaderCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.$scope.$watch(function () {
          return _this.$mdMedia('xs');
        }, function (isMatch) {
          _this.isMobile = isMatch;
        });
        this.$scope.$watch(function () {
          return _this.$mdMedia('sm');
        }, function (isMatch) {
          _this.isTablet = isMatch;
        });
        this.setMobileAppStatusBar();
        this.setShowCallMenu();
        this.setTrialStatus();
        this.getPhoneNumber();
        this.launchDarklyService.getFeature('use-live-agent-chat').then(function (useLiveAgentChat) {
          _this.showIntercomButton = !useLiveAgentChat;
        });
        this.eventHandlers = [this.$rootScope.$on('$stateChangeSuccess', function () {
          var elem = angular.element(_this.$window.document.body);
          elem.removeClass('side-nav__app--open');
        }), this.$rootScope.$on('videoSliderModule:sliderOpened', function () {
          _this.hideVideoButton = true;
        }), this.$rootScope.$on('videoSliderModule:sliderClosed', function () {
          _this.hideVideoButton = false;
        })];
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.eventHandlers.forEach(function (unbindHandler) {
          unbindHandler();
        });
      }
    }, {
      key: "onBackClick",
      value: function onBackClick() {
        if (this.searchIndex && this.searchCtrl.searchInitialized) {
          this.searchCtrl.reset();
        }

        if (this.hasOnBackButtonClick) {
          this.onBackButtonClick();
        }
      }
    }, {
      key: "routeOnAddButtonClicked",
      value: function routeOnAddButtonClicked() {
        if (this.addButtonState) {
          return this.$state.go(this.addButtonState);
        }

        this.onAddButtonClicked();
      }
    }, {
      key: "openSideNav",
      value: function openSideNav() {
        this.navigationMenuService.toggle();
      }
    }, {
      key: "openHelpCenter",
      value: function openHelpCenter() {
        this.$window.open(_constants.HELP_CENTER_URL, '_blank');
      }
    }, {
      key: "setMobileAppStatusBar",
      value: function setMobileAppStatusBar() {
        var kit = this.nativePlatformService.getKit(this.$window);

        if (this.nativePlatformService.isIOS && this.nativePlatformService.supports(this.$window, 'StatusBarUpdateHandler')) {
          var backgroundColor = this.getStatusBarBackgroundColor(this.pageTitle);

          if (backgroundColor) {
            kit.messageHandlers.StatusBarUpdateHandler.postMessage({
              statusBarStyle: 'light',
              statusBarBackgroundColor: backgroundColor
            });
          }
        }

        if (this.nativePlatformService.isAndroid && this.nativePlatformService.supports(this.$window, 'changeStatusBarColor')) {
          var _backgroundColor = this.getStatusBarBackgroundColor(this.pageTitle);

          if (_backgroundColor) {
            kit.changeStatusBarColor(_backgroundColor);
          }
        }
      }
    }, {
      key: "getStatusBarBackgroundColor",
      value: function getStatusBarBackgroundColor(pageTitle) {
        var pageColorMap = {
          'All Orders': '#3EC671',
          products: '#0FB3CC',
          Categories: '#1E66C3',
          customers: '#684BB6',
          Pages: '#C45898',
          'Theme Store': '#BC7180',
          'App Store': '#EC6060',
          'Store Settings': '#FF8055',
          'Edit Store': '#79919D',
          'My Account': '#79919D',
          Analytics: '#4d98f0',
          'Abandoned Carts': '#4d98f0',
          Mailchimp: '#52BAD5',
          Printify: '#2EB56D',
          Dropshipping: '#1F3856',
          'Fulfillment Services': '#4747CD',
          'Live Chat': '#887AAD'
        };
        return pageColorMap[pageTitle];
      }
    }, {
      key: "setShowCallMenu",
      value: function setShowCallMenu() {
        var _this2 = this;

        this.subscriptionsService.getSubscription().then(function (subs) {
          _this2.showCallMenu = subs.features.scheduleCallDisplayed;
        });
      }
    }, {
      key: "openVideoSlider",
      value: function openVideoSlider() {
        this.videoSliderService.openSlider(this.videoLink);
      }
    }, {
      key: "setTrialStatus",
      value: function setTrialStatus() {
        var _this3 = this;

        this.trialService.getTrialStatus().then(function (status) {
          _this3.isTrialAccount = status !== _trial.NOT_TRIAL;
        });
      }
    }, {
      key: "getPhoneNumber",
      value: function getPhoneNumber() {
        var _this4 = this;

        this.myAccountService.getUser().then(function (user) {
          _this4.hasFetchedUserInfo = true;

          if (user.phoneNumber) {
            _this4.phoneNumber = user.phoneNumber;
          }
        });
      }
    }]);

    return PageHeaderCtrl;
  }()
}).name;
exports.PageHeaderComponentModule = PageHeaderComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConciergeIndicatorModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _auth = __webpack_require__(77);

var _volusionPaymentsSignupManagement = __webpack_require__(1421);

var _conciergeIndicator = _interopRequireDefault(__webpack_require__(1424));

__webpack_require__(1425);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ConciergeIndicatorModule = angular.module('app.components.conciergeIndicator', [_auth.AuthServiceModule, _volusionPaymentsSignupManagement.VolusionPaymentsSignupManagement]).component('conciergeIndicator', {
  template: _conciergeIndicator.default,
  bindings: {
    storeInformation: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    ConciergeIndicatorController.$inject = ["authService", "$mdDialog"];

    function ConciergeIndicatorController(authService, $mdDialog) {
      'ngInject';

      _classCallCheck(this, ConciergeIndicatorController);

      (0, _assign.default)(this, {
        authService: authService,
        $mdDialog: $mdDialog
      });
    }

    _createClass(ConciergeIndicatorController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.authService.isImpersonator().then(function (isImpersonator) {
          _this.conciergeUser = isImpersonator;
        });
      }
    }, {
      key: "shouldShowAuthNetManagementLink",
      value: function shouldShowAuthNetManagementLink() {
        var info = this.storeInformation;
        return !!info && info.authorizeNet && info.authorizeNet.isPaymentsSignupSubmitted && !info.authorizeNet.accessToken;
      }
    }, {
      key: "manageAuthNet",
      value: function manageAuthNet() {
        this.$mdDialog.show({
          template: "\n                    <md-dialog class=\"configure-authorize-net-edit-modal\" aria-label=\"Edit Volusion Payments\">\n                        <md-dialog-content>\n                            <volusion-payments-signup-management></volusion-payments-signup-management>\n                        </md-dialog-content>\n                    </md-dialog>\n                    ",
          clickOutsideToClose: true,
          controller: this.basicDialogController({})
        });
      }
    }, {
      key: "basicDialogController",
      value: function basicDialogController(scopeVars) {
        return ["$scope", "$mdDialog", function DialogController($scope, $mdDialog) {
          // eslint-disable-line no-shadow
          'ngInject'; // eslint-disable-line lines-around-directive

          (0, _assign.default)($scope, scopeVars);

          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }];
      }
    }]);

    return ConciergeIndicatorController;
  }()
}).name;
exports.ConciergeIndicatorModule = ConciergeIndicatorModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VolusionPaymentsSignupManagement = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _volusionPayments = __webpack_require__(621);

var _storeInformation = __webpack_require__(38);

var _volusionPaymentsSignupManagement = _interopRequireDefault(__webpack_require__(1422));

__webpack_require__(1423);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VolusionPaymentsSignupManagement = angular.module('app.components.volusionPaymentsSignupManagement', ['ngMaterial', _volusionPayments.VolusionPaymentsServiceModule, _storeInformation.StoreInformationServiceModule]).component('volusionPaymentsSignupManagement', {
  template: _volusionPaymentsSignupManagement.default,
  controller:
  /*#__PURE__*/
  function () {
    VolusionPaymentsSignupManagementController.$inject = ["$scope", "$mdDialog", "$timeout", "volusionPaymentsService", "storeInformationService"];

    function VolusionPaymentsSignupManagementController($scope, $mdDialog, $timeout, volusionPaymentsService, storeInformationService) {
      'ngInject';

      _classCallCheck(this, VolusionPaymentsSignupManagementController);

      (0, _assign.default)(this, {
        gtmId: 'settings_payment.detail',
        $mdDialog: $mdDialog,
        $scope: $scope,
        $timeout: $timeout,
        volusionPaymentsService: volusionPaymentsService,
        storeInformationService: storeInformationService,
        isLoading: true
      });
      this.closeDialog = this.closeDialog.bind(this);
      this.handleAccountSave = this.handleAccountSave.bind(this);
      this.handleAccountSaveError = this.handleAccountSaveError.bind(this);
    }

    _createClass(VolusionPaymentsSignupManagementController, [{
      key: "$onInit",
      value: function $onInit() {
        this.getStoreInfo();
      }
    }, {
      key: "getStoreInfo",
      value: function getStoreInfo() {
        var _this = this;

        var force = true;
        this.storeInformationService.getStore(force).then(function (storeInfo) {
          _this.storeInfo = storeInfo;
          _this.isLoading = false;
        }).catch(function (err) {
          _this.storeInfoError = err;
        });
      }
    }, {
      key: "shouldShowControls",
      value: function shouldShowControls() {
        return !this.isSaving && !this.isDoneSaving && !this.isLoading;
      }
    }, {
      key: "saveAccountCreated",
      value: function saveAccountCreated() {
        this.isSaving = true;
        this.volusionPaymentsService.saveAccountCreated().then(this.handleAccountSave).catch(this.handleAccountSaveError);
      }
    }, {
      key: "saveAccountDenied",
      value: function saveAccountDenied() {
        this.isSaving = true;
        this.volusionPaymentsService.saveAccountDenied().then(this.handleAccountSave).catch(this.handleAccountSaveError);
      }
    }, {
      key: "handleAccountSave",
      value: function handleAccountSave() {
        this.isSaving = false;
        this.isDoneSaving = true;
      }
    }, {
      key: "handleAccountSaveError",
      value: function handleAccountSaveError(error) {
        this.savingError = error;
        this.isSaving = false;
      }
    }, {
      key: "cancelDialog",
      value: function cancelDialog(result) {
        this.$mdDialog.cancel(result);
      }
    }, {
      key: "closeDialog",
      value: function closeDialog(results) {
        if (results) {
          this.$mdDialog.hide(results);
        } else {
          this.$mdDialog.hide();
        }
      }
    }]);

    return VolusionPaymentsSignupManagementController;
  }()
}).name;
exports.VolusionPaymentsSignupManagement = VolusionPaymentsSignupManagement;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

module.exports = "<div class=\"volusion-payments-signup-management\"> <div class=\"volusion-payments-signup-management-modal\"> <div class=\"volusion-payments-signup-management-modal-header\" layout=\"row\" layout-align=\"space-between center\"> <div layout=\"row\" layout-align=\"start center\"> <h2> Volusion Payments Authorize.net Signup Management </h2> </div> <md-icon class=\"volusion-payments-signup-management-modal-header__close\" ng-click=\"$ctrl.closeDialog()\">close</md-icon> </div> <div ng-if=\"$ctrl.shouldShowControls()\" class=\"volusion-payments-signup-management-modal-contents\" layout=\"column\" layout-align=\"start center\"> <p ng-if=\"$ctrl.savingError\" class=\"volusion-payments-signup-management-modal-error\"> Error saving: {{$ctrl.savingError}} </p> <h2>Managing this store:</h2> <p layout=\"column\"> <span>{{$ctrl.storeInfo.name}}</span> <span>{{$ctrl.storeInfo.email}}</span> <span>{{$ctrl.storeInfo.phoneNumber | phone}}</span> </p> <p ng-if=\"$ctrl.storeInfo.authorizeNet.isAccountCreated\"> Current saved status: Account Approved </p> <p ng-if=\"$ctrl.storeInfo.authorizeNet.isAccountDenied\"> Current saved status: Account Declined </p> <div flex=\"100\" class=\"volusion-payments-signup-management-modal-actions\" layout=\"row\" layout-align=\"space-between center\"> <md-button class=\"md-button--border\" ng-click=\"$ctrl.saveAccountDenied()\">Account Declined</md-button> <md-button class=\"md-button md-raised md-accent\" ng-click=\"$ctrl.saveAccountCreated()\">Account Approved</md-button> </div> </div> <div ng-if=\"$ctrl.isSaving\" class=\"volusion-payments-signup-management-modal-contents\" layout=\"column\" layout-align=\"start center\"> <h2>Saving...</h2> <md-progress-circular></md-progress-circular> </div> <div ng-if=\"$ctrl.isDoneSaving\" class=\"volusion-payments-signup-management-modal-contents\" layout=\"column\" layout-align=\"start center\"> <h2>Saved!</h2> </div> <div ng-if=\"$ctrl.isLoading\" class=\"volusion-payments-signup-management-modal-contents\" layout=\"column\" layout-align=\"start center\"> <h2>Just a moment, retrieving store information...</h2> <md-progress-circular></md-progress-circular> <p ng-if=\"$ctrl.storeInfoError\">Something went wrong: {{$ctrl.storeInfoError}}</p> </div> </div> </div> ";

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.conciergeUser\" class=\"header__concierge\"> <span>Concierge</span> <span ng-if=\"$ctrl.shouldShowAuthNetManagementLink()\" ng-click=\"$ctrl.manageAuthNet()\" class=\"header__concierge-auth-net-link\"> Manage Volusion Payments Authorize.net Settings </span> </div> ";

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePlanClickModule = void 0;

var _launchChangePlan = __webpack_require__(102);

var ChangePlanClickModule = angular.module('app.components.changePlan.changePlanClick', [_launchChangePlan.LaunchChangePlanServiceModule]).directive('changePlanClick', ["launchChangePlanService", function (launchChangePlanService) {
  return {
    restrict: 'A',
    link: function link(scope, element) {
      element.on('click', function (event) {
        launchChangePlanService.openModal(event);
      });
    }
  };
}]).name;
exports.ChangePlanClickModule = ChangePlanClickModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page__header {{$ctrl.headerClasses}} page-header content--new-nav flex-props\" ng-class=\"{'page-header--dark': $ctrl.theme === 'dark'}\" header-scroll> <concierge-indicator store-information=\"$ctrl.storeInformation\"></concierge-indicator> <div class=\"header__left left\"> <div ng-if=\"!$ctrl.showSavebar && !$ctrl.hideNav\" class=\"header__nav\" ng-class=\"{'header__nav--searching': $ctrl.searchCtrl.searchInitialized}\"> <div class=\"quick-menu__container\" hide-gt-sm> <div class=\"quick-menu__mobile-container\"> <div class=\"quick-menu__logo\"> <md-button ng-click=\"$ctrl.openSideNav()\" class=\"md-icon-button quick-menu__icon-button\" aria-label=\"icon button\"> <md-icon class=\"quick-menu__icon quick-menu__icon--closed\" md-svg-src=\"{{$ctrl.theme === 'dark' ? $ctrl.LOGO_SYMBOL_URL : $ctrl.LOGO_SYMBOL_LIGHT_URL}}\"></md-icon> </md-button> </div> </div> </div> <div class=\"header__back\" ng-if=\"$ctrl.backButton || $ctrl.hasOnBackButtonClick || $ctrl.searchCtrl.searchInitialized\"> <back-button theme=\"{{$ctrl.theme}}\" show-spinner=\"true\" state-name=\"{{$ctrl.backButton}}\" on-click=\"$ctrl.onBackClick()\" gtm-id=\"$ctrl.gtmId ? $ctrl.gtmId + '_back' : 'admin_back'\"> </back-button> </div> <div class=\"header__title\" ng-if=\"(!$ctrl.searchCtrl.searchOpen &&\n                 $ctrl.searchCtrl.isMobile.matches) ||\n                 !$ctrl.searchCtrl.isMobile.matches\"> <span ng-if=\"!$ctrl.searchCtrl.searchInitialized\">{{$ctrl.pageTitle}}</span> <span ng-if=\"$ctrl.searchCtrl.searchInitialized\">{{'SEARCH.RESULTS' | translate}}</span> </div> </div> <div class=\"header__save\" ng-if=\"$ctrl.showSavebar\"> <save-bar is-detail=\"{{$ctrl.isDetail}}\" vln-model=\"$ctrl.savebarData\" vln-form=\"$ctrl.savebarForm\" on-save=\"$ctrl.savebarOnSave()\" on-reset=\"$ctrl.savebarOnReset()\" preferences=\"$ctrl.savebarPreferences\" disable-add=\"$ctrl.disableAdd\" labels=\"$ctrl.savebarLabels\" ng-class=\"{'no-pointer': $ctrl.savebarDisableCancel}\"> </save-bar> </div> <div ng-transclude=\"leftSideContent\"></div> </div> <div class=\"header__center\"> <tabs ng-if=\"$ctrl.tabs\" tabs=\"$ctrl.tabs\" on-tab-change=\"$ctrl.onTabChange\" gtm-id=\"$ctrl.gtmId\" is-mobile=\"$ctrl.isMobile\"></tabs> </div> <div class=\"header__right right\"> <div ng-transclude=\"rightSideContent\"></div> <md-button ng-if=\"$ctrl.showAddButton && ((!$ctrl.isMobile && !$ctrl.isTablet) || !$ctrl.searchCtrl.searchOpen)\" class=\"page-header__add-button\" ng-click=\"$ctrl.routeOnAddButtonClicked()\" gtm-click-event=\"{{$ctrl.gtmId + '-add-link'}}\"> <md-icon>add_box</md-icon> <md-tooltip ng-if=\"$ctrl.addButtonText\" md-position=\"bottom\">{{$ctrl.addButtonText | translate}}</md-tooltip> </md-button> <md-button ng-if=\"$ctrl.openUpdateModal && !$ctrl.isDetail && !$ctrl.isMobile\" class=\"page-header__file-upload\" ng-click=\"$ctrl.openUpdateModal()\" gtm-click-event=\"{{$ctrl.gtmId + '-upload'}}\"> <md-icon>file_upload</md-icon> </md-button> <div ng-transclude=\"afterAddButtonContent\"></div> <md-button ng-if=\"$ctrl.showLockButton && (!$ctrl.isMobile || !$ctrl.searchCtrl.searchOpen)\" class=\"page-header__lock-button\" change-plan-click gtm-click-event=\"{{$ctrl.gtmId + '-plan_upgrade-link'}}\"> <md-icon>lock</md-icon> <md-tooltip md-position=\"bottom\">Product limit reached</md-tooltip> </md-button> <search ng-init=\"$ctrl.searchCtrl = searchCtrl\" ng-if=\"!!$ctrl.searchFunction\" ng-show=\"$ctrl.showSearch && (!$ctrl.isMobile || $ctrl.searchCtrl.searchOpen)\" index=\"{{$ctrl.searchIndex}}\" page-controller=\"$ctrl.pageController\" search-function=\"$ctrl.searchFunction({params})\" search-delay=\"$ctrl.searchDelay\" options=\"{{$ctrl.searchOptions}}\"></search> <search ng-init=\"$ctrl.searchCtrl = searchCtrl\" ng-if=\"!$ctrl.searchFunction\" ng-show=\"$ctrl.showSearch && (!$ctrl.isMobile || $ctrl.searchCtrl.searchOpen)\" index=\"{{$ctrl.searchIndex}}\" page-controller=\"$ctrl.pageController\" options=\"{{$ctrl.searchOptions}}\"></search> <md-menu ng-if=\"!$ctrl.isMobile\" class=\"page-header__help-menu help-menu\" md-position-mode=\"target-right target\"> <md-button class=\"help-menu__open-btn\" ng-click=\"$mdMenu.open($event)\" analytics-click-event=\"help_menu_dropdown-opened\" aria-label=\"Help Menu\"> <span class=\"help-menu__icon\"> <md-icon>help</md-icon> <intercom-unread-count></intercom-unread-count> </span> </md-button> <md-menu-content class=\"help-menu__menu-content\"> <md-menu-item> <md-button id=\"helpCenterButton\" ng-click=\"$ctrl.openHelpCenter()\"> <md-icon>help_outline</md-icon> {{\"HELP_ACTIONS.DOCS\" | translate}} </md-button> </md-menu-item> <md-menu-item class=\"help-menu__menu-item help-menu__menu-item--intercom\" ng-if=\"$ctrl.showIntercomButton\"> <intercom-button icon-button=\"false\"> <intercom-icon> </intercom-icon> <intercom-unread-count></intercom-unread-count> </intercom-button> </md-menu-item> <md-menu-item ng-if=\"$ctrl.showCallMenu\"> <calendly-button show-icon=\"true\"></calendly-button> </md-menu-item> <md-menu-item ng-if=\"!$ctrl.isTrialAccount && $ctrl.videoLink\"> <md-button ng-click=\"$ctrl.openVideoSlider()\"> <md-icon>play_circle_outline</md-icon> {{'LABEL.WATCH_VIDEO' | translate}} </md-button> </md-menu-item> <md-menu-item ng-if=\"$ctrl.hasFetchedUserInfo\"> <support-pin phone-number=\"$ctrl.phoneNumber\"/> </md-menu-item> </md-menu-content> </md-menu> <page-header-overflow-menu gtm-id=\"$ctrl.gtmId\" show-open-import-modal=\"$ctrl.isMobile && && !$ctrl.isDetail && $ctrl.openImportModal\" show-search-button=\"$ctrl.showSearch\" on-search-button-clicked=\"$ctrl.searchCtrl.toggleSearch()\" show-call-menu=\"$ctrl.showCallMenu\" transclude-position=\"$ctrl.menuItemsPosition\"> <div ng-transclude=\"overflowMenuItems\"></div> </page-header-overflow-menu> </div> </div> ";

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackButtonComponentModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

__webpack_require__(1431);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BackButtonComponentModule = angular.module('app.components.pageHeader.backButton', [_angularjs.default]).component('backButton', {
  template: "\n            <md-button\n                class=\"md-icon-button back-button back-button--{{$ctrl.themeName}}\"\n                gtm-click-event=\"{{$ctrl.gtmId}}_back\"\n                ng-click=\"$ctrl.onButtonClick()\"\n                ng-disabled=\"$ctrl.shouldShowSpinner()\"\n                aria-label=\"Back to previous page\">\n                <md-icon id=\"{{$ctrl.gtmId}}\" ng-if=\"!$ctrl.shouldShowSpinner()\">arrow_back</md-icon>\n                <md-progress-circular\n                    ng-if=\"$ctrl.shouldShowSpinner()\"\n                    md-diameter=\"24\"\n                    md-mode=\"indeterminate\"\n                    ng-class=\"{'progress-white': $ctrl.themeName === 'light',\n                        'progress-dark': $ctrl.themeName === 'dark'}\">\n                </md-progress-circular>\n            </md-button>\n        ",
  bindings: {
    showSpinner: '<',
    stateName: '@',
    gtmId: '<',
    theme: '@',
    onClick: '&'
  },
  controller:
  /*#__PURE__*/
  function () {
    BackButtonController.$inject = ["$state", "$attrs"];

    function BackButtonController($state, $attrs) {
      'ngInject';

      _classCallCheck(this, BackButtonController);

      angular.extend(this, {
        loading: false,
        themeName: this.theme === 'dark' ? 'dark' : 'light',
        $state: $state,
        $attrs: $attrs
      });
    }

    _createClass(BackButtonController, [{
      key: "onButtonClick",
      value: function onButtonClick() {
        var _this = this;

        if (this.stateName) {
          this.loading = true;
          this.$state.go(this.stateName).then(function () {
            _this.loading = false;
          });
        }

        if (this.$attrs.onClick) {
          this.onClick();
        }
      }
    }, {
      key: "shouldShowSpinner",
      value: function shouldShowSpinner() {
        return this.showSpinner && this.loading;
      }
    }]);

    return BackButtonController;
  }()
}).name;
exports.BackButtonComponentModule = BackButtonComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsComponentModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

__webpack_require__(1433);

var _tabs2 = _interopRequireDefault(__webpack_require__(1434));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TabsComponentModule = angular.module('app.components.pageHeader.tabs', [_angularjs.default]).component('tabs', {
  template: _tabs2.default,
  bindings: {
    tabs: '<',
    onTabChange: '<',
    gtmId: '<',
    isMobile: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    TabsController.$inject = ["$state", "$attrs", "$scope"];

    function TabsController($state, $attrs, $scope) {
      'ngInject';

      var _this = this;

      _classCallCheck(this, TabsController);

      angular.extend(this, {
        currentTab: 0,
        tabState: {},
        loading: false,
        themeName: this.theme === 'dark' ? 'dark' : 'light',
        $state: $state,
        $attrs: $attrs
      });
      $scope.$on('$stateChangeStart', function (event, toState) {
        _this.currentTab = _this.getTabIndex(toState.name);
      });
    }

    _createClass(TabsController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this2 = this;

        this.tabs.forEach(function (item, index) {
          _this2.tabState[item.state] = index;
        });
        this.currentTab = this.getTabIndex(this.$state.current.name);
      }
    }, {
      key: "getTabIndex",
      value: function getTabIndex(state) {
        return this.tabState[state];
      }
    }]);

    return TabsController;
  }()
}).name;
exports.TabsComponentModule = TabsComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header--tabs\"> <md-tabs data-e2e=\"Header_Tabs\" md-selected=\"$ctrl.currentTab\" md-no-pagination=\"{{!$ctrl.isMobile}}\" id=\"tabs\" class=\"md-tabs vln-center-tabs-scroll\" md-center-tabs md-dynamic-height> <md-tab ng-repeat=\"item in $ctrl.tabs\" ui-sref=\"{{item.state}}\" gtm-click-event=\"{{$ctrl.gtmId}}-myappsTab\" md-on-select=\"$ctrl.onTabChange($ctrl.currentTab)\"> <md-tab-label>{{item.title}}</md-tab-label> </md-tab> </md-tabs> </div> ";

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendlyButtonComponentModule = void 0;

var _calendlyLaunch = __webpack_require__(657);

__webpack_require__(1439);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CalendlyButtonComponentModule = angular.module('app.components.pageHeader.calendlyButton', [_calendlyLaunch.LaunchCalendlyModalModule]).component('calendlyButton', {
  template: "\n            <md-button\n                ng-click=\"$ctrl.showCalendly()\"\n                class=\"calendly-button\">\n                <md-icon ng-show=\"$ctrl.showIcon\">phone</md-icon>\n                {{\"HELP_ACTIONS.CALL\" | translate}}\n            </md-button>\n        ",
  bindings: {
    showIcon: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    CalendlyButtonCtrl.$inject = ["launchCalendlyModal"];

    function CalendlyButtonCtrl(launchCalendlyModal) {
      'ngInject';

      _classCallCheck(this, CalendlyButtonCtrl);

      angular.extend(this, {
        launchCalendlyModal: launchCalendlyModal
      });
    }

    _createClass(CalendlyButtonCtrl, [{
      key: "showCalendly",
      value: function showCalendly() {
        this.launchCalendlyModal.openSupportScheduler();
      }
    }]);

    return CalendlyButtonCtrl;
  }()
}).name;
exports.CalendlyButtonComponentModule = CalendlyButtonComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendlyModalModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _calendlyModal = _interopRequireDefault(__webpack_require__(1437));

__webpack_require__(1438);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CalendlyModalModule = angular.module('app.components.calendlyModal', ['ngMaterial']).component('calendlyModal', {
  template: _calendlyModal.default,
  bindings: {
    link: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    CalendlyModal.$inject = ["$mdDialog"];

    function CalendlyModal($mdDialog) {
      _classCallCheck(this, CalendlyModal);

      (0, _assign.default)(this, {
        $mdDialog: $mdDialog
      });
    }

    _createClass(CalendlyModal, [{
      key: "close",
      value: function close() {
        this.$mdDialog.cancel();
      }
    }]);

    return CalendlyModal;
  }()
}).name;
exports.CalendlyModalModule = CalendlyModalModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

module.exports = "<md-button class=\"calendly-modal__close\" ng-click=\"$ctrl.close()\" aria-label=\"Close schedule a call dialog\"> <md-icon>close</md-icon> </md-button> <md-dialog-content layout=\"column\"> <iframe flex ng-src=\"{{$ctrl.link}}\"/> </md-dialog-content> ";

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SupportPinComponentModule = void 0;

var _createSupportPin = _interopRequireDefault(__webpack_require__(1441));

__webpack_require__(1442);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SupportPinComponentModule = angular.module('app.components.pageHeader.supportPin', []).component('supportPin', {
  bindings: {
    phoneNumber: '<'
  },
  template: "\n            <div class=\"support-pin\" ng-if=\"$ctrl.supportPin\">\n                <div class=\"support-pin__label\">\n                    Support Pin\n                </div>\n                <div class=\"support-pin__number\">\n                    {{$ctrl.supportPin}}\n                </div>\n            </div>\n            <md-button\n                class=\"support-pin\"\n                ui-sref=\"myAccount\"\n                alt=\"my account\"\n                title=\"My Account\"\n                ng-if=\"!$ctrl.supportPin\">\n                <div class=\"support-pin__label\">\n                    Support Pin\n                </div>\n                <div class=\"support-pin__text\">\n                    Add phone number to get PIN\n                </div>\n            </md-button>\n        ",
  controller:
  /*#__PURE__*/
  function () {
    function SupportPinCtrl() {
      'ngInject';

      _classCallCheck(this, SupportPinCtrl);
    }

    _createClass(SupportPinCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        if (this.phoneNumber) this.supportPin = (0, _createSupportPin.default)(this.phoneNumber);
      }
    }]);

    return SupportPinCtrl;
  }()
}).name;
exports.SupportPinComponentModule = SupportPinComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var createSupportPin = function createSupportPin(phoneNumber) {
  phoneNumber = phoneNumber.toString().trim().replace(/[^0-9]/g, '');
  return "".concat(phoneNumber.slice(0, 3), "-").concat(phoneNumber.slice(3, 6), "-").concat(phoneNumber.slice(6));
};

var _default = createSupportPin;
exports.default = _default;

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowMenuBulkProcessModule = void 0;
var OverflowMenuBulkProcessModule = angular.module('app.components.pageHeader.overflowMenuBulkProcess', []).component('overflowMenuBulkProcess', {
  template: "\n            <md-menu-item>\n                <md-button ng-click=\"$ctrl.onClick()\">\n                    {{'ORDER.BULK_PROCESS_ORDERS' | translate}}\n                </md-button>\n            </md-menu-item>\n        ",
  bindings: {
    onClick: '&'
  }
}).name;
exports.OverflowMenuBulkProcessModule = OverflowMenuBulkProcessModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowMenuCalendlyComponentModule = void 0;
var OverflowMenuCalendlyComponentModule = angular.module('app.components.pageHeader.overflowMenuCalendly', []).component('overflowMenuCalendly', {
  template: "\n            <md-menu-item class=\"overflow-menu-calendly\">\n                <calendly-button show-icon=\"false\"></calendly-button>\n            </md-menu-item>\n        "
}).name;
exports.OverflowMenuCalendlyComponentModule = OverflowMenuCalendlyComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowMenuComponentModule = void 0;

var _subscription = __webpack_require__(42);

var _launchDarkly = __webpack_require__(30);

var _storeInformation = __webpack_require__(38);

__webpack_require__(1446);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom'
};
var OverflowMenuComponentModule = angular.module('app.components.pageHeader.pageHeaderOverflowMenu', [_subscription.SubscriptionServiceModule, _launchDarkly.LaunchDarklyServiceModule, _storeInformation.StoreInformationServiceModule]).component('pageHeaderOverflowMenu', {
  template: "\n            <md-menu md-position-mode=\"target-right target\" md-helper>\n                <md-button\n                    data-cy=\"overflow\"\n                    class=\"md-icon-button header__menu-button\"\n                    ng-click=\"$mdMenu.open($event)\"\n                    gtm-click-event=\"{{$ctrl.gtmId}}_menu-open\">\n                    <md-icon>more_vert</md-icon>\n                </md-button>\n                <md-menu-content class=\"overflow-menu__content\">\n                    <ng-transclude ng-if=\"$ctrl.transcludePosition === $ctrl.POSITION.TOP\"></ng-transclude>\n                    <overflow-menu-bulk-process\n                        ng-if=\"$ctrl.showOpenUpdateModal\"\n                        on-click=\"$ctrl.showOpenUpdateModal()\">\n                    </overflow-menu-bulk-process>\n                    <overflow-menu-search ng-if=\"$ctrl.showSearchButton\"\n                        on-click=\"$ctrl.onSearchButtonClicked()\">\n                    </overflow-menu-search>\n                    <md-divider ng-if=\"$ctrl.isMobile && $ctrl.showSearchButton\"></md-divider>\n                    <overflow-menu-help hide-gt-xs></overflow-menu-help>\n                    <overflow-menu-intercom hide-gt-xs></overflow-menu-intercom>\n                    <overflow-menu-calendly hide-gt-xs ng-if=\"$ctrl.showCallMenu\"></overflow-menu-calendly>\n                    <md-divider ng-if=\"$ctrl.isMobile\"></md-divider>\n                    <overflow-menu-storefront-preview ng-if=\"!$ctrl.isElementStore\"/>\n                    <overflow-menu-logout></overflow-menu-logout>\n                    <ng-transclude ng-if=\"$ctrl.transcludePosition === $ctrl.POSITION.BOTTOM\"></ng-transclude>\n                </md-menu-content>\n            </md-menu>\n        ",
  transclude: true,
  bindings: {
    gtmId: '<',
    showCallMenu: '<',
    showOpenUpdateModal: '<',
    showSearchButton: '<',
    onSearchButtonClicked: '&',
    transcludePosition: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    PageHeaderOverflowMenuCtrl.$inject = ["subscriptionsService", "launchDarklyService", "storeInformationService", "$window"];

    function PageHeaderOverflowMenuCtrl(subscriptionsService, launchDarklyService, storeInformationService, $window) {
      'ngInject';

      _classCallCheck(this, PageHeaderOverflowMenuCtrl);

      angular.extend(this, {
        subscriptionsService: subscriptionsService,
        launchDarklyService: launchDarklyService,
        storeInformationService: storeInformationService,
        $window: $window,
        showCallMenu: false,
        isMobile: false,
        POSITION: POSITION
      });
    }

    _createClass(PageHeaderOverflowMenuCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.setShowCallMenu();
        var mobileCheck = this.$window.matchMedia('(max-width: 599px)');
        this.isMobile = mobileCheck.matches;
        this.transcludePosition = this.transcludePosition || POSITION.TOP;
        this.launchDarklyService.isElementStore(this.storeInformationService).then(function (isElementStore) {
          return _this.isElementStore = isElementStore;
        });
      }
    }, {
      key: "setShowCallMenu",
      value: function setShowCallMenu() {
        var _this2 = this;

        this.subscriptionsService.getSubscription().then(function (subs) {
          _this2.showCallMenu = subs.features.scheduleCallDisplayed;
        });
      }
    }]);

    return PageHeaderOverflowMenuCtrl;
  }()
}).name;
exports.OverflowMenuComponentModule = OverflowMenuComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowMenuHelpComponentModule = void 0;
var OverflowMenuHelpComponentModule = angular.module('app.components.pageHeader.overflowMenuHelp', []).component('overflowMenuHelp', {
  template: "\n            <md-menu-item class=\"overflow-menu-help\">\n                <md-button\n                    ng-href=\"https://help.volusion.com/\"\n                    target=\"_blank\"\n                    aria-label=\"{{'HELP_ACTIONS.DOCS' | translate}}\"\n                >\n                    <span translate=\"HELP_ACTIONS.DOCS\"></span>\n                </md-button>\n            </md-menu-item>\n        "
}).name;
exports.OverflowMenuHelpComponentModule = OverflowMenuHelpComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowMenuIntercomComponentModule = void 0;

__webpack_require__(1449);

var OverflowMenuIntercomComponentModule = angular.module('app.components.pageHeader.overflowMenuIntercom', []).component('overflowMenuIntercom', {
  template: "\n            <md-menu-item class=\"overflow-menu-intercom\">\n                <intercom-button>\n                    <span class=\"overflow-menu-intercom__text\" translate=\"HELP_ACTIONS.CHAT\"></span>\n                    <intercom-unread-count></intercom-unread-count>\n                </intercom-button>\n            </md-menu-item>\n        "
}).name;
exports.OverflowMenuIntercomComponentModule = OverflowMenuIntercomComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowMenuLogoutComponentModule = void 0;

var _logout = __webpack_require__(593);

var OverflowMenuLogoutComponentModule = angular.module('app.components.pageHeader.overflowMenuLogout', [_logout.LogoutDirectiveModule]).component('overflowMenuLogout', {
  template: "\n            <md-menu-item>\n                <md-button logout>{{\"STORE.LOGOUT\" | translate}}</md-button>\n            </md-menu-item>\n        "
}).name;
exports.OverflowMenuLogoutComponentModule = OverflowMenuLogoutComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowMenuSearchComponentModule = void 0;
var OverflowMenuSearchComponentModule = angular.module('app.components.pageHeader.overflowMenuSearch', []).component('overflowMenuSearch', {
  template: "\n            <md-menu-item>\n                <md-button ng-click=\"$ctrl.onClick()\">Search</md-button>\n            </md-menu-item>\n        ",
  bindings: {
    onClick: '&'
  }
}).name;
exports.OverflowMenuSearchComponentModule = OverflowMenuSearchComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowMenuStorefrontCacheModule = void 0;
var OverflowMenuStorefrontCacheModule = angular.module('app.components.pageHeader.overflowStorefrontCache', []).component('overflowMenuStorefrontCache', {
  template: "\n            <md-menu-item class=\"overflow-menu-storefront-cache\">\n                <md-button aria-label=\"Storefront Cache Refresh Button\" ng-click=\"$ctrl.onRefreshCache()\">\n                        <span translate=\"BUTTON.STOREFRONTCACHE\"></span>\n                </md-button>\n            </md-menu-item>\n        ",
  bindings: {
    onRefreshCache: '<'
  }
}).name;
exports.OverflowMenuStorefrontCacheModule = OverflowMenuStorefrontCacheModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowMenuStorefrontPreviewComponentModule = void 0;
var OverflowMenuStorefrontPreviewComponentModule = angular.module('app.components.pageHeader.overflowMenuStorefrontPreview', []).component('overflowMenuStorefrontPreview', {
  template: "\n            <md-menu-item>\n                <md-button open-storefront-slider>{{'BUTTON.STOREFRONTPREVIEW' | translate}}</md-button>\n            </md-menu-item>\n        "
}).name;
exports.OverflowMenuStorefrontPreviewComponentModule = OverflowMenuStorefrontPreviewComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

module.exports = "<div class=\"layout__scope content--new-nav\" ng-class=\"{'layout__scope--no-touch': $ctrl.noTouch}\"> <ng-transclude></ng-transclude> </div> ";

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

module.exports = "<div class=\"appshell__scope\"> <div class=\"page\"> <page-header page-title=\"{{$ctrl.title}}\"> </page-header> <page-content> <div class=\"page__content appframe\"> <iframe ng-src=\"{{$ctrl.trustedSrc}}\" frameborder=\"0\"/> </div> </page-content> </div> </div> ";

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteDesignerModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(34));

var _appShell = __webpack_require__(117);

var _apps = __webpack_require__(76);

var _launchDarkly = __webpack_require__(30);

var _onboarding = __webpack_require__(59);

var _storeInformation = __webpack_require__(38);

__webpack_require__(1458);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* site designer module */
var SiteDesignerModule = angular.module('app.pages.siteDesigner', [_angularjs.default, _appShell.AppShellModule, _apps.AppsServiceModule, _launchDarkly.LaunchDarklyServiceModule, _onboarding.OnboardingServiceModule, _storeInformation.StoreInformationServiceModule]).config(["$stateProvider", function ($stateProvider) {
  'ngInject';

  $stateProvider.state('designer', {
    parent: 'auth',
    name: 'siteDesigner',
    url: '/designer',
    params: {
      gallery: '',
      addpage: ''
    },
    component: 'appShell',
    resolve: {
      title: function title() {
        return 'Site Designer';
      },
      trackingId: function trackingId() {
        return 'Site Designer';
      },
      state: ["onboardingService", function state(onboardingService) {
        return onboardingService.getState();
      }],
      isNewAccount: ["launchDarklyService", "storeInformationService", function isNewAccount(launchDarklyService, storeInformationService) {
        return storeInformationService.getStore().then(function (storeInformation) {
          return launchDarklyService.isNewAccount(storeInformation);
        });
      }],
      canAddPages: ["launchDarklyService", "isNewAccount", function canAddPages(launchDarklyService, isNewAccount) {
        return launchDarklyService.getFeature('site-designer-add-page') || isNewAccount;
      }],
      src: ["authTokenService", "onboardingService", "state", "isNewAccount", "canAddPages", "$stateParams", function src(authTokenService, onboardingService, state, isNewAccount, canAddPages, $stateParams) {
        var tenantId = authTokenService.getCachedTenantId();
        var token = authTokenService.getCachedToken();
        var FIRST_VISIT_KEY = 'sitedesigner.firstvisit';
        var firstVisit = isNewAccount && !(0, _get.default)(state, "tasks.completed['".concat(FIRST_VISIT_KEY, "']"), false);
        var paramList = [];
        if ($stateParams.gallery || firstVisit) paramList.push('gallery=1');
        if ($stateParams.addpage && canAddPages) paramList.push('addpage=1');
        var params = paramList.length ? "&".concat(paramList.join('&')) : '';
        if (firstVisit) onboardingService.completeTask(FIRST_VISIT_KEY);
        return "".concat("https://design.v2-sandbox.volusion.com", "?tenantId=").concat(tenantId, "&token=").concat(token).concat(params);
      }]
    },
    data: {
      page: 'siteDesigner'
    }
  }).state('usersAndPermissions', {
    url: '/designer/users',
    reloadOnSearch: false,
    parent: 'auth',
    name: 'usersAndPermissions',
    component: 'appShell',
    resolve: {
      title: function title() {
        return 'User Management';
      },
      trackingId: function trackingId() {
        return 'Users Permissions';
      },
      src: ["authTokenService", function src(authTokenService) {
        var tenantId = authTokenService.getCachedTenantId();
        var token = authTokenService.getCachedToken();
        return "".concat("https://design.v2-sandbox.volusion.com", "?tenantId=").concat(tenantId, "&token=").concat(token, "&users=1");
      }]
    },
    data: {
      page: 'usersAndPermissions'
    }
  }).state('blockManagement', {
    url: '/designer/blocks',
    reloadOnSearch: false,
    parent: 'auth',
    name: 'blockManagement',
    component: 'appShell',
    resolve: {
      title: function title() {
        return 'Block Management';
      },
      trackingId: function trackingId() {
        return 'Block Management';
      },
      src: ["authTokenService", function src(authTokenService) {
        var tenantId = authTokenService.getCachedTenantId();
        var token = authTokenService.getCachedToken();
        return "".concat("https://design.v2-sandbox.volusion.com", "?tenantId=").concat(tenantId, "&token=").concat(token, "&blocks=1");
      }]
    },
    data: {
      page: 'blockManagement'
    }
  }).state('menuManagement', {
    url: '/designer/menus',
    reloadOnSearch: false,
    parent: 'auth',
    name: 'menuManagement',
    component: 'appShell',
    resolve: {
      title: function title() {
        return 'Menu Management';
      },
      trackingId: function trackingId() {
        return 'Menu Management';
      },
      src: ["authTokenService", function src(authTokenService) {
        var tenantId = authTokenService.getCachedTenantId();
        var token = authTokenService.getCachedToken();
        return "".concat("https://design.v2-sandbox.volusion.com", "?tenantId=").concat(tenantId, "&token=").concat(token, "&menus=1");
      }]
    },
    data: {
      page: 'menuManagement'
    }
  });
}]).name;
exports.SiteDesignerModule = SiteDesignerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoreCreditModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _launchDarkly = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreCreditModule = angular.module('app.pages.storeCredit', [_angularjs.default, _launchDarkly.LaunchDarklyServiceModule]).config(["$stateProvider", function ($stateProvider) {
  'ngInject';

  $stateProvider.state('storeCredit', {
    parent: 'auth',
    name: 'storeCredit',
    resolve: {
      hasStoreCreditFeature: ["launchDarklyService", "$state", function hasStoreCreditFeature(launchDarklyService, $state) {
        launchDarklyService.getFeature('new-admin-features-enabled').then(function (feature) {
          if (!feature.includes('storeCredit')) {
            return $state.go('dashboard');
          }
        });
      }]
    }
  }).state('storeCredit.add', {
    name: 'storeCredit.add',
    params: {
      email: ''
    }
  }).state('storeCredit.detail', {
    url: '/storeCredit/:storeCreditId',
    name: 'storeCredit.detail'
  });
}]).name;
exports.StoreCreditModule = StoreCreditModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MailChimpModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _appShell = __webpack_require__(117);

var _apps = __webpack_require__(76);

__webpack_require__(1461);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MailChimpModule = angular.module('app.pages.mailchimp', [_angularjs.default, _appShell.AppShellModule, _apps.AppsServiceModule]).config(["$stateProvider", function ($stateProvider) {
  'ngInject';

  $stateProvider.state({
    parent: 'apps',
    name: 'mailchimp',
    url: '/mailchimp',
    component: 'appShell',
    params: {
      queryString: null
    },
    resolve: {
      title: function title() {
        return 'Mailchimp';
      },
      trackingId: function trackingId() {
        return 'Mailchimp';
      },
      src: ["$stateParams", "$sce", "$q", "appsService", function src($stateParams, $sce, $q, appsService) {
        return $q.all([appsService.getApps(), appsService.getHmac(), appsService.getAppToken('hA1pajdjzlQeGnPggFWKDI-FHb_obphqrxMpwCQwLEQba-VWelW0vxjBHPtOYu_snOFU0WACbwwHauz31JSJIg')]) // eslint-disable-line max-len
        .then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 3),
              apps = _ref2[0],
              hmac = _ref2[1],
              token = _ref2[2];

          var uri = '';
          apps.forEach(function (app) {
            if (app.sku === 'mailchimp') {
              uri = "".concat(app.uri, "?tenant=").concat(hmac.tenant, "&hmac=").concat(hmac.hmac, "&timestamp=").concat(hmac.timestamp, "&token=").concat(token); //eslint-disable-line

              if ($stateParams.queryString) {
                uri = "".concat(uri, "&").concat($stateParams.queryString);
              }
            }
          });
          return uri;
        });
      }]
    },
    data: {
      page: 'mailchimp'
    }
  });
}]).name;
exports.MailChimpModule = MailChimpModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalFulfillerModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _appShell = __webpack_require__(117);

var _apps = __webpack_require__(76);

__webpack_require__(1463);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ExternalFulfillerModule = angular.module('app.pages.externalFulfiller', [_angularjs.default, _appShell.AppShellModule, _apps.AppsServiceModule]).config(["$stateProvider", function ($stateProvider) {
  'ngInject';

  $stateProvider.state({
    parent: 'apps',
    name: 'externalfulfiller',
    url: '/externalfulfiller/:redirectAppKey/:orderId/:redirectUrl/:appName',
    component: 'appShell',
    resolve: {
      title: ["$transition$", function title($transition$) {
        var appName = $transition$.params().appName;
        return decodeURIComponent(appName);
      }],
      trackingId: function trackingId() {
        return 'ExternalFulfiller';
      },
      src: ["$sce", "$q", "appsService", "$transition$", function src($sce, $q, appsService, $transition$) {
        var _$transition$$params = $transition$.params(),
            redirectAppKey = _$transition$$params.redirectAppKey,
            orderId = _$transition$$params.orderId,
            redirectUrl = _$transition$$params.redirectUrl;

        return $q.all([appsService.getHmac(), appsService.getAppToken(redirectAppKey)]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              hmac = _ref2[0],
              token = _ref2[1];

          var baseUri = decodeURIComponent(redirectUrl); // eslint-disable-next-line max-len

          var uri = "".concat(baseUri, "?tenant=").concat(hmac.tenant, "&hmac=").concat(hmac.hmac, "&timestamp=").concat(hmac.timestamp, "&token=").concat(token, "&orderid=").concat(orderId);
          return uri;
        });
      }]
    },
    data: {
      page: 'externalfulfiller'
    }
  });
}]).name;
exports.ExternalFulfillerModule = ExternalFulfillerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmazonModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _appShell = __webpack_require__(117);

var _apps = __webpack_require__(76);

__webpack_require__(1465);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AmazonModule = angular.module('app.pages.amazon', [_angularjs.default, _appShell.AppShellModule, _apps.AppsServiceModule]).config(["$stateProvider", function ($stateProvider) {
  'ngInject';

  $stateProvider.state({
    parent: 'apps',
    name: 'amazon',
    url: '/amazon',
    component: 'appShell',
    params: {
      queryString: null
    },
    resolve: {
      title: function title() {
        return 'Amazon';
      },
      trackingId: function trackingId() {
        return 'Amazon';
      },
      src: ["appsService", "authTokenService", "$q", "$stateParams", function src(appsService, authTokenService, $q, $stateParams) {
        return $q.all([appsService.getApps(), appsService.getAppToken('Sr3iikb5vPhglN5X76J2ZLRgygbzyQWcCvJaz1CbV8judBuuyZ358z97PpmRehXuDd-pC6asA2_rXDxgQA8E6w'), // eslint-disable-line max-len
        authTokenService.getTenantId()]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 3),
              apps = _ref2[0],
              token = _ref2[1],
              tenant = _ref2[2];

          var uri = '';
          apps.forEach(function (app) {
            if (app.sku === 'amazon') {
              uri = "".concat(app.uri, "#connect/volusion?tenant=").concat(tenant, "&token=").concat(token); //eslint-disable-line

              if ($stateParams.queryString) {
                uri = "".concat(uri, "&").concat($stateParams.queryString);
              }
            }
          });
          return uri;
        });
      }]
    },
    data: {
      page: 'amazon'
    }
  });
}]).name;
exports.AmazonModule = AmazonModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickbooksModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _appShell = __webpack_require__(117);

var _apps = __webpack_require__(76);

__webpack_require__(1467);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var QuickbooksModule = angular.module('app.pages.quickbooks', [_angularjs.default, _appShell.AppShellModule, _apps.AppsServiceModule]).config(["$stateProvider", function ($stateProvider) {
  'ngInject';

  $stateProvider.state({
    parent: 'apps',
    name: 'quickbooks',
    url: '/quickbooks',
    component: 'appShell',
    params: {
      queryString: null
    },
    resolve: {
      title: function title() {
        return 'Quickbooks';
      },
      trackingId: function trackingId() {
        return 'Quickbooks';
      },
      src: ["appsService", "authTokenService", "$q", "$stateParams", function src(appsService, authTokenService, $q, $stateParams) {
        return $q.all([appsService.getApps(), appsService.getAppToken('w5JXLS5vDLQkgdjsPvZNC1dU2HZ2S3YgTYu4N5gq9Gjc8W1fCvZWVYdcBDW_hryJw5vaE2AsOcj9KxB7Iowz6A'), // eslint-disable-line max-len
        authTokenService.getTenantId()]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 3),
              apps = _ref2[0],
              token = _ref2[1],
              tenant = _ref2[2];

          var uri = '';
          apps.forEach(function (app) {
            if (app.sku === 'quickbooks') {
              uri = "".concat(app.uri, "?orgid=").concat(tenant, "&token=").concat(token, "&keyname=quickbooksonline"); //eslint-disable-line

              if ($stateParams.queryString) {
                uri = "".concat(uri, "&").concat($stateParams.queryString);
              }
            }
          });
          return uri;
        });
      }]
    },
    data: {
      page: 'quickbooks'
    }
  });
}]).name;
exports.QuickbooksModule = QuickbooksModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XeroModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _appShell = __webpack_require__(117);

var _apps = __webpack_require__(76);

__webpack_require__(1469);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var XeroModule = angular.module('app.pages.xero', [_angularjs.default, _appShell.AppShellModule, _apps.AppsServiceModule]).config(["$stateProvider", function ($stateProvider) {
  'ngInject';

  $stateProvider.state({
    parent: 'apps',
    name: 'xero',
    url: '/xero',
    component: 'appShell',
    params: {
      queryString: null
    },
    resolve: {
      title: function title() {
        return 'xero';
      },
      trackingId: function trackingId() {
        return 'xero';
      },
      src: ["appsService", "authTokenService", "$q", "$stateParams", function src(appsService, authTokenService, $q, $stateParams) {
        return $q.all([appsService.getApps(), appsService.getAppToken('w5JXLS5vDLQkgdjsPvZNC1dU2HZ2S3YgTYu4N5gq9Gjc8W1fCvZWVYdcBDW_hryJw5vaE2AsOcj9KxB7Iowz6A'), // eslint-disable-line max-len
        authTokenService.getTenantId()]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 3),
              apps = _ref2[0],
              token = _ref2[1],
              tenant = _ref2[2];

          var uri = '';
          apps.forEach(function (app) {
            if (app.sku === 'xero') {
              uri = "".concat(app.uri, "?orgid=").concat(tenant, "&token=").concat(token, "&keyname=xero"); //eslint-disable-line

              if ($stateParams.queryString) {
                uri = "".concat(uri, "&").concat($stateParams.queryString);
              }
            }
          });
          return uri;
        });
      }]
    },
    data: {
      page: 'xero'
    }
  });
}]).name;
exports.XeroModule = XeroModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayControllerModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

__webpack_require__(1471);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverlayControllerModule = angular.module('app.components.overlay.overlayController', ['ngMaterial']).controller('OverlayController', ["$scope", "$mdDialog", function ($scope, $mdDialog) {
  init();

  function init() {
    (0, _assign.default)($scope, {
      close: close,
      hideCloseButton: hideCloseButton,
      showCloseButton: showCloseButton
    });
    showCloseButton();
  }

  function close() {
    $mdDialog.hide();
  }

  function hideCloseButton() {
    $scope.closeButtonVisible = false;
  }

  function showCloseButton() {
    $scope.closeButtonVisible = true;
  }
}]).name;
exports.OverlayControllerModule = OverlayControllerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeoFilterModule = void 0;
var SeoFilterModule = angular.module('app.filters.seoFilter', []).filter('seoFilter', function () {
  return function (s) {
    s = s === undefined || s === null ? '' : s;
    var str = s.toString().replace(/(\s)/g, '-').trim();
    str = str.replace(/([^a-zA-Z0-9-])+/g, '');
    return str.toLowerCase();
  };
}).name;
exports.SeoFilterModule = SeoFilterModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tcGridDirective = void 0;

var _tcGrid = _interopRequireDefault(__webpack_require__(1521));

__webpack_require__(1522);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var tcGridDirective = function tcGridDirective($parse, $compile, $timeout) {
  'ngInject';

  return {
    restrict: 'E',
    scope: true,
    template: function template(element, attrs) {
      var children = element.find('tc-column');
      var childHtml = '';
      attrs.defaultHeaders = [];
      angular.forEach(children, function (child, index) {
        var childClass = child.getAttribute('tc-class');
        child.setAttribute('data-identifier', Math.random());
        child.setAttribute('tc-col-index', index + 1);
        child.className += " " + (childClass || 'tc-style_td');
        attrs.defaultHeaders.push({
          element: element,
          options: {
            tcName: child.getAttribute('tc-name'),
            tcField: child.getAttribute('tc-field'),
            identifier: child.getAttribute('data-identifier')
          }
        });
        childHtml += child.outerHTML;
      });
      var templateHtml = _tcGrid.default;
      templateHtml = templateHtml.replace(/%gridclass%/g, attrs.tcGridClass || 'tc-grid');
      templateHtml = templateHtml.replace(/%rowclass%/g, attrs.tcRowClass ? '' : 'tc-style_tr');
      templateHtml = templateHtml.replace(/%rowexpression%/g, attrs.tcRowClass || '');
      templateHtml = templateHtml.replace(/%rowclick%/g, attrs.tcRowClick ? 'ng-click="' + attrs.tcRowClick + '"' : '');
      templateHtml = templateHtml.replace(/%rowlink%/g, attrs.tcRowLink ? ' ng-href="' + attrs.tcRowLink + '"' : '');
      templateHtml = templateHtml.replace(/%filter%/g, attrs.tcGridFilter ? ' | filter: ' + attrs.tcGridFilter : '');
      templateHtml = templateHtml.replace(/%children%/g, childHtml);
      return templateHtml;
    },
    controller: ["$scope", "$element", "$attrs", function tcGridController($scope, $element, $attrs) {
      'ngInject';

      var watchInitialized = false;
      var headTimeout;
      var bodyTimeout;
      var vm = this;
      vm.pageCount = 1;
      vm.showFooter = false;
      vm.columns = [];
      vm.columnTemplates = [];
      vm.headerTemplates = [];
      vm.rowTemplate = $attrs.rowTemplate;
      $attrs.rowTemplate = null;
      vm.addColumn = addColumn;
      vm.prev = prev;
      vm.next = next;
      vm.first = first;
      vm.last = last;
      vm.sort = sort;
      vm.updatePageSize = updatePageSize;
      vm.orderColumns = orderColumns;
      vm.registerColumn = registerColumn;
      init();
      $scope.$on('$destroy', function () {
        if (headTimeout) $timeout.cancel(headTimeout);
        if (bodyTimeout) $timeout.cancel(bodyTimeout);
      });

      function init() {
        vm.options = $parse($attrs.tcOptions)($scope.$parent);
        vm.data = $parse($attrs.tcData)($scope.$parent);
        initColumns();
        initOptions();
        initWatch();

        if (vm.options) {
          if (vm.options.onLoad && typeof vm.options.onLoad === 'function') vm.options.onLoad();else if (vm.options.sorting.onSortChange) sortChanged();else if (vm.options.paging.onPageChange) pageChanged();
        }
      }

      function reset() {
        vm.options.paging.currentPage = 1;
        vm.options.sorting.sort = [];
        cleanSortClasses();
        pageChanged();
        sortChanged();
      }

      function initColumns() {
        var header;

        while ((header = $attrs.defaultHeaders.shift()) != null) {
          registerColumn(header.element, header.options);
          header.element = null;
        }
      }

      function registerColumn(element, options) {
        if (hasColumn(options)) return;
        var sortFn;
        var headerId;
        var hideFn;
        options.tcField = options.tcField || '';
        options.tcName = options.tcName || options.tcField;
        var index = vm.headerTemplates.length;

        if (options.tcField) {
          sortFn = ' ng-click="tcGrid.sort(\'' + options.tcField + '\')"';
          headerId = ' id="' + $attrs.tcOptions + "_" + options.tcField.replace(/\./g, '') + '"';
        } else {
          sortFn = '';
          headerId = '';
        }

        hideFn = " ng-class=\"{'tc-hide-col': !tcGrid.columns[\'" + index + "\'].visible}\"";
        var header = '<div class="tc-display_th tc-style_th" tc-col-index="' + (index + 1) + '"' + headerId + sortFn + hideFn + '>' + options.tcName + '<span class="tc-display_sort tc-style_sort"></span></div>';
        var headerEl = angular.element(header);
        vm.headerTemplates.push(headerEl);
        vm.columnTemplates.push(element.clone());
        element = null;
        headerEl = null;
        addColumn(options);
        orderColumns();
      }

      function hasColumn(options) {
        for (var i = 0; i < vm.columns.length; i++) {
          if (vm.columns[i].identifier === options.identifier) {
            return true;
          }
        }

        return false;
      }

      function orderColumns(columnOrder) {
        if (!columnOrder) {
          var columnOrder = [];

          for (var i = 0; i < vm.columns.length; i++) {
            columnOrder.push(i + 1);
          }
        }

        if (vm.columns.length) {
          var table = getTable();
          updateHead(table, columnOrder); //updateBody(table, columnOrder);

          table = null;
        }
      } //TODO: fix body


      function updateBody(table, columnOrder) {
        var body = angular.element('<div class="tc-display_tbody tc-style_tbody"></div>');
        var row = angular.element(vm.rowTemplate);

        if (table.tbody && table.tbody.parentNode) {
          table.tbody.parentNode.removeChild(table.tbody);
        }

        row.html('');

        for (var i in columnOrder) {
          var col = getTemplate(vm.columnTemplates, columnOrder[i]);
          col.removeAttr("ng-transclude");
          row.append(col.clone());
          col = null;
        }

        body.append(row);
        $compile(body)($scope);
        table = angular.element(table);
        table.append(body);
        body = null;
        row = null;
        table = null;
      }

      function updateHead(table, columnOrder) {
        var head = angular.element(table.thead);
        var row = angular.element(head.find('div')[0]);
        row.html('');

        for (var i in columnOrder) {
          var col = getTemplate(vm.headerTemplates, columnOrder[i]);
          row.append(col.clone());
          col = null;
        }

        $compile(head)($scope);
        row = null;
        head = null;
        initSort();
      }

      function getTemplate(templates, identifier) {
        for (var i in templates) {
          var colIndex = templates[i].attr('tc-col-index');
          var colName = templates[i].attr('tc-name');
          var colField = templates[i].attr('tc-field');

          if (colIndex == identifier || colName == identifier || colField == identifier) {
            return templates[i];
          }
        }
      }

      function getTable() {
        //TODO: refactor
        var table = $element.children().children().children()[0];
        var tableChildren = Array.prototype.slice.call(table.children);
        var thead, tbody, node;

        for (var i in tableChildren) {
          node = tableChildren[i];

          if (node.className && node.className.indexOf("tc-display_thead") > -1) {
            thead = node;
          } else if (node.className && node.className.indexOf('tc-display_tbody') > -1) {
            tbody = node;
            tbody.parent = node.parentNode;
          }
        }

        table.tbody = tbody;
        table.thead = thead;
        tbody = null;
        thead = null;
        return table;
      }

      function watchColumn(colIndex, visibleVar) {
        $scope.$parent.$watch(visibleVar, function (newVal, oldVal) {
          if (newVal != oldVal) {
            vm.columns[colIndex].visible = newVal;
          }
        });
      }

      function initOptions() {
        if (!vm.options) return;
        vm.options.reset = reset;
        vm.options.prev = prev;
        vm.options.next = next;
        vm.options.first = first;
        vm.options.last = last;
        vm.options.sort = sort;
        if (vm.options.paging) initPaging();else vm.options.paging = {};
        if (vm.options.sorting) initSort();else vm.options.sorting = {};
      }

      function initWatch() {
        if ($attrs.tcOptions) {
          $scope.$parent.$watch($attrs.tcOptions, function (newVal, oldVal) {
            vm.options = newVal;

            if (newVal == oldVal && newVal.columnDisplay) {
              orderColumns(vm.options.columnDisplay);
            } else if (newVal == oldVal && !newVal.columnDisplay) {
              var colDisplay = [];

              for (var i = 0; i < vm.columns.length; i++) {
                colDisplay.push(i + 1);
              }

              orderColumns(colDisplay);
            } else if (newVal.columnDisplay != oldVal.columnDisplay) {
              orderColumns(vm.options.columnDisplay);
            }

            pageCountWatcher();
          }, true);
        }

        $scope.$parent.$watchCollection($attrs.tcData, function (newVal) {
          vm.data = newVal;
        });

        function pageCountWatcher() {
          if (!watchInitialized) {
            watchInitialized = true;
            return;
          }

          if (vm.options && vm.options.paging) getPageCount();
        }
      }

      function initPaging() {
        if (!vm.options.paging.pageSize || vm.options.paging.pageSize < 1) {
          if (vm.options.paging.pageSizeOptions) {
            vm.options.paging.pageSize = vm.options.paging.pageSizeOptions[0];
          } else {
            vm.options.paging.pageSize = 20;
          }
        }

        if (!vm.options.paging.totalItemCount || vm.options.paging.totalItemCount < 0) vm.options.paging.totalItemCount = 0;
        if (!vm.options.paging.currentPage || vm.options.paging.currentPage < 1) vm.options.paging.currentPage = 1;
        getPageCount();

        if (!$attrs.tcHideFooter) {
          vm.showFooter = true;
        }
      }

      function initSort() {
        if (!vm.options || !vm.options.sorting || !vm.options.sorting.sort) return;
        angular.forEach(vm.options.sorting.sort, function (sortItem) {
          var col = sortItem.split(' ')[0];
          var dir = sortItem.split(' ')[1] || 'asc';
          var column = fetchColumn(col);

          if (column) {
            column.addClass(dir.toLowerCase());
            column = null;
          }
        });
      }

      function getPageCount() {
        var totalCount = vm.options.paging.total || vm.options.paging.totalItemCount;
        vm.pageCount = totalCount > 0 ? Math.ceil(totalCount / vm.options.paging.pageSize) : 0;

        if (vm.pageCount < 1) {
          vm.pageCount = 1;
        }

        vm.options.paging.pageCount = vm.pageCount;
      }

      function first() {
        vm.options.paging.currentPage = 1;
        pageChanged();
      }

      function prev() {
        vm.options.paging.currentPage -= 1;

        if (vm.options.paging.currentPage < 1) {
          vm.options.paging.currentPage = 1;
        }

        pageChanged();
      }

      function next() {
        vm.options.paging.currentPage += 1;

        if (vm.options.paging.currentPage > vm.pageCount) {
          vm.options.paging.currentPage = vm.pageCount;
        }

        pageChanged();
      }

      function last() {
        vm.options.paging.currentPage = vm.pageCount;
        pageChanged();
      }

      function pageChanged() {
        if (vm.options.paging.onPageChange) {
          vm.options.paging.onPageChange(vm.options.paging.currentPage, vm.options.paging.pageSize, vm.options.sorting.sort);
        }
      }

      function sortChanged() {
        if (vm.options.sorting.onSortChange) {
          if (vm.options.paging) {
            vm.options.paging.currentPage = 1;
            vm.options.sorting.onSortChange(vm.options.paging.currentPage, vm.options.paging.pageSize, vm.options.sorting.sort);
          } else {
            vm.options.sorting.onSortChange(null, null, vm.options.sorting.sort);
          }
        }
      }

      function sort(field) {
        if (Object.getOwnPropertyNames(vm.columns).length === 0) return;
        var col = fetchColumn(field);

        if (col) {
          var direction = 'asc';
          if (col.hasClass('asc')) direction = 'desc';
          cleanSortClasses();
          col.addClass(direction);
          vm.options.sorting.sort = [field + ' ' + direction];
          sortChanged();
          col = null;
        }
      }

      function cleanSortClasses() {
        angular.forEach(Object.keys(vm.columns), function (col) {
          if (vm.columns[col].field) {
            var colElement = fetchColumn(vm.columns[col].field);

            if (colElement) {
              colElement.removeClass('desc');
              colElement.removeClass('asc');
              colElement = null;
            }
          }
        });
      }

      function fetchColumn(name) {
        if (!name) return;
        var id = $attrs.tcOptions + '_' + name.replace(/\./g, '');
        var col = document.getElementById(id);

        if (col) {
          var children = col.childNodes;

          for (var s in children) {
            if (children[s].className && children[s].className.indexOf('tc-display_sort') > -1) {
              return angular.element(children[s]);
            }
          }
        }

        return null;
      }

      function addColumn(options) {
        vm.columns.push({
          field: options.tcField,
          identifier: options.identifier,
          visible: true
        });
      }

      function updatePageSize() {
        getPageCount();

        if (vm.options.paging.currentPage > vm.pageCount) {
          vm.options.paging.currentPage = vm.pageCount;
        } else if (vm.options.paging.currentPage < 0) {
          vm.options.paging.currentPage = 0;
        }

        pageChanged();
      }
    }],
    controllerAs: 'tcGrid'
  };
};

exports.tcGridDirective = tcGridDirective;
tcGridDirective.$inject = ["$parse", "$compile", "$timeout"];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tcGrid__scope\"> <div class=\"%gridclass%\"> <div class=\"tc-display_table tc-style_table\"> <div class=\"tc-display_thead tc-style_thead\"> <div class=\"tc-display_tr tc-style_tr\"></div> </div> <div class=\"tc-display_tbody tc-style_tbody\"> <a class=\"tc-display_tr %rowclass%\" ng-class=\"%rowexpression%\" id=\"tc-row-container\" ng-repeat=\"row in tcGrid.data %filter%\" %rowclick% %rowlink%> %children% </a> </div> </div> <div class=\"tc-display_pager tc-style_pager\" ng-show=\"tcGrid.showFooter && tcGrid.pageCount > 1\"> <div class=\"tc-display_item-total\"> {{(tcGrid.options.paging.currentPage - 1) * tcGrid.options.paging.pageSize + 1}} - {{tcGrid.options.paging.currentPage === tcGrid.pageCount ? tcGrid.options.paging.totalItemCount : tcGrid.options.paging.currentPage * tcGrid.options.paging.pageSize}} of {{tcGrid.options.paging.totalItemCount}} </div> <div class=\"tc-display_page-nav\"> <span class=\"tc-style_page-display\">{{tcGrid.options.paging.currentPage}} / {{tcGrid.pageCount}}</span> <select class=\"tc-select\" ng-if=\"tcGrid.options.paging.pageSizeOptions.length\" ng-options=\"pageSize for pageSize in tcGrid.options.paging.pageSizeOptions\" ng-model=\"tcGrid.options.paging.pageSize\" ng-change=\"tcGrid.updatePageSize()\"></select> <button class=\"tc-button\" ng-click=\"tcGrid.first()\" ng-disabled=\"tcGrid.options.paging.currentPage === 1\"><strong>|</strong>&#9668;</button> <button class=\"tc-button\" ng-click=\"tcGrid.prev()\" ng-disabled=\"tcGrid.options.paging.currentPage === 1\">&#9668;</button> <button class=\"tc-button\" ng-click=\"tcGrid.next()\" ng-disabled=\"tcGrid.options.paging.currentPage === tcGrid.pageCount\">&#9658;</button> <button class=\"tc-button\" ng-click=\"tcGrid.last()\" ng-disabled=\"tcGrid.options.paging.currentPage === tcGrid.pageCount\">&#9658;<strong>|</strong></button> </div> <div class=\"clearfix\"></div> </div> </div> </div>";

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tcColumnDirective = void 0;

/*eslint-disable */
var tcColumnDirective = function tcColumnDirective() {
  'ngInject';

  return {
    restrict: 'E',
    require: '^?tcGrid',
    replace: true,
    transclude: true,
    template: function template(element, attrs) {
      var template = "<div class='tc-display_td' ng-transclude";

      if (attrs.tcIgnoreClick) {
        template += " ng-click=\"$event.preventDefault();$event.stopPropagation();\"";
      }

      template += "></div>";
      return template;
    },
    compile: function compile(element, attrs) {
      if (attrs.tcIgnoreClick) {
        element.attr('ng-click', 'test();vm.test()');
      }

      return {
        post: function post(scope, element, attrs, ctrl) {
          if (ctrl) {
            ctrl.registerColumn(element, attrs);
          }
        }
      };
    },
    controller: ["$scope", "$element", "$attrs", function controller($scope, $element, $attrs) {
      'ngInject';

      $scope.test = function () {
        console.log('test');
      };
    }]
  };
};
/*eslint-enable */


exports.tcColumnDirective = tcColumnDirective;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _materialIconsReact = _interopRequireDefault(__webpack_require__(196));

var _IconCircle = _interopRequireDefault(__webpack_require__(727));

var _GtmTracking = __webpack_require__(278);

var _thread = __webpack_require__(64);

var _grid = __webpack_require__(83);

var _OtherThingsButton = _interopRequireDefault(__webpack_require__(1525));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 48px;\n    margin-bottom: 0;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    margin-right: 20px;\n    width: auto;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: 48px;\n    line-height: 48px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 80px;\n    max-width: 800px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "EmptyListPage2__Container",
  componentId: "anj03e-0"
})(["width:100%;padding:0 24px;color:", ";", ""], _thread.colors.white, _thread.media.sm(_templateObject()));
var StyledIcon = (0, _styledComponents.default)(_IconCircle.default).attrs({
  backgroundColor: _thread.colors.white
}).withConfig({
  displayName: "EmptyListPage2__StyledIcon",
  componentId: "anj03e-1"
})(["display:none;margin-bottom:28px;justify-content:center;align-items:center;", ""], _thread.media.sm(_templateObject2()));
var SmallStyledIcon = (0, _styledComponents.default)(StyledIcon).attrs({
  size: '48px'
}).withConfig({
  displayName: "EmptyListPage2__SmallStyledIcon",
  componentId: "anj03e-2"
})(["margin:16px 0;display:flex;", ""], _thread.media.sm(_templateObject3()));

var Headline = _styledComponents.default.h1.withConfig({
  displayName: "EmptyListPage2__Headline",
  componentId: "anj03e-3"
})(["font-size:24px;line-height:32px;", ""], _thread.media.sm(_templateObject4()));

var Subhead = _styledComponents.default.p.withConfig({
  displayName: "EmptyListPage2__Subhead",
  componentId: "anj03e-4"
})(["color:", ";"], _thread.colors.white70);

var ActionsContainer = (0, _styledComponents.default)(_grid.Flex).attrs({
  flexDirection: ['column', 'row'],
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexWrap: 'wrap'
}).withConfig({
  displayName: "EmptyListPage2__ActionsContainer",
  componentId: "anj03e-5"
})(["margin:8px 0 14px;width:100%;"]);
var SecondaryButton = (0, _styledComponents.default)(_thread.Button).attrs({
  large: true
}).withConfig({
  displayName: "EmptyListPage2__SecondaryButton",
  componentId: "anj03e-6"
})(["border-color:", ";color:", ";width:100%;margin:0;margin-bottom:16px;", " &:last-child{margin-right:0;}i{color:", " !important;margin-right:8px;}*{pointer-events:none;}"], _thread.colors.white30, _thread.colors.white, _thread.media.sm(_templateObject5()), _thread.colors.white);
var PrimaryButton = (0, _styledComponents.default)(SecondaryButton).attrs({
  variant: 'primary'
}).withConfig({
  displayName: "EmptyListPage2__PrimaryButton",
  componentId: "anj03e-7"
})(["background-color:", ";box-shadow:none;color:", ";margin-bottom:16px;&:hover{background-color:", ";}i{color:", " !important;}"], _thread.colors.white, function (props) {
  return props.color || _thread.colors.black87;
}, _thread.colors.white70, function (props) {
  return props.color || _thread.colors.black87;
});

var OtherThingsHeader = _styledComponents.default.h3.withConfig({
  displayName: "EmptyListPage2__OtherThingsHeader",
  componentId: "anj03e-8"
})(["text-transform:uppercase;font-size:12px;font-weight:bold;letter-spacing:1px;line-height:16px;margin-bottom:16px;color:", ";"], _thread.colors.white70);

var HelpMessageContainer = (0, _styledComponents.default)(_grid.Flex).attrs({
  flexDirection: 'row',
  justifyContent: 'start',
  alignItems: 'start'
}).withConfig({
  displayName: "EmptyListPage2__HelpMessageContainer",
  componentId: "anj03e-9"
})(["margin-top:16px;margin-bottom:32px;color:", ";.material-icons{margin-right:16px;}span{color:", ";font-weight:bold;}", ""], _thread.colors.white70, _thread.colors.white, _thread.media.sm(_templateObject6()));

var TextLink = _styledComponents.default.a.withConfig({
  displayName: "EmptyListPage2__TextLink",
  componentId: "anj03e-10"
})(["color:inherit;text-decoration:underline;cursor:pointer;"]);

var EmptyListPage =
/*#__PURE__*/
function (_Component) {
  _inherits(EmptyListPage, _Component);

  function EmptyListPage() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, EmptyListPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EmptyListPage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.openChat = function () {
      (0, _GtmTracking.trackEvent)('admin_onboarding_chatnow');
      window.Intercom('showNewMessage');
    };

    _this.closeDemoModal = function () {
      return _this.setState({
        demoModalIsOpen: false
      });
    };

    return _this;
  }

  _createClass(EmptyListPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_thread.ThemeProvider, {
        theme: _thread.defaultTheme
      }, _react.default.createElement(Container, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start"
      }, !!this.props.icon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledIcon, null, _react.default.createElement(_materialIconsReact.default, {
        icon: this.props.icon,
        size: 48,
        color: this.props.color
      })), _react.default.createElement(SmallStyledIcon, null, _react.default.createElement(_materialIconsReact.default, {
        icon: this.props.icon,
        size: 24,
        color: this.props.color
      }))), _react.default.createElement(Headline, null, this.props.headline), _react.default.createElement(Subhead, null, this.props.message), _react.default.createElement(ActionsContainer, null, this.props.onCreateClicked && _react.default.createElement(PrimaryButton, {
        onClick: this.props.onCreateClicked,
        id: "admin_".concat(this.props.page, "_new_record"),
        icon: "add",
        variant: "primary",
        color: this.props.color
      }, this.props.createLabel), this.props.onVideoClicked && _react.default.createElement(SecondaryButton, {
        onClick: this.props.onVideoClicked,
        id: "admin_".concat(this.props.page, "_watch_video"),
        icon: "play_circle_outline",
        variant: "link"
      }, "Watch the Video")), !!this.props.ctas.length && _react.default.createElement(_grid.Box, {
        width: 1
      }, _react.default.createElement(OtherThingsHeader, null, "Other Things to Try"), _react.default.createElement(_grid.Flex, {
        flexDirection: ['column', 'row'],
        justifyContent: ['flex-start']
      }, this.props.ctas.map(function (cta, index) {
        return _react.default.createElement(_OtherThingsButton.default, {
          key: index,
          icon: cta.icon,
          svgIcon: cta.svgIcon,
          heading: cta.heading,
          subhead: cta.subhead,
          onClick: cta.action,
          name: cta.name
        });
      }))), _react.default.createElement(HelpMessageContainer, null, _react.default.createElement(_materialIconsReact.default, {
        icon: "help_outline",
        size: 26,
        color: "inherit"
      }), _react.default.createElement("div", null, _react.default.createElement("span", null, this.props.helpText, " "), _react.default.createElement(TextLink, {
        onClick: this.openChat
      }, "Chat online now"), "."))));
    }
  }]);

  return EmptyListPage;
}(_react.Component);

EmptyListPage.propTypes = {
  page: _propTypes.default.string.isRequired,
  icon: _propTypes.default.string,
  color: _propTypes.default.string,
  headline: _propTypes.default.string.isRequired,
  message: _propTypes.default.string,
  onVideoClicked: _propTypes.default.func,
  ctas: _propTypes.default.array,
  onCreateClicked: _propTypes.default.func,
  createLabel: _propTypes.default.string,
  helpText: _propTypes.default.string.isRequired
};
EmptyListPage.defaultProps = {
  color: 'inherit',
  icon: '',
  message: null,
  onVideoClicked: null,
  onCreateClicked: null,
  createLabel: 'Add Item',
  ctas: []
};
var _default = EmptyListPage;
exports.default = _default;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _materialIconsReact = _interopRequireDefault(__webpack_require__(196));

var _thread = __webpack_require__(64);

var _grid = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 50%;\n    margin-bottom: 0;\n\n    &:first-child {\n      margin-right: 8px;\n    }\n  \n    &:last-child {\n      margin-left: 8px;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "OtherThingsButton__StyledButton",
  componentId: "sc-1ndauoz-0"
})(["display:flex;justify-content:center;align-items:center;border:none;background-color:", ";color:#fff;min-height:80px;width:100%;border-radius:4px;cursor:pointer;padding:16px;margin-bottom:16px;&:hover{background-color:", ";}&:active{background-color:", ";}*{pointer-events:none;}", ""], _thread.colors.black10, _thread.colors.black20, _thread.colors.black38, _thread.media.sm(_templateObject()));

var Heading = _styledComponents.default.p.withConfig({
  displayName: "OtherThingsButton__Heading",
  componentId: "sc-1ndauoz-1"
})(["margin:0;margin-bottom:6px;padding:0;font-size:16px;font-weight:bold;line-height:24px;color:#fff;"]);

var Subhead = _styledComponents.default.p.withConfig({
  displayName: "OtherThingsButton__Subhead",
  componentId: "sc-1ndauoz-2"
})(["margin:0;padding:0;font-size:14px;font-weight:normal;line-height:16px;color:", ";text-transform:none;"], _thread.colors.white70);

var SvgIconContainer = (0, _styledComponents.default)(_grid.Flex).attrs({
  justifyContent: 'center',
  alignItems: 'center'
}).withConfig({
  displayName: "OtherThingsButton__SvgIconContainer",
  componentId: "sc-1ndauoz-3"
})(["background-color:", ";width:48px;height:48px;border-radius:50%;margin-left:16px;"], _thread.colors.white);

var OtherThingsButton = function OtherThingsButton(props) {
  return _react.default.createElement(StyledButton, {
    onClick: props.onClick,
    id: "admin_".concat(props.name)
  }, _react.default.createElement(_grid.Flex, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    flex: "1"
  }, _react.default.createElement(Heading, null, props.heading), _react.default.createElement(Subhead, null, props.subhead)), props.icon && _react.default.createElement(_materialIconsReact.default, {
    icon: props.icon,
    size: 48,
    color: _thread.colors.white30
  }), props.svgIcon && _react.default.createElement(SvgIconContainer, null, _react.default.createElement("img", {
    src: props.svgIcon,
    width: "24"
  })));
};

OtherThingsButton.propTypes = {
  icon: _propTypes.default.string,
  svgIcon: _propTypes.default.string,
  heading: _propTypes.default.string.isRequired,
  subhead: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired,
  name: _propTypes.default.string
};
OtherThingsButton.defaultProps = {
  icon: null,
  svgIcon: null,
  heading: '',
  subhead: '',
  onClick: function onClick() {},
  name: ''
};
var _default = OtherThingsButton;
exports.default = _default;

/***/ }),
/* 1526 */,
/* 1527 */,
/* 1528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BulkImportProgressModal = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _constants = __webpack_require__(24);

var _products = __webpack_require__(98);

var _orders = __webpack_require__(378);

var _customers = __webpack_require__(632);

var _bulkImport = __webpack_require__(728);

var _categories = __webpack_require__(100);

var _csvReader = __webpack_require__(409);

var _segment = __webpack_require__(58);

var _bulkImportProgressModal = _interopRequireDefault(__webpack_require__(1530));

__webpack_require__(1531);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BulkImportProgressModal = angular.module('app.pages.products.bulkImportProgressModal', ['ngMaterial', _angularjs.default, _angularTranslate.default, _products.ProductServiceModule, _orders.OrderServiceModule, _customers.CustomerServiceModule, _bulkImport.BulkImportServiceModule, _categories.CategoryServiceModule, _csvReader.CSVReaderService, _segment.SegmentServiceModule]).component('bulkImportProgressModal', {
  template: _bulkImportProgressModal.default,
  bindings: {
    csvObj: '<',
    fileName: '@',
    featureLimitation: '<',
    importerType: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    BulkImportProgressModalController.$inject = ["$scope", "$mdDialog", "$mdToast", "productService", "orderService", "customerService", "bulkImportService", "categoryService", "$state", "$timeout", "$interval", "$window", "$location", "$translate", "segmentService"];

    function BulkImportProgressModalController($scope, $mdDialog, $mdToast, productService, orderService, customerService, bulkImportService, categoryService, $state, $timeout, $interval, $window, $location, $translate, segmentService) {
      'ngInject';

      _classCallCheck(this, BulkImportProgressModalController);

      (0, _assign.default)(this, {
        gtmid: '',
        IMPORT_STATUS_POLL_INTERVAL: 3000,
        $scope: $scope,
        $mdDialog: $mdDialog,
        $mdToast: $mdToast,
        productService: productService,
        orderService: orderService,
        customerService: customerService,
        bulkImportService: bulkImportService,
        categoryService: categoryService,
        $state: $state,
        $timeout: $timeout,
        $interval: $interval,
        $window: $window,
        $location: $location,
        $translate: $translate,
        segmentService: segmentService
      });
    }

    _createClass(BulkImportProgressModalController, [{
      key: "$onInit",
      value: function $onInit() {
        this.gtmid = "admin_".concat(this.$state.current.name, "_bulkImportProgressModal");
        this.bulkUpload();
        this.trackPage();
      }
    }, {
      key: "bulkUpload",
      value: function bulkUpload() {
        var _this = this;

        if (this.csvObj && this.csvObj.contents) {
          if (this.importerType === _constants.IMPORTER_TYPES.PRODUCT) {
            this.productService.createImportJob().then(function (result) {
              _this.productService.bulkUpload(result.url, _this.csvObj.contents);

              _this.pollForBulkUploadStatus(result.importerJobId);
            });
          } else if (this.importerType === _constants.IMPORTER_TYPES.CUSTOMER) {
            this.customerService.bulkUpload(this.csvObj).then(function () {
              _this.pollForCustomerBulkUploadStatus();
            });
          } else {
            this.orderService.bulkUpload(this.csvObj).then(function (orderUploadResponse) {
              _this.handleImportResponse(orderUploadResponse.contents);
            });
          }
        }
      }
    }, {
      key: "pollForBulkUploadStatus",
      value: function pollForBulkUploadStatus(importJobId) {
        var _this2 = this;

        this.activeInterval = this.$interval(function () {
          _this2.getBulkUploadStatus(importJobId);
        }, this.IMPORT_STATUS_POLL_INTERVAL);
      }
    }, {
      key: "stopPolling",
      value: function stopPolling() {
        if (angular.isDefined(this.activeInterval)) {
          this.$interval.cancel(this.activeInterval);
          this.activeInterval = undefined;
        }
      }
    }, {
      key: "pollForCustomerBulkUploadStatus",
      value: function pollForCustomerBulkUploadStatus() {
        var _this3 = this;

        this.activeInterval = this.$interval(function () {
          _this3.getBulkUploadCustomerStatus();
        }, this.IMPORT_STATUS_POLL_INTERVAL);
      }
    }, {
      key: "getBulkUploadCustomerStatus",
      value: function getBulkUploadCustomerStatus() {
        var _this4 = this;

        this.customerService.getBulkUploadStatus().then(function (response) {
          if (response && response.status !== 'InProgress') {
            _this4.stopPolling();

            _this4.handleImportResponse(response.result, response.status);
          }
        });
      }
    }, {
      key: "getBulkUploadStatus",
      value: function getBulkUploadStatus(importJobId) {
        var _this5 = this;

        this.productService.getBulkUploadStatus(importJobId).then(function (response) {
          if (response && response.status !== 'InProgress') {
            _this5.stopPolling();

            _this5.handleProductImportResponse(response.result);
          }
        }, function (err) {
          if (err && err.status !== 404) {
            _this5.stopPolling();

            _this5.handleProductImportResponse(err);
          }
        });
      }
    }, {
      key: "handleImportResponse",
      value: function handleImportResponse(response, status) {
        var formattedErrors = response.errorKeys;
        var isErrorFree = !this.bulkImportService.hasErrors(response);

        if (status === 'None' || this.bulkImportService.isImportSuccessful(response)) {
          this.$mdDialog.hide();
          this.$state.reload();
          this.importSuccess = true;
          this.showSuccess(response.fileRows, response.itemsAdded);
        } else if (!isErrorFree) {
          this.showErrors(formattedErrors);
        }
      }
    }, {
      key: "handleProductImportResponse",
      value: function handleProductImportResponse(response) {
        var _this6 = this;

        var formattedErrors = this.setFormattedErrors(response);
        var isErrorFree = !this.bulkImportService.hasErrors(response);

        if (this.bulkImportService.isImportSuccessful(response)) {
          this.importSuccess = true;

          if (!isErrorFree) {
            var refreshOnClose = true;
            this.showErrors(formattedErrors, refreshOnClose);
          }

          this.$timeout(function () {
            _this6.categoryService.getCategories(true);

            if (isErrorFree) {
              _this6.$mdDialog.hide();

              _this6.$state.reload();
            }

            _this6.showSuccess(response.fileRows, response.importedProducts, response.orderedExtensions);
          }, 700);
        } else if (!isErrorFree) {
          this.showErrors(formattedErrors);
        }
      }
    }, {
      key: "setFormattedErrors",
      value: function setFormattedErrors(response) {
        this.formattedErrors = this.bulkImportService.getFormattedErrors(response.errorKeys);
        return this.formattedErrors;
      }
    }, {
      key: "showErrors",
      value: function showErrors(formattedErrors) {
        var refreshOnClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (formattedErrors.length === 1) {
          this.showErrorWithMessage(formattedErrors[0], refreshOnClose);
        } else if (formattedErrors.length > 1) {
          this.showErrorList(formattedErrors, refreshOnClose);
        }
      }
    }, {
      key: "showSuccess",
      value: function showSuccess(attempted, imported, extensions) {
        var _this7 = this;

        this.$translate('IMPORTER_MODULE.SUCCESS_IMPORTED', {
          COUNT: imported,
          ATTEMPTED: attempted,
          IMPORTER_TYPE: this.importerType
        }).then(function (importMessage) {
          if (extensions && _this7.hasNewExtensions(extensions)) {
            _this7.$translate('PRODUCT.SUCCESSEXTENSIONS', {
              COUNT: extensions.length
            }).then(function (extensionsMessage) {
              _this7.showSuccessToast("".concat(importMessage, " ").concat(extensionsMessage));
            });
          } else {
            _this7.showSuccessToast(importMessage);
          }
        });
      } // ideally this would check against the extensions already installed in the store

    }, {
      key: "hasNewExtensions",
      value: function hasNewExtensions(extensions) {
        return extensions.length > 0;
      }
    }, {
      key: "showSuccessToast",
      value: function showSuccessToast(message) {
        this.$mdToast.show(this.$mdToast.simple().textContent(message).position('bottom left').hideDelay(10000));
      }
    }, {
      key: "showErrorWithMessage",
      value: function showErrorWithMessage(error, doRefreshOnClose) {
        this.$mdDialog.show({
          clickOutsideToClose: true,
          template: "<bulk-import-modal\n                                single-error=\"".concat(error, "\"\n                                importer-type=\"importerType\"\n                                refresh-on-close=\"refreshOnClose\"\n                                feature-limitation=\"featureLimitation\">\n                                </bulk-import-modal>"),
          locals: {
            featureLimitation: this.featureLimitation,
            refreshOnClose: doRefreshOnClose,
            importerType: this.importerType
          },
          controller: ["$scope", "featureLimitation", "refreshOnClose", "importerType", function controller($scope, featureLimitation, refreshOnClose, importerType) {
            'ngInject';

            $scope.featureLimitation = featureLimitation;
            $scope.refreshOnClose = refreshOnClose;
            $scope.importerType = importerType;
          }]
        });
      }
    }, {
      key: "showErrorList",
      value: function showErrorList(formattedErrors, doRefreshOnClose) {
        this.$mdDialog.show({
          clickOutsideToClose: true,
          template: "<bulk-import-modal\n                                error-list=\"errorList\"\n                                refresh-on-close=\"refreshOnClose\"\n                                importer-type=\"importerType\"\n                                feature-limitation=\"featureLimitation\">\n                                </bulk-import-modal>",
          locals: {
            featureLimitation: this.featureLimitation,
            errorList: formattedErrors,
            refreshOnClose: doRefreshOnClose,
            importerType: this.importerType
          },
          controller: ["$scope", "featureLimitation", "errorList", "refreshOnClose", "importerType", function controller($scope, featureLimitation, errorList, refreshOnClose, importerType) {
            'ngInject';

            $scope.featureLimitation = featureLimitation;
            $scope.errorList = errorList;
            $scope.refreshOnClose = refreshOnClose;
            $scope.importerType = importerType;
          }]
        });
      }
    }, {
      key: "trackPage",
      value: function trackPage() {
        this.segmentService.trackGtmEvent({
          analyticsClickEvent: 'virtualPageView'
        }, {
          virtualPage: "".concat(this.$location.path(), "/bulkimport/progress"),
          virtualTitle: 'Bulk Import Upload Progress'
        });
      }
    }]);

    return BulkImportProgressModalController;
  }()
}).name;
exports.BulkImportProgressModal = BulkImportProgressModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal--progress modal__container\"> <md-dialog-content class=\"modal__content upload-progress\"> <div class=\"md-dialog-content\"> <div class=\"upload-progress__csv\"> <svg width=\"48px\" height=\"60px\" viewBox=\"0 0 48 60\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <title>CSV_icon</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" fill-opacity=\"0.54\"> <g id=\"Products---Import-Dialog---Free-Upload\" transform=\"translate(-742.000000, -434.000000)\" fill=\"#000000\"> <g id=\"Card\" transform=\"translate(290.000000, 187.000000)\"> <g id=\"Rectangle-17-+-android\" transform=\"translate(328.000000, 182.000000)\"> <g id=\"Group-2\" transform=\"translate(8.000000, 8.000000)\"> <g id=\"Group-3\" transform=\"translate(34.000000, 57.000000)\"> <g id=\"drive-file\" transform=\"translate(82.000000, 0.000000)\"> <path d=\"M6,0 C2.7,0 0,2.7 0,6 L0,54 C0,57.3 2.7,60 6,60 L42,60 C45.3,60 48,57.3 48,54 L48,18 L30,0 L6,0 L6,0 Z M27,21 L27,4.5 L43.5,21 L27,21 Z M18.12,42.272 C18.2373339,42.272 18.3386662,42.3173329 18.424,42.408 L19.272,43.328 C18.8026643,43.9093362 18.2253368,44.3546651 17.54,44.664 C16.8546632,44.9733349 16.0320048,45.128 15.072,45.128 C14.213329,45.128 13.4413368,44.9813348 12.756,44.688 C12.0706632,44.3946652 11.4853358,43.9866693 11,43.464 C10.5146642,42.9413307 10.142668,42.317337 9.884,41.592 C9.62533204,40.866663 9.496,40.074671 9.496,39.216 C9.496,38.3466623 9.63999856,37.5506703 9.928,36.828 C10.2160014,36.1053297 10.6213307,35.4826693 11.144,34.96 C11.6666693,34.4373307 12.2919964,34.0306681 13.02,33.74 C13.7480036,33.4493319 14.5519956,33.304 15.432,33.304 C16.290671,33.304 17.0413301,33.441332 17.684,33.716 C18.3266699,33.990668 18.877331,34.3546644 19.336,34.808 L18.616,35.808 C18.5733331,35.8720003 18.518667,35.9279998 18.452,35.976 C18.385333,36.0240002 18.2933339,36.048 18.176,36.048 C18.0533327,36.048 17.9280006,36.0000005 17.8,35.904 C17.6719994,35.8079995 17.5093343,35.7040006 17.312,35.592 C17.1146657,35.4799994 16.8653348,35.3760005 16.564,35.28 C16.2626652,35.1839995 15.8800023,35.136 15.416,35.136 C14.8719973,35.136 14.3720023,35.2306657 13.916,35.42 C13.4599977,35.6093343 13.0680016,35.8799982 12.74,36.232 C12.4119984,36.5840018 12.1560009,37.0119975 11.972,37.516 C11.7879991,38.0200025 11.696,38.5866635 11.696,39.216 C11.696,39.8666699 11.7879991,40.4453308 11.972,40.952 C12.1560009,41.4586692 12.4053318,41.8853316 12.72,42.232 C13.0346682,42.5786684 13.4053312,42.8439991 13.832,43.028 C14.2586688,43.2120009 14.7173309,43.304 15.208,43.304 C15.5013348,43.304 15.7666655,43.2880002 16.004,43.256 C16.2413345,43.2239998 16.459999,43.1733337 16.66,43.104 C16.860001,43.0346663 17.0493324,42.9453339 17.228,42.836 C17.4066676,42.7266661 17.5839991,42.5920008 17.76,42.432 C17.8133336,42.3839998 17.869333,42.3453335 17.928,42.316 C17.986667,42.2866665 18.0506663,42.272 18.12,42.272 Z M27.096,35.536 C27.037333,35.6533339 26.9693337,35.7359998 26.892,35.784 C26.8146663,35.8320002 26.7226672,35.856 26.616,35.856 C26.5093328,35.856 26.389334,35.8146671 26.256,35.732 C26.122666,35.6493329 25.9653342,35.5573338 25.784,35.456 C25.6026658,35.3546662 25.3906679,35.2626671 25.148,35.18 C24.9053321,35.0973329 24.6186683,35.056 24.288,35.056 C23.9893318,35.056 23.7293344,35.0919996 23.508,35.164 C23.2866656,35.2360004 23.1000008,35.3359994 22.948,35.464 C22.7959992,35.5920006 22.682667,35.7453324 22.608,35.924 C22.533333,36.1026676 22.496,36.2986656 22.496,36.512 C22.496,36.7840014 22.5719992,37.0106658 22.724,37.192 C22.8760008,37.3733342 23.0773321,37.5279994 23.328,37.656 C23.5786679,37.7840006 23.8639984,37.8986662 24.184,38 C24.5040016,38.1013338 24.830665,38.2093328 25.164,38.324 C25.497335,38.4386672 25.8239984,38.5719992 26.144,38.724 C26.4640016,38.8760008 26.7493321,39.0679988 27,39.3 C27.2506679,39.5320012 27.4519992,39.8159983 27.604,40.152 C27.7560008,40.4880017 27.832,40.8959976 27.832,41.376 C27.832,41.8986693 27.7426676,42.3879977 27.564,42.844 C27.3853324,43.3000023 27.1240017,43.6973316 26.78,44.036 C26.4359983,44.3746684 26.0160025,44.6413324 25.52,44.836 C25.0239975,45.0306676 24.4560032,45.128 23.816,45.128 C23.4479982,45.128 23.0853351,45.0920004 22.728,45.02 C22.3706649,44.9479996 22.0280016,44.845334 21.7,44.712 C21.3719984,44.578666 21.0653348,44.4186676 20.78,44.232 C20.4946652,44.0453324 20.2400011,43.8373345 20.016,43.608 L20.64,42.576 C20.698667,42.501333 20.7693329,42.4386669 20.852,42.388 C20.9346671,42.3373331 21.0266662,42.312 21.128,42.312 C21.261334,42.312 21.4053326,42.3666661 21.56,42.476 C21.7146674,42.5853339 21.8973323,42.706666 22.108,42.84 C22.3186677,42.973334 22.5666652,43.0946661 22.852,43.204 C23.1373348,43.3133339 23.479998,43.368 23.88,43.368 C24.4933364,43.368 24.9679983,43.2226681 25.304,42.932 C25.6400017,42.6413319 25.808,42.2240027 25.808,41.68 C25.808,41.3759985 25.7320008,41.128001 25.58,40.936 C25.4279992,40.743999 25.2266679,40.5826673 24.976,40.452 C24.7253321,40.3213327 24.4400016,40.2106671 24.12,40.12 C23.7999984,40.0293329 23.4746683,39.9306672 23.144,39.824 C22.8133317,39.7173328 22.4880016,39.5893341 22.168,39.44 C21.8479984,39.2906659 21.5626679,39.0960012 21.312,38.856 C21.0613321,38.6159988 20.8600008,38.3160018 20.708,37.956 C20.5559992,37.5959982 20.48,37.1520026 20.48,36.624 C20.48,36.2026646 20.5639992,35.792002 20.732,35.392 C20.9000008,34.991998 21.1453317,34.6373349 21.468,34.328 C21.7906683,34.0186651 22.1866643,33.7706676 22.656,33.584 C23.1253357,33.3973324 23.6613303,33.304 24.264,33.304 C24.9466701,33.304 25.5759971,33.4106656 26.152,33.624 C26.7280029,33.8373344 27.2186646,34.1359981 27.624,34.52 L27.096,35.536 Z M28.344,33.432 L30.08,33.432 C30.2666676,33.432 30.4186661,33.4773329 30.536,33.568 C30.6533339,33.6586671 30.741333,33.7759993 30.8,33.92 L33.52,40.976 C33.6106671,41.2053345 33.6973329,41.457332 33.78,41.732 C33.8626671,42.006668 33.941333,42.2959985 34.016,42.6 C34.1386673,41.9866636 34.2906658,41.4453357 34.472,40.976 L37.184,33.92 C37.2320002,33.7973327 37.3173327,33.6853338 37.44,33.584 C37.5626673,33.4826662 37.7146658,33.432 37.896,33.432 L39.632,33.432 L34.96,45 L33.016,45 L28.344,33.432 Z\" id=\"CSV_icon\"></path> </g> </g> </g> </g> </g> </g> </g> </svg> </div> <div class=\"upload-progress__file-name\"> {{$ctrl.fileName}} </div> <div class=\"upload-progress__bar\"> <div class=\"upload-progress__progress\"></div> <div ng-if=\"$ctrl.importSuccess\" class=\"upload-progress__done\"></div> </div> <div class=\"upload-progress__text\">{{'IMPORTER_MODULE.IMPORTING' | translate: {'IMPORTER_TYPE': $ctrl.importerType} }}</div> </div> </md-dialog-content> </div> ";

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal--upload modal__container\" layout=\"column\"> <md-dialog-content class=\"modal__content\"> <div class=\"md-dialog-content\"> <div ng-if=\"!$ctrl.isViewingErrorList\"> <a href=\"https://help.volusion.com/run-your-business/how-to-add-multiple-products-at-once\" target=\"_blank\" class=\"file-upload__help\" analytics-click-event=\"{{$ctrl.gtmid}}-importHelp\">?</a> <h3 class=\"modal__header\"> {{'IMPORTER_MODULE.TITLE' | translate: {'IMPORTER_TYPE': $ctrl.importerType} }} <span ng-if=\"$ctrl.limitedProducts && !$ctrl.featureLimitation.hasHitProductLimit\" class=\"badge badge--tab\">{{\"PRODUCT.LIMITBADGE\" | translate: {'LIMIT': $ctrl.productLimit} }}</span> <span ng-if=\"$ctrl.featureLimitation.hasHitProductLimit\" class=\"badge badge--tab badge--warning\">{{\"PRODUCT.LIMITREACHEDBADGE\" | translate}}</span> </h3> <div class=\"product-limit\" ng-if=\"$ctrl.featureLimitation.hasHitProductLimit\"> <div class=\"app__icon\"> <div class=\"icon__background\"></div> <span class=\"icon__badge\">!</span> <md-icon>local_offer</md-icon> </div> <div class=\"app__text\">{{'PRODUCT.LIMITREACHED' | translate}}</div> <div class=\"app__upgrade-desc\">{{'PRODUCT.LIMITREACHEDDESCLINE1' | translate}}</div> <div class=\"app__upgrade-desc\">{{'PRODUCT.LIMITREACHEDDESCLINE2' | translate}}</div> <change-plan-button></change-plan-button> </div> <div ng-if=\"!$ctrl.featureLimitation.hasHitProductLimit\"> <md-toolbar layout=\"row\" layout-align=\"space-between center\" ng-if=\"$ctrl.singleError && !$ctrl.dismissedErrors\" class=\"upload-errors\"> <div class=\"md-toolbar-tools\"> <md-icon class=\"material-icons upload-errors__icon\">report_problem</md-icon> <div> <p>{{\"IMPORTER_MODULE.SINGLE_ERROR\" | translate}}</p> <p class=\"upload-errors__single-error-text\">&#8226; {{$ctrl.singleError}}</p> </div> <md-button aria-label=\"dismiss\" ng-click=\"$ctrl.dismissErrors()\">{{\"IMPORTER_MODULE.ERROR_DISMISS\" | translate}}</md-button> </div> </md-toolbar> <md-toolbar layout=\"row\" layout-align=\"space-between center\" ng-if=\"$ctrl.errorList && !$ctrl.dismissedErrors\" class=\"upload-errors\"> <div class=\"md-toolbar-tools\"> <md-icon class=\"material-icons upload-errors__icon\">report_problem</md-icon> <div> <p>{{\"IMPORTER_MODULE.MULTIPLE_ERRORS\" | translate}}</p> <p class=\"upload-errors__view-error-report\" ng-click=\"$ctrl.viewErrorReport()\">{{'IMPORTER_MODULE.ERROR_VIEW_REPORT' | translate: {'IMPORTER_TYPE': $ctrl.importerType} }}</p> </div> <md-button aria-label=\"dismiss\" ng-click=\"$ctrl.dismissErrors()\">{{\"IMPORTER_MODULE.ERROR_DISMISS\" | translate}}</md-button> </div> </md-toolbar> <div class=\"file-upload\" layout=\"column\" layout-gt-xs=\"row\"> <div class=\"file-upload__instructions\" flex> <p>{{'IMPORTER_MODULE.HELP' | translate: {'IMPORTER_TYPE': $ctrl.importerType} }}</p> <p> <a href=\"{{$ctrl.getCSVSampleUrl()}}\" download=\"sample.csv\" analytics-click-event=\"{{$ctrl.gtmid}}-downloadSample\">{{\"IMPORTER_MODULE.SAMPLE_CSV\" | translate}}</a> </p> <dl> <dt>{{\"PRODUCT.REQUIREMENT1\" | translate}}</dt> <dd>{{\"PRODUCT.REQUIREMENT1VALUE\" | translate}}</dd> <dt>{{\"PRODUCT.REQUIREMENT2\" | translate}}</dt> <dd>{{\"PRODUCT.REQUIREMENT2VALUE\" | translate}}</dd> </dl> </div> <div flex=\"none\" class=\"file-upload__uploader\" ng-class=\"{'file-upload__file-uploaded': $ctrl.isFileReady()}\" ngf-drop ngf-multiple=\"false\" ngf-allow-dir=\"false\" ngf-change=\"$ctrl.uploadFile($files, $invalidFiles); $ctrl.trackDrop();\" ngf-drag-over-class=\"'file-upload__dropzone-active'\" ngf-max-size=\"$ctrl.fileMaxSize\" ngf-accept=\"'.csv'\" ngf-pattern=\"'.csv'\"> <div class=\"upload\" ngf-select ngf-multiple=\"false\" ngf-change=\"$ctrl.uploadFile($files, $invalidFiles);\" ngf-max-size=\"$ctrl.fileMaxSize\" ngf-accept=\"'.csv'\" ngf-pattern=\"'.csv'\" layout=\"column\" layout-align=\"center center\"> <span flex></span> <div ng-class=\"{'file-upload__file-preview': $ctrl.isFileReady()}\"> <div class=\"upload__csv\"> <svg width=\"48px\" height=\"60px\" viewBox=\"0 0 48 60\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <title>CSV_icon</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" fill-opacity=\"{{$ctrl.iconOpacity()}}\"> <g id=\"Products---Import-Dialog---Free-Upload\" transform=\"translate(-742.000000, -434.000000)\" fill=\"#000000\"> <g id=\"Card\" transform=\"translate(290.000000, 187.000000)\"> <g id=\"Rectangle-17-+-android\" transform=\"translate(328.000000, 182.000000)\"> <g id=\"Group-2\" transform=\"translate(8.000000, 8.000000)\"> <g id=\"Group-3\" transform=\"translate(34.000000, 57.000000)\"> <g id=\"drive-file\" transform=\"translate(82.000000, 0.000000)\"> <path d=\"M6,0 C2.7,0 0,2.7 0,6 L0,54 C0,57.3 2.7,60 6,60 L42,60 C45.3,60 48,57.3 48,54 L48,18 L30,0 L6,0 L6,0 Z M27,21 L27,4.5 L43.5,21 L27,21 Z M18.12,42.272 C18.2373339,42.272 18.3386662,42.3173329 18.424,42.408 L19.272,43.328 C18.8026643,43.9093362 18.2253368,44.3546651 17.54,44.664 C16.8546632,44.9733349 16.0320048,45.128 15.072,45.128 C14.213329,45.128 13.4413368,44.9813348 12.756,44.688 C12.0706632,44.3946652 11.4853358,43.9866693 11,43.464 C10.5146642,42.9413307 10.142668,42.317337 9.884,41.592 C9.62533204,40.866663 9.496,40.074671 9.496,39.216 C9.496,38.3466623 9.63999856,37.5506703 9.928,36.828 C10.2160014,36.1053297 10.6213307,35.4826693 11.144,34.96 C11.6666693,34.4373307 12.2919964,34.0306681 13.02,33.74 C13.7480036,33.4493319 14.5519956,33.304 15.432,33.304 C16.290671,33.304 17.0413301,33.441332 17.684,33.716 C18.3266699,33.990668 18.877331,34.3546644 19.336,34.808 L18.616,35.808 C18.5733331,35.8720003 18.518667,35.9279998 18.452,35.976 C18.385333,36.0240002 18.2933339,36.048 18.176,36.048 C18.0533327,36.048 17.9280006,36.0000005 17.8,35.904 C17.6719994,35.8079995 17.5093343,35.7040006 17.312,35.592 C17.1146657,35.4799994 16.8653348,35.3760005 16.564,35.28 C16.2626652,35.1839995 15.8800023,35.136 15.416,35.136 C14.8719973,35.136 14.3720023,35.2306657 13.916,35.42 C13.4599977,35.6093343 13.0680016,35.8799982 12.74,36.232 C12.4119984,36.5840018 12.1560009,37.0119975 11.972,37.516 C11.7879991,38.0200025 11.696,38.5866635 11.696,39.216 C11.696,39.8666699 11.7879991,40.4453308 11.972,40.952 C12.1560009,41.4586692 12.4053318,41.8853316 12.72,42.232 C13.0346682,42.5786684 13.4053312,42.8439991 13.832,43.028 C14.2586688,43.2120009 14.7173309,43.304 15.208,43.304 C15.5013348,43.304 15.7666655,43.2880002 16.004,43.256 C16.2413345,43.2239998 16.459999,43.1733337 16.66,43.104 C16.860001,43.0346663 17.0493324,42.9453339 17.228,42.836 C17.4066676,42.7266661 17.5839991,42.5920008 17.76,42.432 C17.8133336,42.3839998 17.869333,42.3453335 17.928,42.316 C17.986667,42.2866665 18.0506663,42.272 18.12,42.272 Z M27.096,35.536 C27.037333,35.6533339 26.9693337,35.7359998 26.892,35.784 C26.8146663,35.8320002 26.7226672,35.856 26.616,35.856 C26.5093328,35.856 26.389334,35.8146671 26.256,35.732 C26.122666,35.6493329 25.9653342,35.5573338 25.784,35.456 C25.6026658,35.3546662 25.3906679,35.2626671 25.148,35.18 C24.9053321,35.0973329 24.6186683,35.056 24.288,35.056 C23.9893318,35.056 23.7293344,35.0919996 23.508,35.164 C23.2866656,35.2360004 23.1000008,35.3359994 22.948,35.464 C22.7959992,35.5920006 22.682667,35.7453324 22.608,35.924 C22.533333,36.1026676 22.496,36.2986656 22.496,36.512 C22.496,36.7840014 22.5719992,37.0106658 22.724,37.192 C22.8760008,37.3733342 23.0773321,37.5279994 23.328,37.656 C23.5786679,37.7840006 23.8639984,37.8986662 24.184,38 C24.5040016,38.1013338 24.830665,38.2093328 25.164,38.324 C25.497335,38.4386672 25.8239984,38.5719992 26.144,38.724 C26.4640016,38.8760008 26.7493321,39.0679988 27,39.3 C27.2506679,39.5320012 27.4519992,39.8159983 27.604,40.152 C27.7560008,40.4880017 27.832,40.8959976 27.832,41.376 C27.832,41.8986693 27.7426676,42.3879977 27.564,42.844 C27.3853324,43.3000023 27.1240017,43.6973316 26.78,44.036 C26.4359983,44.3746684 26.0160025,44.6413324 25.52,44.836 C25.0239975,45.0306676 24.4560032,45.128 23.816,45.128 C23.4479982,45.128 23.0853351,45.0920004 22.728,45.02 C22.3706649,44.9479996 22.0280016,44.845334 21.7,44.712 C21.3719984,44.578666 21.0653348,44.4186676 20.78,44.232 C20.4946652,44.0453324 20.2400011,43.8373345 20.016,43.608 L20.64,42.576 C20.698667,42.501333 20.7693329,42.4386669 20.852,42.388 C20.9346671,42.3373331 21.0266662,42.312 21.128,42.312 C21.261334,42.312 21.4053326,42.3666661 21.56,42.476 C21.7146674,42.5853339 21.8973323,42.706666 22.108,42.84 C22.3186677,42.973334 22.5666652,43.0946661 22.852,43.204 C23.1373348,43.3133339 23.479998,43.368 23.88,43.368 C24.4933364,43.368 24.9679983,43.2226681 25.304,42.932 C25.6400017,42.6413319 25.808,42.2240027 25.808,41.68 C25.808,41.3759985 25.7320008,41.128001 25.58,40.936 C25.4279992,40.743999 25.2266679,40.5826673 24.976,40.452 C24.7253321,40.3213327 24.4400016,40.2106671 24.12,40.12 C23.7999984,40.0293329 23.4746683,39.9306672 23.144,39.824 C22.8133317,39.7173328 22.4880016,39.5893341 22.168,39.44 C21.8479984,39.2906659 21.5626679,39.0960012 21.312,38.856 C21.0613321,38.6159988 20.8600008,38.3160018 20.708,37.956 C20.5559992,37.5959982 20.48,37.1520026 20.48,36.624 C20.48,36.2026646 20.5639992,35.792002 20.732,35.392 C20.9000008,34.991998 21.1453317,34.6373349 21.468,34.328 C21.7906683,34.0186651 22.1866643,33.7706676 22.656,33.584 C23.1253357,33.3973324 23.6613303,33.304 24.264,33.304 C24.9466701,33.304 25.5759971,33.4106656 26.152,33.624 C26.7280029,33.8373344 27.2186646,34.1359981 27.624,34.52 L27.096,35.536 Z M28.344,33.432 L30.08,33.432 C30.2666676,33.432 30.4186661,33.4773329 30.536,33.568 C30.6533339,33.6586671 30.741333,33.7759993 30.8,33.92 L33.52,40.976 C33.6106671,41.2053345 33.6973329,41.457332 33.78,41.732 C33.8626671,42.006668 33.941333,42.2959985 34.016,42.6 C34.1386673,41.9866636 34.2906658,41.4453357 34.472,40.976 L37.184,33.92 C37.2320002,33.7973327 37.3173327,33.6853338 37.44,33.584 C37.5626673,33.4826662 37.7146658,33.432 37.896,33.432 L39.632,33.432 L34.96,45 L33.016,45 L28.344,33.432 Z\" id=\"CSV_icon\"></path> </g> </g> </g> </g> </g> </g> </g> </svg> </div> <div ng-show=\"$ctrl.isFileReady()\"> <div class=\"file-upload__text\"> {{$ctrl.fileName}} </div> </div> </div> <div class=\"file-upload__text\"> <div ng-show=\"!$ctrl.isFileReady()\"> {{\"IMPORTER_MODULE.DRAG_AND_DROP\" | translate}} </div> </div> <div class=\"file-upload__or\" ng-show=\"!$ctrl.isFileReady()\"> <span class=\"or__line\"></span> <span class=\"or__text\">{{\"PRODUCT.OR\" | translate}}</span> <span class=\"or__line\"></span> </div> <div class=\"file-upload__browse\" ng-show=\"!$ctrl.isFileReady()\" analytics-click-event=\"{{$ctrl.gtmid}}-chooseFile\"> <md-button class=\"md-accent\">{{\"IMPORTER_MODULE.CHOOSE_FILE\" | translate}}</md-button> </div> <div class=\"file-upload__dropzone\"> <i class=\"file-upload__dropzone-icon mi\">cloud_upload</i> <p class=\"file-upload__dropzone-text\">{{\"IMPORTER_MODULE.DROP\" | translate}}</p> </div> <span flex></span> </div> </div> </div> </div> </div> <div ng-if=\"$ctrl.isViewingErrorList\" class=\"import-error-report\"> <div class=\"import-error-report__heading\" layout=\"row\" layout-align=\"space-between center\"> <div layout=\"row\" layout-align=\"start center\"> <md-icon ng-click=\"$ctrl.cancelErrorReport()\" class=\"import-error-report__back\">arrow_back</md-icon> <span>ERROR REPORT</span> </div> <div> <md-icon ng-click=\"$ctrl.cancelImport()\" class=\"import-error-report__close\">close</md-icon> </div> </div> <table class=\"import-error-report__error-table\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\"> <thead> <tr> <td>#</td> <td>ERROR DESCRIPTION</td> </tr> </thead> <tbody> <tr ng-repeat=\"error in $ctrl.errorList track by $index\"> <td class=\"import-error-report__error-table__error-number\">{{$index + 1}}</td> <td>{{error}}</td> </tr> </tbody> </table> </div> </div> </md-dialog-content> <md-dialog-actions class=\"modal__buttons\" layout=\"row\" ng-if=\"!$ctrl.isViewingErrorList\"> <md-button ng-click=\"$ctrl.cancelImport()\" class=\"file-upload__cancel-button\" analytics-click-event=\"{{$ctrl.gtmid}}-cancelImport\">{{\"BUTTON.CANCEL\" | translate}}</md-button> <md-button ng-if=\"!$ctrl.featureLimitation.hasHitProductLimit\" ng-disabled=\"!$ctrl.isFileReady()\" class=\"md-raised md-accent modal--upload__proceed\" ng-click=\"$ctrl.proceedImport($ctrl.csvDataObject, $ctrl.fileName);\" analytics-click-event=\"{{$ctrl.gtmid}}-importProducts\">{{\"IMPORTER_MODULE.IMPORT_TYPES\" | translate: {'IMPORTER_TYPE': $ctrl.importerType} }}</md-button> </md-dialog-actions> </div> ";

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal--delete modal__container\"> <md-dialog-content class=\"modal__content\"> <div class=\"md-dialog-content\"> <h3 class=\"modal__header\">{{'LABEL.DELETE' | translate}}</h3> <p ng-if=\"!$ctrl.isDetail\">{{\"MODAL.DELETE\" | translate: $ctrl.translateData}}</p> <p ng-if=\"$ctrl.isDetail\">{{$ctrl.itemType + \".DELETE\" | translate}}</p> <ul class=\"modal__list\" ng-if=\"$ctrl.warnings.length\"> <li ng-repeat=\"warning in $ctrl.warnings track by $index\"> {{ warning.text | translate: warning.options }} </li> </ul> </div> </md-dialog-content> <md-dialog-actions class=\"modal__buttons\"> <md-button ng-click=\"$ctrl.cancelDelete()\" gtm-click-event=\"{{$ctrl.gtmid}}-cancelDelete\">{{\"BUTTON.CANCEL\" | translate}}</md-button> <md-button class=\"md-accent delete\" ng-click=\"$ctrl.confirmDelete()\" gtm-click-event=\"{{$ctrl.gtmid}}-confirmDelete\">{{'LABEL.DELETE' | translate}}</md-button> </md-dialog-actions> </div> ";

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1536 */,
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _countryData = _interopRequireDefault(__webpack_require__(256));

var _sortBy = _interopRequireDefault(__webpack_require__(195));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var countrySort = function countrySort(countries, primaryCountry) {
  return prioritizeCountriesList(createCountryCodeList(sortCountriesByName(addCountryNames(countries))), primaryCountry);
};

var addCountryNames = function addCountryNames(countries) {
  return countries.map(function (country) {
    return _objectSpread({}, country, {
      name: _countryData.default.countries[country.country].name
    });
  });
};

var createCountryCodeList = function createCountryCodeList(countries) {
  return countries.map(function (country) {
    return country.country;
  });
};

var sortCountriesByName = function sortCountriesByName(countries) {
  return (0, _sortBy.default)(countries, function (country) {
    return country.name;
  });
};

var prioritizeCountriesList = function prioritizeCountriesList(countries, primaryCountry) {
  if (countries.find(function (item) {
    return item === primaryCountry;
  })) return sortByPrimaryCountry(countries, primaryCountry);
  return countries;
};

var sortByPrimaryCountry = function sortByPrimaryCountry(list, primary) {
  return list.filter(function (item) {
    return item === primary;
  }).concat(list.filter(function (item) {
    return item !== primary;
  }));
};

var _default = countrySort;
exports.default = _default;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _styledComponents = _interopRequireDefault(__webpack_require__(21));

var _propTypes = __webpack_require__(4);

var _FormControl = _interopRequireDefault(__webpack_require__(391));

var _NativeSelect = _interopRequireDefault(__webpack_require__(731));

var _Input = _interopRequireDefault(__webpack_require__(199));

var _InputLabel = _interopRequireDefault(__webpack_require__(410));

var _FormHelperText = _interopRequireDefault(__webpack_require__(411));

var _Icon = _interopRequireDefault(__webpack_require__(661));

var _thread = __webpack_require__(64);

var _styles = __webpack_require__(379);

var _muiTheme = _interopRequireDefault(__webpack_require__(635));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formColors = {
  text: {
    main: _muiTheme.default.palette.primary.light,
    placeholder: 'rgba(0,0,0,0.38)'
  },
  borders: {
    main: 'rgba(0, 0, 0, 0.12)'
  }
};

var styles = function styles() {
  return {
    formControl: {
      'label + &': {
        marginTop: '0'
      },
      '&:before, &:after': {
        zIndex: '2'
      },
      '&:before': {
        borderColor: formColors.borders.main
      },
      '&:hover:before': {
        borderColor: "".concat(formColors.borders.main, " !important"),
        borderWidth: '0 0 1px 0 !important'
      }
    },
    select: {
      paddingBottom: '5px',
      '&:focus': {
        background: '#fff'
      }
    },
    // FormHelperText root
    root: {
      marginTop: '0',
      paddingBottom: '0'
    }
  };
};

var ErrorText = _styledComponents.default.span.withConfig({
  displayName: "NativeSelect__ErrorText",
  componentId: "sc-51qyyj-0"
})(["padding-left:4px"]);

var MuiNativeSelect = function MuiNativeSelect(props) {
  var autoComplete = props.autoComplete,
      classes = props.classes,
      error = props.error,
      handleSelectBlur = props.handleSelectBlur,
      handleSelectChange = props.handleSelectChange,
      id = props.id,
      label = props.label,
      options = props.options,
      placeholder = props.placeholder,
      type = props.type,
      value = props.value;
  var fieldName = placeholder.toLowerCase().replace(' ', '-');
  var hasErrors = Object.values(error).find(function (res) {
    return res;
  });
  return _react.default.createElement(_styles.MuiThemeProvider, {
    theme: _muiTheme.default
  }, _react.default.createElement(_thread.ThemeProvider, {
    theme: _thread.defaultTheme
  }, _react.default.createElement(_FormControl.default, {
    className: "".concat(id, "__").concat(fieldName, "-select"),
    error: hasErrors,
    style: {
      width: '100%',
      minHeight: '58px'
    }
  }, label && _react.default.createElement(_InputLabel.default, {
    className: "".concat(id, "__label ").concat(id, "__label--md-override"),
    htmlFor: "".concat(id, "-").concat(fieldName),
    id: "".concat(id, "-label"),
    shrink: true,
    style: {
      opacity: value ? '1' : '0',
      paddingLeft: '0',
      top: '-19px'
    }
  }, label), _react.default.createElement(_NativeSelect.default, {
    classes: {
      select: classes.select
    },
    input: _react.default.createElement(_Input.default, {
      classes: {
        formControl: classes.formControl
      },
      id: "".concat(id, "-").concat(fieldName),
      name: fieldName,
      autoComplete: "".concat(id, "-").concat(fieldName, " ").concat(autoComplete),
      onBlur: function onBlur() {
        return handleSelectBlur(type);
      }
    }),
    onChange: handleSelectChange(type),
    style: {
      color: value ? formColors.text.main : formColors.text.placeholder
    },
    value: value || ''
  }, _react.default.createElement("option", {
    value: "",
    disabled: true
  }, placeholder), options && Object.keys(options).map(function (key) {
    return _react.default.createElement("option", {
      key: key,
      value: key
    }, options[key]);
  })), hasErrors && _react.default.createElement(_FormHelperText.default, {
    classes: {
      root: classes.root
    }
  }, _react.default.createElement(_Icon.default, {
    style: {
      fontSize: '16px',
      verticalAlign: 'middle'
    }
  }, "warning"), _react.default.createElement(ErrorText, null, error.required && "".concat(placeholder, " is required"))))));
};

MuiNativeSelect.defaultProps = {
  error: {}
};
MuiNativeSelect.propTypes = {
  autoComplete: _propTypes.string,
  classes: _propTypes.object,
  error: _propTypes.object,
  handleSelectBlur: _propTypes.func,
  handleSelectChange: _propTypes.func,
  id: _propTypes.string,
  label: _propTypes.string,
  options: _propTypes.object,
  placeholder: _propTypes.string,
  type: _propTypes.string,
  value: _propTypes.string
};

var _default = (0, _styles.withStyles)(styles)(MuiNativeSelect);

exports.default = _default;

/***/ }),
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */
/***/ (function(module, exports) {

module.exports = "<div class=\"next-step-notice-wrap\" ng-style=\"{backgroundColor:$ctrl.backgroundColor}\" ng-class=\"{\n        'next-step-notice-wrap--full-width': $ctrl.fullWidth,\n        'next-step-notice-wrap--animate-in': $ctrl.animateIn,\n        'next-step-notice-wrap--founderguide-notice': $ctrl.isFounderGuideNextStep,\n        'next-step-notice-wrap--editstore-landing': $ctrl.founderGuideStep === 'editstore.landing'\n    }\"> <div class=\"next-step-notice-wrap__animation-container\"> <md-card class=\"next-step-notice\" ng-style=\"$ctrl.cardStyle\"> <md-card-content layout=\"row\" layout-align=\"start start\" layout-align-gt-xs=\"start center\"> <div class=\"next-step-notice__icon\" layout=\"row\" layout-align=\"center center\" ng-style=\"$ctrl.iconStyle\"> <md-icon ng-if=\"!$ctrl.isFounderGuideNextStep\" layout=\"row\" layout-align=\"center center\">check</md-icon> <img ng-if=\"$ctrl.isFounderGuideNextStep\" width=\"40\" height=\"40\" src=\"/assets/founder-guide-logo.svg\" alt=\"founder guide logo\"> </div> <div class=\"next-step-notice__content-wrap\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center start\" layout-align-gt-xs=\"space-between center\" flex> <div class=\"next-step-notice__content\" layout=\"column\" layout-align=\"center start\"> <h3 ng-style=\"$ctrl.hstyle\">{{$ctrl.noticeTitle | translate:$ctrl.titleData}}</h3> <p class=\"next-step-notice__content-subtitle\">{{$ctrl.subtitle | translate}}</p> </div> <div class=\"next-step-notice__actions\" layout=\"column\" layout-align=\"center start\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center center\" ng-if=\"$ctrl.link || $ctrl.url\"> <md-button ng-if=\"$ctrl.secondaryCtaLabel\" ng-click=\"$ctrl.goTo($ctrl.secondaryLink)\" ng-href=\"{{$ctrl.secondaryUrl}}\" target=\"_blank\"> {{$ctrl.secondaryCtaLabel | translate}} </md-button> <md-button class=\"md-primary\" ng-click=\"$ctrl.goTo($ctrl.link)\" ng-href=\"{{$ctrl.url}}\" target=\"_blank\"> {{$ctrl.ctaLabel | translate}} </md-button> </div> </div> </md-card-content> </md-card> <div class=\"next-step-initial-message\" ng-if=\"$ctrl.showInitialMessage\" ng-style=\"$ctrl.messageStyle\" layout=\"row\" layout-align=\"start center\" ng-click=\"$ctrl.goTo($ctrl.initialMessageLink)\"> <div layout=\"column\" layout-gt-xs=\"row\" flex> <span class=\"next-step-initial-message__label\">{{'NEXTSTEPS.LABEL_NEXT_STEP' | translate }}</span> <span class=\"next-step-initial-message__action\">{{$ctrl.initialMessage | translate}}</span> </div> <div> <md-icon>keyboard_arrow_right</md-icon> </div> </div> </div> </div>";

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  steps: {
    product: {
      noticeTitle: 'Founder Guide Step Complete',
      subtitle: 'Way to go! You’ve added your first product.',
      ctaLabel: 'View Founder Guide',
      link: 'dashboard',
      secondaryCtaLabel: 'Add Another',
      secondaryLink: 'product.add'
    },
    page: {
      noticeTitle: 'Founder Guide Step Complete!',
      subtitle: 'Nice job! You’ve successfully generated pages.',
      ctaLabel: 'View Founder Guide',
      link: 'dashboard',
      secondaryCtaLabel: 'Add Another',
      secondaryLink: 'pages.add'
    },
    'editstore.landing': {
      noticeTitle: 'Founder Guide Assistant',
      subtitle: 'Customize any part of your store below to complete the next step.'
    },
    'editstore.edit': {
      noticeTitle: 'Founder Guide Step Complete!',
      subtitle: 'Nice job! You’ve personalized your storefront.',
      ctaLabel: 'View Founder Guide',
      link: 'dashboard'
    }
  },
  nextsteps: {
    product: {
      initialMessage: 'Add your products',
      initialMessageLink: 'product.add'
    },
    personalize: {
      initialMessage: 'Personalize your storefront',
      initialMessageLink: 'editstore.landing'
    },
    page: {
      initialMessage: 'Automatically generate pages',
      initialMessageLink: 'pages.list'
    },
    finalstep: {
      initialMessage: 'Let’s get you selling!',
      initialMessageLink: 'dashboard'
    }
  }
};
exports.default = _default;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressUtilitiesServiceModule = void 0;
var AddressUtilitiesServiceModule = angular.module('app.services.utilities.addressUtilities', []).factory('addressUtilities', function () {
  return {
    convertStripeAddress: function convertStripeAddress(stripeAddress) {
      return {
        city: stripeAddress.city,
        postalCode: stripeAddress.zip,
        state: stripeAddress.state,
        selectedState: {
          code: stripeAddress.state
        },
        address1: "".concat(stripeAddress.line1, " ").concat(stripeAddress.line2 || '')
      };
    }
  };
}).name;
exports.AddressUtilitiesServiceModule = AddressUtilitiesServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdatePaymentButtonComponent = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _launchUpdatePaymentModal = __webpack_require__(734);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UpdatePaymentButtonComponent = angular.module('app.components.updatePayment.updatePaymentButton', [_launchUpdatePaymentModal.LaunchUpdatePaymentModalService]).component('updatePaymentButton', {
  template: "\n            <md-button\n                ng-click=\"$ctrl.launchModal($event)\"\n                class=\"{{$ctrl.buttonClass}}\"\n                aria-label=\"{{'UPDATEPAYMENT.LAUNCH_MODAL_BUTTON' | translate}}\">\n                <span ng-if=\"$ctrl.editMode === 'update'\">\n                    {{'UPDATEPAYMENT.LAUNCH_MODAL_BUTTON' | translate}}\n                </span>\n                <span ng-if=\"$ctrl.editMode === 'new'\">\n                    <md-icon>add</md-icon> {{'UPDATEPAYMENT.LAUNCH_MODAL_BUTTON_ADD' | translate}}\n                </span>\n            </md-button>\n        ",
  bindings: {
    buttonClass: '@',
    editMode: '@',
    prefillData: '<',
    onPaymentMethodChanged: '&'
  },
  controller:
  /*#__PURE__*/
  function () {
    UpdatePaymentButtonController.$inject = ["$scope", "launchUpdatePaymentService"];

    function UpdatePaymentButtonController($scope, launchUpdatePaymentService) {
      'ngInject';

      _classCallCheck(this, UpdatePaymentButtonController);

      (0, _assign.default)(this, {
        $scope: $scope,
        launchUpdatePaymentService: launchUpdatePaymentService
      });
    }

    _createClass(UpdatePaymentButtonController, [{
      key: "$onInit",
      value: function $onInit() {}
    }, {
      key: "launchModal",
      value: function launchModal(ev) {
        var _this = this;

        this.launchUpdatePaymentService.launchModal(this.editMode, this.prefillData, ev).then(function (cardInfo) {
          _this.onPaymentMethodChanged({
            cardInfo: cardInfo
          });
        });
      }
    }]);

    return UpdatePaymentButtonController;
  }()
}).name;
exports.UpdatePaymentButtonComponent = UpdatePaymentButtonComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdatePaymentModalController = void 0;

var _creditCardEditor = __webpack_require__(424);

var _creditCardUtilities = __webpack_require__(86);

var _addressEditor = __webpack_require__(735);

var _updatePayment = __webpack_require__(736);

var UpdatePaymentModalController = angular.module('app.components.updatePaymentModal.updatePaymentModalController', ['ngMaterial', _creditCardEditor.CreditCardEditorModule, _creditCardUtilities.CreditCardUtilitiesServiceModule, _addressEditor.AddressEditorModule, _updatePayment.UpdatePaymentServiceModule]).controller('UpdatePaymentModalController', ["$scope", "$mdDialog", "creditCardUtilities", "updatePaymentService", "editMode", "prefillData", function ($scope, $mdDialog, creditCardUtilities, updatePaymentService, editMode, prefillData) {
  var vm = {
    changePaymentMethod: changePaymentMethod,
    cancel: cancel,
    card: creditCardUtilities.newCard(),
    billingAddress: {},
    loading: false,
    errorTextVisible: false,
    editMode: editMode,
    errorText: 'There was an issue updating your payment info.'
  };
  init();

  function init() {
    $scope.vm = vm;
    if (angular.isDefined(prefillData) && prefillData !== null) setPrefillData(prefillData);
  }

  function setPrefillData(data) {
    vm.billingAddress = data.address;
    vm.card = {
      cardNumber: data.maskedCardNumber,
      expiration: data.expirationString
    };
  }

  function changePaymentMethod() {
    vm.loading = true;
    vm.errorTextVisible = false;
    updatePaymentService.changePaymentMethod(vm.card, vm.billingAddress).then(function () {
      $mdDialog.hide(convertForm(vm.card, vm.billingAddress));
    }, function (err) {
      vm.loading = false;
      if (err.message) vm.errorText = err.message;
      vm.errorTextVisible = true;
    });
  }

  function convertForm(card, billingAddress) {
    return {
      lastFour: creditCardUtilities.getLastFour(card.cardNumber),
      maskedCardNumber: creditCardUtilities.getMaskedCardNumber(card.cardNumber),
      brand: card.cardTypeName,
      expiration: creditCardUtilities.parseExpiration(card.expiration),
      expirationString: card.expiration,
      address: billingAddress
    };
  }

  function cancel() {
    $mdDialog.cancel();
  }
}]).name;
exports.UpdatePaymentModalController = UpdatePaymentModalController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressEditorDropdownModule = void 0;
var AddressEditorDropdownModule = angular.module('app.components.addressEditor.addressEditorDropdown', []).directive('addressEditorDropdown', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      availableoptions: '=',
      optionselect: '=',
      selectedOption: '=ngModel',
      placeholder: '@',
      displayField: '@',
      selectedField: '@',
      name: '@',
      ngRequired: '=',
      errorKey: '@'
    },
    template: "\n                <md-input-container flex=\"50\" md-no-float>\n                    <select\n                        name=\"{{name}}\"\n                        ng-model=\"selectedOption\"\n                        ng-change=\"changeOptionSelect(selectedOption)\"\n                        tabindex=\"-1\"\n                        class=\"md-visually-hidden\"\n                        ng-options=\"option.selectedDisplayValue for option in options\">\n                    </select>\n                    <md-select\n                        placeholder=\"State\"\n                        ng-required=\"true\"\n                        md-no-asterisk\n                        ng-model=\"selectedOption.code\"\n                        ng-change=\"changeOptionSelect(selectedOption)\">\n                        <md-option\n                            data-ng-repeat=\"option in options\"\n                            value=\"{{option.code}}\">\n                        {{option.displayValue}}\n                        </md-option>\n                    </md-select>\n                    <div class=\"md-errors-spacer\"></div>\n                </md-input-container>\n            ",
    link: function postlink(scope, element) {
      scope.button = angular.element(element).find('button');
      scope.options = scope.availableoptions || [];

      scope.changeOption = function (index) {
        if (index) {
          //select the option on the hidden select dropdown
          scope.selectedOption = scope.options[index]; //run the callback function

          if (typeof scope.optionselect === 'function') {
            scope.optionselect(scope.selectedOption);
          } //focus on the select element... the placeholder directive demands it.


          scope.button.focus();
        }
      };

      scope.changeOptionSelect = function (selectedOption) {
        //select the option on the hidden select dropdown
        //run the callback function
        if (typeof scope.optionselect === 'function') {
          scope.optionselect(selectedOption);
        } //focus on the select element... the placeholder directive demands it.


        scope.button.focus();
      };

      scope.$watch('availableoptions', function () {
        //Only change things up if we have the ability. If there's no options to show
        //it means we shouldnt have focus. Preserve the data and dom when
        //options are blank.
        if (typeof scope.availableoptions !== 'undefined' && scope.availableoptions.length > 0) {
          scope.options = scope.availableoptions.slice();
          angular.forEach(scope.options, function (option) {
            option.displayValue = option[scope.displayField || 'name'];
            option.selectedDisplayValue = option[scope.selectedField || 'name'];
          });
        }
      });
      scope.$watch('selectedOption', function (newValue) {
        if (newValue) {
          scope.button.focus();
        } else {
          scope.button.blur();
        }
      });
    }
  };
}).name;
exports.AddressEditorDropdownModule = AddressEditorDropdownModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

module.exports = "<form id=\"addressForm\" name=\"addressForm\" novalidate data-ng-submit=\"updateAddress(address)\" class=\"m-address-editor\"> <md-input-container class=\"md-block m-address-editor__control m-address-editor__control--address1\" md-no-float> <input name=\"address1\" ng-model=\"address.address1\" placeholder=\"Billing Address\" required md-no-asterisk> <div ng-messages=\"addressForm.address1.$error\" role=\"alert\"> <div ng-message=\"required\">Address is required.</div> </div> </md-input-container> <div layout=\"row\" layout-xs=\"column\"> <md-input-container flex=\"33\" flex-xs=\"100\" class=\"m-address-editor__control m-address-editor__control--city\" md-no-float> <input name=\"city\" ng-model=\"address.city\" placeholder=\"City\" required md-no-asterisk pattern=\"^[\\w ]+$\"> <div ng-messages=\"addressForm.city.$error\" role=\"alert\"> <div ng-message=\"required\">City is required.</div> <div ng-message=\"pattern\">City must not contain special characters.</div> </div> </md-input-container> <div flex=\"66\" flex-xs=\"100\"> <div layout=\"row\"> <address-editor-dropdown name=\"inputUSState\" class=\"m-address-editor__control m-address-editor__control--state\" availableoptions=\"states\" placeholder=\"State\" optionselect=\"onStateChanged\" ng-model=\"address.selectedState\" selected-field=\"code\" data-required-field data-error-key=\"stateEmpty\"> </address-editor-dropdown> <md-input-container flex=\"50\" class=\"m-address-editor__control m-address-editor__control--postal-code\" md-no-float> <input name=\"postalCode\" ng-model=\"address.postalCode\" placeholder=\"ZIP\" ng-pattern=\"/^(\\d{5}-\\d{4}|\\d{5})$/\" required md-no-asterisk maxlength=\"10\"> <div ng-messages=\"addressForm.postalCode.$error\" role=\"alert\"> <div ng-message=\"required\">ZIP Code is required.</div> <div ng-message=\"pattern\">ZIP Code must be in the proper format.</div> <div ng-message=\"maxlength\">ZIP Code must be in the proper format.</div> </div> </md-input-container> </div> </div> </div> </form> ";

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

module.exports = "<md-dialog aria-label=\"Change Payment Method\" class=\"update-payment-modal\"> <md-dialog-content class=\"md-dialog-content update-payment-modal__content\" ng-if=\"!vm.loading\"> <h3 class=\"modal__header\"> <span ng-if=\"vm.editMode === 'update'\">{{'UPDATEPAYMENT.MODAL_TITLE' | translate}}</span> <span ng-if=\"vm.editMode === 'new'\">{{'UPDATEPAYMENT.MODAL_TITLE_NEW' | translate}}</span> </h3> <md-icon class=\"update-payment-modal__lock\">lock</md-icon> <p class=\"update-payment-modal__description\">{{'UPDATEPAYMENT.DESCRIPTION_NOTE' | translate}}</p> <p ng-if=\"vm.errorTextVisible\" class=\"update-payment-modal__error\"> <span>{{vm.errorText}}</span> <md-icon ng-click=\"vm.errorTextVisible = false\">close</md-icon> </p> <credit-card-editor data-card=\"vm.card\" form-controller=\"vm.creditCardFormController\"> </credit-card-editor> <address-editor address=\"vm.billingAddress\" form-controller=\"vm.addressFormController\"> </address-editor> </md-dialog-content> <md-dialog-actions class=\"update-payment-modal__actions\" ng-if=\"!vm.loading\"> <md-button ng-click=\"vm.cancel()\" ng-disabled=\"vm.loading\">{{'UPDATEPAYMENT.MODAL_CANCEL' | translate}}</md-button> <md-button ng-click=\"vm.changePaymentMethod()\" class=\"md-accent md-raised\" ng-disabled=\"!vm.creditCardFormController.$valid || !vm.addressFormController.$valid || vm.loading\"> {{'UPDATEPAYMENT.MODAL_SAVE' | translate}} </md-button> </md-dialog-actions> <md-progress-circular class=\"md-accent\" md-diameter=\"50\" md-mode=\"indeterminate\" ng-if=\"vm.loading\"> </md-progress-circular> </md-dialog> ";

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

module.exports = "<md-card class=\"update-payment-card\"> <md-card-title> <md-card-title-text> <span class=\"md-headline\">{{$ctrl.titleText}}</span> </md-card-title-text> </md-card-title> <md-card-content ng-if=\"!$ctrl.loading\"> <div layout=\"column\" layout-gt-xs=\"row\"> <card-info ng-if=\"$ctrl.hasPaymentMethod\" brand=\"$ctrl.paymentMethod.brand\" last-four=\"$ctrl.paymentMethod.lastFour\" expiration=\"$ctrl.paymentMethod.expiration\"></card-info> <span flex ng-if=\"$ctrl.hasPaymentMethod\"></span> <update-payment-button on-payment-method-changed=\"$ctrl.paymentMethodChanged(cardInfo)\" edit-mode=\"{{$ctrl.hasPaymentMethod ? 'update': 'new'}}\" prefill-data=\"$ctrl.hasPaymentMethod ? $ctrl.paymentMethod : null\" button-class=\"md-accent\"> </update-payment-button> </div> </md-card-content> <md-progress-circular md-diameter=\"30\" md-mode=\"indeterminate\" ng-if=\"$ctrl.loading\" class=\"md-accent update-payment-card__loading\"></md-progress-circular> </md-card> ";

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedactorDirectiveModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _imageLibrary = __webpack_require__(372);

var _nativePlatform = __webpack_require__(125);

var _menuEditor = __webpack_require__(1572);

var _redactor = _interopRequireDefault(__webpack_require__(1589));

__webpack_require__(1590);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RedactorDirectiveModule = angular.module('app.components.redactor.redactorDirective', ['ngMaterial', _angularjs.default, _imageLibrary.ImageLibraryModule, _menuEditor.MenuEditorService, _nativePlatform.NativePlatformServiceModule]).directive('redactor', ["$timeout", "$mdDialog", "imageLibraryService", "menuEditorService", "nativePlatformService", "$state", "$window", function ($timeout, $mdDialog, imageLibraryService, menuEditorService, nativePlatformService, $state, $window) {
  return {
    require: 'ngModel',
    restrict: 'E',
    template: _redactor.default,
    replace: true,
    scope: {},
    link: function link(scope, elem, attrs, ngModel) {
      var $editor = angular.element('.redactor__scope');
      var el;
      var showExpand = !!attrs.expand;
      scope.count = 0;
      scope.MAX = parseInt(attrs.maxlength);
      scope.updateModel = updateModel;
      var plugins = ['source', 'addlink', 'addimage', 'addvideo', 'expand', 'charactercounter', 'bufferbuttons'];

      if (!showExpand) {
        plugins = plugins.filter(function (plugin) {
          return plugin !== 'expand';
        });
      }

      $timeout(function () {
        el = angular.element(elem).find('textarea');

        if (!nativePlatformService.isIOS) {
          el.redactor({
            minHeight: 320,
            maxHeight: 320,
            buttons: ['source', 'format', 'style', 'bold', 'italic', 'lists'],
            plugins: plugins,
            cleanOnPaste: true,
            pastePlainText: true,
            toolbarFixed: false,
            // eslint-disable-next-line object-shorthand
            callbacks: {
              change: function change() {
                if (!scope.initialLoad) {
                  updateModel(this.code.get());
                }

                scope.initialLoad = false;
              }
            },
            deniedTags: ['script', 'code', 'embed'] //,
            // paragraphize: true

          });
        } else {
          scope.fallbackTextValue = ngModel.$modelValue;
        }
      });

      function updateModel(val) {
        var $counterButton = angular.element('.redactor-toolbar-count');

        var updateModelValue = function updateModelValue(_val) {
          scope.count = _val.length;

          if (scope.count >= scope.MAX + 1) {
            ngModel.$$parentForm.$setValidity('maxlength', false);
            $editor.addClass('border-error');
            $counterButton.addClass('redactor-toolbar-count--error');
          } else {
            ngModel.$$parentForm.$setValidity('maxlength', true);
            $editor.removeClass('border-error');
            $counterButton.removeClass('redactor-toolbar-count--error');
          }

          ngModel.$setViewValue(_val);
          ngModel.$render();
        };

        if (val) {
          updateModelValue(val);
        } else if (scope.fallbackTextValue !== undefined) {
          updateModelValue(scope.fallbackTextValue);
        } else {
          scope.count = 0;
          ngModel.$setViewValue('<p>&nbsp;</p>');
          ngModel.$render();
        }

        $counterButton.find('.redactor-toolbar-count__count').text(scope.count);
      }

      ngModel.$formatters.push(function (value) {
        value = value == null ? '' : value;
        scope.count = value.length;
        $timeout(function () {
          if (value) {
            scope.initialLoad = true;
          }

          el.redactor('code.set', value);
        });
      });

      if (!$window.RedactorPlugins) {
        $window.RedactorPlugins = {};
      }

      $window.RedactorPlugins.addimage = function () {
        return {
          // eslint-disable-next-line object-shorthand
          init: function init() {
            var imageButton = this.button.add('image', 'Image');
            this.button.setIcon(imageButton, '<i class="material-icons md-18">image</i>');
            this.button.addCallback(imageButton, this.addimage.show);
          },
          show: function show() {
            var _this = this;

            this.selection.save();
            var state = $state.current.name.split('.')[0];
            imageLibraryService.open({
              multiSelect: false,
              context: state,
              associationTags: [state]
            }).then(function (data) {
              $timeout(function () {
                var val = "<span><img src=\"".concat(data.fullUri, "\"></span>");

                _this.selection.restore();

                el.redactor('insert.raw', val);
              });
            });
          }
        };
      };

      $window.RedactorPlugins.addvideo = function () {
        return {
          // eslint-disable-next-line object-shorthand
          init: function init() {
            var videoButton = this.button.add('video', 'Video');
            this.button.setIcon(videoButton, '<i class="material-icons md-18">videocam</i>');
            this.button.addCallback(videoButton, this.addvideo.show);
          },
          show: function show() {
            var _this2 = this;

            this.selection.save();
            $mdDialog.show({
              clickOutsideToClose: true,
              template: '<redactor-embed-video-modal></redactor-embed-video-modal>'
            }).then(function (data) {
              $timeout(function () {
                var utubeId;
                var splitChar = /youtube\.com/.test(data.youtube) ? 'v=' : 'e/';
                utubeId = data.youtube.substr(data.youtube.indexOf(splitChar) + 2);
                var width = data.fullWidth ? '100%' : "".concat(data.width, "px");
                var height = "".concat(data.height, "px");
                var iframeHtml = "<iframe\n                                    src=\"https://www.youtube.com/embed/".concat(utubeId, "\"\n                                    style=\"max-width: 100%;\"\n                                    id=\"vln-pages-video\"\n                                    width=\"").concat(width, "\"\n                                    height=\"").concat(height, "\"\n                                    frameborder=\"0\" allowfullscreen></iframe>");

                _this2.selection.restore();

                el.redactor('insert.raw', iframeHtml);
              });
            });
          }
        };
      };

      $window.RedactorPlugins.addlink = function () {
        return {
          // eslint-disable-next-line object-shorthand
          init: function init() {
            var linkButton = this.button.add('link', 'Link');
            this.button.setIcon(linkButton, '<i class="material-icons md-18">insert_link</i>');
            this.button.addCallback(linkButton, this.addlink.show);
          },
          show: function show() {
            var _this3 = this;

            this.selection.save();
            return menuEditorService.openAddToMenuDialog(undefined, 'body').then(function (data) {
              $timeout(function () {
                var url = '';

                if (data.itemType === 'link') {
                  url = data.newItem.url || '';
                } else if (data.itemType === 'category') {
                  url = "/c/".concat(data.newItem.seo.friendlyName);
                } else if (data.itemType === 'product') {
                  url = "/p/".concat(data.newItem.seo.friendlyName);
                } else if (data.itemType === 'page') {
                  url = "/page/".concat(data.newItem.seo.friendlyName);
                }

                _this3.selection.restore();

                el.redactor('insert.raw', "<a href=\"".concat(url, "\">").concat(data.newItem.name || url, "</a>"));
              });
            });
          }
        };
      };

      $window.RedactorPlugins.bufferbuttons = function () {
        return {
          // eslint-disable-next-line object-shorthand
          init: function init() {
            var undo = this.button.add('undo', 'Undo');
            this.button.setIcon(undo, '<i class="material-icons md-18">undo</i>');
            var redo = this.button.addAfter('undo', 'redo', 'Redo');
            this.button.setIcon(redo, '<i class="material-icons md-18">redo</i>');
            this.button.addCallback(undo, this.buffer.undo);
            this.button.addCallback(redo, this.buffer.redo);
          }
        };
      };

      $window.RedactorPlugins.charactercounter = function () {
        return {
          init: function init() {
            var counterDisplay = this.button.add('counter', 'Character Counter');
            this.button.setIcon(counterDisplay, "<span class=\"redactor-toolbar-count\">\n                                    <span class=\"redactor-toolbar-count__count\">".concat(scope.count, "</span>\n                                    / ").concat(scope.MAX, "\n                                </span>"));
            this.button.addCallback(counterDisplay, this.charactercounter.noop);
          },
          noop: function noop() {}
        };
      };

      $window.RedactorPlugins.expand = function () {
        return {
          init: function init() {
            var expand = this.button.add('expand', 'Expand');
            this.button.setIcon(expand, '<i class="material-icons md-18">zoom_out_map</i>');
            this.button.addCallback(expand, this.expand.toggle);
          },
          toggle: function toggle() {
            angular.element('.page__content').toggleClass('page__content--expanded');
          }
        };
      };
    }
  };
}]).name;
exports.RedactorDirectiveModule = RedactorDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuEditorService = void 0;

var _addLink = __webpack_require__(617);

var _addToMenu = __webpack_require__(1576);

var MenuEditorService = angular.module('app.pages.editstore.menuEditor.menuEditorService', ['ngMaterial', _addLink.AddLink, _addToMenu.AddToMenu]).service('menuEditorService', ["$mdDialog", function ($mdDialog) {
  function openAddToMenuDialog(blacklistTypes, parent) {
    return $mdDialog.show({
      parent: angular.element(parent),
      clickOutsideToClose: true,
      controller: ['$scope', '$mdDialog', function DialogController(_$scope, _$mdDialog) {
        _$scope.hide = function (itemToAdd) {
          _$mdDialog.hide(itemToAdd);
        };

        _$scope.cancel = function () {
          _$mdDialog.cancel();
        };
      }],
      autoWrap: false,
      template: "\n                    <md-dialog class=\"menu-editor-dialog\">\n                        <menu-editor-add-to-menu\n                            ".concat(blacklistTypes ? "blacklist-types=\"".concat(blacklistTypes, "\"") : '', "\n                            on-item-selected=\"hide\">\n                        </menu-editor-add-to-menu>\n                    </md-dialog>\n                ")
    }).then(function (newItem) {
      return newItem;
    });
  }

  function openEditLinkDialog(prefillData, parent) {
    return $mdDialog.show({
      parent: angular.element(parent),
      clickOutsideToClose: true,
      locals: {
        prefillData: prefillData
      },
      controller: ['$scope', '$mdDialog', 'prefillData', function EditLinkDialogController(_$scope, _$mdDialog, _prefillData) {
        _$scope.prefillData = _prefillData;

        _$scope.hide = function (editedItem) {
          _$mdDialog.hide(editedItem);
        };

        _$scope.cancel = function () {
          _$mdDialog.cancel();
        };
      }],
      template: "\n                    <menu-editor-add-link\n                        prefill-link-data=\"prefillData\"\n                        on-cancel-click=\"cancel()\"\n                        on-link-saved=\"hide(item)\">\n                    </menu-editor-add-link>\n                "
    }).then(function (editedItem) {
      return editedItem;
    });
  }

  return {
    openAddToMenuDialog: openAddToMenuDialog,
    openEditLinkDialog: openEditLinkDialog
  };
}]).name;
exports.MenuEditorService = MenuEditorService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpPrefixerService = void 0;
var HttpPrefixerService = angular.module('app.components.httpPrefix.httpPrefixerService', []).factory('httpPrefixer', function () {
  return {
    prefixUrl: function prefixUrl(urlToPrefix, forceHtps) {
      // Need to add prefix if we don't have http:// prefix already AND we don't have part of it
      var httpPrefixRegex = /^(https?):\/\//i;

      if (urlToPrefix && !httpPrefixRegex.test(urlToPrefix) && 'http://'.indexOf(urlToPrefix) !== 0 && 'https://'.indexOf(urlToPrefix) !== 0) {
        return forceHtps ? "https://".concat(urlToPrefix) : "http://".concat(urlToPrefix);
      }

      return urlToPrefix;
    }
  };
}).name;
exports.HttpPrefixerService = HttpPrefixerService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"md-dialog-content\"> <ng-form name=\"addLinkForm\"> <md-input-container class=\"no-errors md-accent md-block\"> <label>{{'EDITSTORECONTENT.NEWITEMLABEL' | translate}}</label> <input ng-model=\"$ctrl.linkData.name\" required md-no-asterisk> </md-input-container> <md-input-container class=\"no-errors no-bottom-margin md-accent md-block\"> <label>{{'EDITSTORECONTENT.LINKURL' | translate}}</label> <input ng-model=\"$ctrl.linkData.url\" vln-http-prefix force-https=\"true\" required md-no-asterisk> </md-input-container> </ng-form> </md-dialog-content> <md-dialog-actions layout=\"row\" layout-align=\"end center\"> <md-button ng-click=\"$ctrl.onCancelClick()\">{{'BUTTON.CANCEL' | translate}}</md-button> <md-button class=\"md-accent\" ng-click=\"$ctrl.onLinkSaved({item: $ctrl.linkData})\" ng-disabled=\"addLinkForm.$invalid\">{{'BUTTON.SAVE' | translate}}</md-button> </md-dialog-actions>";

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToMenu = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _addLink = __webpack_require__(617);

var _addUrl = __webpack_require__(1577);

var _selectItem = __webpack_require__(1580);

var _selectItemType = __webpack_require__(1584);

var _addItem = __webpack_require__(1585);

__webpack_require__(1588);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AddToMenu = angular.module('app.pages.editstore.menuEditor.addToMenu', [_addLink.AddLink, _addUrl.AddUrl, _selectItem.SelectItem, _selectItemType.SelectItemType, _addItem.AddItem]).component('menuEditorAddToMenu', {
  template: "\n\n            <menu-editor-select-item-type\n                ng-if=\"$ctrl.menuState === 'selectItemType'\"\n                blacklist-types=\"$ctrl.blacklistTypes\"\n                on-item-selected=\"$ctrl.onMenuItemTypeSelected(type)\"\n                class=\"menu-editor-list\">\n            </menu-editor-select-item-type>\n\n            <menu-editor-select-item\n                ng-if=\"$ctrl.menuState === 'selectItem'\"\n                type=\"$ctrl.addItemType\"\n                on-back-button-click=\"$ctrl.showSelectItemType\"\n                on-menu-item-selected=\"$ctrl.onItemSelected\"\n                on-add-item-click=\"$ctrl.showAddItemType\">\n            </menu-editor-select-item>\n\n            <menu-editor-add-link\n                ng-if=\"$ctrl.menuState === 'addLink'\"\n                on-cancel-click=\"$ctrl.showSelectItemType()\"\n                on-link-saved=\"$ctrl.onItemSelected({ newItem: item, itemType: 'link' })\">\n            </menu-editor-add-link>\n\n            <menu-editor-add-url\n                ng-if=\"$ctrl.menuState === 'addUrl'\"\n                on-cancel-click=\"$ctrl.showSelectItemType()\"\n                on-url-saved=\"$ctrl.onItemSelected({ newItem: item, itemType: 'externalUrl' })\">\n            </menu-editor-add-url>\n\n            <menu-editor-add-item\n                ng-if=\"$ctrl.menuState === 'addItem'\"\n                type=\"$ctrl.addItemType\"\n                on-back-button-click=\"$ctrl.onMenuItemTypeSelected\"\n                on-save-click=\"$ctrl.onMenuItemTypeSelected\">\n            </menu-editor-add-item>\n        ",
  bindings: {
    onItemSelected: '<',
    blacklistTypes: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    function MenuEditorAddToMenuCtrl() {
      'ngInject';

      _classCallCheck(this, MenuEditorAddToMenuCtrl);

      (0, _assign.default)(this, {
        menuState: 'selectItemType'
      });
      this.showAddItemType = this.showAddItemType.bind(this);
      this.onMenuItemTypeSelected = this.onMenuItemTypeSelected.bind(this);
      this.showSelectItemType = this.showSelectItemType.bind(this);
    }

    _createClass(MenuEditorAddToMenuCtrl, [{
      key: "onMenuItemTypeSelected",
      value: function onMenuItemTypeSelected(type) {
        this.addItemType = type;

        switch (type) {
          case 'link':
            this.menuState = 'addLink';
            break;

          case 'externalUrl':
            this.menuState = 'addUrl';
            break;

          default:
            this.menuState = 'selectItem';
            break;
        }
      }
    }, {
      key: "showSelectItemType",
      value: function showSelectItemType() {
        this.menuState = 'selectItemType';
      }
    }, {
      key: "showAddItemType",
      value: function showAddItemType(type) {
        this.addItemType = type;
        this.menuState = 'addItem';
      }
    }]);

    return MenuEditorAddToMenuCtrl;
  }()
}).name;
exports.AddToMenu = AddToMenu;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddUrl = void 0;

var _httpPrefix = __webpack_require__(377);

var _addUrl = _interopRequireDefault(__webpack_require__(1578));

__webpack_require__(1579);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AddUrl = angular.module('app.pages.editstore.menuEditor.addUrl', [_httpPrefix.HttpPrefixDirective]).component('menuEditorAddUrl', {
  template: _addUrl.default,
  bindings: {
    prefillUrlData: '<',
    onCancelClick: '&',
    onUrlSaved: '&'
  },
  controller:
  /*#__PURE__*/
  function () {
    function MenuEditorAddUrlCtrl() {
      _classCallCheck(this, MenuEditorAddUrlCtrl);
    }

    _createClass(MenuEditorAddUrlCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        this.urlData = this.prefillUrlData || {};
      }
    }]);

    return MenuEditorAddUrlCtrl;
  }()
}).name;
exports.AddUrl = AddUrl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"md-dialog-content\"> <ng-form name=\"addUrlForm\"> <md-input-container class=\"no-errors no-bottom-margin md-accent md-block\"> <label>{{'EDITSTORECONTENT.URL' | translate}}</label> <input ng-model=\"$ctrl.urlData.url\" vln-http-prefix force-https=\"true\" required md-no-asterisk> </md-input-container> </ng-form> </md-dialog-content> <md-dialog-actions layout=\"row\" layout-align=\"end center\"> <md-button ng-click=\"$ctrl.onCancelClick()\">{{'BUTTON.CANCEL' | translate}}</md-button> <md-button class=\"md-accent\" ng-click=\"$ctrl.onUrlSaved({item: $ctrl.urlData})\" ng-disabled=\"addUrlForm.$invalid\">{{'BUTTON.SAVE' | translate}}</md-button> </md-dialog-actions> ";

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectItem = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _orderBy = _interopRequireDefault(__webpack_require__(1581));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _categories = __webpack_require__(100);

var _products = __webpack_require__(98);

var _pages = __webpack_require__(266);

var _launchDarkly = __webpack_require__(30);

var _authToken = __webpack_require__(43);

var _storeInformation = __webpack_require__(38);

var _SiteDesigner = _interopRequireDefault(__webpack_require__(601));

var _selectItem = _interopRequireDefault(__webpack_require__(1582));

__webpack_require__(1583);

var _menuConstants = _interopRequireDefault(__webpack_require__(618));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PRODUCT_LIMIT = 200;
var GENEROUS_PAGE_SIZE = 1000;
var FIRST_PAGE = 1;
var dynamicPageOr404 = /\/:|(^\/404$)|(^\/search)/;
var SelectItem = angular.module('app.pages.editstore.menuEditor.selectItem', [_categories.CategoryServiceModule, _products.ProductServiceModule, _pages.PagesServiceModule, _launchDarkly.LaunchDarklyServiceModule, _authToken.AuthTokenServiceModule, _storeInformation.StoreInformationServiceModule, _angularjs.default]).component('menuEditorSelectItem', {
  template: _selectItem.default,
  bindings: {
    onBackButtonClick: '<',
    onMenuItemSelected: '<',
    onAddItemClick: '<',
    type: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    MenuEditorSelectItemCtrl.$inject = ["categoryService", "productService", "pagesService", "launchDarklyService", "authTokenService", "storeInformationService", "$rootScope", "$state", "$q"];

    function MenuEditorSelectItemCtrl(categoryService, productService, pagesService, launchDarklyService, authTokenService, storeInformationService, $rootScope, $state, $q) {
      'ngInject';

      _classCallCheck(this, MenuEditorSelectItemCtrl);

      (0, _assign.default)(this, {
        dataItems: [],
        linkData: {},
        urlData: {},
        loading: true,
        categoryService: categoryService,
        productService: productService,
        pagesService: pagesService,
        launchDarklyService: launchDarklyService,
        authTokenService: authTokenService,
        storeInformationService: storeInformationService,
        $rootScope: $rootScope,
        $state: $state,
        $q: $q,
        TYPES: _menuConstants.default.TYPES,
        showAddItemLink: true
      });
    }

    _createClass(MenuEditorSelectItemCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        if (this.type === _menuConstants.default.TYPES.CATEGORY) {
          this.categoryService.getCategories(true).then(function (data) {
            return _this.sort(data);
          }).then(function (data) {
            return _this.onDataResponse(data);
          });
        } else if (this.type === _menuConstants.default.TYPES.PRODUCT) {
          this.productService.getMinimalProducts(FIRST_PAGE, PRODUCT_LIMIT, ['name asc'], {
            filter: 'state eq "Active"',
            include: 'seo'
          }).then(function (data) {
            return _this.sort(data);
          }).then(function (data) {
            return _this.onDataResponse(data);
          });
        } else if (this.type === _menuConstants.default.TYPES.PAGE) {
          this.authTokenService.getBearer().then(function (token) {
            _SiteDesigner.default.setAuthToken(token);

            var SiteDesignerPagesPromise = _SiteDesigner.default.getInstalledTheme().then(function (theme) {
              return theme.id;
            }).then(function (themeId) {
              return _SiteDesigner.default.getPages(themeId);
            }).then(function (pages) {
              return pages.filter(function (page) {
                return !page.path.match(dynamicPageOr404);
              });
            });

            _this.storeInformationService.getStore().then(function (storeInformation) {
              return _this.$q.all([_this.pagesService.getPages(null, null, {
                pageSize: GENEROUS_PAGE_SIZE
              }), SiteDesignerPagesPromise, _this.launchDarklyService.isNewAccount(storeInformation)]);
            }).then(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 3),
                  pages = _ref2[0],
                  elementPages = _ref2[1],
                  newAccount = _ref2[2];

              _this.showAddItemLink = !newAccount;
              var normalizedElementPages = elementPages.map(function (page) {
                return {
                  type: _menuConstants.default.TYPES.ELEMENT_PAGE,
                  name: page.title,
                  createdOn: page.auditInfo.createdOn,
                  updatedOn: page.auditInfo.updatedOn,
                  path: page.path,
                  seo: {}
                };
              });
              return newAccount ? normalizedElementPages : _toConsumableArray(pages.items).concat(_toConsumableArray(normalizedElementPages));
            }).then(function (pages) {
              return _this.sort(pages);
            }).then(function (data) {
              return _this.onDataResponse(data);
            }).catch(function (err) {
              // eslint-disable-next-line no-console
              console.error("Problem getting pages: ".concat(err));

              _this.onDataResponse([]);
            });
          });
        }
      }
    }, {
      key: "onDataResponse",
      value: function onDataResponse(data) {
        this.dataItems = data;
        this.loading = false;
      }
    }, {
      key: "sort",
      value: function sort(data) {
        if (this.type === _menuConstants.default.TYPES.CATEGORY) {
          return (0, _orderBy.default)(data, ['createdOn'], ['desc']);
        }

        if (this.type === _menuConstants.default.TYPES.PRODUCT) {
          return (0, _orderBy.default)(data.items, ['updatedOn'], ['desc']);
        }

        if (this.type === _menuConstants.default.TYPES.PAGE) {
          return (0, _orderBy.default)(data, ['updatedOn'], ['desc']);
        }

        return data;
      }
    }]);

    return MenuEditorSelectItemCtrl;
  }()
}).name;
exports.SelectItem = SelectItem;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1581 */,
/* 1582 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"select-menu-item\"> <div layout=\"row\" layout-align=\"start center\" class=\"select-menu-item__header\"> <md-button class=\"md-icon-button\" ng-click=\"$ctrl.onBackButtonClick()\"> <md-icon>chevron_left</md-icon> </md-button> <md-input-container class=\"no-errors no-bottom-margin no-top-margin\" flex md-no-float> <input ng-model=\"itemSearch.name\" placeholder=\"Search\" autocomplete=\"off\" maxlength=\"100\"> </md-input-container> </div> <div layout=\"row\" layout-align=\"center center\" class=\"select-menu-item__loading\" ng-if=\"$ctrl.loading\"> <md-progress-circular md-diameter=\"40\" class=\"md-accent\"></md-progress-circular> </div> <md-list class=\"select-menu-item__items\" ng-if=\"!$ctrl.loading\"> <md-list-item class=\"select-menu-item__item select-menu-item__item--add\" ng-click=\"$ctrl.onAddItemClick($ctrl.type)\" ng-if=\"$ctrl.showAddItemLink\"> <md-icon class=\"menu-item-icon\">add</md-icon> <div class=\"select-menu-item__item-text md-list-item-text ellipsis\" layout=\"column\"> <p class=\"ellipsis\"> <span ng-if=\"$ctrl.type === $ctrl.TYPES.CATEGORY\">{{'CATEGORY.ADD' | translate}}</span> <span ng-if=\"$ctrl.type === $ctrl.TYPES.PRODUCT\">{{'PRODUCT.ADD' | translate}}</span> <span ng-if=\"$ctrl.type === $ctrl.TYPES.PAGE\">{{'PAGES.ADD_A_PAGE' | translate}}</span> </p> </div> </md-list-item> <md-list-item class=\"select-menu-item__item md-2-line\" ng-repeat=\"item in filteredItems = ($ctrl.dataItems | filter:itemSearch:strict)\" ng-click=\"$ctrl.onMenuItemSelected({newItem: item, itemType: $ctrl.type})\"> <md-icon class=\"menu-item-icon\" ng-if=\"$ctrl.type === $ctrl.TYPES.CATEGORY\">list</md-icon> <md-icon class=\"menu-item-icon\" ng-if=\"$ctrl.type === $ctrl.TYPES.PRODUCT\">local_offer</md-icon> <md-icon class=\"menu-item-icon\" ng-if=\"$ctrl.type === $ctrl.TYPES.PAGE\">insert_drive_file</md-icon> <div class=\"select-menu-item__item-text md-list-item-text ellipsis\" layout=\"column\"> <p class=\"ellipsis\" md-highlight-text=\"itemSearch.name\" md-highlight-flags=\"^i\">{{item.name}}</p> <p class=\"ellipsis\"> <span ng-if=\"$ctrl.type !== $ctrl.TYPES.CATEGORY && item.updatedOn\">{{'EDITSTORECONTENT.LASTUPDATED' | translate}}: {{item.updatedOn | date: 'M/d/y'}}</span> <span ng-if=\"$ctrl.type === $ctrl.TYPES.CATEGORY\" ng-pluralize count=\"item.subCategories.length\" when=\"{'0': 'No subcategories','one': '1 subcategory', 'other': '{} subcategories'}\"> </span> </p> </div> </md-list-item> <md-list-item class=\"select-menu-item__item md-2-line\" ng-if=\"filteredItems.length === 0\"> <div class=\"select-menu-item__item-text md-list-item-text ellipsis\" layout=\"column\"> <p class=\"ellipsis\"> <span ng-if=\"$ctrl.dataItems.length === 0\">No items</span> <span ng-if=\"$ctrl.dataItems.length !== 0\">No matching items</span> </p> </div> </md-list-item> </md-list> </md-dialog-content>";

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectItemType = void 0;

var _remove = _interopRequireDefault(__webpack_require__(193));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _includes = _interopRequireDefault(__webpack_require__(287));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SelectItemType = angular.module('app.pages.editstore.menuEditor.selectItemType', []).component('menuEditorSelectItemType', {
  template: "\n            <md-list>\n                <md-list-item\n                    id=\"{{item.id}}-menu-item-type\"\n                    ng-repeat=\"item in $ctrl.items\"\n                    ng-click=\"$ctrl.onItemSelected({ type: item.id })\"\n                    gtm-click-event=\"admin_editStore.content.menu_add-category\">\n                    <md-icon class=\"menu-item-icon\">{{::item.icon}}</md-icon>\n                    <p>{{item.translationKey | translate}}</p>\n                </md-list-item>\n            </md-list>\n        ",
  bindings: {
    onItemSelected: '&',
    blacklistTypes: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    function MenuEditorSelectItemTypeCtrl() {
      'ngInject';

      _classCallCheck(this, MenuEditorSelectItemTypeCtrl);

      (0, _assign.default)(this, {
        items: [{
          id: 'externalUrl',
          icon: 'link',
          translationKey: 'EDITSTORECONTENT.URL'
        }, {
          id: 'category',
          icon: 'list',
          translationKey: 'EDITSTORECONTENT.CATEGORY'
        }, {
          id: 'product',
          icon: 'local_offer',
          translationKey: 'EDITSTORECONTENT.PRODUCT'
        }, {
          id: 'link',
          icon: 'link',
          translationKey: 'EDITSTORECONTENT.LINK'
        }, {
          id: 'page',
          icon: 'insert_drive_file',
          translationKey: 'EDITSTORECONTENT.PAGE'
        }]
      });
    }

    _createClass(MenuEditorSelectItemTypeCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        if (this.blacklistTypes) {
          this.filterTypes();
        }
      }
    }, {
      key: "filterTypes",
      value: function filterTypes() {
        var _this = this;

        (0, _remove.default)(this.items, function (item) {
          return (0, _includes.default)(_this.blacklistTypes, item.id);
        });
      }
    }]);

    return MenuEditorSelectItemTypeCtrl;
  }()
}).name;
exports.SelectItemType = SelectItemType;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddItem = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _categories = __webpack_require__(100);

var _products = __webpack_require__(98);

var _pages = __webpack_require__(266);

var _model = __webpack_require__(251);

var _restrictCurrency = __webpack_require__(636);

var _validateMin = __webpack_require__(640);

var _validateMax = __webpack_require__(641);

var _addItem = _interopRequireDefault(__webpack_require__(1586));

__webpack_require__(1587);

var _menuConstants = _interopRequireDefault(__webpack_require__(618));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AddItem = angular.module('app.pages.editstore.menuEditor.addItem', [_categories.CategoryServiceModule, _products.ProductServiceModule, _pages.PagesServiceModule, _model.ModelModule, _restrictCurrency.RestrictCurrency, _validateMax.ValidateMax, _validateMin.ValidateMin]).component('menuEditorAddItem', {
  template: _addItem.default,
  bindings: {
    onBackButtonClick: '<',
    onSaveClick: '<',
    type: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    MenuEditorAddItemCtrl.$inject = ["categoryService", "productService", "pagesService", "modelService"];

    function MenuEditorAddItemCtrl(categoryService, productService, pagesService, modelService) {
      'ngInject';

      _classCallCheck(this, MenuEditorAddItemCtrl);

      (0, _assign.default)(this, {
        categoryService: categoryService,
        productService: productService,
        pagesService: pagesService,
        modelService: modelService,
        TYPES: _menuConstants.default.TYPES
      });
    }

    _createClass(MenuEditorAddItemCtrl, [{
      key: "$onInit",
      value: function $onInit() {
        if (this.type === _menuConstants.default.TYPES.CATEGORY) {
          this.title = 'CATEGORY.CATEGORY_TITLE';
          this.buttonLabel = 'CATEGORY.CREATE_BUTTON_LABEL';
          this.dialogTitle = 'CATEGORY.ADD';
        } else if (this.type === _menuConstants.default.TYPES.PAGE) {
          this.title = 'PAGES.PAGE_TITLE';
          this.buttonLabel = 'PAGES.CREATE_BUTTON_LABEL';
          this.dialogTitle = 'PAGES.ADD_A_PAGE';
        } else if (this.type === _menuConstants.default.TYPES.PRODUCT) {
          this.title = 'PRODUCT.PRODUCT_TITLE';
          this.buttonLabel = 'PRODUCT.CREATE_BUTTON_LABEL';
          this.dialogTitle = 'PRODUCT.ADD';
        }
      }
    }, {
      key: "create",
      value: function create() {
        var _this = this;

        var name = this.itemData.name;
        var price = this.itemData.price;
        this.saving = true;
        var promise;

        if (this.type === _menuConstants.default.TYPES.CATEGORY) {
          promise = this.categoryService.add({
            category: this.modelService.makeModel({
              name: name
            }, 'categoryModel')
          });
        } else if (this.type === _menuConstants.default.TYPES.PAGE) {
          var page = this.modelService.makeEmptyModel('pagesModel');
          page.name = name;
          promise = this.pagesService.create(page);
        } else if (this.type === _menuConstants.default.TYPES.PRODUCT) {
          promise = this.productService.create({
            name: name,
            price: price
          });
        }

        promise.then(function () {
          _this.saving = false;

          _this.onSaveClick(_this.type);
        });
      }
    }]);

    return MenuEditorAddItemCtrl;
  }()
}).name;
exports.AddItem = AddItem;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"menu-editor-add-item\"> <div layout=\"row\" layout-align=\"start center\" class=\"menu-editor-add-item__header\"> <md-button class=\"md-icon-button\" ng-click=\"$ctrl.onBackButtonClick($ctrl.type)\"> <md-icon>chevron_left</md-icon> </md-button> <div class=\"menu-editor-add-item__header-text\">{{$ctrl.dialogTitle | translate}}</div> </div> <ng-form name=\"addItemForm\" class=\"md-dialog-content menu-editor-add-item__form\"> <md-input-container class=\"no-errors md-accent md-block no-top-margin no-bottom-margin\"> <label>{{$ctrl.title | translate}}</label> <input ng-model=\"$ctrl.itemData.name\" type=\"text\" required md-no-asterisk> </md-input-container> <md-input-container class=\"no-errors md-accent md-block\" ng-if=\"$ctrl.type === $ctrl.TYPES.PRODUCT\"> <label>{{'Product Price'}}</label> <input ng-model=\"$ctrl.itemData.price\" type=\"text\" required md-no-asterisk restrict-currency vln-min=\"0\" vln-max=\"100000\" aria-label=\"product-price\"> </md-input-container> <md-button class=\"md-accent md-raised menu-editor-add-item__submit-button\" ng-click=\"$ctrl.create()\" ng-disabled=\"addItemForm.$invalid || $ctrl.saving\" layout=\"row\" layout-align=\"center center\"> <span ng-if=\"!$ctrl.saving\">{{$ctrl.buttonLabel | translate}}</span> <span ng-if=\"$ctrl.saving\"> <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular> </span> </md-button> </ng-form> </md-dialog-content>";

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

module.exports = "<div class=\"redactor__scope\"> <textarea class=\"fallback\" ng-model=\"fallbackTextValue\" ng-change=\"updateModel()\"></textarea> </div> ";

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedactorAddLinkModalModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _httpPrefix = __webpack_require__(377);

var _addLinkModal = _interopRequireDefault(__webpack_require__(1592));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RedactorAddLinkModalModule = angular.module('app.components.redactor.redactorAddLinkModal', ['ngMaterial', _angularjs.default, _httpPrefix.HttpPrefixDirective]).component('redactorAddLinkModal', {
  template: _addLinkModal.default,
  controller:
  /*#__PURE__*/
  function () {
    AddLinkModalController.$inject = ["$scope", "$mdDialog", "$state"];

    function AddLinkModalController($scope, $mdDialog, $state) {
      'ngInject';

      _classCallCheck(this, AddLinkModalController);

      (0, _assign.default)(this, {
        link: {},
        $scope: $scope,
        $mdDialog: $mdDialog,
        $state: $state
      });
    }

    _createClass(AddLinkModalController, [{
      key: "$onInit",
      value: function $onInit() {
        this.stateName = this.$state.current.name;
      }
    }, {
      key: "confirm",
      value: function confirm() {
        this.$mdDialog.hide(this.link);
      }
    }, {
      key: "cancel",
      value: function cancel() {
        this.$mdDialog.cancel('cancel');
      }
    }]);

    return AddLinkModalController;
  }()
}).name;
exports.RedactorAddLinkModalModule = RedactorAddLinkModalModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

module.exports = "<div> <md-dialog-content class=\"modal__content\"> <div class=\"md-dialog-content\"> <div> <h3 class=\"modal__header\">{{'PAGES.ADDLINK' | translate}}</h3> </div> <md-input-container class=\"md-accent md-block\" md-no-float> <input type=\"text\" ng-model=\"$ctrl.link.linkLabel\" placeholder=\"{{'PAGES.LINKLABEL' | translate}}\" name=\"linkLabel\" aria-label=\"link-label\"> </md-input-container> <md-input-container class=\"md-accent md-block\" md-no-float> <input type=\"text\" ng-model=\"$ctrl.link.linkUrl\" placeholder=\"{{'PAGES.LINKURL' | translate}}\" name=\"linkUrl\" aria-label=\"link-url\" vln-http-prefix> </md-input-container> </div> </md-dialog-content> <md-dialog-actions class=\"modal__buttons\"> <md-button ng-click=\"$ctrl.cancel()\" gtm-click-event=\"admin_{{$ctrl.stateName}}_redactor_linkModal-cancel\">{{\"BUTTON.CANCEL\" | translate}}</md-button> <md-button class=\"md-accent\" ng-click=\"$ctrl.confirm()\" gtm-click-event=\"admin_{{$ctrl.stateName}}_redactor_linkModal-save\">{{'LABEL.SAVE' | translate}}</md-button> </md-dialog-actions> </div> ";

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedactorEmbedVideoModalModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _embedVideoModal = _interopRequireDefault(__webpack_require__(1594));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RedactorEmbedVideoModalModule = angular.module('app.components.redactor.redactorEmbedVideoModal', ['ngMaterial', _angularjs.default]).component('redactorEmbedVideoModal', {
  template: _embedVideoModal.default,
  controller:
  /*#__PURE__*/
  function () {
    EmbedVideoModalController.$inject = ["$scope", "$mdDialog", "$state"];

    function EmbedVideoModalController($scope, $mdDialog, $state) {
      'ngInject';

      _classCallCheck(this, EmbedVideoModalController);

      (0, _assign.default)(this, {
        video: {},
        regex: /(youtube\.com|youtu\.be)/g,
        $scope: $scope,
        $mdDialog: $mdDialog,
        $state: $state
      });
    }

    _createClass(EmbedVideoModalController, [{
      key: "$onInit",
      value: function $onInit() {
        this.stateName = this.$state.current.name;
      }
    }, {
      key: "confirm",
      value: function confirm() {
        this.$mdDialog.hide(this.video);
      }
    }, {
      key: "cancel",
      value: function cancel() {
        this.$mdDialog.cancel('cancel');
      }
    }]);

    return EmbedVideoModalController;
  }()
}).name;
exports.RedactorEmbedVideoModalModule = RedactorEmbedVideoModalModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

module.exports = "<div> <md-dialog-content class=\"modal__content\"> <form name=\"embedForm\" class=\"md-dialog-content\"> <div> <h3 class=\"modal__header\">{{'PAGES.EMBEDVIDEO' | translate}}</h3> </div> <p>{{'PAGES.ENTERYOUTUBEURL' | translate}}</p> <md-input-container class=\"md-accent md-block\"> <label>{{'PAGES.YOUTUBE' | translate}}</label> <input type=\"url\" ng-model=\"$ctrl.video.youtube\" name=\"youtube\" aria-label=\"youtube-embed\" ng-pattern=\"$ctrl.regex\"> <div ng-messages=\"embedForm.youtube.$error\" ng-if=\"embedForm.youtube.$touched\"> <div ng-message=\"pattern\">{{'ERROR.YOUTUBEEMBED' | translate}}</div> </div> </md-input-container> <div layout=\"row\"> <md-checkbox ng-model=\"$ctrl.video.fullWidth\" aria-label=\"Use full width\"> {{'PAGES.USEFULLWIDTH' | translate}} </md-checkbox> </div> <div layout=\"row\" ng-if=\"!$ctrl.video.fullWidth\"> <md-input-container class=\"md-accent md-block\" flex> <label>{{'PAGES.VIDEOWIDTH' | translate}}</label> <input type=\"number\" ng-model=\"$ctrl.video.width\" name=\"width\" aria-label=\"youtube-embed\" min=\"0\"> </md-input-container> </div> <div layout=\"row\"> <md-input-container class=\"md-accent md-block\" flex> <label>{{'PAGES.VIDEOHEIGHT' | translate}}</label> <input type=\"number\" ng-model=\"$ctrl.video.height\" name=\"height\" aria-label=\"youtube-embed\" min=\"0\"> </md-input-container> </div> </form> </md-dialog-content> <md-dialog-actions class=\"modal__buttons\"> <md-button ng-click=\"$ctrl.cancel()\" gtm-click-event=\"admin_{{$ctrl.stateName}}_redactor_embedModal-cancel\">{{\"BUTTON.CANCEL\" | translate}}</md-button> <md-button class=\"md-accent\" ng-click=\"$ctrl.confirm()\" gtm-click-event=\"admin_{{$ctrl.stateName}}_redactor_embedModal-save\" ng-disabled=\"embedForm.$invalid\">{{'LABEL.SAVE' | translate}}</md-button> </md-dialog-actions> </div> ";

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

module.exports = "<div class=\"extension-store-container\"> <md-button ng-click=\"$ctrl.extensionStoreActive = true;\" gtm-click-event=\"admin_extentions-extras\">{{'APPSTORE.EXTENSIONS' | translate}}</md-button> <md-card ng-if=\"$ctrl.extensionStoreActive\" class=\"extension-store\"> <md-card-title> <md-card-title-text> <span class=\"md-headline\">{{'APPSTORE.EXTENSIONS' | translate}}</span> </md-card-title-text> <md-button class=\"md-icon-button extension-store__close\" ng-click=\"$ctrl.extensionStoreActive = false;\"><md-icon>close</md-icon></md-button> </md-card-title> <md-card-content> <ul class=\"extension-store__items\" layout=\"row\" layout-wrap> <li flex-xs=\"100\" flex-gt-xs=\"50\" class=\"extension\" ng-repeat=\"item in $ctrl.extensions\" layout=\"row\" ng-click=\"$ctrl.openExtension(item, $index)\"> <div class=\"extension__image\" layout=\"row\" layout-align=\"center center\"> <span class=\"image\"> <div vln-back-img=\"{{item.logo.imageLink.fullUri}}\"></div> </span> </div> <div class=\"extension__heading\"> <span class=\"extension__title md-headline\">{{item.title}}</span> <p class=\"extension__description\">{{item.descriptionShort | stripHTML}}</p> </div> </li> <li> <md-button ui-sref=\"appstore.allextensions\" class=\"extension__themestore-button\">{{'APPSTORE.VISITMARKETPLACEFORMORE' | translate}}</md-button> </li> </ul> </md-card-content> </md-card> </div> ";

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal__container\"> <md-dialog-content class=\"modal__content\"> <div class=\"md-dialog-content\"> <h3 class=\"modal__header\">{{'LABEL.DUPLICATE' | translate}}</h3> <p>{{\"MODAL.DUPLICATE\" | translate: $ctrl.translateData}}</p> </div> </md-dialog-content> <md-dialog-actions class=\"modal__buttons\"> <md-button ng-click=\"$ctrl.cancelDuplicate()\" gtm-click-event=\"{{$ctrl.gtmid}}-cancelCopy\">{{\"BUTTON.CANCEL\" | translate}}</md-button> <md-button class=\"md-accent\" ng-click=\"$ctrl.confirmDuplicate()\" gtm-click-event=\"{{$ctrl.gtmid}}-confirmCopy\">{{'LABEL.DUPLICATE' | translate}}</md-button> </md-dialog-actions> </div> ";

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

module.exports = "<md-card class=\"seo__card\"> <md-card-title> <md-card-title-text> <h2> <span class=\"md-headline\">{{'SEO.SEO' | translate}}</span> <a href=\"https://help.volusion.com/grow-your-business/the-seo-extension\" target=\"_blank\" class=\"help-icon\"> <md-icon class=\"material-icons\" role=\"img\" aria-label=\"help\">help</md-icon> </a> </h2> <span class=\"md-subhead\"> {{'SEO.SUBHEAD' | translate}} </span> </md-card-title-text> </md-card-title> <md-card-content> <ng-form name=\"extensionForm\"> <md-input-container class=\"md-accent md-block\"> <label>{{'SEO.FRIENDLYNAME' | translate}}</label> <div class=\"leading-text\"> <span>{{$ctrl.storeUrl}}</span> <input type=\"text\" name=\"friendlyName\" ng-model=\"$ctrl.model.seo.friendlyName\" maxlength=\"255\" placeholder=\"{{$ctrl.model.seo.friendlyName}}\"> </div> </md-input-container> <md-input-container class=\"md-accent md-block\"> <label>{{'SEO.TITLE' | translate}}</label> <input type=\"text\" name=\"title\" ng-model=\"$ctrl.model.seo.title\"> <span class=\"seo-hint\" ng-bind-html=\"$ctrl.hint\"></span> <span> {{$scope.title}} </span> </md-input-container> <md-input-container class=\"md-accent md-block\"> <label>{{'SEO.METADESCRIPTIONSHORT' | translate}}</label> <div class=\"editable__input-container\"> <textarea name=\"metaDescription\" ng-model=\"$ctrl.model.seo.metaDescription\" maxlength=\"320\"/> </div> </md-input-container> <div class=\"seo-preview\"> <h4>{{ 'STORESETTINGS.SEOHOMEPAGESEOGOOGLEPREVIEWTITLE' | translate }}</h4> <div class=\"google\"> <h1 class=\"google__title ellipsis\"> {{$ctrl.model.seo.title || 'STORESETTINGS.SEOHOMEPAGESEOGOOGLEPREVIEWTITLETAGEXAMPLE' | translate }} </h1> <span class=\"google__url\"> {{ $ctrl.storeUrl + $ctrl.model.seo.friendlyName || 'STORESETTINGS.SEOHOMEPAGESEOGOOGLEPREVIEWURLEXAMPLE' | translate }} </span> <p class=\"google__description\"> {{$ctrl.model.seo.metaDescription || 'STORESETTINGS.SEOHOMEPAGESEOGOOGLEPREVIEWMETADESCTAGEXAMPLE' | translate}} </p> </div> </div> </ng-form> </md-card-content> </md-card> ";

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */
/***/ (function(module, exports) {

module.exports = "<md-card class=\"category_picker\"> <h2>{{$ctrl.title}} </h2> <md-chips class=\"md-accent\" md-require-match=\"true\" ng-model=\"$ctrl.selectedCategories\" md-on-remove=\"$ctrl.removeCategory($chip)\"> <md-button class=\"md-icon-button variant__remove variant__remove--chip\" md-chip-remove> <md-icon>cancel</md-icon> </md-button> <md-autocomplete md-no-cache md-selected-item=\"$ctrl.autocomplete.selectedItem\" md-search-text=\"$ctrl.autocomplete.searchText\" md-items=\"item in $ctrl.querySearch($ctrl.autocomplete.searchText)\" md-selected-item-change=\"$ctrl.addCategory(item)\" md-min-length=\"1\" class=\"md-accent\" md-item-text=\"item.lineage\" md-input-name=\"addCategories\" ng-disabled=\"$ctrl.autocomplete.disabled\" placeholder=\"{{$ctrl.autocomplete.placeholder}}\"> <md-item-template class=\"md-accent\"> <div ng-class=\"{'item--hidden': item.state == 'Inactive'}\"> <span><span class=\"name\" md-highlight-text=\"$ctrl.autocomplete.searchText\" md-highlight-flags=\"^i\">{{item.lineage}}</span></span> <div ng-if=\"item.parentName\" class=\"child\" ng-class=\"{'child--hidden': item.state == 'Inactive'}\"> <span md-highlight-text=\"$ctrl.autocomplete.searchText\" md-highlight-flags=\"^i\">{{item.lineage}}</span> </div> </div> </md-item-template> <md-not-found> <div ng-if=\"$ctrl.autocomplete.searchText.length\" class=\"md-not-found\" ng-touchstart=\"$ctrl.createCategory($ctrl.autocomplete.searchText)\" ng-mousedown=\"$ctrl.createCategory($ctrl.autocomplete.searchText)\"> <md-icon class=\"md-accent\">add</md-icon> <span><span class=\"uppercase\">{{$ctrl.createNewCategoryText}}</span><span class=\"md-not-found--search-text\"> \"{{$ctrl.autocomplete.searchText}}\"</span> </span> </div> <div ng-if=\"!$ctrl.autocomplete.searchText.length\"> {{$ctrl.noResultsText}} </div> </md-not-found> </md-autocomplete> <md-chip-template> <span ng-class=\"{'item--hidden': $chip.state == 'Inactive'}\"> <span class=\"name\"> <span ng-if=\"$chip.lineage\"> {{$chip.lineage}} </span> </span> </span> </md-chip-template> </md-chips> </md-card> ";

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductPickerModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _get = _interopRequireDefault(__webpack_require__(34));

var _find = _interopRequireDefault(__webpack_require__(66));

var _filter = _interopRequireDefault(__webpack_require__(157));

var _cloneDeep = _interopRequireDefault(__webpack_require__(189));

var _pick = _interopRequireDefault(__webpack_require__(273));

var _reduce = _interopRequireDefault(__webpack_require__(160));

var _some = _interopRequireDefault(__webpack_require__(194));

var _every = _interopRequireDefault(__webpack_require__(1623));

var _union = _interopRequireDefault(__webpack_require__(422));

var _pull = _interopRequireDefault(__webpack_require__(677));

var _productPicker = __webpack_require__(741);

var _productPicker2 = _interopRequireDefault(__webpack_require__(1626));

__webpack_require__(1627);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ProductPickerModule = angular.module('app.components.productPicker', ['ngMaterial', _productPicker.ProductPickerServiceModule]).component('productPicker', {
  template: _productPicker2.default,
  bindings: {
    filterItems: '<',
    confirmText: '<',
    filterText: '<',
    showZeroInventory: '<',
    isZeroInventorySelectionEnabled: '<',
    addProductsHeadingKey: '<',
    customHeaderClass: '<',
    customBannerClass: '<',
    gtmId: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    ProductPicker.$inject = ["$filter", "$mdDialog", "productPicker"];

    function ProductPicker($filter, $mdDialog, productPicker) {
      _classCallCheck(this, ProductPicker);

      (0, _assign.default)(this, {
        $filter: $filter,
        $mdDialog: $mdDialog,
        productPicker: productPicker,
        STEP: {
          CATEGORY: 1,
          PRODUCT: 2
        },
        items: {
          categories: [],
          products: [],
          filteredProducts: []
        },
        productsCountBannerText: '',
        itemSearch: {
          data: {
            name: ''
          }
        },
        selectedCategory: {},
        selectedItems: [],
        initCategoryIds: [],
        initProductIds: [],
        loading: true
      });
    }

    _createClass(ProductPicker, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.step = this.STEP.CATEGORY;
        this.itemSearch.data.name = this.filterText || '';
        this.productPicker.getMinimalProductVariantsAndCategories().then(function (items) {
          _this.setItems(items);

          if (items.categories.length === 0 || _this.filterText.length > 0) {
            _this.step = _this.STEP.PRODUCT;
            _this.selectedCategory = {};
          }

          _this.goToStep(_this.step, _this.filterText);
        }).finally(function () {
          _this.loading = false;
        });
      }
    }, {
      key: "shouldShowNoResultsForFilterMessage",
      value: function shouldShowNoResultsForFilterMessage() {
        return this.items.filteredProducts.length === 0 && this.itemSearch.data.name.length > 0;
      }
    }, {
      key: "shouldShowNoProductsMessage",
      value: function shouldShowNoProductsMessage() {
        return this.items.filteredProducts.length === 0 && this.itemSearch.data.name.length === 0 && !this.loading;
      }
    }, {
      key: "constructCountText",
      value: function constructCountText(count, countNouns) {
        var trailingText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        var singularNoun = countNouns.singularNoun,
            pluralNoun = countNouns.pluralNoun;
        return "".concat(count, " ").concat(count === 1 ? singularNoun : pluralNoun).concat(trailingText);
      }
    }, {
      key: "setProductsCountBannerText",
      value: function setProductsCountBannerText() {
        var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var categories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var categoriesCountTextFragment = this.step === this.STEP.CATEGORY && categories.length > 0 ? this.constructCountText(categories.length, {
          singularNoun: 'category',
          pluralNoun: 'categories'
        }, ', ') : '';
        var nonVariantProducts = (0, _filter.default)(products, function (product) {
          return !product.isVariant;
        });
        var variantProducts = (0, _filter.default)(products, function (product) {
          return product.isVariant || !product.hasVariants;
        });
        var productsCount = nonVariantProducts.length;
        var variantsCount = variantProducts.length;
        var stockCount = (0, _reduce.default)(variantProducts, function (totalTrackedInventory, p) {
          totalTrackedInventory += p.isInventoryTracked ? p.quantity : 0;
          return totalTrackedInventory;
        }, 0);
        var isInventoryTrackedForAnyProduct = products.find(function (p) {
          return p.isInventoryTracked;
        });
        var stockCountTextFragment = "".concat(stockCount, " in stock for");
        var variantsCountTextFragment = this.constructCountText(variantsCount, {
          singularNoun: 'variant',
          pluralNoun: 'variants'
        });
        var productsCountTextFragment = this.constructCountText(productsCount, {
          singularNoun: 'product',
          pluralNoun: 'products'
        }, ', ');
        var stockAndVariantsCountTextFragment = isInventoryTrackedForAnyProduct ? "".concat(stockCountTextFragment, " ").concat(variantsCountTextFragment) : variantsCountTextFragment;
        this.productsCountBannerText = "".concat(categoriesCountTextFragment).concat(productsCountTextFragment).concat(stockAndVariantsCountTextFragment);
      }
    }, {
      key: "showZeroInventoryChanged",
      value: function showZeroInventoryChanged() {
        this.goToStep(this.step, this.itemSearch.data.name);
      }
    }, {
      key: "setItems",
      value: function setItems(items) {
        var _this2 = this;

        angular.forEach(items.categories, function (category) {
          _this2.items.categories.push({
            selected: false,
            data: category,
            id: category.id
          });

          if (_this2.initCategoryIds.indexOf(category.id) !== -1) {
            _this2.selectItem(_this2.items.categories[_this2.items.length - 1]);
          }
        });
        angular.forEach(items.products, function (product) {
          var hasVariants = product.productVariants.length > 1;

          if (!hasVariants) {
            (0, _assign.default)(product, (0, _pick.default)(product.productVariants[0], ['sku', 'price', 'priceOverride', 'isInventoryTracked', 'quantity', 'variants']));
          }

          if (hasVariants && !_this2.allVariantsExcluded(product) || !_this2.isProductDisabled(product)) {
            var p = (0, _cloneDeep.default)(product);
            var quantity = (0, _reduce.default)(p.productVariants, function (sum, variant) {
              return sum + variant.quantity;
            }, 0);
            var isInventoryTracked = p.productVariants[0].isInventoryTracked;

            if (p.pricing && p.pricing.salePrice) {
              p.price = p.pricing.salePrice;
            }

            var isOutOfStock = !hasVariants && isInventoryTracked && quantity === 0;

            _this2.items.products.push({
              selected: false,
              data: p,
              id: p.id,
              hasVariants: hasVariants,
              isInventoryTracked: isInventoryTracked,
              quantity: quantity,
              isOutOfStock: isOutOfStock,
              disabled: isOutOfStock && !_this2.isZeroInventorySelectionEnabled
            });
          }

          if (hasVariants) {
            product.productVariants.map(function (variant) {
              var p = (0, _cloneDeep.default)(product);
              (0, _assign.default)(p, (0, _pick.default)(variant, ['sku', 'price', 'priceOverride', 'isInventoryTracked', 'quantity', 'variants']));

              if (product.pricing && product.pricing.salePrice) {
                p.price = product.pricing.salePrice;
              }

              p.productVariantId = variant.id;

              if (!_this2.isProductDisabled(variant, true)) {
                var _isOutOfStock = variant.isInventoryTracked && variant.quantity === 0;

                _this2.items.products.push({
                  selected: false,
                  data: p,
                  id: p.id,
                  isVariant: true,
                  isOutOfStock: _isOutOfStock,
                  isInventoryTracked: variant.isInventoryTracked,
                  quantity: variant.quantity,
                  disabled: _isOutOfStock && !_this2.isZeroInventorySelectionEnabled
                });
              }

              return 0; // lint needs a return value from an arrow function
            });
          }

          if (_this2.initProductIds.indexOf(product.id) !== -1) {
            _this2.selectItem(_this2.items.products[_this2.items.length - 1]);
          }
        });
      }
    }, {
      key: "allVariantsExcluded",
      value: function allVariantsExcluded(product) {
        var _this3 = this;

        return (0, _every.default)(product.productVariants, function (variant) {
          return (0, _find.default)(_this3.filterItems, {
            product: {
              productVariantId: variant.id
            }
          });
        });
      }
    }, {
      key: "isProductDisabled",
      value: function isProductDisabled(product, isVariant) {
        return !!(0, _find.default)(this.filterItems, function (item) {
          var itemProduct = item.product || item;
          return isVariant ? itemProduct.productVariantId === product.id : itemProduct.id === product.id;
        });
      }
    }, {
      key: "selectItem",
      value: function selectItem(item) {
        if (item.disabled) return;
        item.selected = true;

        if (item.isVariant) {
          // if all variants of a product are checked, also check the parent
          var parent = this.getParentProduct(item);
          if (this.areAllVariantsSelected(parent)) this.selectItem(parent);
          this.selectedItems = (0, _union.default)(this.selectedItems, [item.data.productVariantId]);
        } else {
          // don't add product id if it has variants
          if (!item.hasVariants && this.selectedItems.indexOf(item.data.id) === -1) {
            this.selectedItems = (0, _union.default)(this.selectedItems, [item.data.id]);
          }
        }
      }
    }, {
      key: "selectCategory",
      value: function selectCategory(category) {
        this.selectedCategory = category.data;
        this.goToStep(this.STEP.PRODUCT);
      }
    }, {
      key: "onFilterTextChange",
      value: function onFilterTextChange() {
        this.goToStep(this.STEP.PRODUCT, this.itemSearch.data.name);
      }
    }, {
      key: "onFilterTextCleared",
      value: function onFilterTextCleared() {
        this.goToStep(this.STEP.PRODUCT);
      }
    }, {
      key: "goToStep",
      value: function goToStep(step, filterText) {
        this.step = step;
        this.itemSearch.data.name = filterText || '';

        if (step === this.STEP.CATEGORY) {
          this.selectedCategory = {};
          this.selectedItems = [];
          this.items.filteredProducts = this.items.products;
        }

        if (step === this.STEP.PRODUCT) {
          this.filterProducts();
          this.items.filteredProducts = this.$filter('filter')(this.filteredProducts, this.itemSearch);
        }

        if (!this.showZeroInventory) {
          this.items.filteredProducts = (0, _filter.default)(this.items.filteredProducts, function (p) {
            return !p.isOutOfStock;
          });
        }

        this.setProductsCountBannerText(this.items.filteredProducts, this.items.categories);
      }
    }, {
      key: "getCategoryName",
      value: function getCategoryName(id) {
        if (!id) return;
        var categoryWithId = (0, _find.default)(this.items.categories, function (category) {
          return category.data.categoryId === id;
        });
        return (0, _get.default)(categoryWithId, 'data.name');
      }
    }, {
      key: "getParentProduct",
      value: function getParentProduct(item) {
        return (0, _filter.default)(this.items.products, {
          id: item.id,
          hasVariants: true
        })[0];
      }
    }, {
      key: "filterProducts",
      value: function filterProducts() {
        var _this4 = this;

        this.filteredProducts = this.selectedCategory.id ? (0, _filter.default)(this.items.products, function (product) {
          return (0, _get.default)(product, 'data.categoryIds', []).indexOf(_this4.selectedCategory.id) > -1;
        }) : this.items.products;
      }
    }, {
      key: "deselectItem",
      value: function deselectItem(item) {
        item.selected = false;
        var itemId = item.isVariant ? item.data.productVariantId : item.data.id;
        (0, _pull.default)(this.selectedItems, itemId);
      }
    }, {
      key: "toggleItem",
      value: function toggleItem(item) {
        if (item.disabled) return;

        if (item.selected) {
          this.deselectItem(item);

          if (item.hasVariants) {
            this.toggleVariants(item, false);
          } else if (item.isVariant) {
            var itemParent = this.getParentProduct(item);

            if (!this.areVariantsSelected(itemParent)) {
              this.deselectItem(itemParent);
            }
          }
        } else {
          this.selectItem(item);

          if (item.hasVariants) {
            this.toggleVariants(item, true);
          } else if (item.isVariant) {
            var _itemParent = this.getParentProduct(item);

            if (this.areAllVariantsSelected(_itemParent)) {
              this.selectItem(_itemParent);
            }
          }
        }
      }
    }, {
      key: "areVariantsSelected",
      value: function areVariantsSelected(item) {
        if (!item.hasVariants) return false;
        return (0, _some.default)((0, _filter.default)(this.filteredProducts, {
          id: item.id,
          isVariant: true
        }), {
          selected: true
        });
      }
    }, {
      key: "areAllVariantsSelected",
      value: function areAllVariantsSelected(item) {
        if (!item.hasVariants) return false;
        return (0, _every.default)((0, _filter.default)(this.filteredProducts, {
          id: item.id,
          isVariant: true,
          disabled: false
        }), {
          selected: true
        });
      }
    }, {
      key: "toggleVariants",
      value: function toggleVariants(item, checked) {
        var _this5 = this;

        (0, _filter.default)(this.filteredProducts, {
          id: item.id,
          isVariant: true
        }).forEach(function (variant) {
          if (checked) _this5.selectItem(variant);else _this5.deselectItem(variant);
        });
      }
    }, {
      key: "deselectAll",
      value: function deselectAll() {
        angular.forEach(this.items.products, function (item) {
          item.selected = false;
        });
        this.selectedItems = [];
      }
    }, {
      key: "hasSelectedItems",
      value: function hasSelectedItems() {
        return this.selectedItems.length > 0;
      }
    }, {
      key: "close",
      value: function close() {
        this.$mdDialog.cancel();
      }
    }, {
      key: "confirm",
      value: function confirm() {
        var items = angular.copy(this.items.products);
        var selectedItems = [];
        angular.forEach(items, function (item) {
          if (item.selected && !item.hasVariants) {
            delete item.selected;
            delete item.hovering;
            delete item.$$hashKey;
            selectedItems.push(item);
          }
        });
        this.$mdDialog.hide(selectedItems);
      }
    }, {
      key: "getIndentation",
      value: function getIndentation(index) {
        var iconPadding = 54;

        if (index === 0) {
          return 0;
        }

        if (index === 1) {
          return "".concat(iconPadding, "px");
        }

        var lineWidth = 25;
        var spacing = 8;
        var baseIndentation = iconPadding + lineWidth + spacing;
        var multiplier = index - 2;
        return "".concat(baseIndentation + (lineWidth + spacing) * multiplier, "px");
      }
    }]);

    return ProductPicker;
  }()
}).name;
exports.ProductPickerModule = ProductPickerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */
/***/ (function(module, exports) {

module.exports = "<div class=\"product-picker__toolbar--sticky\"> <md-toolbar class=\"product-picker__header product-picker__header--default\" ng-class=\"$ctrl.customHeaderClass\" ng-if=\"!$ctrl.hasSelectedItems()\"> <div class=\"md-toolbar-tools\"> <md-button ng-click=\"$ctrl.goToStep(1)\" class=\"md-icon-button\" ng-if=\"$ctrl.step === 2 && $ctrl.items.categories.length > 0\"><md-icon>arrow_back</md-icon></md-button> <h2 class=\"product-picker__title\"> <span ng-if=\"$ctrl.step === 1\">{{($ctrl.addProductsHeadingKey || 'ORDER.ADDPRODUCTS') | translate}}</span> <span ng-if=\"$ctrl.step === 2\">{{$ctrl.selectedCategory.name || ('PRODUCT.ALLPRODUCTS' | translate)}}</span> </h2> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"> <md-icon aria-label=\"Close dialog\">close</md-icon> </md-button> </div> <div ng-class=\"$ctrl.customBannerClass\" class=\"product-picker__banner\"> <h3 class=\"product-picker__banner-text\"> {{$ctrl.productsCountBannerText}} </h3> <div class=\"product-picker__banner-switch\"> <span class=\"product-picker__banner-text\" ng-click=\"$ctrl.toggleActivate()\"> Show products out of stock </span> <md-switch ng-model=\"$ctrl.showZeroInventory\" ng-change=\"$ctrl.showZeroInventoryChanged()\" aria-label=\"Show out of stock products\" class=\"md-accent\"> </md-switch> </div> </div> </md-toolbar> <md-toolbar class=\"product-picker__header product-picker__header--selected\" ng-if=\"$ctrl.hasSelectedItems()\"> <div class=\"md-toolbar-tools\"> <md-button ng-click=\"$ctrl.deselectAll()\" class=\"md-icon-button product-picker__deselectAll\" ng-if=\"$ctrl.items.categories.length > 0\"><md-icon>arrow_back</md-icon></md-button> <span class=\"product-picker__num-selected\">{{$ctrl.selectedItems.length}} {{'SCOPEPICKER.SELECTED' | translate}}</span> <md-menu class=\"product-picker__menu\" md-offset=\"0 45\" md-position-mode=\"target-right target\"> <md-button aria-label=\"Open menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"> <md-icon md-menu-origin>keyboard_arrow_down</md-icon> </md-button> <md-menu-content class=\"selected-items__menu-content\"> <md-menu-item> <md-button ng-click=\"$ctrl.deselectAll()\"> {{'SCOPEPICKER.SELECTENONE' | translate}} </md-button> </md-menu-item> </md-menu-content> </md-menu> <span flex></span> <md-button class=\"md-raised md-accent\" data-cy=\"product-picker-add\" ng-click=\"$ctrl.confirm()\" gtm-click-event=\"{{$ctrl.gtmId}}_addProducts\"> {{$ctrl.confirmText}} </md-button> </div> </md-toolbar> <md-input-container md-no-float class=\"product-picker__search md-block md-icon-float md-icon-right\"> <md-icon class=\"product-picker__search-icon product-picker__search-icon--search\">search</md-icon> <input data-cy=\"product-picker-name-search\" ng-model=\"$ctrl.itemSearch.data.name\" ng-change=\"$ctrl.onFilterTextChange()\" type=\"text\" placeholder=\"{{('ORDER.PRODUCT_SEARCH_PLACEHOLDER') | translate}}\"> <md-icon class=\"product-picker__search-icon product-picker__search-icon--clear\" ng-click=\"$ctrl.onFilterTextCleared()\" ng-show=\"$ctrl.itemSearch.data.name\">clear</md-icon> </md-input-container> </div> <md-content ng-if=\"$ctrl.step === 1\"> <div class=\"product-picker__loader\" ng-if=\"$ctrl.loading\"> <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"60\" class=\"md-accent\"></md-progress-circular> </div> <md-list class=\"product-picker__list\"> <div class=\"product-picker__no-results\" ng-if=\"$ctrl.items.length > 0 && results.length === 0 && $ctrl.itemSearch.data.name.length > 0\">{{'SCOPEPICKER.NORESULTSFOR' | translate}} {{$ctrl.itemSearch.data.name}}</div> <div class=\"product-picker__no-results text-center\" ng-if=\"$ctrl.items.categories.length === 0 && !$ctrl.loading\">{{'SCOPEPICKER.NORESULTSCATEGORIES' | translate}}</div> <md-list-item class=\"md-2-line product-picker__list-item\" ng-click=\"$ctrl.selectCategory({data:{}})\" ng-mouseover=\"$ctrl.allProductsHover = true\" ng-mouseout=\"$ctrl.allProductsHover = false\" ng-class=\"{'product-picker__list-item--selected': $ctrl.allProductsHover}\"> <span></span> <md-icon class=\"md-avatar product-picker__list-icon\">list</md-icon> <div class=\"md-list-item-text ellispis\" flex> <h3>{{'PRODUCT.ALLPRODUCTS' | translate}}</h3> <div class=\"md-secondary\"> <span>{{$ctrl.items.products.length}} {{'SCOPEPICKER.PRODUCTS' | translate}}</span> </div> </div> </md-list-item> <md-list-item class=\"md-2-line product-picker__list-item\" ng-repeat=\"item in filteredItems = ($ctrl.items.categories | filter:$ctrl.itemSearch) as results\" ng-click=\"$ctrl.selectCategory(item);\" ng-mouseover=\"item.hovering = true\" ng-mouseout=\"item.hovering = false\" ng-class=\"{'product-picker__list-item--selected': item.selected, 'product-picker__list-item--child-item': item.data.parentId}\"> <div ng-class=\"{'product-picker__bars': item.data.level > 0}\" ng-click=\"$ctrl.selectCategory(item);\" ng-style=\"{'margin-left': $ctrl.getIndentation(item.data.level)}\" layout> <span></span> <md-icon ng-if=\"!item.data.parentId\" class=\"md-avatar product-picker__list-icon\">list</md-icon> <div class=\"md-list-item-text ellipsis\" flex layout=\"column\" layout-align=\"center start\"> <div class=\"list-item--secondary-text\" ng-if=\"item.data.parentId\"> <span>{{ $ctrl.getCategoryName(item.data.parentId) }} &gt;</span> </div> <h3>{{item.data.name}}</h3> <div ng-if=\"item.data.subCategories.length > 0\" class=\"list-item--secondary-text\"> <ng-pluralize count=\"item.data.subCategories.length\" when=\"{'one': '1 subcategory', 'other': '{} subcategories'}\"> </ng-pluralize> </div> </div> <div class=\"md-secondary\"> <span>{{item.data.productCount}} {{'SCOPEPICKER.PRODUCTS' | translate}}</span> </div> </div> </md-list-item> </md-list> </md-content> <md-content ng-if=\"$ctrl.step === 2\"> <div class=\"product-picker__loader\" ng-if=\"$ctrl.loading\"> <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"60\" class=\"md-accent\"></md-progress-circular> </div> <md-list class=\"product-picker__list\"> <div class=\"product-picker__no-results\" ng-if=\"$ctrl.shouldShowNoResultsForFilterMessage()\" layout=\"column\" layout-align=\"center center\">{{'SCOPEPICKER.NORESULTSFOR' | translate}} {{$ctrl.itemSearch.data.name}}</div> <div class=\"product-picker__no-results text-center\" ng-if=\"$ctrl.shouldShowNoProductsMessage()\">{{'SCOPEPICKER.NORESULTSPRODUCTS' | translate}}</div> <md-list-item class=\"md-2-line product-picker__list-item\" ng-repeat=\"item in $ctrl.items.filteredProducts\" ng-click=\"$ctrl.toggleItem(item)\" data-cy=\"product-picker-product\" ng-mouseover=\"item.hovering = true\" ng-mouseout=\"item.hovering = false\" ng-class=\"{'product-picker__list-item--selected': item.selected, 'product-picker__list-item--child-item': item.isVariant, 'product-picker__list-item--disabled': item.disabled}\"> <md-checkbox ng-if=\"(item.hovering || item.selected || $ctrl.areVariantsSelected(item)) && !item.disabled\" ng-model=\"item.selected\" ng-checked=\"item.selected\" md-indeterminate=\"$ctrl.areVariantsSelected(item) && !$ctrl.areAllVariantsSelected(item)\"> </md-checkbox> <span ng-if=\"!(item.hovering || item.selected || $ctrl.areVariantsSelected(item)) || item.disabled\" layout=\"row\" layout-align=\"center center\"> <md-icon ng-if=\"!item.isVariant && !item.data.images.length\" class=\"md-avatar product-picker__list-icon\"></md-icon> <span class=\"image md-avatar\" ng-if=\"!item.isVariant && item.data.images.length\"> <div vln-back-img=\"{{item.data.images[0].imageLink.uriBase}}w_80/{{item.data.images[0].imageLink.imagePath}}\"></div> </span> </span> <div class=\"md-list-item-text ellipsis\" flex> <div class=\"list-item--secondary-text\" ng-if=\"item.isVariant\">{{item.data.name}} &gt;</div> <h3>{{item.isVariant ? item.data.variants.join(' > ') : item.data.name}}</h3> <div class=\"list-item--secondary-text\" ng-if=\"item.hasVariants\">{{item.data.productVariants.length}} {{'PRODUCT.PRODUCTVARIANTS' | translate}}</div> <p class=\"md-secondary list-item__quantity\" ng-if=\"!item.hasVariants && item.isInventoryTracked\"> {{item.quantity}} {{'PRODUCT.INSTOCK' | translate}} </p> <p class=\"md-secondary list-item__price\" ng-if=\"!item.hasVariants\"> <span>{{item.data.price | currency}}</span> </p> </div> </md-list-item> </md-list> </md-content> ";

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLabelsModule = void 0;

/* eslint-disable max-len */
// Do not add to this file. We don't want to support translations in the admin anymore
var AppLabelsModule = angular.module('app.labels', []).constant('appLabels', {
  ADDRESS: {
    ADD: 'Add an Address',
    ADDBILLING: 'Add a Billing Address',
    ADDRESS1: 'Address Line 1',
    ADDRESS2: 'Address Line 2 (optional)',
    ADDSHIPPING: 'Add a Shipping Address',
    BILLINGADDRESS: 'Billing Address',
    CITY: 'City',
    COMPANY: 'Company (optional)',
    EDIT: 'Update Address',
    EDITBILLING: 'Update Billing Address',
    EDITSHIPPING: 'Update Shipping Address',
    FIRSTNAME: 'First Name',
    LASTNAME: 'Last Name',
    PHONENUMBER: 'Phone Number',
    PHONE_NUMBER_OPTIONAL: 'Phone Number (optional)',
    POSTALCODE: 'ZIP Code',
    STATE: 'State'
  },
  ANALYTICS: {
    ABANDONED_CARTS: 'Abandoned Carts',
    ABANDONED_CARTS_ABANDONED: 'Abandoned',
    ABANDONED_CARTS_AVERAGE_ITEMS: 'Average Items per Cart',
    ABANDONED_CARTS_AVERAGE_VALUE: 'Average Cart Value',
    ABANDONED_CARTS_CHART_TITLE: 'Conversion',
    ABANDONED_CARTS_CONVERTED: 'Converted',
    ABANDONED_CARTS_DETAILS_BTN: 'View Details',
    ABANDONED_CARTS_ERROR_DESCRIPTION: 'Error getting abandoned cart data',
    ASOF: 'as of',
    AVERAGESESSION: 'Average Session',
    CARTDETAILS: 'Cart Details',
    CARTID: 'Cart Id',
    CARTS: 'Carts',
    CUSTOMERLABEL: 'Customer',
    DATE_FILTER: 'Data from the',
    DESKTOP: 'Desktop',
    ERRORDESCRIPTION: 'Error getting analytics data',
    ERROR_TITLE: 'Error',
    EXPORTORDERS: 'Export orders',
    EXPORT_ABANDONED_CARTS: 'Export carts',
    GROSSREVENUE: 'Gross Revenue',
    ID: 'ID',
    ITEM: '{{COUNT}} Item',
    ITEMS: '{{COUNT}} Items',
    LAST_24_HOURS: 'last 24 hours',
    LAST_30_DAYS: 'last 30 days',
    LAST_7_DAYS: 'last 7 days',
    LAST_90_DAYS: 'last 90 days',
    MOBILE: 'Mobile',
    NO_ABANDONED_CART_DATA: 'No abandoned cart data to show.',
    NOABANDONEDCARTSDETAIL: 'When a customer adds an item to their cart but has not completed the purchase, you can see it here.',
    NOABANDONEDCARTSTITLE: 'Recover those carts',
    NODATAAVAILABLE: 'No data available',
    NOSALESDATA: 'No sales data to show.',
    NOTRAFFICDATA: 'No traffic data to show.',
    PAGESPERSESSION: 'Pages perSession',
    PERFORMANCE: 'Performance',
    TITLE: 'Analytics',
    TOPDEVICE: 'Top Device',
    TOTALORDERS: 'Total Orders',
    TOTALVISITS: 'Total Visits',
    TRAFFIC: 'Traffic',
    UNIQUEVISITS: 'Unique Visits'
  },
  APPSTORE: {
    MYAPPS: 'My Apps',
    APPLICATION: 'App',
    APPSTORETITLE: 'Integrations',
    APPSTORESUBTITLE: 'Access & install powerful new features to grow your Volusion store.',
    APPACCESS: 'Access & manage all your Volusion apps',
    CONFIRMINSTALLBUTTON: 'Confirm Install',
    CONFIRM_UNINSTALL_BUTTON: 'Confirm Uninstall',
    CONFIRMINSTALLFREEAPPBLURB: 'This is a free application. You will not be charged.',
    CONFIRM_UNINSTALL_APP_BLURB: 'By removing {{APP}}, you will no longer be able to view it in your Volusion admin or access its features.',
    CONFIRMINSTALLFREEAPPWITHPLUSBLURB: 'This is a free application with your Volusion subscription. You will not be charged.',
    CONFIRMINSTALLFREEEXTNBLURB: 'This is a free extension. You will not be charged.',
    CONFIRMINSTALLFREEEXTNWITHPLUSBLURB: 'This is a free extension with your Volusion plus subscription. You will not be charged.',
    APPINSTALLERROR: 'This app is available to our upgraded plans. Check them out here.',
    DESCRIPTION: 'Description',
    DEVELOPER: 'Developer',
    EMAILADDRESS: 'Email',
    EXTENDSAPPS: 'Extend these Apps',
    EXTENSION: 'Extension',
    EXTENSIONINSTALLED: '{{EXTENSION}} was installed successfully.',
    EXTENSIONS: 'Extensions',
    FEATUREDAPPS: 'Featured Apps',
    FEATUREDAPPSSUBTITLE: 'Grow your store with apps',
    FREE: 'Free',
    FREEWITHPLUSPLANLONG: 'Free With Volusion Plus',
    FREEWITHPLUSSHORT: 'Free W/Plus',
    GETSTARTEDTITLE: 'Get Started with our Featured Apps',
    GETSTARTEDSUBTITLE: 'You don\'t have any apps installed yet, check out our recommended apps below',
    INSTALLAPP: 'Install',
    INSTALLED: 'Installed',
    INSTALLEXTENSION: 'Install',
    INSTALLING: 'Installing',
    UNINSTALLING: 'Uninstalling',
    PERMISSIONS: 'APP PERMISSIONS',
    PERMISSIONS_BLURB: 'By installing this app, you allow it to:',
    SUPPORTINFO: 'Support Information',
    TITLE: 'Title',
    UNINSTALL: 'Uninstall',
    VIEWAPPSTORE: 'View App Store',
    VISITMARKETPLACEFORMORE: 'Visit the Marketplace for more',
    WEBSITE: 'Website'
  },
  BADGES: {
    ACTIVE: 'Active',
    PENDING: 'Pending',
    PRIMARY: 'Primary'
  },
  BUTTON: {
    ACCEPT: 'Accept',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    COPY: 'Copy',
    DELETE: 'Remove',
    EDIT: 'Edit',
    ERROR: 'Oops! There was an error. Tryagain.',
    NEXT: 'Next',
    OK: 'OK',
    PLACEORDER: 'Place Order',
    PREVIOUS: 'Previous',
    SAVE: 'Save',
    SAVECREATENEW: 'Save & create new',
    SAVERETURNLIST: 'Save & return to list',
    SAVESTAY: 'Save & stay',
    SHIPORDER: 'Ship& Complete',
    STOREFRONTCACHE: 'Storefront Cache Refresh',
    STOREFRONTPREVIEW: 'Storefront Preview',
    SUCCESS: 'Success'
  },
  CANCELACCOUNT: {
    CANCELBUTTON: 'Keep my store',
    CANCELLINGLOADING: 'Deleting store',
    CANCELLINGTITLE: 'Peace out!',
    DESCRIPTION: 'Goodbyes are always tough, especially when there\'s so much left unsaid. Please take a moment to share your thoughts so we can improve.',
    FEEDBACKPLACEHOLDER: 'What can we do better?',
    IUNDERSTAND: 'I understand I will lose access to any data in my store.',
    OKBUTTON: 'Delete my store',
    THANKSFORTRYINGOUTMSG: 'Thank you for trying out Volusion. We will redirect you to our website once your store is deleted.',
    TITLE: 'Say itain\'t so!'
  },
  CANCEL_STORE: {
    TITLE: 'Cancel Store',
    HEADER: 'Cancel Store',
    INFO_1: 'To cancel your store, give us a ring at <a href="tel:1-888-997-0994">1-888-997-0994</a> between 9am and 6pm CST.',
    INFO_2: 'Phone and Chat are available during business hours of 9am-6pm.',
    ACTION_HEADER: 'You can also',
    ACTION_SCHEDULE: 'Schedule a Call',
    ACTION_CHAT: 'Chat With Us'
  },
  CATEGORY: {
    ADD: 'Add a Category',
    ADDPRODUCT: 'Select a Product',
    CATEGORIES: 'Categories',
    PARENT_CATEGORY: 'Parent Category',
    CATEGORY_TITLE: 'Category Title',
    CREATENEW: 'Create a new category',
    CREATE_BUTTON_LABEL: 'Create Category',
    DELETE: 'Remove this category?',
    EDIT: 'Update Category',
    ERROR_SAVE: 'Error saving category. Ensure page URL is not already in use.',
    HIDECATEGORY: 'Hide This Category',
    INACTIVE: 'Hidden',
    MENUSWARNING: 'Will be removed from {{COUNT}} menus',
    MENUWARNING: 'Will be removed from {{COUNT}} menu',
    PRODUCTSWARNING: 'Will be removed from {{COUNT}} products',
    PRODUCTWARNING: 'Will be removed from {{COUNT}} product',
    SHOWCATEGORY: 'Show This Category',
    SUBCATEGORYWARNING: '{{COUNT}} subcategories will be removed'
  },
  CHANGEPLAN: {
    CHANGEPLAN: 'Change Your Plan',
    ERROR_DESCRIPTION: 'There was an error changing your plan',
    ERROR_TITLE: 'Error changing plan'
  },
  CHAT: {
    DESCRIPTION: 'What better way to offer help than through a quick chat on your website? It’s way faster than email and more efficient than phone. Don’t make your customers wait.',
    HEADING: 'The fastest way to help your customers.',
    LINK: 'How do I set this up?',
    TITLE: 'Live Chat',
    SIGNUP: 'Sign up for free',
    SIGNIN: 'Sign in with',
    DONTHAVE: 'Don\'t have a LiveChat account?',
    DASHBOARD: 'Live Chat Dashboard',
    DISCONNECT: 'Disconnect my account'
  },
  CHECKOUT: {
    BEENHEREBEFORE: 'Been here before?',
    CHOOSEMOREOPTIONS: 'Choose more options',
    CLICKTOCREATEACCOUNT: 'Click here to create an account.',
    CREATEACCOUNT: 'Create an account and add a payment method.',
    IHAVEANACCOUNT: 'I have an account.',
    LASTSTEP: 'Last step, {{FIRST_NAME}}!',
    NOPEFIRSTTIME: 'Nope, this is my first time!',
    NOTYOU: 'Not {{FIRST_NAME}}?',
    READYTOGO: 'We\'re ready to go!',
    SUCCESSISASTEPAWAY: 'Success is a step away.',
    THANKYOU: 'Thank you, {{FIRST_NAME}}.',
    WELCOMEBACK: 'Hey, welcome back, {{FIRST_NAME}}!',
    YESIHAVEANACCOUNT: 'Yes, I have an account.'
  },
  CHECKOUTCONTACTINFO: {
    CONTACTINFO: 'Contact Information',
    PAYMENTMETHOD: 'Payment Method'
  },
  CHECKOUTHELP: {
    CHATNOW: 'Chat online now',
    NEEDHELP: 'Need help or have something to ask? You can contact us 24/7.',
    PHONENUMBER: '1-800-646-3517',
    QUESTIONS: 'Questions?'
  },
  CHECKOUTINFO: {
    ALWAYSAVAILABLE: 'With Volusion you’ll have 24/7 access to our Austin-based support staff. We are always available to help you out!',
    HERETOHELP: 'Here to help',
    YOURSUCCESSISOURS: 'Your success is ours.'
  },
  CHECKOUTLOGIN: {
    EMAIL: 'Email',
    PASSWORD: 'Password',
    TITLE: 'Log in to your account'
  },
  CHECKOUTSIGNUP: {
    CANCELCHANGES: 'Cancel changes',
    CARDMESSAGE: 'This card will be charged for all recurring charges and will be linked to your store for any future purchases.',
    CONTACTINFO: 'Contact Information',
    COUPON_APPLY: 'Apply',
    COUPON_CLEAR: 'Clear',
    COUPON_INPUT_LABEL: 'Promo Code',
    COUPON_NOT_VALID: 'Promo code not valid. Note that most are case sensitive and require proper mix of upper and lower case.',
    CREATEYOURACCOUNT: 'Create your account',
    ENTEREMAILPASSWORD: 'Enter your email address and a password you’ll use to log in to your store.',
    HAVE_A_COUPON: 'Have a promo code?',
    PAYMENTMETHOD: 'Payment Method'
  },
  CHECKOUTTHANKYOU: {
    CONTINUEBUTTON: 'Success awaits'
  },
  CONFIGUREAPPLEPAY: {
    DISABLE_CONFIRM_CANCEL: 'Cancel',
    DISABLE_CONFIRM_DESCRIPTION: 'Disabling will remove the ability for your customers to place orders via Apple Pay. You can re-enable Apple Pay at any time.',
    DISABLE_CONFIRM_OK: 'Disable',
    DISABLE_CONFIRM_TITLE: 'Are you sure?'
  },
  CONFIGUREPAYPAL: {
    ACP_STATUS: 'Advanced Card Processing',
    CANCEL_BUTTON: 'Cancel',
    CANCEL_CONFIRM_CANCEL: 'Cancel',
    CANCEL_CONFIRM_DESCRIPTION: 'Cancelling this verification will take you back to the beginning of PayPal setup.',
    CANCEL_CONFIRM_OK: 'Continue',
    CANCEL_CONFIRM_TITLE: 'Are you sure?',
    CONNECT_BUTTON: 'Connect account',
    CONNECT_DISABLED_STEP_DESCRIPTION: 'Your shoppers cannot pay with PayPal on your Volusion store right now. Enable PayPal to offer PayPal payments. Once enabled you must connect your store to a new or existing PayPal Account to collect funds.',
    CONNECT_STEP_DESCRIPTION: 'Your shoppers can pay with PayPal on your Volusion store right now, but to collect the funds you must connect your store to a new or existing PayPal Account.',
    CONNECT_STEP_TITLE: 'Connect to PayPal',
    CONNECT_RETRY: 'Unable to connect PayPal account, please try again and make sure to grant the proper permissions.',
    CONNECTED_DESCRIPTION: 'Your Volusion store and PayPal account are connected! You can now process your PayPal Orders and collect funds.',
    CONNECTED_NOTIFICATION: 'PayPal successully connected!',
    CONNECTED_TITLE: 'Account Connected',
    CONNECTED_PAYPAL_CONTACT: 'Please contact PayPal if you have any questions.',
    CONNECTED_LIMIT_REACHED: 'You have reached your Limit Amount. Advanced Card Processing has been disabled.',
    PREFILL_ERROR_TITLE: 'Unable to complete PayPal connection',
    PREFILL_ERROR_DESCRIPTION: 'Sorry, something went wrong. You cannot connect to PayPal at this time. Please try again later.',
    DISABLE_CONFIRM_CANCEL: 'Cancel',
    DISABLE_CONFIRM_DESCRIPTION: 'Disabling will remove the ability for your customers to place orders via PayPal. You can re-enable PayPal at any time.',
    DISABLE_CONFIRM_OK: 'Disable',
    DISABLE_CONFIRM_TITLE: 'Are you sure?',
    DISABLED: 'PayPal disabled',
    DISABLED_CONNECTED: 'Your shoppers cannot pay with PayPal on your Volusion store right now. Enable PayPal to offer PayPal payments.',
    DISCONNECT_BUTTON: 'Disconnect',
    DISCONNECT_CONFIRM_CANCEL: 'Cancel',
    DISCONNECT_CONFIRM_DESCRIPTION: 'Disconnecting will remove the ability to process transactions via PayPal. To remove PayPal from your checkout page, please disable with the toggle switch.',
    DISCONNECT_CONFIRM_OK: 'Disconnect',
    DISCONNECT_CONFIRM_TITLE: 'Are you sure?',
    DISCONNECTED_NOTIFICATION: 'PayPal successully disconnected!',
    DISCONNECTING: 'Disconnecting',
    ENABLED: 'PayPal enabled',
    LEARN_MORE: 'Learn more about PayPal',
    MERCHANT_PAYER_ID: 'PayPal Merchant Payer ID',
    PAY_IN_FOUR_ENABLED: 'Pay Later Messaging enabled',
    PAY_IN_FOUR_DISABLED: 'Pay Later Messaging disabled',
    PAY_IN_FOUR_DISABLE_DESCRIPTION: 'Disabling will remove the Pay Later Messaging from checkout',
    RETURN_ERROR_TITLE: 'Error Connecting PayPal',
    RETURN_ERROR_DESCRIPTION: 'Sorry, something went wrong connecting PayPal to your store. Please try again.',
    UPGRADE_BUTTON: 'Upgrade account',
    VERIFY_DISABLED_STEP_DESCRIPTION: 'Your shoppers cannot pay with PayPal on your Volusion store right now. Enable PayPal to offer PayPal payments. Once enabled you must confirm your PayPal account email address. <a href="https://www.paypal.com/signin?returnUri=%2Factivation%2FbusinessSetup" target="_blank">Review your PayPal account</a> to learn more.',
    VERIFY_STEP_DESCRIPTION: 'To complete your connection, please confirm your PayPal account email address. <a href="https://www.paypal.com/signin?returnUri=%2Factivation%2FbusinessSetup" target="_blank">Review your PayPal account</a> to learn more.',
    VERIFY_STEP_TITLE: 'Verify with PayPal',
    VERIFY_ACCOUNT_LIMITED: 'Your PayPal Account has been limited by PayPal. Please check your PayPal account inbox for an email to determine the next steps for this.'
  },
  VOLUSION_PAYMENTS: {
    ACTIVATED_STEP_TITLE: 'Volusion Payments Activated',
    COMPLETE_STEP_TITLE: 'Account Setup Complete',
    EMAIL_CONFIRMATION_MODAL_HEADING: 'Check your email!',
    EMAIL_CONFIRMATION_DONE_BUTTON: 'Okay, sounds great!',
    FINISH_PAYMENTS_SETUP_BUTTON: 'Finish Volusion payments setup',
    LOGO_ALT: 'Volusion Payments',
    SELLING_POINT_1: 'Instantly accept credit card payments',
    SELLING_POINT_2: 'No monthly cost or hidden fees',
    SELLING_POINT_3: 'Automated daily payouts',
    VERIFICATION_INSTRUCTION: 'Please click the link in the email to finish your Volusion Payments account setup so you can start getting paid!',
    VERIFICATION_SENT_TO: 'We\'ve sent a verification email to:',
    VERIFY_STEP_DESCRIPTION: 'Simply provide us with additional details, and before you know it, we\'ll be transferring money directly into your bank account.',
    VERIFY_STEP_TITLE: 'Ready to get paid?'
  },
  CUSTOMDOMAIN: {
    ADD: 'Add',
    ADD_PLACEHOLDER: 'example.com',
    CREATEINPROGRESS_DESCRIPTION: 'Your custom domain request is being processed.',
    CUSTOMDOMAIN: 'Custom Domain',
    CREATE_FAILEDERROR: 'Domain creation failed. Please make sure you own the domain <strong>{{CUSTOM_DOMAIN}}</strong>.',
    DELETE_FAILEDERROR: 'Domain removal failed.',
    DELETEINPROGRESS_DESCRIPTION: 'Your request to remove your custom domain is being processed.',
    DOMAIN_NOT_REGISTEREDERROR: 'The domain name <strong>{{CUSTOM_DOMAIN}}</strong> is not yet registered, you must first register the domain name with any ICANN-accredited registrar. For more information on using a custom domain with Volusion see <a class="link" href="{{ \'CUSTOMDOMAIN.NAMESERVER_HELPLINK_URL\' | translate }}" target="_blank">here</a>',
    DOMAIN_ALREADY_REGISTEREDERROR: 'The domain <strong>{{CUSTOM_DOMAIN}}</strong> is in use on another store. Each store must have a unique domain name.',
    DOMAIN_REGISTRATION_FAILEDERROR: 'Domain already exists.',
    ERROR_DESCRIPTION: 'Failed to add custom domain.',
    ERROR_OK: 'Ok',
    ERROR_TITLE: 'Error',
    ETC: 'This process could take up to 30 minutes to complete.',
    HTTPS_REDIRECT_FAILEDERROR: 'HTTPS setup failed.',
    INPROGRESS: 'In Progress',
    NAMESERVER_COLLAPSE: 'Collapse',
    NAMESERVER_DNS: 'DNS',
    NAMESERVER_EXPAND: 'Expand',
    NAMESERVER_HELP: 'Next, you need to update your Domain Name Servers (DNS) through the company you purchased your domain from.',
    NAMESERVER_HELPLINK_TEXT: 'Read our helpful support article on how to do this.',
    NAMESERVER_HELPLINK_URL: 'https://help.volusion.com/launch-your-business/store-info-store-name-domains',
    NAMESERVER_RECORD: 'Record',
    NAMESERVER_REQUIREDDATA: 'Required Data',
    NAMESERVER_TITLE: 'Nameserver Update Info',
    OWNADOMAIN: 'Already own a domain?',
    REFRESH: 'Refresh',
    REMOVE: 'Remove',
    REMOVECONFIRM_CANCEL: 'Keep Domain',
    REMOVECONFIRM_DESCRIPTION: 'Your new domain name will be',
    REMOVECONFIRM_OK: 'Remove Domain',
    REMOVECONFIRM_TITLE: 'Remove custom domain?',
    UPGRADETEXTV2: 'Upgrade to Volusion Plus to add a custom domain and add unlimited products!',
    VALIDATIONERROR: 'Valid domain name required (e.g. mydomain.com)'
  },
  CUSTOMER: {
    ADD: 'Add Customer',
    AVG: 'avg',
    CUSTOMERS: 'customers',
    EXPORTCUSTOMERS: 'Export Customers',
    IMPORT_CUSTOMERS_MENU: 'Import Customers',
    LASTORDER: 'Last Order',
    NEW30DAYS: 'New In Last 30 Days',
    NOCUSTOMERS: 'No customers were found.',
    ORDERS: 'Orders',
    PHONE: 'Phone Number',
    PRIMARYBILLING: 'Primary Billing',
    PRIMARYSHIPPING: 'Primary Shipping',
    SAMEADDRESS: 'same as shipping',
    SELECTEDPLURAL: '{{ITEMS}} Items selected',
    SELECTEDSINGLE: '{{ITEMS}} Item selected',
    TOTALCUSTOMERS: 'Total Customers',
    VALUE: 'Value',
    CUSTOMER_DETAILS_TITLE: 'Customer details',
    CUSTOMER_DETAILS_TITLE_SHORT: 'Customer'
  },
  DISCOUNTADD: {
    AND: 'and',
    ANDAPPLYITTO: 'and apply it to',
    AT_CHECKOUT: 'at checkout.',
    CHAR_MAX: '20 Character Max',
    COMMA: ',',
    CREATETHISDISCOUNT: 'Create this discount',
    DAYS: 'days',
    DISCOUNT: 'discount',
    DOLLAR: 'dollar',
    DOLLARSIGN: '$',
    HAVE_LIMIT: 'have a limit of',
    HAVE_A_LIMITED_DURATION: 'have a limited duration',
    HAVE_A_LIMITED_DURATION_PUNCTUATED: 'have a limited duration.',
    IWANTTOOFFERA: 'I want to offer a',
    MONTHS: 'months',
    MYENTIRESTORE: 'my entire store',
    NAME_HELP: 'which will be displayed at checkout.',
    NO_CODE: 'require a code at checkout.',
    OF: 'of',
    PERCENT: 'percent',
    PERCENT_SYMBOL: '%',
    PERIOD: '.',
    REQUIRE_CODE: 'require the code',
    SELECTCATEGORIESPRODUCTS: 'Select categories/products...',
    SPACEOF: 'of',
    THEDISCOUNT: 'The discount',
    THE_DISCOUNT_WILL_BE_NAMED: 'The discount will be named',
    TITLE: 'Add Discount',
    USES: 'uses',
    WILL: 'will',
    WILLNOT: 'will not'
  },
  DISCOUNTEDIT: {
    ACTIVATE: 'Active',
    ACTIVATEYOURDISCOUNT: 'Please activate your discount to be used in checkout.',
    APPLYTOENTIRESTORE: 'Apply discount to entire store',
    DOLLARS: 'Dollars ($)',
    DURATION: 'Duration',
    DURATIONDESCRIPTION: 'Select the start and end times for the discount.',
    ENDED: 'Ended',
    ENDS: 'Ends',
    ERROR_DELETE: 'There was a problem deleting this discount.',
    ERROR_SAVING: 'There was a problem saving this discount. Please check the quantities in the Rules card.',
    ERROR_TITLE: 'Error',
    MAX: 'maximum',
    MAX_LIMIT: 'Limit discount to',
    MIN: 'minimum',
    MINIMUM_QUANTITY: 'Minimum Quantity',
    NOORDERS: 'No orders have been placed with this discount.',
    ORDERMETRICS: 'This discount has been used for <a href="order/list?search=discount:{{code}}" class="discount-card__orders-link" id="discount-details_filter-orders_link">{{ orderCount }} orders</a>, totaling {{ totalOrderAmount | currency }}. Shoppers using this discount have saved a total of {{ totalDiscountAmount | currency }}, with an average of {{ (totalDiscountAmount / orderCount) | currency }} saved per order.',
    PERCENT: 'Percent (%)',
    PERIOD: '.',
    QUANTITY: 'quantity',
    REQUIRES: 'Discount requires a',
    REQUIRES_CODE: 'Discount requires code',
    RULES: 'Rules',
    RULES_DESCRIPTION: 'These conditions must be met to apply this discount.',
    SCOPE: 'Scope',
    SCOPE_CHANGE_ALERT: 'You will not be able to apply a minimum quantity requirement to more than one product.',
    SELECT_SHORT: 'Selected product/categories',
    SELECTTHECATEGORIESPRODUCTS: 'Select the categories and/or products to which you\'d like to apply the discount.',
    SINGLE_ORDERMETRIC: 'This discount has been used for <a href="order/list?search=discount:{{code}}" class="discount-card__orders-link" id="discount-details_filter-orders_link">{{ orderCount }} order</a>, totaling {{ totalOrderAmount | currency }}. The shopper using this discount has saved {{ (totalDiscountAmount / orderCount) | currency }}.',
    STARTS: 'Starts',
    STATUS: 'Status',
    TITLE: 'Discount Details',
    TOTALPRODUCTSDISCOUNTED: 'Total products discounted:',
    USAGE: 'Usage Limits',
    USAGE_DESCRIPTION: 'Restrict the number of times this discount can be used at checkout.',
    USAGESTATUS: 'Remaining uses:',
    USE_AMBIGUOUS: 'use(s)',
    USE_PLURAL: 'uses',
    USE_SINGULAR: 'use'
  },
  DISCOUNTFIELDS: {
    CODE: 'Code',
    DISCOUNTTYPE: 'Discount type',
    DURATION: 'Duration',
    DURATIONLENGTH: 'Duration length',
    DURATIONUNITS: 'Duration units',
    ERROR_CODE_REQUIRED: 'Discount code is required',
    ERROR_CODE_TAKEN: 'Discount code is already taken',
    ERROR_DURATION_MAX: 'Duration cannot be greater than 1000',
    ERROR_DURATION_MIN: 'Duration must be greater than 0',
    ERROR_DURATION_REQUIRED: 'Duration length is required',
    ERROR_ENDDATE_FORMAT: 'Invalid format',
    ERROR_ENDDATE_MINDATE: 'Min date',
    ERROR_ENDDATE_REQUIRED: 'This is required',
    ERROR_FIXEDREDUCTION_MIN: 'Price reduction must be greater than 0',
    ERROR_FIXEDREDUCTION_REQUIRED: 'Price reduction amount is required',
    ERROR_INVALID_MAX_QUANTITY: 'Must be greater than the minimumquantity',
    ERROR_INVALID_MAX_QUANTITY_GT_ZERO: 'Maximum quantity must be greater than 0',
    ERROR_INVALID_MIN_QUANTITY: 'Minimum quantity must be greater than 1',
    ERROR_INVALID_MIN_QUANTITY_LTE_MAX: 'Minimum quantity must be less than or equal to the maximum quantity',
    ERROR_NAME_REQUIRED: 'Discount name is required',
    ERROR_PERCENTREDUCTION_MAX: 'Percentage cannot be greater than 100',
    ERROR_PERCENTREDUCTION_MIN: 'Price reduction must be greater than 0',
    ERROR_PERCENTREDUCTION_REQUIRED: 'Price reduction amount is required',
    ERROR_STARTDATE_FORMAT: 'Invalid format',
    ERROR_STARTDATE_MINDATE: 'Min date',
    ERROR_STARTDATE_REQUIRED: 'This is required',
    ERROR_USAGELIMIT_MAX: 'Usage limit must be less than 9,999,999',
    ERROR_USAGELIMIT_MIN: 'Usage limit must be greater than 1',
    ERROR_USAGELIMIT_REQUIRED: 'Usage limit is required',
    ERROR_USAGESCOPE_REQUIRED: 'Usage scope is required',
    LIMIT_TOTAL_USES: 'Limit total number of uses',
    LIMIT_CUSTOMER_USES: 'Limit number of uses per customer',
    MIN_QUANTITY: 'Minimum quantity',
    MIN_QUANTITY_REQUIRED: 'Minimum quantity required',
    NAME: 'Name',
    PRICEREDUCTION: 'Price reduction',
    SCOPE: 'Scope',
    STATUS: 'Status',
    UNLIMITEDDURATION: 'Unlimited duration',
    USAGE: 'Usage',
    USAGE_LIMIT_TOTAL: 'Total usage limit',
    USAGE_LIMIT_CUSTOMER: 'Per customer limit',
    VALUE: 'Value'
  },
  DISCOUNTLIST: {
    ACTIVEDISCOUNTS: 'Active Discounts',
    ADD: 'Add Discount',
    ALLDISCOUNTS: 'All Discounts',
    INACTIVEDISCOUNTS: 'Disabled Discounts',
    NODISCOUNTS: 'No discounts found.',
    SELECTEDPLURAL: '{{ITEMS}} Items selected',
    SELECTEDSINGLE: '{{ITEMS}} Item selected',
    TITLE: 'Discounts',
    TOTALAMOUNTSAVEDMETRICLABEL: 'Total Amount Saved',
    TOTALDISCOUNTSMETRICLABEL: 'Total Discounts',
    TOTALUSESMETRICLABEL: 'Total Number of Uses',
    WILLAPPEAR: 'Click + to start adding discounts.'
  },
  EDITSTORECONTENT: {
    404: '404',
    ADD: 'Add Item',
    ALT: 'Alt',
    CANCEL: 'Cancel',
    CATEGORY: 'Category',
    DELETE: 'Clear',
    EDIT: 'Edit',
    FACEBOOK: 'Facebook URL',
    GOOGLE: 'Google+ URL',
    HOME: 'Home',
    INSTAGRAM: 'Instagram URL',
    LASTUPDATED: 'Last updated',
    LINK: 'Link',
    LINKTO: 'Link to',
    LINKURL: 'Link URL',
    MENUSEMPTYTEXT: 'Add a category, product, page or custom link to your menu. To rearrange the order, just drag and drop the item.',
    MENUSEMPTYTITLE: 'Your menu is empty!',
    NEWITEMLABEL: 'Link Text',
    NOMATCHES: 'No matches found.',
    NOSETTINGSFORPAGE: 'No settings for current page',
    OUTOFDATEURL: 'The resource you have linked to has changed or moved.',
    PAGE: 'Page',
    PINTEREST: 'Pinterest URL',
    PRODUCT: 'Product',
    SAVE: 'Save',
    SEARCHRESULTS: 'Search results',
    SELECTPAGE: 'Select a page',
    SOCIAL: 'Social',
    STORENAME: 'Store Name',
    TITLE: 'Content',
    TWITTER: 'Twitter URL',
    UNSAVEDCHANGESCONTENT: 'Save your changes?',
    UNSAVEDCHANGESDONTSAVE: 'Don\'t save',
    UNSAVEDCHANGESSAVE: 'Save',
    UNSAVEDCHANGESTITLE: 'Unsaved Changes',
    URL: 'External URL'
  },
  EDITSTORELANDING: {
    CONTENT: 'Content',
    CONTENTDESCRIPTION: 'Customize your theme’s text, images and settings.',
    LOGO: 'Logo',
    LOGODESCRIPTION: 'Update your store name and logo.',
    MENU: 'Menu',
    MENUDESCRIPTION: 'Update your store\'s navigation menu.',
    STYLES: 'Styles',
    STYLESDESCRIPTION: 'Update colors and fonts, or even add your own custom CSS!',
    THEMES: 'Themes',
    THEMESDESCRIPTION: 'Update your active theme, or visit the Theme Store to check out more options.'
  },
  ERROR: {
    ADDRESSREQUIRED: 'Address is required',
    COUNTRY_REQUIRED: 'Country is required',
    CSVVALIDATION: 'File must be a .csv',
    CSVVALIDATIONSIZE: 'File too large, must be less than {{max}}.',
    DISCOUNTCREATION: 'There was an error creating the discount',
    DOMAINAMEINVALID: 'Subdomains must be less than 64 characters and may contain only letters, numbers, and dashes (-), but cannot start or end with a dash',
    DOMAINAMEREQUIRED: 'Domain name is required',
    DOMAINAMETAKEN: 'Domain name taken',
    EMAILPATTERN: 'A valid email is required',
    EMAILREQUIRED: 'Email is required',
    FIRSTREQUIRED: 'First name is required',
    GENERAL_DESCRIPTION: 'Sorry, something went wrong. Please try again.',
    GENERAL_FAILURE_ERROR: 'Sorry, something went wrong. Please contact Volusion Customer Service.',
    GENERAL_MISSING_REQUIRED_DATA: 'Sorry, some required data is missing. Please review.',
    GENERAL_OK_BUTTON: 'Ok',
    GENERAL_TITLE: 'This is embarrassing.',
    IMAGELIMITREACHED: 'You have reached the image upload limit.',
    IMAGEVALIDATION: 'Images must be a valid type (.jpg, .jpeg, .png, .gif) and under 5mb.',
    INVALID_PRODUCT: 'Product is invalid.',
    INVENTORY_QUANTITY_MAX: 'Quantity must be less than {{MAX_VALUE}}',
    INVENTORY_QUANTITY_MIN: 'Quantity must be greater than {{MIN_VALUE}}',
    INVENTORY_START_QUANTITY_REQUIRED: 'Starting quantity is required',
    INVENTORY_UPDATE_QUANTITY_REQUIRED: 'Quantity is required',
    NAMEMAXLENGTH: 'name must be less than {{COUNT}} characters',
    NAMEREQUIRED: 'Name is required',
    PAGETITLEREQUIRED: 'Page title is required',
    PRICEREQUIRED: 'Price is required',
    SALE_PRICE_BY_PRICE: 'Sale price cannot be greater than regular price',
    SKUREQUIRED: 'SKU is required',
    STATE_REQUIRED: '{{PROVINCE_TYPE}} is required',
    USZIP: 'A valid ZIP code is required',
    VALIDPHONE: 'Please enter a valid phone number',
    VARIANT_DUPLICATE_SKU_CONFLICT: 'Sorry, a duplicate variant SKU already exists in another product.  Please review and update the variants section below before saving.',
    VARIANTNAMEREQUIRED: 'Variant name is required',
    VARIANTVALUESREQUIRED: 'Variant values are required',
    WEIGHTRANGE: 'Weight must be between 0 and 1000 inclusive',
    YOUTUBEEMBED: 'must be valid youtube url',
    ZIPREQUIRED: 'ZIP code is required'
  },
  ERRORPAGE: {
    LOGOUT: 'Logout',
    MESSAGE: 'Something went wrong on our end.',
    REFRESH: 'Refresh',
    SESSIONTIMEOUT: 'For your security, you have been logged out due to inactivity',
    STATUSPAGE: 'View Status Page',
    TITLE: 'Whoops!'
  },
  FACEBOOKPIXEL: {
    DESCRIPTION: 'The Facebook pixel is an analytics tool that allows you to measure the effectiveness of your advertising by understanding the actions people take on your website.',
    HEADING: 'Measure the results of your ads by using Facebook Pixel',
    INPUT_LABEL: 'Facebook Pixel Tracking ID',
    INPUT_PLACEHOLDER: 'Paste Pixel ID here',
    LINK: 'How do I set this up?',
    TITLE: 'Facebook Pixel'
  },
  FRAUD: {
    AVS_CHECK: 'AVS Check',
    AVS_CHECK_FAILED: 'AVS check failed',
    AVS_CHECK_UNAVAILABLE: 'AVS check unavailable',
    AVS_DESCRIPTION: 'Address Verification System (AVS) is used to verify the address of a person claiming to own a credit card. It is comprised of a ZIP code check and a street address check. Gift cards may result in failed AVS checks.',
    AVS_VALUE_UNAVAILABLE: 'Unavailable',
    AVS_ZIP_CHECK_NO: 'Zip code not verified',
    AVS_ZIP_CHECK_YES: 'Zip code verified',
    AVS_ADDRESS_LINE1_CHECK_NO: 'Address not verified',
    AVS_ADDRESS_LINE1_CHECK_YES: 'Address verified',
    BILL_SHIP_MISMATCH: 'Billing and Shipping address mismatch',
    CVC_CHECK_FAILED: 'CVC check failed',
    CVC_CHECK_UNAVAILABLE: 'CVC check unavailable'
  },
  FULFILLEREDIT: {
    CONTACT: 'Contact Information',
    EMAILDESCRIPTION: 'Enter the fulfillment service\'s contact information for quick access when fulfilling orders.',
    METHOD: 'Fulfillment Method',
    METHODDESCRIPTION: 'Select how this service will handle ordered items as they are fulfilled.',
    METHODEMAILDESCRIPTION: 'An email summarizing the ordered items will be sent to the service via the order email address. Label purchasing is disabled.',
    METHODEMAILHEADING: 'Automated Email',
    METHODMANUALDESCRIPTION: 'Use this method to manually separate the ordered items from the local inventory. You will be able to purchase a shipping label for these items.',
    METHODMANUALHEADING: 'Manual',
    NO_PRODUCTS: 'No products',
    OPTIONAL: '(optional)',
    PRODUCT: 'Product',
    PRODUCTDESCRIPTION: 'These are the products in your store associated with this fulfillment service. You can add the products to the service manually here, or within the product details page of any individual product.',
    PRODUCTHEADING: 'Serviced Products',
    PRODUCTS: 'Products',
    SUMMARY_PRICE_HEADING: 'Price',
    SUMMARY_PRODUCT_HEADING: 'Product Name',
    TITLE: 'Update Fulfillment Service'
  },
  FULFILLERFIELDS: {
    EMAIL_CONTACT: 'Email address (for contacting)',
    EMAIL_ORDER: 'Email address (for order submission)',
    ERROR_NAME_REQUIRED: 'Fulfillment Service name is required',
    HASADDRESS: 'This fulfillment service has a physical address',
    ITEMS_NUMBER_LABEL: '# of Items',
    METHOD_LABEL: 'Fulfillment Method',
    NAME: 'Name',
    NAME_LABEL: 'Service Name',
    PHONE: 'Phone number',
    TYPE_LABEL: 'Service Type'
  },
  FULFILLERLIST: {
    ADD: 'Add Service',
    ALLFULFILLERS: 'All Services',
    APPFULFILLERS: 'App',
    CUSTOMFULFILLERS: 'Custom',
    CUSTOMSERVICE: 'Custom Fulfillment Service',
    CUSTOMSERVICEBUTTON: 'Create Custom Service',
    CUSTOMSERVICEDESCRIPTION: 'Create acustom service that can send an email with the order details to a specified email address.',
    LANDINGDESCRIPTION: 'Fulfillment services are warehouses and drop shipping providers who can prepare and ship your orders. If you\'ve grown beyond your capabilities and can\'t ship your orders, or you just don\'t want to deal with shipping at all, try these services or create your own.',
    LANDINGHEADING: 'Add and manage your order fulfillment services',
    NOFULFILLERS: 'No fulfillment Services found.',
    SELECTEDPLURAL: '{{ITEMS}}Items selected',
    SELECTEDSINGLE: '{{ITEMS}} Item selected',
    TITLE: 'Fulfillment Services',
    WILLAPPEAR: 'Click + to start adding Fulfillment Services.'
  },
  FULLSTORY: {
    DESCRIPTION: 'Every click, keypress, page transition and more - automatically recorded so you can play it back and watch a video of how your customers are interacting with your site.',
    ERROR_MESSAGE: 'Looks like you added too much. Just add your Organization ID.',
    HEADING: 'FullStory captures your customer\'s experience using your website.',
    INPUT_LABEL: 'FullStory Organization ID',
    INPUT_PLACEHOLDER: 'Paste Fullstory Organization ID here',
    LINK: 'How do I set this up?',
    REQUIRED: 'A Fullstory Organization ID is required.',
    TITLE: 'Fullstory'
  },
  GETTING_STARTED: {
    EMAIL_VERIFIED_COMPLETE: 'Your email is verified',
    HEADLINE: 'Get Started',
    PHONE_NUMBER: 'tel:8775102334',
    SAVE_STORE_NAME: 'Save store name',
    SECTION_ADD_PRODUCTS_TITLE: 'Add some products',
    SECTION_CHOOSE_THEME_TITLE: 'Choose a new theme design',
    SECTION_CONFIGURE_SETTINGS_TITLE: 'Configure your store settings',
    SECTION_HERE_TO_HELP_TITLE: 'We\'re here to help!',
    SECTION_STORE_NAME_TITLE: 'Name your Volusion store',
    SECTION_TRIAL_STARTED_TITLE: 'Start your free trial',
    SECTION_VIEW_STOREFRONT_TITLE: 'Check out your storefront',
    STORE_NAME_SAVED: 'Updated store name',
    SUBHEADING: 'Volusion\'s simple store setup.',
    TASK_CALL: 'Call us (877) 510-2334',
    TASK_CHAT: 'Chat with an expert now',
    TASK_GO_TO_SETTINGS: 'Go to Settings',
    TASK_GO_TO_THEMES: 'Go to Theme Store',
    TASK_NAME_STORE: 'Set your store\'s name',
    TASK_VIEW_STOREFRONT: 'View Storefront',
    UPDATING_STORE_NAME: 'Updating Store Name'
  },
  GREETING: {
    HAPPENINGTODAY: 'Here’s what’s happening with your store today.',
    FIRSTTIME: 'Welcome back.',
    WELCOME: 'Welcome to Volusion, {{NAME}}',
    WELCOME_GETSTARTED: 'Get started with our simple store setup.',
    GOODAFTERNOON: 'Good afternoon, {{NAME}}.',
    GOODAFTERNOON_NONAME: 'Good afternoon.',
    GOODEVENING: 'Good evening, {{NAME}}.',
    GOODEVENING_NONAME: 'Good evening.',
    GOODMORNING: 'Good morning, {{NAME}}.',
    GOODMORNING_NONAME: 'Good morning.'
  },
  HELP_ACTIONS: {
    CALL: 'Schedule a call',
    CHAT: 'Message us',
    DOCS: 'Help Center'
  },
  IMAGE: {
    ALTTEXT: 'Alt Text',
    DESCRIPTION: 'Description',
    METADATATITLE: 'Image Attributes',
    TITLE: 'Title'
  },
  IMAGELIBRARY: {
    ALLIMAGES: 'All images',
    CANCEL: 'Cancel',
    CLIPBOARDSUCCESS: 'Link copied to clipboard',
    DELETE: 'Delete',
    DELETECONFIRMATION: 'Are you sure you want to delete',
    DELETEMESSAGE: 'This cannot be undone. If in use, the images will no longer appear on your storefront.',
    DELETESUCCESS: 'deleted successfully',
    DISMISS: 'Dismiss',
    IMAGE: 'image',
    IMAGES: 'images',
    IN: 'in',
    IUNDERSTAND: 'I understand',
    MORE: 'More',
    NOIMAGES: 'You don\'t have any images',
    RECENTLYUSED: 'Recently used',
    SELECTALL: 'Select all',
    SELECTED: 'selected',
    SELECTFROMLIBRARY: 'Select from gallery',
    SELECTNONE: 'Select none',
    TITLE: 'Image Gallery',
    TOOLTIPCLIPBOARD: 'Copy image URL to clipboard',
    TOOLTIPDELETE: 'Delete selected images',
    TOOLTIPEDIT: 'Edit image',
    UPLOAD: 'Upload',
    UPLOADLIMIT: 'You have reached the image upload limit.',
    USE: 'Use'
  },
  IMPORTER_MODULE: {
    TITLE: '{{IMPORTER_TYPE}} Importer',
    IMPORT_TYPES: 'Import {{IMPORTER_TYPE}}s',
    CHOOSE_FILE: 'Choose File',
    DRAG_AND_DROP: 'Drag & drop to upload',
    DROP: 'Drop here to select',
    ERROR_DISMISS: 'Dismiss',
    ERROR_VIEW_REPORT: 'View {{IMPORTER_TYPE}} import error report',
    HELP: 'Download our sample CSV to use as a template for importing your new {{IMPORTER_TYPE}}s. If you do not have the required extensions installed, the importer will install them for you.',
    IMPORTING: 'Importing your {{IMPORTER_TYPE}}s...',
    SAMPLE_CSV: 'Download our sample CSV template',
    SUCCESS_IMPORTED: '{{COUNT}} of {{ATTEMPTED}} new {{IMPORTER_TYPE}}s imported.',
    SINGLE_ERROR: 'Unfortunately, we encountered an error while importing:',
    MULTIPLE_ERRORS: 'Unfortunately, we encountered multiple errors while importing:'
  },
  INVENTORY: {
    ADDBUTTONLABEL: 'Add',
    BASEPRODUCTSKU: 'Base Product SKU',
    BASESKU: 'SKU',
    CARDTITLE: 'Inventory',
    INSTRUCTIONS: 'Manage the stock status and SKUs for your products. With the variants extension installed, you can manage each individual variant’s inventory.',
    SETBUTTONLABEL: 'Set',
    STARTQUANTITYLABEL: 'Quantity',
    STARTQUANTITYPLACEHOLDER: 'Starting quantity',
    STARTTRACKING: 'Start Tracking Inventory',
    UPDATEBUTTONLABEL: 'Update',
    UPDATEQUANTITYLABEL: 'Update Quantity',
    UPDATEQUANTITYPLACEHOLDER: 'Update Quantity',
    VARIANTSMESSAGE: 'Product quantities controlled in the variants section'
  },
  INVOICE: {
    AMOUNT: 'Amount',
    BALANCE_DUE: 'Balance Due',
    CANCEL: 'Cancel',
    CARD_CHARGE_MESSAGE: 'Your {{CARDTYPE}} ending in {{LASTFOUR}} will be automatically charged on {{CHARGEDATE}}.',
    CHANGE: 'Change',
    CHARGES: 'Charges',
    CLOSED: 'Closed',
    CONFIRM_AND_PAY: 'Confirm and Pay',
    CONFIRM_PAYMENT: 'Confirm Payment',
    CONFIRM_PAYMENT_DETAILS: 'Please confirm your payment details.',
    CREDIT: 'Credit',
    CREDIT_WILL_BE_APPLIED: 'Your credit will be applied to the next invoice.',
    CURRENCY: '$',
    DATE: 'Date',
    DETAILS: 'Details',
    DISCOUNT: 'Discount',
    DISCOUNTS: 'Discounts',
    DOWNLOAD: 'Download',
    ENDING_IN: 'ending in',
    EXPIRES: 'Expires:',
    FORGIVEN: 'Forgiven',
    INVOICE: 'Invoice',
    INVOICEITEM: 'Subscription',
    INVOICENUMBER: 'Invoice Number',
    INVOICES: 'Billing',
    NOINVOICESHEAD: 'No invoices to display',
    NOINVOICESSUBHEAD: 'Check back after your first invoice is issued.',
    NOTPAIDACCOUNT: 'Balance due will be updated after your first invoice is issued.',
    NUMBER: 'Number',
    PAID: 'Paid',
    PAID_ERROR: 'Sorry, there was an error with your payment.',
    PAID_SUCCESS: 'Payment Successful!',
    PAY_BALANCE_NOW: 'Pay Balance Now',
    PAYMENT_METHOD: 'Payment Method',
    PAYNOW: 'Pay Now',
    PLUSPLAN: 'Plus Plan',
    PLUSPLANURL: '({{URL}})',
    SERVICEPERIOD: 'Service Period',
    SHIPPINGDETAILS: 'Combined postage purchased',
    SHIPPINGITEM: 'Postage',
    STATUS: 'Status',
    TAX: 'Tax',
    TOTAL: 'Total',
    UNPAID: 'Unpaid',
    UNPAID_INVOICE: 'You have one unpaid invoice.',
    UNPAID_INVOICES: 'You have {{UNPAIDCOUNT}} unpaid invoices.',
    UPCOMING: 'Upcoming',
    UPCOMING_NUMBER: '--'
  },
  LABEL: {
    ADDAPP: 'add an app',
    ANALYTICS: 'Analytics',
    AMAZON: 'Amazon',
    APPSTORE: 'Integrations',
    BLOCK_MANAGEMENT: 'Blocks',
    CART: 'Cart',
    CATEGORIES: 'Categories',
    CLOSE_VIDEO: 'Video',
    CREATED: 'Created',
    CURRENCY: '$',
    CUSTOMERNOTE: 'Customer Note',
    CUSTOMERS: 'Customers',
    DELETE: 'Remove',
    DESCRIPTION: 'Description',
    DESKTOPWIDTH: 'Desktop width',
    DISCOUNTS: 'Discounts',
    DUPLICATE: 'duplicate',
    EDITSTORE: 'Store Editor',
    EMAIL: 'Email',
    EXPORT_PRODUCTS: 'Export Products to CSV',
    FACEBOOKPIXEL: 'Facebook Pixel',
    FULFILLERS: 'Fulfillment Services',
    FULLSCREEN: 'Fullscreen',
    FULLSTORY: 'Fullstory',
    GET_STARTED: 'Get Started',
    GOOGLEANALYTICS: 'Google Tracking',
    GRANDTOTAL: 'Grand Total',
    CHAT: 'Live Chat',
    HOME: 'Home',
    ITEMPRICE: 'Item Price',
    ITEMSTOTAL: 'Items total',
    LASTMODIFIED: 'Last Modified',
    MAILCHIMP: 'MailChimp',
    MENU_MANAGEMENT: 'Menu Editor',
    MOBILEWIDTH: 'Mobile width',
    NAME: 'Name',
    OPTIONAL: '(optional)',
    ORDERS: 'Orders',
    PAGES: 'Pages',
    PINTEREST: 'Pinterest',
    PRICE: 'Price',
    PRICEEACH: 'Price Each',
    PRINTIFY: 'Printify',
    PRIVY: 'Privy',
    PRODUCTS: 'Products',
    QTY: 'Qty',
    QUANTITY: 'quantity',
    QUICKBOOKS: 'Quickbooks',
    SAVE: 'Save',
    SHIPPING: 'Shipping',
    SITE_DESIGNER: 'Site Designer',
    STORECREDIT: 'Gift Cards',
    STORESETTINGS: 'Settings',
    SUBTOTAL: 'Subtotal',
    TABLETWIDTH: 'Tablet width',
    TAXES: 'Taxes',
    THEMEPREVIEW: '{{TITLE}} Theme Preview',
    THEMESTORE: 'Theme Store',
    UPDATED: 'Updated',
    USER_PERMISSIONS: 'Users & Permissions',
    VALUE: 'Value',
    WATCH_VIDEO: 'Watch the video',
    XERO: 'XERO',
    YOTPO: 'Yotpo',
    ZAPIER: 'Zapier',
    AVALARA: 'Avalara',
    SITE_TAGGING: 'Site Tagging'
  },
  LEAVE: {
    AREYOUSURE: 'Sure you want to leave?',
    CONTINUE: 'Continue',
    UNSAVEDCHANGES: 'You have unsaved changes.'
  },
  LOGIN: {
    ACCOUNTNOTFOUND: 'No account found',
    CHECKEMAIL: 'Check your email to finish password reset.',
    COOKIESREQUIRED: 'Enable cookies to log in.',
    EMAIL: 'Email Address',
    EMAILREQUIRED: 'Email is required',
    EMAILTAKEN: 'That email is already being used',
    EMAILVALID: 'A valid email is required',
    ERRORRESET: 'Can\'t reset password. Try again later.',
    FIRSTNAME: 'First Name',
    FORGOTPASSWORD: 'Forgot password?',
    HAVEANACCOUNT: 'Have an account?',
    IMPERSONATING: 'Logging you in for concierge session',
    INVALIDLOGIN: 'A valid username or password is required',
    LASTNAME: 'Last Name',
    LOGGINGIN: 'Logging you in',
    LOGIN: 'Log in',
    OR: 'or',
    PASSLENGTH: 'Use more than {{COUNT}} characters',
    PASSREQUIRED: 'Password is required',
    PASSVALID: 'Use 1 lowercase letter, 1 uppercase letter, and either a number or a special character',
    PASSWORD: 'Password',
    PASSWORDRESET: 'Password successfully reset. Log in to continue.',
    RESETPASSWORD: 'Reset Password',
    RESETTINGPASSWORD: 'Resetting password',
    SETTINGUPSTORE: 'Just a moment while we set up your store',
    SETTINGUPSTORESUCCESS: 'Congratulations, your store is ready! Sign in with Google one more time to finalize your account setup.',
    SIGNINWITHGOOGLE: 'Sign In With Google',
    SOCIALLOADING: 'Just a moment',
    TOOMANYATTEMPTS: 'Your account is blocked. Check your email.',
    UNKNOWNSERVERERROR: 'Server Error. Try again later.',
    PASSWORDEXPIRED: 'Your password has expired. Please enter your email below to reset your password.',
    VALIDATED: 'Your email address has been verified.'
  },
  MODAL: {
    CANTUNDO: 'This cannot be undone.',
    DELETE: 'Remove {{COUNT}} {{TYPE}}?',
    DUPLICATE: 'Copy {{COUNT}} {{TYPE}}?'
  },
  MYACCOUNT: {
    CANCEL: 'Cancel',
    CANCEL_MY_STORE: 'Cancel My Store',
    CHANGE: 'Change',
    CHANGEPASSWORD: 'Change password',
    DELETEMYSTORE: 'Delete my store',
    EMAIL: 'Email',
    EMAILREQUIRED: 'Email is required',
    EMAILTAKEN: 'That email is already being used',
    FIRSTNAME: 'First Name',
    LASTNAME: 'Last Name',
    NEWPASSWORD: 'New password',
    OLDPASSWORD: 'Old password',
    PASSWORD: 'Password',
    PASSWORDERROR: 'Can\'t update password. Try again.',
    PASSWORDMATCH: 'Passwords don\'t match',
    PASSWORDREQUIRED: 'Password is required',
    PASSWORDVALID: 'Use 1 lowercase letter, 1 uppercase letter, and either a number or a special character',
    PAYMENTMETHOD: 'Payment Method',
    PLUSFEATURES: 'Custom Domain_Bulk Product Import_Unlimited Products_Unlimited Image Uploads',
    PROFILE: 'Profile',
    REPEATPASSWORD: 'Confirm password',
    TITLE: 'My Account',
    UPDATEAVATAR: 'Update Avatar',
    VALIDEMAIL: 'A valid email is required'
  },
  NOTIFICATION: {
    DISMISS: 'Dismiss',
    ENABLE: 'Turn On',
    NEWORDER: 'New Order from {{STORE}}.',
    NEWORDERNOSTORENAME: 'New Order from Your Store',
    REQUEST: 'Turn on desktop notifications.',
    RESEND: 'Resend',
    RESENT: 'Re-sent',
    THEMEUPDATEMESSAGE: 'Your current theme has an update available!',
    UPDATE: 'Update',
    UPDATENOW: 'Update Now'
  },
  ONBOARDING: {
    ADDPRODUCT_TITLE: 'Add Products',
    CONGRATS_GETSELLING: 'Let\'s Get Selling!',
    CONGRATS_OPEN: 'Your store is now open tothe world!',
    CONGRATS_YOURLIVE: 'Congratulations, you\'re live!',
    LAUNCHSTORE_COMPLETETITLE: 'Store Launched!',
    LAUNCHSTORE_TITLE: 'Launch Store',
    READYTOLAUNCH_DESCRIPTION: 'Since you\'ve completed the required actions, you can launch your store and open it to the world! If you\'re not ready yet, you can come back and launch later.',
    READYTOLAUNCH_TITLE: 'You\'re ready to launch!',
    SECTION_LAUNCH_DESCRIPTION: 'Complete these steps to launch your store.',
    SECTION_LAUNCH_TITLE: 'Launch Status',
    SENDING_VERIFICATION_EMAIL: 'Sending verification email...',
    SENT_VERIFICATION_EMAIL: 'Verification email sent!',
    VERIFICATION_EMAIL_TOAST: 'Re-sent verification email.',
    VERIFYEMAIL_TITLE: 'Verify your email address'
  },
  ORDER: {
    ACCEPT_BULK_PAYMENT: 'You\'re about to accept payment for {{COUNT}} {{TYPE}}.',
    ACCEPT_BULK_PAYMENT_SUCCESS: 'Payment accepted on {{COUNT}} {{TYPE}}.',
    ACCEPT_PAYMENT: 'Accept Payment',
    ADD: 'Add an Order',
    ADDCHARGE: 'Add Charge',
    ADD_INTERNAL_NOTES: 'Add internal notes...',
    ADDPRODUCTS: 'Add Products to Order',
    ADDPROMOCODE: 'Add Promo Code',
    ADDGIFTCARD: 'Add Gift Card',
    ADD_TRACKING: 'Add Tracking Info',
    ADJUSTMENTCHARGE: 'Adjustment Charge',
    ALLORDERS: 'All Orders',
    ALREADY_PAID: '{{COUNT}} {{TYPE}} you selected are already paid. No action will be taken on them.',
    AMOUNT: 'Amount',
    AMOUNTISREQUIRED: 'Amount is required',
    ARCHIVED: 'Archived',
    BILLING: 'Billing',
    BILLING_ADDRESS_UPDATED: 'Billing address updated',
    BILLINGADDRESS: 'Billing Address',
    BILLTO: 'Bill To',
    BROWSE_PRODUCTS: 'Browse Products',
    BULK_PROCESS_CHECKLIST_TRACKING: 'Tracking number added',
    BULK_PROCESS_CHECKLIST_PAYMENT: 'Payment Received',
    BULK_PROCESS_CHECKLIST_SHIPPED: 'Shipping confirmation sent',
    BULK_PROCESS_CHECKLIST_FULFILLED: 'Mark as fulfilled',
    BULK_PROCESS_CHOOSE_FILE: 'Choose File',
    BULK_PROCESS_DRAG_AND_DROP: 'Drag & drop to upload',
    BULK_PROCESS_DROP: 'Drop here to select',
    BULK_PROCESS_ERROR_DESCRIPTION: 'Error Description',
    BULK_PROCESS_ERROR_HEADING: 'We encountered {{COUNT}} {{TYPE}} while importing:',
    BULK_PROCESS_ERROR_REPORT: 'Error Report',
    BULK_PROCESS_HELP: 'This will automatically process many orders at once by updating orders with a tracking number, capture payment, send a shipping confirmation email, and mark the orders as fulfilled.',
    BULK_PROCESS_IMPORTING: 'Importing yourorders...',
    BULK_PROCESS_IMPORT_BUTTON: 'Import Orders',
    BULK_PROCESS_LINE_NUMBER: 'Line #',
    BULK_PROCESS_OR: 'or',
    BULK_PROCESS_ORDERS: 'Bulk Process Orders',
    BULK_PROCESS_REQUIREMENT_1: 'Maximum file size:',
    BULK_PROCESS_REQUIREMENT_1_VALUE: '5MB',
    BULK_PROCESS_REQUIREMENT_2: 'File type:',
    BULK_PROCESS_REQUIREMENT_2_VALUE: 'Comma-separated values (.csv)',
    BULK_PROCESS_RE_UPLOAD_MESSAGE: 'You can re-upload your file once you have corrected those errors.',
    BULK_PROCESS_SAMPLE_CSV: 'Download our sample CSV template',
    BULK_PROCESS_SERVER_ERROR: 'The server responded with an error. Please try again later.',
    BULK_PROCESS_SUCCESS_IMPORTED: '{{COUNT}} of {{ATTEMPTED}} orders were successful.',
    BULK_PROCESS_TITLE: 'Bulk Process Orders',
    BULK_PROCESS_VIEW_REPORT: 'View error report',
    CANCEL: 'Cancel Order',
    CANCELED: 'Canceled',
    CANCELMODAL: 'Cancel Order?',
    CANCELMODALCANCEL: 'Cancel Order',
    CANCELMODALHEADING: 'Confirm Order Cancel',
    CANCELMODALKEEPORDER: 'Keep Order',
    CANCELORDER: 'Cancel Order',
    CARDDECLINED: 'The card was declined.',
    CHARGEERROR: 'Can\'t charge card',
    CHARGEERRORDETAIL: 'Failed to Capture Charge. Authorization Expired.',
    CHARGESUCCESSFUL: 'Payment Captured',
    COMPLETED: 'Completed',
    CONTACTCUSTOMER: 'Contact customer',
    CREATED_DATE: 'Created {{DATE}}',
    CREATE_LABEL: 'Create Shipping Label',
    CREATING_FULFILLMENT: 'Creating fulfillment',
    CUSTOMERCARDPREAMBLE: 'Find an existing customer, or create a new one.',
    CUSTOMERLABEL: 'Customer',
    CUSTOMER_NOTE: 'Customer Note',
    CUSTOMER_PAID: 'Amount customer paid for shipping: {{SHIPPING}}',
    CUSTOMERSEARCHPLACEHOLDER: 'Search customers...',
    CUSTOMSHIPPING: 'Custom shipping cost',
    DATE: 'Order Placed',
    DETAILS: 'Details',
    DISCOUNT: 'Order Discount',
    DISCOUNT_TOTAL: 'Discount Total',
    DISCOUNT_CUSTOM_FIXED: '(CUSTOM {{AMOUNT}})',
    DISCOUNT_CUSTOM_PERCENT: '(CUSTOM {{AMOUNT}}%)',
    DISCOUNTPREAMBLE: 'Enter a promo code, or choose a custom discount amount.',
    DISCOUNTTYPECUSTOM: 'Custom Discount',
    DISCOUNTTYPEPROMOCODE: 'Promo Code',
    EDITORDER: 'Edit Order',
    EDIT_PRICE: 'Edit Price',
    EDIT_PRICE_INSTRUCTION: 'Editing the product price will create a custom discount. The order total will be updated to reflect your changes.',
    ENDINGIN: 'ending in',
    ENTER_NEW_PRICE: 'Enter New Price',
    ERROR_DISMISS: 'Dismiss',
    ESTIMATEDDELIVERY: 'Estimated Delivery:',
    FINISHTOACCEPT: 'Finish your PayPal account setup to accept.',
    FINISHTOSHIP: 'Finish your PayPal account setup to ship.',
    FLAGGED: 'Flagged',
    FULFILL: 'Fulfill',
    FULFILLED: 'Fulfilled',
    FULFILLING_ITEMS: 'Fulfilling Items...',
    FULFILLMENT_METHOD: 'Fulfillment Method',
    FULFILLMENT_NO_QTY: 'No Fulfillment Qty',
    FULFILLMENT_NUMBER: 'Fulfillment #{{NUMBER}}',
    FULFILLMENT_PARTIAL: 'Partial Fulfillment',
    FULFILLMENT_SERVICE: 'Shipping carrier',
    FULFILLMENT_TOTALS: 'Fulfillment totals:',
    FULFILLMENTS: 'Fulfillments',
    GIFTCARD: 'Gift Card',
    GIFTCARD_PREAMBLE: 'Enter a gift card code.',
    REMAINING_BALANCE: 'Remaining Balance',
    HASH_X: '#{{NUMBER}}',
    IMPORT_ORDERS_MENU: 'Import Orders',
    INBOX: 'Inbox',
    INPROGRESS: 'In Progress',
    INTERNALNOTE: 'Internal Notes',
    INTERNAL_NOTE: 'Notes',
    INVENTORY_ERROR: 'Inventory was exceeded.',
    INVENTORY_REMAINING: '{{QUANTITY}} in stock.',
    INVOICE: 'Invoice',
    ISSUEREFUND: 'Issue Refund',
    ITEM: 'item',
    ITEM_WEIGHT: 'Item Weight',
    ITEMDETAIL: 'Item Details',
    ITEMS: 'items',
    ITEMS_FULFILLED: 'Items Fulfilled',
    LAST30DAYS: 'Orders In Last 30 Days',
    LBS: 'lbs',
    LIST_DATE_LABEL: 'Date',
    MANUAL_TRACKING: 'Manually fulfill the ordered items and add optional tracking information.',
    MARK_FULFILLED: 'Mark as Fulfilled',
    MARK_FULFILLED_NOW: 'Mark as Fulfilled Now',
    MARKSHIPPED: 'Mark as Shipped',
    NAME: 'Order',
    NEW: 'New',
    NO_FLAGGED_ORDERS: 'No flagged orders',
    NO_TRACKING: 'No tracking information',
    NOORDERS: 'No orders found.',
    NOTE: 'note',
    NOTEADDED: 'Internal Note Added',
    NOTEREMOVED: 'Internal Note Removed',
    NOTEUPDATED: 'Internal Note Updated',
    NOTIFIED_VIA_EMAIL: 'Emailed {{TIME_AGO}}',
    NOTIFY_CUSTOMER: 'Send shipping notification to customer',
    NOTIFY_EMAIL_FULFILLER: 'Notify Fulfiller Via Email',
    NOTIFY_EMAIL_FULFILLER_SUCCESS: 'Notification has been sent via email. You can mark these items as fulfilled now, or wait for {{FULFILLER}} to send you a shipping confirmation.',
    NOTIFYING_FULFILLER_VIA_EMAIL: 'Notifying {{FULFILLER}} via email',
    NUMBER: 'Number',
    OF_QUANTITY: 'of {{QUANTITY}}',
    OPTIONAL: '(optional)',
    ORDER_FULFILLMENT: 'Order Fulfillment',
    ORDERCARDPREAMBLE: 'Search your store\'s inventory and add products to the order.',
    ORDERDATE: 'Order Date',
    ORDEREDITED: 'Order Updated',
    ORIGINAL_PAYMENT: 'Original Payment',
    ORIGINALINVOICE: 'Original Invoice',
    OVERVIEW_DATE: '{{DATE}}',
    OVERVIEW_ITEMS_TOTAL: '{{CUSTOMER}} ordered {{ITEM}} for a total of {{TOTAL}}.',
    PACKINGSLIP: 'Packing Slip',
    PAID: 'Paid',
    PARTIALLY_FULFILLED: 'Partially Fulfilled',
    PAYMENTACCEPTED: 'Payment Authorized',
    PAYMENTCAPTURED: 'Payment Captured',
    PAYMENT_CASH: 'Cash/in-person Payment',
    PAYMENT_CREDIT: 'Credit Card',
    PAYMENT_PURCHASE_ORDER: 'Purchase Order',
    PAYMENTDECLINED: 'Payment Declined',
    PAYMENTMETHOD: 'Payment Method',
    PAYMENTMETHODPREAMBLE: 'Add a payment method for this order. Payment will not be captured until after order creation.',
    PAYPALEMAILINSTRUCTIONS: 'Please verify your email with PayPal so that you can accept payments.',
    PAYPALIPNDENIED: 'Merchant denied the payment.',
    PAYPALIPNEXPIRED: 'An order or authorization has expired and can no longer be captured.',
    PAYPALIPNFAILED: 'The buyer paid by eCheck, but the attempt to withdraw the funds from the buyer’s bank account failed.',
    PAYPALIPNNONE: 'There was a problem processing payment with PayPal.',
    PAYPALIPNREVERSAL: 'The payment was reversed by PayPal.',
    PAYPALSETUP: 'Finish PayPal Setup',
    PENDING: 'Pending',
    PLURAL: 'Orders',
    PO_NUMBER: 'PO Number',
    PREAMBLEBODY: 'Manually create a new order and enter credit card payments for sales you’ve made by phone, in person, or elsewhere outside of your online store.',
    PREAMBLEHEADER: 'Create Order',
    PRICE: 'Price',
    PRICEEACHLABEL: 'Price Each:',
    PRINT_DOCUMENTS: 'Print Documents',
    PRINT_LABEL: 'Print Label',
    PRODUCT_SEARCH_PLACEHOLDER: 'Search products...',
    PROMOCODEHINT: 'Start typing to see a list of matching promo codes',
    PURCHASE_LABEL: 'Purchase and print a shipping label with discounted rates through Volusion.',
    QUANTITY: 'Quantity',
    QUANTITY_TO_FULFILL: 'Qty to Fulfill',
    QUANTITY_X: '{{QUANTITY}} x',
    REFUND: 'Mark Order as Returned',
    REFUND_LABEL: 'Refund',
    REFUNDAMOUNT: 'Refund Amount',
    REFUNDDATE: 'Refund on {{DATE}}',
    REFUNDDUE: 'Refund Due',
    REFUNDED: 'Order Refunded',
    REFUNDERROR: 'Can\'t issue a refund',
    REFUNDSUCCESSFUL: 'Refund Issued',
    REVERSECANCELED: 'Payment Reverse Canceled',
    REVIEW_EMAIL_NOTIFICATION: 'Review the ordered items and confirm the request for fulfillment. The fulfiller will be notified via email.',
    REVIEW_FULFILLMENT: 'Review the ordered items and confirm fulfillment weight. Select the quantity you\'d like to fulfill.',
    REVIEW_FULFILLMENT_NOTIFIED: 'Review the ordered items and add tracking information, if you have it.',
    SALE_ITEM: 'Sale Item',
    SAVE_PRICE: 'Save Price',
    SELECTEDPLURAL: '{{ITEMS}} Items selected',
    SELECTEDSINGLE: '{{ITEMS}} Item selected',
    SELECTPROMOCODE: 'Select a Promo Code',
    SET_UP_POSTAGE: 'Complete your setup to enable postage printing',
    SET_UP_SHIPPO: 'Go to Shippo settings',
    SHIPPED: 'Shipped',
    SHIPPING: 'Shipping',
    SHIPPING_ADDRESS: 'Shipping Address',
    SHIPPING_ADDRESS_UPDATED: 'Shipping address updated',
    SHIPPING_VIA_CARRIER: 'Shipping via {{CARRIER}}',
    SHIPPINGCARDPREAMBLE: 'Choose a shipping method and cost to assign to this product. Shipping methods are prepopulated based on the products in the order. You may also input a custom shipping cost.',
    SHIPPINGLABEL: 'Shipping Label',
    SHIPPINGMETHOD: 'Shipping Method',
    SHIPPINGMETHODPROMPT: 'Add a product and shipping address to get calculated shipping',
    SHIPPINGRATECOSTLABEL: 'Rate Cost',
    SHIPPINGRATENAMELABEL: 'Rate Name',
    SHIPPING_REQUIRED: 'Shipping carrier required if tracking number provided',
    SHIPTO: 'Shipping Address',
    SKU_LABEL: 'SKU:',
    STATUS: 'Status',
    STATUSITEM: '{{TOTAL}} item',
    STATUSITEMS: '{{TOTAL}} items',
    STATUS_FULFILLMENT: '{{TOTAL}} fulfillment,',
    STATUS_FULFILLMENTS: '{{TOTAL}} fulfillments,',
    STATUS_SOURCE: '{{TOTAL}} source,',
    STATUS_SOURCES: '{{TOTAL}} sources,',
    PAYMENTID: 'Payment ID:',
    SUBTOTAL: 'Subtotal',
    TAX: 'Tax',
    TAX_EXEMPT_INSTRUCTION: 'Choose whether or not to collect tax for this order',
    TAX_EXEMPT_SAVE: 'Set tax status',
    TAX_RECALCULATED: 'Tax recalculated',
    TAXEXEMPT: 'Order is tax exempt',
    TAXSTATUS: 'Tax Status',
    TITLE: 'Order {{NUMBER}}',
    TOTAL: 'Total',
    TOTALPRICE: 'Total Price',
    TOTAL_WEIGHT: 'Total Weight',
    TOTALAFTERREFUND: 'Total after refund',
    TOTALDUE: 'Total Due',
    TOTALORDERS: 'Total Orders',
    TRACKING_INFO: 'Tracking information',
    TRACKING_NUMBER: 'Tracking number',
    TRYAGAIN: 'Try Again',
    UNFULFILLED_ITEMS: 'Unfulfilled Items',
    UPDATEDINVOICE: 'Updated Invoice',
    VARIANTS_LABEL: 'Variants:',
    VIA_CARRIER: 'via {{CARRIER}}',
    VIEW_IN_MAP: 'View in Google Maps',
    VIEWMORECUSTOMERINFO: 'View more customer info',
    WAIT_FOR_SHIPPING_CONFIRMATION: 'Wait For Shipping Confirmation',
    WEIGHT_LBS: '{{WEIGHT}} lbs',
    WILLAPPEAR: 'When a customer makes a purchase, you can see the order here.'
  },
  PAGES: {
    ACTIVE_PAGES: 'Displayed Pages',
    ADD: 'Add Page',
    ADD_A_PAGE: 'Add a Page',
    ADDLINK: 'Add a Link',
    ALL_PAGES: 'All Pages',
    AWAITING: 'Make your site shine.',
    CONTENT: 'Pages',
    CREATE_BUTTON_LABEL: 'Create Page',
    CREATED_ON: 'Created On',
    DELETE: 'Remove this page?',
    EMBEDVIDEO: 'Embed Video',
    ENTERYOUTUBEURL: 'Please paste youtube video url or share url.',
    HIDE: 'Hide Page',
    INACTIVE: 'Hidden',
    INACTIVE_PAGES: 'Hidden Pages',
    LASTUPDATED: 'Last Updated',
    LINKLABEL: 'Link Text',
    LINKURL: 'Link URL',
    NEW_IN_LAST_30_DAYS: 'New In Last 30 Days',
    NOPAGES: 'No pages were found.',
    PAGETITLE: 'Title',
    PAGE_TITLE: 'Page Title',
    SELECTEDPLURAL: '{{ITEMS}} Items selected',
    SELECTEDSINGLE: '{{ITEMS}} Item selected',
    SHOW: 'Show Page',
    TOTAL_PAGES: 'Total Pages',
    USEFULLWIDTH: 'Use full width',
    VIDEOHEIGHT: 'Video height',
    VIDEOWIDTH: 'Video width',
    WILLAPPEAR: 'Use Pages to display anything that isn\'t a product or category. Do you have a funny mission statement? A cool story about your startup? Let the world know. Click + to start building a page.',
    YOUTUBE: 'YouTube URL'
  },
  PLACEHOLDER: {
    EMAILADDRESS: 'Email Address',
    PHONENUMBER: 'Phone Number'
  },
  POSTAGE: {
    DIMENSIONS: 'Dimensions',
    EVENT_LABELPURCHASED: 'Label purchased',
    EVENT_LABELREFUNDED: 'Label refunded',
    HEIGHTMIN: 'Height must be greaterthan 0',
    HEIGHTREQUIRED: 'Height is required',
    INCHESABREV: 'in.',
    LABEL: 'Postage Printing',
    LENGTHMIN: 'Length is required',
    LENGTHREQUIRED: 'Length must be greater than 0',
    OWNPACKAGING: 'Own packaging',
    POUNDSABREV: 'lbs.',
    USPS: 'USPS',
    WEIGHTMIN: 'Weight must be greater than 0',
    WEIGHTREQUIRED: 'Weight is required',
    WIDTHMIN: 'Width must be greater than 0',
    WIDTHREQUIRED: 'Width is required'
  },
  POSTAGEDEFAULTSEDIT: {
    LABEL_DESC: 'Prefills label printing format for all orders. You can always change it later for each order.',
    LABEL_LABEL: 'Label format',
    LABEL_TITLE: 'Default label settings',
    ORDERHANDLING_DESC: 'Set your typical order handling time for your orders. You can always change it later for each order.',
    ORDERHANDLING_LABEL: 'Order handling time',
    ORDERHANDLING_TITLE: 'Default order handling settings',
    PACKAGE_DESC: 'Prefills package type for all orders. You can always change it later for each order.',
    PACKAGE_TITLE: 'Default package settings',
    PAYMENT_TITLE: 'Payment method for label purchase',
    RETURNPOSTAGE_DESC: 'Set your preference to print return postage and set your return address.',
    RETURNPOSTAGE_SWITCH: 'Print return postage for each order.',
    RETURNPOSTAGE_TITLE: 'Return postage settings'
  },
  POSTAGEDEFAULTSSETUP: {
    ANDI: 'and I',
    BROUGHTTOYOUBY: 'Postage printing brought to you by',
    CONFIGURESETTINGS: 'Configure Settings',
    LABELFORMAT_INTRO: 'My default label format will be',
    ORDERHANDLING_DAYS: 'days.',
    ORDERHANDLING_INTRO: 'My default order handling time is',
    PACKAGE_CHOOSECARRIERPACKAGING: 'choose carrier packaging...',
    PACKAGE_INTRO: 'My default package for label purchase will be',
    PACKAGE_MYOWNPACKAGING: 'my own packaging...',
    PACKAGESETUPMODAL_ADDTITLE: 'Add default package',
    PACKAGESETUPMODAL_CANCEL: 'Cancel',
    PACKAGESETUPMODAL_DESCRIPTION: 'Prefills package type for all orders. You can always change it later for each order.',
    PACKAGESETUPMODAL_ERROR: 'Could not update address',
    PACKAGESETUPMODAL_OTHERSSOON: 'Others soon!',
    PACKAGESETUPMODAL_SAVE: 'Save package',
    PACKAGESETUPMODAL_SELECTTITLE: 'Select default package',
    PAYMENT_ENDINGIN: 'ending in',
    PAYMENT_INTRO: 'To purchase postage, I will use',
    PAYMENT_MYCARDONFILE: 'my card on file',
    PRINTRETURNPOSTAGE: 'print return postage.',
    REDIRECTMODAL_DESCRIPTION: 'You need to configure your settings before purchasing a shipping label.',
    REDIRECTMODAL_OKBUTTON: 'Go to setup',
    REDIRECTMODAL_TITLE_NOADDRESS: 'No Return Address',
    REDIRECTMODAL_TITLE_NOCARD: 'No Payment Method',
    REDIRECTMODAL_TITLE_NODEFAULTS: 'Settings not configured',
    RETURNADDRESS_CONFIGURESTOREADDRESS: 'configure store address...',
    RETURNADDRESS_INTRO: 'My return address is',
    RETURNADDRESS_MYSTOREADDRESS: 'my store address',
    WILL: 'will',
    WILLNOT: 'will not'
  },
  POSTAGEFULFILLMENT: {
    AMOUNTPAID: 'Amount paid for shipping:',
    ERRORGETTINGLABEL: 'Failed to get shipping label',
    ITEMS: '{{NUMBEROFITEMS}} items',
    LINEWEIGHT: 'Line Weight',
    NOTNOW: 'Notnow',
    OPTIONS: 'Options',
    PACKAGEDETAILS: 'Package Details',
    PACKAGEDETAILSDESC: 'Based on the weight of your products, we\'ve prefilled an approximate total shipping weight. Confirm this weight and select a package to continue to label purchasing.',
    PREFERREDLABELFORMAT: 'Preferred label format',
    PRINTLABEL: 'Print label',
    PRINTPACKINGSLIP: 'Print Packing Slip',
    PRINTRETURNLABEL: 'Print Return label',
    PRODUCT: 'Product',
    PRODUCTINFORMATION: 'Product Information',
    PRODUCTINFORMATIONDESC: 'Review the ordered products and confirm product options and weight.',
    PRODUCTTOTALS: 'Product Totals',
    PURCHASERETURNPOSTAGE: 'Purchase return postage',
    QTY: 'Qty.',
    REFUNDMODAL_DESCRIPTION: 'You will get a refund of {{refundamount}}, and the label will be invalidated.',
    REFUNDMODAL_OKBUTTON: 'Get refund',
    REFUNDMODAL_TITLE: 'Refund shipping label?',
    SHIPPINGLABELPURCHASED: 'Shipping label purchased',
    SKU: 'SKU:',
    TITLE1: 'Fulfill Order Shipment',
    TITLE2: 'Purchase Shipping Label',
    TITLE3: 'Label Purchase Confirmation',
    TRACKINGNUMBER: 'Tracking number:',
    WEIGHT: 'Weight',
    WEIGHTLBS: '{{WEIGHT}} lbs.'
  },
  PRIVY: {
    CONNECT_PRIVY: 'Connect Privy Account',
    DESCRIPTION: 'Customizable, mobile-friendly display types including popups, spin to win, banners, flyouts, scroll boxes, announcement bars, and embedded forms for email collection.',
    HEADING: 'Get email subscribers using banners, triggered pop-ups, and coupons',
    HELP: 'Don\'t have a Privy account?',
    INPUT_LABEL: 'Paste your Privy account identifier to connect.',
    INPUT_PLACEHOLDER: 'i.e. A1B8C78G0915EA2456AE3176',
    LINK: 'Sign up for free.',
    MANAGE: 'Manage',
    MANAGE_MESSAGE: 'Your store is now ready to collect email addresses and display custom banners.',
    MODAL_LINK: 'Learn How',
    MODAL_TITLE: 'Screenshot of Privy dashboard',
    TITLE: 'Privy'
  },
  PRODUCT: {
    ACTIVEPRODUCTS: 'Displayed Products',
    ADD: 'Add a Product',
    ALLPRODUCTS: 'All Products',
    ATTACH_PAGE: 'Attach a page',
    CHOOSE_PAGE: 'Choose a page',
    CREATE_BUTTON_LABEL: 'Create Product',
    DELETE: 'Remove this product?',
    DESCRIPTION: 'Description',
    DESCRIPTION_CREATOR_ATTRIBUTES_NO_PRODUCT_NAME: 'Choose attributes',
    DESCRIPTION_CREATOR_ATTRIBUTES_PRODUCT_NAME: 'P',
    DESCRIPTION_CREATOR_BUTTON: 'Help me write',
    DESCRIPTION_CREATOR_CARD_TITLE: 'Quick Write',
    DESCRIPTION_CREATOR_CATEGORY: '{{PRODUCT_NAME}} category:',
    DESCRIPTION_CREATOR_DESCRIPTIVE_QUESTION: '{{PRODUCT_NAME}} is',
    DESCRIPTION_CREATOR_GENERATE_BUTTON: 'Generate Description',
    DESCRIPTION_CREATOR_IN_PROGRESS: 'Your base description has been updated below.',
    DESCRIPTION_CREATOR_INSTRUCTIONS: 'Get a jump start on your description! You can edit your full description later for grammar and personality.',
    DESCRIPTION_CREATOR_LOCATION_QUESTION: 'when they are',
    DESCRIPTION_CREATOR_MATERIAL: '{{PRODUCT_NAME}} material:',
    DESCRIPTION_CREATOR_NO_PRODUCT_NAME: 'This product is',
    DESCRIPTION_CREATOR_PERFECT_FOR_QUESTION: 'It\'s perfect for',
    DESCRIPTION_CREATOR_SEARCHPLACEHOLDER: 'Search Attributes',
    DESCRIPTION_CREATOR_SUBCATEGORY: '{{PRODUCT_NAME}} subcategory',
    DETACH_PAGE: 'Detach Page',
    DOESNOTEXIST: 'This product no longer exists.',
    EDIT: 'Update Product',
    EMPTYSEARCH: 'Begin typing to add a category',
    EXPORT_PRODUCTS_LINE1: 'You\'ve chosen to export {{PRODUCT_COUNT}} products.',
    EXPORT_PRODUCTS_LINE2: 'Note that the format will be CSV with different headers than your import files, so you can report on things like inventory levels and access image links quickly.',
    EXPORT_PRODUCTS_SUCCESS_MESSAGE: 'You will receive an email with a link to download the CSV with {{PRODUCT_COUNT}} products when it\'s ready. At peak times this could take several minutes.',
    EXPORT_PRODUCTS_START_EXPORT: 'Start Export',
    EXPORTPRODUCTSMENU: 'Export Products',
    HIDE: 'Hide Product',
    IMPORT_CUSTOMER_REVIEW_ADD: 'ADD EXISTING PRODUCT REVIEW',
    IMPORT_CUSTOMER_REVIEW_AUTHOR: 'Reviewer\'s Name',
    IMPORT_CUSTOMER_REVIEW_DATE: 'Date of Review',
    IMPORT_CUSTOMER_REVIEW_DESCRIPTION: 'Bring reviews you\'ve already earned to your Volusion store.  Add reviews you\'ve received from Facebook, Etsy, Yelp, Amazon or anywhere else on the web using this simple form.',
    IMPORT_CUSTOMER_REVIEW_FOR: 'REVIEW FOR',
    IMPORT_CUSTOMER_REVIEW_INPUT: 'Review',
    IMPORT_CUSTOMER_REVIEW_RATING: 'Rating received',
    IMPORT_CUSTOMER_REVIEW_SUBMIT: 'SUBMIT REVIEW',
    IMPORT_CUSTOMER_REVIEW_TIP: '*Reviews will appear in your product description text editor.',
    IMPORT_CUSTOMER_REVIEW_TITLE: 'PRODUCT REVIEWS',
    IMPORTPRODUCTSMENU: 'Import Products',
    INACTIVE: 'Hidden',
    INACTIVEPRODUCTS: 'Hidden Products',
    INSTOCK: 'in stock',
    INVALID_PAGE: 'We can\'t find your attached content page. This can happen if you deleted the page which was attached. To hide this message, attach a new page or click the \'Detach Page\' button, below.',
    INVENTORY: 'Inventory',
    LIMITBADGE: '{{LIMIT}} Product Limit',
    LIMITREACHED: 'You\'ve reached your limit!',
    LIMITREACHEDBADGE: 'Product Limit Reached',
    LIMITREACHEDDESC1: 'Volusion Free has a max product limit of {{PRODUCTLIMIT}} products.',
    LIMITREACHEDDESC2: 'Upgrade to Volusion Plus to unlock unlimited products.',
    LIMITREACHEDDESCLINE1: 'Volusion Free has a max product limit of {{PRODUCTLIMIT}} products.',
    LIMITREACHEDDESCLINE2: 'Upgrade to Volusion Plus to unlock unlimited products.',
    NAME: 'product',
    NAMELABEL: 'Name',
    NEWINLAST30DAYS: 'New In Last 30 Days',
    NO_CONTENT_PAGES: 'You don\'t have any pages. Go to the <a href="/pages/add" title="Add a page">pages app</a> to create a new page.',
    NOPRODUCTS: 'No products found.',
    OR: 'Or',
    PLURAL: 'products',
    PRICE: 'Price',
    PRICEVARIANTS: 'Price modified by variants',
    PRODUCT_TITLE: 'Product Title',
    PRODUCTVARIANTS: 'product variants',
    QUANTITY: 'Qty',
    RELATEDPRODUCTS: 'Related Products',
    REQUIREMENT1: 'Maximum file size:',
    REQUIREMENT1VALUE: '5MB',
    REQUIREMENT2: 'File type:',
    REQUIREMENT2VALUE: 'Comma-separated values (.csv)',
    SALE_PRICE: 'Sale Price',
    SELECTEDPLURAL: '{{ITEMS}} Items selected',
    SELECTEDSINGLE: '{{ITEMS}} Item selected',
    SHIPPINGANDTAX: 'Shipping and Tax',
    SHIPPINGREQUIRED: 'Requires Shipping',
    SHOW: 'Show Product',
    SINGLE: 'product',
    SOURCE_SKU: 'Fulfiller Sku',
    STOPTRACKINGPRODUCTINVENTORYCONFIRMBODY: 'Stop tracking inventory for the product \'{{PRODUCT_NAME}}\'?',
    STOPTRACKINGPRODUCTINVENTORYCONFIRMHEADING: 'Are You Sure?',
    STOPTRACKINGPRODUCTINVENTORYCONFIRMNO: 'Cancel',
    STOPTRACKINGPRODUCTINVENTORYCONFIRMYES: 'Stop Tracking Inventory',
    SUCCESSEXTENSIONS: 'Installed {{COUNT}} extensions',
    TAXABLE: 'Taxable',
    TOTALPRODUCTS: 'Total Products',
    VARIANTIMAGESMODALGROUPIMAGE: 'GROUP IMAGE',
    VARIANTIMAGESMODALHEADINGSUBTEXT: 'Select and/or upload images for this variant',
    VARIANTIMAGESMODALNAMELABEL: 'Variant name:',
    VARIANTIMAGESMODALPRODUCTVARIANT: 'Product Variant:',
    VARIANTIMAGESMODALSELECTEDCOUNT: 'Selected',
    VARIANTIMAGESMODALSKU: 'SKU:',
    VARIANTIMAGESMODALTITLE: 'Variant Images',
    VARIANTIMAGESMODALTITLESELECT: 'Select',
    VARIANTIMAGESMODALUSEBUTTON: 'USE',
    VARIANTIMAGESMODALVALUELABEL: 'Variant value:',
    VARIANTIMAGESSKUMODALHEADINGSUBTEXT: 'Select and/or upload images for this variant. Override group level images.'
  },
  REGISTER: {
    CREDITCARD_CVV_LABEL: 'CVC',
    CREDITCARD_CVV_REQUIRED: 'CVC is required.',
    CREDITCARD_CVV_VALID: 'CVC must be valid.',
    CREDITCARD_EXP_LABEL: 'MM/YY',
    CREDITCARD_EXP_REQUIRED: 'Exp. is required.',
    CREDITCARD_EXP_VALID: 'Exp. must be valid.',
    CREDITCARD_NUMBER_LABEL: 'Card Number',
    CREDITCARD_NUMBER_REQUIRED: 'Card Number is required.',
    CREDITCARD_NUMBER_VALID: 'Card Number must be valid.',
    PROCESSINGSTEP1: 'Building your store',
    REGISTRATION_ERROR_DESCRIPTION: 'We could not register your store.',
    REGISTRATION_ERROR_TITLE: 'Registration Error'
  },
  SAVEBAR: {
    LOADING: 'Saving'
  },
  SCOPEPICKER: {
    DOLLARSIGN: '$',
    NORESULTS: 'You have not created any products or categories',
    NORESULTSCATEGORIES: 'You have not created any categories',
    NORESULTSFOR: 'No results for',
    NORESULTSPRODUCTS: 'You have not added any products',
    OFF: 'off -',
    PERCENT: '%',
    PRODUCTS: 'products',
    SEARCHPLACEHOLDER: 'Search categories/products...',
    SELECTED: 'selected',
    SELECTENONE: 'Select none',
    SELECTSCOPE: 'Select Categories/Products'
  },
  SEARCH: {
    CUSTOMERRESULTS: '{{COUNT}} customer results for {{QUERY}}',
    ORDERRESULTS: '{{COUNT}} order results for {{QUERY}}',
    PRODUCTRESULTS: '{{COUNT}} product results for {{QUERY}}',
    RESULTS: 'Search Results',
    SEARCH: 'Search...'
  },
  SEO: {
    FRIENDLYNAME: 'Page URL text',
    HINT: 'Read our <a href="https://www.volusion.com/blog/best-practices-for-creating-seo-friendly-title-tags-ecommerce/" target="_blank">blog post</a> about best practices for creating SEO-friendly title tags',
    METADESCRIPTIONSHORT: 'Meta Description',
    SEO: 'SEO',
    SUBHEAD: 'SEO = Search Engine Optimization. Improve search visibility and control your page\'s appearance in search results.',
    TITLE: 'Title Tag'
  },
  SHIPPING: {
    MARKSHIPPED: 'Mark as Shipped',
    MARKSHIPPEDDESCRIPTION: 'Ship and complete your order.',
    METHODNOTSPECIFIED: 'Not Specified',
    PACKINGSLIP: 'packing slip',
    PRINTLABEL: 'Print Shipping Label',
    PRINTSLIP: 'Print Packing Slip',
    PRINTINVOICE: 'Print Invoice',
    SHIPPINGMETHOD: 'Carrier',
    SHIPTO: 'Ship To',
    THANKYOU: 'thank you!',
    TRACKINGNUMBER: 'Tracking Number'
  },
  STORE: {
    CACHEREFRESHED: 'Cache successfully refreshed!',
    CACHEREFRESHERROR: 'Refreshing cache had an error',
    EMAILREQUIRED: 'Email is required',
    LOGOFAVICON: 'Logo and Favicon',
    LOGOUT: 'Log Out',
    RELEASENOTES: 'What\'s new?',
    STOREEMAIL: 'Store Email',
    STORENAME: 'Store Name',
    UPLOADFAVICONBLURB: 'Your favicon will display in the tab bar of your browser.',
    UPLOADFAVICONINSTRUCTION1: 'Dimensions: 32x32',
    UPLOADFAVICONINSTRUCTION2: 'File type: PNG',
    UPLOADLOGOBLURB: 'Upload your logo to be displayed on your storefront aswell as invoices, packing slips, and shipping labels.',
    UPLOADLOGOINSTRUCTION1: 'Maximum file size: 5MB',
    UPLOADLOGOINSTRUCTION2: 'File types: PNG, JPG, JPEG, GIF',
    VALIDEMAIL: 'A valid email is required'
  },
  STOREADDRESSES: {
    ADD: 'Add',
    CANCEL: 'Cancel',
    STORE_ADDRESSES: 'Store Addresses'
  },
  STORESETTINGS: {
    ADDTHISCONFIRMMODALTITLE: 'Are You Sure?',
    ADDTHISDESCRIPTION: 'Make it easy for shoppers to share your product links via email, on Facebook, Twitter, Pinterest, and Google Plus.',
    ADDTHISDISABLECONFIRMCANCEL: 'Cancel',
    ADDTHISDISABLECONFIRMDESCRIPTION: 'Disabling will remove the ability for your customers to share via the Social Sharing Widget. You can re-enable the Social Sharing Widget at any time.',
    ADDTHISDISABLECONFIRMOK: 'Disable',
    ADDTHISDISABLED: 'Disabled',
    ADDTHISENABLED: 'Enabled',
    ADDTHISTITLE: 'SHARE BUTTON',
    BADGE_EMAIL_VERIFIED: 'Email Verified',
    BADGE_LAUNCHED: 'Live',
    BADGE_NOT_LAUNCHED: 'Not Live',
    BADGE_NOTEMAIL: 'Email not verified',
    INTROFREEOTHERWISE: ', otherwise I\'ll charge',
    INTROPAYMENT: 'I will use',
    INTROPAYMENTSUFFIX: 'to collect payment',
    INTROSHIPPING: 'I will',
    INTROSHIPPINGCHARGE: ', and I\'ll charge',
    INTROSHIPPINGFOOTNOTE: '* You can create more advanced shipping methods later.',
    INTROSHIPPINGFREE: 'for all orders over',
    INTROSHIPPINGSUFFIX: 'per order',
    INTROSTATE: 'I am located in the state of',
    INTROSTORENAME: 'The name of my store is',
    INTROSTORENAMEPLACEHOLDER: '(optional)',
    INTROSUBMIT: 'Configure Settings',
    LAUNCH_YOUR_STORE: 'Launch your store',
    NAME: 'Settings',
    PAYMENTSTABTITLE: 'Payments',
    RESEND_EMAIL: 'Resend Verification Email',
    SEOHOMEPAGESEOCARDDESC: 'Add a title tag and meta description to your home page for use on the search engine results pages (SERPs).',
    SEOHOMEPAGESEOCARDTITLE: 'Homepage SEO',
    SEOHOMEPAGESEODESCTAGLABEL: 'Homepage meta description',
    SEOHOMEPAGESEODESCTAGPLACEHOLDER: 'Write compelling, readable ad copy to draw visitors using important keywords.',
    SEOHOMEPAGESEOGOOGLEPREVIEWMETADESCTAGEXAMPLE: 'This is your page description. The font and size of the description has not changed in the latest redesign. Descriptions get cut off after roughly 320 characters ...',
    SEOHOMEPAGESEOGOOGLEPREVIEWTITLE: 'Google result preview',
    SEOHOMEPAGESEOGOOGLEPREVIEWTITLETAGEXAMPLE: 'Primary Keyword - Secondary Keyword | Brand Name',
    SEOHOMEPAGESEOGOOGLEPREVIEWURLEXAMPLE: 'www.example.com/example',
    SEOHOMEPAGESEOTITLETAGLABEL: 'Homepage title tag',
    SEOHOMEPAGESEOTITLETAGPLACEHOLDER: 'e.g. Primary Keyword - Secondary Keyword | Brand Name',
    SEOSITEVERIFICATIONBINGLABEL: 'Bing Webmaster Tools',
    SEOSITEVERIFICATIONBINGPLACEHOLDER: 'e.g. 0FC3FD705126161B052E755A56F8952D',
    SEOSITEVERIFICATIONCARDDESC: 'Add verification meta tags for popular websites.',
    SEOSITEVERIFICATIONCARDTITLE: 'Verification Tags',
    SEOSITEVERIFICATIONGOOGLELABEL: 'Google Search Console',
    SEOSITEVERIFICATIONGOOGLEPLACEHOLDER: 'e.g. uEtG4638yYT42PzvFua6iiR1v+iJ2lfnUpZ/cJPdzKM=',
    SEOSITEVERIFICATIONPINTERESTLABEL: 'Pinterest',
    SEOSITEVERIFICATIONPINTERESTPLACEHOLDER: 'e.g. a20678558024142eb16eb12c1c69ba96',
    SEOTABTITLE: 'SEO',
    SHIPPINGACTIVE: 'Active',
    SHIPPINGADDFREE: 'Add Free Shipping',
    SHIPPINGADDMETHOD: 'Add Method',
    SHIPPINGBYPRICEDESC: 'Create and manage shipping rates based on the order subtotal.',
    SHIPPINGBYWEIGHTDESC: 'Create and manage shipping rates based on the order weight.',
    SHIPPINGCANCEL: 'Cancel',
    SHIPPINGCREATENEWRATE: 'Create New Rate',
    SHIPPINGCURRENCY: '$',
    SHIPPINGEDITPRICERATE: 'Edit Price Rate',
    SHIPPINGEDITWEIGHTRATE: 'Edit Weight Rate',
    SHIPPINGFREE: 'Free Shipping',
    SHIPPINGFREEALL: 'Free shipping on all orders',
    SHIPPINGFREEDESC: 'Reward your customers with free shipping.',
    SHIPPINGFREEOVER: 'Free shipping on orders over',
    SHIPPINGGOTOPRODUCTS: 'Go to products',
    SHIPPINGINPUTPRICERANGE: 'Input a price range. Add multiple delivery methods if necessary. Leave the Maximum order price empty if you don\'t want an upper limit on this rate.',
    SHIPPINGINPUTWEIGHTRANGE: 'Input a weight range. Add multiple delivery methods if necessary. Leave the Maximum order weight empty if you don\'t want an upper limit on this rate.',
    SHIPPINGMAXIMUMORDERPRICE: 'Maximum order price',
    SHIPPINGMAXIMUMORDERWEIGHT: 'Maximum order weight (in lbs)',
    SHIPPINGMETHODS: 'Shipping Methods',
    SHIPPINGMINIMUMORDERPRICE: 'Minimum order price',
    SHIPPINGMINIMUMORDERWEIGHT: 'Minimum order weight (in lbs)',
    SHIPPINGMISSINGPRODUCTWEIGHTS: 'Missing Product Weights',
    SHIPPINGMISSINGPRODUCTWEIGHTSMESSAGE: 'You have products and/or variants without weights. In order to use weight-based shipping rates, all products and variants require weight values. Please add weights to you products. All products and/or variants without weights will be treated as weighing 0lbs at checkout.',
    SHIPPINGNEWBYPRICE: 'New Price Rate',
    SHIPPINGNEWBYWEIGHT: 'New Weight Rate',
    SHIPPINGNEWPRICERATE: 'New Price Rate',
    SHIPPINGNEWWEIGHTRATE: 'New Weight Rate',
    SHIPPINGNOMAX: 'No maximum',
    SHIPPINGPREVIOUSPRICERATE: 'We\'ve added the methods from a previous price rate.',
    SHIPPINGPREVIOUSRATEDISMISS: 'Dismiss',
    SHIPPINGPREVIOUSRATEUNDO: 'Undo',
    SHIPPINGPREVIOUSWEIGHTRATE: 'We\'ve added the methods from a previous weight rate.',
    SHIPPINGPRICE: 'Shipping Price',
    SHIPPINGPRICEBASED: 'Price Based Rates',
    SHIPPINGPRICEOVERLAP: 'This rate overlaps another rate. Please change the price values.',
    SHIPPINGPRICERANGE: 'Order Price Range',
    SHIPPINGSAVERATE: 'Done Editing',
    SHIPPINGSUCCESSCREATED: 'successfully created.',
    SHIPPINGSUCCESSEDITED: 'successfully edited.',
    SHIPPINGSUCCESSPRICERATE: 'Price rate for',
    SHIPPINGSUCCESSWEIGHTRATE: 'Weight rate for',
    SHIPPINGTABTITLE: 'Shipping',
    SHIPPINGWEIGHTBASED: 'Weight Based Rates',
    SHIPPINGWEIGHTOVERLAP: 'This rate overlaps another rate. Please change the weight values.',
    SHIPPINGWEIGHTRANGE: 'Order Weight Range',
    SHIPPINGWEIGHTUNITS: 'lbs',
    SITEMAP_DESCRIPTION: 'You can find your sitemap.xml file here. We automatically refresh it once a day or you can manually refresh it below.',
    SITEMAP_DOWNLOAD: 'Download sitemap.xml',
    SITEMAP_LINKLABEL: 'Link to sitemap.xml',
    SITEMAP_REFRESH: 'Refresh sitemap.xml',
    SITEMAP_REFRESHED: 'Refreshed',
    SITEMAP_REFRESHERROR: 'Error Refreshing',
    SITEMAP_REFRESHING: 'Refreshing',
    SITEMAP_TITLE: 'Sitemap.xml',
    SOCIALACCOUNTSTITLE: 'Social Media Accounts',
    STATUS_NOTEMAIL_LAUNCHED: 'Your store is live but your email is unverified. Please click the link we sent you to verify your email address.',
    STATUS_NOTEMAIL_NOTLAUNCHED: 'Verification email has been sent to {{email}}. In order to launch your store, you must click the link we sent you to verify your email address.',
    STATUS_VERIFIED_LAUNCHED: 'Your store is live! Search engines can now index your site and show your site on search results.',
    STATUS_VERIFIED_NOTLAUNCHED: 'Your email has been successfully verified. You can now launch your store! This will allow search engines (like Google) to index your site and display it on search results.',
    STOREINFORMATIONTABTITLE: 'Store Info',
    TITLE_STORE_STATUS: 'Store Status'
  },
  STYLEEDITOR: {
    ADVANCED: 'Advanced CSS Editor',
    COLORS: 'Colors',
    COMPILEERROR: 'An error occurred.',
    CUSTOM: 'Custom',
    CUSTOMSTYLES: 'Custom Styles',
    FONTS: 'Fonts',
    PUBLISHCONFIRMBLOB: 'Publish changes to your live store?',
    PUBLISHCONFIRMTITLE: 'Publish',
    PUBLISHDIALOGCANCEL: 'No, do not publish',
    PUBLISHDIALOGOK: 'Yes, publish my changes',
    PUBLISHSUCCESS: 'Published successfully',
    RESTORE: 'Restore',
    REVERTCONFIRMBLOB: 'Restore the theme defaults? This erases any custom style changes.',
    REVERTCONFIRMRESTORE: 'Restore Theme Defaults',
    REVERTDIALOGLABEL: 'Publish Changes',
    REVERTDONOTRESTORE: 'Do not restore',
    REVERTRESTOREDEFAULTS: 'Restore defaults',
    REVERTSUCCESS: 'Theme Defaults Restored',
    UNDO: 'Undo',
    UNSAVEDCHANGES: 'You have unsavedchanges.',
    UNSAVEDCHANGESCANCEL: 'Cancel and Go Back',
    UNSAVEDCHANGESCONTINUE: 'Save and Continue',
    UNSAVEDCHANGESDIALOG: 'Save before continuing? You have unsaved changes that will be lost.'
  },
  SYSTEMSTATUS: {
    DEFAULTSTATUS: 'All Systems Operational',
    STATUSLABELV2: 'Volusion Status'
  },
  THEMESTORE: {
    ACTIVATE: 'Activate',
    ACTIVATESUCCESS: 'Your theme has been applied to your store.',
    ACTIVATING: 'Activating',
    ALLTHEMES: 'All Themes',
    CANCEL: 'cancel',
    CONFIRMACTIVATELINE1: 'Are you sure you want to make {{THEME}} your active theme?',
    CONFIRMACTIVATELINE2: '{{THEME}} will replace your current theme, {{CURRENTTHEME}}. This will take effect immediately, and the changes will be publicly visible on your storefront.',
    CONFIRMINSTALL: 'Confirm Install',
    CONFIRMPURCHASEALERT: 'This is a free theme. You will not be charged.',
    CONFIRMUPDATELINE1: 'Are you sure you want to update your theme to version {{VERSION}}?',
    CONFIRMUPDATELINE2: 'New in version {{VERSION}}:',
    CURRENCY: '$',
    CURRENTVERSION: 'Current version',
    DESCRIPTION: 'description',
    DEVELOPER: 'Developer',
    FEATURED: 'featured',
    FREE: 'free',
    INACTIVE: 'Inactive',
    INSTALL: 'install',
    INSTALLED: 'Installed',
    INSTALLING: 'Installing',
    INSTALLSUCCESS: 'Your theme is installed. Activate it to apply it to your store.',
    LIVE: 'Live',
    NOTHEMES: 'No themes found.',
    PREVIEW: 'preview',
    PURCHASE: 'purchase',
    SHORTVERSION: 'v',
    THEME: 'Theme',
    THEMEFEATURES: 'theme features',
    THEMEMARKETPLACE: 'Theme Store',
    THEMESTORE: 'Theme Store',
    THEMESUPPORTINFO: 'Theme Support',
    UPDATE: 'Update',
    UPDATEAVAILABLE: 'Update to',
    UPDATEERRORCONTENT: 'Well, it looks like there\'s a conflict with your site settings when updating your theme. You can continue to update to the latest version without all of your custom settings or return to your last version.',
    UPDATEERRORREVERT: 'Go Back to Previous Version',
    UPDATEERRORSAVE: 'Update Without Settings',
    UPDATEERRORTITLE: 'Well, that didn\'t work.',
    UPDATESUCCESS: 'There you go. Your theme’s all updated!',
    UPDATING: 'Updating',
    VERSION: 'version',
    WEBSITE: 'Website'
  },
  TITLETAG: {
    ABANDONED_CARTS: 'Abandoned Carts',
    ALLAPPS: 'All Apps',
    ALLTHEMES: 'All Themes',
    ANALYTICS: 'Analytics',
    APIKEYS: 'API Keys',
    APPSTORE: 'Integrations',
    CANCEL_STORE: 'Cancel Store',
    CATEGORIES: 'Categories',
    CATEGORY: 'Category',
    CUSTOMERS: 'Customers',
    DISCOUNTS: 'Discounts',
    EDITSTORE: 'Update Store',
    EDITSTORE_CONTENT: 'Update Content',
    EDITSTORE_LOGO: 'Update Logo',
    EDITSTORE_STYLES: 'Update Styles',
    EDITSTORE_THEMEDETAILS: 'Theme Details',
    EDITSTORE_THEMES: 'Themes',
    EDITSTORELANDING: 'Edit Store',
    FACEBOOKPIXEL: 'Facebook Pixel',
    FULFILLERS: 'Fulfillment Services',
    FULLSTORY: 'Fullstory',
    GOOGLEANALYTICS: 'Google Tracking',
    CHAT: 'Live Chat',
    INSTALLEDTHEMES: 'Installed Themes',
    INVOICE: 'Invoice',
    LANDING: 'Dashboard',
    MORE_COUNT: '{{COUNT}} more ...',
    MYACCOUNT: 'My Account',
    ORDERS: 'Orders',
    PACKINGSLIP: 'Packing Slip',
    PAGES: 'Pages',
    PRIVY: 'Privy',
    PRODUCTS: 'Products',
    SETTINGS: 'Settings',
    SHIPPINGLABEL: 'Shipping Label',
    THEMESTORE: 'Theme Store',
    YOTPO: 'Yotpo'
  },
  TOAST: {
    ACCEPTERROR: 'Problem processing your {{TYPE}}',
    MULTIREMOVE: '{{COUNT}} {{TYPE}} successfully removed',
    SUCCESSFULLYREMOVED: '{{NAME}} successfully removed'
  },
  TRIALSTATUSBAR: {
    TIMEREMAINING: 'Hey {{NAME}}, you have <b>{{TIMEREMAINING}} left</b> in your trial.',
    TIMEREMAININGSHORT: '<b>{{TIMEREMAINING}} left</b> in your trial.',
    TRIALEXPIRED: 'Your trial has expired.',
    TRIALEXPIREDSHORT: 'Trial expired.'
  },
  UPDATEPAYMENT: {
    DESCRIPTION: 'This is your default payment method for all Volusion admin purchases.',
    DESCRIPTION_NOTE: 'This is your default payment method for all Volusion admin purchases.',
    LAUNCH_MODAL_BUTTON: 'Change Payment Method',
    LAUNCH_MODAL_BUTTON_ADD: 'Add Payment Method',
    MODAL_CANCEL: 'Cancel',
    MODAL_ERROR: 'There was an issue updating your payment info.',
    MODAL_SAVE: 'Save Changes',
    MODAL_TITLE: 'Change Payment Method',
    MODAL_TITLE_NEW: 'New Payment Method'
  },
  UPDATEPAYMENTCARD: {
    ENDINGIN: 'ending in',
    EXP: 'Exp:'
  },
  VARIANTS: {
    ADDGROUP: 'Add Variant Group',
    ADDGROUPCONFIRMBODY: 'Adding a variant group will remove the inventory currently being tracked.',
    ADDGROUPCONFIRMHEADING: 'Are You Sure?',
    ADDGROUPCONFIRMNO: 'Cancel',
    ADDGROUPCONFIRMYES: 'Add Variant Group',
    DELETETHIS: 'Delete this variant',
    ENTERTOCREATE: 'PRESS ENTER TO CREATE',
    INLINENAMEPLACEHOLDER: '(e.g. Size, Color)',
    INLINEVALUEPLACEHOLDER: '(e.g. Small, Brown, Canvas)',
    INSTRUCTIONS: 'Does your product come in multiple variations? Add variant groups and values for each variation of your product, then assign prices to each product variant.',
    MENUHIDE: 'Hide this variant',
    MENUPRICERESET: 'Reset price override',
    MENUSHOW: 'Show this variant',
    NAMEHEADER: 'Variant Name',
    PLURAL: 'VARIANTS',
    PRICEDIFFERENCE: 'Price difference',
    PRODUCTSHEADERIMAGES: 'Images',
    PRODUCTSHEADERPRICE: 'Price',
    PRODUCTSHEADERQUANTITY: 'Quantity',
    PRODUCTSHEADERSKU: 'SKU',
    PRODUCTSHEADERVARIANT: 'Variant',
    PRODUCTSQUANTITYNOTSET: 'Not Set',
    PRODUCTSTABLEHEADER: 'Edit Products',
    REMOVEGROUPCONFIRMBODY: 'Deleting this variant group will remove all associated variant products and their price differences.',
    REMOVEGROUPCONFIRMHEADING: 'Are You Sure?',
    REMOVEGROUPCONFIRMNO: 'Cancel',
    REMOVEGROUPCONFIRMWITHINVENTORYBODY: 'Deleting this variant group will remove all associated variant products, their price differences and inventory.',
    REMOVEGROUPCONFIRMYES: 'Delete Variant Group',
    RESETINVENTORY: 'Reset Inventory',
    SHOW: 'Show variant',
    STOPTRACKING: 'Stop Tracking Inventory',
    STOPTRACKINGVARIANTINVENTORYCONFIRMBODY: 'Stop tracking inventory for the variant \'{{VARIANT_SKU}}\'?',
    STOPTRACKINGVARIANTINVENTORYCONFIRMHEADING: 'Are You Sure?',
    STOPTRACKINGVARIANTINVENTORYCONFIRMNO: 'Cancel',
    STOPTRACKINGVARIANTINVENTORYCONFIRMYES: 'Stop Tracking Inventory',
    TABLECOLLAPSE: 'Collapse Table',
    TABLEEXPAND: 'Expand Table',
    VALUEHEADER: 'Variant Values',
    VARIANTIMAGES: 'Variant Images'
  },
  YOTPO: {
    CONNECT_YOTPO: 'Connect to Yotpo',
    DESCRIPTION: 'Leverage customer reviews and photos throughout the buyer journey to increase trust, social proof, and sales.',
    DISCONNECT: 'Disconnect Account',
    HEADING: 'Turn your happy customers into your best marketers',
    MANAGE: 'Manage Account',
    MANAGE_MESSAGE: 'Your Yotpo account is connected',
    TITLE: 'Yotpo',
    CONFIRM_DISCONNECT_TITLE: 'Disconnect Yotpo',
    CONFIRM_DISCONNECT_MESSAGE: 'Are you sure you want to disconnect? This will prevent Yotpo content like product reviews from being displayed on your store.',
    CONFIRM_DISCONNECT_ARIA: 'Confirm Disconnect Yotpo',
    CONFIRM_DISCONNECT_CONFIRM_TOAST: 'Yotpo successfully disconnected',
    CONFIRM_DISCONNECT_CANCEL_TOAST: 'Disconnect canceled'
  },
  DASHBOARD: {
    ADD_APP_TITLE: 'Add App',
    ADVISOR_CTA_CHAT: 'Chat now',
    ADVISOR_HELLO_TEXT: 'I’m dedicated to helping your business achieve success and growth. From best practices to industry standards, I’ll help you take your store to the next level.',
    DISMISS_CARD_MENU: 'Dismiss',
    FOOTER_BLOG_TITLE: 'Volusion Blog',
    FOOTER_BLOG_SUBTITLE: 'Fresh ecommerce insights from our in-house experts',
    FOOTER_GUIDES_TITLE: 'Ecommerce Guides',
    FOOTER_GUIDES_SUBTITLE: 'Comprehensive guides and online business resources',
    FOOTER_HELP_TITLE: 'Help Center',
    FOOTER_HELP_SUBTITLE: 'Reference expertly-written support articles and tutorials',
    FOOTER_SERVICES_TITLE: 'Volusion Design & Marketing Services',
    FOOTER_SERVICES_SUBTITLE: 'Our in-house and marketing team will create the perfect site for you',
    NOTICE_TRIAL_TITLE: 'Free Trial',
    NOTICE_TRIAL_EXPIRED: 'Your trial has expired. Start selling now!',
    NOTICE_TRIAL_TIME_REMAINING: 'You have {{TIMEREMAINING}} days left in your trial',
    NOTICE_TRIAL_ACTION: 'Select a Plan',
    NOTICE_ORDERS_TITLE: 'Orders',
    NOTICE_ORDERS_MESSAGE: 'You have {{ORDERCOUNT}} orders totalling {{ORDERTOTAL}}',
    NOTICE_ORDERS_ACTION: 'View Orders',
    SECTION_NEXTSTEPS_TRIAL_TITLE: 'Get Started',
    SECTION_NEXTSTEPS_TRIAL_SUBTITLE: 'Here are some recommended steps to set up your online store.',
    SECTION_NEXTSTEPS_TITLE: 'Apps to help you grow',
    SECTION_NEXTSTEPS_SUBTITLE: 'Try one of these top recommended apps to help your business.'
  },
  DASHBOARD_ANALYTICS: {
    MENU_TODAY: 'Today',
    MENU_YESTERDAY: 'Yesterday',
    MENU_7_DAYS: 'Last 7 Days',
    MENU_30_DAYS: 'Last 30 Days',
    MENU_MONTH: 'Month to Date'
  },
  DASHBOARD_ANNOUNCEMENT: {
    SUBTITLE: 'Introducing',
    TITLE: 'Your Store’s New Homepage',
    ANNOUNCEMENT_TEXT: 'Your new home page includes new order notifications and at-a-glance analytics. We’ll also start recommending new apps to help your business grow.',
    ANNOUNCEMENT_CTA: 'Got it - Let Me In'
  },
  NEXTSTEPS: {
    CARD_ACTIONS_VIDEO: 'Watch Video',
    CARD_THEMES_NAME: 'Themes',
    CARD_THEMES_FULL_HEADLINE: 'Pick the Perfect Look <br> for Your Brand',
    CARD_THEMES_SMALL_HEADLINE: 'Pick the Perfect Look for Your Brand',
    CARD_THEMES_FULL_CTA: 'Browse Themes',
    CARD_THEMES_COMPLETED_CTA: 'View Themes',
    CARD_THEMES_FULL_SUMMARY: 'Your theme is how your store looks to the world. Customize it right here.',
    CARD_THEMES_SMALL_SUMMARY: 'Your theme is how your store looks to the world. Customize it right here.',
    CARD_THEMES_COMPLETED_SUMMARY: 'Change your mind? You can customize your theme anytime.',
    CARD_PRODUCTS_NAME: 'Products',
    CARD_PRODUCTS_FULL_HEADLINE: 'Add a Product and <br> Start Selling',
    CARD_PRODUCTS_SMALL_HEADLINE: 'Add a Product and Start Selling',
    CARD_PRODUCTS_FULL_CTA: 'Add Products',
    CARD_PRODUCTS_COMPLETED_CTA: 'View Products',
    CARD_PRODUCTS_FULL_SUMMARY: 'You have products, so let’s get them on your shelves.',
    CARD_PRODUCTS_SMALL_SUMMARY: 'You have products, so let’s get them on your shelves.',
    CARD_PRODUCTS_COMPLETED_SUMMARY: 'You can always add products when you have new merch to sell.',
    CARD_CATEGORIES_NAME: 'Categories',
    CARD_CATEGORIES_FULL_HEADLINE: 'Organize Your Items <br> into Categories',
    CARD_CATEGORIES_SMALL_HEADLINE: 'Organize Your Items into Categories',
    CARD_CATEGORIES_FULL_CTA: 'Add Categories',
    CARD_CATEGORIES_COMPLETED_CTA: 'View Categories',
    CARD_CATEGORIES_FULL_SUMMARY: 'Add your products to a category or subcategory to organize your store.',
    CARD_CATEGORIES_SMALL_SUMMARY: 'Add your products to a category or subcategory to organize your store.',
    CARD_CATEGORIES_COMPLETED_SUMMARY: 'Switching things up? You can add or edit your categories anytime.',
    CARD_CUSTOMERS_NAME: 'Customers',
    CARD_CUSTOMERS_FULL_HEADLINE: 'Keep in Touch With Your Customers',
    CARD_CUSTOMERS_SMALL_HEADLINE: 'Customers',
    CARD_CUSTOMERS_FULL_CTA: 'View Customers',
    CARD_CUSTOMERS_COMPLETED_CTA: 'Customers',
    CARD_CUSTOMERS_FULL_SUMMARY: 'Manage relationships with your current and existing customers right here.',
    CARD_CUSTOMERS_SMALL_SUMMARY: 'Manage relationships with your current and existing customers right here.',
    CARD_CUSTOMERS_COMPLETED_SUMMARY: 'Manage your customers whenever you need.',
    CARD_PAGES_NAME: 'Pages',
    CARD_PAGES_FULL_HEADLINE: 'Tell Your Story with <br> Custom Pages',
    CARD_PAGES_SMALL_HEADLINE: 'Add Custom Pages',
    CARD_PAGES_FULL_CTA: 'Add Pages',
    CARD_PAGES_COMPLETED_CTA: 'View Pages',
    CARD_PAGES_FULL_SUMMARY: 'Create pages for contact info, about us, terms & conditions — whatever you want to share.',
    CARD_PAGES_SMALL_SUMMARY: 'Create pages for contact info, about us, terms & conditions — whatever you want to share.',
    CARD_PAGES_COMPLETED_SUMMARY: 'Add all the pages your heart desires.',
    CARD_APPSTORE_NAME: 'Integrations',
    CARD_APPSTORE_FULL_HEADLINE: 'Expand Your Toolbox With <br> Our Integrations',
    CARD_APPSTORE_SMALL_HEADLINE: 'Check out our Integrations',
    CARD_APPSTORE_FULL_CTA: 'View Integrations',
    CARD_APPSTORE_COMPLETED_CTA: 'View Integrations',
    CARD_APPSTORE_FULL_SUMMARY: 'Boost your business with our integrated apps.',
    CARD_APPSTORE_SMALL_SUMMARY: 'Boost your business with our integrated apps.',
    CARD_APPSTORE_COMPLETED_SUMMARY: 'Check out the Integrations for even more great additions to your site.',
    CARD_DISCOUNTS_NAME: 'Discounts',
    CARD_DISCOUNTS_FULL_HEADLINE: 'Entice Customers <br> with Discounts',
    CARD_DISCOUNTS_SMALL_HEADLINE: 'Create Discounts',
    CARD_DISCOUNTS_FULL_CTA: 'View App',
    CARD_DISCOUNTS_COMPLETED_CTA: 'Discounts',
    CARD_DISCOUNTS_FULL_SUMMARY: 'Improve conversions with deals on products, categories or throughout your store.',
    CARD_DISCOUNTS_SMALL_SUMMARY: 'Offer customers an even more enticing shopping experience.',
    CARD_DISCOUNTS_COMPLETED_SUMMARY: 'Create discounts to get customers coming back for more.',
    CARD_SHIPPO_NAME: 'Shippo',
    CARD_SHIPPO_FULL_HEADLINE: 'Handle Postage <br> with Ease',
    CARD_SHIPPO_SMALL_HEADLINE: 'Shippo',
    CARD_SHIPPO_FULL_CTA: 'View App',
    CARD_SHIPPO_COMPLETED_CTA: 'View App',
    CARD_SHIPPO_FULL_SUMMARY: 'Compare prices across carriers and then purchase and print shipping labels.',
    CARD_SHIPPO_SMALL_SUMMARY: 'Compare prices across carriers and then purchase and print shipping labels.',
    CARD_SHIPPO_COMPLETED_SUMMARY: 'Configure your postage preference whenever you need.',
    CARD_PINTEREST_NAME: 'Pinterest',
    CARD_PINTEREST_FULL_HEADLINE: 'Start Selling <br> on Pinterest',
    CARD_PINTEREST_SMALL_HEADLINE: 'Pinterest',
    CARD_PINTEREST_FULL_CTA: 'View App',
    CARD_PINTEREST_COMPLETED_CTA: 'View App',
    CARD_PINTEREST_FULL_SUMMARY: 'Connect your Pinterest account (or set one up) and post product images directly to your boards.',
    CARD_PINTEREST_SMALL_SUMMARY: 'Connect your Pinterest account (or set one up) and post product images directly to your boards.',
    CARD_PINTEREST_COMPLETED_SUMMARY: 'Configure your Pinterest app any time you need.',
    CARD_FACEBOOKPIXEL_NAME: 'Facebook Pixel',
    CARD_FACEBOOKPIXEL_FULL_HEADLINE: 'Track Facebook Ad <br> Performance',
    CARD_FACEBOOKPIXEL_SMALL_HEADLINE: 'Facebook Pixel',
    CARD_FACEBOOKPIXEL_FULL_CTA: 'Install Pixel',
    CARD_FACEBOOKPIXEL_COMPLETED_CTA: 'View App',
    CARD_FACEBOOKPIXEL_FULL_SUMMARY: 'See how well your ads are doingwith Facebook Pixel.',
    CARD_FACEBOOKPIXEL_SMALL_SUMMARY: 'See how well your ads are doing with Facebook Pixel.',
    CARD_FACEBOOKPIXEL_COMPLETED_SUMMARY: 'Configure your Facebook Pixel whenever you’d like.',
    CARD_FULLSTORY_NAME: 'Fullstory',
    CARD_FULLSTORY_FULL_HEADLINE: 'View Your <br> Visitor Activity',
    CARD_FULLSTORY_SMALL_HEADLINE: 'Fullstory',
    CARD_FULLSTORY_FULL_CTA: 'View App',
    CARD_FULLSTORY_COMPLETED_CTA: 'View App',
    CARD_FULLSTORY_FULL_SUMMARY: 'View all in-browser interactions with Fullstory.',
    CARD_FULLSTORY_SMALL_SUMMARY: 'View all in-browser interactions with Fullstory.',
    CARD_FULLSTORY_COMPLETED_SUMMARY: 'Configure Fullstory anytime.',
    CARD_GOOGLEANALYTICS_NAME: 'Google Analytics',
    CARD_GOOGLEANALYTICS_FULL_HEADLINE: 'Track Store Data <br> with Google Analytics',
    CARD_GOOGLEANALYTICS_SMALL_HEADLINE: 'Google Analytics',
    CARD_GOOGLEANALYTICS_FULL_CTA: 'View App',
    CARD_GOOGLEANALYTICS_COMPLETED_CTA: 'View App',
    CARD_GOOGLEANALYTICS_FULL_SUMMARY: 'Send your site’s data to Google Analytics with our easy integration.',
    CARD_GOOGLEANALYTICS_SMALL_SUMMARY: 'Send your site’s data to Google Analytics with our easy integration.',
    CARD_GOOGLEANALYTICS_COMPLETED_SUMMARY: 'Configure your Google Analytics App Settings anytime.',
    CARD_PRIVY_NAME: 'Privy',
    CARD_PRIVY_FULL_HEADLINE: 'Manage Your Email <br> Lists With Privy',
    CARD_PRIVY_SMALL_HEADLINE: 'Privy',
    CARD_PRIVY_FULL_CTA: 'View App',
    CARD_PRIVY_COMPLETED_CTA: 'View App',
    CARD_PRIVY_FULL_SUMMARY: 'Build your email lists for promotions, newsletters blogs and more.',
    CARD_PRIVY_SMALL_SUMMARY: 'Build your email lists for promotions, newsletters blogs and more.',
    CARD_PRIVY_COMPLETED_SUMMARY: 'Manage your email lists whenever works for you.',
    CARD_SETTINGS_NAME: 'Settings',
    CARD_SETTINGS_FULL_HEADLINE: 'Set Up Payments <br> & Shipping',
    CARD_SETTINGS_SMALL_HEADLINE: 'Set up Payments & Shipping',
    CARD_SETTINGS_FULL_CTA: 'Go To Settings',
    CARD_SETTINGS_COMPLETED_CTA: 'View Settings',
    CARD_SETTINGS_FULL_SUMMARY: 'Configure your store information, along with payment and shipping methods.',
    CARD_SETTINGS_SMALL_SUMMARY: 'Configure your store information, along with payment and shipping methods.',
    CARD_SETTINGS_COMPLETED_SUMMARY: 'You can make changes to your store settings whenever you’d like.',
    CARD_STOREEDITOR_NAME: 'Store Editor',
    CARD_STOREEDITOR_FULL_HEADLINE: 'Customize the Look + Feel <br> of Your Site',
    CARD_STOREEDITOR_SMALL_HEADLINE: 'Edit Your Site',
    CARD_STOREEDITOR_FULL_CTA: 'Edit Site',
    CARD_STOREEDITOR_COMPLETED_CTA: 'Edit Store',
    CARD_STOREEDITOR_FULL_SUMMARY: 'Check out your storefront website to personalize your content and style.',
    CARD_STOREEDITOR_SMALL_SUMMARY: 'Check out your storefront website topersonalize your content and style.',
    CARD_STOREEDITOR_COMPLETED_SUMMARY: 'Continue customizing or move on to the next step.',
    CARD_LOGO_NAME: 'Logo',
    CARD_LOGO_FULL_HEADLINE: 'Stand Out with <br> a Store Logo',
    CARD_LOGO_SMALL_HEADLINE: 'Logo',
    CARD_LOGO_FULL_CTA: 'Upload Logo',
    CARD_LOGO_COMPLETED_CTA: 'Update Logo',
    CARD_LOGO_FULL_SUMMARY: 'Give your site a personal touch by adding your own logo.',
    CARD_LOGO_SMALL_SUMMARY: 'Give your site a personal touch by adding your own logo.',
    CARD_LOGO_COMPLETED_SUMMARY: 'Need a new look? You can change your logo at any time.',
    CARD_MENU_NAME: 'Menu',
    CARD_MENU_FULL_HEADLINE: 'Add Your <br> Site’s Navigation',
    CARD_MENU_SMALL_HEADLINE: 'Menu',
    CARD_MENU_FULL_CTA: 'Edit Menu',
    CARD_MENU_COMPLETED_CTA: 'Update Menu',
    CARD_MENU_FULL_SUMMARY: 'Direct your customers where you want them to go by adding a menu.',
    CARD_MENU_SMALL_SUMMARY: 'Direct your customers where you want them to go by adding a menu.',
    CARD_MENU_COMPLETED_SUMMARY: 'Switching it up? You can change your menu at any time.',
    CARD_ANALYTICS_NAME: 'Analytics',
    CARD_ANALYTICS_FULL_HEADLINE: 'Track Your Store’s Success',
    CARD_ANALYTICS_SMALL_HEADLINE: 'Analytics',
    CARD_ANALYTICS_FULL_CTA: 'View Analytics',
    CARD_ANALYTICS_COMPLETED_CTA: 'Analytics',
    CARD_ANALYTICS_FULL_SUMMARY: 'Use our Analytics app to see metrics like site visits and sales performance.',
    CARD_ANALYTICS_SMALL_SUMMARY: 'Use our Analytics app to see metrics like site visits and sales performance.',
    CARD_ANALYTICS_COMPLETED_SUMMARY: 'View your site’s performance at anytime.',
    CARD_MAILCHIMP_NAME: 'MailChimp',
    CARD_MAILCHIMP_FULL_HEADLINE: 'Automate <br> Your Emails',
    CARD_MAILCHIMP_SMALL_HEADLINE: 'MailChimp',
    CARD_MAILCHIMP_FULL_CTA: 'View App',
    CARD_MAILCHIMP_COMPLETED_CTA: 'View App',
    CARD_MAILCHIMP_FULL_SUMMARY: 'Set up, track and measure email effectiveness with your customers.',
    CARD_MAILCHIMP_SMALL_SUMMARY: 'Set up, track and measure email effectiveness with your customers.',
    CARD_MAILCHIMP_COMPLETED_SUMMARY: 'Configure your MailChimp settings anytime.',
    COMPLETE_LABEL_ADD_ANOTHER: 'Add Another',
    COMPLETE_PRODUCT_TITLE: 'Product Added',
    COMPLETE_PRODUCT_SUBTITLE: 'View your product on your storefront or add another',
    COMPLETE_PRODUCT_CTA_LABEL: 'View Product',
    COMPLETE_PRODUCT_INITIAL_STEP_MESSAGE: 'Add a Category',
    COMPLETE_CUSTOMERS_TITLE: 'Customer Added!',
    COMPLETE_CUSTOMERS_SUBTITLE: '',
    COMPLETE_CUSTOMERS_CTA_LABEL: 'Add Another',
    COMPLETE_CUSTOMERS_INITIAL_STEP_MESSAGE: 'Set Up an Email List with Mailchimp',
    COMPLETE_SETTINGS_TITLE: 'Initial Setup Complete',
    COMPLETE_SETTINGS_SUBTITLE: 'Make changes to your payments, shipping and other store info here',
    COMPLETE_CATEGORY_TITLE: 'Category Added',
    COMPLETE_CATEGORY_SUBTITLE: 'View your category on your storefront or add another',
    COMPLETE_CATEGORY_CTA_LABEL: 'View Category',
    COMPLETE_CATEGORY_INITIAL_STEP_MESSAGE: 'Organize your Menu',
    COMPLETE_THEME_TITLE: '{{THEMENAME}} Theme is now live!',
    COMPLETE_THEME_SUBTITLE: 'View your storefront or try customizing your theme’s appearance',
    COMPLETE_THEME_CTA_LABEL: 'Customize Theme',
    COMPLETE_PAGES_TITLE: 'Page Added!',
    COMPLETE_PAGES_SUBTITLE: 'View your page on your storefront or add another',
    COMPLETE_PAGES_INITIAL_STEP_MESSAGE: 'Organize your Menu',
    COMPLETE_PAGES_CTA_LABEL: 'View Page',
    OPEN_STOREFRONT: 'View Storefront',
    LABEL_NEXT_STEP: 'Next Step:'
  },
  CUSTOMER_ACCOUNT_INFO: {
    TITLE: 'Account info',
    ACCOUNT_ACTIVE: 'Active',
    ACCOUNT_INACTIVE: 'Not created',
    ACCOUNT_INACTIVE_LONG: 'Customer has not created an account',
    CREATED_ON: 'Created on'
  },
  CUSTOMER_ADDRESS_FORM: {
    FIRST_NAME_PLACEHOLDER: 'First name',
    FIRST_NAME_ERROR_REQUIRED: 'First name is required.',
    LAST_NAME_PLACEHOLDER: 'Last name',
    LAST_NAME_ERROR_REQUIRED: 'Last name is required.',
    ADDRESS_1_PLACEHOLDER: 'Address 1',
    ADDRESS_1_ERROR_REQUIRED: 'Address 1 is required.',
    ADDRESS_2_PLACEHOLDER: 'Address 2',
    CITY_PLACEHOLDER: 'City',
    CITY_ERROR_REQUIRED: 'City is required.',
    CITY_ERROR_NO_SPECIAL: 'City must not contain special characters.',
    STATE_PLACEHOLDER: 'State',
    ZIP_PLACEHOLDER: 'Zip',
    ZIP_ERROR_REQUIRED: 'ZIP Code is required.',
    ZIP_ERROR_FORMAT: 'ZIP Code must be in the proper format.'
  },
  CUSTOMER_CONTACT_INFO_FORM: {
    TITLE: 'Contact info',
    ACCEPTS_MARKETING: 'Accepts marketing',
    EMAIL_BUTTON: 'Email',
    CALL_BUTTON: 'Call',
    FIRST_NAME_PLACEHOLDER: 'First name',
    LAST_NAME_PLACEHOLDER: 'Last name',
    EMAIL_PLACEHOLDER: 'Email',
    EMAIL_ERROR_VALID: 'A valid email is required',
    EMAIL_ERROR_REQUIRED: 'Email is required.',
    PHONE_PLACEHOLDER: 'Phone number',
    PHONE_ERROR_VALID: 'Please enter a valid phone number.',
    ACCEPTS_MARKETING_CHECKBOX: 'Customer accepts marketing'
  },
  CUSTOMER_NOTES_FORM: {
    TITLE: 'Notes',
    PLACEHOLDER: 'Add private customer notes here',
    INTERNAL: 'Internal use only'
  },
  AVALARA_ENTITY_USE_CODE_FORM: {
    TITLE: 'Entity Use Code',
    INTERNAL: 'For exemptions in AvaTax and other Avalara applications'
  },
  CUSTOMER_SUMMARY: {
    CUSTOMER_SINCE: 'Customer since',
    NO_ORDERS: 'has not yet placed an order.',
    HAS_PLACED: 'has placed',
    TOTAL: 'for a total of'
  },
  CUSTOMER_ORDER_HISTORY: {
    AVERAGE: 'average',
    NO_ORDERS: 'No orders to display',
    NO_ORDERS_LONG: 'Customer has not yet placed an order',
    ORDER_NUMBER: 'Order #',
    ORDER_PLACED: 'Order Placed',
    ORDER_STATUS: 'Order Status',
    ORDER_TOTAL: 'Order Total',
    TITLE: 'Order History'
  },
  CUSTOMER_SHIPPING_ADDRESS: {
    TITLE: 'Shipping addresses',
    NO_ADDRESSES: 'No shipping addresses to display',
    ADD_ADDRESS: 'Add new shipping address',
    DEFAULT: 'Default',
    EDIT: 'Edit',
    SET_DEFAULT_CHECKBOX: 'Set as default shipping address',
    CANCEL: 'Cancel',
    DELETE: 'Delete',
    MODAL_ADD_TITLE: 'Add shipping address',
    MODAL_ADD_CONFIRM: 'Add address',
    MODAL_EDIT_TITLE: 'Edit shipping address',
    MODAL_EDIT_CONFIRM: 'Edit address'
  },
  VIDEOSLIDER: {
    CATEGORIES_TITLE: 'Add a Category',
    CATEGORIES_TEXT: '<p>Creating a category groups and displays products together which makes it easier for your customers to find what they are looking for.</p><ol><li>Go to the Categories app</li><li>Click add a category</li><li>Give your category a name</li><li>Provide a description</li><li>Save</li></ol><p>To add your categories to your site\'s menu, go to the store editor app and tap on Menu. From there click the add button and select the category you wish to add!</p><p>Volusion makes it easy to organize your products so your customers spend less wonderingwhere to go and more time shopping.</p>',
    LOGO_TITLE: 'Upload a Logo',
    LOGO_TEXT: '<p>Personalize your Site by adding your company\'s logo.</p><p>To upload a logo:</p><ol><li>Go to the Store Editor App</li><li>Tap on Logo</li><li>Drag an image or browse your gallery to upload an image</li><li>Save</li></ol><p>Keep it simple! If you don\'t have an image, don\'t worry, your Store\'s name will populate by default.</p><p>Pro tip, make sure your logo looks good on mobile resolution as well!</p>',
    PAGES_TITLE: 'Add a Page',
    PAGES_TEXT: '<p>Pages are great for sharing your blog, and general information about your store.</p><ol><li>Go to the Pages app</li><li>Click add a page</li><li>Add a title to your page</li><li>Add content</li><li>Save</li></ol><p>Optionally you can add videos, images, or links in your description. Don\'t forget to put some meta information so search engines can find your product.</p>',
    PRODUCTS_TITLE: 'Add a Product',
    PRODUCTS_TEXT: '<p>Adding products one by one is easy:</p><ol><li>Go to the Products app</li><li>Click add a product</li><li>Name your product</li><li>Give it a price</li><li>Add an image and description</li><li>Save</li></ol><p>Optionally you can add a sales price and weight to your product. Don\'t forget to add some meta information so search engines can find your product. If you have multiple variations of your product you can add variants too!</p>',
    SETTINGS_TITLE: 'Configure your Settings',
    SETTINGS_TEXT: '<p>Before you start selling, you have to setup and review your Store settings. There are some important information you must configure so let\'s get started!</p><ol><li>Go to the Settings app</li><li>Add your Store\'s location</li><li>Choose how you will take payment</li><li>Configure your shipping options</li><li>Choose a name for your store (optional)</li></ol><p>Don\'t worry if you are not completely sure on this info, you can edit this information at anytime. If you already have a custom domain, you can also add it here in Settings.</p>',
    THEMES_TITLE: 'Choose a Theme',
    THEMES_TEXT: '<p>Themes change the look of your store, you can customize the font, colors, images, and more!</p><p>To install a theme:</p><ol><li>Go to the Theme Store app</li><li>Choose a theme that you like</li><li>Tap Install and confirm</li></ol><p>To edit your theme tap the Pencil icon in the preview panel, or go to the Store Editor app and customize the look of your Site!</p>'
  }
}).name;
/* eslint-enable max-len */

exports.AppLabelsModule = AppLabelsModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedirectsModule = exports.launchDarklyKey = exports.redirects = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _get = _interopRequireDefault(__webpack_require__(34));

var _launchDarkly = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Finished pages in new admin
var redirects = [{
  from: 'dashboard',
  to: '/',
  launchDarklyKey: 'dashboard'
}, {
  from: 'order.list',
  to: '/orders/all',
  launchDarklyKey: 'orders'
}, {
  from: 'order.add',
  to: '/orders/create',
  launchDarklyKey: 'orders'
}, {
  from: 'order.edit',
  to: function to(_ref) {
    var id = _ref.id;
    return "/orders/".concat(id, "/edit");
  },
  launchDarklyKey: 'orders'
}, {
  from: 'order.detail',
  to: function to(_ref2) {
    var id = _ref2.id;
    return "/orders/".concat(id);
  },
  launchDarklyKey: 'orders'
}, {
  from: 'packingSlip',
  to: function to(_ref3) {
    var id = _ref3.id;
    return "/orders/".concat(id, "/shipping-label");
  },
  launchDarklyKey: 'orders'
}, {
  from: 'shippingLabel',
  to: function to(_ref4) {
    var id = _ref4.id;
    return "/orders/".concat(id, "/packing-slip");
  },
  launchDarklyKey: 'orders'
}, {
  from: 'invoiceToShopper',
  to: function to(_ref5) {
    var id = _ref5.id;
    return "/orders/".concat(id, "/invoice-to-shopper");
  },
  launchDarklyKey: 'orders'
}, {
  from: 'product.list',
  to: '/products/all',
  launchDarklyKey: 'products.list'
}, {
  from: 'product.list',
  to: '/products/all',
  launchDarklyKey: 'products'
}, {
  from: 'product.add',
  to: '/products/create',
  launchDarklyKey: 'products'
}, {
  from: 'product.detail',
  to: function to(_ref6) {
    var id = _ref6.id;
    return "/products/".concat(id);
  },
  launchDarklyKey: 'products'
}, {
  from: 'category.list',
  to: '/categories/all',
  launchDarklyKey: 'categories'
}, {
  from: 'category.add',
  to: '/categories/create',
  launchDarklyKey: 'categories'
}, {
  from: 'category.detail',
  to: function to(_ref7) {
    var id = _ref7.id;
    return "/categories/".concat(id);
  },
  launchDarklyKey: 'categories'
}, {
  from: 'customer.list',
  to: '/customers/all',
  launchDarklyKey: 'customers'
}, {
  from: 'customer.add',
  to: '/customers/create',
  launchDarklyKey: 'customers'
}, {
  from: 'customer.detail',
  to: function to(_ref8) {
    var id = _ref8.id;
    return "/customers/".concat(id);
  },
  launchDarklyKey: 'customers'
}, {
  from: 'appstore2.installedapps2',
  to: '/apps/installed',
  launchDarklyKey: 'apps'
}, {
  from: 'appstore2.allapps2',
  to: '/apps/all',
  launchDarklyKey: 'apps'
}, {
  from: 'settings.detail',
  to: '/settings/store',
  launchDarklyKey: 'settings'
}, {
  from: 'settings.payments',
  to: '/settings/payments',
  launchDarklyKey: 'settings'
}, {
  from: 'settings.shipping',
  to: '/settings/shipping',
  launchDarklyKey: 'settings'
}, {
  from: 'settings.seo',
  to: '/settings/seo',
  launchDarklyKey: 'settings'
}, {
  from: 'settings.authorizeNet',
  to: '/settings/volusionpayments/application',
  launchDarklyKey: 'settings'
}, {
  from: 'analytics.main',
  to: '/analytics',
  launchDarklyKey: 'analytics'
}, {
  from: 'analytics.abandonedCartsList',
  to: '/analytics/carts',
  launchDarklyKey: 'analytics'
}, {
  from: 'analytics.abandonedCartDetail',
  to: function to(_ref9) {
    var id = _ref9.id;
    return "/analytics/carts/".concat(id);
  },
  launchDarklyKey: 'analytics'
}, {
  from: 'designer',
  to: '/designer',
  launchDarklyKey: 'siteDesigner'
}, {
  from: 'pages.list',
  to: '/pages/all',
  launchDarklyKey: 'pages'
}, {
  from: 'pages.add',
  to: '/pages/create',
  launchDarklyKey: 'pages'
}, {
  from: 'pages.detail',
  to: function to(_ref10) {
    var id = _ref10.id;
    return "/pages/".concat(id);
  },
  launchDarklyKey: 'pages'
}, // Menu redirect is handled in pages/editstore/editstore.module.js
// { from: 'editstore.menu', to: '/menu', launchDarklyKey: 'menuEditor' },
{
  from: 'myAccount',
  to: '/my-account',
  launchDarklyKey: 'myAccount'
}, {
  from: 'cancelStore',
  to: '/my-account/cancel-store',
  launchDarklyKey: 'myAccount'
}, {
  from: 'discounts.list',
  to: '/discounts/all',
  launchDarklyKey: 'discounts'
}, {
  from: 'discounts.add',
  to: '/discounts/create',
  launchDarklyKey: 'discounts'
}, {
  from: 'discounts.detail',
  to: function to(_ref11) {
    var id = _ref11.id;
    return "/discounts/".concat(id);
  },
  launchDarklyKey: 'discounts'
}, {
  from: 'fulfillers.*',
  to: '/apps/fulfillers',
  launchDarklyKey: 'fulfillers'
}, {
  from: 'googleAnalytics',
  to: '/apps/googleanalytics',
  launchDarklyKey: 'googleAnalytics'
}, {
  from: 'postage.*',
  to: '/apps/shipping',
  launchDarklyKey: 'shippo'
}, {
  from: 'pinterest',
  to: '/apps/pinterest',
  launchDarklyKey: 'pinterest'
}, {
  from: 'yotpo',
  to: '/apps/yotpo',
  launchDarklyKey: 'yotpo'
}, {
  from: 'mailchimp',
  to: '/apps/mailchimp',
  launchDarklyKey: 'mailchimp'
}, {
  from: 'facebookPixel',
  to: '/apps/facebookpixel',
  launchDarklyKey: 'facebookpixel'
}, {
  from: 'fullstory',
  to: '/apps/fullstory',
  launchDarklyKey: 'fullstory'
}, {
  from: 'privy',
  to: '/apps/privy',
  launchDarklyKey: 'privy'
}, {
  from: 'zapier',
  to: '/apps/zapier',
  launchDarklyKey: 'zapier'
}, {
  from: 'chat',
  to: '/apps/chat',
  launchDarklyKey: 'chat'
}, {
  from: 'amazon',
  to: '/apps/amazon',
  launchDarklyKey: 'amazon'
}, {
  from: 'quickbooks',
  to: '/apps/quickbooks',
  launchDarklyKey: 'quickbooks'
}, {
  from: 'xero',
  to: '/apps/xero',
  launchDarklyKey: 'xero'
}, {
  from: 'globalshopex',
  to: '/apps/globalshopex',
  launchDarklyKey: 'globalshopex'
}, {
  from: 'avalara',
  to: '/avalara'
}, {
  from: 'storeCredit',
  to: '/storeCredit/all',
  launchDarklyKey: 'storeCredit'
}, {
  from: 'storeCredit.add',
  to: '/storeCredit/create',
  launchDarklyKey: 'storeCredit'
}, {
  from: 'storeCredit.detail',
  to: function to(_ref12) {
    var storeCreditId = _ref12.storeCreditId;
    return "/storeCredit/".concat(storeCreditId);
  },
  launchDarklyKey: 'storeCredit'
}];
exports.redirects = redirects;
var launchDarklyKey = 'new-admin-features-enabled';
exports.launchDarklyKey = launchDarklyKey;
var RedirectsModule = angular.module('app.services.redirects', [_launchDarkly.LaunchDarklyServiceModule, _angularjs.default]).service('redirectsService', ["$transitions", "launchDarklyService", "$q", function ($transitions, launchDarklyService, $q) {
  var service = {
    registerRedirects: registerRedirects,
    getRedirectPath: getRedirectPath,
    getEnabledRedirects: getEnabledRedirects,
    registerRedirectTransitionHooks: registerRedirectTransitionHooks
  };

  function registerRedirects() {
    return getEnabledRedirects(redirects).then(function (enabledRedirects) {
      return registerRedirectTransitionHooks(enabledRedirects);
    });
  }

  function getRedirectPath(to, urlParams) {
    var path;

    switch (_typeof(to)) {
      case 'string':
        path = to;
        break;

      case 'function':
        path = to(urlParams);
        break;

      default:
        path = '';
        break;
    }

    return path;
  }

  function registerRedirectTransitionHooks(enabledRedirects) {
    // eslint-disable-next-line no-console
    console.log('Enabled redirects to new admin', enabledRedirects);
    var hooks = enabledRedirects.map(function (redirect) {
      return $transitions.onStart({
        to: redirect.from
      }, function (transition) {
        var transitionParams = transition.targetState().params();
        var params = Object.keys(transitionParams).map(function (param) {
          return "".concat(param, "=").concat(encodeURIComponent(transitionParams[param]));
        });
        var serializedParams = params.length ? "?".concat(params.join('&')) : '';
        var redirectPath = getRedirectPath(redirect.to, transition._targetState._params);
        window.location.href = "".concat("https://admin-sandbox.volusion.com/admin").concat(redirectPath).concat(serializedParams); // Prevent transition from finishing

        return false;
      });
    });
    return function () {
      return hooks.forEach(function (unregisterHook) {
        return unregisterHook();
      });
    };
  }

  function getEnabledRedirects(allRedirects) {
    var initLD = launchDarklyService.initialized ? $q.resolve : launchDarklyService.initFromToken;
    return initLD().then(function () {
      return launchDarklyService.allFlags().then(function (flags) {
        var enabledFeatureKeys = (0, _get.default)(flags, launchDarklyKey, []);
        return allRedirects.filter(function (redirect) {
          return enabledFeatureKeys.includes(redirect.launchDarklyKey) || !redirect.launchDarklyKey;
        });
      });
    });
  }

  return service;
}]).name;
exports.RedirectsModule = RedirectsModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1650 */,
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TcGridModule = void 0;

var _tcGrid = __webpack_require__(1520);

var _tcColumn = __webpack_require__(1523);

// https://github.com/ThirdCornerLLC/tc-grid
var TcGridModule = angular.module('tc-grid', []).directive('tcGrid', _tcGrid.tcGridDirective).directive('tcColumn', _tcColumn.tcColumnDirective).name;
exports.TcGridModule = TcGridModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridController = void 0;

__webpack_require__(7);

var _assign = _interopRequireDefault(__webpack_require__(5));

var _each = _interopRequireDefault(__webpack_require__(162));

var _find = _interopRequireDefault(__webpack_require__(66));

var _some = _interopRequireDefault(__webpack_require__(194));

var _remove2 = _interopRequireDefault(__webpack_require__(193));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//eslint-disable-next-line no-unused-vars
var GridController =
/*#__PURE__*/
function () {
  function GridController($window, $location, $state, $translate, $mdToast, $mdDialog, $timeout, gridService, loadingModalService, endpoint, gtmid) {
    _classCallCheck(this, GridController);

    (0, _assign.default)(this, {
      _endpoint: endpoint,
      $window: $window,
      $state: $state,
      $mdToast: $mdToast,
      $mdDialog: $mdDialog,
      $translate: $translate,
      $timeout: $timeout,
      gridService: gridService,
      loadingModalService: loadingModalService,
      filter: $location.search().filter
    });
    this.grid = {
      options: this.gridService.getDefaultOptions(this._endpoint, this.onDataResponse.bind(this), this.filter, gtmid),
      items: [],
      selected: [],
      allSelected: false
    };

    if (this.filter) {
      this.filter = this.filter && this.filter !== 'All' ? "state eq \"".concat(this.filter, "\"") : null;
      this.gridService.updateGridCallbacks(this._endpoint, this.filter, this.grid.options, this.onDataResponse.bind(this));
    }
  }

  _createClass(GridController, [{
    key: "setFilter",
    value: function setFilter(newFilter) {
      var _this = this;

      this.gridService.updateGridCallbacks(this._endpoint, newFilter, this.grid.options, this.onDataResponse.bind(this)); // fetch new items and render to grid

      this.$timeout(function () {
        //reset grid back to page 1
        _this.grid.items = [];
        _this.grid.options.paging.currentPage = 1;

        _this.grid.options.sorting.onSortChange(null, null, _this.grid.options.sorting.sort);
      });
    }
  }, {
    key: "onDataResponse",
    value: function onDataResponse(response, type) {
      var _this2 = this;

      this.grid.options.isLoading = false;
      this.grid.options.scrollLoader = false; // type for customer/product lists is undefined

      this.grid.items = type === 'page' ? this.grid.items.concat(response.items) : this.grid.items = response.items;
      this.grid.options.paging.totalItemCount = response.totalCount || response.total;
      (0, _each.default)(this.grid.selected, function (selected) {
        var item = (0, _find.default)(_this2.grid.items, {
          id: selected.id
        });

        if (item) {
          item.selected = true;
        }
      });
      this.checkAll();
    }
  }, {
    key: "areAllSelected",
    value: function areAllSelected() {
      if (this.grid.items.length) {
        return !(0, _some.default)(this.grid.items, function (item) {
          return !item.selected;
        });
      }
    }
  }, {
    key: "select",
    value: function select(row) {
      if ((0, _some.default)(this.grid.selected, {
        id: row.id
      })) {
        (0, _remove2.default)(this.grid.selected, {
          id: row.id
        });
        row.selected = false;
      } else {
        this.grid.selected.push(row);
        row.selected = true;
      }

      this.checkAll();

      if (this.$window.dataLayer) {
        this.$window.dataLayer.push({
          event: "admin_".concat(this.$state.current.name, "-gridSelectRow")
        });
      }
    }
  }, {
    key: "selectAll",
    value: function selectAll() {
      var _this3 = this;

      if (!this.areAllSelected()) {
        (0, _each.default)(this.grid.items, function (item) {
          if (!(0, _some.default)(_this3.grid.selected, {
            id: item.id
          })) {
            item.selected = true;

            _this3.grid.selected.push(item);
          }
        });
        this.grid.allSelected = true;
      } else {
        (0, _each.default)(this.grid.items, function (item) {
          item.selected = false;
          (0, _remove2.default)(_this3.grid.selected, {
            id: item.id
          });
        });
        this.grid.allSelected = false;
      }

      if (this.$window.dataLayer) {
        this.$window.dataLayer.push({
          event: "admin_".concat(this.$state.current.name, "-gridSelectAll")
        });
      }
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      while (this.grid.selected.length > 0) {
        var item = this.grid.selected.shift();
        item.selected = false;
      }

      this.grid.allSelected = false;
    }
  }, {
    key: "checkAll",
    value: function checkAll() {
      this.grid.allSelected = this.areAllSelected();
    }
  }, {
    key: "openRow",
    value: function openRow(row, location) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (this.hasRowLoading()) return;
      row.loading = true;
      this.$state.go(location, _objectSpread({
        id: row.id
      }, params));
    }
  }, {
    key: "hasRowLoading",
    value: function hasRowLoading() {
      return (0, _some.default)(this.grid.items, ['loading', true]);
    }
  }, {
    key: "remove",
    value: function remove(row, type, fromBulk, translationRoot) {
      var _this4 = this;

      if (this.$window.dataLayer && !fromBulk) {
        this.$window.dataLayer.push({
          event: "admin_".concat(this.$state.current.name, "-gridDeleteRow")
        });
      }

      if (!translationRoot) translationRoot = type.toUpperCase();
      return this.openDeleteModal(row, translationRoot).then(function () {
        return _this4.gridService.remove(_this4._endpoint, row);
      }).then(function (response) {
        (0, _remove2.default)(_this4.grid.items, {
          id: row.id
        });

        _this4.sendDeleteToast(row);

        var options = _this4.grid.options;
        _this4.grid.selected.length = 0;
        options.sorting.onSortChange(options.paging.currentPage, options.totalItemCount, options.sorting.sort);
        return response;
      });
    }
  }, {
    key: "removeBulk",
    value: function removeBulk(type, translationRoot) {
      var _this5 = this;

      if (!translationRoot) translationRoot = type.toUpperCase();

      if (this.grid.selected.length === 1) {
        return this.remove(this.grid.selected[0], type, true, translationRoot);
      }

      return this.openDeleteModal(this.grid.selected, translationRoot).then(function () {
        (0, _remove2.default)(_this5.grid.items, function (item) {
          return (0, _some.default)(_this5.grid.selected, {
            id: item.id
          });
        });

        _this5.loadingModalService.show();

        return _this5.gridService.removeAll(_this5._endpoint, _this5.grid.selected);
      }).then(function (response) {
        _this5.sendBulkDeleteToast(_this5.grid.selected.length, translationRoot);

        _this5.grid.selected.length = 0;
        var options = _this5.grid.options;
        options.sorting.onSortChange(options.paging.currentPage, options.totalItemCount, options.sorting.sort);

        _this5.checkAll();

        return response;
      }).finally(function () {
        _this5.loadingModalService.hide();
      });
    }
  }, {
    key: "sendDeleteToast",
    value: function sendDeleteToast(item) {
      var _this6 = this;

      this.$translate('TOAST.SUCCESSFULLYREMOVED', {
        NAME: item.name
      }).then(function (message) {
        _this6.$mdToast.show(_this6.$mdToast.simple().textContent(message).position('top right').hideDelay(5000));
      });
    }
  }, {
    key: "sendBulkDeleteToast",
    value: function sendBulkDeleteToast(count, type) {
      var _this7 = this;

      this.$translate("".concat(type, ".PLURAL")).then(function (translateType) {
        _this7.$translate('TOAST.MULTIREMOVE', {
          COUNT: count,
          TYPE: translateType
        }).then(function (message) {
          _this7.$mdToast.show(_this7.$mdToast.simple().textContent(message).position('top right').hideDelay(5000));
        });
      });
    }
  }, {
    key: "openDeleteModal",
    value: function openDeleteModal(obj, type) {
      var dialogOptions = {
        clickOutsideToClose: true,
        template: "<delete-modal\n            item-count=\"".concat(Array.isArray(obj) ? obj.length : 1, "\"\n            item-type=\"'").concat(type, "'\"\n            is-detail=\"false\"></delete-modal>")
      };
      return this.$mdDialog.show(dialogOptions);
    }
  }]);

  return GridController;
}();

exports.GridController = GridController;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageCircles = void 0;

__webpack_require__(1535);

var ImageCircles = angular.module('app.components.imageCircle', []).component('imageCircles', {
  template: "\n            <div class=\"image-circle-group\">\n                <image-circle\n                    ng-repeat=\"item in $ctrl.items | limitTo: $ctrl.numToShow track by $index\"\n                    image-uri=\"item.image\"\n                    badge=\"item.badge || $ctrl.badge\"\n                    style=\"height: {{$ctrl.size}}px; width: {{$ctrl.size}}px; font-size: {{$ctrl.size}}px;\">\n                </image-circle>\n                <image-circle ng-if=\"($ctrl.plusButton && $ctrl.items.length === 0)\" \n                              plus-button=\"$ctrl.plusButton\" badge=\"$ctrl.badge\" class=\"image-circle__button\"\n                              style=\"height: {{$ctrl.size}}px; width: {{$ctrl.size}}px; font-size: {{$ctrl.size}}px;\">\n                </image-circle>\n            </div>\n        ",
  bindings: {
    items: '<',
    numToShow: '<',
    badge: '<',
    size: '<',
    plusButton: '<'
  }
}).component('imageCircle', {
  template: "\n            <div class=\"image-circle\"\n                ng-class=\"{'image-circle--more': $ctrl.showMore}\"\n                style=\"background-image: url('{{$ctrl.imageUri}}');\">\n                <md-icon ng-if=\"(!$ctrl.plusButton && (!$ctrl.imageUri || $ctrl.imageUri === ''))\" \n                         class=\"image-circle__offer\">local_offer</md-icon>\n                <md-button ng-if=\"$ctrl.plusButton\" \n                           class=\"md-icon-button image-circle__plus\"><md-icon>add</md-icon></md-button>\n                <div class=\"image-circle__badge\" ng-if=\"$ctrl.badge\">{{$ctrl.badge}}</div>\n            </div>\n        ",
  bindings: {
    imageUri: '<',
    showMore: '<',
    badge: '<',
    plusButton: '<'
  }
}).name;
exports.ImageCircles = ImageCircles;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridScrollModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridScrollModule = angular.module('app.directives.gridScroll', [_angularjs.default]).directive('gridScroll', ["$window", "$timeout", "$rootScope", "$state", "$document", function ($window, $timeout, $rootScope, $state, $document) {
  return {
    link: function link(scope, element, attrs) {
      var cutoff = 0;
      var $$document = angular.element($document);
      var $$window = angular.element($window);
      var $gridWrap = angular.element('.vln-grid__wrap');
      var $gridHeader;
      var pageBackground;
      var descriptionContainer; // a comma-separated set of selectors for fixed elements whose total height
      // becomes top offset of grid header (i.e. '.page__header, .page__status')

      var offsetSelectors = attrs.gridScrollOffset.split(',').map(function (s) {
        return s.trim();
      }); // set this to use multiple grid headers (i.e. '.tc-display_head, .vln-grid__header')

      var headerSelector = attrs.gridScrollHeaders || '.tc-display_thead';
      var watcher = attrs.gridScrollWatch;
      var removeScopeListener = $rootScope.$on('storefrontSliderDirective:update', resizeManager);

      if (watcher) {
        scope.$watch(watcher, function () {
          return $timeout(resizeManager);
        });
      }

      var UI_SETTLING_DELAY = 100;
      $timeout(function () {
        // tc-grid header doesn't exist until first render
        $gridHeader = angular.element(headerSelector);
        $$window.on('scroll', scrollManager);
        $$window.on('resize orientationchange', resizeManager);
        resizeManager();
      }, UI_SETTLING_DELAY);
      scope.$on('$destroy', function () {
        $$window.off('scroll', scrollManager);
        $$window.off('resize orientationchange', resizeManager);
        removeScopeListener();
      });

      function scrollManager() {
        $gridHeader = angular.element(headerSelector);
        var currScroll = $$document.scrollTop();
        var cutoffStart = $state.current.name === 'category.detail' ? cutoff + pageBackground + descriptionContainer : cutoff;
        var cutoffStop = cutoffStart + ($gridWrap.height() - $gridHeader.height());
        var pastCutoffStart = currScroll > cutoffStart;
        var pastCutoffStop = currScroll >= cutoffStop;

        if ($$window.height() === $$document.height()) {
          return;
        }

        $gridWrap.toggleClass('vln-grid--fixed-header', pastCutoffStart);

        if (pastCutoffStart) {
          $gridHeader.css({
            top: getHeaderOffset(),
            width: $gridWrap.width()
          });
          $gridHeader.toggleClass('scrollup', pastCutoffStop);
        } else {
          $gridHeader.css({
            top: '',
            width: ''
          });
        }
      }

      function getHeaderOffset() {
        var headerOffset = 0;
        offsetSelectors.forEach(function (selector) {
          headerOffset += angular.element(selector).outerHeight();
        });
        return headerOffset;
      }

      function getCutoff($el) {
        return $el.offset().top - getHeaderOffset();
      }

      function resizeManager() {
        cutoff = getCutoff($gridWrap);

        if ($state.current.name === 'category.detail') {
          pageBackground = angular.element('.page__background').outerHeight();
          descriptionContainer = angular.element('.description').outerHeight();
        }

        if ($gridHeader) {
          $gridWrap.css('padding-top', $gridHeader.height());
          scrollManager();
        } else {
          $gridWrap.css('padding-top', '40px');
        }
      }
    }
  };
}]).name;
exports.GridScrollModule = GridScrollModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollLoaderDirectiveModule = void 0;

var _throttle = _interopRequireDefault(__webpack_require__(1526));

var _debounce = _interopRequireDefault(__webpack_require__(408));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollLoaderDirectiveModule = angular.module('app.directives.scrollLoader', []).directive('scrollLoader', ["$window", "$document", function ($window, $document) {
  return function (scope) {
    var mainWindow = angular.element($window);
    var checkScrollPosition = (0, _throttle.default)(function () {
      if (mainWindow.scrollTop() + mainWindow.height() > $document.height() - 100) {
        loadMore();
      }
    }, 200); // only allow this to fire twice per second

    var loadMore = (0, _debounce.default)(function () {
      var gridOptions = scope.$ctrl ? scope.$ctrl.grid.options : scope.grid.options;

      if (gridOptions.paging.currentPage < gridOptions.paging.pageCount) {
        gridOptions.scrollLoader = true;
        gridOptions.next();
      }
    }, 500, true);
    mainWindow.on('scroll', checkScrollPosition);
    checkScrollPosition();
    scope.$on('$destroy', function () {
      mainWindow.off('scroll', checkScrollPosition);
    });
  };
}]).name;
exports.ScrollLoaderDirectiveModule = ScrollLoaderDirectiveModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeneralErrorHandlerServiceModule = exports.getDescriptionTranslationKey = exports.extractDetailErrMessage = exports.extractMessageFromResponse = exports.extractItemsMessage = exports.extractModelStateMessage = exports.hasMissingData = exports.hasDuplicateVariantSku = exports.stripJson = void 0;

var _get = _interopRequireDefault(__webpack_require__(34));

var _has = _interopRequireDefault(__webpack_require__(425));

var _isNil = _interopRequireDefault(__webpack_require__(662));

var _isEmpty = _interopRequireDefault(__webpack_require__(190));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stripJson = function stripJson(jsonStr) {
  return !(0, _isNil.default)(jsonStr) ? jsonStr.replace(/\[\d]|["}{]|\[|]/g, '').replace(/[.:,]/g, ' ').replace(/\s{2}/g, ' ').trim() : '';
}; // todo: could be moved to productDetail.component


exports.stripJson = stripJson;

var hasDuplicateVariantSku = function hasDuplicateVariantSku(msg) {
  return !(0, _isNil.default)(msg) && msg.match(/.*ProductVariantSkuUniqueIndex.*/gi) !== null;
};

exports.hasDuplicateVariantSku = hasDuplicateVariantSku;

var hasMissingData = function hasMissingData(msg) {
  return !(0, _isNil.default)(msg) && msg.match(/.*must have a non-empty value.*|.*must contain values.*/gi) !== null;
};

exports.hasMissingData = hasMissingData;

var extractModelStateMessage = function extractModelStateMessage(resp) {
  return (0, _has.default)(resp, 'data.modelState') ? stripJson(JSON.stringify(resp.data.modelState)) : '';
};

exports.extractModelStateMessage = extractModelStateMessage;

var extractItemsMessage = function extractItemsMessage(resp) {
  return (0, _has.default)(resp, 'data.items[0].message') ? stripJson(resp.data.items[0].message) : '';
};

exports.extractItemsMessage = extractItemsMessage;

var extractMessageFromResponse = function extractMessageFromResponse(resp) {
  return (0, _has.default)(resp, 'data.message') ? "".concat((0, _get.default)(resp, 'data.message', ''), " ").concat(extractModelStateMessage(resp)) : extractItemsMessage(resp);
};

exports.extractMessageFromResponse = extractMessageFromResponse;

var extractDetailErrMessage = function extractDetailErrMessage(err) {
  return err instanceof Error ? err.message : extractMessageFromResponse(err);
};

exports.extractDetailErrMessage = extractDetailErrMessage;

var getDescriptionTranslationKey = function getDescriptionTranslationKey(errMsg) {
  if (hasDuplicateVariantSku(errMsg)) {
    return 'ERROR.VARIANT_DUPLICATE_SKU_CONFLICT';
  }

  if (hasMissingData(errMsg)) {
    return 'ERROR.GENERAL_MISSING_REQUIRED_DATA';
  }

  return 'ERROR.GENERAL_DESCRIPTION';
};

exports.getDescriptionTranslationKey = getDescriptionTranslationKey;
var GeneralErrorHandlerServiceModule = angular.module('vln.utilities.generalErrorHandler', ['ngMaterial']).factory('generalErrorHandlerService', ["$mdDialog", "$translate", function ($mdDialog, $translate) {
  function _showGeneralErrorDialog(errMsg, descriptionKey) {
    return function (translations) {
      var errMessage = (0, _isEmpty.default)(errMsg) ? translations[descriptionKey] : "".concat(translations[descriptionKey], "<br/><br/>Details:<br/>").concat(errMsg);
      $mdDialog.show($mdDialog.alert().clickOutsideToClose(false).title(translations['ERROR.GENERAL_TITLE']).htmlContent(errMessage).ariaLabel(translations['ERROR.GENERAL_TITLE']).ok(translations['ERROR.GENERAL_OK_BUTTON']).multiple(false));
    };
  }

  function alertUser(err) {
    var errMsg = extractDetailErrMessage(err);
    var descriptionKey = getDescriptionTranslationKey(errMsg);

    var showGeneralErrDialog = _showGeneralErrorDialog(errMsg, descriptionKey);

    return $translate(['ERROR.GENERAL_TITLE', descriptionKey, 'ERROR.GENERAL_OK_BUTTON']).then(showGeneralErrDialog);
  }

  return {
    alertUser: alertUser
  };
}]).name;
exports.GeneralErrorHandlerServiceModule = GeneralErrorHandlerServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryNameModule = void 0;

var _react2angular = __webpack_require__(97);

var _index = _interopRequireDefault(__webpack_require__(659));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountryNameModule = angular.module('app.components.countryName', []).component('countryName', (0, _react2angular.react2angular)(_index.default)).name;
exports.CountryNameModule = CountryNameModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoHeaderButtonModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _videoSlider = __webpack_require__(156);

var _trial = __webpack_require__(60);

__webpack_require__(1567);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VideoHeaderButtonModule = angular.module('app.components.videoSlider.videoHeaderButton', [_videoSlider.VideoSliderServiceModule, _trial.TrialServiceModule]).component('videoHeaderButton', {
  template: "\n        <md-button ng-if=\"$ctrl.isTrialAccount\"\n            ng-click=\"$ctrl.openVideoSlider()\"\n            class=\"video-slider-header-button\">\n\n            <md-icon>play_circle_outline</md-icon>\n            <span hide-xs>Watch the Video</span>\n        </md-button>\n        ",
  bindings: {
    videoLink: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    VideoHeaderButtonController.$inject = ["videoSliderService", "trialService"];

    function VideoHeaderButtonController(videoSliderService, trialService) {
      'ngInject';

      _classCallCheck(this, VideoHeaderButtonController);

      (0, _assign.default)(this, {
        videoSliderService: videoSliderService,
        trialService: trialService,
        isTrialAccount: true
      });
    }

    _createClass(VideoHeaderButtonController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.trialService.getTrialStatus().then(function (status) {
          return _this.isTrialAccount = status !== _trial.NOT_TRIAL;
        });
      }
    }, {
      key: "openVideoSlider",
      value: function openVideoSlider() {
        this.videoSliderService.openSlider(this.videoLink);
      }
    }]);

    return VideoHeaderButtonController;
  }()
}).name;
exports.VideoHeaderButtonModule = VideoHeaderButtonModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleIconComponent = void 0;

__webpack_require__(1647);

var CircleIconComponent = angular.module('app.components.circleIcon', []).component('circleIcon', {
  bindings: {
    icon: '@',
    iconColor: '@',
    svgUrl: '@'
  },
  template: "\n            <md-icon ng-if=\"$ctrl.icon\" ng-style=\"{'color': $ctrl.iconColor || '#000'}\">{{$ctrl.icon}}</md-icon>\n            <md-icon ng-if=\"$ctrl.svgUrl\" md-svg-src=\"{{$ctrl.svgUrl}}\"></md-icon>\n        ",
  transclude: true
}).name;
exports.CircleIconComponent = CircleIconComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteModalModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _deleteModal = _interopRequireDefault(__webpack_require__(1534));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DeleteModalModule = angular.module('app.components.modals.deleteModal', [_angularjs.default, 'ngMaterial', _angularTranslate.default]).component('deleteModal', {
  template: _deleteModal.default,
  bindings: {
    itemCount: '<',
    itemType: '<',
    isDetail: '<',
    productLength: '<',
    subCategoryLength: '<',
    menuCount: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    DeleteModalController.$inject = ["$scope", "$mdDialog", "$translate", "$state", "$mdMenu"];

    function DeleteModalController($scope, $mdDialog, $translate, $state, $mdMenu) {
      'ngInject';

      _classCallCheck(this, DeleteModalController);

      (0, _assign.default)(this, {
        translateData: {},
        gtmid: '',
        warnings: [],
        $scope: $scope,
        $mdDialog: $mdDialog,
        $translate: $translate,
        $state: $state,
        $mdMenu: $mdMenu
      });
    }

    _createClass(DeleteModalController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.gtmid = "admin_".concat(this.$state.current.name, "_deleteModal");
        this.setWarnings();
        this.getTranslation(this.itemType).then(function (type) {
          _this.translateData = {
            COUNT: _this.itemCount,
            TYPE: type
          };
        });
        this.$mdMenu.hide();
      }
    }, {
      key: "setWarnings",
      value: function setWarnings() {
        if (this.productLength) {
          this.warnings.push({
            text: this.productLength > 1 ? 'CATEGORY.PRODUCTSWARNING' : 'CATEGORY.PRODUCTWARNING',
            options: {
              COUNT: this.productLength
            }
          });
        }

        if (this.subCategoryLength) {
          this.warnings.push({
            text: 'CATEGORY.SUBCATEGORYWARNING',
            options: {
              COUNT: this.subCategoryLength
            }
          });
        }

        if (this.menuCount) {
          this.warnings.push({
            text: this.menuCount > 1 ? 'CATEGORY.MENUSWARNING' : 'CATEGORY.MENUWARNING',
            options: {
              COUNT: this.menuCount
            }
          });
        }
      }
    }, {
      key: "getTranslation",
      value: function getTranslation(iType) {
        var type = this.itemCount > 1 ? "".concat(iType, ".PLURAL") : "".concat(iType, ".SINGLE");
        return this.$translate(type);
      }
    }, {
      key: "confirmDelete",
      value: function confirmDelete() {
        this.$mdDialog.hide();
      }
    }, {
      key: "cancelDelete",
      value: function cancelDelete() {
        this.$mdDialog.cancel('cancel');
      }
    }]);

    return DeleteModalController;
  }()
}).name;
exports.DeleteModalModule = DeleteModalModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateNameModule = void 0;

var _react2angular = __webpack_require__(97);

var _index = _interopRequireDefault(__webpack_require__(729));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StateNameModule = angular.module('app.components.stateName', []).component('stateName', (0, _react2angular.react2angular)(_index.default)).name;
exports.StateNameModule = StateNameModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextStepNoticeModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _isFunction = _interopRequireDefault(__webpack_require__(202));

var _launchDarkly = __webpack_require__(30);

var _nextStepNotice = _interopRequireDefault(__webpack_require__(1554));

__webpack_require__(1555);

var _founderGuideNextStep = _interopRequireDefault(__webpack_require__(1556));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NextStepNoticeModule = angular.module('app.components.nextStepNotice', [_launchDarkly.LaunchDarklyServiceModule]).component('nextStepNotice', {
  template: _nextStepNotice.default,
  bindings: {
    noticeTitle: '<',
    titleData: '<',
    subtitle: '<',
    ctaLabel: '<',
    link: '<',
    url: '<',
    secondaryCtaLabel: '<',
    secondaryLink: '<',
    secondaryUrl: '<',
    color: '<',
    backgroundColor: '<',
    fullWidth: '<',
    showInitialMessage: '<',
    initialMessage: '<',
    initialMessageLink: '<',
    initialMessageColor: '<',
    animateIn: '<',
    founderGuideStep: '<',
    founderGuideNextStep: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    NextStepNoticeController.$inject = ["$state", "launchDarklyService"];

    function NextStepNoticeController($state, launchDarklyService) {
      _classCallCheck(this, NextStepNoticeController);

      (0, _assign.default)(this, {
        $state: $state,
        launchDarklyService: launchDarklyService,
        hasFounderGuide: false,
        cardStyle: {},
        iconStyle: {},
        hstyle: {}
      });
    }

    _createClass(NextStepNoticeController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.backgroundColor = this.backgroundColor || 'transparent';
        if (this.color) this.setElementColors();

        if (this.initialMessageColor) {
          this.messageStyle = {
            backgroundColor: this.initialMessageColor
          };
        }

        this.launchDarklyService.getFeature('founder-guide').then(function (feature) {
          _this.hasFounderGuide = feature;

          _this.setFounderGuideContent();
        });
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        if (changes.founderGuideNextStep) {
          this.setFounderGuideContent();
          this.setFounderGuideNextStep();
        }

        if (changes.color) {
          this.setElementColors();
        }
      }
    }, {
      key: "setElementColors",
      value: function setElementColors() {
        this.cardStyle = {
          borderColor: this.color
        };
        this.iconStyle = {
          backgroundColor: this.color
        };
        this.hstyle = {
          color: this.color
        };
      }
    }, {
      key: "goTo",
      value: function goTo(link) {
        if (!link) return;

        if ((0, _isFunction.default)(link)) {
          link();
        } else {
          var appCard;

          var _link$split = link.split('@');

          var _link$split2 = _slicedToArray(_link$split, 2);

          link = _link$split2[0];
          appCard = _link$split2[1];
          this.$state.go(link, {
            installApp: appCard
          });
        }
      }
    }, {
      key: "setFounderGuideContent",
      value: function setFounderGuideContent() {
        if (!this.hasFounderGuide) return;
        var step = _founderGuideNextStep.default.steps[this.founderGuideStep];

        if (step) {
          this.isFounderGuideNextStep = true;
          this.noticeTitle = step.noticeTitle;
          this.subtitle = step.subtitle;
          this.ctaLabel = step.ctaLabel;
          this.link = step.link;
          this.url = undefined;
          this.secondaryCtaLabel = step.secondaryCtaLabel;
          this.secondaryLink = step.secondaryLink;
          this.secondaryUrl = step.secondaryUrl;
          this.iconStyle = {
            backgroundColor: 'transparent'
          };

          if (this.founderGuideStep === 'product' || this.founderGuideStep === 'page') {
            this.showInitialMessage = true;
            this.setFounderGuideNextStep();
          }
        }
      }
    }, {
      key: "setFounderGuideNextStep",
      value: function setFounderGuideNextStep() {
        var step = _founderGuideNextStep.default.nextsteps[this.founderGuideNextStep];

        if (step) {
          this.initialMessageLink = step.initialMessageLink;
          this.initialMessage = step.initialMessage;
        }
      }
    }]);

    return NextStepNoticeController;
  }()
}).name;
exports.NextStepNoticeModule = NextStepNoticeModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1663 */,
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormatAddressFilterModule = void 0;
var FormatAddressFilterModule = angular.module('app.filters.formatAddressFilter', []).filter('formatAddress', function () {
  return function (address) {
    if (!address) return;
    var address1 = address.address1,
        address2 = address.address2,
        city = address.city,
        state = address.state,
        country = address.country,
        postalCode = address.postalCode;
    return encodeURIComponent([address1, address2, city, state, country, postalCode].filter(function (str) {
      return !!str;
    }).join(' '));
  };
}).name;
exports.FormatAddressFilterModule = FormatAddressFilterModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleMapServiceModule = void 0;

var _constants = __webpack_require__(24);

var GoogleMapServiceModule = angular.module('app.services.utilities.googleMapService', []).factory('googleMapService', function () {
  function setMap(address) {
    return {
      mapLink: "https://www.google.com/maps/place/".concat(address),
      mapSrc: "https://maps.googleapis.com/maps/api/staticmap?center=".concat(address, "&scale=2&zoom=14&maptype=roadmap&markers=").concat(address, "&key=").concat(_constants.GOOGLE_STATIC_MAPS_KEY) // eslint-disable-line max-len

    };
  }

  return {
    setMap: setMap
  };
}).name;
exports.GoogleMapServiceModule = GoogleMapServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyListPage2Module = void 0;

var _react2angular = __webpack_require__(97);

var _index = _interopRequireDefault(__webpack_require__(1524));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyListPage2Module = angular.module('app.components.EmptyListPage2', []).component('emptyListPage2', (0, _react2angular.react2angular)(_index.default, null)).name;
exports.EmptyListPage2Module = EmptyListPage2Module;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmoothScrollModule = void 0;
var SmoothScrollModule = angular.module('app.directives.smoothScroll', []).directive('smoothScroll', ["$window", "$document", function ($window, $document) {
  return {
    link: function link(scope, el, attrs) {
      el.on('click', function () {
        var location = attrs.smoothScroll;
        var $$window = angular.element($window);
        var $$document = angular.element($document);
        var $pageStatus = angular.element('.page__status');
        var $pageHeader = angular.element('.page__header');
        var start;
        var lastTime;
        var offset;
        var scrollTo;
        var maxScroll;

        if (!location) {
          throw new Error('No Scroll location given!');
        }

        var scrollEl = angular.element("#".concat(location));

        if (scrollEl) {
          var headerHeight = $pageHeader.is(':visible') ? $pageHeader.height() : 0;
          var statusHeight = $pageStatus.is(':visible') ? $pageStatus.height() : 0;
          maxScroll = $$document.height() - $$window.height();
          offset = angular.element($window).scrollTop();
          scrollTo = scrollEl.offset().top - headerHeight - statusHeight;
          scrollTo = maxScroll < scrollTo ? maxScroll : scrollTo;
          start = false;
          $window.requestAnimationFrame(scroll);
        }

        function scroll(time) {
          if (!start) {
            lastTime = time;
          }

          var deltaTime = time - lastTime;
          $window.scroll(0, lerp(offset, scrollTo, 0.3 * (deltaTime / 60)));
          var oldOffset = offset;
          offset = angular.element($window).scrollTop();
          lastTime = time;

          if (scrollTo - offset > 0 && (offset !== maxScroll || oldOffset !== offset || start === false)) {
            start = true;
            $window.requestAnimationFrame(scroll);
          }
        }

        function lerp(from, to, time) {
          return Math.ceil(from + time * (to - from));
        }
      });
    }
  };
}]).name;
exports.SmoothScrollModule = SmoothScrollModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabScrollModule = void 0;
var TabScrollModule = angular.module('app.directives.tabScroll', []).directive('tabScroll', ["$window", "$timeout", "$document", function ($window, $timeout, $document) {
  return {
    link: function link(scope, element, attrs) {
      var cutoff = 0;
      var $$window = angular.element($window);
      var $pageHeader = angular.element('.page__header');
      var $pageStatus;
      var $trialBar;
      var $page;
      var $body = angular.element('body');
      var $$document = angular.element($document);
      var watcher = attrs.tabScrollWatch;
      var statusHeight = 0;
      var headerHeight = 0;
      var trialBarHeight = 0; // add fixed class after timeout to
      // prevent wrong positioning on load

      $timeout(function () {
        $pageStatus = angular.element('.page__status');
        $page = angular.element('.page');
        $trialBar = angular.element('.trial-status-bar');
        $$window.on('scroll', scrollManager);
        $$window.on('resize orientationchange', resizeManager).resize();

        if (watcher) {
          scope.$watchCollection(watcher, function () {
            return $timeout(resizeManager);
          });
        }
      });
      scope.$on('$destroy', function () {
        $$window.off('scroll', scrollManager);
        $$window.off('resize orientationchange', resizeManager);
      });

      function scrollManager() {
        var currScroll = $$window.scrollTop();

        if ($$window.height() === $$document.height()) {
          return;
        }

        if (!$body.hasClass('md-dialog-is-showing')) {
          element.toggleClass('md-tabs--fixed', currScroll > cutoff);
        }
      }

      function getCutoff($el) {
        return $el.offset().top - headerHeight - statusHeight;
      }

      function checkVisibility($el) {
        return !!($el && $el.length && $el.is(':visible'));
      }

      function resizeManager() {
        element.toggleClass('md-tabs--has-status', checkVisibility($pageStatus));
        headerHeight = $pageHeader.is(':visible') ? $pageHeader.height() : 0;
        statusHeight = $pageStatus.is(':visible') ? $pageStatus.height() : 0;
        trialBarHeight = $trialBar.is(':visible') ? $trialBar.height() : 0;
        cutoff = getCutoff(element);
        var wHeight = $$window.height();
        var dHeight = $$document.height();
        var maxScroll = dHeight - wHeight;
        var heightNeeded = cutoff - maxScroll;
        $page.css('min-height', Math.ceil($page.height() + heightNeeded - trialBarHeight));
        scrollManager();
      }
    }
  };
}]).name;
exports.TabScrollModule = TabScrollModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LimitationsService = void 0;

var _get = _interopRequireDefault(__webpack_require__(34));

var _products = __webpack_require__(98);

var _settings = __webpack_require__(15);

var _subscription = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LimitationsService = angular.module('app.services.access.limitations', [_subscription.SubscriptionServiceModule, _products.ProductServiceModule, _settings.AppSettingsModule]).service('limitationsService', ["subscriptionsService", "productService", "$q", function (subscriptionsService, productService, $q) {
  return {
    getProductLimitations: getProductLimitations,
    getUpdatedProductLimitations: getUpdatedProductLimitations,
    isFeatureEnabled: isFeatureEnabled
  };

  function getProductLimitations() {
    var getSubscription = subscriptionsService.getSubscription();
    var getProductCount = productService.getProductCount();
    return $q.all([getSubscription, getProductCount]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          subscription = _ref2[0],
          productCount = _ref2[1];

      return {
        hasHitProductLimit: productCount >= subscription.features.productLimit,
        productLimit: subscription.features.productLimit,
        planId: subscription.plan.id,
        productCount: productCount
      };
    });
  }

  function getUpdatedProductLimitations(featureLimitation, planId, productCount) {
    return {
      hasHitProductLimit: productCount >= featureLimitation.productLimit,
      productLimit: featureLimitation.productLimit,
      planId: planId,
      productCount: productCount
    };
  }

  function isFeatureEnabled(featureName) {
    return subscriptionsService.getSubscription().then(function (subscription) {
      return (0, _get.default)(subscription.features, featureName, false);
    });
  }
}]).name;
exports.LimitationsService = LimitationsService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1670 */,
/* 1671 */,
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsService = void 0;

var _moment = _interopRequireDefault(__webpack_require__(74));

var _angularFileSaver = _interopRequireDefault(__webpack_require__(426));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _get = _interopRequireDefault(__webpack_require__(34));

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

var _carts = __webpack_require__(726);

var _launchDarkly = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AnalyticsService = angular.module('app.pages.analytics.analyticsService', [_settings.AppSettingsModule, _data.DataServiceModule, _carts.CartServiceModule, _angularFileSaver.default, _angularTranslate.default, 'ngMaterial', _launchDarkly.LaunchDarklyServiceModule]).service('analyticsService', ["dataService", "settings", "FileSaver", "$translate", "$mdDialog", "cartService", "launchDarklyService", function (dataService, settings, FileSaver, $translate, $mdDialog, cartService, launchDarklyService) {
  function getAnalytics() {
    var dateRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateDateRangeObject(30);
    var dateRangeQuery = "?startDate=".concat(dateRange.startDate, "&endDate=").concat(dateRange.endDate);
    return dataService.getAll("".concat(settings.api.analytics).concat(dateRangeQuery));
  }

  function generateDateRangeObject(days) {
    var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var endDate = end !== null ? (0, _moment.default)().subtract(end, 'days').format('YYYY-MM-DD').toString() : (0, _moment.default)().format('YYYY-MM-DD').toString();
    return {
      startDate: (0, _moment.default)().subtract(days, 'days').format('YYYY-MM-DD').toString(),
      endDate: endDate
    };
  }

  function generateTimestampRangeObject(days) {
    var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var endDate = end !== null ? (0, _moment.default)().subtract(end, 'days').toISOString() : (0, _moment.default)().toISOString();
    return {
      startDate: (0, _moment.default)().subtract(days, 'days').toISOString(),
      endDate: endDate
    };
  }

  function getSalesCsv() {
    var dateRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateDateRangeObject(30);
    var dateRangeQuery = "?startDate=".concat(dateRange.startDate, "&endDate=").concat(dateRange.endDate);
    return dataService.get("".concat(settings.api.analytics, "/sales/export").concat(dateRangeQuery), null, null, null, null).then(function (response) {
      return saveStringToCsv(response.csv, 'VolusionSalesExport.csv');
    });
  }

  function exportCarts() {
    var dateRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateDateRangeObject(30);
    var options = {
      startDate: dateRange.startDate,
      endDate: dateRange.endDate
    };
    var headers = {
      Accept: 'text/csv'
    };
    return dataService.getAll(settings.api.abandonedCartsExport, options, headers).then(function (response) {
      return saveStringToCsv(response, 'VolusionCartsExport.csv');
    });
  }

  function saveStringToCsv(string, fileName) {
    var blob = new Blob([string], {
      type: 'text/csv'
    });
    FileSaver.saveAs(blob, fileName);
    return blob;
  }
  /**
   *  @param {object} { title: 'string', description: 'string' }
  */


  function showError(errorObject) {
    // Need to pass an array to `this.$translate`
    return $translate(Object.values(errorObject)).then(function (translations) {
      return $mdDialog.show($mdDialog.alert().title(translations[errorObject.title]).textContent(translations[errorObject.description]).ok('Ok'));
    });
  }

  function getAbandonedCartsData() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      count: 25,
      days: 30,
      page: 1
    },
        _ref$count = _ref.count,
        count = _ref$count === void 0 ? 25 : _ref$count,
        _ref$days = _ref.days,
        days = _ref$days === void 0 ? 30 : _ref$days,
        _ref$page = _ref.page,
        page = _ref$page === void 0 ? 1 : _ref$page;

    var dates = this.generateTimestampRangeObject(days);
    var returnHeaders = true;
    return cartService.getCarts({
      first: count,
      skip: (page - 1) * count,
      filter: "createdAt gt ".concat(dates.startDate)
    }, returnHeaders).then(function (_ref2) {
      var data = _ref2.data,
          headers = _ref2.headers;
      var first = Number(headers['x-first']);
      var skip = Number(headers['x-skip']);
      var totalCount = Number(headers['x-total-count']);
      return {
        items: data.carts.map(function (item) {
          return _this.createViewModelFromCart(item);
        }),
        pageSize: first,
        pageCount: Math.ceil(totalCount / first),
        startIndex: skip,
        totalCount: totalCount
      };
    });
  }

  function getLegacyAbandonedCartsData(_ref3) {
    var _this2 = this;

    var _ref3$count = _ref3.count,
        count = _ref3$count === void 0 ? 25 : _ref3$count,
        _ref3$days = _ref3.days,
        days = _ref3$days === void 0 ? 30 : _ref3$days,
        _ref3$page = _ref3.page,
        page = _ref3$page === void 0 ? 1 : _ref3$page;

    var _this$generateDateRan = this.generateDateRangeObject(days),
        startDate = _this$generateDateRan.startDate,
        endDate = _this$generateDateRan.endDate;

    return cartService.getLegacyAbandonedCarts({
      pageSize: count,
      startIndex: (page - 1) * count,
      startDate: startDate,
      endDate: endDate
    }).then(function (data) {
      return _objectSpread({}, data, {
        items: data.items.map(function (item) {
          return _this2.createViewModelFromLegacyCart(item);
        })
      });
    });
  }

  function getAbandonedCart(cartId) {
    var _this3 = this;

    return launchDarklyService.getFeature('use-new-carts-in-checkout').then(function (newCartsEnabled) {
      if (!newCartsEnabled) {
        return cartService.getLegacyCart(cartId).then(function (cart) {
          return _this3.createViewModelFromLegacyCart(cart);
        });
      }

      return cartService.getCart(cartId).then(function (cart) {
        return _this3.createViewModelFromCart(cart);
      });
    });
  }

  function createViewModelFromLegacyCart(legacyCart) {
    var _legacyCart$shippingM, _legacyCart$contactIn, _legacyCart$contactIn2, _legacyCart$billingAd, _legacyCart$billingAd2, _legacyCart$billingAd3, _legacyCart$billingAd4, _legacyCart$billingAd5, _legacyCart$billingAd6, _legacyCart$billingAd7, _legacyCart$shippingA, _legacyCart$shippingA2, _legacyCart$shippingA3, _legacyCart$shippingA4, _legacyCart$shippingA5, _legacyCart$shippingA6, _legacyCart$shippingA7;

    return {
      id: legacyCart.id,
      createdAt: legacyCart.createdOn,
      updatedAt: legacyCart.updatedOn,
      total: legacyCart.total,
      taxAmount: legacyCart.taxAmount,
      grandTotal: legacyCart.grandTotal,
      shippingAmount: (_legacyCart$shippingM = legacyCart.shippingMethod) === null || _legacyCart$shippingM === void 0 ? void 0 : _legacyCart$shippingM.shippingCost,
      items: legacyCart.items.map(function (item) {
        return {
          imageSrc: (0, _get.default)(item, 'product.images[0].imageLink.fullUri'),
          quantity: item.quantity,
          name: item.product.name,
          salePrice: item.product.pricing.salePrice,
          listPrice: item.product.pricing.listPrice
        };
      }),
      shopper: {
        email: (_legacyCart$contactIn = legacyCart.contactInfo) === null || _legacyCart$contactIn === void 0 ? void 0 : _legacyCart$contactIn.email,
        firstName: (0, _get.default)(legacyCart, 'shippingAddress.firstName', (0, _get.default)(legacyCart, 'billingAddress.firstName')),
        lastName: (0, _get.default)(legacyCart, 'shippingAddress.lastName', (0, _get.default)(legacyCart, 'billingAddress.lastName')),
        phone: (_legacyCart$contactIn2 = legacyCart.contactInfo) === null || _legacyCart$contactIn2 === void 0 ? void 0 : _legacyCart$contactIn2.phoneNumber,
        billingAddress: {
          firstName: (_legacyCart$billingAd = legacyCart.billingAddress) === null || _legacyCart$billingAd === void 0 ? void 0 : _legacyCart$billingAd.firstName,
          lastName: (_legacyCart$billingAd2 = legacyCart.billingAddress) === null || _legacyCart$billingAd2 === void 0 ? void 0 : _legacyCart$billingAd2.lastName,
          address1: (_legacyCart$billingAd3 = legacyCart.billingAddress) === null || _legacyCart$billingAd3 === void 0 ? void 0 : _legacyCart$billingAd3.address1,
          address2: (_legacyCart$billingAd4 = legacyCart.billingAddress) === null || _legacyCart$billingAd4 === void 0 ? void 0 : _legacyCart$billingAd4.address2,
          city: (_legacyCart$billingAd5 = legacyCart.billingAddress) === null || _legacyCart$billingAd5 === void 0 ? void 0 : _legacyCart$billingAd5.city,
          state: (_legacyCart$billingAd6 = legacyCart.billingAddress) === null || _legacyCart$billingAd6 === void 0 ? void 0 : _legacyCart$billingAd6.state,
          zip: (_legacyCart$billingAd7 = legacyCart.billingAddress) === null || _legacyCart$billingAd7 === void 0 ? void 0 : _legacyCart$billingAd7.postalCode
        },
        shippingAddress: {
          firstName: (_legacyCart$shippingA = legacyCart.shippingAddress) === null || _legacyCart$shippingA === void 0 ? void 0 : _legacyCart$shippingA.firstName,
          lastName: (_legacyCart$shippingA2 = legacyCart.shippingAddress) === null || _legacyCart$shippingA2 === void 0 ? void 0 : _legacyCart$shippingA2.lastName,
          address1: (_legacyCart$shippingA3 = legacyCart.shippingAddress) === null || _legacyCart$shippingA3 === void 0 ? void 0 : _legacyCart$shippingA3.address1,
          address2: (_legacyCart$shippingA4 = legacyCart.shippingAddress) === null || _legacyCart$shippingA4 === void 0 ? void 0 : _legacyCart$shippingA4.address2,
          city: (_legacyCart$shippingA5 = legacyCart.shippingAddress) === null || _legacyCart$shippingA5 === void 0 ? void 0 : _legacyCart$shippingA5.city,
          state: (_legacyCart$shippingA6 = legacyCart.shippingAddress) === null || _legacyCart$shippingA6 === void 0 ? void 0 : _legacyCart$shippingA6.state,
          zip: (_legacyCart$shippingA7 = legacyCart.shippingAddress) === null || _legacyCart$shippingA7 === void 0 ? void 0 : _legacyCart$shippingA7.postalCode
        }
      }
    };
  }

  function createViewModelFromCart(cart) {
    var _cart$items;

    var getCartTotal = function getCartTotal(cartItems) {
      return cartItems.reduce(function (acc, curr) {
        return (acc + curr.price.amount * curr.quantity) / 100;
      }, 0);
    };

    var getCartGrandTotal = function getCartGrandTotal(_cart) {
      return getCartTotal(_cart.items);
    }; // TODO: fill in null values with data once it's available


    return {
      id: cart.cartId,
      createdAt: cart.createdAt,
      updatedAt: cart.updatedAt,
      total: getCartTotal(cart.items),
      taxAmount: null,
      grandTotal: getCartGrandTotal(cart),
      shippingAmount: null,
      items: (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.map(function (item) {
        return {
          imageSrc: (0, _get.default)(item, 'imageSrc'),
          quantity: item.quantity,
          name: item.productName,
          salePrice: null,
          listPrice: item.price.amount / 100
        };
      }),
      shopper: {
        email: cart.shopperEmail,
        firstName: null,
        lastName: null,
        phone: null,
        billingAddress: {
          firstName: null,
          lastName: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          zip: null
        },
        shippingAddress: {
          firstName: null,
          lastName: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          zip: null
        }
      }
    };
  }

  return {
    getAbandonedCartsData: getAbandonedCartsData,
    getLegacyAbandonedCartsData: getLegacyAbandonedCartsData,
    getAnalytics: getAnalytics,
    generateDateRangeObject: generateDateRangeObject,
    getSalesCsv: getSalesCsv,
    exportCarts: exportCarts,
    showError: showError,
    generateTimestampRangeObject: generateTimestampRangeObject,
    createViewModelFromLegacyCart: createViewModelFromLegacyCart,
    createViewModelFromCart: createViewModelFromCart,
    getAbandonedCart: getAbandonedCart
  };
}]).name;
exports.AnalyticsService = AnalyticsService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirstCharFilterModule = void 0;
var FirstCharFilterModule = angular.module('app.filters.firstCharFilter', []).filter('firstChar', function () {
  return function (s) {
    return s ? s[0] : '';
  };
}).name;
exports.FirstCharFilterModule = FirstCharFilterModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPostalCodeRegEx = exports.getAdminLevel1Label = void 0;

var _constants = __webpack_require__(24);

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var getAdminLevel1Label = function getAdminLevel1Label(countryCode, plural) {
  var label;

  if (_typeof(_constants.ADMINISTRATIVE_AREA_LEVEL_1_LABELS[countryCode]) == 'object') {
    label = _constants.ADMINISTRATIVE_AREA_LEVEL_1_LABELS[countryCode][plural ? 'plural' : 'singular'];
  } else {
    label = _constants.ADMINISTRATIVE_AREA_LEVEL_1_LABELS[countryCode];
    if (label && plural) label = "".concat(label, "s");
  }

  if (!label) label = plural ? _constants.ADDRESS_REGION_PLURAL : _constants.ADDRESS_REGION;
  return label;
};

exports.getAdminLevel1Label = getAdminLevel1Label;

var getPostalCodeRegEx = function getPostalCodeRegEx(country) {
  return country === 'US' ? /^(\d{5}-\d{4}|\d{5})$/ : '';
};

exports.getPostalCodeRegEx = getPostalCodeRegEx;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GravatarFilterModule = void 0;

var _blueimpMd = _interopRequireDefault(__webpack_require__(733));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GravatarFilterModule = angular.module('app.filters.gravatarFilter', []).filter('gravatar', function () {
  return function (s) {
    if (!s) return null;
    return (0, _blueimpMd.default)(s.toString().trim().toLowerCase());
  };
}).name;
exports.GravatarFilterModule = GravatarFilterModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyListPageComponentModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _videoSlider = __webpack_require__(156);

__webpack_require__(1566);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EmptyListPageComponentModule = angular.module('app.components.emptyListPage', [_videoSlider.VideoSliderServiceModule]).component('emptyListPage', {
  template: "\n            <div class=\"empty-list-page\" layout=\"column\" layout-align=\"center center\">\n                <div class=\"empty-list-page__image\">\n                    <md-icon ng-if=\"$ctrl.icon\">{{$ctrl.icon}}</md-icon>\n                    <md-icon ng-if=\"$ctrl.iconSvgSrc\" md-svg-src=\"{{$ctrl.iconSvgSrc}}\"></md-icon>\n                </div>\n                <h1 class=\"empty-list-page__headline\">{{$ctrl.headline | translate}}</h1>\n                <p class=\"empty-list-page__message\" ng-if=\"$ctrl.message\">{{$ctrl.message | translate}}</p>\n                <div ng-if=\"$ctrl.showVideoMenu\" class=\"empty-list-page__videoslider-link\"\n                    ng-click=\"$ctrl.openVideoSlider()\">\n                    <md-icon>play_circle_outline</md-icon> {{'LABEL.WATCH_VIDEO' | translate}}\n                </div>\n                <md-button\n                    ng-if=\"$ctrl.showAddButton\"\n                    class=\"md-button--has-icon-left md-raised md-accent\"\n                    ui-sref=\"{{$ctrl.addButtonLink}}\"\n                    ng-click=\"$ctrl.addButtonOnClick()\"\n                    gtm-click-event=\"{{$ctrl.gtmId}}-add-link\">\n                    <md-icon>add</md-icon>\n                    <span>{{$ctrl.addButtonText | translate}}</span>\n                </md-button>\n                <div ng-transclude></div>\n            </div>\n        ",
  transclude: true,
  bindings: {
    icon: '@',
    iconSvgSrc: '@',
    headline: '@',
    message: '@',
    showAddButton: '<',
    addButtonLink: '@',
    addButtonOnClick: '&',
    addButtonText: '@',
    gtmId: '<',
    videoLink: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    EmptyListPageController.$inject = ["videoSliderService"];

    function EmptyListPageController(videoSliderService) {
      'ngInject';

      _classCallCheck(this, EmptyListPageController);

      (0, _assign.default)(this, {
        videoSliderService: videoSliderService
      });
    }

    _createClass(EmptyListPageController, [{
      key: "$onInit",
      value: function $onInit() {
        this.showVideoMenu = !!this.videoLink;
      }
    }, {
      key: "openVideoSlider",
      value: function openVideoSlider() {
        this.videoSliderService.openSlider(this.videoLink);
      }
    }]);

    return EmptyListPageController;
  }()
}).name;
exports.EmptyListPageComponentModule = EmptyListPageComponentModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1677 */,
/* 1678 */,
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BulkImportFileSelectModal = void 0;

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _ngFileUpload = _interopRequireDefault(__webpack_require__(205));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _segment = __webpack_require__(58);

var _csvReader = __webpack_require__(409);

var _changePlanButton = __webpack_require__(658);

var _bulkImportProgressModal = __webpack_require__(1529);

var _bulkImportFileSelectModal = _interopRequireDefault(__webpack_require__(1532));

__webpack_require__(1533);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BulkImportFileSelectModal = angular.module('app.pages.products.bulkImportFileSelectModal', ['ngMaterial', _angularTranslate.default, _angularjs.default, _ngFileUpload.default, _csvReader.CSVReaderService, _changePlanButton.ChangePlanButtonModule, _bulkImportProgressModal.BulkImportProgressModal, _segment.SegmentServiceModule]).component('bulkImportModal', {
  template: _bulkImportFileSelectModal.default,
  bindings: {
    singleError: '@',
    featureLimitation: '<',
    importerType: '<',
    errorList: '<',
    refreshOnClose: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    BulkImportFileSelectModalController.$inject = ["$scope", "$mdDialog", "csvReader", "$state", "$window", "$location", "$mdToast", "$translate", "segmentService"];

    function BulkImportFileSelectModalController($scope, $mdDialog, csvReader, $state, $window, $location, $mdToast, $translate, segmentService) {
      'ngInject';

      _classCallCheck(this, BulkImportFileSelectModalController);

      (0, _assign.default)(this, {
        gtmid: '',
        csvDataObject: null,
        fileName: null,
        fileMaxSize: '200MB',
        isViewingErrorList: false,
        $scope: $scope,
        $mdDialog: $mdDialog,
        csvReader: csvReader,
        $state: $state,
        $window: $window,
        $location: $location,
        $mdToast: $mdToast,
        $translate: $translate,
        segmentService: segmentService
      });
    }

    _createClass(BulkImportFileSelectModalController, [{
      key: "$onInit",
      value: function $onInit() {
        if (this.featureLimitation && this.featureLimitation.hasHitProductLimit) {
          this.gtmid = "admin_".concat(this.$state.current.name, "_bulkImportLimitReached");
          this.trackPage('/bulkimport/limitreached', 'Bulk Import Limit Reached');
        } else {
          this.gtmid = "admin_".concat(this.$state.current.name, "_bulkImportModal");
          this.trackPage('/bulkimport', 'Bulk Import');
        }
      }
    }, {
      key: "cancelImport",
      value: function cancelImport() {
        this.$mdDialog.cancel('cancel');

        if (this.refreshOnClose) {
          this.$state.reload();
        }
      }
    }, {
      key: "viewErrorReport",
      value: function viewErrorReport() {
        this.isViewingErrorList = true;
      }
    }, {
      key: "cancelErrorReport",
      value: function cancelErrorReport() {
        this.isViewingErrorList = false;
      }
    }, {
      key: "getCSVSampleUrl",
      value: function getCSVSampleUrl() {
        switch (this.importerType) {
          case 'product':
            return "https://material-admin-cdn-sandbox.s3.amazonaws.com/data/sample.csv";

          case 'order':
            return "https://material-admin-cdn-sandbox.s3.amazonaws.com/data/importer/orders/orders_sample.csv";

          case 'customer':
            return "https://material-admin-cdn-sandbox.s3.amazonaws.com/data/importer/customers/customers_sample.csv";

          default:
            return '';
        }
      }
    }, {
      key: "proceedImport",
      value: function proceedImport(data, fileName) {
        return this.$mdDialog.show({
          clickOutsideToClose: true,
          template: "<bulk-import-progress-modal\n                                   importer-type=\"importerType\"\n                                   csv-obj=\"csvObj\"\n                                   file-name=\"".concat(fileName, "\"\n                                   feature-limitation=\"featureLimitation\">\n                               </bulk-import-progress-modal>"),
          locals: {
            csvObj: data,
            featureLimitation: this.featureLimitation,
            importerType: this.importerType
          },
          controller: ["$scope", "csvObj", "featureLimitation", "importerType", function controller($scope, csvObj, featureLimitation, importerType) {
            'ngInject';

            $scope.csvObj = csvObj;
            $scope.featureLimitation = featureLimitation;
            $scope.importerType = importerType;
          }]
        });
      }
    }, {
      key: "uploadFile",
      value: function uploadFile(files, invalidFiles) {
        var _this = this;

        if (invalidFiles && invalidFiles.length) {
          var msg = ['ERROR.CSVVALIDATION'];

          if (invalidFiles.some(function (f) {
            return f.$error === 'maxSize';
          })) {
            msg = ['ERROR.CSVVALIDATIONSIZE', {
              max: this.fileMaxSize
            }];
          }

          this.$translate.apply(this, _toConsumableArray(msg)).then(function (error) {
            _this.$mdToast.show(_this.$mdToast.simple().textContent(error).position('bottom left'));
          });
        }

        if (!files || files.length === 0) return;
        this.csvReader.getCsvData(files[0]).then(function (data) {
          _this.fileName = files[0].name || '';
          _this.csvDataObject = {
            contents: data
          };

          if (_this.importerType === 'product') {
            _this.csvDataObject.limit = _this.getNumberOfRemainingProductSlots();
            _this.csvDataObject.data = _this.csvDataObject.data;
          }

          _this.gtmid = "admin_".concat(_this.$state.current.name, "_bulkImportCsvSelected");
        });
      }
    }, {
      key: "getNumberOfRemainingProductSlots",
      value: function getNumberOfRemainingProductSlots() {
        var numberOfRemainingProductSlots = this.featureLimitation.productLimit - this.featureLimitation.productCount;
        return numberOfRemainingProductSlots <= 0 ? 0 : numberOfRemainingProductSlots;
      }
    }, {
      key: "isFileReady",
      value: function isFileReady() {
        return this.csvDataObject !== null;
      }
    }, {
      key: "iconOpacity",
      value: function iconOpacity() {
        var ACTIVE_OPACITY = 0.54;
        var INACTIVE_OPACITY = 0.2;
        return this.isFileReady() ? ACTIVE_OPACITY : INACTIVE_OPACITY;
      }
    }, {
      key: "trackDrop",
      value: function trackDrop() {
        this.segmentService.trackGtmEvent({
          analyticsClickEvent: "".concat(this.gtmid, "-dropCsv")
        }, {});
      }
    }, {
      key: "trackPage",
      value: function trackPage(pageState, pageTitle) {
        this.segmentService.trackGtmEvent({
          analyticsClickEvent: 'virtualPageView'
        }, {
          virtualPage: this.$location.path() + pageState,
          virtualTitle: pageTitle
        });
      }
    }, {
      key: "dismissErrors",
      value: function dismissErrors() {
        this.dismissedErrors = true;
      }
    }]);

    return BulkImportFileSelectModalController;
  }()
}).name;
exports.BulkImportFileSelectModal = BulkImportFileSelectModal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSortedShipToCountries;

var _get = _interopRequireDefault(__webpack_require__(34));

var _constants = __webpack_require__(24);

var _IntlShippingService = _interopRequireDefault(__webpack_require__(660));

var _StoreAddressesService = _interopRequireDefault(__webpack_require__(730));

var _countrySort = _interopRequireDefault(__webpack_require__(1537));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getSortedShipToCountries() {
  return Promise.all([_IntlShippingService.default.fetchShipToLocations(), getPrimaryCountryCode()]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        locations = _ref2[0],
        primaryCountryCode = _ref2[1];

    return {
      shipToLocations: (0, _countrySort.default)(locations, primaryCountryCode),
      defaultCountry: primaryCountryCode
    };
  });
}

var getPrimaryCountryCode = function getPrimaryCountryCode() {
  return _StoreAddressesService.default.getAddresses().then(function (addresses) {
    return (0, _get.default)(addresses, '[0].country', _constants.DEFAULT_COUNTRY_CODE);
  });
};

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvalaraServiceModule = void 0;

var _settings = __webpack_require__(15);

var _data = __webpack_require__(11);

var AvalaraServiceModule = angular.module('app.services.data.avalaraService', [_settings.AppSettingsModule, _data.DataServiceModule]).service('avalaraService', ["dataService", "settings", function (dataService, settings) {
  return {
    getAvalaraStatus: getAvalaraStatus,
    getCredentials: getCredentials,
    getTaxProvider: getTaxProvider,
    isAvalaraEnabled: isAvalaraEnabled
  };

  function getCredentials() {
    return dataService.get(settings.api.avalaraCredential);
  }

  function getTaxProvider() {
    return dataService.get(settings.api.taxProvider);
  }

  function isAvalaraEnabled() {
    return getTaxProvider().then(function (taxProvider) {
      return taxProvider.taxProvider === 'AVALARA';
    }).catch(function () {
      return false;
    });
  }

  function getAvalaraStatus() {
    return dataService.get(settings.api.avalaraStatus);
  }
}]).name;
exports.AvalaraServiceModule = AvalaraServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedactorModule = void 0;

__webpack_require__(1568);

__webpack_require__(1569);

__webpack_require__(1570);

var _redactor3 = __webpack_require__(1571);

var _addLinkModal = __webpack_require__(1591);

var _embedVideoModal = __webpack_require__(1593);

var RedactorModule = angular.module('app.components.redactor', [_redactor3.RedactorDirectiveModule, _addLinkModal.RedactorAddLinkModalModule, _embedVideoModal.RedactorEmbedVideoModalModule]).name;
exports.RedactorModule = RedactorModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtensionStoreModule = void 0;

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _launchAppExtensionPreview = __webpack_require__(401);

var _extension = __webpack_require__(232);

var _vlnBackImage = __webpack_require__(263);

var _extensionStore = _interopRequireDefault(__webpack_require__(1595));

__webpack_require__(1596);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ExtensionStoreModule = angular.module('app.components.extensionStore', ['ngMaterial', _angularTranslate.default, _launchAppExtensionPreview.LaunchAppExtensionPreviewServiceModule, _extension.ExtensionServiceModule, _vlnBackImage.VlnBackImageModule]).component('extensionStore', {
  template: _extensionStore.default,
  controller:
  /*#__PURE__*/
  function () {
    ExtensionStoreController.$inject = ["launchAppExtensionModalService", "$mdToast", "extensionService", "$attrs", "$rootScope", "$translate"];

    function ExtensionStoreController(launchAppExtensionModalService, $mdToast, extensionService, $attrs, $rootScope, $translate) {
      'ngInject';

      _classCallCheck(this, ExtensionStoreController);

      (0, _assign.default)(this, {
        extensions: '',
        extensionStoreActive: false,
        $rootScope: $rootScope,
        $mdToast: $mdToast,
        launchAppExtensionModalService: launchAppExtensionModalService,
        extensionService: extensionService,
        $attrs: $attrs,
        $translate: $translate
      });
    }

    _createClass(ExtensionStoreController, [{
      key: "$onInit",
      value: function $onInit() {
        this.getExtensions();
      }
    }, {
      key: "getExtensions",
      value: function getExtensions() {
        var _this = this;

        this.extensionService.getExtensions(this.$attrs.app).then(function (extensions) {
          _this.extensions = extensions;
        });
      }
    }, {
      key: "openExtension",
      value: function openExtension(extension) {
        var _this2 = this;

        this.launchAppExtensionModalService.launchPreview('extension', extension).then(function () {
          return _this2.$translate('APPSTORE.EXTENSIONINSTALLED', {
            EXTENSION: extension.title
          });
        }).then(function (message) {
          _this2.$mdToast.show(_this2.$mdToast.simple().textContent(message).position('bottom left').parent('.page').hideDelay(5000));
        });
      }
    }]);

    return ExtensionStoreController;
  }()
}).name;
exports.ExtensionStoreModule = ExtensionStoreModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtensionDirective = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _extension = __webpack_require__(232);

__webpack_require__(1597);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExtensionDirective = angular.module('app.components.extensions.extensionDirective', [_angularjs.default, _extension.ExtensionServiceModule]).directive('extensions', ["$rootScope", "$compile", "extensionService", "$state", function ($rootScope, $compile, extensionService, $state) {
  return {
    link: function link(scope, element, attrs) {
      updateExtensions();
      $rootScope.$on('extensions:newinstalled', function () {
        updateExtensions();
      });

      function updateExtensions() {
        return extensionService.getExtensions(attrs.app).then(function (extensions) {
          var productUpdateHandlerAttr = '';
          var preOrdersEnabledAttr = '';
          var togglePreOrderAttr = '';
          var setAvailabilityMessageAttr = '';
          var validationChangedHandlerAttr = '';
          element.html('');

          if ($state.current.name === 'product.detail' || $state.current.name === 'product.add') {
            productUpdateHandlerAttr = "update-product-handler=\"".concat(attrs.updateProductHandler, "\"");
            validationChangedHandlerAttr = "on-validation-changed=\"".concat(attrs.onValidationChanged, "\"");
            preOrdersEnabledAttr = "pre-orders-enabled=\"".concat(attrs.preOrdersEnabled, "\"");
            togglePreOrderAttr = "toggle-pre-order=\"".concat(attrs.togglePreOrder, "\"");
            setAvailabilityMessageAttr = "set-availability-message=\"".concat(attrs.setAvailabilityMessage, "\"");
          }

          angular.forEach(extensions, function (extension) {
            var stateInjection = "page-state=\"".concat(attrs.pageState, "\"");
            var extensionElement = angular.element("<".concat(extension.directive, "\n                                        model=\"").concat(attrs.model, "\"\n                                        ").concat(stateInjection, "\n                                        ").concat(productUpdateHandlerAttr, "\n                                        ").concat(preOrdersEnabledAttr, "\n                                        ").concat(togglePreOrderAttr, "\n                                        ").concat(setAvailabilityMessageAttr, "\n                                        ").concat(validationChangedHandlerAttr, ">\n                                    </").concat(extension.directive, ">"));
            $compile(extensionElement)(scope);
            element.append(extensionElement);
          });
          $rootScope.$emit('extensions:updated');
        });
      }
    }
  };
}]).name;
exports.ExtensionDirective = ExtensionDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DuplicateModalModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _assign = _interopRequireDefault(__webpack_require__(5));

var _duplicateModal = _interopRequireDefault(__webpack_require__(1598));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DuplicateModalModule = angular.module('app.components.modals.duplicateModal', [_angularjs.default, 'ngMaterial', _angularTranslate.default]).component('duplicateModal', {
  template: _duplicateModal.default,
  bindings: {
    itemCount: '<',
    itemType: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    DuplicateModalController.$inject = ["$scope", "$mdDialog", "$mdMenu", "$translate", "$state"];

    function DuplicateModalController($scope, $mdDialog, $mdMenu, $translate, $state) {
      'ngInject';

      _classCallCheck(this, DuplicateModalController);

      (0, _assign.default)(this, {
        translateData: {},
        gtmid: '',
        $scope: $scope,
        $mdDialog: $mdDialog,
        $mdMenu: $mdMenu,
        $translate: $translate,
        $state: $state
      });
    }

    _createClass(DuplicateModalController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.gtmid = "admin_".concat(this.$state.current.name, "_copyModal");
        this.getTranslation(this.itemType).then(function (type) {
          _this.translateData = {
            COUNT: _this.itemCount,
            TYPE: type
          };
        }); // TODO pull when md is fixed - fix for IOS/Android

        this.$mdMenu.hide();
      }
    }, {
      key: "getTranslation",
      value: function getTranslation(iType) {
        var type = this.itemCount > 1 ? "".concat(iType, ".PLURAL") : "".concat(iType, ".SINGLE");
        return this.$translate(type);
      }
    }, {
      key: "confirmDuplicate",
      value: function confirmDuplicate() {
        this.$mdDialog.hide();
      }
    }, {
      key: "cancelDuplicate",
      value: function cancelDuplicate() {
        this.$mdDialog.hide('cancel');
      }
    }]);

    return DuplicateModalController;
  }()
}).name;
exports.DuplicateModalModule = DuplicateModalModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeoExtensionModule = void 0;

var _storeInformation = __webpack_require__(38);

var _assign = _interopRequireDefault(__webpack_require__(5));

var _seo = _interopRequireDefault(__webpack_require__(1599));

__webpack_require__(1600);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SeoExtensionModule = angular.module('app.components.extensions.seo', [_storeInformation.StoreInformationServiceModule]).component('seo', {
  template: _seo.default,
  bindings: {
    model: '='
  },
  controller:
  /*#__PURE__*/
  function () {
    Seo.$inject = ["storeInformationService", "$translate", "$location"];

    function Seo(storeInformationService, $translate, $location) {
      _classCallCheck(this, Seo);

      (0, _assign.default)(this, {
        storeInformationService: storeInformationService,
        $translate: $translate,
        $location: $location
      });
    }

    _createClass(Seo, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        var ctrl = this;
        this.storeInformationService.getStore().then(function (store) {
          return _this.formatExampleUrl(store);
        }).then(function (storeUrl) {
          ctrl.storeUrl = storeUrl;
          return ctrl.$translate('SEO.HINT', {});
        }).then(function (message) {
          ctrl.hint = message;
        });
      }
    }, {
      key: "formatExampleUrl",
      value: function formatExampleUrl(store) {
        var storeUrl = store.customDomain || store.storeUrl;

        if (storeUrl[storeUrl.length - 1] !== '/') {
          storeUrl += '/';
        }

        var type = this.$location.$$path.split('/')[1];

        switch (type) {
          case 'category':
            storeUrl += 'c/';
            break;

          case 'product':
            storeUrl += 'p/';
            break;

          case 'pages':
            storeUrl += 'page/';
            break;

          default:
            break;
        }

        return storeUrl;
      }
    }]);

    return Seo;
  }()
}).name;
exports.SeoExtensionModule = SeoExtensionModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.idInputMatchesPattern = idInputMatchesPattern;
exports.extractIdFromInput = extractIdFromInput;
exports.privyLocatePattern = exports.privyIdentityPattern = exports.facebookPixelLocatePattern = exports.facebookPixelIdentityPattern = exports.googleAnalyticsLocatePattern = exports.googleAnalyticsIdentityPattern = void 0;

//public functions
function idInputMatchesPattern(userInput, identityPattern) {
  var matches = userInput.match(identityPattern);

  if (matches && matches.length && matches.length === 1) {
    if (matches[0] === userInput) {
      return true;
    }
  }

  return false;
}

function extractIdFromInput(userInput, locationPattern, identityPattern) {
  var matches = locateInputMatches(userInput, locationPattern);

  if (matches && matches.length && matches.length >= 1) {
    return extractIdFromInputMatch(matches[0], identityPattern);
  }

  return '';
} //support functions


function locateInputMatches(userInput, locationPattern) {
  return userInput.match(locationPattern);
}

function extractIdFromInputMatch(inputMatch, identityPattern) {
  var matches = inputMatch.match(identityPattern);

  if (matches.length === 1) {
    return matches[0];
  }

  return '';
} //established patterns


var googleAnalyticsIdentityPattern = /[A-z]{2}[-]\d{5,}[-]\d{1,3}/g;
exports.googleAnalyticsIdentityPattern = googleAnalyticsIdentityPattern;
var googleAnalyticsLocatePattern = /ga\('create',\s'[A-z]{2}[-]\d{5,}[-]\d{1,3}',\s'auto'\);/g;
exports.googleAnalyticsLocatePattern = googleAnalyticsLocatePattern;
var facebookPixelIdentityPattern = /\d{15,}/g;
exports.facebookPixelIdentityPattern = facebookPixelIdentityPattern;
var facebookPixelLocatePattern = /fbq\('init',\s'\d{15,}'\);/g;
exports.facebookPixelLocatePattern = facebookPixelLocatePattern;
var privyIdentityPattern = /[0-9A-z]{20,}/g;
exports.privyIdentityPattern = privyIdentityPattern;
var privyLocatePattern = /\|\|\s'[0-9A-z]{20,}';/g;
exports.privyLocatePattern = privyLocatePattern;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayServiceModule = void 0;

var _overlay = __webpack_require__(1470);

var OverlayServiceModule = angular.module('app.components.overlay.overlayService', ['ngMaterial', _overlay.OverlayControllerModule]).service('overlayService', ["$mdDialog", "$document", function ($mdDialog, $document) {
  var overlayBodyClass = 'overlay-open';

  function show(config) {
    return $mdDialog.show({
      controller: 'OverlayController',
      template: buildOverlayTemplate(config.controller, config.templateUrl, config.template, config.displayCloseButton),
      parent: angular.element($document.body),
      targetEvent: config.event,
      clickOutsideToClose: false,
      fullscreen: true,
      hasBackdrop: false,
      onShowing: addBodyClass,
      onRemoving: function onRemoving() {
        handleRemoving(config.onRemoving);
      }
    });
  }

  function buildOverlayTemplate(controller, templateUrl, template) {
    var displayCloseButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return "\n                <md-dialog class=\"overlay\">\n                    <header class=\"overlay__header\">\n                        <logo logo-size=\"small\"></logo>\n                            ".concat(displayCloseButton ? "\n                            <md-button\n                                class=\"overlay__close md-icon-button\"\n                                ng-click=\"close()\"\n                                ng-if=\"closeButtonVisible\">\n                                <md-icon>close</md-icon>\n                            </md-button>" : '', "\n                    </header>\n                    ").concat(template ? "\n                        <div\n                            class=\"overlay__content\">\n                            ".concat(template, "\n                        </div>") : "\n                        <div\n                            class=\"overlay__content\"\n                            ng-include=\"'".concat(templateUrl, "'\"\n                            ng-controller=\"").concat(controller, "\">\n                        </div>\n                    "), "\n                </md-dialog>\n            ");
  }

  function addBodyClass() {
    angular.element($document[0].body).addClass(overlayBodyClass);
  }

  function handleRemoving(onRemoving) {
    removeBodyClass();

    if (onRemoving) {
      onRemoving();
    }
  }

  function removeBodyClass() {
    angular.element($document[0].body).removeClass(overlayBodyClass);
  }

  return {
    show: show
  };
}]).name;
exports.OverlayServiceModule = OverlayServiceModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridModule = void 0;

var _angularjs = _interopRequireDefault(__webpack_require__(7));

var _angularTranslate = _interopRequireDefault(__webpack_require__(33));

var _loadingModal = __webpack_require__(630);

var _grid = __webpack_require__(627);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridModule = angular.module('app.components.grid', [_angularjs.default, 'ngMaterial', _angularTranslate.default, _loadingModal.LoadingModalService, _grid.GridServiceModule]).name;
exports.GridModule = GridModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MuiNativeSelectModule = void 0;

var _react2angular = __webpack_require__(97);

var _index = _interopRequireDefault(__webpack_require__(1538));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MuiNativeSelectModule = angular.module('app.components.muiNativeSelect', []).component('muiNativeSelect', (0, _react2angular.react2angular)(_index.default, ['autoComplete', 'error', 'handleSelectBlur', 'handleSelectChange', 'id', 'label', 'options', 'placeholder', 'type', 'value'])).name;
exports.MuiNativeSelectModule = MuiNativeSelectModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1698 */,
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdatePaymentCardModule = void 0;

var _assign = _interopRequireDefault(__webpack_require__(5));

var _isEmpty = _interopRequireDefault(__webpack_require__(190));

var _creditCardUtilities = __webpack_require__(86);

var _paymentMethod = __webpack_require__(269);

var _addressUtilities = __webpack_require__(1557);

var _cardInfo = __webpack_require__(595);

var _updatePaymentButton = __webpack_require__(1558);

var _updatePaymentCard = _interopRequireDefault(__webpack_require__(1564));

__webpack_require__(1565);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UpdatePaymentCardModule = angular.module('app.components.updatePayment.updatePaymentCard', [_creditCardUtilities.CreditCardUtilitiesServiceModule, _paymentMethod.PaymentMethodServiceModule, _addressUtilities.AddressUtilitiesServiceModule, _updatePaymentButton.UpdatePaymentButtonComponent, _cardInfo.CardInfoModule]).component('updatePaymentCard', {
  template: _updatePaymentCard.default,
  bindings: {
    titleText: '@',
    updatedPaymentCard: '<'
  },
  controller:
  /*#__PURE__*/
  function () {
    UpdatePaymentCardController.$inject = ["$scope", "creditCardUtilities", "addressUtilities", "paymentMethodService"];

    function UpdatePaymentCardController($scope, creditCardUtilities, addressUtilities, paymentMethodService) {
      'ngInject';

      _classCallCheck(this, UpdatePaymentCardController);

      (0, _assign.default)(this, {
        $scope: $scope,
        creditCardUtilities: creditCardUtilities,
        addressUtilities: addressUtilities,
        paymentMethodService: paymentMethodService,
        paymentMethod: {},
        loading: true,
        hasPaymentMethod: false
      });
    }

    _createClass(UpdatePaymentCardController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.paymentMethodService.getPaymentMethod().then(function (paymentMethod) {
          _this.hasPaymentMethod = !(0, _isEmpty.default)(paymentMethod.creditCard);
          if (_this.hasPaymentMethod) _this.setPaymentInfo(_this.convertStipeInfo(paymentMethod.creditCard));
          _this.loading = false;
        });
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changesObj) {
        if (changesObj.updatedPaymentCard && changesObj.updatedPaymentCard.currentValue !== changesObj.updatedPaymentCard.previousValue) {
          this.setPaymentInfo(changesObj.updatedPaymentCard.currentValue);
        }
      }
    }, {
      key: "convertStipeInfo",
      value: function convertStipeInfo(stripeInfo) {
        stripeInfo.address = this.addressUtilities.convertStripeAddress(stripeInfo.address);
        stripeInfo.expirationString = "".concat(stripeInfo.expiration.month, "/").concat(stripeInfo.expiration.year);
        stripeInfo.maskedCardNumber = this.creditCardUtilities.getMaskedCardNumber(stripeInfo.lastFour);
        return stripeInfo;
      }
    }, {
      key: "setPaymentInfo",
      value: function setPaymentInfo(paymentInfo) {
        this.paymentMethod = paymentInfo;
      }
    }, {
      key: "paymentMethodChanged",
      value: function paymentMethodChanged(cardInfo) {
        this.setPaymentInfo(cardInfo);
      }
    }]);

    return UpdatePaymentCardController;
  }()
}).name;
exports.UpdatePaymentCardModule = UpdatePaymentCardModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1700 */,
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryPickerModule = void 0;

var _omit = _interopRequireDefault(__webpack_require__(197));

var _reject = _interopRequireDefault(__webpack_require__(676));

var _constants = __webpack_require__(24);

var _categories = __webpack_require__(100);

var _model = __webpack_require__(251);

var _seoHelper = __webpack_require__(639);

var _categoryPicker = _interopRequireDefault(__webpack_require__(1615));

__webpack_require__(1616);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CategoryPickerModule = angular.module('app.components.categoryPicker', ['ngMaterial', _categories.CategoryServiceModule, _model.ModelModule, _seoHelper.SeoHelperServiceModule]).component('categoryPicker', {
  template: _categoryPicker.default,
  bindings: {
    title: '@',
    placeholder: '@',
    createNewCategoryText: '@',
    noResultsText: '@',
    singleSelection: '<',
    categoryIds: '<',
    excludedCategoryIds: '<',
    onSelectedCategoriesChanged: '&',
    key: '@'
  },
  controller:
  /*#__PURE__*/
  function () {
    CategoryPickerController.$inject = ["categoryService", "modelService", "seoHelperService"];

    function CategoryPickerController(categoryService, modelService, seoHelperService) {
      'ngInject';

      _classCallCheck(this, CategoryPickerController);

      angular.extend(this, {
        categoryService: categoryService,
        modelService: modelService,
        seoHelperService: seoHelperService,
        categoryTree: [],
        selectedCategories: [],
        categoryLineages: [],
        autocomplete: {
          selectedItem: null,
          searchText: '',
          disabled: false
        }
      });
    }

    _createClass(CategoryPickerController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        this.autocomplete.placeholder = this.placeholder;
        this.key = this.key || 'categoryId';

        if (!angular.isArray(this.categoryIds)) {
          this.categoryIds = [];
        }

        this.categoryService.getCategoryTree().then(function (categoryTree) {
          _this.categoryTree = categoryTree;
          _this.categoryLineages = _this.initialize(categoryTree);

          if (_this.categoryIds.length > 0) {
            _this.setSelectedAndCategoryLineages();
          }
        });
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        if (changes.categoryIds) {
          this.categoryLineages = this.initialize(this.categoryTree);
          this.setSelectedAndCategoryLineages();
        }
      }
    }, {
      key: "initialize",
      value: function initialize(categoryTree) {
        var identifierKey = this.key;
        var categoryLineages = [];
        var excludedCategoryIds = this.excludedCategoryIds || [];

        function getLineage(parentLineage, categoryName) {
          return parentLineage ? "".concat(parentLineage, " > ").concat(categoryName) : categoryName;
        }

        function setLineageOnCategoryTree(categories) {
          var parentLineage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
          categories.forEach(function (category) {
            var lineage = getLineage(parentLineage, category.name);

            if (excludedCategoryIds.indexOf(category[identifierKey]) < 0) {
              categoryLineages.push({
                id: category[identifierKey],
                lineage: lineage,
                state: category.state
              });

              if (angular.isArray(category.subCategories) && category.subCategories.length > 0) {
                setLineageOnCategoryTree(category.subCategories, lineage);
              }
            }
          });
        }

        setLineageOnCategoryTree(categoryTree);
        return categoryLineages;
      }
    }, {
      key: "setSelectedAndCategoryLineages",
      value: function setSelectedAndCategoryLineages() {
        var _this2 = this;

        if (!this.categoryLineages) {
          return;
        }

        this.selectedCategories = this.categoryLineages.filter(function (category) {
          return _this2.categoryIds.includes(category.id);
        });
        this.categoryLineages = (0, _reject.default)(this.categoryLineages, function (category) {
          return _this2.categoryIds.includes(category.id);
        });
        this.checkSingleSelection();
      }
    }, {
      key: "checkSingleSelection",
      value: function checkSingleSelection() {
        if (this.singleSelection && this.categoryIds.length === 1) {
          this.autocomplete.disabled = true;
          this.autocomplete.placeholder = '';
        } else {
          this.autocomplete.disabled = false;
          this.autocomplete.placeholder = this.placeholder;
        }
      }
    }, {
      key: "querySearch",
      value: function querySearch(searchText) {
        searchText = searchText.toLowerCase();
        return this.categoryLineages.filter(function (categoryLineage) {
          return categoryLineage.lineage.toLowerCase().indexOf(searchText) !== -1;
        });
      }
    }, {
      key: "addCategory",
      value: function addCategory(selectedItem) {
        if (!selectedItem || this.singleSelection && this.categoryIds.length === 1) {
          return;
        }

        this.selectedCategories.push(selectedItem);
        this.categoryIds.push(selectedItem.id);
        this.categoryLineages = (0, _reject.default)(this.categoryLineages, {
          id: selectedItem.id
        });
        this.checkSingleSelection();

        if (angular.isFunction(this.onSelectedCategoriesChanged)) {
          this.onSelectedCategoriesChanged({
            selectedCategories: this.categoryIds,
            action: _constants.CATEGORY_SELECTION_ACTIONS.ADD
          });
        }
      }
    }, {
      key: "removeCategory",
      value: function removeCategory(itemToRemove) {
        this.selectedCategories = (0, _reject.default)(this.selectedCategories, {
          id: itemToRemove.id
        });
        this.categoryIds = this.categoryIds.filter(function (c) {
          return c !== itemToRemove.id;
        });
        this.categoryLineages.push(itemToRemove);
        this.checkSingleSelection();

        if (angular.isFunction(this.onSelectedCategoriesChanged)) {
          this.onSelectedCategoriesChanged({
            selectedCategories: this.categoryIds,
            action: _constants.CATEGORY_SELECTION_ACTIONS.REMOVE
          });
        }
      }
    }, {
      key: "createCategory",
      value: function createCategory(categoryName) {
        var _this3 = this;

        var parentCategory = this.modelService.makeModel({
          name: categoryName,
          state: 'Active'
        }, 'categoryModel');
        this.seoHelperService.fillDefaultValues(parentCategory, parentCategory.state);
        this.categoryService.createNewCategory((0, _omit.default)(parentCategory, 'categoryId', 'contentPageId', 'images', 'subCategories', 'productCount')).then(function (response) {
          var parentCategoryLineage = {
            id: response[_this3.key],
            lineage: response.name,
            state: response.state
          };

          _this3.categoryLineages.push(parentCategoryLineage);

          _this3.addCategory(parentCategoryLineage);

          _this3.autocomplete.searchText = '';
        });
      }
    }]);

    return CategoryPickerController;
  }()
}).name;
exports.CategoryPickerModule = CategoryPickerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LaunchProductPickerModule = void 0;

var _productPicker = __webpack_require__(1622);

var LaunchProductPickerModule = angular.module('app.pages.orders.launchProductPicker', ['ngMaterial', _productPicker.ProductPickerModule]).service('launchProductPicker', ["$mdDialog", function ($mdDialog) {
  return {
    open: function open(options) {
      return $mdDialog.show({
        template: "\n                        <md-dialog\n                            aria-label=\"Add Products to Order\"\n                            ng-cloak\n                            class=\"product-picker order__add-products\">\n                            <product-picker\n                                gtm-id=\"gtmId\"\n                                init-items=\"initItems\"\n                                confirm-text=\"confirmText\"\n                                filter-items=\"filterItems\"\n                                filter-text=\"filterText\"\n                                add-products-heading-key=\"addProductsHeadingKey\"\n                                custom-header-class=\"customHeaderClass\"\n                                custom-banner-class=\"customBannerClass\"\n                                show-zero-inventory=\"showZeroInventory\"\n                                is-zero-inventory-selection-enabled=\"isZeroInventorySelectionEnabled\">\n                            </product-picker>\n                        </md-dialog>\n                    ",
        controller: ["$scope", "gtmId", "confirmText", "filterItems", "filterText", "showZeroInventory", "isZeroInventorySelectionEnabled", "customHeaderClass", "addProductsHeadingKey", "customBannerClass", function controller($scope, gtmId, confirmText, filterItems, filterText, showZeroInventory, isZeroInventorySelectionEnabled, customHeaderClass, addProductsHeadingKey, customBannerClass) {
          'ngInject';

          $scope.gtmId = gtmId;
          $scope.confirmText = confirmText;
          $scope.filterItems = filterItems;
          $scope.filterText = filterText;
          $scope.showZeroInventory = showZeroInventory;
          $scope.isZeroInventorySelectionEnabled = isZeroInventorySelectionEnabled;
          $scope.customHeaderClass = customHeaderClass;
          $scope.customBannerClass = customBannerClass;
          $scope.addProductsHeadingKey = addProductsHeadingKey;
        }],
        parent: angular.element('body'),
        clickOutsideToClose: true,
        hasBackdrop: true,
        targetEvent: options.event,
        locals: {
          gtmId: options.gtmId,
          confirmText: options.confirmText,
          filterItems: options.filterItems,
          filterText: options.filterText,
          showZeroInventory: options.showZeroInventory,
          isZeroInventorySelectionEnabled: options.isZeroInventorySelectionEnabled,
          customHeaderClass: options.customHeaderClass,
          customBannerClass: options.customBannerClass,
          addProductsHeadingKey: options.addProductsHeadingKey
        }
      });
    }
  };
}]).name;
exports.LaunchProductPickerModule = LaunchProductPickerModule;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })
],[742]);


// WEBPACK FOOTER //
// js/app.0c1f453194f53c29b725.js